/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	window.jQuery = window.$ = __webpack_require__(109);
	var processInclude = __webpack_require__(3);

	$(document).ready(function () {
	    processInclude(__webpack_require__(110));
	    processInclude(__webpack_require__(112));
	    processInclude(__webpack_require__(114));
	    processInclude(__webpack_require__(115));
	    processInclude(__webpack_require__(136));
	    processInclude(__webpack_require__(137));
	    processInclude(__webpack_require__(139));
	    processInclude(__webpack_require__(140));
	    processInclude(__webpack_require__(141));
	    processInclude(__webpack_require__(142));
	    processInclude(__webpack_require__(143));
	    if ($('.js-toTopButtonCorp').length > 0) {
	        processInclude(__webpack_require__(145));
	    }
	    processInclude(__webpack_require__(146));
	});

	__webpack_require__(150);
	__webpack_require__(162);
	__webpack_require__(164);
	__webpack_require__(165);
	__webpack_require__(166);

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	module.exports = function (include) {
	    if (typeof include === 'function') {
	        include();
	    } else if ((typeof include === 'undefined' ? 'undefined' : _typeof(include)) === 'object') {
	        Object.keys(include).forEach(function (key) {
	            if (typeof include[key] === 'function') {
	                include[key]();
	            }
	        });
	    }
	};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Given a list of values and an emptied dropdown element, it populates the dropdown with the values
	 * @param {*} dropdown - the dropdown to fill
	 * @param {Array} list - an array of object containing {ID, value} of the address fields
	 */

	function populateDropdownFromList(dropdown, list) {
	    // one empty option on top
	    var option = document.createElement("option");
	    option.value = '';
	    option.text = $(dropdown).data('empty-option');
	    option.selected = true;
	    option.disabled = true;
	    dropdown.add(option);

	    // then the options coming from the list
	    for (var i in list) {
	        option = document.createElement("option");
	        option.value = list[i].ID;
	        option.text = list[i].value;
	        dropdown.add(option);
	    }
	}

	/**
	 * Function used to empty the values assigned to a unique address field (for example, the zipcode w.r.t. the subdistrict in Bata ID)
	 * @param {String} fieldName - the name of the unique address field to empty
	 * @param {String} formId - the ID of the form in which such address field is located
	 */
	function emptyUniqueField(fieldName, formId) {
	    var uniqueField = $('#' + formId + '-' + fieldName);
	    uniqueField.val('');
	    uniqueField.data('selected-id', '');
	    if (uniqueField.hasClass('js-calculate-shipping-cost')) {
	        uniqueField.trigger('change');
	    }
	}

	/**
	 * Function used to update or empty an address field in case it is unique w.r.t. the previous one
	 * @param {Object} backendData - it contains the list of dropdowns to update, to empty and the type of the next field if it's unique
	 */
	function manageUniqueField(backendData, section) {
	    if (backendData.nextFieldUnique.toUpperCase() === backendData.typeToUpdate) {

	        // if the next -unique- field is to update
	        var valueToAssign = backendData.listToUpdate[0] ? backendData.listToUpdate[0].ID : '';
	        var textToAssign = backendData.listToUpdate[0] ? backendData.listToUpdate[0].value : '';
	        // Notice: the ID is saved in the .data('selected-id'), the value in the .val() to make it visible
	        var uniqueField = $('#' + backendData.formId + '-' + backendData.nextFieldUnique);
	        // in the checkout there are multiple times the same address element type in the same form, therefore we have to identify the correct section
	        if (section) {
	            uniqueField = $('#' + backendData.formId).find('#' + backendData.nextFieldUnique + '-' + section);
	        }
	        uniqueField.data('selected-id', valueToAssign);
	        uniqueField.val(textToAssign);
	        if (uniqueField.hasClass('js-calculate-shipping-cost')) {
	            uniqueField.trigger('change');
	        }
	    } else if (backendData.typesToEmpty.indexOf(backendData.nextFieldUnique.toUpperCase()) > -1) {

	        // if the next -unique- field is to empty
	        emptyUniqueField(backendData.nextFieldUnique, backendData.formId);
	    }
	}

	/**
	 * Updates and populates values for the address dropdown lists on a form.
	 * @param {Object} addressField - An object representing all fields in the form that need to be updated.
	 * @param {Object} data - Contains the dropdown elements to update and the corresponding value lists with new options.
	 * @param {String} section - Specifies the section of the form where the customer is trying to update the values.
	 * @param {Boolean} isShippingBillingSameChecked - A boolean indicating whether the billing form is the same as the shipping form.
	 * @param {String} fieldValue - The ID value from the form dropdowns that needs to be set.
	 * @param {String} fieldToSet - The type of dropdown list where the ID value should be updated.
	 */
	function updateAddress(addressfield, data, section, isShippingBillingSameChecked, fieldValue, fieldToSet) {
	    var addressFields = addressfield.length ? addressfield.find('.js-autofill-address-field select', '#' + data.formId) : $('.js-autofill-address-field select', '#' + data.formId);
	    addressFields.each(function (ind) {
	        var $currentField = $(addressFields[ind]);
	        var fieldType = $currentField.closest('.editable-block').data('field-type');
	        if (isShippingBillingSameChecked && section === 'billing' && fieldType === fieldToSet) {
	            //Update values from the dropdown list when shipping and billing address are the same
	            $currentField.data('selected-id', fieldValue);
	            $currentField.val(fieldValue);
	        }
	        if (fieldType === data.typeToUpdate) {
	            // populate the next dropdown with the new values
	            $currentField.find('option').remove();
	            populateDropdownFromList(addressFields[ind], data.listToUpdate);
	        } else if (data.typesToEmpty.indexOf($(addressFields[ind]).closest('.editable-block').data('field-type')) > -1) {
	            // empty the dropdowns after - if necessary
	            $currentField.find('option').remove();
	            populateDropdownFromList(addressFields[ind], []);
	        }
	        // empty also the other unique fields
	        var otherUniqueField = $currentField.closest('.editable-block').data('next-field-unique');
	        if (otherUniqueField) {
	            emptyUniqueField(otherUniqueField, data.formId);
	        }
	    });
	}

	/**
	 * Function called externally on submit of a form to substitute the fields having unique values with their related ID
	 * @param {FormData} formData - the FormData element
	 */
	function handleUniqueFieldsFormValues(formData) {
	    // the unique fields in the forms need to contain the class 'js-change-value-with-id' and the attribute 'data-selected-id' to trigger the following logic
	    var uniqueFields = $('.js-change-value-with-id');
	    uniqueFields.each(function (field) {
	        var fieldName = $(uniqueFields[field]).attr('name');
	        var fieldID = $(uniqueFields[field]).data('selected-id');
	        if (fieldID) {
	            formData.set(fieldName, fieldID);
	        }
	    });
	}

	/**
	 * Function to update the lists of options related to one or many dropdowns
	 * @param {Object} data - it contains the dropdowns (elements to update) and the valuesLists (Object with the new option values)
	 */
	function updateDropdownOptions(data) {
	    data.dropdowns.each(function (ind) {
	        // populate the next dropdown with the new values
	        $(data.dropdowns[ind]).find('option').remove();
	        var fieldToUpdate = $(data.dropdowns[ind]).closest('.editable-block').data('field-type').toLowerCase();
	        var listToUpdate = data.valuesLists[fieldToUpdate] ? data.valuesLists[fieldToUpdate] : [];
	        populateDropdownFromList(data.dropdowns[ind], listToUpdate);
	    });
	    var $selectPicker = $('.selectpicker');
	    if ($selectPicker.length) {
	        $selectPicker.selectpicker('refresh');
	    }
	}

	/**
	 * Function to retrieve from the backend the lists of options related to one or many dropdowns
	 * @param {Object} data - it contains the formId (telling which form to update) and the address fields' values on the form dropdowns
	 */
	function updateDropdownOptionsAjax(data) {
	    //TODO deprecated at 90%
	    var url = $('.js-shipping-address-container').data('address-field-autocomplete-url');
	    if (url.length > 0) {
	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'POST',
	            data: {
	                formId: data.formId,
	                province: data.attrs.stateCode,
	                city: data.attrs.city,
	                district: data.attrs.district,
	                subdistrict: data.attrs.subdistrict,
	                postalCode: data.attrs.postalCode
	            },
	            success: function success(data) {
	                $.spinner().stop();
	                var dropdowns = $('#' + data.formId).find('.js-autofill-address-field select');
	                updateDropdownOptions({
	                    dropdowns: dropdowns,
	                    valuesLists: data.valuesLists
	                });
	            },
	            error: function error() {
	                $.spinner().stop();
	            },
	            // this is important to prevent the code to move forward (since the next instruction would be the assignment of the variables -> not possible for select elements if the dropdown are not yet populated)
	            async: false
	        });
	    }
	}

	module.exports = {

	    // autofill method to populate the dropdown of an address field once the previous field gets selected, and clean the others if necessary (used by Bata ID and Bata TH)
	    autofillAddressFields: function autofillAddressFields() {
	        $('body').on('change', '.js-autofill-address-field select', function (e) {
	            e.preventDefault();
	            var $addressFieldElement = $(this);
	            // $addressSectionContainer is checkout-exclusive
	            var $addressSectionContainer = $addressFieldElement.closest('.addressContainer');
	            var url = $addressFieldElement.data('url-action'),
	                formId = $addressFieldElement.parents('form')[0].id,
	                section = $addressSectionContainer.data('section'),
	                fieldValue = $addressFieldElement.val(),
	                fieldType = $addressFieldElement.closest('.editable-block').data('field-type'),
	                nextFieldUnique = $addressFieldElement.closest('.editable-block').data('next-field-unique'),
	                $billingAddressSameAsShippingElement = $('#shippingBillingSame'),
	                isShippingBillingSameChecked = $billingAddressSameAsShippingElement.is(':checked'),
	                $addressSectionContainerBilling = $('#customerForm').find('.addressContainer[data-section="billing"]');
	            $.spinner().start();
	            $.ajax({
	                url: url,
	                type: 'POST',
	                data: {
	                    formId: formId,
	                    fieldValue: fieldValue,
	                    fieldType: fieldType,
	                    nextFieldUnique: nextFieldUnique
	                },
	                success: function success(data) {
	                    if (data.success) {
	                        if (data.nextFieldUnique) {
	                            /* in case of unique text field (for example, the zipcode in ID), the previous field (in the example, the subdistrict)
	                                has an attribute 'data-next-field-unique' set, to autocomplete the next one straight away */
	                            manageUniqueField(data, section);
	                        } else {
	                            updateAddress($addressSectionContainer, data, section, isShippingBillingSameChecked, fieldValue, fieldType);
	                        }

	                        if (isShippingBillingSameChecked) {
	                            if (data.nextFieldUnique) {
	                                manageUniqueField(data, 'billing');
	                            }
	                            updateAddress($addressSectionContainerBilling, data, 'billing', isShippingBillingSameChecked, fieldValue, fieldType);
	                        }
	                        // update of bootstrap selectpicker - to apply the visualization of the update
	                        var $selectPicker = $('.selectpicker');
	                        if ($selectPicker.length) {
	                            $selectPicker.selectpicker('refresh');
	                        }
	                    }
	                    $.spinner().stop();
	                },
	                error: function error() {
	                    $.spinner().stop();
	                },
	                async: false
	            });
	        });
	    },

	    methods: {
	        handleUniqueFieldsFormValues: handleUniqueFieldsFormValues,
	        updateDropdownOptions: updateDropdownOptions,
	        updateDropdownOptionsAjax: updateDropdownOptionsAjax
	    }
	};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var addressFieldAutocomplete = __webpack_require__(60),
	    formHelpers = __webpack_require__(62),
	    addressAttributeList = [];

	/**
	 * Given a map of attributes and a target element in the DOM, it updates the data
	 * @param {Object} attrs - A map which contains all the fields to update
	 * @param {Element} $form - The element which contains the fields to be updated
	 * @param {Boolean} triggerAutocomplete - a boolean which eventually triggers autocomplete logics
	 * @param {Boolean} forceUpdate - a boolean which force the target element update, even if the source data is null
	 */
	function populateFieldsWithObject(attrs, $form, triggerAutocomplete, forceUpdate) {
	    var currentAttribute, currentVal;
	    for (var i = 0; i < addressAttributeList.length; i++) {
	        currentAttribute = addressAttributeList[i];
	        currentVal = attrs[currentAttribute];
	        if (currentVal || forceUpdate) {
	            // try to search the input field as a string input
	            var $radioInput = $('input[name$=_' + currentAttribute + '][type="radio"][value="' + currentVal + '"]', $form),
	                $standardInput = $('input[name$=_' + currentAttribute + ']:not([type="radio"])', $form),
	                $selectInput = $('select[name$=_' + currentAttribute + ']', $form),
	                elementFound = false;

	            if ($radioInput.length) {
	                $radioInput.prop('checked', true);
	                elementFound = $radioInput;
	            } else if ($standardInput.length) {
	                $standardInput.val(currentVal);
	                elementFound = $standardInput;
	            } else if ($selectInput.length) {
	                // check if the option is already present in the dropdowns
	                // if so selecte it, otherwhise build a new one and place it into the select element
	                var $optionPresent = $selectInput.find('option[value="' + currentVal + '"]');
	                if ($optionPresent.length) {
	                    $optionPresent.prop('selected', true);
	                } else {
	                    $selectInput.html('<option value=' + currentVal + ' selected>' + currentVal + '</option>');
	                }
	                elementFound = $selectInput;
	            }

	            // if the element we just updated has some autocomplete logic -> trigger it to prefill the next element
	            if (elementFound && triggerAutocomplete && elementFound.is('input') && elementFound.hasClass('js-city-autocomplete')) {
	                elementFound.trigger('blur');
	            }

	            // if the element doesn't exist (like address2, district, subdistrict in some countries, the element is simply skipped)
	        }
	    }
	}

	/**
	 * Given an custome address element, retrieve the address data
	 * @param {Element} $address - the element which contains the address data
	 * @return {Object} - an object with all the address values
	 */
	function getAddressObjectFromElement($address) {
	    // standard attributes
	    var address = {
	        'addressId': $address.data('address-id'),
	        'address1': $address.data('address1'),
	        'address2': $address.data('address2'),
	        'subdistrict': $address.data('subdistrict'),
	        'district': $address.data('district'),
	        'city': $address.data('city'),
	        'stateCode': $address.data('state-code'),
	        'countryCode': $address.data('country-code'),
	        'postalCode': $address.data('postal-code'),
	        'isValidated': $address.data('is-validated') || "false"
	    };

	    // those fields has to be optional, since the argument address could be the result of an address suggestion
	    // (which doens't provide all the address information)
	    var optionalAttributesForAddress = [{
	        key: 'title',
	        value: $address.data('title')
	    }, {
	        key: 'firstName',
	        value: $address.data('first-name')
	    }, {
	        key: 'lastName',
	        value: $address.data('last-name')
	    }];

	    var currentAttr = void 0;
	    for (var i = 0; i < optionalAttributesForAddress.length; i++) {
	        currentAttr = optionalAttributesForAddress[i];
	        if (currentAttr.value && currentAttr.value.length >= 1) {
	            address[currentAttr.key] = currentAttr.value;
	        }
	    }
	    return address;
	}

	/**
	 * Given an custome address element, it copies all it's data to the target address form
	 * @param {Element} $customerAddressSelected - Object that contains shipping address
	 * @param {Element} $formContainer - The element which contains the address form
	 */
	function copyCustomerAddressToAddressForm($customerAddressSelected, $formContainer) {
	    var attrs = getAddressObjectFromElement($customerAddressSelected);
	    populateFieldsWithObject(attrs, $formContainer, true, true);
	}

	/**
	 * Verify if the address already exists as a stored user address
	 * @param {Object} address - Object that contains shipping address
	 * @param {Object} storedAddresses - List of stored user addresses
	 * @returns {boolean} - Boolean indicating if the address already exists
	 */
	function checkIfAddressStored(address, storedAddresses) {
	    for (var i = 0, l = storedAddresses.length; i < l; i++) {
	        if (storedAddresses[i].address1 === address.address1 && storedAddresses[i].postalCode === address.postalCode && storedAddresses[i].firstName === address.firstName && storedAddresses[i].lastName === address.lastName && storedAddresses[i].title === address.title && storedAddresses[i].subdistrict === address.subdistrict && storedAddresses[i].district === address.district && storedAddresses[i].city === address.city && storedAddresses[i].stateCode === address.stateCode) {
	            return true;
	        }
	    }
	    return false;
	}

	/**
	 * Substitute the title in the address with its localized version
	 * @param {Object} address - Object that contains the address
	 */
	function setLocalizedTitle(title) {
	    var femaleTitle = $('.js-container-checkout').data('female-title'),
	        femaleTitleToUse = $('.js-container-checkout').data('female-title-to-use'),
	        maleTitleToUse = $('.js-container-checkout').data('male-title-to-use'),
	        notUseDotForTitle = $('.js-container-checkout').data('no-use-dot-for-title'),
	        titleToUse;

	    if (title.endsWith(".")) {
	        // first, remove the eventual dot we might have from the title received, to compare it with the data values
	        title.slice(0, -1);
	    }
	    titleToUse = title === femaleTitle ? femaleTitleToUse : maleTitleToUse;
	    // Finally we make sure that the title forwarded ends with a dot
	    if (notUseDotForTitle || titleToUse.endsWith('.')) {
	        return titleToUse;
	    } else {
	        return titleToUse + '.';
	    }
	}

	/**
	 * Populate the Billing Address Summary View
	 * @param {string} parentSelector - the top level DOM selector for a unique address summary
	 * @param {Object} address - the address data
	 */
	function populateAddressSummary(parentSelector, address) {
	    if (address.title) {
	        address.title = setLocalizedTitle(address.title);
	    }
	    $.each(address, function (attr) {
	        var val = address[attr];
	        $('.' + attr, parentSelector).text(val ? val.value || val : '');
	    });
	}

	/**
	 * returns a formed <input /> element
	 * @param {Object} shipping - the shipping object (shipment model)
	 * @param {boolean} selected - current shipping is selected (for PLI)
	 * @param {order} order - the Order model
	 * @param {Object} [options] - options
	 * @returns {Object} - the jQuery / DOMElement
	 */
	// eslint-disable-next-line complexity
	function optionValueForAddress(shipping, selected, order, options) {
	    var safeOptions = options || {};
	    var isBilling = safeOptions.type && safeOptions.type === 'billing';
	    var className = safeOptions.className || 'manual-entry';
	    var isSelected = selected;
	    var isNew = !shipping;
	    var safeShipping = shipping || {};
	    var shippingAddress = safeShipping.shippingAddress || {};
	    var shippingMethod = order.shipping[0].selectedShippingMethod.ID;

	    if (isBilling && isNew && !order.billing.matchingAddressId) {
	        shippingAddress = order.billing.billingAddress.address || {};
	        if (!shippingAddress) {
	            isNew = false;
	            isSelected = true;
	            safeShipping.UUID = 'manual-entry';
	        } else {
	            isSelected = true;
	            if (shippingMethod === 'STS' || order.isCollectionPoint) {
	                shippingAddress = {};
	            }
	        }
	    }

	    var uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
	    var newAddressRadioID = isBilling ? 'newAddressRadio' : 'shipping-newAddressRadio';
	    var addressRadioName = isBilling ? 'addressSelector' : 'shipping-radio';
	    var id = isNew ? newAddressRadioID : uuid;
	    var optionEl = $('<div class="cc-content-radio"><input type="radio" id="' + id + '" name="' + addressRadioName + '" class="cc-radio ' + className + '" /> <label class="cc-radio-label" for="' + id + '"></label></div>');

	    $(optionEl).find('input').val(uuid);

	    var title;

	    if (isNew) {
	        title = order.resources.addNewAddress;
	    } else {
	        title = [];
	        if (shippingAddress.title) {
	            var titleToUse = setLocalizedTitle(shippingAddress.title);
	            title.push(titleToUse);
	        }

	        if (shippingAddress.firstName) {
	            title.push(shippingAddress.firstName);
	        }
	        if (shippingAddress.lastName) {
	            title.push(shippingAddress.lastName + ',');
	        }
	        if (shippingAddress.address1) {
	            title.push(shippingAddress.address1 + ',');
	        }
	        if (shippingAddress.address2) {
	            title.push(shippingAddress.address2 + ',');
	        }
	        if (shippingAddress.postalCode) {
	            title.push(shippingAddress.postalCode.value || shippingAddress.postalCode);
	        }
	        if (shippingAddress.subdistrict) {
	            title.push((shippingAddress.subdistrict.value || shippingAddress.subdistrict) + ',');
	        }
	        if (shippingAddress.district) {
	            title.push((shippingAddress.district.value || shippingAddress.district) + ',');
	        }
	        if (shippingAddress.city) {
	            title.push((shippingAddress.city.value || shippingAddress.city) + ',');
	        }
	        if (shippingAddress.stateCode) {
	            title.push((shippingAddress.stateCode.value || shippingAddress.stateCode) + ',');
	        }
	        if (shippingAddress.countryCode) {
	            title.push(shippingAddress.countryCode.displayValue);
	        }

	        if (title.length > 2) {
	            title = title.join(' ');
	        } else {
	            title = order.resources.newAddress;
	        }
	    }
	    $(optionEl).find('label').text(title);

	    if (!jQuery.isEmptyObject(shippingAddress)) {
	        if (shippingAddress.isAddressLengthValid !== null) {
	            if (shippingAddress.isAddressLengthValid !== null || shippingAddress.address1 !== null) {
	                if (!shippingAddress.isAddressLengthValid) {
	                    $(optionEl).find('label').append('<span class=\'cc-invalid-address-warning\'>' + shippingAddress.addressLengthWarning + '</span>');
	                }
	            }
	        }
	    }

	    var keyMap = {
	        'data-title': 'title',
	        'data-first-name': 'firstName',
	        'data-last-name': 'lastName',
	        'data-address1': 'address1',
	        'data-address2': 'address2',
	        'data-subdistrict': 'subdistrict',
	        'data-district': 'district',
	        'data-city': 'city',
	        'data-state-code': 'stateCode',
	        'data-postal-code': 'postalCode',
	        'data-country-code': 'countryCode',
	        'data-phone': 'phone'
	    };
	    $.each(keyMap, function (key) {
	        var mappedKey = keyMap[key];
	        var mappedValue = shippingAddress[mappedKey];
	        // In case of country code
	        if (mappedValue && (typeof mappedValue === 'undefined' ? 'undefined' : _typeof(mappedValue)) === 'object') {
	            mappedValue = mappedValue.ID || mappedValue.value;
	        }

	        $(optionEl).find('input').attr(key, mappedValue || '');
	    });

	    var giftObj = {
	        'data-is-gift': 'isGift',
	        'data-gift-message': 'giftMessage'
	    };

	    $.each(giftObj, function (key) {
	        var mappedKey = giftObj[key];
	        var mappedValue = safeShipping[mappedKey];
	        $(optionEl).find('input').attr(key, mappedValue || '');
	    });

	    if (isSelected) {
	        $(optionEl).find('input').attr('selected', true);
	        $(optionEl).find('input').attr('checked', true);
	    }

	    return optionEl;
	}

	/**
	 * returns address properties from a UI form
	 * @param {Form} form - the Form element
	 * @returns {Object} - a JSON object with all values
	 */
	function getAddressFieldsFromUI(form) {
	    var address = {
	        title: $('input[name$=_title]:checked', form).val(),
	        firstName: $('input[name$=_firstName]', form).val(),
	        lastName: $('input[name$=_lastName]', form).val(),
	        address1: $('input[name$=_address1]', form).val(),
	        address2: $('input[name$=_address2]', form).val(),
	        subdistrict: $('select[name$=_subdistrict],input[name$=_subdistrict]', form).val(),
	        district: $('select[name$=_district],input[name$=_district]', form).val(),
	        city: $('select[name$=_city],input[name$=_city]', form).val(),
	        postalCode: $('select[name$=_postalCode],input[name$=_postalCode]', form).val(),
	        stateCode: $('select[name$=_stateCode],input[name$=_stateCode]', form).val(),
	        countryCode: $('select[name$=_country]', form).val(),
	        phone: $('input[name$=_phone]', form).val(),
	        email: $('input[name$=_email]', form).val()
	    };
	    return address;
	}

	/**
	 * Autocomplete city and state field on pincode entered
	 * @param {*} $pincode - the element containing the pincode inserted
	 */
	function cityAutocomplete($pincode, skipChangeTrigger) {
	    var url = $pincode.data('url'),
	        zipCode = $pincode.val().trim().replaceAll(/\s/g, ''),
	        newZipCode = $pincode.hasClass('js-format-zipCode') ? zipCode.substr(0, 3) + " " + zipCode.substr(3) : zipCode,
	        $form = $pincode.closest('form'),
	        $addressContext = $pincode.closest('.addressContainer');
	    var formContext = $form.attr('name');
	    var data = {
	        newZipCode: newZipCode,
	        formContext: formContext,
	        addressContext: $addressContext.data('section')
	    };

	    $pincode.val(newZipCode);
	    if (!skipChangeTrigger) {
	        $pincode.trigger('change');
	    }
	    var $zipCodeElement = $pincode;
	    $zipCodeElement.removeClass('is-invalid custom-error');
	    $.spinner().start();
	    $.ajax({
	        url: url,
	        type: 'GET',
	        data: data,
	        success: function success(data) {
	            $addressContext.find('.js-city-container').closest('.editable-block').html(data);
	            // Set the province (IT scenario)
	            var $provinceAutocompleteValue = $addressContext.find('.js-province-autocomplete-value');
	            var $provinceAutocompleteSelect = $addressContext.find('select.js-province-autocomplete');
	            if ($provinceAutocompleteValue && $provinceAutocompleteValue.length && $provinceAutocompleteSelect && $provinceAutocompleteSelect.length) {
	                var provinceAutoSelectedId = $provinceAutocompleteValue.data('province');
	                $provinceAutocompleteSelect.val(provinceAutoSelectedId).data('selected-id', provinceAutoSelectedId);
	            } else if ($provinceAutocompleteSelect && $provinceAutocompleteSelect.length) {
	                $provinceAutocompleteSelect.val('').data('selected-id', '');
	            }
	            var $autoCompleteElementUpdated = $($addressContext.find('.js-city-container select.js-city-field-autocomplete'));
	            if ($autoCompleteElementUpdated.data('error')) {
	                var errorMessage = $autoCompleteElementUpdated.data('error');
	                $zipCodeElement.addClass('is-invalid custom-error');
	                $zipCodeElement.parents('.cc-form-group').find('.invalid-feedback').text(errorMessage);
	                if ($zipCodeElement.hasClass('js-validation-add-tick')) {
	                    $zipCodeElement.closest('.cc-content-input').removeClass('cc-tick-ok');
	                }
	                if ($autoCompleteElementUpdated.hasClass('js-validation-add-tick')) {
	                    $autoCompleteElementUpdated.closest('.cc-content-select').removeClass('cc-tick-ok');
	                }
	            } else {
	                $autoCompleteElementUpdated.trigger('change');
	            }
	            // refresh the select picker in the dom
	            $('body').trigger('selectPicker:refresh');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        },
	        async: false
	    });
	}

	/**
	 * Intermediate method called when uploading the options in an address field dropdown
	 * @param {Form} form - the Form element
	 * @param {Array} valuesLists - the list of objects containing the new options for the dropdown
	 */
	function updateAddressFieldsDropdowns(form, valuesLists) {
	    var dropdowns = form.find('.js-autofill-address-field select');
	    addressFieldAutocomplete.methods.updateDropdownOptions({
	        dropdowns: dropdowns,
	        valuesLists: valuesLists
	    });
	}

	/**
	 * Method to hide the shipping cost box of the now deselected shipping method radio button
	 * @param {String} shippingMethodID - the ID of the shipping method selected
	 */
	function manageShippingCostBox(shippingMethodID) {
	    if (shippingMethodID === 'STS') {
	        // if a STH shipping cost was shown, hide it
	        if ($('#js-dynamic-shipping-cost-content').html()) {
	            $('#js-dynamic-shipping-cost').addClass('d-none');
	        }
	        // if a STS shipping cost was already present, show it
	        if ($('#js-click-collect-dynamic-shipping-cost-content').html()) {
	            $('#js-click-collect-dynamic-shipping-cost').removeClass('d-none');
	        }
	    } else {
	        // if a STS shipping cost was shown, hide it
	        if ($('#js-click-collect-dynamic-shipping-cost-content').html()) {
	            $('#js-click-collect-dynamic-shipping-cost').addClass('d-none');
	        }
	        // if a STS shipping cost was already present, show it
	        if ($('#js-dynamic-shipping-cost-content').html()) {
	            $('#js-dynamic-shipping-cost').removeClass('d-none');
	        }
	    }
	}

	/**
	 * Does Ajax call to update the home delivery time slot isml
	 * @param {string} pincode - the element containing the pincode inserted
	 * @param {string} url- the url which will be used to read the controller
	 * @param {string} shippingMethodId - the id of the shipping method selected
	 */
	function homeDeliveryTimeSlotAjax(pincode, url, shippingMethodId) {
	    var zipCode = pincode.trim().replaceAll(/\s/g, ''),
	        updateZipCode = zipCode.substr(0, 3) + " " + zipCode.substr(3);
	    var data = {
	        updateZipCode: updateZipCode,
	        shippingId: shippingMethodId
	    };
	    $.spinner().start();
	    $.ajax({
	        url: url,
	        type: 'GET',
	        data: data,
	        success: function success(data) {

	            var $timeslot = $('.js-timeslot');
	            $timeslot.empty().html(data.homeDeliveryTemplate);
	            if ($timeslot.find('input.js-option').length > 0) {
	                $timeslot.removeClass('d-none');
	            } else {
	                $timeslot.addClass('d-none');
	            }
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	/**
	 * Fetch the address form for the edit address modal
	 * @param {Element} $addressEelement - the element which triggered the action
	 * @param {String} mode - the configuration for the new address to load
	 */
	function openAddressModal($addressEelement, mode) {
	    var $addressFormModal = $('#editAddressCheckoutModal');
	    var addressListContainerSection = $addressEelement.closest('.js-addressListContainerSection').data('section'),
	        newAddressFormModalTitle = $addressFormModal.data('title-' + mode),
	        url = $addressFormModal.data('action');
	    var payload = {};
	    if (mode === 'edit') {
	        payload.addressId = $addressEelement.closest('.js-customerAddressElement').find('.js-customerAddress').data('address-id');
	    }

	    $.spinner().start();
	    $.ajax({
	        url: url,
	        type: 'GET',
	        data: payload,
	        success: function success(data) {
	            if (data.error) {
	                window.location.href = data.redirectUrl;
	            } else {
	                $addressFormModal.find('.js-editAddressCheckoutContainer').empty().html(data);
	                $('body').trigger('selectPicker:refresh');
	                $addressFormModal.data('section', addressListContainerSection);
	                $addressFormModal.find('.js-modal-title').empty().text(newAddressFormModalTitle);
	                $addressFormModal.modal('show');
	                $.spinner().stop();
	            }
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	/**
	 * Even which handle the address modal form submit
	 * @param {Element} $newAddressFormModal - the element containing the modal which is going to show the new/edit address modal
	 * @param {Element} $addressForm - the address form to submit
	 * @param {String} url - the url to the pipeline
	 */
	function saveAddress($newAddressFormModal, $addressForm, url, params) {
	    $.spinner().start();
	    if ($addressForm.find('.js-province-autocomplete').length) {
	        $addressForm.find('.js-province-autocomplete').prop('disabled', false);
	    }
	    var payload = $addressForm ? $addressForm.serialize() : '',
	        async = params.async;
	    $.ajax({
	        url: url,
	        type: 'POST',
	        dataType: 'json',
	        data: payload,
	        success: function success(data) {
	            if (data.error && data.fieldErrors.length) {
	                // errors detected
	                data.fieldErrors.forEach(function (error) {
	                    if (Object.keys(error).length) {
	                        formHelpers.loadFormErrors($addressForm, error);
	                    }
	                });

	                if ($addressForm.find('.js-province-autocomplete').length) {
	                    $addressForm.find('.js-province-autocomplete').prop('disabled', true);
	                }
	            } else {
	                // address correctly saved
	                $('body').trigger('updateView', { sections: data.sectionToReload });
	                if ($newAddressFormModal) {
	                    $newAddressFormModal.modal('hide');
	                }
	            }
	            $('body').trigger('selectPicker:refresh');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        },
	        async: async
	    });
	}

	$(document).ready(function () {
	    // fetch the order of address attribute to populate
	    addressAttributeList = $('#customerForm').data('address-fields-order');
	});

	function updateDniInputMaxLength(selectedInput) {
	    var input = $('#dni-validation-checkout');
	    if (selectedInput === 'CE') {
	        input.prop('maxLength', 9);
	    }
	    if (selectedInput === 'DNI') {
	        input.prop('maxLength', 8);
	    }
	}

	$('#documentPick').on('change', function () {
	    var $selectedInput = $(this).find('option:selected').val();
	    updateDniInputMaxLength($selectedInput);
	});

	$('#dni-validation-checkout').on('change', function () {
	    var $dni = $(this);
	    // Extra validation for DNI's regex
	    $dni.trigger('validateDNIPattern', $dni);
	});

	$('#dni-validation-checkout').on('input', function () {
	    this.value = this.value.replace(/[^0-9]/g, '');
	});

	module.exports = {
	    methods: {
	        populateFieldsWithObject: populateFieldsWithObject,
	        getAddressObjectFromElement: getAddressObjectFromElement,
	        copyCustomerAddressToAddressForm: copyCustomerAddressToAddressForm,
	        checkIfAddressStored: checkIfAddressStored,
	        populateAddressSummary: populateAddressSummary,
	        optionValueForAddress: optionValueForAddress,
	        getAddressFieldsFromUI: getAddressFieldsFromUI,
	        updateAddressFieldsDropdowns: updateAddressFieldsDropdowns,
	        manageShippingCostBox: manageShippingCostBox,
	        cityAutocomplete: cityAutocomplete,
	        homeDeliveryTimeSlotAjax: homeDeliveryTimeSlotAjax,
	        openAddressModal: openAddressModal,
	        saveAddress: saveAddress
	    }
	};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var scrollAnimate = __webpack_require__(63);
	var updateCounters = __webpack_require__(64);

	function insertInvalid(attr, parentSelector, fieldErrors) {
	    var $inputElement = $('*[name=' + attr + ']', parentSelector);
	    $inputElement.addClass('is-invalid');

	    if ($inputElement.closest('.cc-form-group').find('.cc-text-message').length) {
	        $inputElement.closest('.cc-form-group').find('.cc-text-message').html(fieldErrors[attr]);
	    } else {
	        $inputElement.closest('.cc-form-group').find('.invalid-feedback').html(fieldErrors[attr]);
	        // if it is available in the DOM hide the Validado message (Peru DNI/Foreign)
	        if ($inputElement.closest('.cc-form-group').find('.cc-valid-success').length) {
	            $inputElement.closest('.cc-form-group').find('.cc-valid-success').addClass('d-none');
	        }
	    }
	    // for certain fields the errors are managed in a custom way
	    $inputElement.trigger('customValidation:invalid');
	}

	/**
	 * Display error messages and highlight form fields with errors.
	 * @param {string} parentSelector - the form which contains the fields
	 * @param {Object} fieldErrors - the fields with errors
	 */
	function loadFormErrors(parentSelector, fieldErrors) {
	    // eslint-disable-line
	    // Display error messages and highlight form fields with errors.
	    $.each(fieldErrors, function (attr) {
	        if ($('.cc-phone-input-box').length && attr.indexOf('phone') > -1) {
	            $('*[name=' + attr + ']', parentSelector).closest('.cc-phone-input-box').addClass('is-invalid').closest('.cc-form-group').find('.invalid-feedback').html(fieldErrors[attr]);
	        } else {
	            insertInvalid(attr, parentSelector, fieldErrors);
	        }
	    });
	    // Update counter of address length
	    updateCounters.updateAllAddressLengthCounters();
	    // refresh selectpicker to show errors also on the dropdowns (if present)
	    $('body').trigger('selectPicker:refresh');

	    // Animate to top of form that has errors
	    var $invalidElements = $(parentSelector).find('.is-invalid, .custom-error');
	    if ($invalidElements.length > 0) {
	        var $firstElement = $invalidElements.first();
	        if ($firstElement.length > 0) {
	            $firstElement[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	        }
	    }
	}

	/**
	 * Display error messages and highlight field with errors.
	 * @param {string} parentSelector - the form which contains the fields
	 * @param {Object} fieldError - the field with errors
	 */
	function loadFieldErrors(fieldName, errorToShow) {
	    // eslint-disable-line
	    // Display error messages and highlight form field with errors.

	    $('*[name=' + fieldName + ']').addClass('is-invalid').siblings('.invalid-feedback').html(errorToShow);

	    $('*[name=' + fieldName + ']').closest('.cc-content-input').removeClass('cc-tick-ok');

	    // Animate to top of form that has errors
	    scrollAnimate($('*[name=' + fieldName + ']'));
	}

	/**
	 * Display error messages and highlight field with errors.
	 * @param {string} parentSelector - the form which contains the fields
	 * @param {Object} fieldError - the field with errors
	 */
	function loadFieldMessage(fieldName, messageToShow) {
	    // eslint-disable-line
	    // Display error messages and highlight form field with errors.

	    $('*[name=' + fieldName + ']').addClass('is-valid').siblings('.valid-feedback').html(messageToShow);

	    $('*[name=' + fieldName + ']').siblings('.cc-valid-icon').removeClass('d-none');
	    // Animate to top of form that has errors
	    scrollAnimate($('*[name=' + fieldName + ']'));
	}

	function loadFieldMessageMultiple(fieldName, messageToShow, classMessage, container, id) {
	    // eslint-disable-line
	    // Display error messages and highlight form field with errors.

	    $('*[name=' + fieldName + ']').addClass('is-valid').siblings(classMessage).clone().html(messageToShow).attr('id', id).removeClass('d-none').appendTo(container);
	    $('*[name=' + fieldName + ']').siblings('.cc-valid-icon').removeClass('d-none');

	    // Animate to top of form that has errors
	    scrollAnimate($('*[name=' + fieldName + ']'));
	}

	/**
	 * Clear the field errors.
	 * @param {string} parentSelector - the parent form selector.
	 */
	function clearFieldMessageMultiple(fieldName, classMessage, element) {
	    $('*[name=' + fieldName + ']').removeClass('is-invalid');
	    $('*[name=' + fieldName + ']').siblings(classMessage)[element].empty().addClass('d-none');

	    // $('*[name=' + fieldName + ']').siblings('.invalid-feedback').hide();
	}

	/**
	 * Clear the field errors.
	 * @param {string} parentSelector - the parent form selector.
	 */
	function clearFieldPreviousError(fieldName) {
	    $('*[name=' + fieldName + ']').removeClass('is-invalid');
	    // $('*[name=' + fieldName + ']').siblings('.invalid-feedback').hide();
	}

	/**
	 * Clear the form errors.
	 * @param {string} parentSelector - the parent form selector.
	 */
	function clearPreviousErrors(parentSelector) {
	    $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
	    $(parentSelector).find('.cc-phone-input-box.is-invalid').removeClass('is-invalid');
	    $(parentSelector).find('.cc-counter.is-invalid').removeClass('is-invalid'); // removes class from address length counter

	    // reset counter
	    $.each($(parentSelector).find('.js-has-length-counter'), function (ind, element) {
	        $(element).parents('.cc-form-group').find('.js-field-length-counter').text(element.value.length);
	        // Set counter validity to invalid if the address length exceeds the limit
	        if ($(element).data('max-acceptable-length') < element.value.length) {
	            $(element).parents('.cc-form-group').find('.cc-counter').addClass('is-invalid');
	        }
	    });
	    $('.error-message').hide();
	}

	/**
	 * Clears the errors of the Coupon form
	 * @param {String} formSelector - The selector of the coupons form
	 */
	function clearCouponErrors(formSelector) {
	    $(formSelector).find('.form-control.is-invalid').not('.custom-error').removeClass('is-invalid');
	    $(formSelector).find('.coupon-missing-error').removeClass('d-block');
	    $(formSelector).find('.cc-button-remove-error').removeClass('d-block');
	    $(formSelector).find('.coupon-error-message').removeClass('d-block');
	    $(formSelector).find('.coupon-error-message').empty();
	}

	module.exports = {
	    loadFormErrors: loadFormErrors,
	    loadFieldErrors: loadFieldErrors,
	    loadFieldMessage: loadFieldMessage,
	    loadFieldMessageMultiple: loadFieldMessageMultiple,
	    clearFieldMessageMultiple: clearFieldMessageMultiple,
	    clearPreviousErrors: clearPreviousErrors,
	    clearFieldPreviousError: clearFieldPreviousError,
	    clearCouponErrors: clearCouponErrors
	};

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (element) {
	    var position = element && element.length ? element.offset().top : 0;
	    $('html, body').animate({
	        scrollTop: position
	    }, 500);
	    if (!element) {
	        $('.logo-home').focus();
	    }
	};

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    /**
	     * Update length displayed by the counter associated with the field itself
	     */
	    updateFieldLengthCounter: function updateFieldLengthCounter() {
	        $('body').on('input', '.js-has-length-counter', function () {
	            var inputLength = $(this).val().length;
	            $(this).parents('.cc-form-group').find('.js-field-length-counter').text(inputLength);
	        });
	    },

	    updateAllAddressLengthCounters: function updateAllAddressLengthCounters() {
	        var customElemArray = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	        if (customElemArray === null) {
	            $.each($('.js-has-length-counter'), function (ind, element) {
	                $(element).parents('.cc-form-group').find('.js-field-length-counter').text(element.value.length);
	                if ($(element).data('max-acceptable-length') < element.value.length) {
	                    $(element).parents('.cc-form-group').find('.cc-counter').addClass('is-invalid');
	                } else {
	                    $(element).parents('.cc-form-group').find('.cc-counter').removeClass('is-invalid');
	                }
	            });
	        }
	    }
	};

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var addressHelpers = __webpack_require__(61);
	var cleave = __webpack_require__(96);
	var addressFieldAutocomplete = __webpack_require__(60);
	var updateCounters = __webpack_require__(64);

	function updateAddressActiveClass() {
	    $('#billingAddressSelector input[type=radio]').parent('.cc-content-radio').removeClass('cc-active');
	    $('#billingAddressSelector input[type=radio]:checked').parent('.cc-content-radio').addClass('cc-active');
	}

	/**
	 * updates the billing address selector within billing forms
	 * @param {Object} order - the order model
	 * @param {Object} customer - the customer model
	 */
	function updateBillingAddressSelector(order, customer) {
	    var shippings = order.shipping;
	    var form = $('form[name$=billing]')[0];
	    var shippingForm = $('form[name$=shipping]')[0];
	    var $billingAddressSelector = $('.addressSelectorDiv', form);
	    var hasSelectedAddress = false;
	    var shippingMethod = order.shipping[0].selectedShippingMethod.ID;
	    var customerType = $('#checkout-main').attr('data-customer-type');

	    if ($billingAddressSelector && $billingAddressSelector.length === 1) {
	        $billingAddressSelector.empty();
	        var shippingFormAddressMode = $('form[id="shippingForm"]').attr('data-address-mode');

	        //add billing address only for STH
	        if (shippingMethod !== 'STS' && !order.isCollectionPoint && (shippingFormAddressMode === 'new' || shippingFormAddressMode === 'details')) {
	            shippings.forEach(function (aShipping) {
	                if (aShipping.shippingAddress && customer.addresses && !addressHelpers.methods.checkIfAddressStored(aShipping.shippingAddress, customer.addresses)) {
	                    var isSelected = order.billing.matchingAddressId === aShipping.UUID;
	                    hasSelectedAddress = hasSelectedAddress || isSelected;
	                    // Shipping Address option
	                    var optionAddress = addressHelpers.methods.optionValueForAddress(aShipping, isSelected, order, {
	                        type: 'billing'
	                    });
	                    $billingAddressSelector.append(optionAddress);
	                }
	            });
	        }

	        // Add New Address option
	        var newOptionAddres = addressHelpers.methods.optionValueForAddress(null, false, order, { type: 'billing' });

	        if (customer.addresses && customer.addresses.length > 0) {
	            customer.addresses.forEach(function (address) {

	                // eslint-disable-next-line no-extra-boolean-cast
	                var isSelected = order.billing.matchingAddressId === (!!address ? address.ID : null);
	                hasSelectedAddress = hasSelectedAddress || isSelected;
	                // Customer Address option
	                var optionCustomerAddress = addressHelpers.methods.optionValueForAddress({
	                    // eslint-disable-next-line no-extra-boolean-cast
	                    UUID: 'billing_ab_' + (!!address ? address.ID : ''),
	                    shippingAddress: address
	                }, isSelected, order, { type: 'billing' });
	                //append addressbook's addresses radio buttons
	                $billingAddressSelector.append(optionCustomerAddress);
	            });
	        }
	        //append the 'new address' radio button
	        $billingAddressSelector.append(newOptionAddres);
	        updateAddressActiveClass();
	    }

	    if (hasSelectedAddress || !order.billing.matchingAddressId && order.billing.billingAddress.address && shippingMethod !== 'STS' && !order.isCollectionPoint) {
	        // show
	        $(form).attr('data-address-mode', 'edit');
	        if (customerType === 'guest') {
	            $(shippingForm).attr('data-address-mode', 'new');
	        } else if (!customer.addresses.length && customerType === 'registered') {
	            $(shippingForm).attr('data-address-mode', 'new');
	        } else {
	            $(shippingForm).attr('data-address-mode', 'edit');
	        }
	    } else {
	        $(form).attr('data-address-mode', 'new');
	        $(shippingForm).attr('data-address-mode', 'new');
	    }

	    $billingAddressSelector.show();
	}

	/**
	 * Updates the billing address form values within payment forms without any payment instrument validation
	 * @param {Object} order - the order model
	 * @param {Object} [dropdownLists] - list of elements to populate the address fields' dropdowns in the form
	 */
	// eslint-disable-next-line complexity
	function updateBillingAddress(order, dropdownLists) {
	    var billing = order.billing;
	    if (!billing.billingAddress || !billing.billingAddress.address) {
	        return;
	    }

	    var form = $('form[name=dwfrm_billing]');
	    if (!form) {
	        return;
	    }

	    // if the form has dropdowns, refill them with options (to be done before setting the values)
	    // the dropdownList could be null, since the coupons application doesn't require a update on addresses
	    if ($('.js-autofill-address-field', form).length && dropdownLists) {
	        addressHelpers.methods.updateAddressFieldsDropdowns(form, dropdownLists);
	    }
	    //$('input[name$=_title]', form).val(billing.billingAddress.address.title);
	    if (billing.billingAddress.address.title) {
	        var genderId = '#billing_' + billing.billingAddress.address.title.toLowerCase().replace(".", "");
	        $('input[name$=_title]' + genderId, form).prop('checked', true);
	    }
	    $('input[name$=_firstName]', form).val(billing.billingAddress.address.firstName);
	    $('input[name$=_companyName]', form).val(billing.billingAddress.address.companyName);
	    $('input[name$=_taxNumber]', form).val(billing.billingAddress.address.taxNumber);
	    $('input[name$=_lastName]', form).val(billing.billingAddress.address.lastName);
	    $('input[name$=_address1]', form).val(billing.billingAddress.address.address1);
	    $('input[name$=_address2]', form).val(billing.billingAddress.address.address2);
	    $('input[name$=_address3]', form).val(billing.billingAddress.address.address3);
	    $('select[name$=_district],input[name$=_district]', form).val(billing.billingAddress.address.district ? billing.billingAddress.address.district.ID || billing.billingAddress.address.district : '');
	    $('select[name$=_subdistrict],input[name$=_subdistrict]', form).val(billing.billingAddress.address.subdistrict ? billing.billingAddress.address.subdistrict.ID || billing.billingAddress.address.subdistrict : '');
	    $('select[name$=_city],input[name$=_city]', form).val(billing.billingAddress.address.city ? billing.billingAddress.address.city.ID || billing.billingAddress.address.city : '');
	    $('input[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode ? billing.billingAddress.address.postalCode.value || billing.billingAddress.address.postalCode : '');
	    $('select[name$=_postalCode]', form).val(billing.billingAddress.address.postalCode ? billing.billingAddress.address.postalCode.ID || billing.billingAddress.address.postalCode : '');
	    $('select[name$=_stateCode],input[name$=_stateCode]', form).val(billing.billingAddress.address.stateCode ? billing.billingAddress.address.stateCode.ID || billing.billingAddress.address.stateCode : '');
	    $('select[name$=_country]', form).val(billing.billingAddress.address.countryCode.value);
	    $('input[name$=_phone]', form).val(billing.billingAddress.address.phone);
	    $('input[name$=_email]', form).val(order.orderEmail);
	}

	/**
	 * Validate and update payment instrument form fields
	 * @param {Object} order - the order model
	 */
	function validateAndUpdateBillingPaymentInstrument(order) {
	    var billing = order.billing,
	        form = $('form[name=dwfrm_billing]');
	    if (!billing.payment || !billing.payment.selectedPaymentInstruments || billing.payment.selectedPaymentInstruments.length <= 0 || billing.payment.selectedPaymentInstruments[0].paymentMethod === 'PayPal' || !form) {
	        return;
	    }
	    if (billing.payment && billing.payment.selectedPaymentInstruments && billing.payment.selectedPaymentInstruments.length > 0 && !billing.payment.selectedPaymentInstruments[0].paymentMethod === 'PayPal') {
	        var instrument = billing.payment.selectedPaymentInstruments[0];
	        $('select[name$=expirationMonth]', form).val(instrument.expirationMonth);
	        $('select[name$=expirationYear]', form).val(instrument.expirationYear);
	        // Force security code and card number clear
	        $('input[name$=securityCode]', form).val('');
	        $('input[name$=cardNumber]').data('cleave').setRawValue('');
	    }
	}

	/**
	 * Updates the billing address form values within payment forms
	 * @param {Object} order - the order model
	 * @param {List} dropdownLists - list of elements to populate the address fields' dropdowns in the form
	 */
	function updateBillingAddressFormValues(order, dropdownList) {
	    module.exports.methods.updateBillingAddress(order, dropdownList);
	    module.exports.methods.validateAndUpdateBillingPaymentInstrument(order);
	}

	/**
	 * clears the billing address form values
	 */
	function clearBillingAddressFormValues() {
	    updateBillingAddressFormValues({
	        billing: {
	            billingAddress: {
	                address: {
	                    countryCode: {}
	                }
	            }
	        }
	    });
	}

	/**
	 * Updates the billing information in checkout, based on the supplied order model
	 * @param {Object} order - checkout model to use as basis of new truth
	 * @param {List} dropdownLists - list of elements to populate the address fields' dropdowns in the form
	 */
	function updateBillingAddressSummary(order, dropdownLists) {
	    // update billing address form
	    if ($('.new')[0] && $('.new')[0].checked) {
	        $($('form[name$=billing]')[0]).attr('data-address-mode', 'new');
	        clearBillingAddressFormValues();
	    } else {
	        updateBillingAddressFormValues(order, dropdownLists);
	    }

	    var address = Object.assign({}, order.billing.billingAddress.address);

	    // update billing address summary
	    addressHelpers.methods.populateAddressSummary('.billing .address-summary', address);

	    if (address && address.address2) {
	        $('.billing .address-summary2').text(address.address2);
	    } else {
	        $('.billing .address-summary2').empty();
	    }

	    if (address && address.address3) {
	        $('.billing .address-summary3').text(address.address3);
	    } else {
	        $('.billing .address-summary3').empty();
	    }
	    if (address && address.companyName && address.taxNumber) {
	        $('.billing .companyName').text(address.companyName);
	        $('.billing .taxNumber').text(address.taxNumber);
	    } else {
	        $('.billing .companyName').empty();
	        $('.billing .taxNumber').empty();
	    }
	    var shippingCountry = $('.countryCode', '.billing');

	    if (address && address.countryCode && address.countryCode.displayValue && !order.isCollectionPoint) {
	        shippingCountry.text(address.countryCode.displayValue);
	    } else {
	        shippingCountry.empty();
	    }

	    // update billing parts of order summary
	    $('.order-summary-email').text(order.orderEmail);

	    if (order.billing.billingAddress.address) {
	        $('.order-summary-phone').text(order.billing.billingAddress.address.phone);
	    }
	}

	/**
	 * Updates the billing information in checkout, based on the supplied order model
	 * @param {Object} order - checkout model to use as basis of new truth
	 * @param {Object} customer - customer model to use as basis of new truth
	 * @param {List} dropdownLists - list of elements to populate the address fields' dropdowns in the form
	 * NOTE: PLEASE DO NOT REMOVE options PARAMETER FROM METHOD, OTHERWISE CALLER WILL STOP TO WORK CREATING ISSUE
	 */
	function updateBillingInformation(order, customer, options, dropdownLists) {
	    // Angelos-COMMENT: Do we still need this?
	    updateBillingAddressSelector(order, customer);

	    // update billing address form
	    // updateBillingAddressFormValues(order);

	    // update billing address summary and billing parts of order summary
	    updateBillingAddressSummary(order, dropdownLists);
	}

	/**
	 * clears the credit card form
	 */
	function clearCreditCardForm() {
	    $('input[name$="_cardNumber"]').data('cleave').setRawValue('');
	    $('select[name$="_expirationMonth"]').val('');
	    $('select[name$="_expirationYear"]').val('');
	    $('input[name$="_securityCode"]').val('');
	}

	function refreshBlockPaymentMethod(data) {
	    var keepOtpButtonDisabled;
	    if ($('#clubPointsCheckbox').is(':not(:disabled)') && $('#clubPointsOtpbutton').is(':disabled')) {
	        keepOtpButtonDisabled = true;
	    }

	    var $radioPaymentMethod = $('.cc-radio-payment-method'),
	        blockRadioMethods = false;
	    // eslint-disable-next-line eqeqeq
	    if (data.blockRadioMethods == true) {
	        blockRadioMethods = true;
	        $('#cod-content').addClass('d-none');
	        $radioPaymentMethod.prop('checked', false);
	        $('.payment-options .cc-payment-options-item').removeClass('cc-active');
	    }
	    $('.cod-content').prop('disabled', blockRadioMethods);
	    $('.js-cod').prop('disabled', blockRadioMethods);
	    $radioPaymentMethod.prop('disabled', blockRadioMethods);
	    $radioPaymentMethod.prop('required', !blockRadioMethods);

	    // eslint-disable-next-line eqeqeq
	    if (data.blockCreditMethod == true) {
	        $('.creditNote-js-disable').not(':checked').prop('disabled', true);
	        // $('.content-paymant-creditNotes').addClass('d-none');
	    } else {
	        $('.creditNote-js-disable').prop('disabled', false);
	    }

	    // eslint-disable-next-line eqeqeq
	    if (data.blockPointsMethod == true) {
	        $('.clubPoints-js-disable').not(':checked').prop('disabled', true);
	        // $('.content-paymant-clubPoints').addClass('d-none');
	    } else {
	        $('.clubPoints-js-disable').prop('disabled', false);
	    }

	    // eslint-disable-next-line eqeqeq
	    if (data.disableCod == true) {
	        $('.cod-js-disable').prop('disabled', true);
	    }

	    // Iterate over disablePaymentMethods
	    $.each(data.disablePaymentMethods, function (paymentMethod, isEnabled) {
	        if (!isEnabled) {
	            // Select the input element by the value of its ID
	            $('li.js-payment-container[value="' + paymentMethod + '"]').prop('disabled', true);
	        }
	    });

	    if (data.blockCodMethod) {
	        $('.cod-js-disable').prop('disabled', true);
	        $('.js-cod-option-price').addClass('cc-payment-options__price-disabled');
	    } else {
	        if ($('.js-cod-option-price').hasClass('cc-payment-options__price-disabled')) {
	            $('.js-cod-option-price').removeClass('cc-payment-options__price-disabled');
	        }
	    }

	    // eslint-disable-next-line eqeqeq
	    if (data.checkCreditPlusPointsExceed == true && data.checkCreditFe == true && data.blockCreditMethod != true) {
	        $('#creditNoteExceed').removeClass('d-none');
	    } else {
	        $('#creditNoteExceed').addClass('d-none');
	    }

	    // eslint-disable-next-line eqeqeq
	    if (data.checkCreditPlusPointsExceed == true && data.checkPointsFe == true && data.blockPointsMethod != true) {
	        $('#pointsExceed').removeClass('d-none');
	    } else {
	        $('#pointsExceed').addClass('d-none');
	    }

	    if (keepOtpButtonDisabled) {
	        $('#clubPointsOtpbutton').prop('disabled', true);
	    }

	    if (data.disableCoupon) {
	        $('#couponApplyButton').prop('disabled', true);
	        $('#couponRemoveButton').prop('disabled', true);
	    } else {
	        $('#couponApplyButton').prop('disabled', false);
	        $('#couponRemoveButton').prop('disabled', false);
	    }
	}

	/**
	 * Returns inserted zipCode associated cities list (CZ, SK ajax call)
	 * @param {jQuery} addressSelector - Address selector
	 * @param {jQuery} selectedOption - Checked billing address radio button
	 */
	function getCitiesListAjax(addressSelector, selectedOption) {
	    // TODO: to rework entirely
	    var url = addressSelector.data('cityautocomplete');
	    var zipCode = selectedOption.data('postal-code').trim().replaceAll(/\s/g, '');
	    var newZipCode = zipCode.substr(0, 3) + " " + zipCode.substr(3);
	    var isShippingForm;
	    var $form = addressSelector.parents('form');

	    if ($form.hasClass('js-shipping-form')) {
	        isShippingForm = true;
	    } else {
	        isShippingForm = false;
	    }

	    var data = {
	        newZipCode: newZipCode,
	        isCheckoutPage: true,
	        isShippingForm: isShippingForm
	    };

	    $.spinner().start();
	    $.ajax({
	        url: url,
	        type: 'GET',
	        data: data,
	        success: function success(data) {
	            $('.js-city-container', $form).closest('.editable-block').html(data);
	            $('select[name$=_city]', $form).val(selectedOption.data('city'));
	            var $selectPicker = $('.selectpicker');
	            if ($selectPicker.length) {
	                $selectPicker.selectpicker('refresh');
	            }
	            if ($('#city-field-autocomplete', $form).data('success')) {
	                $.spinner().stop();
	            } else {
	                $.spinner().stop();
	            }
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	/**
	 * Scan the payment section and retrieve the current payment method selected, if there is any
	 * @return {*} the payment method selected, false otherwhise
	 */
	function _checkAtLeastOnePaymentMethodIsSelected() {
	    var result = false,

	    // better to use $(document) in case of future payment methods which might be injected in the page
	    $paymentMethods = $(document).find('input[type=radio].js-radio-payment-method:checked');
	    if ($paymentMethods.length > 0) {
	        result = $paymentMethods;
	    }
	    return result;
	}

	module.exports = {
	    methods: {
	        updateBillingAddressSelector: updateBillingAddressSelector,
	        updateBillingAddressFormValues: updateBillingAddressFormValues,
	        clearBillingAddressFormValues: clearBillingAddressFormValues,
	        updateBillingInformation: updateBillingInformation,
	        // updatePaymentInformation: updatePaymentInformation,
	        clearCreditCardForm: clearCreditCardForm,
	        refreshBlockPaymentMethod: refreshBlockPaymentMethod,
	        updateBillingAddress: updateBillingAddress,
	        validateAndUpdateBillingPaymentInstrument: validateAndUpdateBillingPaymentInstrument
	    },

	    showBillingDetails: function showBillingDetails() {
	        $('.btn-show-billing-details').on('click', function () {
	            $(this).parents('[data-address-mode]').attr('data-address-mode', 'new');
	        });
	    },

	    hideBillingDetails: function hideBillingDetails() {
	        $('.btn-hide-billing-details').on('click', function () {
	            $(this).parents('[data-address-mode]').attr('data-address-mode', 'shipment');
	        });
	    },

	    selectBillingAddress: function selectBillingAddress() {
	        $('.payment-form .addressSelectorDiv').on('change', function () {
	            updateAddressActiveClass();
	            var $addressSelector = $(this);
	            var form = $addressSelector.parents('form')[0];
	            var selectedOption = $('input[type=radio]:checked', this);
	            var optionID = selectedOption[0].value;
	            // Copy fields
	            var attrs = selectedOption.data();
	            var element;

	            if ($('.js-autofill-address-field select', form).length) {
	                // pre-populate the dropdowns in order to set the values for the address fields
	                var data = {
	                    formId: form.id,
	                    attrs: attrs
	                };
	                addressFieldAutocomplete.methods.updateDropdownOptionsAjax(data);
	            }

	            if (optionID === 'new') {
	                // Show Address
	                $(form).attr('data-address-mode', 'new');
	            } else {
	                // Hide Address
	                $(form).attr('data-address-mode', 'shipment');
	            }

	            //If checkbox for add to address Book exists, for every occurence of address expect the new one
	            //set the checkbox false (CE + IT scenario)
	            var field = $(this).closest('.billing-address-block').find('.billing-address .js-addToAddressBook-checkbox');
	            if (optionID !== 'new' && field) {
	                field.prop("checked", false);
	            } // else if (order.billing.matchingAddressId !== order.shipping[0].matchingAddressId) {
	            //$('.address-selector-block').removeClass('d-none');}

	            if ($addressSelector.hasClass('js-city-autocomplete-billing')) {
	                addressHelpers.methods.cityAutocomplete($(this));
	                getCitiesListAjax($addressSelector, selectedOption);
	            }

	            Object.keys(attrs).forEach(function (attr) {
	                element = attr === 'countryCode' ? 'country' : attr;
	                if (element === 'cardNumber') {
	                    $('.cardNumber').data('cleave').setRawValue(attrs[attr]);
	                } else if (element === 'title') {
	                    // prefill the 'title' field radio button
	                    var genderId = attrs[attr] ? '#billing_' + attrs[attr].toLowerCase() : '';
	                    if (genderId) {
	                        $('[name$=' + element + ']' + genderId, form).prop('checked', true);
	                    } else {
	                        // clear
	                        $('[name$=' + element + ']', form).prop('checked', false);
	                    }
	                } else if (element !== 'country') {
	                    // ignore country field since it is not editable
	                    $('[name$=' + element + ']', form).val(attrs[attr]);
	                    // this is the case of the unique values that otherwise would be autofilled, we also need to carry their ID onto the attribute 'data-selected-id'
	                    if ($('[name$=' + element + ']', form).hasClass('js-change-value-with-id')) {
	                        $('[name$=' + element + ']', form).data('selected-id', attrs[attr]);
	                    }
	                }
	            });

	            updateCounters.updateAllAddressLengthCounters();
	            var $selectPicker = $('.selectpicker');
	            if ($selectPicker.length) {
	                $selectPicker.selectpicker('refresh');
	            }
	        });
	    },

	    handleCreditCardNumber: function handleCreditCardNumber() {
	        // cleave.handleCreditCardNumber('.cardNumber', '#cardType');
	    },

	    santitizeForm: function santitizeForm() {
	        $('body').on('checkout:serializeBilling', function (e, data) {
	            var serializedForm = cleave.serializeData(data.form);

	            data.callback(serializedForm);
	        });
	    },

	    selectSavedPaymentInstrument: function selectSavedPaymentInstrument() {
	        $(document).on('click', '.saved-payment-instrument', function (e) {
	            e.preventDefault();
	            $('.saved-payment-security-code').val('');
	            $('.saved-payment-instrument').removeClass('selected-payment');
	            $(this).addClass('selected-payment');
	            $('.saved-payment-instrument .card-image').removeClass('checkout-hidden');
	            $('.saved-payment-instrument .security-code-input').addClass('checkout-hidden');
	            $('.saved-payment-instrument.selected-payment' + ' .card-image').addClass('checkout-hidden');
	            $('.saved-payment-instrument.selected-payment ' + '.security-code-input').removeClass('checkout-hidden');
	        });
	    },

	    addNewPaymentInstrument: function addNewPaymentInstrument() {
	        $('.btn.add-payment').on('click', function (e) {
	            e.preventDefault();
	            $('.payment-information').data('is-new-payment', true);
	            clearCreditCardForm();
	            $('.credit-card-form').removeClass('checkout-hidden');
	            $('.user-payment-instruments').addClass('checkout-hidden');
	        });
	    },

	    cancelNewPayment: function cancelNewPayment() {
	        $('.cancel-new-payment').on('click', function (e) {
	            e.preventDefault();
	            $('.payment-information').data('is-new-payment', false);
	            clearCreditCardForm();
	            $('.user-payment-instruments').removeClass('checkout-hidden');
	            $('.credit-card-form').addClass('checkout-hidden');
	        });
	    },

	    clearBillingForm: function clearBillingForm() {
	        $('body').on('checkout:clearBillingForm', function () {
	            clearBillingAddressFormValues();
	        });
	    },

	    paymentTabs: function paymentTabs() {
	        $('.payment-options .nav-item').on('click', function (e) {
	            e.preventDefault();
	            var methodID = $(this).data('method-id');
	            $('.payment-information').data('payment-method-id', methodID);
	        });
	    },

	    displayNewAddressRadio: function displayNewAddressRadio() {
	        if ($('form[id="shippingForm"]').attr('data-address-mode') === 'new') {
	            $('.shippingAddresses').removeClass('d-none');
	        }
	    },

	    shippingBillingSame: function shippingBillingSame() {
	        $('body').on('change', '#shippingBillingSame', function () {
	            var $billingAddressSameAsShippingElement = $(this);
	            var $customerForm = $billingAddressSameAsShippingElement.closest('form');
	            var isShippingBillingSameChecked = $billingAddressSameAsShippingElement.is(':checked'),
	                $customerBillingAddressList = $customerForm.find('.js-addressListContainerSection[data-section="billing"]'),
	                $billingAddressSection = $customerForm.find('.addressContainer.billing');
	            if (isShippingBillingSameChecked) {
	                if ($customerBillingAddressList.length) {
	                    // logged in customer -> hide the address list
	                    $customerBillingAddressList.addClass('d-none');
	                } else {
	                    // guest customer -> hide the billing address form
	                    $billingAddressSection.addClass('d-none');
	                }
	                $('.js-customer-billing-title').addClass('d-none');
	            } else {
	                if ($customerBillingAddressList.length) {
	                    // logged in customer -> show the address list
	                    $customerBillingAddressList.removeClass('d-none');
	                } else {
	                    // guest customer -> show the billing address form
	                    $billingAddressSection.removeClass('d-none');
	                }
	                $('.js-customer-billing-title').removeClass('d-none');
	            }
	        });
	    },
	    checkAtLeastOnePaymentMethodIsSelected: function checkAtLeastOnePaymentMethodIsSelected() {
	        $('body').on('checkout:checkAtLeasOnePaymentMethodIsSelected', function (e, data) {
	            data.result = _checkAtLeastOnePaymentMethodIsSelected();
	        });
	    }
	};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var Cleave = __webpack_require__(97);

	module.exports = {
	    handleCreditCardNumber: function handleCreditCardNumber(cardFieldSelector, cardTypeSelector) {
	        var cleave = new Cleave(cardFieldSelector, {
	            creditCard: true,
	            onCreditCardTypeChanged: function onCreditCardTypeChanged(type) {
	                var creditCardTypes = {
	                    visa: 'Visa',
	                    mastercard: 'Master Card',
	                    amex: 'Amex',
	                    discover: 'Discover',
	                    unknown: 'Unknown'
	                };

	                var cardType = creditCardTypes[Object.keys(creditCardTypes).indexOf(type) > -1 ? type : 'unknown'];
	                $(cardTypeSelector).val(cardType);
	                $('.card-number-wrapper').attr('data-type', type);
	                if (type === 'visa' || type === 'mastercard' || type === 'discover') {
	                    $('#securityCode').attr('maxlength', 3);
	                } else {
	                    $('#securityCode').attr('maxlength', 4);
	                }
	            }
	        });

	        $(cardFieldSelector).data('cleave', cleave);
	    },

	    serializeData: function serializeData(form) {
	        var serializedArray = form.serializeArray();

	        serializedArray.forEach(function (item) {
	            if (item.name.indexOf('cardNumber') > -1) {
	                var dataCleave = $('#encryptedCardNumber').data('cleave');
	                if (dataCleave) {
	                    item.value = dataCleave.getRawValue(); // eslint-disable-line
	                }
	            }
	        });

	        return $.param(serializedArray);
	    }
	};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	(function webpackUniversalModuleDefinition(root, factory) {
		if (( false ? 'undefined' : _typeof(exports)) === 'object' && ( false ? 'undefined' : _typeof(module)) === 'object') module.exports = factory();else if (true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object') exports["Cleave"] = factory();else root["Cleave"] = factory();
	})(undefined, function () {
		return (/******/function (modules) {
				// webpackBootstrap
				/******/ // The module cache
				/******/var installedModules = {};

				/******/ // The require function
				/******/function __webpack_require__(moduleId) {

					/******/ // Check if module is in cache
					/******/if (installedModules[moduleId])
						/******/return installedModules[moduleId].exports;

					/******/ // Create a new module (and put it into the cache)
					/******/var module = installedModules[moduleId] = {
						/******/exports: {},
						/******/id: moduleId,
						/******/loaded: false
						/******/ };

					/******/ // Execute the module function
					/******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

					/******/ // Flag the module as loaded
					/******/module.loaded = true;

					/******/ // Return the exports of the module
					/******/return module.exports;
					/******/
				}

				/******/ // expose the modules object (__webpack_modules__)
				/******/__webpack_require__.m = modules;

				/******/ // expose the module cache
				/******/__webpack_require__.c = installedModules;

				/******/ // __webpack_public_path__
				/******/__webpack_require__.p = "";

				/******/ // Load entry module and return exports
				/******/return __webpack_require__(0);
				/******/
			}(
			/************************************************************************/
			/******/[
			/* 0 */
			/***/function (module, exports, __webpack_require__) {

				/* WEBPACK VAR INJECTION */(function (global) {
					'use strict';

					/**
	     * Construct a new Cleave instance by passing the configuration object
	     *
	     * @param {String | HTMLElement} element
	     * @param {Object} opts
	     */

					var Cleave = function Cleave(element, opts) {
						var owner = this;
						var hasMultipleElements = false;

						if (typeof element === 'string') {
							owner.element = document.querySelector(element);
							hasMultipleElements = document.querySelectorAll(element).length > 1;
						} else {
							if (typeof element.length !== 'undefined' && element.length > 0) {
								owner.element = element[0];
								hasMultipleElements = element.length > 1;
							} else {
								owner.element = element;
							}
						}

						if (!owner.element) {
							throw new Error('[cleave.js] Please check the element');
						}

						if (hasMultipleElements) {
							try {
								// eslint-disable-next-line
								console.warn('[cleave.js] Multiple input fields matched, cleave.js will only take the first one.');
							} catch (e) {
								// Old IE
							}
						}

						opts.initValue = owner.element.value;

						owner.properties = Cleave.DefaultProperties.assign({}, opts);

						owner.init();
					};

					Cleave.prototype = {
						init: function init() {
							var owner = this,
							    pps = owner.properties;

							// no need to use this lib
							if (!pps.numeral && !pps.phone && !pps.creditCard && !pps.time && !pps.date && pps.blocksLength === 0 && !pps.prefix) {
								owner.onInput(pps.initValue);

								return;
							}

							pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);

							owner.isAndroid = Cleave.Util.isAndroid();
							owner.lastInputValue = '';
							owner.isBackward = '';

							owner.onChangeListener = owner.onChange.bind(owner);
							owner.onKeyDownListener = owner.onKeyDown.bind(owner);
							owner.onFocusListener = owner.onFocus.bind(owner);
							owner.onCutListener = owner.onCut.bind(owner);
							owner.onCopyListener = owner.onCopy.bind(owner);

							owner.initSwapHiddenInput();

							owner.element.addEventListener('input', owner.onChangeListener);
							owner.element.addEventListener('keydown', owner.onKeyDownListener);
							owner.element.addEventListener('focus', owner.onFocusListener);
							owner.element.addEventListener('cut', owner.onCutListener);
							owner.element.addEventListener('copy', owner.onCopyListener);

							owner.initPhoneFormatter();
							owner.initDateFormatter();
							owner.initTimeFormatter();
							owner.initNumeralFormatter();

							// avoid touch input field if value is null
							// otherwise Firefox will add red box-shadow for <input required />
							if (pps.initValue || pps.prefix && !pps.noImmediatePrefix) {
								owner.onInput(pps.initValue);
							}
						},

						initSwapHiddenInput: function initSwapHiddenInput() {
							var owner = this,
							    pps = owner.properties;
							if (!pps.swapHiddenInput) return;

							var inputFormatter = owner.element.cloneNode(true);
							owner.element.parentNode.insertBefore(inputFormatter, owner.element);

							owner.elementSwapHidden = owner.element;
							owner.elementSwapHidden.type = 'hidden';

							owner.element = inputFormatter;
							owner.element.id = '';
						},

						initNumeralFormatter: function initNumeralFormatter() {
							var owner = this,
							    pps = owner.properties;

							if (!pps.numeral) {
								return;
							}

							pps.numeralFormatter = new Cleave.NumeralFormatter(pps.numeralDecimalMark, pps.numeralIntegerScale, pps.numeralDecimalScale, pps.numeralThousandsGroupStyle, pps.numeralPositiveOnly, pps.stripLeadingZeroes, pps.prefix, pps.signBeforePrefix, pps.tailPrefix, pps.delimiter);
						},

						initTimeFormatter: function initTimeFormatter() {
							var owner = this,
							    pps = owner.properties;

							if (!pps.time) {
								return;
							}

							pps.timeFormatter = new Cleave.TimeFormatter(pps.timePattern, pps.timeFormat);
							pps.blocks = pps.timeFormatter.getBlocks();
							pps.blocksLength = pps.blocks.length;
							pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
						},

						initDateFormatter: function initDateFormatter() {
							var owner = this,
							    pps = owner.properties;

							if (!pps.date) {
								return;
							}

							pps.dateFormatter = new Cleave.DateFormatter(pps.datePattern, pps.dateMin, pps.dateMax);
							pps.blocks = pps.dateFormatter.getBlocks();
							pps.blocksLength = pps.blocks.length;
							pps.maxLength = Cleave.Util.getMaxLength(pps.blocks);
						},

						initPhoneFormatter: function initPhoneFormatter() {
							var owner = this,
							    pps = owner.properties;

							if (!pps.phone) {
								return;
							}

							// Cleave.AsYouTypeFormatter should be provided by
							// external google closure lib
							try {
								pps.phoneFormatter = new Cleave.PhoneFormatter(new pps.root.Cleave.AsYouTypeFormatter(pps.phoneRegionCode), pps.delimiter);
							} catch (ex) {
								throw new Error('[cleave.js] Please include phone-type-formatter.{country}.js lib');
							}
						},

						onKeyDown: function onKeyDown(event) {
							var owner = this,
							    charCode = event.which || event.keyCode;

							owner.lastInputValue = owner.element.value;
							owner.isBackward = charCode === 8;
						},

						onChange: function onChange(event) {
							var owner = this,
							    pps = owner.properties,
							    Util = Cleave.Util;

							owner.isBackward = owner.isBackward || event.inputType === 'deleteContentBackward';

							var postDelimiter = Util.getPostDelimiter(owner.lastInputValue, pps.delimiter, pps.delimiters);

							if (owner.isBackward && postDelimiter) {
								pps.postDelimiterBackspace = postDelimiter;
							} else {
								pps.postDelimiterBackspace = false;
							}

							this.onInput(this.element.value);
						},

						onFocus: function onFocus() {
							var owner = this,
							    pps = owner.properties;
							owner.lastInputValue = owner.element.value;

							if (pps.prefix && pps.noImmediatePrefix && !owner.element.value) {
								this.onInput(pps.prefix);
							}

							Cleave.Util.fixPrefixCursor(owner.element, pps.prefix, pps.delimiter, pps.delimiters);
						},

						onCut: function onCut(e) {
							if (!Cleave.Util.checkFullSelection(this.element.value)) return;
							this.copyClipboardData(e);
							this.onInput('');
						},

						onCopy: function onCopy(e) {
							if (!Cleave.Util.checkFullSelection(this.element.value)) return;
							this.copyClipboardData(e);
						},

						copyClipboardData: function copyClipboardData(e) {
							var owner = this,
							    pps = owner.properties,
							    Util = Cleave.Util,
							    inputValue = owner.element.value,
							    textToCopy = '';

							if (!pps.copyDelimiter) {
								textToCopy = Util.stripDelimiters(inputValue, pps.delimiter, pps.delimiters);
							} else {
								textToCopy = inputValue;
							}

							try {
								if (e.clipboardData) {
									e.clipboardData.setData('Text', textToCopy);
								} else {
									window.clipboardData.setData('Text', textToCopy);
								}

								e.preventDefault();
							} catch (ex) {
								//  empty
							}
						},

						onInput: function onInput(value) {
							var owner = this,
							    pps = owner.properties,
							    Util = Cleave.Util;

							// case 1: delete one more character "4"
							// 1234*| -> hit backspace -> 123|
							// case 2: last character is not delimiter which is:
							// 12|34* -> hit backspace -> 1|34*
							// note: no need to apply this for numeral mode
							var postDelimiterAfter = Util.getPostDelimiter(value, pps.delimiter, pps.delimiters);
							if (!pps.numeral && pps.postDelimiterBackspace && !postDelimiterAfter) {
								value = Util.headStr(value, value.length - pps.postDelimiterBackspace.length);
							}

							// phone formatter
							if (pps.phone) {
								if (pps.prefix && (!pps.noImmediatePrefix || value.length)) {
									pps.result = pps.prefix + pps.phoneFormatter.format(value).slice(pps.prefix.length);
								} else {
									pps.result = pps.phoneFormatter.format(value);
								}
								owner.updateValueState();

								return;
							}

							// numeral formatter
							if (pps.numeral) {
								// Do not show prefix when noImmediatePrefix is specified
								// This mostly because we need to show user the native input placeholder
								if (pps.prefix && pps.noImmediatePrefix && value.length === 0) {
									pps.result = '';
								} else {
									pps.result = pps.numeralFormatter.format(value);
								}
								owner.updateValueState();

								return;
							}

							// date
							if (pps.date) {
								value = pps.dateFormatter.getValidatedDate(value);
							}

							// time
							if (pps.time) {
								value = pps.timeFormatter.getValidatedTime(value);
							}

							// strip delimiters
							value = Util.stripDelimiters(value, pps.delimiter, pps.delimiters);

							// strip prefix
							value = Util.getPrefixStrippedValue(value, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);

							// strip non-numeric characters
							value = pps.numericOnly ? Util.strip(value, /[^\d]/g) : value;

							// convert case
							value = pps.uppercase ? value.toUpperCase() : value;
							value = pps.lowercase ? value.toLowerCase() : value;

							// prevent from showing prefix when no immediate option enabled with empty input value
							if (pps.prefix) {
								if (pps.tailPrefix) {
									value = value + pps.prefix;
								} else {
									value = pps.prefix + value;
								}

								// no blocks specified, no need to do formatting
								if (pps.blocksLength === 0) {
									pps.result = value;
									owner.updateValueState();

									return;
								}
							}

							// update credit card props
							if (pps.creditCard) {
								owner.updateCreditCardPropsByValue(value);
							}

							// strip over length characters
							value = Util.headStr(value, pps.maxLength);

							// apply blocks
							pps.result = Util.getFormattedValue(value, pps.blocks, pps.blocksLength, pps.delimiter, pps.delimiters, pps.delimiterLazyShow);

							owner.updateValueState();
						},

						updateCreditCardPropsByValue: function updateCreditCardPropsByValue(value) {
							var owner = this,
							    pps = owner.properties,
							    Util = Cleave.Util,
							    creditCardInfo;

							// At least one of the first 4 characters has changed
							if (Util.headStr(pps.result, 4) === Util.headStr(value, 4)) {
								return;
							}

							creditCardInfo = Cleave.CreditCardDetector.getInfo(value, pps.creditCardStrictMode);

							pps.blocks = creditCardInfo.blocks;
							pps.blocksLength = pps.blocks.length;
							pps.maxLength = Util.getMaxLength(pps.blocks);

							// credit card type changed
							if (pps.creditCardType !== creditCardInfo.type) {
								pps.creditCardType = creditCardInfo.type;

								pps.onCreditCardTypeChanged.call(owner, pps.creditCardType);
							}
						},

						updateValueState: function updateValueState() {
							var owner = this,
							    Util = Cleave.Util,
							    pps = owner.properties;

							if (!owner.element) {
								return;
							}

							var endPos = owner.element.selectionEnd;
							var oldValue = owner.element.value;
							var newValue = pps.result;

							endPos = Util.getNextCursorPosition(endPos, oldValue, newValue, pps.delimiter, pps.delimiters);

							// fix Android browser type="text" input field
							// cursor not jumping issue
							if (owner.isAndroid) {
								window.setTimeout(function () {
									owner.element.value = newValue;
									Util.setSelection(owner.element, endPos, pps.document, false);
									owner.callOnValueChanged();
								}, 1);

								return;
							}

							owner.element.value = newValue;
							if (pps.swapHiddenInput) owner.elementSwapHidden.value = owner.getRawValue();

							Util.setSelection(owner.element, endPos, pps.document, false);
							owner.callOnValueChanged();
						},

						callOnValueChanged: function callOnValueChanged() {
							var owner = this,
							    pps = owner.properties;

							pps.onValueChanged.call(owner, {
								target: {
									name: owner.element.name,
									value: pps.result,
									rawValue: owner.getRawValue()
								}
							});
						},

						setPhoneRegionCode: function setPhoneRegionCode(phoneRegionCode) {
							var owner = this,
							    pps = owner.properties;

							pps.phoneRegionCode = phoneRegionCode;
							owner.initPhoneFormatter();
							owner.onChange();
						},

						setRawValue: function setRawValue(value) {
							var owner = this,
							    pps = owner.properties;

							value = value !== undefined && value !== null ? value.toString() : '';

							if (pps.numeral) {
								value = value.replace('.', pps.numeralDecimalMark);
							}

							pps.postDelimiterBackspace = false;

							owner.element.value = value;
							owner.onInput(value);
						},

						getRawValue: function getRawValue() {
							var owner = this,
							    pps = owner.properties,
							    Util = Cleave.Util,
							    rawValue = owner.element.value;

							if (pps.rawValueTrimPrefix) {
								rawValue = Util.getPrefixStrippedValue(rawValue, pps.prefix, pps.prefixLength, pps.result, pps.delimiter, pps.delimiters, pps.noImmediatePrefix, pps.tailPrefix, pps.signBeforePrefix);
							}

							if (pps.numeral) {
								rawValue = pps.numeralFormatter.getRawValue(rawValue);
							} else {
								rawValue = Util.stripDelimiters(rawValue, pps.delimiter, pps.delimiters);
							}

							return rawValue;
						},

						getISOFormatDate: function getISOFormatDate() {
							var owner = this,
							    pps = owner.properties;

							return pps.date ? pps.dateFormatter.getISOFormatDate() : '';
						},

						getISOFormatTime: function getISOFormatTime() {
							var owner = this,
							    pps = owner.properties;

							return pps.time ? pps.timeFormatter.getISOFormatTime() : '';
						},

						getFormattedValue: function getFormattedValue() {
							return this.element.value;
						},

						destroy: function destroy() {
							var owner = this;

							owner.element.removeEventListener('input', owner.onChangeListener);
							owner.element.removeEventListener('keydown', owner.onKeyDownListener);
							owner.element.removeEventListener('focus', owner.onFocusListener);
							owner.element.removeEventListener('cut', owner.onCutListener);
							owner.element.removeEventListener('copy', owner.onCopyListener);
						},

						toString: function toString() {
							return '[Cleave Object]';
						}
					};

					Cleave.NumeralFormatter = __webpack_require__(1);
					Cleave.DateFormatter = __webpack_require__(2);
					Cleave.TimeFormatter = __webpack_require__(3);
					Cleave.PhoneFormatter = __webpack_require__(4);
					Cleave.CreditCardDetector = __webpack_require__(5);
					Cleave.Util = __webpack_require__(6);
					Cleave.DefaultProperties = __webpack_require__(7);

					// for angular directive
					((typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window)['Cleave'] = Cleave;

					// CommonJS
					module.exports = Cleave;

					/* WEBPACK VAR INJECTION */
				}).call(exports, function () {
					return this;
				}());

				/***/
			},
			/* 1 */
			/***/function (module, exports) {

				'use strict';

				var NumeralFormatter = function NumeralFormatter(numeralDecimalMark, numeralIntegerScale, numeralDecimalScale, numeralThousandsGroupStyle, numeralPositiveOnly, stripLeadingZeroes, prefix, signBeforePrefix, tailPrefix, delimiter) {
					var owner = this;

					owner.numeralDecimalMark = numeralDecimalMark || '.';
					owner.numeralIntegerScale = numeralIntegerScale > 0 ? numeralIntegerScale : 0;
					owner.numeralDecimalScale = numeralDecimalScale >= 0 ? numeralDecimalScale : 2;
					owner.numeralThousandsGroupStyle = numeralThousandsGroupStyle || NumeralFormatter.groupStyle.thousand;
					owner.numeralPositiveOnly = !!numeralPositiveOnly;
					owner.stripLeadingZeroes = stripLeadingZeroes !== false;
					owner.prefix = prefix || prefix === '' ? prefix : '';
					owner.signBeforePrefix = !!signBeforePrefix;
					owner.tailPrefix = !!tailPrefix;
					owner.delimiter = delimiter || delimiter === '' ? delimiter : ',';
					owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';
				};

				NumeralFormatter.groupStyle = {
					thousand: 'thousand',
					lakh: 'lakh',
					wan: 'wan',
					none: 'none'
				};

				NumeralFormatter.prototype = {
					getRawValue: function getRawValue(value) {
						return value.replace(this.delimiterRE, '').replace(this.numeralDecimalMark, '.');
					},

					format: function format(value) {
						var owner = this,
						    parts,
						    partSign,
						    partSignAndPrefix,
						    partInteger,
						    partDecimal = '';

						// strip alphabet letters
						value = value.replace(/[A-Za-z]/g, '')
						// replace the first decimal mark with reserved placeholder
						.replace(owner.numeralDecimalMark, 'M')

						// strip non numeric letters except minus and "M"
						// this is to ensure prefix has been stripped
						.replace(/[^\dM-]/g, '')

						// replace the leading minus with reserved placeholder
						.replace(/^\-/, 'N')

						// strip the other minus sign (if present)
						.replace(/\-/g, '')

						// replace the minus sign (if present)
						.replace('N', owner.numeralPositiveOnly ? '' : '-')

						// replace decimal mark
						.replace('M', owner.numeralDecimalMark);

						// strip any leading zeros
						if (owner.stripLeadingZeroes) {
							value = value.replace(/^(-)?0+(?=\d)/, '$1');
						}

						partSign = value.slice(0, 1) === '-' ? '-' : '';
						if (typeof owner.prefix != 'undefined') {
							if (owner.signBeforePrefix) {
								partSignAndPrefix = partSign + owner.prefix;
							} else {
								partSignAndPrefix = owner.prefix + partSign;
							}
						} else {
							partSignAndPrefix = partSign;
						}

						partInteger = value;

						if (value.indexOf(owner.numeralDecimalMark) >= 0) {
							parts = value.split(owner.numeralDecimalMark);
							partInteger = parts[0];
							partDecimal = owner.numeralDecimalMark + parts[1].slice(0, owner.numeralDecimalScale);
						}

						if (partSign === '-') {
							partInteger = partInteger.slice(1);
						}

						if (owner.numeralIntegerScale > 0) {
							partInteger = partInteger.slice(0, owner.numeralIntegerScale);
						}

						switch (owner.numeralThousandsGroupStyle) {
							case NumeralFormatter.groupStyle.lakh:
								partInteger = partInteger.replace(/(\d)(?=(\d\d)+\d$)/g, '$1' + owner.delimiter);

								break;

							case NumeralFormatter.groupStyle.wan:
								partInteger = partInteger.replace(/(\d)(?=(\d{4})+$)/g, '$1' + owner.delimiter);

								break;

							case NumeralFormatter.groupStyle.thousand:
								partInteger = partInteger.replace(/(\d)(?=(\d{3})+$)/g, '$1' + owner.delimiter);

								break;
						}

						if (owner.tailPrefix) {
							return partSign + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '') + owner.prefix;
						}

						return partSignAndPrefix + partInteger.toString() + (owner.numeralDecimalScale > 0 ? partDecimal.toString() : '');
					}
				};

				module.exports = NumeralFormatter;

				/***/
			},
			/* 2 */
			/***/function (module, exports) {

				'use strict';

				var DateFormatter = function DateFormatter(datePattern, dateMin, dateMax) {
					var owner = this;

					owner.date = [];
					owner.blocks = [];
					owner.datePattern = datePattern;
					owner.dateMin = dateMin.split('-').reverse().map(function (x) {
						return parseInt(x, 10);
					});
					if (owner.dateMin.length === 2) owner.dateMin.unshift(0);

					owner.dateMax = dateMax.split('-').reverse().map(function (x) {
						return parseInt(x, 10);
					});
					if (owner.dateMax.length === 2) owner.dateMax.unshift(0);

					owner.initBlocks();
				};

				DateFormatter.prototype = {
					initBlocks: function initBlocks() {
						var owner = this;
						owner.datePattern.forEach(function (value) {
							if (value === 'Y') {
								owner.blocks.push(4);
							} else {
								owner.blocks.push(2);
							}
						});
					},

					getISOFormatDate: function getISOFormatDate() {
						var owner = this,
						    date = owner.date;

						return date[2] ? date[2] + '-' + owner.addLeadingZero(date[1]) + '-' + owner.addLeadingZero(date[0]) : '';
					},

					getBlocks: function getBlocks() {
						return this.blocks;
					},

					getValidatedDate: function getValidatedDate(value) {
						var owner = this,
						    result = '';

						value = value.replace(/[^\d]/g, '');

						owner.blocks.forEach(function (length, index) {
							if (value.length > 0) {
								var sub = value.slice(0, length),
								    sub0 = sub.slice(0, 1),
								    rest = value.slice(length);

								switch (owner.datePattern[index]) {
									case 'd':
										if (sub === '00') {
											sub = '01';
										} else if (parseInt(sub0, 10) > 3) {
											sub = '0' + sub0;
										} else if (parseInt(sub, 10) > 31) {
											sub = '31';
										}

										break;

									case 'm':
										if (sub === '00') {
											sub = '01';
										} else if (parseInt(sub0, 10) > 1) {
											sub = '0' + sub0;
										} else if (parseInt(sub, 10) > 12) {
											sub = '12';
										}

										break;
								}

								result += sub;

								// update remaining string
								value = rest;
							}
						});

						return this.getFixedDateString(result);
					},

					getFixedDateString: function getFixedDateString(value) {
						var owner = this,
						    datePattern = owner.datePattern,
						    date = [],
						    dayIndex = 0,
						    monthIndex = 0,
						    yearIndex = 0,
						    dayStartIndex = 0,
						    monthStartIndex = 0,
						    yearStartIndex = 0,
						    day,
						    month,
						    year,
						    fullYearDone = false;

						// mm-dd || dd-mm
						if (value.length === 4 && datePattern[0].toLowerCase() !== 'y' && datePattern[1].toLowerCase() !== 'y') {
							dayStartIndex = datePattern[0] === 'd' ? 0 : 2;
							monthStartIndex = 2 - dayStartIndex;
							day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
							month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);

							date = this.getFixedDate(day, month, 0);
						}

						// yyyy-mm-dd || yyyy-dd-mm || mm-dd-yyyy || dd-mm-yyyy || dd-yyyy-mm || mm-yyyy-dd
						if (value.length === 8) {
							datePattern.forEach(function (type, index) {
								switch (type) {
									case 'd':
										dayIndex = index;
										break;
									case 'm':
										monthIndex = index;
										break;
									default:
										yearIndex = index;
										break;
								}
							});

							yearStartIndex = yearIndex * 2;
							dayStartIndex = dayIndex <= yearIndex ? dayIndex * 2 : dayIndex * 2 + 2;
							monthStartIndex = monthIndex <= yearIndex ? monthIndex * 2 : monthIndex * 2 + 2;

							day = parseInt(value.slice(dayStartIndex, dayStartIndex + 2), 10);
							month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
							year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

							fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

							date = this.getFixedDate(day, month, year);
						}

						// mm-yy || yy-mm
						if (value.length === 4 && (datePattern[0] === 'y' || datePattern[1] === 'y')) {
							monthStartIndex = datePattern[0] === 'm' ? 0 : 2;
							yearStartIndex = 2 - monthStartIndex;
							month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
							year = parseInt(value.slice(yearStartIndex, yearStartIndex + 2), 10);

							fullYearDone = value.slice(yearStartIndex, yearStartIndex + 2).length === 2;

							date = [0, month, year];
						}

						// mm-yyyy || yyyy-mm
						if (value.length === 6 && (datePattern[0] === 'Y' || datePattern[1] === 'Y')) {
							monthStartIndex = datePattern[0] === 'm' ? 0 : 4;
							yearStartIndex = 2 - 0.5 * monthStartIndex;
							month = parseInt(value.slice(monthStartIndex, monthStartIndex + 2), 10);
							year = parseInt(value.slice(yearStartIndex, yearStartIndex + 4), 10);

							fullYearDone = value.slice(yearStartIndex, yearStartIndex + 4).length === 4;

							date = [0, month, year];
						}

						date = owner.getRangeFixedDate(date);
						owner.date = date;

						var result = date.length === 0 ? value : datePattern.reduce(function (previous, current) {
							switch (current) {
								case 'd':
									return previous + (date[0] === 0 ? '' : owner.addLeadingZero(date[0]));
								case 'm':
									return previous + (date[1] === 0 ? '' : owner.addLeadingZero(date[1]));
								case 'y':
									return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], false) : '');
								case 'Y':
									return previous + (fullYearDone ? owner.addLeadingZeroForYear(date[2], true) : '');
							}
						}, '');

						return result;
					},

					getRangeFixedDate: function getRangeFixedDate(date) {
						var owner = this,
						    datePattern = owner.datePattern,
						    dateMin = owner.dateMin || [],
						    dateMax = owner.dateMax || [];

						if (!date.length || dateMin.length < 3 && dateMax.length < 3) return date;

						if (datePattern.find(function (x) {
							return x.toLowerCase() === 'y';
						}) && date[2] === 0) return date;

						if (dateMax.length && (dateMax[2] < date[2] || dateMax[2] === date[2] && (dateMax[1] < date[1] || dateMax[1] === date[1] && dateMax[0] < date[0]))) return dateMax;

						if (dateMin.length && (dateMin[2] > date[2] || dateMin[2] === date[2] && (dateMin[1] > date[1] || dateMin[1] === date[1] && dateMin[0] > date[0]))) return dateMin;

						return date;
					},

					getFixedDate: function getFixedDate(day, month, year) {
						day = Math.min(day, 31);
						month = Math.min(month, 12);
						year = parseInt(year || 0, 10);

						if (month < 7 && month % 2 === 0 || month > 8 && month % 2 === 1) {
							day = Math.min(day, month === 2 ? this.isLeapYear(year) ? 29 : 28 : 30);
						}

						return [day, month, year];
					},

					isLeapYear: function isLeapYear(year) {
						return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
					},

					addLeadingZero: function addLeadingZero(number) {
						return (number < 10 ? '0' : '') + number;
					},

					addLeadingZeroForYear: function addLeadingZeroForYear(number, fullYearMode) {
						if (fullYearMode) {
							return (number < 10 ? '000' : number < 100 ? '00' : number < 1000 ? '0' : '') + number;
						}

						return (number < 10 ? '0' : '') + number;
					}
				};

				module.exports = DateFormatter;

				/***/
			},
			/* 3 */
			/***/function (module, exports) {

				'use strict';

				var TimeFormatter = function TimeFormatter(timePattern, timeFormat) {
					var owner = this;

					owner.time = [];
					owner.blocks = [];
					owner.timePattern = timePattern;
					owner.timeFormat = timeFormat;
					owner.initBlocks();
				};

				TimeFormatter.prototype = {
					initBlocks: function initBlocks() {
						var owner = this;
						owner.timePattern.forEach(function () {
							owner.blocks.push(2);
						});
					},

					getISOFormatTime: function getISOFormatTime() {
						var owner = this,
						    time = owner.time;

						return time[2] ? owner.addLeadingZero(time[0]) + ':' + owner.addLeadingZero(time[1]) + ':' + owner.addLeadingZero(time[2]) : '';
					},

					getBlocks: function getBlocks() {
						return this.blocks;
					},

					getTimeFormatOptions: function getTimeFormatOptions() {
						var owner = this;
						if (String(owner.timeFormat) === '12') {
							return {
								maxHourFirstDigit: 1,
								maxHours: 12,
								maxMinutesFirstDigit: 5,
								maxMinutes: 60
							};
						}

						return {
							maxHourFirstDigit: 2,
							maxHours: 23,
							maxMinutesFirstDigit: 5,
							maxMinutes: 60
						};
					},

					getValidatedTime: function getValidatedTime(value) {
						var owner = this,
						    result = '';

						value = value.replace(/[^\d]/g, '');

						var timeFormatOptions = owner.getTimeFormatOptions();

						owner.blocks.forEach(function (length, index) {
							if (value.length > 0) {
								var sub = value.slice(0, length),
								    sub0 = sub.slice(0, 1),
								    rest = value.slice(length);

								switch (owner.timePattern[index]) {

									case 'h':
										if (parseInt(sub0, 10) > timeFormatOptions.maxHourFirstDigit) {
											sub = '0' + sub0;
										} else if (parseInt(sub, 10) > timeFormatOptions.maxHours) {
											sub = timeFormatOptions.maxHours + '';
										}

										break;

									case 'm':
									case 's':
										if (parseInt(sub0, 10) > timeFormatOptions.maxMinutesFirstDigit) {
											sub = '0' + sub0;
										} else if (parseInt(sub, 10) > timeFormatOptions.maxMinutes) {
											sub = timeFormatOptions.maxMinutes + '';
										}
										break;
								}

								result += sub;

								// update remaining string
								value = rest;
							}
						});

						return this.getFixedTimeString(result);
					},

					getFixedTimeString: function getFixedTimeString(value) {
						var owner = this,
						    timePattern = owner.timePattern,
						    time = [],
						    secondIndex = 0,
						    minuteIndex = 0,
						    hourIndex = 0,
						    secondStartIndex = 0,
						    minuteStartIndex = 0,
						    hourStartIndex = 0,
						    second,
						    minute,
						    hour;

						if (value.length === 6) {
							timePattern.forEach(function (type, index) {
								switch (type) {
									case 's':
										secondIndex = index * 2;
										break;
									case 'm':
										minuteIndex = index * 2;
										break;
									case 'h':
										hourIndex = index * 2;
										break;
								}
							});

							hourStartIndex = hourIndex;
							minuteStartIndex = minuteIndex;
							secondStartIndex = secondIndex;

							second = parseInt(value.slice(secondStartIndex, secondStartIndex + 2), 10);
							minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
							hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

							time = this.getFixedTime(hour, minute, second);
						}

						if (value.length === 4 && owner.timePattern.indexOf('s') < 0) {
							timePattern.forEach(function (type, index) {
								switch (type) {
									case 'm':
										minuteIndex = index * 2;
										break;
									case 'h':
										hourIndex = index * 2;
										break;
								}
							});

							hourStartIndex = hourIndex;
							minuteStartIndex = minuteIndex;

							second = 0;
							minute = parseInt(value.slice(minuteStartIndex, minuteStartIndex + 2), 10);
							hour = parseInt(value.slice(hourStartIndex, hourStartIndex + 2), 10);

							time = this.getFixedTime(hour, minute, second);
						}

						owner.time = time;

						return time.length === 0 ? value : timePattern.reduce(function (previous, current) {
							switch (current) {
								case 's':
									return previous + owner.addLeadingZero(time[2]);
								case 'm':
									return previous + owner.addLeadingZero(time[1]);
								case 'h':
									return previous + owner.addLeadingZero(time[0]);
							}
						}, '');
					},

					getFixedTime: function getFixedTime(hour, minute, second) {
						second = Math.min(parseInt(second || 0, 10), 60);
						minute = Math.min(minute, 60);
						hour = Math.min(hour, 60);

						return [hour, minute, second];
					},

					addLeadingZero: function addLeadingZero(number) {
						return (number < 10 ? '0' : '') + number;
					}
				};

				module.exports = TimeFormatter;

				/***/
			},
			/* 4 */
			/***/function (module, exports) {

				'use strict';

				var PhoneFormatter = function PhoneFormatter(formatter, delimiter) {
					var owner = this;

					owner.delimiter = delimiter || delimiter === '' ? delimiter : ' ';
					owner.delimiterRE = delimiter ? new RegExp('\\' + delimiter, 'g') : '';

					owner.formatter = formatter;
				};

				PhoneFormatter.prototype = {
					setFormatter: function setFormatter(formatter) {
						this.formatter = formatter;
					},

					format: function format(phoneNumber) {
						var owner = this;

						owner.formatter.clear();

						// only keep number and +
						phoneNumber = phoneNumber.replace(/[^\d+]/g, '');

						// strip non-leading +
						phoneNumber = phoneNumber.replace(/^\+/, 'B').replace(/\+/g, '').replace('B', '+');

						// strip delimiter
						phoneNumber = phoneNumber.replace(owner.delimiterRE, '');

						var result = '',
						    current,
						    validated = false;

						for (var i = 0, iMax = phoneNumber.length; i < iMax; i++) {
							current = owner.formatter.inputDigit(phoneNumber.charAt(i));

							// has ()- or space inside
							if (/[\s()-]/g.test(current)) {
								result = current;

								validated = true;
							} else {
								if (!validated) {
									result = current;
								}
								// else: over length input
								// it turns to invalid number again
							}
						}

						// strip ()
						// e.g. US: 7161234567 returns (716) 123-4567
						result = result.replace(/[()]/g, '');
						// replace library delimiter with user customized delimiter
						result = result.replace(/[\s-]/g, owner.delimiter);

						return result;
					}
				};

				module.exports = PhoneFormatter;

				/***/
			},
			/* 5 */
			/***/function (module, exports) {

				'use strict';

				var CreditCardDetector = {
					blocks: {
						uatp: [4, 5, 6],
						amex: [4, 6, 5],
						diners: [4, 6, 4],
						discover: [4, 4, 4, 4],
						mastercard: [4, 4, 4, 4],
						dankort: [4, 4, 4, 4],
						instapayment: [4, 4, 4, 4],
						jcb15: [4, 6, 5],
						jcb: [4, 4, 4, 4],
						maestro: [4, 4, 4, 4],
						visa: [4, 4, 4, 4],
						mir: [4, 4, 4, 4],
						unionPay: [4, 4, 4, 4],
						general: [4, 4, 4, 4]
					},

					re: {
						// starts with 1; 15 digits, not starts with 1800 (jcb card)
						uatp: /^(?!1800)1\d{0,14}/,

						// starts with 34/37; 15 digits
						amex: /^3[47]\d{0,13}/,

						// starts with 6011/65/644-649; 16 digits
						discover: /^(?:6011|65\d{0,2}|64[4-9]\d?)\d{0,12}/,

						// starts with 300-305/309 or 36/38/39; 14 digits
						diners: /^3(?:0([0-5]|9)|[689]\d?)\d{0,11}/,

						// starts with 51-55/2221–2720; 16 digits
						mastercard: /^(5[1-5]\d{0,2}|22[2-9]\d{0,1}|2[3-7]\d{0,2})\d{0,12}/,

						// starts with 5019/4175/4571; 16 digits
						dankort: /^(5019|4175|4571)\d{0,12}/,

						// starts with 637-639; 16 digits
						instapayment: /^63[7-9]\d{0,13}/,

						// starts with 2131/1800; 15 digits
						jcb15: /^(?:2131|1800)\d{0,11}/,

						// starts with 2131/1800/35; 16 digits
						jcb: /^(?:35\d{0,2})\d{0,12}/,

						// starts with 50/56-58/6304/67; 16 digits
						maestro: /^(?:5[0678]\d{0,2}|6304|67\d{0,2})\d{0,12}/,

						// starts with 22; 16 digits
						mir: /^220[0-4]\d{0,12}/,

						// starts with 4; 16 digits
						visa: /^4\d{0,15}/,

						// starts with 62/81; 16 digits
						unionPay: /^(62|81)\d{0,14}/
					},

					getStrictBlocks: function getStrictBlocks(block) {
						var total = block.reduce(function (prev, current) {
							return prev + current;
						}, 0);

						return block.concat(19 - total);
					},

					getInfo: function getInfo(value, strictMode) {
						var blocks = CreditCardDetector.blocks,
						    re = CreditCardDetector.re;

						// Some credit card can have up to 19 digits number.
						// Set strictMode to true will remove the 16 max-length restrain,
						// however, I never found any website validate card number like
						// this, hence probably you don't want to enable this option.
						strictMode = !!strictMode;

						for (var key in re) {
							if (re[key].test(value)) {
								var matchedBlocks = blocks[key];
								return {
									type: key,
									blocks: strictMode ? this.getStrictBlocks(matchedBlocks) : matchedBlocks
								};
							}
						}

						return {
							type: 'unknown',
							blocks: strictMode ? this.getStrictBlocks(blocks.general) : blocks.general
						};
					}
				};

				module.exports = CreditCardDetector;

				/***/
			},
			/* 6 */
			/***/function (module, exports) {

				'use strict';

				var Util = {
					noop: function noop() {},

					strip: function strip(value, re) {
						return value.replace(re, '');
					},

					getPostDelimiter: function getPostDelimiter(value, delimiter, delimiters) {
						// single delimiter
						if (delimiters.length === 0) {
							return value.slice(-delimiter.length) === delimiter ? delimiter : '';
						}

						// multiple delimiters
						var matchedDelimiter = '';
						delimiters.forEach(function (current) {
							if (value.slice(-current.length) === current) {
								matchedDelimiter = current;
							}
						});

						return matchedDelimiter;
					},

					getDelimiterREByDelimiter: function getDelimiterREByDelimiter(delimiter) {
						return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1'), 'g');
					},

					getNextCursorPosition: function getNextCursorPosition(prevPos, oldValue, newValue, delimiter, delimiters) {
						// If cursor was at the end of value, just place it back.
						// Because new value could contain additional chars.
						if (oldValue.length === prevPos) {
							return newValue.length;
						}

						return prevPos + this.getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters);
					},

					getPositionOffset: function getPositionOffset(prevPos, oldValue, newValue, delimiter, delimiters) {
						var oldRawValue, newRawValue, lengthOffset;

						oldRawValue = this.stripDelimiters(oldValue.slice(0, prevPos), delimiter, delimiters);
						newRawValue = this.stripDelimiters(newValue.slice(0, prevPos), delimiter, delimiters);
						lengthOffset = oldRawValue.length - newRawValue.length;

						return lengthOffset !== 0 ? lengthOffset / Math.abs(lengthOffset) : 0;
					},

					stripDelimiters: function stripDelimiters(value, delimiter, delimiters) {
						var owner = this;

						// single delimiter
						if (delimiters.length === 0) {
							var delimiterRE = delimiter ? owner.getDelimiterREByDelimiter(delimiter) : '';

							return value.replace(delimiterRE, '');
						}

						// multiple delimiters
						delimiters.forEach(function (current) {
							current.split('').forEach(function (letter) {
								value = value.replace(owner.getDelimiterREByDelimiter(letter), '');
							});
						});

						return value;
					},

					headStr: function headStr(str, length) {
						return str.slice(0, length);
					},

					getMaxLength: function getMaxLength(blocks) {
						return blocks.reduce(function (previous, current) {
							return previous + current;
						}, 0);
					},

					// strip prefix
					// Before type  |   After type    |     Return value
					// PEFIX-...    |   PEFIX-...     |     ''
					// PREFIX-123   |   PEFIX-123     |     123
					// PREFIX-123   |   PREFIX-23     |     23
					// PREFIX-123   |   PREFIX-1234   |     1234
					getPrefixStrippedValue: function getPrefixStrippedValue(value, prefix, prefixLength, prevResult, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix) {
						// No prefix
						if (prefixLength === 0) {
							return value;
						}

						// Value is prefix
						if (value === prefix && value !== '') {
							return '';
						}

						if (signBeforePrefix && value.slice(0, 1) == '-') {
							var prev = prevResult.slice(0, 1) == '-' ? prevResult.slice(1) : prevResult;
							return '-' + this.getPrefixStrippedValue(value.slice(1), prefix, prefixLength, prev, delimiter, delimiters, noImmediatePrefix, tailPrefix, signBeforePrefix);
						}

						// Pre result prefix string does not match pre-defined prefix
						if (prevResult.slice(0, prefixLength) !== prefix && !tailPrefix) {
							// Check if the first time user entered something
							if (noImmediatePrefix && !prevResult && value) return value;
							return '';
						} else if (prevResult.slice(-prefixLength) !== prefix && tailPrefix) {
							// Check if the first time user entered something
							if (noImmediatePrefix && !prevResult && value) return value;
							return '';
						}

						var prevValue = this.stripDelimiters(prevResult, delimiter, delimiters);

						// New value has issue, someone typed in between prefix letters
						// Revert to pre value
						if (value.slice(0, prefixLength) !== prefix && !tailPrefix) {
							return prevValue.slice(prefixLength);
						} else if (value.slice(-prefixLength) !== prefix && tailPrefix) {
							return prevValue.slice(0, -prefixLength - 1);
						}

						// No issue, strip prefix for new value
						return tailPrefix ? value.slice(0, -prefixLength) : value.slice(prefixLength);
					},

					getFirstDiffIndex: function getFirstDiffIndex(prev, current) {
						var index = 0;

						while (prev.charAt(index) === current.charAt(index)) {
							if (prev.charAt(index++) === '') {
								return -1;
							}
						}

						return index;
					},

					getFormattedValue: function getFormattedValue(value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
						var result = '',
						    multipleDelimiters = delimiters.length > 0,
						    currentDelimiter = '';

						// no options, normal input
						if (blocksLength === 0) {
							return value;
						}

						blocks.forEach(function (length, index) {
							if (value.length > 0) {
								var sub = value.slice(0, length),
								    rest = value.slice(length);

								if (multipleDelimiters) {
									currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
								} else {
									currentDelimiter = delimiter;
								}

								if (delimiterLazyShow) {
									if (index > 0) {
										result += currentDelimiter;
									}

									result += sub;
								} else {
									result += sub;

									if (sub.length === length && index < blocksLength - 1) {
										result += currentDelimiter;
									}
								}

								// update remaining string
								value = rest;
							}
						});

						return result;
					},

					// move cursor to the end
					// the first time user focuses on an input with prefix
					fixPrefixCursor: function fixPrefixCursor(el, prefix, delimiter, delimiters) {
						if (!el) {
							return;
						}

						var val = el.value,
						    appendix = delimiter || delimiters[0] || ' ';

						if (!el.setSelectionRange || !prefix || prefix.length + appendix.length <= val.length) {
							return;
						}

						var len = val.length * 2;

						// set timeout to avoid blink
						setTimeout(function () {
							el.setSelectionRange(len, len);
						}, 1);
					},

					// Check if input field is fully selected
					checkFullSelection: function checkFullSelection(value) {
						try {
							var selection = window.getSelection() || document.getSelection() || {};
							return selection.toString().length === value.length;
						} catch (ex) {
							// Ignore
						}

						return false;
					},

					setSelection: function setSelection(element, position, doc) {
						if (element !== this.getActiveElement(doc)) {
							return;
						}

						// cursor is already in the end
						if (element && element.value.length <= position) {
							return;
						}

						if (element.createTextRange) {
							var range = element.createTextRange();

							range.move('character', position);
							range.select();
						} else {
							try {
								element.setSelectionRange(position, position);
							} catch (e) {
								// eslint-disable-next-line
								console.warn('The input element type does not support selection');
							}
						}
					},

					getActiveElement: function getActiveElement(parent) {
						var activeElement = parent.activeElement;
						if (activeElement && activeElement.shadowRoot) {
							return this.getActiveElement(activeElement.shadowRoot);
						}
						return activeElement;
					},

					isAndroid: function isAndroid() {
						return navigator && /android/i.test(navigator.userAgent);
					},

					// On Android chrome, the keyup and keydown events
					// always return key code 229 as a composition that
					// buffers the user’s keystrokes
					// see https://github.com/nosir/cleave.js/issues/147
					isAndroidBackspaceKeydown: function isAndroidBackspaceKeydown(lastInputValue, currentInputValue) {
						if (!this.isAndroid() || !lastInputValue || !currentInputValue) {
							return false;
						}

						return currentInputValue === lastInputValue.slice(0, -1);
					}
				};

				module.exports = Util;

				/***/
			},
			/* 7 */
			/***/function (module, exports) {

				/* WEBPACK VAR INJECTION */(function (global) {
					'use strict';

					/**
	     * Props Assignment
	     *
	     * Separate this, so react module can share the usage
	     */

					var DefaultProperties = {
						// Maybe change to object-assign
						// for now just keep it as simple
						assign: function assign(target, opts) {
							target = target || {};
							opts = opts || {};

							// credit card
							target.creditCard = !!opts.creditCard;
							target.creditCardStrictMode = !!opts.creditCardStrictMode;
							target.creditCardType = '';
							target.onCreditCardTypeChanged = opts.onCreditCardTypeChanged || function () {};

							// phone
							target.phone = !!opts.phone;
							target.phoneRegionCode = opts.phoneRegionCode || 'AU';
							target.phoneFormatter = {};

							// time
							target.time = !!opts.time;
							target.timePattern = opts.timePattern || ['h', 'm', 's'];
							target.timeFormat = opts.timeFormat || '24';
							target.timeFormatter = {};

							// date
							target.date = !!opts.date;
							target.datePattern = opts.datePattern || ['d', 'm', 'Y'];
							target.dateMin = opts.dateMin || '';
							target.dateMax = opts.dateMax || '';
							target.dateFormatter = {};

							// numeral
							target.numeral = !!opts.numeral;
							target.numeralIntegerScale = opts.numeralIntegerScale > 0 ? opts.numeralIntegerScale : 0;
							target.numeralDecimalScale = opts.numeralDecimalScale >= 0 ? opts.numeralDecimalScale : 2;
							target.numeralDecimalMark = opts.numeralDecimalMark || '.';
							target.numeralThousandsGroupStyle = opts.numeralThousandsGroupStyle || 'thousand';
							target.numeralPositiveOnly = !!opts.numeralPositiveOnly;
							target.stripLeadingZeroes = opts.stripLeadingZeroes !== false;
							target.signBeforePrefix = !!opts.signBeforePrefix;
							target.tailPrefix = !!opts.tailPrefix;

							// others
							target.swapHiddenInput = !!opts.swapHiddenInput;

							target.numericOnly = target.creditCard || target.date || !!opts.numericOnly;

							target.uppercase = !!opts.uppercase;
							target.lowercase = !!opts.lowercase;

							target.prefix = target.creditCard || target.date ? '' : opts.prefix || '';
							target.noImmediatePrefix = !!opts.noImmediatePrefix;
							target.prefixLength = target.prefix.length;
							target.rawValueTrimPrefix = !!opts.rawValueTrimPrefix;
							target.copyDelimiter = !!opts.copyDelimiter;

							target.initValue = opts.initValue !== undefined && opts.initValue !== null ? opts.initValue.toString() : '';

							target.delimiter = opts.delimiter || opts.delimiter === '' ? opts.delimiter : opts.date ? '/' : opts.time ? ':' : opts.numeral ? ',' : opts.phone ? ' ' : ' ';
							target.delimiterLength = target.delimiter.length;
							target.delimiterLazyShow = !!opts.delimiterLazyShow;
							target.delimiters = opts.delimiters || [];

							target.blocks = opts.blocks || [];
							target.blocksLength = target.blocks.length;

							target.root = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) === 'object' && global ? global : window;
							target.document = opts.document || target.root.document;

							target.maxLength = 0;

							target.backspace = false;
							target.result = '';

							target.onValueChanged = opts.onValueChanged || function () {};

							return target;
						}
					};

					module.exports = DefaultProperties;

					/* WEBPACK VAR INJECTION */
				}).call(exports, function () {
					return this;
				}());

				/***/
			}]
			/******/)
		);
	});
	;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)(module)))

/***/ }),
/* 98 */
/***/ (function(module, exports) {

	"use strict";

	module.exports = function (module) {
		if (!module.webpackPolyfill) {
			module.deprecate = function () {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	};

/***/ }),
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module) {"use strict";

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/*!
	 * jQuery JavaScript Library v3.7.1
	 * https://jquery.com/
	 *
	 * Copyright OpenJS Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2023-08-28T13:37Z
	 */
	(function (global, factory) {

		"use strict";

		if (( false ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {

			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket trac-14549 for more info.
			module.exports = global.document ? factory(global, true) : function (w) {
				if (!w.document) {
					throw new Error("jQuery requires a window with a document");
				}
				return factory(w);
			};
		} else {
			factory(global);
		}

		// Pass this if window is not defined yet
	})(typeof window !== "undefined" ? window : undefined, function (window, noGlobal) {

		// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
		// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
		// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
		// enough that all such attempts are guarded in a try block.
		"use strict";

		var arr = [];

		var getProto = Object.getPrototypeOf;

		var _slice = arr.slice;

		var flat = arr.flat ? function (array) {
			return arr.flat.call(array);
		} : function (array) {
			return arr.concat.apply([], array);
		};

		var push = arr.push;

		var indexOf = arr.indexOf;

		var class2type = {};

		var toString = class2type.toString;

		var hasOwn = class2type.hasOwnProperty;

		var fnToString = hasOwn.toString;

		var ObjectFunctionString = fnToString.call(Object);

		var support = {};

		var isFunction = function isFunction(obj) {

			// Support: Chrome <=57, Firefox <=52
			// In some browsers, typeof returns "function" for HTML <object> elements
			// (i.e., `typeof document.createElement( "object" ) === "function"`).
			// We don't want to classify *any* DOM node as a function.
			// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
			// Plus for old WebKit, typeof returns "function" for HTML collections
			// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
			return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
		};

		var isWindow = function isWindow(obj) {
			return obj != null && obj === obj.window;
		};

		var document = window.document;

		var preservedScriptAttributes = {
			type: true,
			src: true,
			nonce: true,
			noModule: true
		};

		function DOMEval(code, node, doc) {
			doc = doc || document;

			var i,
			    val,
			    script = doc.createElement("script");

			script.text = code;
			if (node) {
				for (i in preservedScriptAttributes) {

					// Support: Firefox 64+, Edge 18+
					// Some browsers don't support the "nonce" property on scripts.
					// On the other hand, just using `getAttribute` is not enough as
					// the `nonce` attribute is reset to an empty string whenever it
					// becomes browsing-context connected.
					// See https://github.com/whatwg/html/issues/2369
					// See https://html.spec.whatwg.org/#nonce-attributes
					// The `node.getAttribute` check was added for the sake of
					// `jQuery.globalEval` so that it can fake a nonce-containing node
					// via an object.
					val = node[i] || node.getAttribute && node.getAttribute(i);
					if (val) {
						script.setAttribute(i, val);
					}
				}
			}
			doc.head.appendChild(script).parentNode.removeChild(script);
		}

		function toType(obj) {
			if (obj == null) {
				return obj + "";
			}

			// Support: Android <=2.3 only (functionish RegExp)
			return (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
		}
		/* global Symbol */
		// Defining this global in .eslintrc.json would create a danger of using the global
		// unguarded in another place, it seems safer to define global only for this module


		var version = "3.7.1",
		    rhtmlSuffix = /HTML$/i,


		// Define a local copy of jQuery
		jQuery = function jQuery(selector, context) {

			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init(selector, context);
		};

		jQuery.fn = jQuery.prototype = {

			// The current version of jQuery being used
			jquery: version,

			constructor: jQuery,

			// The default length of a jQuery object is 0
			length: 0,

			toArray: function toArray() {
				return _slice.call(this);
			},

			// Get the Nth element in the matched element set OR
			// Get the whole matched element set as a clean array
			get: function get(num) {

				// Return all the elements in a clean array
				if (num == null) {
					return _slice.call(this);
				}

				// Return just the one element from the set
				return num < 0 ? this[num + this.length] : this[num];
			},

			// Take an array of elements and push it onto the stack
			// (returning the new matched element set)
			pushStack: function pushStack(elems) {

				// Build a new jQuery matched element set
				var ret = jQuery.merge(this.constructor(), elems);

				// Add the old object onto the stack (as a reference)
				ret.prevObject = this;

				// Return the newly-formed element set
				return ret;
			},

			// Execute a callback for every element in the matched set.
			each: function each(callback) {
				return jQuery.each(this, callback);
			},

			map: function map(callback) {
				return this.pushStack(jQuery.map(this, function (elem, i) {
					return callback.call(elem, i, elem);
				}));
			},

			slice: function slice() {
				return this.pushStack(_slice.apply(this, arguments));
			},

			first: function first() {
				return this.eq(0);
			},

			last: function last() {
				return this.eq(-1);
			},

			even: function even() {
				return this.pushStack(jQuery.grep(this, function (_elem, i) {
					return (i + 1) % 2;
				}));
			},

			odd: function odd() {
				return this.pushStack(jQuery.grep(this, function (_elem, i) {
					return i % 2;
				}));
			},

			eq: function eq(i) {
				var len = this.length,
				    j = +i + (i < 0 ? len : 0);
				return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
			},

			end: function end() {
				return this.prevObject || this.constructor();
			},

			// For internal use only.
			// Behaves like an Array's method, not like a jQuery method.
			push: push,
			sort: arr.sort,
			splice: arr.splice
		};

		jQuery.extend = jQuery.fn.extend = function () {
			var options,
			    name,
			    src,
			    copy,
			    copyIsArray,
			    clone,
			    target = arguments[0] || {},
			    i = 1,
			    length = arguments.length,
			    deep = false;

			// Handle a deep copy situation
			if (typeof target === "boolean") {
				deep = target;

				// Skip the boolean and the target
				target = arguments[i] || {};
				i++;
			}

			// Handle case when target is a string or something (possible in deep copy)
			if ((typeof target === "undefined" ? "undefined" : _typeof(target)) !== "object" && !isFunction(target)) {
				target = {};
			}

			// Extend jQuery itself if only one argument is passed
			if (i === length) {
				target = this;
				i--;
			}

			for (; i < length; i++) {

				// Only deal with non-null/undefined values
				if ((options = arguments[i]) != null) {

					// Extend the base object
					for (name in options) {
						copy = options[name];

						// Prevent Object.prototype pollution
						// Prevent never-ending loop
						if (name === "__proto__" || target === copy) {
							continue;
						}

						// Recurse if we're merging plain objects or arrays
						if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
							src = target[name];

							// Ensure proper type for the source value
							if (copyIsArray && !Array.isArray(src)) {
								clone = [];
							} else if (!copyIsArray && !jQuery.isPlainObject(src)) {
								clone = {};
							} else {
								clone = src;
							}
							copyIsArray = false;

							// Never move original objects, clone them
							target[name] = jQuery.extend(deep, clone, copy);

							// Don't bring in undefined values
						} else if (copy !== undefined) {
							target[name] = copy;
						}
					}
				}
			}

			// Return the modified object
			return target;
		};

		jQuery.extend({

			// Unique for each copy of jQuery on the page
			expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

			// Assume jQuery is ready without the ready module
			isReady: true,

			error: function error(msg) {
				throw new Error(msg);
			},

			noop: function noop() {},

			isPlainObject: function isPlainObject(obj) {
				var proto, Ctor;

				// Detect obvious negatives
				// Use toString instead of jQuery.type to catch host objects
				if (!obj || toString.call(obj) !== "[object Object]") {
					return false;
				}

				proto = getProto(obj);

				// Objects with no prototype (e.g., `Object.create( null )`) are plain
				if (!proto) {
					return true;
				}

				// Objects with prototype are plain iff they were constructed by a global Object function
				Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
				return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
			},

			isEmptyObject: function isEmptyObject(obj) {
				var name;

				for (name in obj) {
					return false;
				}
				return true;
			},

			// Evaluates a script in a provided context; falls back to the global one
			// if not specified.
			globalEval: function globalEval(code, options, doc) {
				DOMEval(code, { nonce: options && options.nonce }, doc);
			},

			each: function each(obj, callback) {
				var length,
				    i = 0;

				if (isArrayLike(obj)) {
					length = obj.length;
					for (; i < length; i++) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				} else {
					for (i in obj) {
						if (callback.call(obj[i], i, obj[i]) === false) {
							break;
						}
					}
				}

				return obj;
			},

			// Retrieve the text value of an array of DOM nodes
			text: function text(elem) {
				var node,
				    ret = "",
				    i = 0,
				    nodeType = elem.nodeType;

				if (!nodeType) {

					// If no nodeType, this is expected to be an array
					while (node = elem[i++]) {

						// Do not traverse comment nodes
						ret += jQuery.text(node);
					}
				}
				if (nodeType === 1 || nodeType === 11) {
					return elem.textContent;
				}
				if (nodeType === 9) {
					return elem.documentElement.textContent;
				}
				if (nodeType === 3 || nodeType === 4) {
					return elem.nodeValue;
				}

				// Do not include comment or processing instruction nodes

				return ret;
			},

			// results is for internal usage only
			makeArray: function makeArray(arr, results) {
				var ret = results || [];

				if (arr != null) {
					if (isArrayLike(Object(arr))) {
						jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
					} else {
						push.call(ret, arr);
					}
				}

				return ret;
			},

			inArray: function inArray(elem, arr, i) {
				return arr == null ? -1 : indexOf.call(arr, elem, i);
			},

			isXMLDoc: function isXMLDoc(elem) {
				var namespace = elem && elem.namespaceURI,
				    docElem = elem && (elem.ownerDocument || elem).documentElement;

				// Assume HTML when documentElement doesn't yet exist, such as inside
				// document fragments.
				return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
			},

			// Support: Android <=4.0 only, PhantomJS 1 only
			// push.apply(_, arraylike) throws on ancient WebKit
			merge: function merge(first, second) {
				var len = +second.length,
				    j = 0,
				    i = first.length;

				for (; j < len; j++) {
					first[i++] = second[j];
				}

				first.length = i;

				return first;
			},

			grep: function grep(elems, callback, invert) {
				var callbackInverse,
				    matches = [],
				    i = 0,
				    length = elems.length,
				    callbackExpect = !invert;

				// Go through the array, only saving the items
				// that pass the validator function
				for (; i < length; i++) {
					callbackInverse = !callback(elems[i], i);
					if (callbackInverse !== callbackExpect) {
						matches.push(elems[i]);
					}
				}

				return matches;
			},

			// arg is for internal usage only
			map: function map(elems, callback, arg) {
				var length,
				    value,
				    i = 0,
				    ret = [];

				// Go through the array, translating each of the items to their new values
				if (isArrayLike(elems)) {
					length = elems.length;
					for (; i < length; i++) {
						value = callback(elems[i], i, arg);

						if (value != null) {
							ret.push(value);
						}
					}

					// Go through every key on the object,
				} else {
					for (i in elems) {
						value = callback(elems[i], i, arg);

						if (value != null) {
							ret.push(value);
						}
					}
				}

				// Flatten any nested arrays
				return flat(ret);
			},

			// A global GUID counter for objects
			guid: 1,

			// jQuery.support is not used in Core but other projects attach their
			// properties to it so it needs to exist.
			support: support
		});

		if (typeof Symbol === "function") {
			jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
		}

		// Populate the class2type map
		jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
			class2type["[object " + name + "]"] = name.toLowerCase();
		});

		function isArrayLike(obj) {

			// Support: real iOS 8.2 only (not reproducible in simulator)
			// `in` check used to prevent JIT error (gh-2145)
			// hasOwn isn't used here due to false negatives
			// regarding Nodelist length in IE
			var length = !!obj && "length" in obj && obj.length,
			    type = toType(obj);

			if (isFunction(obj) || isWindow(obj)) {
				return false;
			}

			return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
		}

		function nodeName(elem, name) {

			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		}
		var pop = arr.pop;

		var sort = arr.sort;

		var splice = arr.splice;

		var whitespace = "[\\x20\\t\\r\\n\\f]";

		var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");

		// Note: an element does not contain itself
		jQuery.contains = function (a, b) {
			var bup = b && b.parentNode;

			return a === bup || !!(bup && bup.nodeType === 1 && (

			// Support: IE 9 - 11+
			// IE doesn't have `contains` on SVG.
			a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
		};

		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

		function fcssescape(ch, asCodePoint) {
			if (asCodePoint) {

				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if (ch === "\0") {
					return "\uFFFD";
				}

				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
			}

			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		}

		jQuery.escapeSelector = function (sel) {
			return (sel + "").replace(rcssescape, fcssescape);
		};

		var preferredDoc = document,
		    pushNative = push;

		(function () {

			var i,
			    Expr,
			    outermostContext,
			    sortInput,
			    hasDuplicate,
			    push = pushNative,


			// Local document vars
			document,
			    documentElement,
			    documentIsHTML,
			    rbuggyQSA,
			    matches,


			// Instance-specific data
			expando = jQuery.expando,
			    dirruns = 0,
			    done = 0,
			    classCache = createCache(),
			    tokenCache = createCache(),
			    compilerCache = createCache(),
			    nonnativeSelectorCache = createCache(),
			    sortOrder = function sortOrder(a, b) {
				if (a === b) {
					hasDuplicate = true;
				}
				return 0;
			},
			    booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" + "loop|multiple|open|readonly|required|scoped",


			// Regular expressions

			// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
			identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",


			// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
			attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +

			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
			    pseudos = ":(" + identifier + ")(?:\\((" +

			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

			// 3. anything else (capture 2)
			".*" + ")\\)|)",


			// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
			rwhitespace = new RegExp(whitespace + "+", "g"),
			    rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
			    rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
			    rdescend = new RegExp(whitespace + "|>"),
			    rpseudo = new RegExp(pseudos),
			    ridentifier = new RegExp("^" + identifier + "$"),
			    matchExpr = {
				ID: new RegExp("^#(" + identifier + ")"),
				CLASS: new RegExp("^\\.(" + identifier + ")"),
				TAG: new RegExp("^(" + identifier + "|[*])"),
				ATTR: new RegExp("^" + attributes),
				PSEUDO: new RegExp("^" + pseudos),
				CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
				bool: new RegExp("^(?:" + booleans + ")$", "i"),

				// For use in libraries implementing .is()
				// We use this for POS matching in `select`
				needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
			},
			    rinputs = /^(?:input|select|textarea|button)$/i,
			    rheader = /^h\d$/i,


			// Easily-parseable/retrievable ID or TAG or CLASS selectors
			rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
			    rsibling = /[+~]/,


			// CSS escapes
			// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
			runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
			    funescape = function funescape(escape, nonHex) {
				var high = "0x" + escape.slice(1) - 0x10000;

				if (nonHex) {

					// Strip the backslash prefix from a non-hex escape sequence
					return nonHex;
				}

				// Replace a hexadecimal escape sequence with the encoded Unicode code point
				// Support: IE <=11+
				// For values outside the Basic Multilingual Plane (BMP), manually construct a
				// surrogate pair
				return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
			},


			// Used for iframes; see `setDocument`.
			// Support: IE 9 - 11+, Edge 12 - 18+
			// Removing the function wrapper causes a "Permission Denied"
			// error in IE/Edge.
			unloadHandler = function unloadHandler() {
				setDocument();
			},
			    inDisabledFieldset = addCombinator(function (elem) {
				return elem.disabled === true && nodeName(elem, "fieldset");
			}, { dir: "parentNode", next: "legend" });

			// Support: IE <=9 only
			// Accessing document.activeElement can throw unexpectedly
			// https://bugs.jquery.com/ticket/13393
			function safeActiveElement() {
				try {
					return document.activeElement;
				} catch (err) {}
			}

			// Optimize for push.apply( _, NodeList )
			try {
				push.apply(arr = _slice.call(preferredDoc.childNodes), preferredDoc.childNodes);

				// Support: Android <=4.0
				// Detect silently failing push.apply
				// eslint-disable-next-line no-unused-expressions
				arr[preferredDoc.childNodes.length].nodeType;
			} catch (e) {
				push = {
					apply: function apply(target, els) {
						pushNative.apply(target, _slice.call(els));
					},
					call: function call(target) {
						pushNative.apply(target, _slice.call(arguments, 1));
					}
				};
			}

			function find(selector, context, results, seed) {
				var m,
				    i,
				    elem,
				    nid,
				    match,
				    groups,
				    newSelector,
				    newContext = context && context.ownerDocument,


				// nodeType defaults to 9, since context defaults to document
				nodeType = context ? context.nodeType : 9;

				results = results || [];

				// Return early from calls with invalid selector or context
				if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {

					return results;
				}

				// Try to shortcut find operations (as opposed to filters) in HTML documents
				if (!seed) {
					setDocument(context);
					context = context || document;

					if (documentIsHTML) {

						// If the selector is sufficiently simple, try using a "get*By*" DOM method
						// (excepting DocumentFragment context, where the methods don't exist)
						if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {

							// ID selector
							if (m = match[1]) {

								// Document context
								if (nodeType === 9) {
									if (elem = context.getElementById(m)) {

										// Support: IE 9 only
										// getElementById can match elements by name instead of ID
										if (elem.id === m) {
											push.call(results, elem);
											return results;
										}
									} else {
										return results;
									}

									// Element context
								} else {

									// Support: IE 9 only
									// getElementById can match elements by name instead of ID
									if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {

										push.call(results, elem);
										return results;
									}
								}

								// Type selector
							} else if (match[2]) {
								push.apply(results, context.getElementsByTagName(selector));
								return results;

								// Class selector
							} else if ((m = match[3]) && context.getElementsByClassName) {
								push.apply(results, context.getElementsByClassName(m));
								return results;
							}
						}

						// Take advantage of querySelectorAll
						if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {

							newSelector = selector;
							newContext = context;

							// qSA considers elements outside a scoping root when evaluating child or
							// descendant combinators, which is not what we want.
							// In such cases, we work around the behavior by prefixing every selector in the
							// list with an ID selector referencing the scope context.
							// The technique has to be used as well when a leading combinator is used
							// as such selectors are not recognized by querySelectorAll.
							// Thanks to Andrew Dupont for this technique.
							if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {

								// Expand context for sibling selectors
								newContext = rsibling.test(selector) && testContext(context.parentNode) || context;

								// We can use :scope instead of the ID hack if the browser
								// supports it & if we're not changing the context.
								// Support: IE 11+, Edge 17 - 18+
								// IE/Edge sometimes throw a "Permission denied" error when
								// strict-comparing two documents; shallow comparisons work.
								// eslint-disable-next-line eqeqeq
								if (newContext != context || !support.scope) {

									// Capture the context ID, setting it first if necessary
									if (nid = context.getAttribute("id")) {
										nid = jQuery.escapeSelector(nid);
									} else {
										context.setAttribute("id", nid = expando);
									}
								}

								// Prefix every selector in the list
								groups = tokenize(selector);
								i = groups.length;
								while (i--) {
									groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
								}
								newSelector = groups.join(",");
							}

							try {
								push.apply(results, newContext.querySelectorAll(newSelector));
								return results;
							} catch (qsaError) {
								nonnativeSelectorCache(selector, true);
							} finally {
								if (nid === expando) {
									context.removeAttribute("id");
								}
							}
						}
					}
				}

				// All others
				return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
			}

			/**
	   * Create key-value caches of limited size
	   * @returns {function(string, object)} Returns the Object data after storing it on itself with
	   *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	   *	deleting the oldest entry
	   */
			function createCache() {
				var keys = [];

				function cache(key, value) {

					// Use (key + " ") to avoid collision with native prototype properties
					// (see https://github.com/jquery/sizzle/issues/157)
					if (keys.push(key + " ") > Expr.cacheLength) {

						// Only keep the most recent entries
						delete cache[keys.shift()];
					}
					return cache[key + " "] = value;
				}
				return cache;
			}

			/**
	   * Mark a function for special use by jQuery selector module
	   * @param {Function} fn The function to mark
	   */
			function markFunction(fn) {
				fn[expando] = true;
				return fn;
			}

			/**
	   * Support testing using an element
	   * @param {Function} fn Passed the created element and returns a boolean result
	   */
			function assert(fn) {
				var el = document.createElement("fieldset");

				try {
					return !!fn(el);
				} catch (e) {
					return false;
				} finally {

					// Remove from its parent by default
					if (el.parentNode) {
						el.parentNode.removeChild(el);
					}

					// release memory in IE
					el = null;
				}
			}

			/**
	   * Returns a function to use in pseudos for input types
	   * @param {String} type
	   */
			function createInputPseudo(type) {
				return function (elem) {
					return nodeName(elem, "input") && elem.type === type;
				};
			}

			/**
	   * Returns a function to use in pseudos for buttons
	   * @param {String} type
	   */
			function createButtonPseudo(type) {
				return function (elem) {
					return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
				};
			}

			/**
	   * Returns a function to use in pseudos for :enabled/:disabled
	   * @param {Boolean} disabled true for :disabled; false for :enabled
	   */
			function createDisabledPseudo(disabled) {

				// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
				return function (elem) {

					// Only certain elements can match :enabled or :disabled
					// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
					// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
					if ("form" in elem) {

						// Check for inherited disabledness on relevant non-disabled elements:
						// * listed form-associated elements in a disabled fieldset
						//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
						//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
						// * option elements in a disabled optgroup
						//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
						// All such elements have a "form" property.
						if (elem.parentNode && elem.disabled === false) {

							// Option elements defer to a parent optgroup if present
							if ("label" in elem) {
								if ("label" in elem.parentNode) {
									return elem.parentNode.disabled === disabled;
								} else {
									return elem.disabled === disabled;
								}
							}

							// Support: IE 6 - 11+
							// Use the isDisabled shortcut property to check for disabled fieldset ancestors
							return elem.isDisabled === disabled ||

							// Where there is no isDisabled, check manually
							elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
						}

						return elem.disabled === disabled;

						// Try to winnow out elements that can't be disabled before trusting the disabled property.
						// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
						// even exist on them, let alone have a boolean value.
					} else if ("label" in elem) {
						return elem.disabled === disabled;
					}

					// Remaining elements are neither :enabled nor :disabled
					return false;
				};
			}

			/**
	   * Returns a function to use in pseudos for positionals
	   * @param {Function} fn
	   */
			function createPositionalPseudo(fn) {
				return markFunction(function (argument) {
					argument = +argument;
					return markFunction(function (seed, matches) {
						var j,
						    matchIndexes = fn([], seed.length, argument),
						    i = matchIndexes.length;

						// Match elements found at the specified indexes
						while (i--) {
							if (seed[j = matchIndexes[i]]) {
								seed[j] = !(matches[j] = seed[j]);
							}
						}
					});
				});
			}

			/**
	   * Checks a node for validity as a jQuery selector context
	   * @param {Element|Object=} context
	   * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	   */
			function testContext(context) {
				return context && typeof context.getElementsByTagName !== "undefined" && context;
			}

			/**
	   * Sets document-related variables once based on the current document
	   * @param {Element|Object} [node] An element or document object to use to set the document
	   * @returns {Object} Returns the current document
	   */
			function setDocument(node) {
				var subWindow,
				    doc = node ? node.ownerDocument || node : preferredDoc;

				// Return early if doc is invalid or already selected
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
					return document;
				}

				// Update global variables
				document = doc;
				documentElement = document.documentElement;
				documentIsHTML = !jQuery.isXMLDoc(document);

				// Support: iOS 7 only, IE 9 - 11+
				// Older browsers didn't support unprefixed `matches`.
				matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;

				// Support: IE 9 - 11+, Edge 12 - 18+
				// Accessing iframe documents after unload throws "permission denied" errors
				// (see trac-13936).
				// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
				// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
				if (documentElement.msMatchesSelector &&

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {

					// Support: IE 9 - 11+, Edge 12 - 18+
					subWindow.addEventListener("unload", unloadHandler);
				}

				// Support: IE <10
				// Check if getElementById returns elements by name
				// The broken getElementById methods don't pick up programmatically-set names,
				// so use a roundabout getElementsByName test
				support.getById = assert(function (el) {
					documentElement.appendChild(el).id = jQuery.expando;
					return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
				});

				// Support: IE 9 only
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node.
				support.disconnectedMatch = assert(function (el) {
					return matches.call(el, "*");
				});

				// Support: IE 9 - 11+, Edge 12 - 18+
				// IE/Edge don't support the :scope pseudo-class.
				support.scope = assert(function () {
					return document.querySelectorAll(":scope");
				});

				// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
				// Make sure the `:has()` argument is parsed unforgivingly.
				// We include `*` in the test to detect buggy implementations that are
				// _selectively_ forgiving (specifically when the list includes at least
				// one valid selector).
				// Note that we treat complete lack of support for `:has()` as if it were
				// spec-compliant support, which is fine because use of `:has()` in such
				// environments will fail in the qSA path and fall back to jQuery traversal
				// anyway.
				support.cssHas = assert(function () {
					try {
						document.querySelector(":has(*,:jqfake)");
						return false;
					} catch (e) {
						return true;
					}
				});

				// ID filter and find
				if (support.getById) {
					Expr.filter.ID = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							return elem.getAttribute("id") === attrId;
						};
					};
					Expr.find.ID = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var elem = context.getElementById(id);
							return elem ? [elem] : [];
						}
					};
				} else {
					Expr.filter.ID = function (id) {
						var attrId = id.replace(runescape, funescape);
						return function (elem) {
							var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
							return node && node.value === attrId;
						};
					};

					// Support: IE 6 - 7 only
					// getElementById is not reliable as a find shortcut
					Expr.find.ID = function (id, context) {
						if (typeof context.getElementById !== "undefined" && documentIsHTML) {
							var node,
							    i,
							    elems,
							    elem = context.getElementById(id);

							if (elem) {

								// Verify the id attribute
								node = elem.getAttributeNode("id");
								if (node && node.value === id) {
									return [elem];
								}

								// Fall back on getElementsByName
								elems = context.getElementsByName(id);
								i = 0;
								while (elem = elems[i++]) {
									node = elem.getAttributeNode("id");
									if (node && node.value === id) {
										return [elem];
									}
								}
							}

							return [];
						}
					};
				}

				// Tag
				Expr.find.TAG = function (tag, context) {
					if (typeof context.getElementsByTagName !== "undefined") {
						return context.getElementsByTagName(tag);

						// DocumentFragment nodes don't have gEBTN
					} else {
						return context.querySelectorAll(tag);
					}
				};

				// Class
				Expr.find.CLASS = function (className, context) {
					if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
						return context.getElementsByClassName(className);
					}
				};

				/* QSA/matchesSelector
	   ---------------------------------------------------------------------- */

				// QSA and matchesSelector support

				rbuggyQSA = [];

				// Build QSA regex
				// Regex strategy adopted from Diego Perini
				assert(function (el) {

					var input;

					documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";

					// Support: iOS <=7 - 8 only
					// Boolean attributes and "value" are not treated correctly in some XML documents
					if (!el.querySelectorAll("[selected]").length) {
						rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
					}

					// Support: iOS <=7 - 8 only
					if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
						rbuggyQSA.push("~=");
					}

					// Support: iOS 8 only
					// https://bugs.webkit.org/show_bug.cgi?id=136851
					// In-page `selector#id sibling-combinator selector` fails
					if (!el.querySelectorAll("a#" + expando + "+*").length) {
						rbuggyQSA.push(".#.+[+~]");
					}

					// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
					// In some of the document kinds, these selectors wouldn't work natively.
					// This is probably OK but for backwards compatibility we want to maintain
					// handling them through jQuery traversal in jQuery 3.x.
					if (!el.querySelectorAll(":checked").length) {
						rbuggyQSA.push(":checked");
					}

					// Support: Windows 8 Native Apps
					// The type and name attributes are restricted during .innerHTML assignment
					input = document.createElement("input");
					input.setAttribute("type", "hidden");
					el.appendChild(input).setAttribute("name", "D");

					// Support: IE 9 - 11+
					// IE's :disabled selector does not pick up the children of disabled fieldsets
					// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
					// In some of the document kinds, these selectors wouldn't work natively.
					// This is probably OK but for backwards compatibility we want to maintain
					// handling them through jQuery traversal in jQuery 3.x.
					documentElement.appendChild(el).disabled = true;
					if (el.querySelectorAll(":disabled").length !== 2) {
						rbuggyQSA.push(":enabled", ":disabled");
					}

					// Support: IE 11+, Edge 15 - 18+
					// IE 11/Edge don't find elements on a `[name='']` query in some cases.
					// Adding a temporary attribute to the document before the selection works
					// around the issue.
					// Interestingly, IE 10 & older don't seem to have the issue.
					input = document.createElement("input");
					input.setAttribute("name", "");
					el.appendChild(input);
					if (!el.querySelectorAll("[name='']").length) {
						rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
					}
				});

				if (!support.cssHas) {

					// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
					// Our regular `try-catch` mechanism fails to detect natively-unsupported
					// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
					// in browsers that parse the `:has()` argument as a forgiving selector list.
					// https://drafts.csswg.org/selectors/#relational now requires the argument
					// to be parsed unforgivingly, but browsers have not yet fully adjusted.
					rbuggyQSA.push(":has");
				}

				rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));

				/* Sorting
	   ---------------------------------------------------------------------- */

				// Document order sorting
				sortOrder = function sortOrder(a, b) {

					// Flag for duplicate removal
					if (a === b) {
						hasDuplicate = true;
						return 0;
					}

					// Sort on method existence if only one input has compareDocumentPosition
					var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
					if (compare) {
						return compare;
					}

					// Calculate position if both inputs belong to the same document
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :

					// Otherwise we know they are disconnected
					1;

					// Disconnected nodes
					if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {

						// Choose the first element that is related to our preferred document
						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
							return -1;
						}

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
							return 1;
						}

						// Maintain original order
						return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
					}

					return compare & 4 ? -1 : 1;
				};

				return document;
			}

			find.matches = function (expr, elements) {
				return find(expr, null, null, elements);
			};

			find.matchesSelector = function (elem, expr) {
				setDocument(elem);

				if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {

					try {
						var ret = matches.call(elem, expr);

						// IE 9's matchesSelector returns false on disconnected nodes
						if (ret || support.disconnectedMatch ||

						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11) {
							return ret;
						}
					} catch (e) {
						nonnativeSelectorCache(expr, true);
					}
				}

				return find(expr, document, null, [elem]).length > 0;
			};

			find.contains = function (context, elem) {

				// Set document vars if needed
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ((context.ownerDocument || context) != document) {
					setDocument(context);
				}
				return jQuery.contains(context, elem);
			};

			find.attr = function (elem, name) {

				// Set document vars if needed
				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				if ((elem.ownerDocument || elem) != document) {
					setDocument(elem);
				}

				var fn = Expr.attrHandle[name.toLowerCase()],


				// Don't get fooled by Object.prototype properties (see trac-13807)
				val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;

				if (val !== undefined) {
					return val;
				}

				return elem.getAttribute(name);
			};

			find.error = function (msg) {
				throw new Error("Syntax error, unrecognized expression: " + msg);
			};

			/**
	   * Document sorting and removing duplicates
	   * @param {ArrayLike} results
	   */
			jQuery.uniqueSort = function (results) {
				var elem,
				    duplicates = [],
				    j = 0,
				    i = 0;

				// Unless we *know* we can detect duplicates, assume their presence
				//
				// Support: Android <=4.0+
				// Testing for detecting duplicates is unpredictable so instead assume we can't
				// depend on duplicate detection in all browsers without a stable sort.
				hasDuplicate = !support.sortStable;
				sortInput = !support.sortStable && _slice.call(results, 0);
				sort.call(results, sortOrder);

				if (hasDuplicate) {
					while (elem = results[i++]) {
						if (elem === results[i]) {
							j = duplicates.push(i);
						}
					}
					while (j--) {
						splice.call(results, duplicates[j], 1);
					}
				}

				// Clear input after sorting to release objects
				// See https://github.com/jquery/sizzle/pull/225
				sortInput = null;

				return results;
			};

			jQuery.fn.uniqueSort = function () {
				return this.pushStack(jQuery.uniqueSort(_slice.apply(this)));
			};

			Expr = jQuery.expr = {

				// Can be adjusted by the user
				cacheLength: 50,

				createPseudo: markFunction,

				match: matchExpr,

				attrHandle: {},

				find: {},

				relative: {
					">": { dir: "parentNode", first: true },
					" ": { dir: "parentNode" },
					"+": { dir: "previousSibling", first: true },
					"~": { dir: "previousSibling" }
				},

				preFilter: {
					ATTR: function ATTR(match) {
						match[1] = match[1].replace(runescape, funescape);

						// Move the given value to match[3] whether quoted or unquoted
						match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);

						if (match[2] === "~=") {
							match[3] = " " + match[3] + " ";
						}

						return match.slice(0, 4);
					},

					CHILD: function CHILD(match) {

						/* matches from matchExpr["CHILD"]
	     	1 type (only|nth|...)
	     	2 what (child|of-type)
	     	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	     	4 xn-component of xn+y argument ([+-]?\d*n|)
	     	5 sign of xn-component
	     	6 x of xn-component
	     	7 sign of y-component
	     	8 y of y-component
	     */
						match[1] = match[1].toLowerCase();

						if (match[1].slice(0, 3) === "nth") {

							// nth-* requires argument
							if (!match[3]) {
								find.error(match[0]);
							}

							// numeric x and y parameters for Expr.filter.CHILD
							// remember that false/true cast respectively to 0/1
							match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
							match[5] = +(match[7] + match[8] || match[3] === "odd");

							// other types prohibit arguments
						} else if (match[3]) {
							find.error(match[0]);
						}

						return match;
					},

					PSEUDO: function PSEUDO(match) {
						var excess,
						    unquoted = !match[6] && match[2];

						if (matchExpr.CHILD.test(match[0])) {
							return null;
						}

						// Accept quoted arguments as-is
						if (match[3]) {
							match[2] = match[4] || match[5] || "";

							// Strip excess characters from unquoted arguments
						} else if (unquoted && rpseudo.test(unquoted) && (

						// Get excess from tokenize (recursively)
						excess = tokenize(unquoted, true)) && (

						// advance to the next closing parenthesis
						excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {

							// excess is a negative index
							match[0] = match[0].slice(0, excess);
							match[2] = unquoted.slice(0, excess);
						}

						// Return only captures needed by the pseudo filter method (type and argument)
						return match.slice(0, 3);
					}
				},

				filter: {

					TAG: function TAG(nodeNameSelector) {
						var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
						return nodeNameSelector === "*" ? function () {
							return true;
						} : function (elem) {
							return nodeName(elem, expectedNodeName);
						};
					},

					CLASS: function CLASS(className) {
						var pattern = classCache[className + " "];

						return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
							return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
						});
					},

					ATTR: function ATTR(name, operator, check) {
						return function (elem) {
							var result = find.attr(elem, name);

							if (result == null) {
								return operator === "!=";
							}
							if (!operator) {
								return true;
							}

							result += "";

							if (operator === "=") {
								return result === check;
							}
							if (operator === "!=") {
								return result !== check;
							}
							if (operator === "^=") {
								return check && result.indexOf(check) === 0;
							}
							if (operator === "*=") {
								return check && result.indexOf(check) > -1;
							}
							if (operator === "$=") {
								return check && result.slice(-check.length) === check;
							}
							if (operator === "~=") {
								return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
							}
							if (operator === "|=") {
								return result === check || result.slice(0, check.length + 1) === check + "-";
							}

							return false;
						};
					},

					CHILD: function CHILD(type, what, _argument, first, last) {
						var simple = type.slice(0, 3) !== "nth",
						    forward = type.slice(-4) !== "last",
						    ofType = what === "of-type";

						return first === 1 && last === 0 ?

						// Shortcut for :nth-*(n)
						function (elem) {
							return !!elem.parentNode;
						} : function (elem, _context, xml) {
							var cache,
							    outerCache,
							    node,
							    nodeIndex,
							    start,
							    dir = simple !== forward ? "nextSibling" : "previousSibling",
							    parent = elem.parentNode,
							    name = ofType && elem.nodeName.toLowerCase(),
							    useCache = !xml && !ofType,
							    diff = false;

							if (parent) {

								// :(first|last|only)-(child|of-type)
								if (simple) {
									while (dir) {
										node = elem;
										while (node = node[dir]) {
											if (ofType ? nodeName(node, name) : node.nodeType === 1) {

												return false;
											}
										}

										// Reverse direction for :only-* (if we haven't yet done so)
										start = dir = type === "only" && !start && "nextSibling";
									}
									return true;
								}

								start = [forward ? parent.firstChild : parent.lastChild];

								// non-xml :nth-child(...) stores cache data on `parent`
								if (forward && useCache) {

									// Seek `elem` from a previously-cached index
									outerCache = parent[expando] || (parent[expando] = {});
									cache = outerCache[type] || [];
									nodeIndex = cache[0] === dirruns && cache[1];
									diff = nodeIndex && cache[2];
									node = nodeIndex && parent.childNodes[nodeIndex];

									while (node = ++nodeIndex && node && node[dir] || (

									// Fallback to seeking `elem` from the start
									diff = nodeIndex = 0) || start.pop()) {

										// When found, cache indexes on `parent` and break
										if (node.nodeType === 1 && ++diff && node === elem) {
											outerCache[type] = [dirruns, nodeIndex, diff];
											break;
										}
									}
								} else {

									// Use previously-cached element index if available
									if (useCache) {
										outerCache = elem[expando] || (elem[expando] = {});
										cache = outerCache[type] || [];
										nodeIndex = cache[0] === dirruns && cache[1];
										diff = nodeIndex;
									}

									// xml :nth-child(...)
									// or :nth-last-child(...) or :nth(-last)?-of-type(...)
									if (diff === false) {

										// Use the same loop as above to seek `elem` from the start
										while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {

											if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {

												// Cache the index of each encountered element
												if (useCache) {
													outerCache = node[expando] || (node[expando] = {});
													outerCache[type] = [dirruns, diff];
												}

												if (node === elem) {
													break;
												}
											}
										}
									}
								}

								// Incorporate the offset, then check against cycle size
								diff -= last;
								return diff === first || diff % first === 0 && diff / first >= 0;
							}
						};
					},

					PSEUDO: function PSEUDO(pseudo, argument) {

						// pseudo-class names are case-insensitive
						// https://www.w3.org/TR/selectors/#pseudo-classes
						// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
						// Remember that setFilters inherits from pseudos
						var args,
						    fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);

						// The user may use createPseudo to indicate that
						// arguments are needed to create the filter function
						// just as jQuery does
						if (fn[expando]) {
							return fn(argument);
						}

						// But maintain support for old signatures
						if (fn.length > 1) {
							args = [pseudo, pseudo, "", argument];
							return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
								var idx,
								    matched = fn(seed, argument),
								    i = matched.length;
								while (i--) {
									idx = indexOf.call(seed, matched[i]);
									seed[idx] = !(matches[idx] = matched[i]);
								}
							}) : function (elem) {
								return fn(elem, 0, args);
							};
						}

						return fn;
					}
				},

				pseudos: {

					// Potentially complex pseudos
					not: markFunction(function (selector) {

						// Trim the selector passed to compile
						// to avoid treating leading and trailing
						// spaces as combinators
						var input = [],
						    results = [],
						    matcher = compile(selector.replace(rtrimCSS, "$1"));

						return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
							var elem,
							    unmatched = matcher(seed, null, xml, []),
							    i = seed.length;

							// Match elements unmatched by `matcher`
							while (i--) {
								if (elem = unmatched[i]) {
									seed[i] = !(matches[i] = elem);
								}
							}
						}) : function (elem, _context, xml) {
							input[0] = elem;
							matcher(input, null, xml, results);

							// Don't keep the element
							// (see https://github.com/jquery/sizzle/issues/299)
							input[0] = null;
							return !results.pop();
						};
					}),

					has: markFunction(function (selector) {
						return function (elem) {
							return find(selector, elem).length > 0;
						};
					}),

					contains: markFunction(function (text) {
						text = text.replace(runescape, funescape);
						return function (elem) {
							return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
						};
					}),

					// "Whether an element is represented by a :lang() selector
					// is based solely on the element's language value
					// being equal to the identifier C,
					// or beginning with the identifier C immediately followed by "-".
					// The matching of C against the element's language value is performed case-insensitively.
					// The identifier C does not have to be a valid language name."
					// https://www.w3.org/TR/selectors/#lang-pseudo
					lang: markFunction(function (lang) {

						// lang value must be a valid identifier
						if (!ridentifier.test(lang || "")) {
							find.error("unsupported lang: " + lang);
						}
						lang = lang.replace(runescape, funescape).toLowerCase();
						return function (elem) {
							var elemLang;
							do {
								if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {

									elemLang = elemLang.toLowerCase();
									return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
								}
							} while ((elem = elem.parentNode) && elem.nodeType === 1);
							return false;
						};
					}),

					// Miscellaneous
					target: function target(elem) {
						var hash = window.location && window.location.hash;
						return hash && hash.slice(1) === elem.id;
					},

					root: function root(elem) {
						return elem === documentElement;
					},

					focus: function focus(elem) {
						return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
					},

					// Boolean properties
					enabled: createDisabledPseudo(false),
					disabled: createDisabledPseudo(true),

					checked: function checked(elem) {

						// In CSS3, :checked should return both checked and selected elements
						// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
						return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
					},

					selected: function selected(elem) {

						// Support: IE <=11+
						// Accessing the selectedIndex property
						// forces the browser to treat the default option as
						// selected when in an optgroup.
						if (elem.parentNode) {
							// eslint-disable-next-line no-unused-expressions
							elem.parentNode.selectedIndex;
						}

						return elem.selected === true;
					},

					// Contents
					empty: function empty(elem) {

						// https://www.w3.org/TR/selectors/#empty-pseudo
						// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
						//   but not by others (comment: 8; processing instruction: 7; etc.)
						// nodeType < 6 works because attributes (2) do not appear as children
						for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
							if (elem.nodeType < 6) {
								return false;
							}
						}
						return true;
					},

					parent: function parent(elem) {
						return !Expr.pseudos.empty(elem);
					},

					// Element/input types
					header: function header(elem) {
						return rheader.test(elem.nodeName);
					},

					input: function input(elem) {
						return rinputs.test(elem.nodeName);
					},

					button: function button(elem) {
						return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
					},

					text: function text(elem) {
						var attr;
						return nodeName(elem, "input") && elem.type === "text" && (

						// Support: IE <10 only
						// New HTML5 attribute values (e.g., "search") appear
						// with elem.type === "text"
						(attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
					},

					// Position-in-collection
					first: createPositionalPseudo(function () {
						return [0];
					}),

					last: createPositionalPseudo(function (_matchIndexes, length) {
						return [length - 1];
					}),

					eq: createPositionalPseudo(function (_matchIndexes, length, argument) {
						return [argument < 0 ? argument + length : argument];
					}),

					even: createPositionalPseudo(function (matchIndexes, length) {
						var i = 0;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),

					odd: createPositionalPseudo(function (matchIndexes, length) {
						var i = 1;
						for (; i < length; i += 2) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),

					lt: createPositionalPseudo(function (matchIndexes, length, argument) {
						var i;

						if (argument < 0) {
							i = argument + length;
						} else if (argument > length) {
							i = length;
						} else {
							i = argument;
						}

						for (; --i >= 0;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					}),

					gt: createPositionalPseudo(function (matchIndexes, length, argument) {
						var i = argument < 0 ? argument + length : argument;
						for (; ++i < length;) {
							matchIndexes.push(i);
						}
						return matchIndexes;
					})
				}
			};

			Expr.pseudos.nth = Expr.pseudos.eq;

			// Add button/input type pseudos
			for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
				Expr.pseudos[i] = createInputPseudo(i);
			}
			for (i in { submit: true, reset: true }) {
				Expr.pseudos[i] = createButtonPseudo(i);
			}

			// Easy API for creating new setFilters
			function setFilters() {}
			setFilters.prototype = Expr.filters = Expr.pseudos;
			Expr.setFilters = new setFilters();

			function tokenize(selector, parseOnly) {
				var matched,
				    match,
				    tokens,
				    type,
				    soFar,
				    groups,
				    preFilters,
				    cached = tokenCache[selector + " "];

				if (cached) {
					return parseOnly ? 0 : cached.slice(0);
				}

				soFar = selector;
				groups = [];
				preFilters = Expr.preFilter;

				while (soFar) {

					// Comma and first run
					if (!matched || (match = rcomma.exec(soFar))) {
						if (match) {

							// Don't consume trailing commas as valid
							soFar = soFar.slice(match[0].length) || soFar;
						}
						groups.push(tokens = []);
					}

					matched = false;

					// Combinators
					if (match = rleadingCombinator.exec(soFar)) {
						matched = match.shift();
						tokens.push({
							value: matched,

							// Cast descendant combinators to space
							type: match[0].replace(rtrimCSS, " ")
						});
						soFar = soFar.slice(matched.length);
					}

					// Filters
					for (type in Expr.filter) {
						if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
							matched = match.shift();
							tokens.push({
								value: matched,
								type: type,
								matches: match
							});
							soFar = soFar.slice(matched.length);
						}
					}

					if (!matched) {
						break;
					}
				}

				// Return the length of the invalid excess
				// if we're just parsing
				// Otherwise, throw an error or return tokens
				if (parseOnly) {
					return soFar.length;
				}

				return soFar ? find.error(selector) :

				// Cache the tokens
				tokenCache(selector, groups).slice(0);
			}

			function toSelector(tokens) {
				var i = 0,
				    len = tokens.length,
				    selector = "";
				for (; i < len; i++) {
					selector += tokens[i].value;
				}
				return selector;
			}

			function addCombinator(matcher, combinator, base) {
				var dir = combinator.dir,
				    skip = combinator.next,
				    key = skip || dir,
				    checkNonElements = base && key === "parentNode",
				    doneName = done++;

				return combinator.first ?

				// Check against closest ancestor/preceding element
				function (elem, context, xml) {
					while (elem = elem[dir]) {
						if (elem.nodeType === 1 || checkNonElements) {
							return matcher(elem, context, xml);
						}
					}
					return false;
				} :

				// Check against all ancestor/preceding elements
				function (elem, context, xml) {
					var oldCache,
					    outerCache,
					    newCache = [dirruns, doneName];

					// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
					if (xml) {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								if (matcher(elem, context, xml)) {
									return true;
								}
							}
						}
					} else {
						while (elem = elem[dir]) {
							if (elem.nodeType === 1 || checkNonElements) {
								outerCache = elem[expando] || (elem[expando] = {});

								if (skip && nodeName(elem, skip)) {
									elem = elem[dir] || elem;
								} else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {

									// Assign to newCache so results back-propagate to previous elements
									return newCache[2] = oldCache[2];
								} else {

									// Reuse newcache so results back-propagate to previous elements
									outerCache[key] = newCache;

									// A match means we're done; a fail means we have to keep checking
									if (newCache[2] = matcher(elem, context, xml)) {
										return true;
									}
								}
							}
						}
					}
					return false;
				};
			}

			function elementMatcher(matchers) {
				return matchers.length > 1 ? function (elem, context, xml) {
					var i = matchers.length;
					while (i--) {
						if (!matchers[i](elem, context, xml)) {
							return false;
						}
					}
					return true;
				} : matchers[0];
			}

			function multipleContexts(selector, contexts, results) {
				var i = 0,
				    len = contexts.length;
				for (; i < len; i++) {
					find(selector, contexts[i], results);
				}
				return results;
			}

			function condense(unmatched, map, filter, context, xml) {
				var elem,
				    newUnmatched = [],
				    i = 0,
				    len = unmatched.length,
				    mapped = map != null;

				for (; i < len; i++) {
					if (elem = unmatched[i]) {
						if (!filter || filter(elem, context, xml)) {
							newUnmatched.push(elem);
							if (mapped) {
								map.push(i);
							}
						}
					}
				}

				return newUnmatched;
			}

			function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
				if (postFilter && !postFilter[expando]) {
					postFilter = setMatcher(postFilter);
				}
				if (postFinder && !postFinder[expando]) {
					postFinder = setMatcher(postFinder, postSelector);
				}
				return markFunction(function (seed, results, context, xml) {
					var temp,
					    i,
					    elem,
					    matcherOut,
					    preMap = [],
					    postMap = [],
					    preexisting = results.length,


					// Get initial elements from seed or context
					elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),


					// Prefilter to get matcher input, preserving a map for seed-results synchronization
					matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;

					if (matcher) {

						// If we have a postFinder, or filtered seed, or non-seed postFilter
						// or preexisting results,
						matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ?

						// ...intermediate processing is necessary
						[] :

						// ...otherwise use results directly
						results;

						// Find primary matches
						matcher(matcherIn, matcherOut, context, xml);
					} else {
						matcherOut = matcherIn;
					}

					// Apply postFilter
					if (postFilter) {
						temp = condense(matcherOut, postMap);
						postFilter(temp, [], context, xml);

						// Un-match failing elements by moving them back to matcherIn
						i = temp.length;
						while (i--) {
							if (elem = temp[i]) {
								matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
							}
						}
					}

					if (seed) {
						if (postFinder || preFilter) {
							if (postFinder) {

								// Get the final matcherOut by condensing this intermediate into postFinder contexts
								temp = [];
								i = matcherOut.length;
								while (i--) {
									if (elem = matcherOut[i]) {

										// Restore matcherIn since elem is not yet a final match
										temp.push(matcherIn[i] = elem);
									}
								}
								postFinder(null, matcherOut = [], temp, xml);
							}

							// Move matched elements from seed to results to keep them synchronized
							i = matcherOut.length;
							while (i--) {
								if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {

									seed[temp] = !(results[temp] = elem);
								}
							}
						}

						// Add elements to results, through postFinder if defined
					} else {
						matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
						if (postFinder) {
							postFinder(null, results, matcherOut, xml);
						} else {
							push.apply(results, matcherOut);
						}
					}
				});
			}

			function matcherFromTokens(tokens) {
				var checkContext,
				    matcher,
				    j,
				    len = tokens.length,
				    leadingRelative = Expr.relative[tokens[0].type],
				    implicitRelative = leadingRelative || Expr.relative[" "],
				    i = leadingRelative ? 1 : 0,


				// The foundational matcher ensures that elements are reachable from top-level context(s)
				matchContext = addCombinator(function (elem) {
					return elem === checkContext;
				}, implicitRelative, true),
				    matchAnyContext = addCombinator(function (elem) {
					return indexOf.call(checkContext, elem) > -1;
				}, implicitRelative, true),
				    matchers = [function (elem, context, xml) {

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));

					// Avoid hanging onto element
					// (see https://github.com/jquery/sizzle/issues/299)
					checkContext = null;
					return ret;
				}];

				for (; i < len; i++) {
					if (matcher = Expr.relative[tokens[i].type]) {
						matchers = [addCombinator(elementMatcher(matchers), matcher)];
					} else {
						matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

						// Return special upon seeing a positional matcher
						if (matcher[expando]) {

							// Find the next relative operator (if any) for proper handling
							j = ++i;
							for (; j < len; j++) {
								if (Expr.relative[tokens[j].type]) {
									break;
								}
							}
							return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(

							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
						}
						matchers.push(matcher);
					}
				}

				return elementMatcher(matchers);
			}

			function matcherFromGroupMatchers(elementMatchers, setMatchers) {
				var bySet = setMatchers.length > 0,
				    byElement = elementMatchers.length > 0,
				    superMatcher = function superMatcher(seed, context, xml, results, outermost) {
					var elem,
					    j,
					    matcher,
					    matchedCount = 0,
					    i = "0",
					    unmatched = seed && [],
					    setMatched = [],
					    contextBackup = outermostContext,


					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find.TAG("*", outermost),


					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
					    len = elems.length;

					if (outermost) {

						// Support: IE 11+, Edge 17 - 18+
						// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
						// two documents; shallow comparisons work.
						// eslint-disable-next-line eqeqeq
						outermostContext = context == document || context || outermost;
					}

					// Add elements passing elementMatchers directly to results
					// Support: iOS <=7 - 9 only
					// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
					// elements by id. (see trac-14142)
					for (; i !== len && (elem = elems[i]) != null; i++) {
						if (byElement && elem) {
							j = 0;

							// Support: IE 11+, Edge 17 - 18+
							// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
							// two documents; shallow comparisons work.
							// eslint-disable-next-line eqeqeq
							if (!context && elem.ownerDocument != document) {
								setDocument(elem);
								xml = !documentIsHTML;
							}
							while (matcher = elementMatchers[j++]) {
								if (matcher(elem, context || document, xml)) {
									push.call(results, elem);
									break;
								}
							}
							if (outermost) {
								dirruns = dirrunsUnique;
							}
						}

						// Track unmatched elements for set filters
						if (bySet) {

							// They will have gone through all possible matchers
							if (elem = !matcher && elem) {
								matchedCount--;
							}

							// Lengthen the array for every element, matched or not
							if (seed) {
								unmatched.push(elem);
							}
						}
					}

					// `i` is now the count of elements visited above, and adding it to `matchedCount`
					// makes the latter nonnegative.
					matchedCount += i;

					// Apply set filters to unmatched elements
					// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
					// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
					// no element matchers and no seed.
					// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
					// case, which will result in a "00" `matchedCount` that differs from `i` but is also
					// numerically zero.
					if (bySet && i !== matchedCount) {
						j = 0;
						while (matcher = setMatchers[j++]) {
							matcher(unmatched, setMatched, context, xml);
						}

						if (seed) {

							// Reintegrate element matches to eliminate the need for sorting
							if (matchedCount > 0) {
								while (i--) {
									if (!(unmatched[i] || setMatched[i])) {
										setMatched[i] = pop.call(results);
									}
								}
							}

							// Discard index placeholder values to get only actual matches
							setMatched = condense(setMatched);
						}

						// Add matches to results
						push.apply(results, setMatched);

						// Seedless set matches succeeding multiple successful matchers stipulate sorting
						if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {

							jQuery.uniqueSort(results);
						}
					}

					// Override manipulation of globals by nested matchers
					if (outermost) {
						dirruns = dirrunsUnique;
						outermostContext = contextBackup;
					}

					return unmatched;
				};

				return bySet ? markFunction(superMatcher) : superMatcher;
			}

			function compile(selector, match /* Internal Use Only */) {
				var i,
				    setMatchers = [],
				    elementMatchers = [],
				    cached = compilerCache[selector + " "];

				if (!cached) {

					// Generate a function of recursive functions that can be used to check each element
					if (!match) {
						match = tokenize(selector);
					}
					i = match.length;
					while (i--) {
						cached = matcherFromTokens(match[i]);
						if (cached[expando]) {
							setMatchers.push(cached);
						} else {
							elementMatchers.push(cached);
						}
					}

					// Cache the compiled function
					cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

					// Save selector and tokenization
					cached.selector = selector;
				}
				return cached;
			}

			/**
	   * A low-level selection function that works with jQuery's compiled
	   *  selector functions
	   * @param {String|Function} selector A selector or a pre-compiled
	   *  selector function built with jQuery selector compile
	   * @param {Element} context
	   * @param {Array} [results]
	   * @param {Array} [seed] A set of elements to match against
	   */
			function select(selector, context, results, seed) {
				var i,
				    tokens,
				    token,
				    type,
				    find,
				    compiled = typeof selector === "function" && selector,
				    match = !seed && tokenize(selector = compiled.selector || selector);

				results = results || [];

				// Try to minimize operations if there is only one selector in the list and no seed
				// (the latter of which guarantees us context)
				if (match.length === 1) {

					// Reduce context if the leading compound selector is an ID
					tokens = match[0] = match[0].slice(0);
					if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {

						context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
						if (!context) {
							return results;

							// Precompiled matchers will still verify ancestry, so step up a level
						} else if (compiled) {
							context = context.parentNode;
						}

						selector = selector.slice(tokens.shift().value.length);
					}

					// Fetch a seed set for right-to-left matching
					i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
					while (i--) {
						token = tokens[i];

						// Abort if we hit a combinator
						if (Expr.relative[type = token.type]) {
							break;
						}
						if (find = Expr.find[type]) {

							// Search, expanding context for leading sibling combinators
							if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {

								// If seed is empty or no tokens remain, we can return early
								tokens.splice(i, 1);
								selector = seed.length && toSelector(tokens);
								if (!selector) {
									push.apply(results, seed);
									return results;
								}

								break;
							}
						}
					}
				}

				// Compile and execute a filtering function if one is not provided
				// Provide `match` to avoid retokenization if we modified the selector above
				(compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
				return results;
			}

			// One-time assignments

			// Support: Android <=4.0 - 4.1+
			// Sort stability
			support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

			// Initialize against the default document
			setDocument();

			// Support: Android <=4.0 - 4.1+
			// Detached nodes confoundingly follow *each other*
			support.sortDetached = assert(function (el) {

				// Should return 1, but returns 4 (following)
				return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
			});

			jQuery.find = find;

			// Deprecated
			jQuery.expr[":"] = jQuery.expr.pseudos;
			jQuery.unique = jQuery.uniqueSort;

			// These have always been private, but they used to be documented as part of
			// Sizzle so let's maintain them for now for backwards compatibility purposes.
			find.compile = compile;
			find.select = select;
			find.setDocument = setDocument;
			find.tokenize = tokenize;

			find.escape = jQuery.escapeSelector;
			find.getText = jQuery.text;
			find.isXML = jQuery.isXMLDoc;
			find.selectors = jQuery.expr;
			find.support = jQuery.support;
			find.uniqueSort = jQuery.uniqueSort;

			/* eslint-enable */
		})();

		var dir = function dir(elem, _dir, until) {
			var matched = [],
			    truncate = until !== undefined;

			while ((elem = elem[_dir]) && elem.nodeType !== 9) {
				if (elem.nodeType === 1) {
					if (truncate && jQuery(elem).is(until)) {
						break;
					}
					matched.push(elem);
				}
			}
			return matched;
		};

		var _siblings = function _siblings(n, elem) {
			var matched = [];

			for (; n; n = n.nextSibling) {
				if (n.nodeType === 1 && n !== elem) {
					matched.push(n);
				}
			}

			return matched;
		};

		var rneedsContext = jQuery.expr.match.needsContext;

		var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

		// Implement the identical functionality for filter and not
		function winnow(elements, qualifier, not) {
			if (isFunction(qualifier)) {
				return jQuery.grep(elements, function (elem, i) {
					return !!qualifier.call(elem, i, elem) !== not;
				});
			}

			// Single element
			if (qualifier.nodeType) {
				return jQuery.grep(elements, function (elem) {
					return elem === qualifier !== not;
				});
			}

			// Arraylike of elements (jQuery, arguments, Array)
			if (typeof qualifier !== "string") {
				return jQuery.grep(elements, function (elem) {
					return indexOf.call(qualifier, elem) > -1 !== not;
				});
			}

			// Filtered directly for both simple and complex selectors
			return jQuery.filter(qualifier, elements, not);
		}

		jQuery.filter = function (expr, elems, not) {
			var elem = elems[0];

			if (not) {
				expr = ":not(" + expr + ")";
			}

			if (elems.length === 1 && elem.nodeType === 1) {
				return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
			}

			return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
				return elem.nodeType === 1;
			}));
		};

		jQuery.fn.extend({
			find: function find(selector) {
				var i,
				    ret,
				    len = this.length,
				    self = this;

				if (typeof selector !== "string") {
					return this.pushStack(jQuery(selector).filter(function () {
						for (i = 0; i < len; i++) {
							if (jQuery.contains(self[i], this)) {
								return true;
							}
						}
					}));
				}

				ret = this.pushStack([]);

				for (i = 0; i < len; i++) {
					jQuery.find(selector, self[i], ret);
				}

				return len > 1 ? jQuery.uniqueSort(ret) : ret;
			},
			filter: function filter(selector) {
				return this.pushStack(winnow(this, selector || [], false));
			},
			not: function not(selector) {
				return this.pushStack(winnow(this, selector || [], true));
			},
			is: function is(selector) {
				return !!winnow(this,

				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
			}
		});

		// Initialize a jQuery object


		// A central reference to the root jQuery(document)
		var rootjQuery,


		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
		// Strict HTML recognition (trac-11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
		    init = jQuery.fn.init = function (selector, context, root) {
			var match, elem;

			// HANDLE: $(""), $(null), $(undefined), $(false)
			if (!selector) {
				return this;
			}

			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;

			// Handle HTML strings
			if (typeof selector === "string") {
				if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {

					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [null, selector, null];
				} else {
					match = rquickExpr.exec(selector);
				}

				// Match html or make sure no context is specified for #id
				if (match && (match[1] || !context)) {

					// HANDLE: $(html) -> $(array)
					if (match[1]) {
						context = context instanceof jQuery ? context[0] : context;

						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

						// HANDLE: $(html, props)
						if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
							for (match in context) {

								// Properties of context are called as methods if possible
								if (isFunction(this[match])) {
									this[match](context[match]);

									// ...and otherwise set as attributes
								} else {
									this.attr(match, context[match]);
								}
							}
						}

						return this;

						// HANDLE: $(#id)
					} else {
						elem = document.getElementById(match[2]);

						if (elem) {

							// Inject the element directly into the jQuery object
							this[0] = elem;
							this.length = 1;
						}
						return this;
					}

					// HANDLE: $(expr, $(...))
				} else if (!context || context.jquery) {
					return (context || root).find(selector);

					// HANDLE: $(expr, context)
					// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor(context).find(selector);
				}

				// HANDLE: $(DOMElement)
			} else if (selector.nodeType) {
				this[0] = selector;
				this.length = 1;
				return this;

				// HANDLE: $(function)
				// Shortcut for document ready
			} else if (isFunction(selector)) {
				return root.ready !== undefined ? root.ready(selector) :

				// Execute immediately if ready is not present
				selector(jQuery);
			}

			return jQuery.makeArray(selector, this);
		};

		// Give the init function the jQuery prototype for later instantiation
		init.prototype = jQuery.fn;

		// Initialize central reference
		rootjQuery = jQuery(document);

		var rparentsprev = /^(?:parents|prev(?:Until|All))/,


		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};

		jQuery.fn.extend({
			has: function has(target) {
				var targets = jQuery(target, this),
				    l = targets.length;

				return this.filter(function () {
					var i = 0;
					for (; i < l; i++) {
						if (jQuery.contains(this, targets[i])) {
							return true;
						}
					}
				});
			},

			closest: function closest(selectors, context) {
				var cur,
				    i = 0,
				    l = this.length,
				    matched = [],
				    targets = typeof selectors !== "string" && jQuery(selectors);

				// Positional selectors never match, since there's no _selection_ context
				if (!rneedsContext.test(selectors)) {
					for (; i < l; i++) {
						for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {

							// Always skip document fragments
							if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :

							// Don't pass non-elements to jQuery#find
							cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {

								matched.push(cur);
								break;
							}
						}
					}
				}

				return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
			},

			// Determine the position of an element within the set
			index: function index(elem) {

				// No argument, return index in parent
				if (!elem) {
					return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
				}

				// Index in selector
				if (typeof elem === "string") {
					return indexOf.call(jQuery(elem), this[0]);
				}

				// Locate the position of the desired element
				return indexOf.call(this,

				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[0] : elem);
			},

			add: function add(selector, context) {
				return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
			},

			addBack: function addBack(selector) {
				return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
			}
		});

		function sibling(cur, dir) {
			while ((cur = cur[dir]) && cur.nodeType !== 1) {}
			return cur;
		}

		jQuery.each({
			parent: function parent(elem) {
				var parent = elem.parentNode;
				return parent && parent.nodeType !== 11 ? parent : null;
			},
			parents: function parents(elem) {
				return dir(elem, "parentNode");
			},
			parentsUntil: function parentsUntil(elem, _i, until) {
				return dir(elem, "parentNode", until);
			},
			next: function next(elem) {
				return sibling(elem, "nextSibling");
			},
			prev: function prev(elem) {
				return sibling(elem, "previousSibling");
			},
			nextAll: function nextAll(elem) {
				return dir(elem, "nextSibling");
			},
			prevAll: function prevAll(elem) {
				return dir(elem, "previousSibling");
			},
			nextUntil: function nextUntil(elem, _i, until) {
				return dir(elem, "nextSibling", until);
			},
			prevUntil: function prevUntil(elem, _i, until) {
				return dir(elem, "previousSibling", until);
			},
			siblings: function siblings(elem) {
				return _siblings((elem.parentNode || {}).firstChild, elem);
			},
			children: function children(elem) {
				return _siblings(elem.firstChild);
			},
			contents: function contents(elem) {
				if (elem.contentDocument != null &&

				// Support: IE 11+
				// <object> elements with no `data` attribute has an object
				// `contentDocument` with a `null` prototype.
				getProto(elem.contentDocument)) {

					return elem.contentDocument;
				}

				// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
				// Treat the template element as a regular one in browsers that
				// don't support it.
				if (nodeName(elem, "template")) {
					elem = elem.content || elem;
				}

				return jQuery.merge([], elem.childNodes);
			}
		}, function (name, fn) {
			jQuery.fn[name] = function (until, selector) {
				var matched = jQuery.map(this, fn, until);

				if (name.slice(-5) !== "Until") {
					selector = until;
				}

				if (selector && typeof selector === "string") {
					matched = jQuery.filter(selector, matched);
				}

				if (this.length > 1) {

					// Remove duplicates
					if (!guaranteedUnique[name]) {
						jQuery.uniqueSort(matched);
					}

					// Reverse order for parents* and prev-derivatives
					if (rparentsprev.test(name)) {
						matched.reverse();
					}
				}

				return this.pushStack(matched);
			};
		});
		var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

		// Convert String-formatted options into Object-formatted ones
		function createOptions(options) {
			var object = {};
			jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
				object[flag] = true;
			});
			return object;
		}

		/*
	  * Create a callback list using the following parameters:
	  *
	  *	options: an optional list of space-separated options that will change how
	  *			the callback list behaves or a more traditional option object
	  *
	  * By default a callback list will act like an event callback list and can be
	  * "fired" multiple times.
	  *
	  * Possible options:
	  *
	  *	once:			will ensure the callback list can only be fired once (like a Deferred)
	  *
	  *	memory:			will keep track of previous values and will call any callback added
	  *					after the list has been fired right away with the latest "memorized"
	  *					values (like a Deferred)
	  *
	  *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	  *
	  *	stopOnFalse:	interrupt callings when a callback returns false
	  *
	  */
		jQuery.Callbacks = function (options) {

			// Convert options from String-formatted to Object-formatted if needed
			// (we check in cache first)
			options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);

			var // Flag to know if list is currently firing
			firing,


			// Last fire value for non-forgettable lists
			memory,


			// Flag to know if list was already fired
			_fired,


			// Flag to prevent firing
			_locked,


			// Actual callback list
			list = [],


			// Queue of execution data for repeatable lists
			queue = [],


			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,


			// Fire callbacks
			fire = function fire() {

				// Enforce single-firing
				_locked = _locked || options.once;

				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				_fired = firing = true;
				for (; queue.length; firingIndex = -1) {
					memory = queue.shift();
					while (++firingIndex < list.length) {

						// Run callback and check for early termination
						if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {

							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}

				// Forget the data if we're done with it
				if (!options.memory) {
					memory = false;
				}

				firing = false;

				// Clean up if we're done firing for good
				if (_locked) {

					// Keep an empty list if we have data for future add calls
					if (memory) {
						list = [];

						// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},


			// Actual Callbacks object
			self = {

				// Add a callback or a collection of callbacks to the list
				add: function add() {
					if (list) {

						// If we have memory from a past run, we should fire after adding
						if (memory && !firing) {
							firingIndex = list.length - 1;
							queue.push(memory);
						}

						(function add(args) {
							jQuery.each(args, function (_, arg) {
								if (isFunction(arg)) {
									if (!options.unique || !self.has(arg)) {
										list.push(arg);
									}
								} else if (arg && arg.length && toType(arg) !== "string") {

									// Inspect recursively
									add(arg);
								}
							});
						})(arguments);

						if (memory && !firing) {
							fire();
						}
					}
					return this;
				},

				// Remove a callback from the list
				remove: function remove() {
					jQuery.each(arguments, function (_, arg) {
						var index;
						while ((index = jQuery.inArray(arg, list, index)) > -1) {
							list.splice(index, 1);

							// Handle firing indexes
							if (index <= firingIndex) {
								firingIndex--;
							}
						}
					});
					return this;
				},

				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function has(fn) {
					return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
				},

				// Remove all callbacks from the list
				empty: function empty() {
					if (list) {
						list = [];
					}
					return this;
				},

				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function disable() {
					_locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function disabled() {
					return !list;
				},

				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function lock() {
					_locked = queue = [];
					if (!memory && !firing) {
						list = memory = "";
					}
					return this;
				},
				locked: function locked() {
					return !!_locked;
				},

				// Call all callbacks with the given context and arguments
				fireWith: function fireWith(context, args) {
					if (!_locked) {
						args = args || [];
						args = [context, args.slice ? args.slice() : args];
						queue.push(args);
						if (!firing) {
							fire();
						}
					}
					return this;
				},

				// Call all the callbacks with the given arguments
				fire: function fire() {
					self.fireWith(this, arguments);
					return this;
				},

				// To know if the callbacks have already been called at least once
				fired: function fired() {
					return !!_fired;
				}
			};

			return self;
		};

		function Identity(v) {
			return v;
		}
		function Thrower(ex) {
			throw ex;
		}

		function adoptValue(value, resolve, reject, noValue) {
			var method;

			try {

				// Check for promise aspect first to privilege synchronous behavior
				if (value && isFunction(method = value.promise)) {
					method.call(value).done(resolve).fail(reject);

					// Other thenables
				} else if (value && isFunction(method = value.then)) {
					method.call(value, resolve, reject);

					// Other non-thenables
				} else {

					// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
					// * false: [ value ].slice( 0 ) => resolve( value )
					// * true: [ value ].slice( 1 ) => resolve()
					resolve.apply(undefined, [value].slice(noValue));
				}

				// For Promises/A+, convert exceptions into rejections
				// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
				// Deferred#then to conditionally suppress rejection.
			} catch (value) {

				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				reject.apply(undefined, [value]);
			}
		}

		jQuery.extend({

			Deferred: function Deferred(func) {
				var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
				    _state = "pending",
				    _promise = {
					state: function state() {
						return _state;
					},
					always: function always() {
						deferred.done(arguments).fail(arguments);
						return this;
					},
					"catch": function _catch(fn) {
						return _promise.then(null, fn);
					},

					// Keep pipe for back-compat
					pipe: function pipe() /* fnDone, fnFail, fnProgress */{
						var fns = arguments;

						return jQuery.Deferred(function (newDefer) {
							jQuery.each(tuples, function (_i, tuple) {

								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[tuple[1]](function () {
									var returned = fn && fn.apply(this, arguments);
									if (returned && isFunction(returned.promise)) {
										returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
									} else {
										newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
									}
								});
							});
							fns = null;
						}).promise();
					},
					then: function then(onFulfilled, onRejected, onProgress) {
						var maxDepth = 0;
						function resolve(depth, deferred, handler, special) {
							return function () {
								var that = this,
								    args = arguments,
								    mightThrow = function mightThrow() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if (depth < maxDepth) {
										return;
									}

									returned = handler.apply(that, args);

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if (returned === deferred.promise()) {
										throw new TypeError("Thenable self-resolution");
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned && (

									// Support: Promises/A+ section 2.3.4
									// https://promisesaplus.com/#point-64
									// Only check objects and functions for thenability
									(typeof returned === "undefined" ? "undefined" : _typeof(returned)) === "object" || typeof returned === "function") && returned.then;

									// Handle a returned thenable
									if (isFunction(then)) {

										// Special processors (notify) just wait for resolution
										if (special) {
											then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

											// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
										}

										// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if (handler !== Identity) {
											that = undefined;
											args = [returned];
										}

										// Process the value(s)
										// Default process is resolve
										(special || deferred.resolveWith)(that, args);
									}
								},


								// Only normal processors (resolve) catch and reject exceptions
								process = special ? mightThrow : function () {
									try {
										mightThrow();
									} catch (e) {

										if (jQuery.Deferred.exceptionHook) {
											jQuery.Deferred.exceptionHook(e, process.error);
										}

										// Support: Promises/A+ section 2.3.3.3.4.1
										// https://promisesaplus.com/#point-61
										// Ignore post-resolution exceptions
										if (depth + 1 >= maxDepth) {

											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if (handler !== Thrower) {
												that = undefined;
												args = [e];
											}

											deferred.rejectWith(that, args);
										}
									}
								};

								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if (depth) {
									process();
								} else {

									// Call an optional hook to record the error, in case of exception
									// since it's otherwise lost when execution goes async
									if (jQuery.Deferred.getErrorHook) {
										process.error = jQuery.Deferred.getErrorHook();

										// The deprecated alias of the above. While the name suggests
										// returning the stack, not an error instance, jQuery just passes
										// it directly to `console.warn` so both will work; an instance
										// just better cooperates with source maps.
									} else if (jQuery.Deferred.getStackHook) {
										process.error = jQuery.Deferred.getStackHook();
									}
									window.setTimeout(process);
								}
							};
						}

						return jQuery.Deferred(function (newDefer) {

							// progress_handlers.add( ... )
							tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

							// fulfilled_handlers.add( ... )
							tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

							// rejected_handlers.add( ... )
							tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
						}).promise();
					},

					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function promise(obj) {
						return obj != null ? jQuery.extend(obj, _promise) : _promise;
					}
				},
				    deferred = {};

				// Add list-specific methods
				jQuery.each(tuples, function (i, tuple) {
					var list = tuple[2],
					    stateString = tuple[5];

					// promise.progress = list.add
					// promise.done = list.add
					// promise.fail = list.add
					_promise[tuple[1]] = list.add;

					// Handle state
					if (stateString) {
						list.add(function () {

							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							_state = stateString;
						},

						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[3 - i][2].disable,

						// rejected_handlers.disable
						// fulfilled_handlers.disable
						tuples[3 - i][3].disable,

						// progress_callbacks.lock
						tuples[0][2].lock,

						// progress_handlers.lock
						tuples[0][3].lock);
					}

					// progress_handlers.fire
					// fulfilled_handlers.fire
					// rejected_handlers.fire
					list.add(tuple[3].fire);

					// deferred.notify = function() { deferred.notifyWith(...) }
					// deferred.resolve = function() { deferred.resolveWith(...) }
					// deferred.reject = function() { deferred.rejectWith(...) }
					deferred[tuple[0]] = function () {
						deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
						return this;
					};

					// deferred.notifyWith = list.fireWith
					// deferred.resolveWith = list.fireWith
					// deferred.rejectWith = list.fireWith
					deferred[tuple[0] + "With"] = list.fireWith;
				});

				// Make the deferred a promise
				_promise.promise(deferred);

				// Call given func if any
				if (func) {
					func.call(deferred, deferred);
				}

				// All done!
				return deferred;
			},

			// Deferred helper
			when: function when(singleValue) {
				var

				// count of uncompleted subordinates
				remaining = arguments.length,


				// count of unprocessed arguments
				i = remaining,


				// subordinate fulfillment data
				resolveContexts = Array(i),
				    resolveValues = _slice.call(arguments),


				// the primary Deferred
				primary = jQuery.Deferred(),


				// subordinate callback factory
				updateFunc = function updateFunc(i) {
					return function (value) {
						resolveContexts[i] = this;
						resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
						if (! --remaining) {
							primary.resolveWith(resolveContexts, resolveValues);
						}
					};
				};

				// Single- and empty arguments are adopted like Promise.resolve
				if (remaining <= 1) {
					adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);

					// Use .then() to unwrap secondary thenables (cf. gh-3000)
					if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {

						return primary.then();
					}
				}

				// Multiple arguments are aggregated like Promise.all array elements
				while (i--) {
					adoptValue(resolveValues[i], updateFunc(i), primary.reject);
				}

				return primary.promise();
			}
		});

		// These usually indicate a programmer mistake during development,
		// warn about them ASAP rather than swallowing them by default.
		var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

		// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
		// captured before the async barrier to get the original error cause
		// which may otherwise be hidden.
		jQuery.Deferred.exceptionHook = function (error, asyncError) {

			// Support: IE 8 - 9 only
			// Console exists when dev tools are open, which can happen at any time
			if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
				window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
			}
		};

		jQuery.readyException = function (error) {
			window.setTimeout(function () {
				throw error;
			});
		};

		// The deferred used on DOM ready
		var readyList = jQuery.Deferred();

		jQuery.fn.ready = function (fn) {

			readyList.then(fn)

			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch(function (error) {
				jQuery.readyException(error);
			});

			return this;
		};

		jQuery.extend({

			// Is the DOM ready to be used? Set to true once it occurs.
			isReady: false,

			// A counter to track how many items to wait for before
			// the ready event fires. See trac-6781
			readyWait: 1,

			// Handle when the DOM is ready
			ready: function ready(wait) {

				// Abort if there are pending holds or we're already ready
				if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
					return;
				}

				// Remember that the DOM is ready
				jQuery.isReady = true;

				// If a normal DOM Ready event fired, decrement, and wait if need be
				if (wait !== true && --jQuery.readyWait > 0) {
					return;
				}

				// If there are functions bound, to execute
				readyList.resolveWith(document, [jQuery]);
			}
		});

		jQuery.ready.then = readyList.then;

		// The ready event handler and self cleanup method
		function completed() {
			document.removeEventListener("DOMContentLoaded", completed);
			window.removeEventListener("load", completed);
			jQuery.ready();
		}

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE <=9 - 10 only
		// Older IE sometimes signals "interactive" too soon
		if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout(jQuery.ready);
		} else {

			// Use the handy event callback
			document.addEventListener("DOMContentLoaded", completed);

			// A fallback to window.onload, that will always work
			window.addEventListener("load", completed);
		}

		// Multifunctional method to get and set values of a collection
		// The value/s can optionally be executed if it's a function
		var access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
			var i = 0,
			    len = elems.length,
			    bulk = key == null;

			// Sets many values
			if (toType(key) === "object") {
				chainable = true;
				for (i in key) {
					access(elems, fn, i, key[i], true, emptyGet, raw);
				}

				// Sets one value
			} else if (value !== undefined) {
				chainable = true;

				if (!isFunction(value)) {
					raw = true;
				}

				if (bulk) {

					// Bulk operations run against the entire set
					if (raw) {
						fn.call(elems, value);
						fn = null;

						// ...except when executing function values
					} else {
						bulk = fn;
						fn = function fn(elem, _key, value) {
							return bulk.call(jQuery(elem), value);
						};
					}
				}

				if (fn) {
					for (; i < len; i++) {
						fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
					}
				}
			}

			if (chainable) {
				return elems;
			}

			// Gets
			if (bulk) {
				return fn.call(elems);
			}

			return len ? fn(elems[0], key) : emptyGet;
		};

		// Matches dashed string for camelizing
		var rmsPrefix = /^-ms-/,
		    rdashAlpha = /-([a-z])/g;

		// Used by camelCase as callback to replace()
		function fcamelCase(_all, letter) {
			return letter.toUpperCase();
		}

		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 15
		// Microsoft forgot to hump their vendor prefix (trac-9572)
		function camelCase(string) {
			return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
		}
		var acceptData = function acceptData(owner) {

			// Accepts only:
			//  - Node
			//    - Node.ELEMENT_NODE
			//    - Node.DOCUMENT_NODE
			//  - Object
			//    - Any
			return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
		};

		function Data() {
			this.expando = jQuery.expando + Data.uid++;
		}

		Data.uid = 1;

		Data.prototype = {

			cache: function cache(owner) {

				// Check if the owner object already has a cache
				var value = owner[this.expando];

				// If not, create one
				if (!value) {
					value = {};

					// We can accept data for non-element nodes in modern browsers,
					// but we should not, see trac-8335.
					// Always return an empty object.
					if (acceptData(owner)) {

						// If it is a node unlikely to be stringify-ed or looped over
						// use plain assignment
						if (owner.nodeType) {
							owner[this.expando] = value;

							// Otherwise secure it in a non-enumerable property
							// configurable must be true to allow the property to be
							// deleted when data is removed
						} else {
							Object.defineProperty(owner, this.expando, {
								value: value,
								configurable: true
							});
						}
					}
				}

				return value;
			},
			set: function set(owner, data, value) {
				var prop,
				    cache = this.cache(owner);

				// Handle: [ owner, key, value ] args
				// Always use camelCase key (gh-2257)
				if (typeof data === "string") {
					cache[camelCase(data)] = value;

					// Handle: [ owner, { properties } ] args
				} else {

					// Copy the properties one-by-one to the cache object
					for (prop in data) {
						cache[camelCase(prop)] = data[prop];
					}
				}
				return cache;
			},
			get: function get(owner, key) {
				return key === undefined ? this.cache(owner) :

				// Always use camelCase key (gh-2257)
				owner[this.expando] && owner[this.expando][camelCase(key)];
			},
			access: function access(owner, key, value) {

				// In cases where either:
				//
				//   1. No key was specified
				//   2. A string key was specified, but no value provided
				//
				// Take the "read" path and allow the get method to determine
				// which value to return, respectively either:
				//
				//   1. The entire cache object
				//   2. The data stored at the key
				//
				if (key === undefined || key && typeof key === "string" && value === undefined) {

					return this.get(owner, key);
				}

				// When the key is not a string, or both a key and value
				// are specified, set or extend (existing objects) with either:
				//
				//   1. An object of properties
				//   2. A key and value
				//
				this.set(owner, key, value);

				// Since the "set" path can have two possible entry points
				// return the expected data based on which path was taken[*]
				return value !== undefined ? value : key;
			},
			remove: function remove(owner, key) {
				var i,
				    cache = owner[this.expando];

				if (cache === undefined) {
					return;
				}

				if (key !== undefined) {

					// Support array or space separated string of keys
					if (Array.isArray(key)) {

						// If key is an array of keys...
						// We always set camelCase keys, so remove that.
						key = key.map(camelCase);
					} else {
						key = camelCase(key);

						// If a key with the spaces exists, use it.
						// Otherwise, create an array by matching non-whitespace
						key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
					}

					i = key.length;

					while (i--) {
						delete cache[key[i]];
					}
				}

				// Remove the expando if there's no more data
				if (key === undefined || jQuery.isEmptyObject(cache)) {

					// Support: Chrome <=35 - 45
					// Webkit & Blink performance suffers when deleting properties
					// from DOM nodes, so set to undefined instead
					// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
					if (owner.nodeType) {
						owner[this.expando] = undefined;
					} else {
						delete owner[this.expando];
					}
				}
			},
			hasData: function hasData(owner) {
				var cache = owner[this.expando];
				return cache !== undefined && !jQuery.isEmptyObject(cache);
			}
		};
		var dataPriv = new Data();

		var dataUser = new Data();

		//	Implementation Summary
		//
		//	1. Enforce API surface and semantic compatibility with 1.9.x branch
		//	2. Improve the module's maintainability by reducing the storage
		//		paths to a single mechanism.
		//	3. Use the same single mechanism to support "private" and "user" data.
		//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
		//	5. Avoid exposing implementation details on user objects (eg. expando properties)
		//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

		var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		    rmultiDash = /[A-Z]/g;

		function getData(data) {
			if (data === "true") {
				return true;
			}

			if (data === "false") {
				return false;
			}

			if (data === "null") {
				return null;
			}

			// Only convert to a number if it doesn't change the string
			if (data === +data + "") {
				return +data;
			}

			if (rbrace.test(data)) {
				return JSON.parse(data);
			}

			return data;
		}

		function dataAttr(elem, key, data) {
			var name;

			// If nothing was found internally, try to fetch any
			// data from the HTML5 data-* attribute
			if (data === undefined && elem.nodeType === 1) {
				name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
				data = elem.getAttribute(name);

				if (typeof data === "string") {
					try {
						data = getData(data);
					} catch (e) {}

					// Make sure we set the data so it isn't changed later
					dataUser.set(elem, key, data);
				} else {
					data = undefined;
				}
			}
			return data;
		}

		jQuery.extend({
			hasData: function hasData(elem) {
				return dataUser.hasData(elem) || dataPriv.hasData(elem);
			},

			data: function data(elem, name, _data) {
				return dataUser.access(elem, name, _data);
			},

			removeData: function removeData(elem, name) {
				dataUser.remove(elem, name);
			},

			// TODO: Now that all calls to _data and _removeData have been replaced
			// with direct calls to dataPriv methods, these can be deprecated.
			_data: function _data(elem, name, data) {
				return dataPriv.access(elem, name, data);
			},

			_removeData: function _removeData(elem, name) {
				dataPriv.remove(elem, name);
			}
		});

		jQuery.fn.extend({
			data: function data(key, value) {
				var i,
				    name,
				    data,
				    elem = this[0],
				    attrs = elem && elem.attributes;

				// Gets all values
				if (key === undefined) {
					if (this.length) {
						data = dataUser.get(elem);

						if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
							i = attrs.length;
							while (i--) {

								// Support: IE 11 only
								// The attrs elements can be null (trac-14894)
								if (attrs[i]) {
									name = attrs[i].name;
									if (name.indexOf("data-") === 0) {
										name = camelCase(name.slice(5));
										dataAttr(elem, name, data[name]);
									}
								}
							}
							dataPriv.set(elem, "hasDataAttrs", true);
						}
					}

					return data;
				}

				// Sets multiple values
				if ((typeof key === "undefined" ? "undefined" : _typeof(key)) === "object") {
					return this.each(function () {
						dataUser.set(this, key);
					});
				}

				return access(this, function (value) {
					var data;

					// The calling jQuery object (element matches) is not empty
					// (and therefore has an element appears at this[ 0 ]) and the
					// `value` parameter was not undefined. An empty jQuery object
					// will result in `undefined` for elem = this[ 0 ] which will
					// throw an exception if an attempt to read a data cache is made.
					if (elem && value === undefined) {

						// Attempt to get data from the cache
						// The key will always be camelCased in Data
						data = dataUser.get(elem, key);
						if (data !== undefined) {
							return data;
						}

						// Attempt to "discover" the data in
						// HTML5 custom data-* attrs
						data = dataAttr(elem, key);
						if (data !== undefined) {
							return data;
						}

						// We tried really hard, but the data doesn't exist.
						return;
					}

					// Set the data...
					this.each(function () {

						// We always store the camelCased key
						dataUser.set(this, key, value);
					});
				}, null, value, arguments.length > 1, null, true);
			},

			removeData: function removeData(key) {
				return this.each(function () {
					dataUser.remove(this, key);
				});
			}
		});

		jQuery.extend({
			queue: function queue(elem, type, data) {
				var queue;

				if (elem) {
					type = (type || "fx") + "queue";
					queue = dataPriv.get(elem, type);

					// Speed up dequeue by getting out quickly if this is just a lookup
					if (data) {
						if (!queue || Array.isArray(data)) {
							queue = dataPriv.access(elem, type, jQuery.makeArray(data));
						} else {
							queue.push(data);
						}
					}
					return queue || [];
				}
			},

			dequeue: function dequeue(elem, type) {
				type = type || "fx";

				var queue = jQuery.queue(elem, type),
				    startLength = queue.length,
				    fn = queue.shift(),
				    hooks = jQuery._queueHooks(elem, type),
				    next = function next() {
					jQuery.dequeue(elem, type);
				};

				// If the fx queue is dequeued, always remove the progress sentinel
				if (fn === "inprogress") {
					fn = queue.shift();
					startLength--;
				}

				if (fn) {

					// Add a progress sentinel to prevent the fx queue from being
					// automatically dequeued
					if (type === "fx") {
						queue.unshift("inprogress");
					}

					// Clear up the last queue stop function
					delete hooks.stop;
					fn.call(elem, next, hooks);
				}

				if (!startLength && hooks) {
					hooks.empty.fire();
				}
			},

			// Not public - generate a queueHooks object, or return the current one
			_queueHooks: function _queueHooks(elem, type) {
				var key = type + "queueHooks";
				return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
					empty: jQuery.Callbacks("once memory").add(function () {
						dataPriv.remove(elem, [type + "queue", key]);
					})
				});
			}
		});

		jQuery.fn.extend({
			queue: function queue(type, data) {
				var setter = 2;

				if (typeof type !== "string") {
					data = type;
					type = "fx";
					setter--;
				}

				if (arguments.length < setter) {
					return jQuery.queue(this[0], type);
				}

				return data === undefined ? this : this.each(function () {
					var queue = jQuery.queue(this, type, data);

					// Ensure a hooks for this queue
					jQuery._queueHooks(this, type);

					if (type === "fx" && queue[0] !== "inprogress") {
						jQuery.dequeue(this, type);
					}
				});
			},
			dequeue: function dequeue(type) {
				return this.each(function () {
					jQuery.dequeue(this, type);
				});
			},
			clearQueue: function clearQueue(type) {
				return this.queue(type || "fx", []);
			},

			// Get a promise resolved when queues of a certain type
			// are emptied (fx is the type by default)
			promise: function promise(type, obj) {
				var tmp,
				    count = 1,
				    defer = jQuery.Deferred(),
				    elements = this,
				    i = this.length,
				    resolve = function resolve() {
					if (! --count) {
						defer.resolveWith(elements, [elements]);
					}
				};

				if (typeof type !== "string") {
					obj = type;
					type = undefined;
				}
				type = type || "fx";

				while (i--) {
					tmp = dataPriv.get(elements[i], type + "queueHooks");
					if (tmp && tmp.empty) {
						count++;
						tmp.empty.add(resolve);
					}
				}
				resolve();
				return defer.promise(obj);
			}
		});
		var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

		var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");

		var cssExpand = ["Top", "Right", "Bottom", "Left"];

		var documentElement = document.documentElement;

		var isAttached = function isAttached(elem) {
			return jQuery.contains(elem.ownerDocument, elem);
		},
		    composed = { composed: true };

		// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
		// Check attachment across shadow DOM boundaries when possible (gh-3504)
		// Support: iOS 10.0-10.2 only
		// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
		// leading to errors. We need to check for `getRootNode`.
		if (documentElement.getRootNode) {
			isAttached = function isAttached(elem) {
				return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
			};
		}
		var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {

			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;

			// Inline style trumps all
			return elem.style.display === "none" || elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached(elem) && jQuery.css(elem, "display") === "none";
		};

		function adjustCSS(elem, prop, valueParts, tween) {
			var adjusted,
			    scale,
			    maxIterations = 20,
			    currentValue = tween ? function () {
				return tween.cur();
			} : function () {
				return jQuery.css(elem, prop, "");
			},
			    initial = currentValue(),
			    unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),


			// Starting value computation is required for potential unit mismatches
			initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));

			if (initialInUnit && initialInUnit[3] !== unit) {

				// Support: Firefox <=54
				// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
				initial = initial / 2;

				// Trust units reported by jQuery.css
				unit = unit || initialInUnit[3];

				// Iteratively approximate from a nonzero starting point
				initialInUnit = +initial || 1;

				while (maxIterations--) {

					// Evaluate and update our best guess (doubling guesses that zero out).
					// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
					jQuery.style(elem, prop, initialInUnit + unit);
					if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
						maxIterations = 0;
					}
					initialInUnit = initialInUnit / scale;
				}

				initialInUnit = initialInUnit * 2;
				jQuery.style(elem, prop, initialInUnit + unit);

				// Make sure we update the tween properties later on
				valueParts = valueParts || [];
			}

			if (valueParts) {
				initialInUnit = +initialInUnit || +initial || 0;

				// Apply relative offset (+=/-=) if specified
				adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
				if (tween) {
					tween.unit = unit;
					tween.start = initialInUnit;
					tween.end = adjusted;
				}
			}
			return adjusted;
		}

		var defaultDisplayMap = {};

		function getDefaultDisplay(elem) {
			var temp,
			    doc = elem.ownerDocument,
			    nodeName = elem.nodeName,
			    display = defaultDisplayMap[nodeName];

			if (display) {
				return display;
			}

			temp = doc.body.appendChild(doc.createElement(nodeName));
			display = jQuery.css(temp, "display");

			temp.parentNode.removeChild(temp);

			if (display === "none") {
				display = "block";
			}
			defaultDisplayMap[nodeName] = display;

			return display;
		}

		function showHide(elements, show) {
			var display,
			    elem,
			    values = [],
			    index = 0,
			    length = elements.length;

			// Determine new display value for elements that need to change
			for (; index < length; index++) {
				elem = elements[index];
				if (!elem.style) {
					continue;
				}

				display = elem.style.display;
				if (show) {

					// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
					// check is required in this first loop unless we have a nonempty display value (either
					// inline or about-to-be-restored)
					if (display === "none") {
						values[index] = dataPriv.get(elem, "display") || null;
						if (!values[index]) {
							elem.style.display = "";
						}
					}
					if (elem.style.display === "" && isHiddenWithinTree(elem)) {
						values[index] = getDefaultDisplay(elem);
					}
				} else {
					if (display !== "none") {
						values[index] = "none";

						// Remember what we're overwriting
						dataPriv.set(elem, "display", display);
					}
				}
			}

			// Set the display of the elements in a second loop to avoid constant reflow
			for (index = 0; index < length; index++) {
				if (values[index] != null) {
					elements[index].style.display = values[index];
				}
			}

			return elements;
		}

		jQuery.fn.extend({
			show: function show() {
				return showHide(this, true);
			},
			hide: function hide() {
				return showHide(this);
			},
			toggle: function toggle(state) {
				if (typeof state === "boolean") {
					return state ? this.show() : this.hide();
				}

				return this.each(function () {
					if (isHiddenWithinTree(this)) {
						jQuery(this).show();
					} else {
						jQuery(this).hide();
					}
				});
			}
		});
		var rcheckableType = /^(?:checkbox|radio)$/i;

		var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

		var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

		(function () {
			var fragment = document.createDocumentFragment(),
			    div = fragment.appendChild(document.createElement("div")),
			    input = document.createElement("input");

			// Support: Android 4.0 - 4.3 only
			// Check state lost if the name is set (trac-11217)
			// Support: Windows Web Apps (WWA)
			// `name` and `type` must use .setAttribute for WWA (trac-14901)
			input.setAttribute("type", "radio");
			input.setAttribute("checked", "checked");
			input.setAttribute("name", "t");

			div.appendChild(input);

			// Support: Android <=4.1 only
			// Older WebKit doesn't clone checked state correctly in fragments
			support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

			// Support: IE <=11 only
			// Make sure textarea (and checkbox) defaultValue is properly cloned
			div.innerHTML = "<textarea>x</textarea>";
			support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

			// Support: IE <=9 only
			// IE <=9 replaces <option> tags with their contents when inserted outside of
			// the select element.
			div.innerHTML = "<option></option>";
			support.option = !!div.lastChild;
		})();

		// We have to close these tags to support XHTML (trac-13200)
		var wrapMap = {

			// XHTML parsers do not magically insert elements in the
			// same way that tag soup parsers do. So we cannot shorten
			// this by omitting <tbody> or other required elements.
			thead: [1, "<table>", "</table>"],
			col: [2, "<table><colgroup>", "</colgroup></table>"],
			tr: [2, "<table><tbody>", "</tbody></table>"],
			td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

			_default: [0, "", ""]
		};

		wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
		wrapMap.th = wrapMap.td;

		// Support: IE <=9 only
		if (!support.option) {
			wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
		}

		function getAll(context, tag) {

			// Support: IE <=9 - 11 only
			// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
			var ret;

			if (typeof context.getElementsByTagName !== "undefined") {
				ret = context.getElementsByTagName(tag || "*");
			} else if (typeof context.querySelectorAll !== "undefined") {
				ret = context.querySelectorAll(tag || "*");
			} else {
				ret = [];
			}

			if (tag === undefined || tag && nodeName(context, tag)) {
				return jQuery.merge([context], ret);
			}

			return ret;
		}

		// Mark scripts as having already been evaluated
		function setGlobalEval(elems, refElements) {
			var i = 0,
			    l = elems.length;

			for (; i < l; i++) {
				dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
			}
		}

		var rhtml = /<|&#?\w+;/;

		function buildFragment(elems, context, scripts, selection, ignored) {
			var elem,
			    tmp,
			    tag,
			    wrap,
			    attached,
			    j,
			    fragment = context.createDocumentFragment(),
			    nodes = [],
			    i = 0,
			    l = elems.length;

			for (; i < l; i++) {
				elem = elems[i];

				if (elem || elem === 0) {

					// Add nodes directly
					if (toType(elem) === "object") {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

						// Convert non-html into a text node
					} else if (!rhtml.test(elem)) {
						nodes.push(context.createTextNode(elem));

						// Convert html into DOM nodes
					} else {
						tmp = tmp || fragment.appendChild(context.createElement("div"));

						// Deserialize a standard representation
						tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
						wrap = wrapMap[tag] || wrapMap._default;
						tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

						// Descend through wrappers to the right content
						j = wrap[0];
						while (j--) {
							tmp = tmp.lastChild;
						}

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge(nodes, tmp.childNodes);

						// Remember the top-level container
						tmp = fragment.firstChild;

						// Ensure the created nodes are orphaned (trac-12392)
						tmp.textContent = "";
					}
				}
			}

			// Remove wrapper from fragment
			fragment.textContent = "";

			i = 0;
			while (elem = nodes[i++]) {

				// Skip elements already in the context collection (trac-4087)
				if (selection && jQuery.inArray(elem, selection) > -1) {
					if (ignored) {
						ignored.push(elem);
					}
					continue;
				}

				attached = isAttached(elem);

				// Append to fragment
				tmp = getAll(fragment.appendChild(elem), "script");

				// Preserve script evaluation history
				if (attached) {
					setGlobalEval(tmp);
				}

				// Capture executables
				if (scripts) {
					j = 0;
					while (elem = tmp[j++]) {
						if (rscriptType.test(elem.type || "")) {
							scripts.push(elem);
						}
					}
				}
			}

			return fragment;
		}

		var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

		function returnTrue() {
			return true;
		}

		function returnFalse() {
			return false;
		}

		function _on(elem, types, selector, data, fn, one) {
			var origFn, type;

			// Types can be a map of types/handlers
			if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

				// ( types-Object, selector, data )
				if (typeof selector !== "string") {

					// ( types-Object, data )
					data = data || selector;
					selector = undefined;
				}
				for (type in types) {
					_on(elem, type, selector, data, types[type], one);
				}
				return elem;
			}

			if (data == null && fn == null) {

				// ( types, fn )
				fn = selector;
				data = selector = undefined;
			} else if (fn == null) {
				if (typeof selector === "string") {

					// ( types, selector, fn )
					fn = data;
					data = undefined;
				} else {

					// ( types, data, fn )
					fn = data;
					data = selector;
					selector = undefined;
				}
			}
			if (fn === false) {
				fn = returnFalse;
			} else if (!fn) {
				return elem;
			}

			if (one === 1) {
				origFn = fn;
				fn = function fn(event) {

					// Can use an empty set, since event contains the info
					jQuery().off(event);
					return origFn.apply(this, arguments);
				};

				// Use same guid so caller can remove using origFn
				fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
			}
			return elem.each(function () {
				jQuery.event.add(this, types, fn, data, selector);
			});
		}

		/*
	  * Helper functions for managing events -- not part of the public interface.
	  * Props to Dean Edwards' addEvent library for many of the ideas.
	  */
		jQuery.event = {

			global: {},

			add: function add(elem, types, handler, data, selector) {

				var handleObjIn,
				    eventHandle,
				    tmp,
				    events,
				    t,
				    handleObj,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = dataPriv.get(elem);

				// Only attach events to objects that accept data
				if (!acceptData(elem)) {
					return;
				}

				// Caller can pass in an object of custom data in lieu of the handler
				if (handler.handler) {
					handleObjIn = handler;
					handler = handleObjIn.handler;
					selector = handleObjIn.selector;
				}

				// Ensure that invalid selectors throw exceptions at attach time
				// Evaluate against documentElement in case elem is a non-element node (e.g., document)
				if (selector) {
					jQuery.find.matchesSelector(documentElement, selector);
				}

				// Make sure that the handler has a unique ID, used to find/remove it later
				if (!handler.guid) {
					handler.guid = jQuery.guid++;
				}

				// Init the element's event structure and main handler, if this is the first
				if (!(events = elemData.events)) {
					events = elemData.events = Object.create(null);
				}
				if (!(eventHandle = elemData.handle)) {
					eventHandle = elemData.handle = function (e) {

						// Discard the second event of a jQuery.event.trigger() and
						// when an event is called after a page has unloaded
						return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
					};
				}

				// Handle multiple events separated by a space
				types = (types || "").match(rnothtmlwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();

					// There *must* be a type, no attaching namespace-only handlers
					if (!type) {
						continue;
					}

					// If event changes its type, use the special event handlers for the changed type
					special = jQuery.event.special[type] || {};

					// If selector defined, determine special event api type, otherwise given type
					type = (selector ? special.delegateType : special.bindType) || type;

					// Update special based on newly reset type
					special = jQuery.event.special[type] || {};

					// handleObj is passed to all event handlers
					handleObj = jQuery.extend({
						type: type,
						origType: origType,
						data: data,
						handler: handler,
						guid: handler.guid,
						selector: selector,
						needsContext: selector && jQuery.expr.match.needsContext.test(selector),
						namespace: namespaces.join(".")
					}, handleObjIn);

					// Init the event handler queue if we're the first
					if (!(handlers = events[type])) {
						handlers = events[type] = [];
						handlers.delegateCount = 0;

						// Only use addEventListener if the special events handler returns false
						if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {

							if (elem.addEventListener) {
								elem.addEventListener(type, eventHandle);
							}
						}
					}

					if (special.add) {
						special.add.call(elem, handleObj);

						if (!handleObj.handler.guid) {
							handleObj.handler.guid = handler.guid;
						}
					}

					// Add to the element's handler list, delegates in front
					if (selector) {
						handlers.splice(handlers.delegateCount++, 0, handleObj);
					} else {
						handlers.push(handleObj);
					}

					// Keep track of which events have ever been used, for event optimization
					jQuery.event.global[type] = true;
				}
			},

			// Detach an event or set of events from an element
			remove: function remove(elem, types, handler, selector, mappedTypes) {

				var j,
				    origCount,
				    tmp,
				    events,
				    t,
				    handleObj,
				    special,
				    handlers,
				    type,
				    namespaces,
				    origType,
				    elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

				if (!elemData || !(events = elemData.events)) {
					return;
				}

				// Once for each type.namespace in types; type may be omitted
				types = (types || "").match(rnothtmlwhite) || [""];
				t = types.length;
				while (t--) {
					tmp = rtypenamespace.exec(types[t]) || [];
					type = origType = tmp[1];
					namespaces = (tmp[2] || "").split(".").sort();

					// Unbind all events (on this namespace, if provided) for the element
					if (!type) {
						for (type in events) {
							jQuery.event.remove(elem, type + types[t], handler, selector, true);
						}
						continue;
					}

					special = jQuery.event.special[type] || {};
					type = (selector ? special.delegateType : special.bindType) || type;
					handlers = events[type] || [];
					tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

					// Remove matching events
					origCount = j = handlers.length;
					while (j--) {
						handleObj = handlers[j];

						if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
							handlers.splice(j, 1);

							if (handleObj.selector) {
								handlers.delegateCount--;
							}
							if (special.remove) {
								special.remove.call(elem, handleObj);
							}
						}
					}

					// Remove generic event handler if we removed something and no more handlers exist
					// (avoids potential for endless recursion during removal of special event handlers)
					if (origCount && !handlers.length) {
						if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {

							jQuery.removeEvent(elem, type, elemData.handle);
						}

						delete events[type];
					}
				}

				// Remove data and the expando if it's no longer used
				if (jQuery.isEmptyObject(events)) {
					dataPriv.remove(elem, "handle events");
				}
			},

			dispatch: function dispatch(nativeEvent) {

				var i,
				    j,
				    ret,
				    matched,
				    handleObj,
				    handlerQueue,
				    args = new Array(arguments.length),


				// Make a writable jQuery.Event from the native event object
				event = jQuery.event.fix(nativeEvent),
				    handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
				    special = jQuery.event.special[event.type] || {};

				// Use the fix-ed jQuery.Event rather than the (read-only) native event
				args[0] = event;

				for (i = 1; i < arguments.length; i++) {
					args[i] = arguments[i];
				}

				event.delegateTarget = this;

				// Call the preDispatch hook for the mapped type, and let it bail if desired
				if (special.preDispatch && special.preDispatch.call(this, event) === false) {
					return;
				}

				// Determine handlers
				handlerQueue = jQuery.event.handlers.call(this, event, handlers);

				// Run delegates first; they may want to stop propagation beneath us
				i = 0;
				while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
					event.currentTarget = matched.elem;

					j = 0;
					while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {

						// If the event is namespaced, then each handler is only invoked if it is
						// specially universal or its namespaces are a superset of the event's.
						if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {

							event.handleObj = handleObj;
							event.data = handleObj.data;

							ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);

							if (ret !== undefined) {
								if ((event.result = ret) === false) {
									event.preventDefault();
									event.stopPropagation();
								}
							}
						}
					}
				}

				// Call the postDispatch hook for the mapped type
				if (special.postDispatch) {
					special.postDispatch.call(this, event);
				}

				return event.result;
			},

			handlers: function handlers(event, _handlers) {
				var i,
				    handleObj,
				    sel,
				    matchedHandlers,
				    matchedSelectors,
				    handlerQueue = [],
				    delegateCount = _handlers.delegateCount,
				    cur = event.target;

				// Find delegate handlers
				if (delegateCount &&

				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&

				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!(event.type === "click" && event.button >= 1)) {

					for (; cur !== this; cur = cur.parentNode || this) {

						// Don't check non-elements (trac-13208)
						// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
						if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
							matchedHandlers = [];
							matchedSelectors = {};
							for (i = 0; i < delegateCount; i++) {
								handleObj = _handlers[i];

								// Don't conflict with Object.prototype properties (trac-13203)
								sel = handleObj.selector + " ";

								if (matchedSelectors[sel] === undefined) {
									matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
								}
								if (matchedSelectors[sel]) {
									matchedHandlers.push(handleObj);
								}
							}
							if (matchedHandlers.length) {
								handlerQueue.push({ elem: cur, handlers: matchedHandlers });
							}
						}
					}
				}

				// Add the remaining (directly-bound) handlers
				cur = this;
				if (delegateCount < _handlers.length) {
					handlerQueue.push({ elem: cur, handlers: _handlers.slice(delegateCount) });
				}

				return handlerQueue;
			},

			addProp: function addProp(name, hook) {
				Object.defineProperty(jQuery.Event.prototype, name, {
					enumerable: true,
					configurable: true,

					get: isFunction(hook) ? function () {
						if (this.originalEvent) {
							return hook(this.originalEvent);
						}
					} : function () {
						if (this.originalEvent) {
							return this.originalEvent[name];
						}
					},

					set: function set(value) {
						Object.defineProperty(this, name, {
							enumerable: true,
							configurable: true,
							writable: true,
							value: value
						});
					}
				});
			},

			fix: function fix(originalEvent) {
				return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
			},

			special: {
				load: {

					// Prevent triggered image.load events from bubbling to window.load
					noBubble: true
				},
				click: {

					// Utilize native event to ensure correct state for checkable inputs
					setup: function setup(data) {

						// For mutual compressibility with _default, replace `this` access with a local var.
						// `|| data` is dead code meant only to preserve the variable through minification.
						var el = this || data;

						// Claim the first handler
						if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

							// dataPriv.set( el, "click", ... )
							leverageNative(el, "click", true);
						}

						// Return false to allow normal processing in the caller
						return false;
					},
					trigger: function trigger(data) {

						// For mutual compressibility with _default, replace `this` access with a local var.
						// `|| data` is dead code meant only to preserve the variable through minification.
						var el = this || data;

						// Force setup before triggering a click
						if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {

							leverageNative(el, "click");
						}

						// Return non-false to allow normal event-path propagation
						return true;
					},

					// For cross-browser consistency, suppress native .click() on links
					// Also prevent it if we're currently inside a leveraged native-event stack
					_default: function _default(event) {
						var target = event.target;
						return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
					}
				},

				beforeunload: {
					postDispatch: function postDispatch(event) {

						// Support: Firefox 20+
						// Firefox doesn't alert if the returnValue field is not set.
						if (event.result !== undefined && event.originalEvent) {
							event.originalEvent.returnValue = event.result;
						}
					}
				}
			}
		};

		// Ensure the presence of an event listener that handles manually-triggered
		// synthetic events by interrupting progress until reinvoked in response to
		// *native* events that it fires directly, ensuring that state changes have
		// already occurred before other listeners are invoked.
		function leverageNative(el, type, isSetup) {

			// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
			if (!isSetup) {
				if (dataPriv.get(el, type) === undefined) {
					jQuery.event.add(el, type, returnTrue);
				}
				return;
			}

			// Register the controller as a special universal handler for all event namespaces
			dataPriv.set(el, type, false);
			jQuery.event.add(el, type, {
				namespace: false,
				handler: function handler(event) {
					var result,
					    saved = dataPriv.get(this, type);

					if (event.isTrigger & 1 && this[type]) {

						// Interrupt processing of the outer synthetic .trigger()ed event
						if (!saved) {

							// Store arguments for use when handling the inner native event
							// There will always be at least one argument (an event object), so this array
							// will not be confused with a leftover capture object.
							saved = _slice.call(arguments);
							dataPriv.set(this, type, saved);

							// Trigger the native event and capture its result
							this[type]();
							result = dataPriv.get(this, type);
							dataPriv.set(this, type, false);

							if (saved !== result) {

								// Cancel the outer synthetic event
								event.stopImmediatePropagation();
								event.preventDefault();

								return result;
							}

							// If this is an inner synthetic event for an event with a bubbling surrogate
							// (focus or blur), assume that the surrogate already propagated from triggering
							// the native event and prevent that from happening again here.
							// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
							// bubbling surrogate propagates *after* the non-bubbling base), but that seems
							// less bad than duplication.
						} else if ((jQuery.event.special[type] || {}).delegateType) {
							event.stopPropagation();
						}

						// If this is a native event triggered above, everything is now in order
						// Fire an inner synthetic event with the original arguments
					} else if (saved) {

						// ...and capture the result
						dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));

						// Abort handling of the native event by all jQuery handlers while allowing
						// native handlers on the same element to run. On target, this is achieved
						// by stopping immediate propagation just on the jQuery event. However,
						// the native event is re-wrapped by a jQuery one on each level of the
						// propagation so the only way to stop it for jQuery is to stop it for
						// everyone via native `stopPropagation()`. This is not a problem for
						// focus/blur which don't bubble, but it does also stop click on checkboxes
						// and radios. We accept this limitation.
						event.stopPropagation();
						event.isImmediatePropagationStopped = returnTrue;
					}
				}
			});
		}

		jQuery.removeEvent = function (elem, type, handle) {

			// This "if" is needed for plain objects
			if (elem.removeEventListener) {
				elem.removeEventListener(type, handle);
			}
		};

		jQuery.Event = function (src, props) {

			// Allow instantiation without the 'new' keyword
			if (!(this instanceof jQuery.Event)) {
				return new jQuery.Event(src, props);
			}

			// Event object
			if (src && src.type) {
				this.originalEvent = src;
				this.type = src.type;

				// Events bubbling up the document may have been marked as prevented
				// by a handler lower down the tree; reflect the correct value.
				this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ? returnTrue : returnFalse;

				// Create target properties
				// Support: Safari <=6 - 7 only
				// Target should not be a text node (trac-504, trac-13143)
				this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;

				this.currentTarget = src.currentTarget;
				this.relatedTarget = src.relatedTarget;

				// Event type
			} else {
				this.type = src;
			}

			// Put explicitly provided properties onto the event object
			if (props) {
				jQuery.extend(this, props);
			}

			// Create a timestamp if incoming event doesn't have one
			this.timeStamp = src && src.timeStamp || Date.now();

			// Mark it as fixed
			this[jQuery.expando] = true;
		};

		// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
		// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
		jQuery.Event.prototype = {
			constructor: jQuery.Event,
			isDefaultPrevented: returnFalse,
			isPropagationStopped: returnFalse,
			isImmediatePropagationStopped: returnFalse,
			isSimulated: false,

			preventDefault: function preventDefault() {
				var e = this.originalEvent;

				this.isDefaultPrevented = returnTrue;

				if (e && !this.isSimulated) {
					e.preventDefault();
				}
			},
			stopPropagation: function stopPropagation() {
				var e = this.originalEvent;

				this.isPropagationStopped = returnTrue;

				if (e && !this.isSimulated) {
					e.stopPropagation();
				}
			},
			stopImmediatePropagation: function stopImmediatePropagation() {
				var e = this.originalEvent;

				this.isImmediatePropagationStopped = returnTrue;

				if (e && !this.isSimulated) {
					e.stopImmediatePropagation();
				}

				this.stopPropagation();
			}
		};

		// Includes all common event props including KeyEvent and MouseEvent specific props
		jQuery.each({
			altKey: true,
			bubbles: true,
			cancelable: true,
			changedTouches: true,
			ctrlKey: true,
			detail: true,
			eventPhase: true,
			metaKey: true,
			pageX: true,
			pageY: true,
			shiftKey: true,
			view: true,
			"char": true,
			code: true,
			charCode: true,
			key: true,
			keyCode: true,
			button: true,
			buttons: true,
			clientX: true,
			clientY: true,
			offsetX: true,
			offsetY: true,
			pointerId: true,
			pointerType: true,
			screenX: true,
			screenY: true,
			targetTouches: true,
			toElement: true,
			touches: true,
			which: true
		}, jQuery.event.addProp);

		jQuery.each({ focus: "focusin", blur: "focusout" }, function (type, delegateType) {

			function focusMappedHandler(nativeEvent) {
				if (document.documentMode) {

					// Support: IE 11+
					// Attach a single focusin/focusout handler on the document while someone wants
					// focus/blur. This is because the former are synchronous in IE while the latter
					// are async. In other browsers, all those handlers are invoked synchronously.

					// `handle` from private data would already wrap the event, but we need
					// to change the `type` here.
					var handle = dataPriv.get(this, "handle"),
					    event = jQuery.event.fix(nativeEvent);
					event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
					event.isSimulated = true;

					// First, handle focusin/focusout
					handle(nativeEvent);

					// ...then, handle focus/blur
					//
					// focus/blur don't bubble while focusin/focusout do; simulate the former by only
					// invoking the handler at the lower level.
					if (event.target === event.currentTarget) {

						// The setup part calls `leverageNative`, which, in turn, calls
						// `jQuery.event.add`, so event handle will already have been set
						// by this point.
						handle(event);
					}
				} else {

					// For non-IE browsers, attach a single capturing handler on the document
					// while someone wants focusin/focusout.
					jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
				}
			}

			jQuery.event.special[type] = {

				// Utilize native event if possible so blur/focus sequence is correct
				setup: function setup() {

					var attaches;

					// Claim the first handler
					// dataPriv.set( this, "focus", ... )
					// dataPriv.set( this, "blur", ... )
					leverageNative(this, type, true);

					if (document.documentMode) {

						// Support: IE 9 - 11+
						// We use the same native handler for focusin & focus (and focusout & blur)
						// so we need to coordinate setup & teardown parts between those events.
						// Use `delegateType` as the key as `type` is already used by `leverageNative`.
						attaches = dataPriv.get(this, delegateType);
						if (!attaches) {
							this.addEventListener(delegateType, focusMappedHandler);
						}
						dataPriv.set(this, delegateType, (attaches || 0) + 1);
					} else {

						// Return false to allow normal processing in the caller
						return false;
					}
				},
				trigger: function trigger() {

					// Force setup before trigger
					leverageNative(this, type);

					// Return non-false to allow normal event-path propagation
					return true;
				},

				teardown: function teardown() {
					var attaches;

					if (document.documentMode) {
						attaches = dataPriv.get(this, delegateType) - 1;
						if (!attaches) {
							this.removeEventListener(delegateType, focusMappedHandler);
							dataPriv.remove(this, delegateType);
						} else {
							dataPriv.set(this, delegateType, attaches);
						}
					} else {

						// Return false to indicate standard teardown should be applied
						return false;
					}
				},

				// Suppress native focus or blur if we're currently inside
				// a leveraged native-event stack
				_default: function _default(event) {
					return dataPriv.get(event.target, type);
				},

				delegateType: delegateType
			};

			// Support: Firefox <=44
			// Firefox doesn't have focus(in | out) events
			// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
			//
			// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
			// focus(in | out) events fire after focus & blur events,
			// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
			// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
			//
			// Support: IE 9 - 11+
			// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
			// attach a single handler for both events in IE.
			jQuery.event.special[delegateType] = {
				setup: function setup() {

					// Handle: regular nodes (via `this.ownerDocument`), window
					// (via `this.document`) & document (via `this`).
					var doc = this.ownerDocument || this.document || this,
					    dataHolder = document.documentMode ? this : doc,
					    attaches = dataPriv.get(dataHolder, delegateType);

					// Support: IE 9 - 11+
					// We use the same native handler for focusin & focus (and focusout & blur)
					// so we need to coordinate setup & teardown parts between those events.
					// Use `delegateType` as the key as `type` is already used by `leverageNative`.
					if (!attaches) {
						if (document.documentMode) {
							this.addEventListener(delegateType, focusMappedHandler);
						} else {
							doc.addEventListener(type, focusMappedHandler, true);
						}
					}
					dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
				},
				teardown: function teardown() {
					var doc = this.ownerDocument || this.document || this,
					    dataHolder = document.documentMode ? this : doc,
					    attaches = dataPriv.get(dataHolder, delegateType) - 1;

					if (!attaches) {
						if (document.documentMode) {
							this.removeEventListener(delegateType, focusMappedHandler);
						} else {
							doc.removeEventListener(type, focusMappedHandler, true);
						}
						dataPriv.remove(dataHolder, delegateType);
					} else {
						dataPriv.set(dataHolder, delegateType, attaches);
					}
				}
			};
		});

		// Create mouseenter/leave events using mouseover/out and event-time checks
		// so that event delegation works in jQuery.
		// Do the same for pointerenter/pointerleave and pointerover/pointerout
		//
		// Support: Safari 7 only
		// Safari sends mouseenter too often; see:
		// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
		// for the description of the bug (it existed in older Chrome versions as well).
		jQuery.each({
			mouseenter: "mouseover",
			mouseleave: "mouseout",
			pointerenter: "pointerover",
			pointerleave: "pointerout"
		}, function (orig, fix) {
			jQuery.event.special[orig] = {
				delegateType: fix,
				bindType: fix,

				handle: function handle(event) {
					var ret,
					    target = this,
					    related = event.relatedTarget,
					    handleObj = event.handleObj;

					// For mouseenter/leave call the handler if related is outside the target.
					// NB: No relatedTarget if the mouse left/entered the browser window
					if (!related || related !== target && !jQuery.contains(target, related)) {
						event.type = handleObj.origType;
						ret = handleObj.handler.apply(this, arguments);
						event.type = fix;
					}
					return ret;
				}
			};
		});

		jQuery.fn.extend({

			on: function on(types, selector, data, fn) {
				return _on(this, types, selector, data, fn);
			},
			one: function one(types, selector, data, fn) {
				return _on(this, types, selector, data, fn, 1);
			},
			off: function off(types, selector, fn) {
				var handleObj, type;
				if (types && types.preventDefault && types.handleObj) {

					// ( event )  dispatched jQuery.Event
					handleObj = types.handleObj;
					jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
					return this;
				}
				if ((typeof types === "undefined" ? "undefined" : _typeof(types)) === "object") {

					// ( types-object [, selector] )
					for (type in types) {
						this.off(type, selector, types[type]);
					}
					return this;
				}
				if (selector === false || typeof selector === "function") {

					// ( types [, fn] )
					fn = selector;
					selector = undefined;
				}
				if (fn === false) {
					fn = returnFalse;
				}
				return this.each(function () {
					jQuery.event.remove(this, types, fn, selector);
				});
			}
		});

		var

		// Support: IE <=10 - 11, Edge 12 - 13 only
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,


		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		    rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

		// Prefer a tbody over its parent table for containing new rows
		function manipulationTarget(elem, content) {
			if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {

				return jQuery(elem).children("tbody")[0] || elem;
			}

			return elem;
		}

		// Replace/restore the type attribute of script elements for safe DOM manipulation
		function disableScript(elem) {
			elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
			return elem;
		}
		function restoreScript(elem) {
			if ((elem.type || "").slice(0, 5) === "true/") {
				elem.type = elem.type.slice(5);
			} else {
				elem.removeAttribute("type");
			}

			return elem;
		}

		function cloneCopyEvent(src, dest) {
			var i, l, type, pdataOld, udataOld, udataCur, events;

			if (dest.nodeType !== 1) {
				return;
			}

			// 1. Copy private data: events, handlers, etc.
			if (dataPriv.hasData(src)) {
				pdataOld = dataPriv.get(src);
				events = pdataOld.events;

				if (events) {
					dataPriv.remove(dest, "handle events");

					for (type in events) {
						for (i = 0, l = events[type].length; i < l; i++) {
							jQuery.event.add(dest, type, events[type][i]);
						}
					}
				}
			}

			// 2. Copy user data
			if (dataUser.hasData(src)) {
				udataOld = dataUser.access(src);
				udataCur = jQuery.extend({}, udataOld);

				dataUser.set(dest, udataCur);
			}
		}

		// Fix IE bugs, see support tests
		function fixInput(src, dest) {
			var nodeName = dest.nodeName.toLowerCase();

			// Fails to persist the checked state of a cloned checkbox or radio button.
			if (nodeName === "input" && rcheckableType.test(src.type)) {
				dest.checked = src.checked;

				// Fails to return the selected option to the default selected state when cloning options
			} else if (nodeName === "input" || nodeName === "textarea") {
				dest.defaultValue = src.defaultValue;
			}
		}

		function domManip(collection, args, callback, ignored) {

			// Flatten any nested arrays
			args = flat(args);

			var fragment,
			    first,
			    scripts,
			    hasScripts,
			    node,
			    doc,
			    i = 0,
			    l = collection.length,
			    iNoClone = l - 1,
			    value = args[0],
			    valueIsFunction = isFunction(value);

			// We can't cloneNode fragments that contain checked, in WebKit
			if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
				return collection.each(function (index) {
					var self = collection.eq(index);
					if (valueIsFunction) {
						args[0] = value.call(this, index, self.html());
					}
					domManip(self, args, callback, ignored);
				});
			}

			if (l) {
				fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
				first = fragment.firstChild;

				if (fragment.childNodes.length === 1) {
					fragment = first;
				}

				// Require either new content or an interest in ignored elements to invoke the callback
				if (first || ignored) {
					scripts = jQuery.map(getAll(fragment, "script"), disableScript);
					hasScripts = scripts.length;

					// Use the original fragment for the last item
					// instead of the first because it can end up
					// being emptied incorrectly in certain situations (trac-8070).
					for (; i < l; i++) {
						node = fragment;

						if (i !== iNoClone) {
							node = jQuery.clone(node, true, true);

							// Keep references to cloned scripts for later restoration
							if (hasScripts) {

								// Support: Android <=4.0 only, PhantomJS 1 only
								// push.apply(_, arraylike) throws on ancient WebKit
								jQuery.merge(scripts, getAll(node, "script"));
							}
						}

						callback.call(collection[i], node, i);
					}

					if (hasScripts) {
						doc = scripts[scripts.length - 1].ownerDocument;

						// Re-enable scripts
						jQuery.map(scripts, restoreScript);

						// Evaluate executable scripts on first document insertion
						for (i = 0; i < hasScripts; i++) {
							node = scripts[i];
							if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {

								if (node.src && (node.type || "").toLowerCase() !== "module") {

									// Optional AJAX dependency, but won't run scripts if not present
									if (jQuery._evalUrl && !node.noModule) {
										jQuery._evalUrl(node.src, {
											nonce: node.nonce || node.getAttribute("nonce")
										}, doc);
									}
								} else {

									// Unwrap a CDATA section containing script contents. This shouldn't be
									// needed as in XML documents they're already not visible when
									// inspecting element contents and in HTML documents they have no
									// meaning but we're preserving that logic for backwards compatibility.
									// This will be removed completely in 4.0. See gh-4904.
									DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
								}
							}
						}
					}
				}
			}

			return collection;
		}

		function _remove(elem, selector, keepData) {
			var node,
			    nodes = selector ? jQuery.filter(selector, elem) : elem,
			    i = 0;

			for (; (node = nodes[i]) != null; i++) {
				if (!keepData && node.nodeType === 1) {
					jQuery.cleanData(getAll(node));
				}

				if (node.parentNode) {
					if (keepData && isAttached(node)) {
						setGlobalEval(getAll(node, "script"));
					}
					node.parentNode.removeChild(node);
				}
			}

			return elem;
		}

		jQuery.extend({
			htmlPrefilter: function htmlPrefilter(html) {
				return html;
			},

			clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
				var i,
				    l,
				    srcElements,
				    destElements,
				    clone = elem.cloneNode(true),
				    inPage = isAttached(elem);

				// Fix IE cloning issues
				if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {

					// We eschew jQuery#find here for performance reasons:
					// https://jsperf.com/getall-vs-sizzle/2
					destElements = getAll(clone);
					srcElements = getAll(elem);

					for (i = 0, l = srcElements.length; i < l; i++) {
						fixInput(srcElements[i], destElements[i]);
					}
				}

				// Copy the events from the original to the clone
				if (dataAndEvents) {
					if (deepDataAndEvents) {
						srcElements = srcElements || getAll(elem);
						destElements = destElements || getAll(clone);

						for (i = 0, l = srcElements.length; i < l; i++) {
							cloneCopyEvent(srcElements[i], destElements[i]);
						}
					} else {
						cloneCopyEvent(elem, clone);
					}
				}

				// Preserve script evaluation history
				destElements = getAll(clone, "script");
				if (destElements.length > 0) {
					setGlobalEval(destElements, !inPage && getAll(elem, "script"));
				}

				// Return the cloned set
				return clone;
			},

			cleanData: function cleanData(elems) {
				var data,
				    elem,
				    type,
				    special = jQuery.event.special,
				    i = 0;

				for (; (elem = elems[i]) !== undefined; i++) {
					if (acceptData(elem)) {
						if (data = elem[dataPriv.expando]) {
							if (data.events) {
								for (type in data.events) {
									if (special[type]) {
										jQuery.event.remove(elem, type);

										// This is a shortcut to avoid jQuery.event.remove's overhead
									} else {
										jQuery.removeEvent(elem, type, data.handle);
									}
								}
							}

							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[dataPriv.expando] = undefined;
						}
						if (elem[dataUser.expando]) {

							// Support: Chrome <=35 - 45+
							// Assign undefined instead of using delete, see Data#remove
							elem[dataUser.expando] = undefined;
						}
					}
				}
			}
		});

		jQuery.fn.extend({
			detach: function detach(selector) {
				return _remove(this, selector, true);
			},

			remove: function remove(selector) {
				return _remove(this, selector);
			},

			text: function text(value) {
				return access(this, function (value) {
					return value === undefined ? jQuery.text(this) : this.empty().each(function () {
						if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
							this.textContent = value;
						}
					});
				}, null, value, arguments.length);
			},

			append: function append() {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.appendChild(elem);
					}
				});
			},

			prepend: function prepend() {
				return domManip(this, arguments, function (elem) {
					if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
						var target = manipulationTarget(this, elem);
						target.insertBefore(elem, target.firstChild);
					}
				});
			},

			before: function before() {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this);
					}
				});
			},

			after: function after() {
				return domManip(this, arguments, function (elem) {
					if (this.parentNode) {
						this.parentNode.insertBefore(elem, this.nextSibling);
					}
				});
			},

			empty: function empty() {
				var elem,
				    i = 0;

				for (; (elem = this[i]) != null; i++) {
					if (elem.nodeType === 1) {

						// Prevent memory leaks
						jQuery.cleanData(getAll(elem, false));

						// Remove any remaining nodes
						elem.textContent = "";
					}
				}

				return this;
			},

			clone: function clone(dataAndEvents, deepDataAndEvents) {
				dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
				deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

				return this.map(function () {
					return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
				});
			},

			html: function html(value) {
				return access(this, function (value) {
					var elem = this[0] || {},
					    i = 0,
					    l = this.length;

					if (value === undefined && elem.nodeType === 1) {
						return elem.innerHTML;
					}

					// See if we can take a shortcut and just use innerHTML
					if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {

						value = jQuery.htmlPrefilter(value);

						try {
							for (; i < l; i++) {
								elem = this[i] || {};

								// Remove element nodes and prevent memory leaks
								if (elem.nodeType === 1) {
									jQuery.cleanData(getAll(elem, false));
									elem.innerHTML = value;
								}
							}

							elem = 0;

							// If using innerHTML throws an exception, use the fallback method
						} catch (e) {}
					}

					if (elem) {
						this.empty().append(value);
					}
				}, null, value, arguments.length);
			},

			replaceWith: function replaceWith() {
				var ignored = [];

				// Make the changes, replacing each non-ignored context element with the new content
				return domManip(this, arguments, function (elem) {
					var parent = this.parentNode;

					if (jQuery.inArray(this, ignored) < 0) {
						jQuery.cleanData(getAll(this));
						if (parent) {
							parent.replaceChild(elem, this);
						}
					}

					// Force callback invocation
				}, ignored);
			}
		});

		jQuery.each({
			appendTo: "append",
			prependTo: "prepend",
			insertBefore: "before",
			insertAfter: "after",
			replaceAll: "replaceWith"
		}, function (name, original) {
			jQuery.fn[name] = function (selector) {
				var elems,
				    ret = [],
				    insert = jQuery(selector),
				    last = insert.length - 1,
				    i = 0;

				for (; i <= last; i++) {
					elems = i === last ? this : this.clone(true);
					jQuery(insert[i])[original](elems);

					// Support: Android <=4.0 only, PhantomJS 1 only
					// .get() because push.apply(_, arraylike) throws on ancient WebKit
					push.apply(ret, elems.get());
				}

				return this.pushStack(ret);
			};
		});
		var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

		var rcustomProp = /^--/;

		var getStyles = function getStyles(elem) {

			// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;

			if (!view || !view.opener) {
				view = window;
			}

			return view.getComputedStyle(elem);
		};

		var swap = function swap(elem, options, callback) {
			var ret,
			    name,
			    old = {};

			// Remember the old values, and insert the new ones
			for (name in options) {
				old[name] = elem.style[name];
				elem.style[name] = options[name];
			}

			ret = callback.call(elem);

			// Revert the old values
			for (name in options) {
				elem.style[name] = old[name];
			}

			return ret;
		};

		var rboxStyle = new RegExp(cssExpand.join("|"), "i");

		(function () {

			// Executing both pixelPosition & boxSizingReliable tests require only one layout
			// so they're executed at the same time to save the second computation.
			function computeStyleTests() {

				// This is a singleton, we need to execute it only once
				if (!div) {
					return;
				}

				container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
				div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
				documentElement.appendChild(container).appendChild(div);

				var divStyle = window.getComputedStyle(div);
				pixelPositionVal = divStyle.top !== "1%";

				// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
				reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

				// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
				// Some styles come back with percentage values, even though they shouldn't
				div.style.right = "60%";
				pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

				// Support: IE 9 - 11 only
				// Detect misreporting of content dimensions for box-sizing:border-box elements
				boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

				// Support: IE 9 only
				// Detect overflow:scroll screwiness (gh-3699)
				// Support: Chrome <=64
				// Don't get tricked when zoom affects offsetWidth (gh-4029)
				div.style.position = "absolute";
				scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

				documentElement.removeChild(container);

				// Nullify the div so it wouldn't be stored in the memory and
				// it will also be a sign that checks already performed
				div = null;
			}

			function roundPixelMeasures(measure) {
				return Math.round(parseFloat(measure));
			}

			var pixelPositionVal,
			    boxSizingReliableVal,
			    scrollboxSizeVal,
			    pixelBoxStylesVal,
			    reliableTrDimensionsVal,
			    reliableMarginLeftVal,
			    container = document.createElement("div"),
			    div = document.createElement("div");

			// Finish early in limited (non-browser) environments
			if (!div.style) {
				return;
			}

			// Support: IE <=9 - 11 only
			// Style of cloned element affects source element cloned (trac-8908)
			div.style.backgroundClip = "content-box";
			div.cloneNode(true).style.backgroundClip = "";
			support.clearCloneStyle = div.style.backgroundClip === "content-box";

			jQuery.extend(support, {
				boxSizingReliable: function boxSizingReliable() {
					computeStyleTests();
					return boxSizingReliableVal;
				},
				pixelBoxStyles: function pixelBoxStyles() {
					computeStyleTests();
					return pixelBoxStylesVal;
				},
				pixelPosition: function pixelPosition() {
					computeStyleTests();
					return pixelPositionVal;
				},
				reliableMarginLeft: function reliableMarginLeft() {
					computeStyleTests();
					return reliableMarginLeftVal;
				},
				scrollboxSize: function scrollboxSize() {
					computeStyleTests();
					return scrollboxSizeVal;
				},

				// Support: IE 9 - 11+, Edge 15 - 18+
				// IE/Edge misreport `getComputedStyle` of table rows with width/height
				// set in CSS while `offset*` properties report correct values.
				// Behavior in IE 9 is more subtle than in newer versions & it passes
				// some versions of this test; make sure not to make it pass there!
				//
				// Support: Firefox 70+
				// Only Firefox includes border widths
				// in computed dimensions. (gh-4529)
				reliableTrDimensions: function reliableTrDimensions() {
					var table, tr, trChild, trStyle;
					if (reliableTrDimensionsVal == null) {
						table = document.createElement("table");
						tr = document.createElement("tr");
						trChild = document.createElement("div");

						table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
						tr.style.cssText = "box-sizing:content-box;border:1px solid";

						// Support: Chrome 86+
						// Height set through cssText does not get applied.
						// Computed height then comes back as 0.
						tr.style.height = "1px";
						trChild.style.height = "9px";

						// Support: Android 8 Chrome 86+
						// In our bodyBackground.html iframe,
						// display for all div elements is set to "inline",
						// which causes a problem only in Android 8 Chrome 86.
						// Ensuring the div is `display: block`
						// gets around this issue.
						trChild.style.display = "block";

						documentElement.appendChild(table).appendChild(tr).appendChild(trChild);

						trStyle = window.getComputedStyle(tr);
						reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;

						documentElement.removeChild(table);
					}
					return reliableTrDimensionsVal;
				}
			});
		})();

		function curCSS(elem, name, computed) {
			var width,
			    minWidth,
			    maxWidth,
			    ret,
			    isCustomProp = rcustomProp.test(name),


			// Support: Firefox 51+
			// Retrieving style before computed somehow
			// fixes an issue with getting wrong values
			// on detached elements
			style = elem.style;

			computed = computed || getStyles(elem);

			// getPropertyValue is needed for:
			//   .css('filter') (IE 9 only, trac-12537)
			//   .css('--customProperty) (gh-3144)
			if (computed) {

				// Support: IE <=9 - 11+
				// IE only supports `"float"` in `getPropertyValue`; in computed styles
				// it's only available as `"cssFloat"`. We no longer modify properties
				// sent to `.css()` apart from camelCasing, so we need to check both.
				// Normally, this would create difference in behavior: if
				// `getPropertyValue` returns an empty string, the value returned
				// by `.css()` would be `undefined`. This is usually the case for
				// disconnected elements. However, in IE even disconnected elements
				// with no styles return `"none"` for `getPropertyValue( "float" )`
				ret = computed.getPropertyValue(name) || computed[name];

				if (isCustomProp && ret) {

					// Support: Firefox 105+, Chrome <=105+
					// Spec requires trimming whitespace for custom properties (gh-4926).
					// Firefox only trims leading whitespace. Chrome just collapses
					// both leading & trailing whitespace to a single space.
					//
					// Fall back to `undefined` if empty string returned.
					// This collapses a missing definition with property defined
					// and set to an empty string but there's no standard API
					// allowing us to differentiate them without a performance penalty
					// and returning `undefined` aligns with older jQuery.
					//
					// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
					// as whitespace while CSS does not, but this is not a problem
					// because CSS preprocessing replaces them with U+000A LINE FEED
					// (which *is* CSS whitespace)
					// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
					ret = ret.replace(rtrimCSS, "$1") || undefined;
				}

				if (ret === "" && !isAttached(elem)) {
					ret = jQuery.style(elem, name);
				}

				// A tribute to the "awesome hack by Dean Edwards"
				// Android Browser returns percentage for some values,
				// but width seems to be reliably pixels.
				// This is against the CSSOM draft spec:
				// https://drafts.csswg.org/cssom/#resolved-values
				if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {

					// Remember the original values
					width = style.width;
					minWidth = style.minWidth;
					maxWidth = style.maxWidth;

					// Put in the new values to get a computed value out
					style.minWidth = style.maxWidth = style.width = ret;
					ret = computed.width;

					// Revert the changed values
					style.width = width;
					style.minWidth = minWidth;
					style.maxWidth = maxWidth;
				}
			}

			return ret !== undefined ?

			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" : ret;
		}

		function addGetHookIf(conditionFn, hookFn) {

			// Define the hook, we'll check on the first run if it's really needed.
			return {
				get: function get() {
					if (conditionFn()) {

						// Hook not needed (or it's not possible to use it due
						// to missing dependency), remove it.
						delete this.get;
						return;
					}

					// Hook needed; redefine it so that the support test is not executed again.
					return (this.get = hookFn).apply(this, arguments);
				}
			};
		}

		var cssPrefixes = ["Webkit", "Moz", "ms"],
		    emptyStyle = document.createElement("div").style,
		    vendorProps = {};

		// Return a vendor-prefixed property or undefined
		function vendorPropName(name) {

			// Check for vendor prefixed names
			var capName = name[0].toUpperCase() + name.slice(1),
			    i = cssPrefixes.length;

			while (i--) {
				name = cssPrefixes[i] + capName;
				if (name in emptyStyle) {
					return name;
				}
			}
		}

		// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
		function finalPropName(name) {
			var final = jQuery.cssProps[name] || vendorProps[name];

			if (final) {
				return final;
			}
			if (name in emptyStyle) {
				return name;
			}
			return vendorProps[name] = vendorPropName(name) || name;
		}

		var

		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		    cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		};

		function setPositiveNumber(_elem, value, subtract) {

			// Any relative (+/-) values have already been
			// normalized at this point
			var matches = rcssNum.exec(value);
			return matches ?

			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
		}

		function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
			var i = dimension === "width" ? 1 : 0,
			    extra = 0,
			    delta = 0,
			    marginDelta = 0;

			// Adjustment may not be necessary
			if (box === (isBorderBox ? "border" : "content")) {
				return 0;
			}

			for (; i < 4; i += 2) {

				// Both box models exclude margin
				// Count margin delta separately to only add it after scroll gutter adjustment.
				// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
				if (box === "margin") {
					marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
				}

				// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
				if (!isBorderBox) {

					// Add padding
					delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

					// For "border" or "margin", add border
					if (box !== "padding") {
						delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

						// But still keep track of it otherwise
					} else {
						extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}

					// If we get here with a border-box (content + padding + border), we're seeking "content" or
					// "padding" or "margin"
				} else {

					// For "content", subtract padding
					if (box === "content") {
						delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
					}

					// For "content" or "padding", subtract border
					if (box !== "margin") {
						delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
					}
				}
			}

			// Account for positive content-box scroll gutter when requested by providing computedVal
			if (!isBorderBox && computedVal >= 0) {

				// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
				// Assuming integer scroll gutter, subtract the rest and round down
				delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

				// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
				// Use an explicit zero to avoid NaN (gh-3964)
				)) || 0;
			}

			return delta + marginDelta;
		}

		function getWidthOrHeight(elem, dimension, extra) {

			// Start with computed style
			var styles = getStyles(elem),


			// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
			// Fake content-box until we know it's needed to know the true value.
			boxSizingNeeded = !support.boxSizingReliable() || extra,
			    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
			    valueIsBorderBox = isBorderBox,
			    val = curCSS(elem, dimension, styles),
			    offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

			// Support: Firefox <=54
			// Return a confounding non-pixel value or feign ignorance, as appropriate.
			if (rnumnonpx.test(val)) {
				if (!extra) {
					return val;
				}
				val = "auto";
			}

			// Support: IE 9 - 11 only
			// Use offsetWidth/offsetHeight for when box sizing is unreliable.
			// In those cases, the computed value can be trusted to be border-box.
			if ((!support.boxSizingReliable() && isBorderBox ||

			// Support: IE 10 - 11+, Edge 15 - 18+
			// IE/Edge misreport `getComputedStyle` of table rows with width/height
			// set in CSS while `offset*` properties report correct values.
			// Interestingly, in some cases IE 9 doesn't suffer from this issue.
			!support.reliableTrDimensions() && nodeName(elem, "tr") ||

			// Fall back to offsetWidth/offsetHeight when value is "auto"
			// This happens for inline elements with no explicit setting (gh-3571)
			val === "auto" ||

			// Support: Android <=4.1 - 4.3 only
			// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
			!parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&

			// Make sure the element is visible & connected
			elem.getClientRects().length) {

				isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

				// Where available, offsetWidth/offsetHeight approximate border box dimensions.
				// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
				// retrieved value as a content box dimension.
				valueIsBorderBox = offsetProp in elem;
				if (valueIsBorderBox) {
					val = elem[offsetProp];
				}
			}

			// Normalize "" and auto
			val = parseFloat(val) || 0;

			// Adjust for the element's box model
			return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val) + "px";
		}

		jQuery.extend({

			// Add in style property hooks for overriding the default
			// behavior of getting and setting a style property
			cssHooks: {
				opacity: {
					get: function get(elem, computed) {
						if (computed) {

							// We should always get a number back from opacity
							var ret = curCSS(elem, "opacity");
							return ret === "" ? "1" : ret;
						}
					}
				}
			},

			// Don't automatically add "px" to these possibly-unitless properties
			cssNumber: {
				animationIterationCount: true,
				aspectRatio: true,
				borderImageSlice: true,
				columnCount: true,
				flexGrow: true,
				flexShrink: true,
				fontWeight: true,
				gridArea: true,
				gridColumn: true,
				gridColumnEnd: true,
				gridColumnStart: true,
				gridRow: true,
				gridRowEnd: true,
				gridRowStart: true,
				lineHeight: true,
				opacity: true,
				order: true,
				orphans: true,
				scale: true,
				widows: true,
				zIndex: true,
				zoom: true,

				// SVG-related
				fillOpacity: true,
				floodOpacity: true,
				stopOpacity: true,
				strokeMiterlimit: true,
				strokeOpacity: true
			},

			// Add in properties whose names you wish to fix before
			// setting or getting the value
			cssProps: {},

			// Get and set the style property on a DOM Node
			style: function style(elem, name, value, extra) {

				// Don't set styles on text and comment nodes
				if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
					return;
				}

				// Make sure that we're working with the right name
				var ret,
				    type,
				    hooks,
				    origName = camelCase(name),
				    isCustomProp = rcustomProp.test(name),
				    style = elem.style;

				// Make sure that we're working with the right name. We don't
				// want to query the value if it is a CSS custom property
				// since they are user-defined.
				if (!isCustomProp) {
					name = finalPropName(origName);
				}

				// Gets hook for the prefixed version, then unprefixed version
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

				// Check if we're setting a value
				if (value !== undefined) {
					type = typeof value === "undefined" ? "undefined" : _typeof(value);

					// Convert "+=" or "-=" to relative numbers (trac-7345)
					if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
						value = adjustCSS(elem, name, ret);

						// Fixes bug trac-9237
						type = "number";
					}

					// Make sure that null and NaN values aren't set (trac-7116)
					if (value == null || value !== value) {
						return;
					}

					// If a number was passed in, add the unit (except for certain CSS properties)
					// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
					// "px" to a few hardcoded values.
					if (type === "number" && !isCustomProp) {
						value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
					}

					// background-* props affect original clone's values
					if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
						style[name] = "inherit";
					}

					// If a hook was provided, use that value, otherwise just set the specified value
					if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {

						if (isCustomProp) {
							style.setProperty(name, value);
						} else {
							style[name] = value;
						}
					}
				} else {

					// If a hook was provided get the non-computed value from there
					if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {

						return ret;
					}

					// Otherwise just get the value from the style object
					return style[name];
				}
			},

			css: function css(elem, name, extra, styles) {
				var val,
				    num,
				    hooks,
				    origName = camelCase(name),
				    isCustomProp = rcustomProp.test(name);

				// Make sure that we're working with the right name. We don't
				// want to modify the value if it is a CSS custom property
				// since they are user-defined.
				if (!isCustomProp) {
					name = finalPropName(origName);
				}

				// Try prefixed name followed by the unprefixed name
				hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

				// If a hook was provided get the computed value from there
				if (hooks && "get" in hooks) {
					val = hooks.get(elem, true, extra);
				}

				// Otherwise, if a way to get the computed value exists, use that
				if (val === undefined) {
					val = curCSS(elem, name, styles);
				}

				// Convert "normal" to computed value
				if (val === "normal" && name in cssNormalTransform) {
					val = cssNormalTransform[name];
				}

				// Make numeric if forced or a qualifier was provided and val looks numeric
				if (extra === "" || extra) {
					num = parseFloat(val);
					return extra === true || isFinite(num) ? num || 0 : val;
				}

				return val;
			}
		});

		jQuery.each(["height", "width"], function (_i, dimension) {
			jQuery.cssHooks[dimension] = {
				get: function get(elem, computed, extra) {
					if (computed) {

						// Certain elements can have dimension info if we invisibly show them
						// but it must have a current display style that would benefit
						return rdisplayswap.test(jQuery.css(elem, "display")) && (

						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
							return getWidthOrHeight(elem, dimension, extra);
						}) : getWidthOrHeight(elem, dimension, extra);
					}
				},

				set: function set(elem, value, extra) {
					var matches,
					    styles = getStyles(elem),


					// Only read styles.position if the test has a chance to fail
					// to avoid forcing a reflow.
					scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",


					// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
					boxSizingNeeded = scrollboxSizeBuggy || extra,
					    isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
					    subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

					// Account for unreliable border-box dimensions by comparing offset* to computed and
					// faking a content-box to get border and padding (gh-3699)
					if (isBorderBox && scrollboxSizeBuggy) {
						subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
					}

					// Convert to pixels if value adjustment is needed
					if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {

						elem.style[dimension] = value;
						value = jQuery.css(elem, dimension);
					}

					return setPositiveNumber(elem, value, subtract);
				}
			};
		});

		jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
			if (computed) {
				return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, { marginLeft: 0 }, function () {
					return elem.getBoundingClientRect().left;
				})) + "px";
			}
		});

		// These hooks are used by animate to expand properties
		jQuery.each({
			margin: "",
			padding: "",
			border: "Width"
		}, function (prefix, suffix) {
			jQuery.cssHooks[prefix + suffix] = {
				expand: function expand(value) {
					var i = 0,
					    expanded = {},


					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split(" ") : [value];

					for (; i < 4; i++) {
						expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
					}

					return expanded;
				}
			};

			if (prefix !== "margin") {
				jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
			}
		});

		jQuery.fn.extend({
			css: function css(name, value) {
				return access(this, function (elem, name, value) {
					var styles,
					    len,
					    map = {},
					    i = 0;

					if (Array.isArray(name)) {
						styles = getStyles(elem);
						len = name.length;

						for (; i < len; i++) {
							map[name[i]] = jQuery.css(elem, name[i], false, styles);
						}

						return map;
					}

					return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
				}, name, value, arguments.length > 1);
			}
		});

		function Tween(elem, options, prop, end, easing) {
			return new Tween.prototype.init(elem, options, prop, end, easing);
		}
		jQuery.Tween = Tween;

		Tween.prototype = {
			constructor: Tween,
			init: function init(elem, options, prop, end, easing, unit) {
				this.elem = elem;
				this.prop = prop;
				this.easing = easing || jQuery.easing._default;
				this.options = options;
				this.start = this.now = this.cur();
				this.end = end;
				this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
			},
			cur: function cur() {
				var hooks = Tween.propHooks[this.prop];

				return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
			},
			run: function run(percent) {
				var eased,
				    hooks = Tween.propHooks[this.prop];

				if (this.options.duration) {
					this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
				} else {
					this.pos = eased = percent;
				}
				this.now = (this.end - this.start) * eased + this.start;

				if (this.options.step) {
					this.options.step.call(this.elem, this.now, this);
				}

				if (hooks && hooks.set) {
					hooks.set(this);
				} else {
					Tween.propHooks._default.set(this);
				}
				return this;
			}
		};

		Tween.prototype.init.prototype = Tween.prototype;

		Tween.propHooks = {
			_default: {
				get: function get(tween) {
					var result;

					// Use a property on the element directly when it is not a DOM element,
					// or when there is no matching style property that exists.
					if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
						return tween.elem[tween.prop];
					}

					// Passing an empty string as a 3rd parameter to .css will automatically
					// attempt a parseFloat and fallback to a string if the parse fails.
					// Simple values such as "10px" are parsed to Float;
					// complex values such as "rotate(1rad)" are returned as-is.
					result = jQuery.css(tween.elem, tween.prop, "");

					// Empty strings, null, undefined and "auto" are converted to 0.
					return !result || result === "auto" ? 0 : result;
				},
				set: function set(tween) {

					// Use step hook for back compat.
					// Use cssHook if its there.
					// Use .style if available and use plain properties where available.
					if (jQuery.fx.step[tween.prop]) {
						jQuery.fx.step[tween.prop](tween);
					} else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
						jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
					} else {
						tween.elem[tween.prop] = tween.now;
					}
				}
			}
		};

		// Support: IE <=9 only
		// Panic based approach to setting things on disconnected nodes
		Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
			set: function set(tween) {
				if (tween.elem.nodeType && tween.elem.parentNode) {
					tween.elem[tween.prop] = tween.now;
				}
			}
		};

		jQuery.easing = {
			linear: function linear(p) {
				return p;
			},
			swing: function swing(p) {
				return 0.5 - Math.cos(p * Math.PI) / 2;
			},
			_default: "swing"
		};

		jQuery.fx = Tween.prototype.init;

		// Back compat <1.8 extension point
		jQuery.fx.step = {};

		var fxNow,
		    inProgress,
		    rfxtypes = /^(?:toggle|show|hide)$/,
		    rrun = /queueHooks$/;

		function schedule() {
			if (inProgress) {
				if (document.hidden === false && window.requestAnimationFrame) {
					window.requestAnimationFrame(schedule);
				} else {
					window.setTimeout(schedule, jQuery.fx.interval);
				}

				jQuery.fx.tick();
			}
		}

		// Animations created synchronously will run synchronously
		function createFxNow() {
			window.setTimeout(function () {
				fxNow = undefined;
			});
			return fxNow = Date.now();
		}

		// Generate parameters to create a standard animation
		function genFx(type, includeWidth) {
			var which,
			    i = 0,
			    attrs = { height: type };

			// If we include width, step value is 1 to do all cssExpand values,
			// otherwise step value is 2 to skip over Left and Right
			includeWidth = includeWidth ? 1 : 0;
			for (; i < 4; i += 2 - includeWidth) {
				which = cssExpand[i];
				attrs["margin" + which] = attrs["padding" + which] = type;
			}

			if (includeWidth) {
				attrs.opacity = attrs.width = type;
			}

			return attrs;
		}

		function createTween(value, prop, animation) {
			var tween,
			    collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
			    index = 0,
			    length = collection.length;
			for (; index < length; index++) {
				if (tween = collection[index].call(animation, prop, value)) {

					// We're done with this property
					return tween;
				}
			}
		}

		function defaultPrefilter(elem, props, opts) {
			var prop,
			    value,
			    toggle,
			    hooks,
			    oldfire,
			    propTween,
			    restoreDisplay,
			    display,
			    isBox = "width" in props || "height" in props,
			    anim = this,
			    orig = {},
			    style = elem.style,
			    hidden = elem.nodeType && isHiddenWithinTree(elem),
			    dataShow = dataPriv.get(elem, "fxshow");

			// Queue-skipping animations hijack the fx hooks
			if (!opts.queue) {
				hooks = jQuery._queueHooks(elem, "fx");
				if (hooks.unqueued == null) {
					hooks.unqueued = 0;
					oldfire = hooks.empty.fire;
					hooks.empty.fire = function () {
						if (!hooks.unqueued) {
							oldfire();
						}
					};
				}
				hooks.unqueued++;

				anim.always(function () {

					// Ensure the complete handler is called before this completes
					anim.always(function () {
						hooks.unqueued--;
						if (!jQuery.queue(elem, "fx").length) {
							hooks.empty.fire();
						}
					});
				});
			}

			// Detect show/hide animations
			for (prop in props) {
				value = props[prop];
				if (rfxtypes.test(value)) {
					delete props[prop];
					toggle = toggle || value === "toggle";
					if (value === (hidden ? "hide" : "show")) {

						// Pretend to be hidden if this is a "show" and
						// there is still data from a stopped show/hide
						if (value === "show" && dataShow && dataShow[prop] !== undefined) {
							hidden = true;

							// Ignore all other no-op show/hide data
						} else {
							continue;
						}
					}
					orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
				}
			}

			// Bail out if this is a no-op like .hide().hide()
			propTween = !jQuery.isEmptyObject(props);
			if (!propTween && jQuery.isEmptyObject(orig)) {
				return;
			}

			// Restrict "overflow" and "display" styles during box animations
			if (isBox && elem.nodeType === 1) {

				// Support: IE <=9 - 11, Edge 12 - 15
				// Record all 3 overflow attributes because IE does not infer the shorthand
				// from identically-valued overflowX and overflowY and Edge just mirrors
				// the overflowX value there.
				opts.overflow = [style.overflow, style.overflowX, style.overflowY];

				// Identify a display type, preferring old show/hide data over the CSS cascade
				restoreDisplay = dataShow && dataShow.display;
				if (restoreDisplay == null) {
					restoreDisplay = dataPriv.get(elem, "display");
				}
				display = jQuery.css(elem, "display");
				if (display === "none") {
					if (restoreDisplay) {
						display = restoreDisplay;
					} else {

						// Get nonempty value(s) by temporarily forcing visibility
						showHide([elem], true);
						restoreDisplay = elem.style.display || restoreDisplay;
						display = jQuery.css(elem, "display");
						showHide([elem]);
					}
				}

				// Animate inline elements as inline-block
				if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
					if (jQuery.css(elem, "float") === "none") {

						// Restore the original display value at the end of pure show/hide animations
						if (!propTween) {
							anim.done(function () {
								style.display = restoreDisplay;
							});
							if (restoreDisplay == null) {
								display = style.display;
								restoreDisplay = display === "none" ? "" : display;
							}
						}
						style.display = "inline-block";
					}
				}
			}

			if (opts.overflow) {
				style.overflow = "hidden";
				anim.always(function () {
					style.overflow = opts.overflow[0];
					style.overflowX = opts.overflow[1];
					style.overflowY = opts.overflow[2];
				});
			}

			// Implement show/hide animations
			propTween = false;
			for (prop in orig) {

				// General show/hide setup for this element animation
				if (!propTween) {
					if (dataShow) {
						if ("hidden" in dataShow) {
							hidden = dataShow.hidden;
						}
					} else {
						dataShow = dataPriv.access(elem, "fxshow", { display: restoreDisplay });
					}

					// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
					if (toggle) {
						dataShow.hidden = !hidden;
					}

					// Show elements before animating them
					if (hidden) {
						showHide([elem], true);
					}

					/* eslint-disable no-loop-func */

					anim.done(function () {

						/* eslint-enable no-loop-func */

						// The final step of a "hide" animation is actually hiding the element
						if (!hidden) {
							showHide([elem]);
						}
						dataPriv.remove(elem, "fxshow");
						for (prop in orig) {
							jQuery.style(elem, prop, orig[prop]);
						}
					});
				}

				// Per-property setup
				propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
				if (!(prop in dataShow)) {
					dataShow[prop] = propTween.start;
					if (hidden) {
						propTween.end = propTween.start;
						propTween.start = 0;
					}
				}
			}
		}

		function propFilter(props, specialEasing) {
			var index, name, easing, value, hooks;

			// camelCase, specialEasing and expand cssHook pass
			for (index in props) {
				name = camelCase(index);
				easing = specialEasing[name];
				value = props[index];
				if (Array.isArray(value)) {
					easing = value[1];
					value = props[index] = value[0];
				}

				if (index !== name) {
					props[name] = value;
					delete props[index];
				}

				hooks = jQuery.cssHooks[name];
				if (hooks && "expand" in hooks) {
					value = hooks.expand(value);
					delete props[name];

					// Not quite $.extend, this won't overwrite existing keys.
					// Reusing 'index' because we have the correct "name"
					for (index in value) {
						if (!(index in props)) {
							props[index] = value[index];
							specialEasing[index] = easing;
						}
					}
				} else {
					specialEasing[name] = easing;
				}
			}
		}

		function Animation(elem, properties, options) {
			var result,
			    stopped,
			    index = 0,
			    length = Animation.prefilters.length,
			    deferred = jQuery.Deferred().always(function () {

				// Don't match elem in the :animated selector
				delete tick.elem;
			}),
			    tick = function tick() {
				if (stopped) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
				    remaining = Math.max(0, animation.startTime + animation.duration - currentTime),


				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				    percent = 1 - temp,
				    index = 0,
				    length = animation.tweens.length;

				for (; index < length; index++) {
					animation.tweens[index].run(percent);
				}

				deferred.notifyWith(elem, [animation, percent, remaining]);

				// If there's more to do, yield
				if (percent < 1 && length) {
					return remaining;
				}

				// If this was an empty animation, synthesize a final progress notification
				if (!length) {
					deferred.notifyWith(elem, [animation, 1, 0]);
				}

				// Resolve the animation and report its conclusion
				deferred.resolveWith(elem, [animation]);
				return false;
			},
			    animation = deferred.promise({
				elem: elem,
				props: jQuery.extend({}, properties),
				opts: jQuery.extend(true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function createTween(prop, end) {
					var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
					animation.tweens.push(tween);
					return tween;
				},
				stop: function stop(gotoEnd) {
					var index = 0,


					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
					if (stopped) {
						return this;
					}
					stopped = true;
					for (; index < length; index++) {
						animation.tweens[index].run(1);
					}

					// Resolve when we played the last frame; otherwise, reject
					if (gotoEnd) {
						deferred.notifyWith(elem, [animation, 1, 0]);
						deferred.resolveWith(elem, [animation, gotoEnd]);
					} else {
						deferred.rejectWith(elem, [animation, gotoEnd]);
					}
					return this;
				}
			}),
			    props = animation.props;

			propFilter(props, animation.opts.specialEasing);

			for (; index < length; index++) {
				result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
				if (result) {
					if (isFunction(result.stop)) {
						jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
					}
					return result;
				}
			}

			jQuery.map(props, createTween, animation);

			if (isFunction(animation.opts.start)) {
				animation.opts.start.call(elem, animation);
			}

			// Attach callbacks from options
			animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);

			jQuery.fx.timer(jQuery.extend(tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			}));

			return animation;
		}

		jQuery.Animation = jQuery.extend(Animation, {

			tweeners: {
				"*": [function (prop, value) {
					var tween = this.createTween(prop, value);
					adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
					return tween;
				}]
			},

			tweener: function tweener(props, callback) {
				if (isFunction(props)) {
					callback = props;
					props = ["*"];
				} else {
					props = props.match(rnothtmlwhite);
				}

				var prop,
				    index = 0,
				    length = props.length;

				for (; index < length; index++) {
					prop = props[index];
					Animation.tweeners[prop] = Animation.tweeners[prop] || [];
					Animation.tweeners[prop].unshift(callback);
				}
			},

			prefilters: [defaultPrefilter],

			prefilter: function prefilter(callback, prepend) {
				if (prepend) {
					Animation.prefilters.unshift(callback);
				} else {
					Animation.prefilters.push(callback);
				}
			}
		});

		jQuery.speed = function (speed, easing, fn) {
			var opt = speed && (typeof speed === "undefined" ? "undefined" : _typeof(speed)) === "object" ? jQuery.extend({}, speed) : {
				complete: fn || !fn && easing || isFunction(speed) && speed,
				duration: speed,
				easing: fn && easing || easing && !isFunction(easing) && easing
			};

			// Go to the end state if fx are off
			if (jQuery.fx.off) {
				opt.duration = 0;
			} else {
				if (typeof opt.duration !== "number") {
					if (opt.duration in jQuery.fx.speeds) {
						opt.duration = jQuery.fx.speeds[opt.duration];
					} else {
						opt.duration = jQuery.fx.speeds._default;
					}
				}
			}

			// Normalize opt.queue - true/undefined/null -> "fx"
			if (opt.queue == null || opt.queue === true) {
				opt.queue = "fx";
			}

			// Queueing
			opt.old = opt.complete;

			opt.complete = function () {
				if (isFunction(opt.old)) {
					opt.old.call(this);
				}

				if (opt.queue) {
					jQuery.dequeue(this, opt.queue);
				}
			};

			return opt;
		};

		jQuery.fn.extend({
			fadeTo: function fadeTo(speed, to, easing, callback) {

				// Show any hidden elements after setting opacity to 0
				return this.filter(isHiddenWithinTree).css("opacity", 0).show()

				// Animate to the value specified
				.end().animate({ opacity: to }, speed, easing, callback);
			},
			animate: function animate(prop, speed, easing, callback) {
				var empty = jQuery.isEmptyObject(prop),
				    optall = jQuery.speed(speed, easing, callback),
				    doAnimation = function doAnimation() {

					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation(this, jQuery.extend({}, prop), optall);

					// Empty animations, or finishing resolves immediately
					if (empty || dataPriv.get(this, "finish")) {
						anim.stop(true);
					}
				};

				doAnimation.finish = doAnimation;

				return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
			},
			stop: function stop(type, clearQueue, gotoEnd) {
				var stopQueue = function stopQueue(hooks) {
					var stop = hooks.stop;
					delete hooks.stop;
					stop(gotoEnd);
				};

				if (typeof type !== "string") {
					gotoEnd = clearQueue;
					clearQueue = type;
					type = undefined;
				}
				if (clearQueue) {
					this.queue(type || "fx", []);
				}

				return this.each(function () {
					var dequeue = true,
					    index = type != null && type + "queueHooks",
					    timers = jQuery.timers,
					    data = dataPriv.get(this);

					if (index) {
						if (data[index] && data[index].stop) {
							stopQueue(data[index]);
						}
					} else {
						for (index in data) {
							if (data[index] && data[index].stop && rrun.test(index)) {
								stopQueue(data[index]);
							}
						}
					}

					for (index = timers.length; index--;) {
						if (timers[index].elem === this && (type == null || timers[index].queue === type)) {

							timers[index].anim.stop(gotoEnd);
							dequeue = false;
							timers.splice(index, 1);
						}
					}

					// Start the next in the queue if the last step wasn't forced.
					// Timers currently will call their complete callbacks, which
					// will dequeue but only if they were gotoEnd.
					if (dequeue || !gotoEnd) {
						jQuery.dequeue(this, type);
					}
				});
			},
			finish: function finish(type) {
				if (type !== false) {
					type = type || "fx";
				}
				return this.each(function () {
					var index,
					    data = dataPriv.get(this),
					    queue = data[type + "queue"],
					    hooks = data[type + "queueHooks"],
					    timers = jQuery.timers,
					    length = queue ? queue.length : 0;

					// Enable finishing flag on private data
					data.finish = true;

					// Empty the queue first
					jQuery.queue(this, type, []);

					if (hooks && hooks.stop) {
						hooks.stop.call(this, true);
					}

					// Look for any active animations, and finish them
					for (index = timers.length; index--;) {
						if (timers[index].elem === this && timers[index].queue === type) {
							timers[index].anim.stop(true);
							timers.splice(index, 1);
						}
					}

					// Look for any animations in the old queue and finish them
					for (index = 0; index < length; index++) {
						if (queue[index] && queue[index].finish) {
							queue[index].finish.call(this);
						}
					}

					// Turn off finishing flag
					delete data.finish;
				});
			}
		});

		jQuery.each(["toggle", "show", "hide"], function (_i, name) {
			var cssFn = jQuery.fn[name];
			jQuery.fn[name] = function (speed, easing, callback) {
				return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
			};
		});

		// Generate shortcuts for custom animations
		jQuery.each({
			slideDown: genFx("show"),
			slideUp: genFx("hide"),
			slideToggle: genFx("toggle"),
			fadeIn: { opacity: "show" },
			fadeOut: { opacity: "hide" },
			fadeToggle: { opacity: "toggle" }
		}, function (name, props) {
			jQuery.fn[name] = function (speed, easing, callback) {
				return this.animate(props, speed, easing, callback);
			};
		});

		jQuery.timers = [];
		jQuery.fx.tick = function () {
			var timer,
			    i = 0,
			    timers = jQuery.timers;

			fxNow = Date.now();

			for (; i < timers.length; i++) {
				timer = timers[i];

				// Run the timer and safely remove it when done (allowing for external removal)
				if (!timer() && timers[i] === timer) {
					timers.splice(i--, 1);
				}
			}

			if (!timers.length) {
				jQuery.fx.stop();
			}
			fxNow = undefined;
		};

		jQuery.fx.timer = function (timer) {
			jQuery.timers.push(timer);
			jQuery.fx.start();
		};

		jQuery.fx.interval = 13;
		jQuery.fx.start = function () {
			if (inProgress) {
				return;
			}

			inProgress = true;
			schedule();
		};

		jQuery.fx.stop = function () {
			inProgress = null;
		};

		jQuery.fx.speeds = {
			slow: 600,
			fast: 200,

			// Default speed
			_default: 400
		};

		// Based off of the plugin by Clint Helfers, with permission.
		jQuery.fn.delay = function (time, type) {
			time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
			type = type || "fx";

			return this.queue(type, function (next, hooks) {
				var timeout = window.setTimeout(next, time);
				hooks.stop = function () {
					window.clearTimeout(timeout);
				};
			});
		};

		(function () {
			var input = document.createElement("input"),
			    select = document.createElement("select"),
			    opt = select.appendChild(document.createElement("option"));

			input.type = "checkbox";

			// Support: Android <=4.3 only
			// Default value for a checkbox should be "on"
			support.checkOn = input.value !== "";

			// Support: IE <=11 only
			// Must access selectedIndex to make default options select
			support.optSelected = opt.selected;

			// Support: IE <=11 only
			// An input loses its value after becoming a radio
			input = document.createElement("input");
			input.value = "t";
			input.type = "radio";
			support.radioValue = input.value === "t";
		})();

		var boolHook,
		    attrHandle = jQuery.expr.attrHandle;

		jQuery.fn.extend({
			attr: function attr(name, value) {
				return access(this, jQuery.attr, name, value, arguments.length > 1);
			},

			removeAttr: function removeAttr(name) {
				return this.each(function () {
					jQuery.removeAttr(this, name);
				});
			}
		});

		jQuery.extend({
			attr: function attr(elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;

				// Don't get/set attributes on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}

				// Fallback to prop when attributes are not supported
				if (typeof elem.getAttribute === "undefined") {
					return jQuery.prop(elem, name, value);
				}

				// Attribute hooks are determined by the lowercase version
				// Grab necessary hook if one is defined
				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
					hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
				}

				if (value !== undefined) {
					if (value === null) {
						jQuery.removeAttr(elem, name);
						return;
					}

					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}

					elem.setAttribute(name, value + "");
					return value;
				}

				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}

				ret = jQuery.find.attr(elem, name);

				// Non-existent attributes return null, we normalize to undefined
				return ret == null ? undefined : ret;
			},

			attrHooks: {
				type: {
					set: function set(elem, value) {
						if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
							var val = elem.value;
							elem.setAttribute("type", value);
							if (val) {
								elem.value = val;
							}
							return value;
						}
					}
				}
			},

			removeAttr: function removeAttr(elem, value) {
				var name,
				    i = 0,


				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match(rnothtmlwhite);

				if (attrNames && elem.nodeType === 1) {
					while (name = attrNames[i++]) {
						elem.removeAttribute(name);
					}
				}
			}
		});

		// Hooks for boolean attributes
		boolHook = {
			set: function set(elem, value, name) {
				if (value === false) {

					// Remove boolean attributes when set to false
					jQuery.removeAttr(elem, name);
				} else {
					elem.setAttribute(name, name);
				}
				return name;
			}
		};

		jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
			var getter = attrHandle[name] || jQuery.find.attr;

			attrHandle[name] = function (elem, name, isXML) {
				var ret,
				    handle,
				    lowercaseName = name.toLowerCase();

				if (!isXML) {

					// Avoid an infinite loop by temporarily removing this function from the getter
					handle = attrHandle[lowercaseName];
					attrHandle[lowercaseName] = ret;
					ret = getter(elem, name, isXML) != null ? lowercaseName : null;
					attrHandle[lowercaseName] = handle;
				}
				return ret;
			};
		});

		var rfocusable = /^(?:input|select|textarea|button)$/i,
		    rclickable = /^(?:a|area)$/i;

		jQuery.fn.extend({
			prop: function prop(name, value) {
				return access(this, jQuery.prop, name, value, arguments.length > 1);
			},

			removeProp: function removeProp(name) {
				return this.each(function () {
					delete this[jQuery.propFix[name] || name];
				});
			}
		});

		jQuery.extend({
			prop: function prop(elem, name, value) {
				var ret,
				    hooks,
				    nType = elem.nodeType;

				// Don't get/set properties on text, comment and attribute nodes
				if (nType === 3 || nType === 8 || nType === 2) {
					return;
				}

				if (nType !== 1 || !jQuery.isXMLDoc(elem)) {

					// Fix name and attach hooks
					name = jQuery.propFix[name] || name;
					hooks = jQuery.propHooks[name];
				}

				if (value !== undefined) {
					if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
						return ret;
					}

					return elem[name] = value;
				}

				if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
					return ret;
				}

				return elem[name];
			},

			propHooks: {
				tabIndex: {
					get: function get(elem) {

						// Support: IE <=9 - 11 only
						// elem.tabIndex doesn't always return the
						// correct value when it hasn't been explicitly set
						// Use proper attribute retrieval (trac-12072)
						var tabindex = jQuery.find.attr(elem, "tabindex");

						if (tabindex) {
							return parseInt(tabindex, 10);
						}

						if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
							return 0;
						}

						return -1;
					}
				}
			},

			propFix: {
				"for": "htmlFor",
				"class": "className"
			}
		});

		// Support: IE <=11 only
		// Accessing the selectedIndex property
		// forces the browser to respect setting selected
		// on the option
		// The getter ensures a default option is selected
		// when in an optgroup
		// eslint rule "no-unused-expressions" is disabled for this code
		// since it considers such accessions noop
		if (!support.optSelected) {
			jQuery.propHooks.selected = {
				get: function get(elem) {

					/* eslint no-unused-expressions: "off" */

					var parent = elem.parentNode;
					if (parent && parent.parentNode) {
						parent.parentNode.selectedIndex;
					}
					return null;
				},
				set: function set(elem) {

					/* eslint no-unused-expressions: "off" */

					var parent = elem.parentNode;
					if (parent) {
						parent.selectedIndex;

						if (parent.parentNode) {
							parent.parentNode.selectedIndex;
						}
					}
				}
			};
		}

		jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
			jQuery.propFix[this.toLowerCase()] = this;
		});

		// Strip and collapse whitespace according to HTML spec
		// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
		function stripAndCollapse(value) {
			var tokens = value.match(rnothtmlwhite) || [];
			return tokens.join(" ");
		}

		function getClass(elem) {
			return elem.getAttribute && elem.getAttribute("class") || "";
		}

		function classesToArray(value) {
			if (Array.isArray(value)) {
				return value;
			}
			if (typeof value === "string") {
				return value.match(rnothtmlwhite) || [];
			}
			return [];
		}

		jQuery.fn.extend({
			addClass: function addClass(value) {
				var classNames, cur, curValue, className, i, finalValue;

				if (isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).addClass(value.call(this, j, getClass(this)));
					});
				}

				classNames = classesToArray(value);

				if (classNames.length) {
					return this.each(function () {
						curValue = getClass(this);
						cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

						if (cur) {
							for (i = 0; i < classNames.length; i++) {
								className = classNames[i];
								if (cur.indexOf(" " + className + " ") < 0) {
									cur += className + " ";
								}
							}

							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse(cur);
							if (curValue !== finalValue) {
								this.setAttribute("class", finalValue);
							}
						}
					});
				}

				return this;
			},

			removeClass: function removeClass(value) {
				var classNames, cur, curValue, className, i, finalValue;

				if (isFunction(value)) {
					return this.each(function (j) {
						jQuery(this).removeClass(value.call(this, j, getClass(this)));
					});
				}

				if (!arguments.length) {
					return this.attr("class", "");
				}

				classNames = classesToArray(value);

				if (classNames.length) {
					return this.each(function () {
						curValue = getClass(this);

						// This expression is here for better compressibility (see addClass)
						cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

						if (cur) {
							for (i = 0; i < classNames.length; i++) {
								className = classNames[i];

								// Remove *all* instances
								while (cur.indexOf(" " + className + " ") > -1) {
									cur = cur.replace(" " + className + " ", " ");
								}
							}

							// Only assign if different to avoid unneeded rendering.
							finalValue = stripAndCollapse(cur);
							if (curValue !== finalValue) {
								this.setAttribute("class", finalValue);
							}
						}
					});
				}

				return this;
			},

			toggleClass: function toggleClass(value, stateVal) {
				var classNames,
				    className,
				    i,
				    self,
				    type = typeof value === "undefined" ? "undefined" : _typeof(value),
				    isValidValue = type === "string" || Array.isArray(value);

				if (isFunction(value)) {
					return this.each(function (i) {
						jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
					});
				}

				if (typeof stateVal === "boolean" && isValidValue) {
					return stateVal ? this.addClass(value) : this.removeClass(value);
				}

				classNames = classesToArray(value);

				return this.each(function () {
					if (isValidValue) {

						// Toggle individual class names
						self = jQuery(this);

						for (i = 0; i < classNames.length; i++) {
							className = classNames[i];

							// Check each className given, space separated list
							if (self.hasClass(className)) {
								self.removeClass(className);
							} else {
								self.addClass(className);
							}
						}

						// Toggle whole class name
					} else if (value === undefined || type === "boolean") {
						className = getClass(this);
						if (className) {

							// Store className if set
							dataPriv.set(this, "__className__", className);
						}

						// If the element has a class name or if we're passed `false`,
						// then remove the whole classname (if there was one, the above saved it).
						// Otherwise bring back whatever was previously saved (if anything),
						// falling back to the empty string if nothing was stored.
						if (this.setAttribute) {
							this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
						}
					}
				});
			},

			hasClass: function hasClass(selector) {
				var className,
				    elem,
				    i = 0;

				className = " " + selector + " ";
				while (elem = this[i++]) {
					if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
						return true;
					}
				}

				return false;
			}
		});

		var rreturn = /\r/g;

		jQuery.fn.extend({
			val: function val(value) {
				var hooks,
				    ret,
				    valueIsFunction,
				    elem = this[0];

				if (!arguments.length) {
					if (elem) {
						hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];

						if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
							return ret;
						}

						ret = elem.value;

						// Handle most common string cases
						if (typeof ret === "string") {
							return ret.replace(rreturn, "");
						}

						// Handle cases where value is null/undef or number
						return ret == null ? "" : ret;
					}

					return;
				}

				valueIsFunction = isFunction(value);

				return this.each(function (i) {
					var val;

					if (this.nodeType !== 1) {
						return;
					}

					if (valueIsFunction) {
						val = value.call(this, i, jQuery(this).val());
					} else {
						val = value;
					}

					// Treat null/undefined as ""; convert numbers to string
					if (val == null) {
						val = "";
					} else if (typeof val === "number") {
						val += "";
					} else if (Array.isArray(val)) {
						val = jQuery.map(val, function (value) {
							return value == null ? "" : value + "";
						});
					}

					hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

					// If set returns undefined, fall back to normal setting
					if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
						this.value = val;
					}
				});
			}
		});

		jQuery.extend({
			valHooks: {
				option: {
					get: function get(elem) {

						var val = jQuery.find.attr(elem, "value");
						return val != null ? val :

						// Support: IE <=10 - 11 only
						// option.text throws exceptions (trac-14686, trac-14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse(jQuery.text(elem));
					}
				},
				select: {
					get: function get(elem) {
						var value,
						    option,
						    i,
						    options = elem.options,
						    index = elem.selectedIndex,
						    one = elem.type === "select-one",
						    values = one ? null : [],
						    max = one ? index + 1 : options.length;

						if (index < 0) {
							i = max;
						} else {
							i = one ? index : 0;
						}

						// Loop through all the selected options
						for (; i < max; i++) {
							option = options[i];

							// Support: IE <=9 only
							// IE8-9 doesn't update selected after form reset (trac-2551)
							if ((option.selected || i === index) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {

								// Get the specific value for the option
								value = jQuery(option).val();

								// We don't need an array for one selects
								if (one) {
									return value;
								}

								// Multi-Selects return an array
								values.push(value);
							}
						}

						return values;
					},

					set: function set(elem, value) {
						var optionSet,
						    option,
						    options = elem.options,
						    values = jQuery.makeArray(value),
						    i = options.length;

						while (i--) {
							option = options[i];

							/* eslint-disable no-cond-assign */

							if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
								optionSet = true;
							}

							/* eslint-enable no-cond-assign */
						}

						// Force browsers to behave consistently when non-matching value is set
						if (!optionSet) {
							elem.selectedIndex = -1;
						}
						return values;
					}
				}
			}
		});

		// Radios and checkboxes getter/setter
		jQuery.each(["radio", "checkbox"], function () {
			jQuery.valHooks[this] = {
				set: function set(elem, value) {
					if (Array.isArray(value)) {
						return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
					}
				}
			};
			if (!support.checkOn) {
				jQuery.valHooks[this].get = function (elem) {
					return elem.getAttribute("value") === null ? "on" : elem.value;
				};
			}
		});

		// Return jQuery for attributes-only inclusion
		var location = window.location;

		var nonce = { guid: Date.now() };

		var rquery = /\?/;

		// Cross-browser xml parsing
		jQuery.parseXML = function (data) {
			var xml, parserErrorElem;
			if (!data || typeof data !== "string") {
				return null;
			}

			// Support: IE 9 - 11 only
			// IE throws on parseFromString with invalid input.
			try {
				xml = new window.DOMParser().parseFromString(data, "text/xml");
			} catch (e) {}

			parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
			if (!xml || parserErrorElem) {
				jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
					return el.textContent;
				}).join("\n") : data));
			}
			return xml;
		};

		var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
		    stopPropagationCallback = function stopPropagationCallback(e) {
			e.stopPropagation();
		};

		jQuery.extend(jQuery.event, {

			trigger: function trigger(event, data, elem, onlyHandlers) {

				var i,
				    cur,
				    tmp,
				    bubbleType,
				    ontype,
				    handle,
				    special,
				    lastElement,
				    eventPath = [elem || document],
				    type = hasOwn.call(event, "type") ? event.type : event,
				    namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];

				cur = lastElement = tmp = elem = elem || document;

				// Don't do events on text and comment nodes
				if (elem.nodeType === 3 || elem.nodeType === 8) {
					return;
				}

				// focus/blur morphs to focusin/out; ensure we're not firing them right now
				if (rfocusMorph.test(type + jQuery.event.triggered)) {
					return;
				}

				if (type.indexOf(".") > -1) {

					// Namespaced trigger; create a regexp to match event type in handle()
					namespaces = type.split(".");
					type = namespaces.shift();
					namespaces.sort();
				}
				ontype = type.indexOf(":") < 0 && "on" + type;

				// Caller can pass in a jQuery.Event object, Object, or just an event type string
				event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : _typeof(event)) === "object" && event);

				// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
				event.isTrigger = onlyHandlers ? 2 : 3;
				event.namespace = namespaces.join(".");
				event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

				// Clean up the event in case it is being reused
				event.result = undefined;
				if (!event.target) {
					event.target = elem;
				}

				// Clone any incoming data and prepend the event, creating the handler arg list
				data = data == null ? [event] : jQuery.makeArray(data, [event]);

				// Allow special events to draw outside the lines
				special = jQuery.event.special[type] || {};
				if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
					return;
				}

				// Determine event propagation path in advance, per W3C events spec (trac-9951)
				// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
				if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {

					bubbleType = special.delegateType || type;
					if (!rfocusMorph.test(bubbleType + type)) {
						cur = cur.parentNode;
					}
					for (; cur; cur = cur.parentNode) {
						eventPath.push(cur);
						tmp = cur;
					}

					// Only add window if we got to document (e.g., not plain obj or detached DOM)
					if (tmp === (elem.ownerDocument || document)) {
						eventPath.push(tmp.defaultView || tmp.parentWindow || window);
					}
				}

				// Fire handlers on the event path
				i = 0;
				while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
					lastElement = cur;
					event.type = i > 1 ? bubbleType : special.bindType || type;

					// jQuery handler
					handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
					if (handle) {
						handle.apply(cur, data);
					}

					// Native handler
					handle = ontype && cur[ontype];
					if (handle && handle.apply && acceptData(cur)) {
						event.result = handle.apply(cur, data);
						if (event.result === false) {
							event.preventDefault();
						}
					}
				}
				event.type = type;

				// If nobody prevented the default action, do it now
				if (!onlyHandlers && !event.isDefaultPrevented()) {

					if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {

						// Call a native DOM method on the target with the same name as the event.
						// Don't do default actions on window, that's where global variables be (trac-6170)
						if (ontype && isFunction(elem[type]) && !isWindow(elem)) {

							// Don't re-trigger an onFOO event when we call its FOO() method
							tmp = elem[ontype];

							if (tmp) {
								elem[ontype] = null;
							}

							// Prevent re-triggering of the same event, since we already bubbled it above
							jQuery.event.triggered = type;

							if (event.isPropagationStopped()) {
								lastElement.addEventListener(type, stopPropagationCallback);
							}

							elem[type]();

							if (event.isPropagationStopped()) {
								lastElement.removeEventListener(type, stopPropagationCallback);
							}

							jQuery.event.triggered = undefined;

							if (tmp) {
								elem[ontype] = tmp;
							}
						}
					}
				}

				return event.result;
			},

			// Piggyback on a donor event to simulate a different one
			// Used only for `focus(in | out)` events
			simulate: function simulate(type, elem, event) {
				var e = jQuery.extend(new jQuery.Event(), event, {
					type: type,
					isSimulated: true
				});

				jQuery.event.trigger(e, null, elem);
			}

		});

		jQuery.fn.extend({

			trigger: function trigger(type, data) {
				return this.each(function () {
					jQuery.event.trigger(type, data, this);
				});
			},
			triggerHandler: function triggerHandler(type, data) {
				var elem = this[0];
				if (elem) {
					return jQuery.event.trigger(type, data, elem, true);
				}
			}
		});

		var rbracket = /\[\]$/,
		    rCRLF = /\r?\n/g,
		    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		    rsubmittable = /^(?:input|select|textarea|keygen)/i;

		function buildParams(prefix, obj, traditional, add) {
			var name;

			if (Array.isArray(obj)) {

				// Serialize array item.
				jQuery.each(obj, function (i, v) {
					if (traditional || rbracket.test(prefix)) {

						// Treat each array item as a scalar.
						add(prefix, v);
					} else {

						// Item is non-scalar (array or object), encode its numeric index.
						buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : _typeof(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
					}
				});
			} else if (!traditional && toType(obj) === "object") {

				// Serialize object item.
				for (name in obj) {
					buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
				}
			} else {

				// Serialize scalar item.
				add(prefix, obj);
			}
		}

		// Serialize an array of form elements or a set of
		// key/values into a query string
		jQuery.param = function (a, traditional) {
			var prefix,
			    s = [],
			    add = function add(key, valueOrFunction) {

				// If value is a function, invoke it and use its return value
				var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;

				s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
			};

			if (a == null) {
				return "";
			}

			// If an array was passed in, assume that it is an array of form elements.
			if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {

				// Serialize the form elements
				jQuery.each(a, function () {
					add(this.name, this.value);
				});
			} else {

				// If traditional, encode the "old" way (the way 1.3.2 or older
				// did it), otherwise encode params recursively.
				for (prefix in a) {
					buildParams(prefix, a[prefix], traditional, add);
				}
			}

			// Return the resulting serialization
			return s.join("&");
		};

		jQuery.fn.extend({
			serialize: function serialize() {
				return jQuery.param(this.serializeArray());
			},
			serializeArray: function serializeArray() {
				return this.map(function () {

					// Can add propHook for "elements" to filter or add form elements
					var elements = jQuery.prop(this, "elements");
					return elements ? jQuery.makeArray(elements) : this;
				}).filter(function () {
					var type = this.type;

					// Use .is( ":disabled" ) so that fieldset[disabled] works
					return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
				}).map(function (_i, elem) {
					var val = jQuery(this).val();

					if (val == null) {
						return null;
					}

					if (Array.isArray(val)) {
						return jQuery.map(val, function (val) {
							return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
						});
					}

					return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
				}).get();
			}
		});

		var r20 = /%20/g,
		    rhash = /#.*$/,
		    rantiCache = /([?&])_=[^&]*/,
		    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,


		// trac-7653, trac-8125, trac-8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		    rnoContent = /^(?:GET|HEAD)$/,
		    rprotocol = /^\/\//,


		/* Prefilters
	  * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	  * 2) These are called:
	  *    - BEFORE asking for a transport
	  *    - AFTER param serialization (s.data is a string if s.processData is true)
	  * 3) key is the dataType
	  * 4) the catchall symbol "*" can be used
	  * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	  */
		prefilters = {},


		/* Transports bindings
	  * 1) key is the dataType
	  * 2) the catchall symbol "*" can be used
	  * 3) selection will start with transport dataType and THEN go to "*" if needed
	  */
		transports = {},


		// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
		allTypes = "*/".concat("*"),


		// Anchor tag for parsing the document origin
		originAnchor = document.createElement("a");

		originAnchor.href = location.href;

		// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
		function addToPrefiltersOrTransports(structure) {

			// dataTypeExpression is optional and defaults to "*"
			return function (dataTypeExpression, func) {

				if (typeof dataTypeExpression !== "string") {
					func = dataTypeExpression;
					dataTypeExpression = "*";
				}

				var dataType,
				    i = 0,
				    dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

				if (isFunction(func)) {

					// For each dataType in the dataTypeExpression
					while (dataType = dataTypes[i++]) {

						// Prepend if requested
						if (dataType[0] === "+") {
							dataType = dataType.slice(1) || "*";
							(structure[dataType] = structure[dataType] || []).unshift(func);

							// Otherwise append
						} else {
							(structure[dataType] = structure[dataType] || []).push(func);
						}
					}
				}
			};
		}

		// Base inspection function for prefilters and transports
		function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {

			var inspected = {},
			    seekingTransport = structure === transports;

			function inspect(dataType) {
				var selected;
				inspected[dataType] = true;
				jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
					var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
					if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {

						options.dataTypes.unshift(dataTypeOrTransport);
						inspect(dataTypeOrTransport);
						return false;
					} else if (seekingTransport) {
						return !(selected = dataTypeOrTransport);
					}
				});
				return selected;
			}

			return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
		}

		// A special extend for ajax options
		// that takes "flat" options (not to be deep extended)
		// Fixes trac-9887
		function ajaxExtend(target, src) {
			var key,
			    deep,
			    flatOptions = jQuery.ajaxSettings.flatOptions || {};

			for (key in src) {
				if (src[key] !== undefined) {
					(flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
				}
			}
			if (deep) {
				jQuery.extend(true, target, deep);
			}

			return target;
		}

		/* Handles responses to an ajax request:
	  * - finds the right dataType (mediates between content-type and expected dataType)
	  * - returns the corresponding response
	  */
		function ajaxHandleResponses(s, jqXHR, responses) {

			var ct,
			    type,
			    finalDataType,
			    firstDataType,
			    contents = s.contents,
			    dataTypes = s.dataTypes;

			// Remove auto dataType and get content-type in the process
			while (dataTypes[0] === "*") {
				dataTypes.shift();
				if (ct === undefined) {
					ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
				}
			}

			// Check if we're dealing with a known content-type
			if (ct) {
				for (type in contents) {
					if (contents[type] && contents[type].test(ct)) {
						dataTypes.unshift(type);
						break;
					}
				}
			}

			// Check to see if we have a response for the expected dataType
			if (dataTypes[0] in responses) {
				finalDataType = dataTypes[0];
			} else {

				// Try convertible dataTypes
				for (type in responses) {
					if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
						finalDataType = type;
						break;
					}
					if (!firstDataType) {
						firstDataType = type;
					}
				}

				// Or just use first one
				finalDataType = finalDataType || firstDataType;
			}

			// If we found a dataType
			// We add the dataType to the list if needed
			// and return the corresponding response
			if (finalDataType) {
				if (finalDataType !== dataTypes[0]) {
					dataTypes.unshift(finalDataType);
				}
				return responses[finalDataType];
			}
		}

		/* Chain conversions given the request and the original response
	  * Also sets the responseXXX fields on the jqXHR instance
	  */
		function ajaxConvert(s, response, jqXHR, isSuccess) {
			var conv2,
			    current,
			    conv,
			    tmp,
			    prev,
			    converters = {},


			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();

			// Create converters map with lowercased keys
			if (dataTypes[1]) {
				for (conv in s.converters) {
					converters[conv.toLowerCase()] = s.converters[conv];
				}
			}

			current = dataTypes.shift();

			// Convert to each sequential dataType
			while (current) {

				if (s.responseFields[current]) {
					jqXHR[s.responseFields[current]] = response;
				}

				// Apply the dataFilter if provided
				if (!prev && isSuccess && s.dataFilter) {
					response = s.dataFilter(response, s.dataType);
				}

				prev = current;
				current = dataTypes.shift();

				if (current) {

					// There's only work to do if current dataType is non-auto
					if (current === "*") {

						current = prev;

						// Convert response if prev dataType is non-auto and differs from current
					} else if (prev !== "*" && prev !== current) {

						// Seek a direct converter
						conv = converters[prev + " " + current] || converters["* " + current];

						// If none found, seek a pair
						if (!conv) {
							for (conv2 in converters) {

								// If conv2 outputs current
								tmp = conv2.split(" ");
								if (tmp[1] === current) {

									// If prev can be converted to accepted input
									conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
									if (conv) {

										// Condense equivalence converters
										if (conv === true) {
											conv = converters[conv2];

											// Otherwise, insert the intermediate dataType
										} else if (converters[conv2] !== true) {
											current = tmp[0];
											dataTypes.unshift(tmp[1]);
										}
										break;
									}
								}
							}
						}

						// Apply converter (if not an equivalence)
						if (conv !== true) {

							// Unless errors are allowed to bubble, catch and return them
							if (conv && s.throws) {
								response = conv(response);
							} else {
								try {
									response = conv(response);
								} catch (e) {
									return {
										state: "parsererror",
										error: conv ? e : "No conversion from " + prev + " to " + current
									};
								}
							}
						}
					}
				}
			}

			return { state: "success", data: response };
		}

		jQuery.extend({

			// Counter for holding the number of active queries
			active: 0,

			// Last-Modified header cache for next request
			lastModified: {},
			etag: {},

			ajaxSettings: {
				url: location.href,
				type: "GET",
				isLocal: rlocalProtocol.test(location.protocol),
				global: true,
				processData: true,
				async: true,
				contentType: "application/x-www-form-urlencoded; charset=UTF-8",

				/*
	   timeout: 0,
	   data: null,
	   dataType: null,
	   username: null,
	   password: null,
	   cache: null,
	   throws: false,
	   traditional: false,
	   headers: {},
	   */

				accepts: {
					"*": allTypes,
					text: "text/plain",
					html: "text/html",
					xml: "application/xml, text/xml",
					json: "application/json, text/javascript"
				},

				contents: {
					xml: /\bxml\b/,
					html: /\bhtml/,
					json: /\bjson\b/
				},

				responseFields: {
					xml: "responseXML",
					text: "responseText",
					json: "responseJSON"
				},

				// Data converters
				// Keys separate source (or catchall "*") and destination types with a single space
				converters: {

					// Convert anything to text
					"* text": String,

					// Text to html (true = no transformation)
					"text html": true,

					// Evaluate text as a json expression
					"text json": JSON.parse,

					// Parse text as xml
					"text xml": jQuery.parseXML
				},

				// For options that shouldn't be deep extended:
				// you can add your own custom options here if
				// and when you create one that shouldn't be
				// deep extended (see ajaxExtend)
				flatOptions: {
					url: true,
					context: true
				}
			},

			// Creates a full fledged settings object into target
			// with both ajaxSettings and settings fields.
			// If target is omitted, writes into ajaxSettings.
			ajaxSetup: function ajaxSetup(target, settings) {
				return settings ?

				// Building a settings object
				ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :

				// Extending ajaxSettings
				ajaxExtend(jQuery.ajaxSettings, target);
			},

			ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
			ajaxTransport: addToPrefiltersOrTransports(transports),

			// Main method
			ajax: function ajax(url, options) {

				// If url is an object, simulate pre-1.5 signature
				if ((typeof url === "undefined" ? "undefined" : _typeof(url)) === "object") {
					options = url;
					url = undefined;
				}

				// Force options to be an object
				options = options || {};

				var transport,


				// URL without anti-cache param
				cacheURL,


				// Response headers
				responseHeadersString,
				    responseHeaders,


				// timeout handle
				timeoutTimer,


				// Url cleanup var
				urlAnchor,


				// Request state (becomes false upon send and true upon completion)
				completed,


				// To know if global events are to be dispatched
				fireGlobals,


				// Loop variable
				i,


				// uncached part of the url
				uncached,


				// Create the final options object
				s = jQuery.ajaxSetup({}, options),


				// Callbacks context
				callbackContext = s.context || s,


				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,


				// Deferreds
				deferred = jQuery.Deferred(),
				    completeDeferred = jQuery.Callbacks("once memory"),


				// Status-dependent callbacks
				_statusCode = s.statusCode || {},


				// Headers (they are sent all at once)
				requestHeaders = {},
				    requestHeadersNames = {},


				// Default abort message
				strAbort = "canceled",


				// Fake xhr
				jqXHR = {
					readyState: 0,

					// Builds headers hashtable if needed
					getResponseHeader: function getResponseHeader(key) {
						var match;
						if (completed) {
							if (!responseHeaders) {
								responseHeaders = {};
								while (match = rheaders.exec(responseHeadersString)) {
									responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
								}
							}
							match = responseHeaders[key.toLowerCase() + " "];
						}
						return match == null ? null : match.join(", ");
					},

					// Raw string
					getAllResponseHeaders: function getAllResponseHeaders() {
						return completed ? responseHeadersString : null;
					},

					// Caches the header
					setRequestHeader: function setRequestHeader(name, value) {
						if (completed == null) {
							name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
							requestHeaders[name] = value;
						}
						return this;
					},

					// Overrides response content-type header
					overrideMimeType: function overrideMimeType(type) {
						if (completed == null) {
							s.mimeType = type;
						}
						return this;
					},

					// Status-dependent callbacks
					statusCode: function statusCode(map) {
						var code;
						if (map) {
							if (completed) {

								// Execute the appropriate callbacks
								jqXHR.always(map[jqXHR.status]);
							} else {

								// Lazy-add the new callbacks in a way that preserves old ones
								for (code in map) {
									_statusCode[code] = [_statusCode[code], map[code]];
								}
							}
						}
						return this;
					},

					// Cancel the request
					abort: function abort(statusText) {
						var finalText = statusText || strAbort;
						if (transport) {
							transport.abort(finalText);
						}
						done(0, finalText);
						return this;
					}
				};

				// Attach deferreds
				deferred.promise(jqXHR);

				// Add protocol if not provided (prefilters might expect it)
				// Handle falsy url in the settings object (trac-10093: consistency with old signature)
				// We also use the url parameter if available
				s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

				// Alias method option to type as per ticket trac-12004
				s.type = options.method || options.type || s.method || s.type;

				// Extract dataTypes list
				s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

				// A cross-domain request is in order when the origin doesn't match the current origin.
				if (s.crossDomain == null) {
					urlAnchor = document.createElement("a");

					// Support: IE <=8 - 11, Edge 12 - 15
					// IE throws exception on accessing the href property if url is malformed,
					// e.g. http://example.com:80x/
					try {
						urlAnchor.href = s.url;

						// Support: IE <=8 - 11 only
						// Anchor's host property isn't correctly set when s.url is relative
						urlAnchor.href = urlAnchor.href;
						s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
					} catch (e) {

						// If there is an error parsing the URL, assume it is crossDomain,
						// it can be rejected by the transport if it is invalid
						s.crossDomain = true;
					}
				}

				// Convert data if not already a string
				if (s.data && s.processData && typeof s.data !== "string") {
					s.data = jQuery.param(s.data, s.traditional);
				}

				// Apply prefilters
				inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

				// If request was aborted inside a prefilter, stop there
				if (completed) {
					return jqXHR;
				}

				// We can fire global events as of now if asked to
				// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
				fireGlobals = jQuery.event && s.global;

				// Watch for a new set of requests
				if (fireGlobals && jQuery.active++ === 0) {
					jQuery.event.trigger("ajaxStart");
				}

				// Uppercase the type
				s.type = s.type.toUpperCase();

				// Determine if request has content
				s.hasContent = !rnoContent.test(s.type);

				// Save the URL in case we're toying with the If-Modified-Since
				// and/or If-None-Match header later on
				// Remove hash to simplify url manipulation
				cacheURL = s.url.replace(rhash, "");

				// More options handling for requests with no content
				if (!s.hasContent) {

					// Remember the hash so we can put it back
					uncached = s.url.slice(cacheURL.length);

					// If data is available and should be processed, append data to url
					if (s.data && (s.processData || typeof s.data === "string")) {
						cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

						// trac-9682: remove data so that it's not used in an eventual retry
						delete s.data;
					}

					// Add or update anti-cache param if needed
					if (s.cache === false) {
						cacheURL = cacheURL.replace(rantiCache, "$1");
						uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
					}

					// Put hash and anti-cache on the URL that will be requested (gh-1732)
					s.url = cacheURL + uncached;

					// Change '%20' to '+' if this is encoded form body content (gh-2658)
				} else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
					s.data = s.data.replace(r20, "+");
				}

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if (s.ifModified) {
					if (jQuery.lastModified[cacheURL]) {
						jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
					}
					if (jQuery.etag[cacheURL]) {
						jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
					}
				}

				// Set the correct header, if data is being sent
				if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
					jqXHR.setRequestHeader("Content-Type", s.contentType);
				}

				// Set the Accepts header for the server, depending on the dataType
				jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

				// Check for headers option
				for (i in s.headers) {
					jqXHR.setRequestHeader(i, s.headers[i]);
				}

				// Allow custom headers/mimetypes and early abort
				if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {

					// Abort if not done already and return
					return jqXHR.abort();
				}

				// Aborting is no longer a cancellation
				strAbort = "abort";

				// Install callbacks on deferreds
				completeDeferred.add(s.complete);
				jqXHR.done(s.success);
				jqXHR.fail(s.error);

				// Get transport
				transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

				// If no transport, we auto-abort
				if (!transport) {
					done(-1, "No Transport");
				} else {
					jqXHR.readyState = 1;

					// Send global event
					if (fireGlobals) {
						globalEventContext.trigger("ajaxSend", [jqXHR, s]);
					}

					// If request was aborted inside ajaxSend, stop there
					if (completed) {
						return jqXHR;
					}

					// Timeout
					if (s.async && s.timeout > 0) {
						timeoutTimer = window.setTimeout(function () {
							jqXHR.abort("timeout");
						}, s.timeout);
					}

					try {
						completed = false;
						transport.send(requestHeaders, done);
					} catch (e) {

						// Rethrow post-completion exceptions
						if (completed) {
							throw e;
						}

						// Propagate others as results
						done(-1, e);
					}
				}

				// Callback for when everything is done
				function done(status, nativeStatusText, responses, headers) {
					var isSuccess,
					    success,
					    error,
					    response,
					    modified,
					    statusText = nativeStatusText;

					// Ignore repeat invocations
					if (completed) {
						return;
					}

					completed = true;

					// Clear timeout if it exists
					if (timeoutTimer) {
						window.clearTimeout(timeoutTimer);
					}

					// Dereference transport for early garbage collection
					// (no matter how long the jqXHR object will be used)
					transport = undefined;

					// Cache response headers
					responseHeadersString = headers || "";

					// Set readyState
					jqXHR.readyState = status > 0 ? 4 : 0;

					// Determine if successful
					isSuccess = status >= 200 && status < 300 || status === 304;

					// Get response data
					if (responses) {
						response = ajaxHandleResponses(s, jqXHR, responses);
					}

					// Use a noop converter for missing script but not if jsonp
					if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
						s.converters["text script"] = function () {};
					}

					// Convert no matter what (that way responseXXX fields are always set)
					response = ajaxConvert(s, response, jqXHR, isSuccess);

					// If successful, handle type chaining
					if (isSuccess) {

						// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
						if (s.ifModified) {
							modified = jqXHR.getResponseHeader("Last-Modified");
							if (modified) {
								jQuery.lastModified[cacheURL] = modified;
							}
							modified = jqXHR.getResponseHeader("etag");
							if (modified) {
								jQuery.etag[cacheURL] = modified;
							}
						}

						// if no content
						if (status === 204 || s.type === "HEAD") {
							statusText = "nocontent";

							// if not modified
						} else if (status === 304) {
							statusText = "notmodified";

							// If we have data, let's convert it
						} else {
							statusText = response.state;
							success = response.data;
							error = response.error;
							isSuccess = !error;
						}
					} else {

						// Extract error from statusText and normalize for non-aborts
						error = statusText;
						if (status || !statusText) {
							statusText = "error";
							if (status < 0) {
								status = 0;
							}
						}
					}

					// Set data for the fake xhr object
					jqXHR.status = status;
					jqXHR.statusText = (nativeStatusText || statusText) + "";

					// Success/Error
					if (isSuccess) {
						deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
					} else {
						deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
					}

					// Status-dependent callbacks
					jqXHR.statusCode(_statusCode);
					_statusCode = undefined;

					if (fireGlobals) {
						globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
					}

					// Complete
					completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

					if (fireGlobals) {
						globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

						// Handle the global AJAX counter
						if (! --jQuery.active) {
							jQuery.event.trigger("ajaxStop");
						}
					}
				}

				return jqXHR;
			},

			getJSON: function getJSON(url, data, callback) {
				return jQuery.get(url, data, callback, "json");
			},

			getScript: function getScript(url, callback) {
				return jQuery.get(url, undefined, callback, "script");
			}
		});

		jQuery.each(["get", "post"], function (_i, method) {
			jQuery[method] = function (url, data, callback, type) {

				// Shift arguments if data argument was omitted
				if (isFunction(data)) {
					type = type || callback;
					callback = data;
					data = undefined;
				}

				// The url can be an options object (which then must have .url)
				return jQuery.ajax(jQuery.extend({
					url: url,
					type: method,
					dataType: type,
					data: data,
					success: callback
				}, jQuery.isPlainObject(url) && url));
			};
		});

		jQuery.ajaxPrefilter(function (s) {
			var i;
			for (i in s.headers) {
				if (i.toLowerCase() === "content-type") {
					s.contentType = s.headers[i] || "";
				}
			}
		});

		jQuery._evalUrl = function (url, options, doc) {
			return jQuery.ajax({
				url: url,

				// Make this explicit, since user can override this through ajaxSetup (trac-11264)
				type: "GET",
				dataType: "script",
				cache: true,
				async: false,
				global: false,

				// Only evaluate the response if it is successful (gh-4126)
				// dataFilter is not invoked for failure responses, so using it instead
				// of the default converter is kludgy but it works.
				converters: {
					"text script": function textScript() {}
				},
				dataFilter: function dataFilter(response) {
					jQuery.globalEval(response, options, doc);
				}
			});
		};

		jQuery.fn.extend({
			wrapAll: function wrapAll(html) {
				var wrap;

				if (this[0]) {
					if (isFunction(html)) {
						html = html.call(this[0]);
					}

					// The elements to wrap the target around
					wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

					if (this[0].parentNode) {
						wrap.insertBefore(this[0]);
					}

					wrap.map(function () {
						var elem = this;

						while (elem.firstElementChild) {
							elem = elem.firstElementChild;
						}

						return elem;
					}).append(this);
				}

				return this;
			},

			wrapInner: function wrapInner(html) {
				if (isFunction(html)) {
					return this.each(function (i) {
						jQuery(this).wrapInner(html.call(this, i));
					});
				}

				return this.each(function () {
					var self = jQuery(this),
					    contents = self.contents();

					if (contents.length) {
						contents.wrapAll(html);
					} else {
						self.append(html);
					}
				});
			},

			wrap: function wrap(html) {
				var htmlIsFunction = isFunction(html);

				return this.each(function (i) {
					jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
				});
			},

			unwrap: function unwrap(selector) {
				this.parent(selector).not("body").each(function () {
					jQuery(this).replaceWith(this.childNodes);
				});
				return this;
			}
		});

		jQuery.expr.pseudos.hidden = function (elem) {
			return !jQuery.expr.pseudos.visible(elem);
		};
		jQuery.expr.pseudos.visible = function (elem) {
			return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
		};

		jQuery.ajaxSettings.xhr = function () {
			try {
				return new window.XMLHttpRequest();
			} catch (e) {}
		};

		var xhrSuccessStatus = {

			// File protocol always yields status code 0, assume 200
			0: 200,

			// Support: IE <=9 only
			// trac-1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		    xhrSupported = jQuery.ajaxSettings.xhr();

		support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
		support.ajax = xhrSupported = !!xhrSupported;

		jQuery.ajaxTransport(function (options) {
			var _callback, errorCallback;

			// Cross domain only allowed if supported through XMLHttpRequest
			if (support.cors || xhrSupported && !options.crossDomain) {
				return {
					send: function send(headers, complete) {
						var i,
						    xhr = options.xhr();

						xhr.open(options.type, options.url, options.async, options.username, options.password);

						// Apply custom fields if provided
						if (options.xhrFields) {
							for (i in options.xhrFields) {
								xhr[i] = options.xhrFields[i];
							}
						}

						// Override mime type if needed
						if (options.mimeType && xhr.overrideMimeType) {
							xhr.overrideMimeType(options.mimeType);
						}

						// X-Requested-With header
						// For cross-domain requests, seeing as conditions for a preflight are
						// akin to a jigsaw puzzle, we simply never set it to be sure.
						// (it can always be set on a per-request basis or even using ajaxSetup)
						// For same-domain requests, won't change header if already provided.
						if (!options.crossDomain && !headers["X-Requested-With"]) {
							headers["X-Requested-With"] = "XMLHttpRequest";
						}

						// Set headers
						for (i in headers) {
							xhr.setRequestHeader(i, headers[i]);
						}

						// Callback
						_callback = function callback(type) {
							return function () {
								if (_callback) {
									_callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;

									if (type === "abort") {
										xhr.abort();
									} else if (type === "error") {

										// Support: IE <=9 only
										// On a manual native abort, IE9 throws
										// errors on any property access that is not readyState
										if (typeof xhr.status !== "number") {
											complete(0, "error");
										} else {
											complete(

											// File: protocol always yields status 0; see trac-8605, trac-14207
											xhr.status, xhr.statusText);
										}
									} else {
										complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,

										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										(xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? { binary: xhr.response } : { text: xhr.responseText }, xhr.getAllResponseHeaders());
									}
								}
							};
						};

						// Listen to events
						xhr.onload = _callback();
						errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

						// Support: IE 9 only
						// Use onreadystatechange to replace onabort
						// to handle uncaught aborts
						if (xhr.onabort !== undefined) {
							xhr.onabort = errorCallback;
						} else {
							xhr.onreadystatechange = function () {

								// Check readyState before timeout as it changes
								if (xhr.readyState === 4) {

									// Allow onerror to be called first,
									// but that will not handle a native abort
									// Also, save errorCallback to a variable
									// as xhr.onerror cannot be accessed
									window.setTimeout(function () {
										if (_callback) {
											errorCallback();
										}
									});
								}
							};
						}

						// Create the abort callback
						_callback = _callback("abort");

						try {

							// Do send the request (this may raise an exception)
							xhr.send(options.hasContent && options.data || null);
						} catch (e) {

							// trac-14683: Only rethrow if this hasn't been notified as an error yet
							if (_callback) {
								throw e;
							}
						}
					},

					abort: function abort() {
						if (_callback) {
							_callback();
						}
					}
				};
			}
		});

		// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
		jQuery.ajaxPrefilter(function (s) {
			if (s.crossDomain) {
				s.contents.script = false;
			}
		});

		// Install script dataType
		jQuery.ajaxSetup({
			accepts: {
				script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
			},
			contents: {
				script: /\b(?:java|ecma)script\b/
			},
			converters: {
				"text script": function textScript(text) {
					jQuery.globalEval(text);
					return text;
				}
			}
		});

		// Handle cache's special case and crossDomain
		jQuery.ajaxPrefilter("script", function (s) {
			if (s.cache === undefined) {
				s.cache = false;
			}
			if (s.crossDomain) {
				s.type = "GET";
			}
		});

		// Bind script tag hack transport
		jQuery.ajaxTransport("script", function (s) {

			// This transport only deals with cross domain or forced-by-attrs requests
			if (s.crossDomain || s.scriptAttrs) {
				var script, _callback2;
				return {
					send: function send(_, complete) {
						script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({ charset: s.scriptCharset, src: s.url }).on("load error", _callback2 = function callback(evt) {
							script.remove();
							_callback2 = null;
							if (evt) {
								complete(evt.type === "error" ? 404 : 200, evt.type);
							}
						});

						// Use native DOM manipulation to avoid our domManip AJAX trickery
						document.head.appendChild(script[0]);
					},
					abort: function abort() {
						if (_callback2) {
							_callback2();
						}
					}
				};
			}
		});

		var oldCallbacks = [],
		    rjsonp = /(=)\?(?=&|$)|\?\?/;

		// Default jsonp settings
		jQuery.ajaxSetup({
			jsonp: "callback",
			jsonpCallback: function jsonpCallback() {
				var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
				this[callback] = true;
				return callback;
			}
		});

		// Detect, normalize options and install callbacks for jsonp requests
		jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {

			var callbackName,
			    overwritten,
			    responseContainer,
			    jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

			// Handle iff the expected data type is "jsonp" or we have a parameter to set
			if (jsonProp || s.dataTypes[0] === "jsonp") {

				// Get callback name, remembering preexisting value associated with it
				callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

				// Insert callback into url or form data
				if (jsonProp) {
					s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
				} else if (s.jsonp !== false) {
					s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
				}

				// Use data converter to retrieve json after script execution
				s.converters["script json"] = function () {
					if (!responseContainer) {
						jQuery.error(callbackName + " was not called");
					}
					return responseContainer[0];
				};

				// Force json dataType
				s.dataTypes[0] = "json";

				// Install callback
				overwritten = window[callbackName];
				window[callbackName] = function () {
					responseContainer = arguments;
				};

				// Clean-up function (fires after converters)
				jqXHR.always(function () {

					// If previous value didn't exist - remove it
					if (overwritten === undefined) {
						jQuery(window).removeProp(callbackName);

						// Otherwise restore preexisting value
					} else {
						window[callbackName] = overwritten;
					}

					// Save back as free
					if (s[callbackName]) {

						// Make sure that re-using the options doesn't screw things around
						s.jsonpCallback = originalSettings.jsonpCallback;

						// Save the callback name for future use
						oldCallbacks.push(callbackName);
					}

					// Call if it was a function and we have a response
					if (responseContainer && isFunction(overwritten)) {
						overwritten(responseContainer[0]);
					}

					responseContainer = overwritten = undefined;
				});

				// Delegate to script
				return "script";
			}
		});

		// Support: Safari 8 only
		// In Safari 8 documents created via document.implementation.createHTMLDocument
		// collapse sibling forms: the second one becomes a child of the first one.
		// Because of that, this security measure has to be disabled in Safari 8.
		// https://bugs.webkit.org/show_bug.cgi?id=137337
		support.createHTMLDocument = function () {
			var body = document.implementation.createHTMLDocument("").body;
			body.innerHTML = "<form></form><form></form>";
			return body.childNodes.length === 2;
		}();

		// Argument "data" should be string of html
		// context (optional): If specified, the fragment will be created in this context,
		// defaults to document
		// keepScripts (optional): If true, will include scripts passed in the html string
		jQuery.parseHTML = function (data, context, keepScripts) {
			if (typeof data !== "string") {
				return [];
			}
			if (typeof context === "boolean") {
				keepScripts = context;
				context = false;
			}

			var base, parsed, scripts;

			if (!context) {

				// Stop scripts or inline event handlers from being executed immediately
				// by using document.implementation
				if (support.createHTMLDocument) {
					context = document.implementation.createHTMLDocument("");

					// Set the base href for the created document
					// so any parsed elements with URLs
					// are based on the document's URL (gh-2965)
					base = context.createElement("base");
					base.href = document.location.href;
					context.head.appendChild(base);
				} else {
					context = document;
				}
			}

			parsed = rsingleTag.exec(data);
			scripts = !keepScripts && [];

			// Single tag
			if (parsed) {
				return [context.createElement(parsed[1])];
			}

			parsed = buildFragment([data], context, scripts);

			if (scripts && scripts.length) {
				jQuery(scripts).remove();
			}

			return jQuery.merge([], parsed.childNodes);
		};

		/**
	  * Load a url into a page
	  */
		jQuery.fn.load = function (url, params, callback) {
			var selector,
			    type,
			    response,
			    self = this,
			    off = url.indexOf(" ");

			if (off > -1) {
				selector = stripAndCollapse(url.slice(off));
				url = url.slice(0, off);
			}

			// If it's a function
			if (isFunction(params)) {

				// We assume that it's the callback
				callback = params;
				params = undefined;

				// Otherwise, build a param string
			} else if (params && (typeof params === "undefined" ? "undefined" : _typeof(params)) === "object") {
				type = "POST";
			}

			// If we have elements to modify, make the request
			if (self.length > 0) {
				jQuery.ajax({
					url: url,

					// If "type" variable is undefined, then "GET" method will be used.
					// Make value of this field explicit since
					// user can override it through ajaxSetup method
					type: type || "GET",
					dataType: "html",
					data: params
				}).done(function (responseText) {

					// Save response for use in complete callback
					response = arguments;

					self.html(selector ?

					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :

					// Otherwise use the full result
					responseText);

					// If the request succeeds, this function gets "data", "status", "jqXHR"
					// but they are ignored because response was set above.
					// If it fails, this function gets "jqXHR", "status", "error"
				}).always(callback && function (jqXHR, status) {
					self.each(function () {
						callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
					});
				});
			}

			return this;
		};

		jQuery.expr.pseudos.animated = function (elem) {
			return jQuery.grep(jQuery.timers, function (fn) {
				return elem === fn.elem;
			}).length;
		};

		jQuery.offset = {
			setOffset: function setOffset(elem, options, i) {
				var curPosition,
				    curLeft,
				    curCSSTop,
				    curTop,
				    curOffset,
				    curCSSLeft,
				    calculatePosition,
				    position = jQuery.css(elem, "position"),
				    curElem = jQuery(elem),
				    props = {};

				// Set position first, in-case top/left are set even on static elem
				if (position === "static") {
					elem.style.position = "relative";
				}

				curOffset = curElem.offset();
				curCSSTop = jQuery.css(elem, "top");
				curCSSLeft = jQuery.css(elem, "left");
				calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

				// Need to be able to calculate position if either
				// top or left is auto and position is either absolute or fixed
				if (calculatePosition) {
					curPosition = curElem.position();
					curTop = curPosition.top;
					curLeft = curPosition.left;
				} else {
					curTop = parseFloat(curCSSTop) || 0;
					curLeft = parseFloat(curCSSLeft) || 0;
				}

				if (isFunction(options)) {

					// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
					options = options.call(elem, i, jQuery.extend({}, curOffset));
				}

				if (options.top != null) {
					props.top = options.top - curOffset.top + curTop;
				}
				if (options.left != null) {
					props.left = options.left - curOffset.left + curLeft;
				}

				if ("using" in options) {
					options.using.call(elem, props);
				} else {
					curElem.css(props);
				}
			}
		};

		jQuery.fn.extend({

			// offset() relates an element's border box to the document origin
			offset: function offset(options) {

				// Preserve chaining for setter
				if (arguments.length) {
					return options === undefined ? this : this.each(function (i) {
						jQuery.offset.setOffset(this, options, i);
					});
				}

				var rect,
				    win,
				    elem = this[0];

				if (!elem) {
					return;
				}

				// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
				// Support: IE <=11 only
				// Running getBoundingClientRect on a
				// disconnected node in IE throws an error
				if (!elem.getClientRects().length) {
					return { top: 0, left: 0 };
				}

				// Get document-relative position by adding viewport scroll to viewport-relative gBCR
				rect = elem.getBoundingClientRect();
				win = elem.ownerDocument.defaultView;
				return {
					top: rect.top + win.pageYOffset,
					left: rect.left + win.pageXOffset
				};
			},

			// position() relates an element's margin box to its offset parent's padding box
			// This corresponds to the behavior of CSS absolute positioning
			position: function position() {
				if (!this[0]) {
					return;
				}

				var offsetParent,
				    offset,
				    doc,
				    elem = this[0],
				    parentOffset = { top: 0, left: 0 };

				// position:fixed elements are offset from the viewport, which itself always has zero offset
				if (jQuery.css(elem, "position") === "fixed") {

					// Assume position:fixed implies availability of getBoundingClientRect
					offset = elem.getBoundingClientRect();
				} else {
					offset = this.offset();

					// Account for the *real* offset parent, which can be the document or its root element
					// when a statically positioned element is identified
					doc = elem.ownerDocument;
					offsetParent = elem.offsetParent || doc.documentElement;
					while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {

						offsetParent = offsetParent.parentNode;
					}
					if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {

						// Incorporate borders into its offset, since they are outside its content origin
						parentOffset = jQuery(offsetParent).offset();
						parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
						parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
					}
				}

				// Subtract parent offsets and element margins
				return {
					top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
					left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
				};
			},

			// This method will return documentElement in the following cases:
			// 1) For the element inside the iframe without offsetParent, this method will return
			//    documentElement of the parent window
			// 2) For the hidden or detached element
			// 3) For body or html element, i.e. in case of the html node - it will return itself
			//
			// but those exceptions were never presented as a real life use-cases
			// and might be considered as more preferable results.
			//
			// This logic, however, is not guaranteed and can change at any point in the future
			offsetParent: function offsetParent() {
				return this.map(function () {
					var offsetParent = this.offsetParent;

					while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
						offsetParent = offsetParent.offsetParent;
					}

					return offsetParent || documentElement;
				});
			}
		});

		// Create scrollLeft and scrollTop methods
		jQuery.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (method, prop) {
			var top = "pageYOffset" === prop;

			jQuery.fn[method] = function (val) {
				return access(this, function (elem, method, val) {

					// Coalesce documents and windows
					var win;
					if (isWindow(elem)) {
						win = elem;
					} else if (elem.nodeType === 9) {
						win = elem.defaultView;
					}

					if (val === undefined) {
						return win ? win[prop] : elem[method];
					}

					if (win) {
						win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
					} else {
						elem[method] = val;
					}
				}, method, val, arguments.length);
			};
		});

		// Support: Safari <=7 - 9.1, Chrome <=37 - 49
		// Add the top/left cssHooks using jQuery.fn.position
		// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
		// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
		// getComputedStyle returns percent when specified for top/left/bottom/right;
		// rather than make the css module depend on the offset module, just check for it here
		jQuery.each(["top", "left"], function (_i, prop) {
			jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
				if (computed) {
					computed = curCSS(elem, prop);

					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
				}
			});
		});

		// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
		jQuery.each({ Height: "height", Width: "width" }, function (name, type) {
			jQuery.each({
				padding: "inner" + name,
				content: type,
				"": "outer" + name
			}, function (defaultExtra, funcName) {

				// Margin is only for outerHeight, outerWidth
				jQuery.fn[funcName] = function (margin, value) {
					var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
					    extra = defaultExtra || (margin === true || value === true ? "margin" : "border");

					return access(this, function (elem, type, value) {
						var doc;

						if (isWindow(elem)) {

							// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
							return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
						}

						// Get document width or height
						if (elem.nodeType === 9) {
							doc = elem.documentElement;

							// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
							// whichever is greatest
							return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
						}

						return value === undefined ?

						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css(elem, type, extra) :

						// Set width or height on the element
						jQuery.style(elem, type, value, extra);
					}, type, chainable ? margin : undefined, chainable);
				};
			});
		});

		jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
			jQuery.fn[type] = function (fn) {
				return this.on(type, fn);
			};
		});

		jQuery.fn.extend({

			bind: function bind(types, data, fn) {
				return this.on(types, null, data, fn);
			},
			unbind: function unbind(types, fn) {
				return this.off(types, null, fn);
			},

			delegate: function delegate(selector, types, data, fn) {
				return this.on(types, selector, data, fn);
			},
			undelegate: function undelegate(selector, types, fn) {

				// ( namespace ) or ( selector, types [, fn] )
				return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
			},

			hover: function hover(fnOver, fnOut) {
				return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
			}
		});

		jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {

			// Handle event binding
			jQuery.fn[name] = function (data, fn) {
				return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
			};
		});

		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		// Require that the "whitespace run" starts from a non-whitespace
		// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
		var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

		// Bind a function to a context, optionally partially applying any
		// arguments.
		// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
		// However, it is not slated for removal any time soon
		jQuery.proxy = function (fn, context) {
			var tmp, args, proxy;

			if (typeof context === "string") {
				tmp = fn[context];
				context = fn;
				fn = tmp;
			}

			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if (!isFunction(fn)) {
				return undefined;
			}

			// Simulated bind
			args = _slice.call(arguments, 2);
			proxy = function proxy() {
				return fn.apply(context || this, args.concat(_slice.call(arguments)));
			};

			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;

			return proxy;
		};

		jQuery.holdReady = function (hold) {
			if (hold) {
				jQuery.readyWait++;
			} else {
				jQuery.ready(true);
			}
		};
		jQuery.isArray = Array.isArray;
		jQuery.parseJSON = JSON.parse;
		jQuery.nodeName = nodeName;
		jQuery.isFunction = isFunction;
		jQuery.isWindow = isWindow;
		jQuery.camelCase = camelCase;
		jQuery.type = toType;

		jQuery.now = Date.now;

		jQuery.isNumeric = function (obj) {

			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type(obj);
			return (type === "number" || type === "string") &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN(obj - parseFloat(obj));
		};

		jQuery.trim = function (text) {
			return text == null ? "" : (text + "").replace(rtrim, "$1");
		};

		// Register as a named AMD module, since jQuery can be concatenated with other
		// files that may use define, but not via a proper concatenation script that
		// understands anonymous AMD modules. A named AMD is safest and most robust
		// way to register. Lowercase jquery is used because AMD module names are
		// derived from file names, and jQuery is normally delivered in a lowercase
		// file name. Do this after creating the global so that if an AMD module wants
		// to call noConflict to hide this version of jQuery, it will work.

		// Note that for maximum portability, libraries that are not jQuery should
		// declare themselves as anonymous modules, and avoid setting a global if an
		// AMD loader is present. jQuery is a special case. For more information, see
		// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return jQuery;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}

		var

		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,


		// Map over the $ in case of overwrite
		_$ = window.$;

		jQuery.noConflict = function (deep) {
			if (window.$ === jQuery) {
				window.$ = _$;
			}

			if (deep && window.jQuery === jQuery) {
				window.jQuery = _jQuery;
			}

			return jQuery;
		};

		// Expose jQuery and $ identifiers, even in AMD
		// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
		// and CommonJS for browser emulators (trac-13566)
		if (typeof noGlobal === "undefined") {
			window.jQuery = window.$ = jQuery;
		}

		return jQuery;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)(module)))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var keyboardAccessibility = __webpack_require__(111);

	function isDesktop() {
	    return window.innerWidth >= 1200;
	}

	function sessionStorageSupported() {
	    try {
	        var storage = window.sessionStorage;
	        storage.setItem('test', 'test');
	        storage.removeItem('test');
	        return true;
	    } catch (e) {
	        return false;
	    }
	}

	// Bata Redesign - Editorial Menu

	function closeMenu() {
	    $('html').removeClass('cc-no-scroll');
	    $('.js-editorialMenu').removeClass('open');
	    $('.js-menuFirstLevelItem').removeClass('selected');
	    $('.js-menuOverlay').addClass('d-none');
	    $('.js-menuSecondLevel').removeClass('open');
	    $('.js-menuSecondLevel').removeClass('overflow-mobile');
	    $('.js-menuSecondLevelItem').removeClass('selected');
	    $('.js-menuFirstLevelItemFake').removeClass('selected');
	    $('#launcher').removeClass('cc-fadeout');
	    $('.js-duplicated-menu-for-mobile').scrollLeft(0);
	    if (isDesktop()) {
	        $('.js-menuSecondLevel').attr('inert', '');
	        $('.js-menuClose').attr('inert', '');
	    }
	}

	function openMenu() {
	    $('html').addClass('cc-no-scroll');
	    $('.js-menuOverlay').removeClass('d-none');

	    // CLS Fix: Remove inline style to allow menu to show
	    $('.js-menuSecondLevel').removeAttr('style');

	    $('.js-menuFirstLevelItem.selected .js-menuSecondLevel').addClass('open');
	    if (window.isDesktop) {
	        $('.js-openFirst').addClass('selected');
	    }
	    $('.js-editorialMenu').addClass('open');
	    $('#launcher').addClass('cc-fadeout');
	    if (isDesktop()) {
	        $('.js-menuSecondLevel').removeAttr('inert');
	        $('.js-menuClose').removeAttr('inert');
	    }
	}

	function openMenuMobile() {
	    $('html').addClass('cc-no-scroll');
	    // CLS Fix: Remove inline style to allow menu to show
	    $('.js-menuSecondLevel').removeAttr('style');
	    $('.js-editorialMenu').addClass('open');

	    var index = $('.cc-menu__firstLevel__link__activeCategory').length > 0 ? $('.cc-menu__firstLevel__link__activeCategory').closest('.js-menuFirstLevelItem').index() : 0;
	    $('.js-menuFirstLevelItemFake').eq(index).addClass('selected');
	    $('.js-menuFirstLevelItem').eq(index).addClass('selected');
	    $('.js-menuFirstLevelItem.selected .js-menuSecondLevel').addClass('open');
	    $('#launcher').addClass('cc-fadeout');
	}

	var clearSelection = function clearSelection(element) {
	    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category').detach();
	    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
	    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
	    $(element).closest('.dropdown.show').removeClass('show');
	    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
	    $(element).closest('li').detach();
	};

	// Initialize inert attributes based on screen size
	function initializeInertAttributes() {
	    if (isDesktop()) {
	        $('.js-menuSecondLevel').attr('inert', '');
	        $('.js-menuClose').attr('inert', '');
	        $('.js-searchBarMobile').attr('inert', '');
	    } else {
	        $('.js-menuSecondLevel').removeAttr('inert');
	        $('.js-menuClose').removeAttr('inert');
	        $('.js-searchBarMobile').removeAttr('inert');
	    }
	}

	module.exports = function () {
	    // Initialize inert attributes on page load
	    initializeInertAttributes();

	    // Handle window resize
	    $(window).on('resize', function () {
	        initializeInertAttributes();
	    });

	    var headerBannerStatus = sessionStorageSupported() ? window.sessionStorage.getItem('hide_header_banner') : false;
	    $('.header-banner .close').on('click', function () {
	        $('.header-banner').addClass('d-none');
	        window.sessionStorage.setItem('hide_header_banner', '1');
	    });

	    if (!headerBannerStatus || headerBannerStatus < 0) {
	        $('.header-banner').removeClass('d-none');
	    }

	    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link', {
	        40: function _(menuItem) {
	            // down
	            if (menuItem.hasClass('nav-item')) {
	                // top level
	                $('.navbar-nav .show').removeClass('show').children('.dropdown-menu').removeClass('show');
	                menuItem.addClass('show').children('.dropdown-menu').addClass('show');
	                menuItem.find('ul > li > a').first().focus();
	            } else {
	                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
	                if (!(menuItem.next().length > 0)) {
	                    // if this is the last menuItem
	                    menuItem.parent().parent().find('li > a') // set focus to the first menuitem
	                    .first().focus();
	                } else {
	                    menuItem.next().children().first().focus();
	                }
	            }
	        },
	        39: function _(menuItem) {
	            // right
	            if (menuItem.hasClass('nav-item')) {
	                // top level
	                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
	                $(this).attr('aria-expanded', 'false');
	                menuItem.next().children().first().focus();
	            } else if (menuItem.hasClass('dropdown')) {
	                menuItem.addClass('show').children('.dropdown-menu').addClass('show');
	                $(this).attr('aria-expanded', 'true');
	                menuItem.find('ul > li > a').first().focus();
	            }
	        },
	        38: function _(menuItem) {
	            // up
	            if (menuItem.hasClass('nav-item')) {
	                // top level
	                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
	            } else if (menuItem.prev().length === 0) {
	                // first menuItem
	                menuItem.parent().parent().removeClass('show').children('.nav-link').attr('aria-expanded', 'false');
	                menuItem.parent().children().last().children() // set the focus to the last menuItem
	                .first().focus();
	            } else {
	                menuItem.prev().children().first().focus();
	            }
	        },
	        37: function _(menuItem) {
	            // left
	            if (menuItem.hasClass('nav-item')) {
	                // top level
	                menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
	                $(this).attr('aria-expanded', 'false');
	                menuItem.prev().children().first().focus();
	            } else {
	                menuItem.closest('.show').removeClass('show').closest('li.show').removeClass('show').children().first().focus().attr('aria-expanded', 'false');
	            }
	        },
	        27: function _(menuItem) {
	            // escape
	            var parentMenu = menuItem.hasClass('show') ? menuItem : menuItem.closest('li.show');
	            parentMenu.children('.show').removeClass('show');
	            parentMenu.removeClass('show').children('.nav-link').attr('aria-expanded', 'false');
	            parentMenu.children().first().focus();
	        }
	    }, function () {
	        return $(this).parent();
	    });

	    $('.navbar>.close-menu>.close-button').on('click', function (e) {
	        e.preventDefault();
	        $('.menu-toggleable-left').removeClass('in');
	        $('.modal-background').hide();

	        $('.navbar-toggler').focus();

	        $('.main-menu').attr('aria-hidden', 'true');
	        $('.main-menu').siblings().attr('aria-hidden', 'false');
	        $('header').siblings().attr('aria-hidden', 'false');
	    });

	    $('.navbar-nav').on('click', '.back', function (e) {
	        e.preventDefault();
	        clearSelection(this);
	    });

	    $('.navbar-nav').on('click', '.close-button', function (e) {
	        e.preventDefault();
	        $('.navbar-nav').find('.top-category').detach();
	        $('.navbar-nav').find('.nav-menu').detach();
	        $('.navbar-nav').find('.show').removeClass('show');
	        $('.menu-toggleable-left').removeClass('in');

	        $('.main-menu').siblings().attr('aria-hidden', 'false');
	        $('header').siblings().attr('aria-hidden', 'false');

	        $('.modal-background').hide();
	    });

	    $('.navbar-toggler').click(function (e) {
	        e.preventDefault();
	        $('.main-menu').toggleClass('in');
	        $('.modal-background').show();

	        $('.main-menu').removeClass('d-none');
	        $('.main-menu').attr('aria-hidden', 'false');
	        $('.main-menu').siblings().attr('aria-hidden', 'true');
	        $('header').siblings().attr('aria-hidden', 'true');

	        $('.main-menu .nav.navbar-nav .nav-link').first().focus();
	    });

	    keyboardAccessibility('.navbar-header .user', {
	        40: function _($popover) {
	            // down
	            if ($popover.children('a').first().is(':focus')) {
	                $popover.next().children().first().focus();
	            } else {
	                $popover.children('a').first().focus();
	            }
	        },
	        38: function _($popover) {
	            // up
	            if ($popover.children('a').first().is(':focus')) {
	                $(this).focus();
	                $popover.removeClass('show');
	            } else {
	                $popover.children('a').first().focus();
	            }
	        },
	        27: function _() {
	            // escape
	            $('.navbar-header .user .popover').removeClass('show');
	            $('.user').attr('aria-expanded', 'false');
	        },
	        9: function _() {
	            // tab
	            $('.navbar-header .user .popover').removeClass('show');
	            $('.user').attr('aria-expanded', 'false');
	        }
	    }, function () {
	        var $popover = $('.user .popover li.nav-item');
	        return $popover;
	    });

	    $('.navbar-header .user').on('mouseenter focusin', function () {
	        if ($('.navbar-header .user .popover').length > 0) {
	            $('.navbar-header .user .popover').addClass('show');
	            $('.user').attr('aria-expanded', 'true');
	        }
	    });

	    $('.navbar-header .user').on('mouseleave', function () {
	        $('.navbar-header .user .popover').removeClass('show');
	        $('.user').attr('aria-expanded', 'false');
	    });
	    $('body').on('click', '#myaccount', function () {
	        event.preventDefault();
	    });

	    /**
	     * @description set the new mobile menu header based on the category diplayed
	     * @param $category {Element} the category clicked | false in case of root category
	     * @param isGoBackCall {boolean} true if it is a go back button invocation, true otherwhise
	     */

	    var lastFocusedElement = null;

	    // Bata Redesign - Editorial Menu
	    if (!$('.js-editorialMenu').hasClass('js-editorialMenuNoCommerce') && !$('.js-editorialMenu').hasClass('js-static-menu')) {
	        var setTimeoutConst = void 0;
	        $('.js-menuFirstLevelItem').on('mouseenter', function (e) {
	            var _this = this;

	            setTimeoutConst = setTimeout(function () {
	                if (!$('.js-editorialMenu').hasClass('cc-menu__editorialMode') && window.isDesktop && !$('.js-fullPage').hasClass('cc-editorialMode') && !$('.js-editorialMenu').hasClass('js-editorialMenuNoCommerce')) {
	                    e.preventDefault();
	                    $(_this).addClass('selected');
	                    lastFocusedElement = $(_this);
	                    openMenu();
	                } else {
	                    return;
	                }
	            }, 50);
	        });

	        $('.js-menuFirstLevelItem').on('mouseleave', function () {
	            clearTimeout(setTimeoutConst);
	        });
	    }

	    // Bata Redesign - Editorial Menu No Commerce Seconnd Level Hover
	    $('.js-editorialMenuNoCommerce .js-menuSecondLevelItem').on('click', function () {
	        var thirdLevel = $(this).next('.js-menuThirdLevel')[0];
	        var secondLevel = $(this);

	        setTimeout(function () {
	            if (secondLevel.hasClass('accordionSelect')) {
	                secondLevel.removeClass('accordionSelect');
	                thirdLevel.style.maxHeight = '0px';
	                return;
	            }
	            $('.accordionSelect').removeClass('accordionSelect');
	            $('.js-menuThirdLevel').each(function () {
	                this.style.maxHeight = '0px';
	            });

	            thirdLevel.style.maxHeight = thirdLevel.scrollHeight + 'px';
	            secondLevel.addClass('accordionSelect');
	        }, 50);
	    });

	    $('.js-editorialMenuNoCommerce .js-menuSecondLevelItem').on('mouseleave', function () {
	        $('.js-menuSecondLevelItem.selected').removeClass('selected');
	    });

	    if ($('.js-editorialMenu').hasClass('js-editorialMenuNoCommerce')) {
	        $('.cc-header').addClass('cc-header--editorialMenuNoCommerce');
	    }

	    // Open no commerce menu - on click (hamburger menu)

	    $('.js-editorialMenuNoCommerce').on('click', function () {
	        if (!$(this).hasClass('open')) {
	            openMenu();
	        }
	    });

	    // Open menu - Page Designer editorial mode

	    $('.js-menuFirstLevelItem').on('click', function (e) {
	        if ($('.js-editorialMenu').hasClass('cc-menu__editorialMode') && window.isDesktop && !$('.js-fullPage').hasClass('cc-editorialMode')) {
	            e.preventDefault();
	            $(this).addClass('selected');
	            lastFocusedElement = $(this);
	            openMenu();
	        } else {
	            return;
	        }
	    });

	    // Switch first level menu
	    $('.js-menuFirstLevelItem:not(.selected)').on('mouseenter', function () {
	        if ($('.js-editorialMenu').hasClass('js-static-menu')) {
	            return;
	        }
	        if (window.isDesktop) {
	            $('.js-menuFirstLevelItem').removeClass('selected');
	            $('.js-openFirst').removeClass('selected');
	            $('.js-menuSecondLevelItem').removeClass('selected');
	            $(this).addClass('selected');
	            $('.js-menuFirstLevelItem.selected .js-menuSecondLevel').addClass('open');
	            $('.js-openFirst').addClass('selected');
	        }
	    });

	    // Switch second level menu
	    var setTimeoutConstSecondLevel = void 0;
	    $('.js-menuSecondLevelItem').on('mouseenter', function () {
	        var _this2 = this;

	        setTimeoutConstSecondLevel = setTimeout(function () {
	            if (window.isDesktop) {
	                if ($(_this2).hasClass('selected')) {
	                    return;
	                } else {
	                    $('.js-menuSecondLevelItem').removeClass('selected');
	                    $(_this2).addClass('selected');

	                    if ($(_this2).next('.js-menuThirdLevel').find('.experience-thirdLevelColumnRegion').children().length === 0) {
	                        $(_this2).find('.cc-menu__secondLevel-arrow-icon').remove();
	                    }
	                }
	            }
	        }, 50);
	    });

	    $('.js-menuSecondLevelItem').on('mouseleave', function () {
	        clearTimeout(setTimeoutConstSecondLevel);
	    });

	    // Close menu
	    $('.js-menuClose').on('click', function (e) {
	        e.stopPropagation();
	        closeMenu();
	        if (!window.isDesktop) {
	            $('.js-menuSecondLevel').scrollTop(0);
	        }
	    });

	    $('.js-menuOverlay').on('click', function () {
	        closeMenu();
	    });

	    $(document).on('keydown', function (event) {
	        if (event.key === 'Escape' && $('.js-editorialMenu').hasClass('open')) {
	            closeMenu();
	            if (lastFocusedElement && lastFocusedElement.length) {
	                lastFocusedElement.focus();
	                lastFocusedElement = null;
	            }
	        }
	    });

	    function handleKeyboardMenuOpen(e) {
	        if (!window.isDesktop || e.key !== 'Enter' && e.key !== ' ') return;

	        var $menuItem = $(e.target);
	        if (!$menuItem.hasClass('js-menuFirstLevelItem') && !$menuItem.hasClass('js-menuSecondLevelItem')) return;

	        e.preventDefault();
	        e.stopPropagation();
	        lastFocusedElement = $menuItem;

	        if ($menuItem.hasClass('js-menuFirstLevelItem')) {
	            $menuItem.addClass('selected');
	            openMenu();
	        } else {
	            $menuItem.trigger('mouseenter');
	        }
	    }

	    document.addEventListener('keydown', handleKeyboardMenuOpen, true);
	    document.addEventListener('keyup', handleKeyboardMenuOpen, true);

	    $(document).on('click', '.js-menuFirstLevelItem', function (e) {
	        if (!$('.js-editorialMenu').hasClass('open')) {
	            e.preventDefault();
	            e.stopPropagation();
	            lastFocusedElement = $(this);
	            $(this).addClass('selected');
	            openMenu();
	        }
	    });

	    // Bata Redesign - Editorial Menu Mobile

	    // Open menu mobile
	    $('.js-toggleMenuMobile').on('click', function () {
	        var $menuMobileFirstLevel = $('.js-duplicated-menu-for-mobile');

	        if ($menuMobileFirstLevel.children().length === 0) {
	            var $menuFirstLevelItem = $('.js-menuFirstLevelItem');
	            $menuFirstLevelItem.each(function () {
	                var html = '';
	                var classes = 'cc-menu__level cc-menu__firstLevel__fakeLink js-menuFirstLevelItemFake';

	                html = '<div class="' + classes + '" aria-label="' + $(this).find('.cc-menu__firstLevel__title').html() + '">' + $(this).find('.cc-menu__firstLevel__title').html() + '</div>';
	                $menuMobileFirstLevel.append(html);
	            });
	        }

	        $('.js-menuThirdLevel').css('display', 'none');
	        openMenuMobile();
	        $('.js-menuThirdLevel').css('display', 'block');
	    });

	    // Switch first level menu mobile
	    $('.js-menuFirstLevelItem:not(.selected)').on('click', function () {
	        $('.js-menuFirstLevelItem').removeClass('selected');
	        $(this).addClass('selected');
	        $('.js-menuFirstLevelItem.selected .js-menuSecondLevel').addClass('open');
	        $('.js-menuSecondLevel').scrollTop(0);
	    });

	    $(document).on('click', '.js-menuFirstLevelItemFake', function () {
	        $('.js-menuFirstLevelItemFake').removeClass('selected');
	        $(this).addClass('selected');
	        var index = $(this).index();
	        $('.js-menuFirstLevelItem').eq(index).trigger('click');
	    });

	    // Switch second level menu mobile
	    $('.js-menuSecondLevelItem').on('click', function (e) {
	        var menuItem = $(this);

	        if (menuItem && menuItem.data('menu-selection')) {
	            var secondLevelData = menuItem.data('menu-selection');

	            $('body').trigger('analytics:brandSecondCategoryLevel', secondLevelData);
	        }

	        if (!window.isDesktop && !$(this).hasClass('secondary')) {
	            if (!$('.js-editorialMenu').hasClass('js-editorialMenuNoCommerce')) {
	                e.preventDefault();
	            }
	            if ($(this).hasClass('selected')) {
	                return;
	            } else {
	                $('.js-menuSecondLevelItem').removeClass('selected');
	                $('.js-menuSecondLevel').addClass('overflow-mobile');
	                $(this).addClass('selected');
	            }
	        } else {
	            return;
	        }
	    });

	    // Go back menu mobile
	    $('.js-backButton').on('click', function () {
	        $('.js-menuSecondLevelItem').removeClass('selected');
	        $('.js-menuSecondLevel').removeClass('overflow-mobile');
	        $('.js-menuThirdLevelWrapper').scrollTop(0);
	    });

	    $(window).resize(function () {
	        if (!window.isDesktop && $('.js-editorialMenu').hasClass('open')) {
	            var $menuMobileFirstLevel = $('.js-duplicated-menu-for-mobile');

	            if ($menuMobileFirstLevel.children().length === 0) {
	                var $menuFirstLevelItem = $('.js-menuFirstLevelItem');
	                $menuFirstLevelItem.each(function () {
	                    var html = '';
	                    var classes = 'cc-menu__level cc-menu__firstLevel__fakeLink js-menuFirstLevelItemFake';

	                    html = '<div class="' + classes + '" aria-label="' + $(this).find('.cc-menu__firstLevel__title').html() + '">' + $(this).find('.cc-menu__firstLevel__title').html() + '</div>';
	                    $menuMobileFirstLevel.append(html);
	                });
	            }

	            var index = $('.js-menuFirstLevelItem.selected').index();
	            $('.jjs-menuFirstLevelItemFake').eq(index).addClass('selected');
	        }
	    });
	};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (selector, keyFunctions, preFunction) {
	    $(selector).on('keydown', function (e) {
	        var key = e.which;
	        var supportedKeyCodes = [37, 38, 39, 40, 27];
	        if (supportedKeyCodes.indexOf(key) >= 0) {
	            e.preventDefault();
	        }
	        var returnedScope = preFunction.call(this);
	        if (keyFunctions[key]) {
	            keyFunctions[key].call(this, returnedScope);
	        }
	    });
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var focusHelper = __webpack_require__(113);

	/**
	 * Renders a modal window that will track the users consenting to accepting site tracking policy
	 */
	function showConsentModal() {
	    var trackingConsentData = $('.tracking-consent');
	    if (!trackingConsentData.data('caonline')) {
	        return;
	    }

	    var urlContent = trackingConsentData.data('url');
	    var urlAccept = trackingConsentData.data('accept');
	    var urlReject = trackingConsentData.data('reject');
	    var textYes = trackingConsentData.data('accepttext');
	    var textNo = trackingConsentData.data('rejecttext');
	    var textHeader = trackingConsentData.data('heading');
	    var tokenName = trackingConsentData.data('tokenname');
	    var token = trackingConsentData.data('token');

	    var htmlString = '<!-- Modal -->' + '<div class="modal show" id="consent-tracking" aria-modal="true" role="dialog" style="display: block;">' + '<div class="modal-dialog">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + textHeader + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer">' + '<div class="button-wrapper">' + '<button class="affirm btn btn-primary" data-url="' + urlAccept + '" autofocus data-dismiss="modal">' + textYes + '</button>' + '<button class="decline btn btn-primary" data-url="' + urlReject + '" data-dismiss="modal" >' + textNo + '</button>' + '</div>' + '</div>' + '</div>' + '</div>' + '</div>';
	    $.spinner().start();
	    $('body').append(htmlString);

	    $.ajax({
	        url: urlContent,
	        type: 'get',
	        dataType: 'html',
	        success: function success(response) {
	            $('.modal-body').html(response);
	            $('#consent-tracking').modal('show');
	        },
	        error: function error() {
	            $('#consent-tracking').remove();
	        }
	    });

	    $('#consent-tracking .button-wrapper button').click(function (e) {
	        e.preventDefault();
	        var url = $(this).data('url');
	        var data = {};
	        data[tokenName] = token;
	        $.ajax({
	            url: url,
	            type: 'post',
	            data: data,
	            dataType: 'json',
	            success: function success(response) {
	                // Only hide modal if the operation is successful - don't want to give a false impression
	                if (response.success) {
	                    $('#consent-tracking').remove();
	                    $.spinner().stop();
	                }
	            },
	            error: function error(err) {
	                // Expected error response is for CSRF failure, which will include a redirect to CSRF-Fail
	                if (err.responseJSON.redirectUrl) {
	                    window.location.href = err.responseJSON.redirectUrl;
	                }
	            }
	        });
	    });
	}

	module.exports = function () {
	    if ($('.consented').length === 0 && $('.tracking-consent').hasClass('api-true')) {
	        showConsentModal();
	    }

	    if ($('.tracking-consent').hasClass('api-true')) {
	        $('.tracking-consent').click(function () {
	            showConsentModal();
	        });
	    }

	    $('body').on('shown.bs.modal', '#consent-tracking', function () {
	        $('#consent-tracking').siblings().attr('aria-hidden', 'true');
	        $('#consent-tracking .affirm').focus();
	    });

	    $('body').on('hidden.bs.modal', '#consent-tracking', function () {
	        $('#consent-tracking').siblings().attr('aria-hidden', 'false');
	    });

	    $('body').on('keydown', '#consent-tracking', function (e) {
	        var focusParams = {
	            event: e,
	            containerSelector: '#consent-tracking',
	            firstElementSelector: '.affirm',
	            lastElementSelector: '.decline',
	            nextToLastElementSelector: '.affirm'
	        };
	        focusHelper.setTabNextFocus(focusParams);
	    });
	};

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = {
	    setTabNextFocus: function setTabNextFocus(focusParams) {
	        var KEYCODE_TAB = 9;
	        var isTabPressed = focusParams.event.key === 'Tab' || focusParams.event.keyCode === KEYCODE_TAB;

	        if (!isTabPressed) {
	            return;
	        }

	        var firstFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.firstElementSelector);
	        var lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.lastElementSelector);

	        if ($(focusParams.containerSelector + ' ' + focusParams.lastElementSelector).is(':disabled')) {
	            lastFocusableEl = $(focusParams.containerSelector + ' ' + focusParams.nextToLastElementSelector);
	            if ($('.product-quickview.product-set').length > 0) {
	                var linkElements = $(focusParams.containerSelector + ' a#fa-link.share-icons');
	                lastFocusableEl = linkElements[linkElements.length - 1];
	            }
	        }

	        if (focusParams.event.shiftKey) /* shift + tab */{
	                if ($(':focus').is(firstFocusableEl)) {
	                    lastFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            } else /* tab */{
	                if ($(':focus').is(lastFocusableEl)) {
	                    // eslint-disable-line
	                    firstFocusableEl.focus();
	                    focusParams.event.preventDefault();
	                }
	            }
	    }
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var scrollAnimate = __webpack_require__(63);

	/**
	 * appends params to a url
	 * @param {string} data - data returned from the server's ajax call
	 * @param {Object} button - button that was clicked for email sign-up
	 */
	function displayMessage(data, button) {
	    $.spinner().stop();
	    var status;
	    if (data.success) {
	        status = 'alert-success';
	    } else {
	        status = 'alert-danger';
	    }

	    if ($('.email-signup-message').length === 0) {
	        $('body').append('<div class="email-signup-message"></div>');
	    }
	    $('.email-signup-message').append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

	    setTimeout(function () {
	        $('.email-signup-message').remove();
	        button.removeAttr('disabled');
	    }, 3000);
	}

	module.exports = function () {
	    $('.back-to-top').click(function () {
	        scrollAnimate();
	    });

	    $('.subscribe-email').on('click', function (e) {
	        e.preventDefault();
	        var url = $(this).data('href');
	        var button = $(this);
	        var emailId = $('input[name=hpEmailSignUp]').val();
	        $.spinner().start();
	        $(this).attr('disabled', true);
	        $.ajax({
	            url: url,
	            type: 'post',
	            dataType: 'json',
	            data: {
	                emailId: emailId
	            },
	            success: function success(data) {
	                displayMessage(data, button);
	            },
	            error: function error(err) {
	                displayMessage(err, button);
	            }
	        });
	    });
	    $('.js-cookies-bar-close').on('click', function () {
	        var cookieBanner = $('.cookie-warning');
	        //active the tracking
	        var url = cookieBanner.data('accept');
	        $.ajax({
	            url: url,
	            type: 'get',
	            dataType: 'json'
	        });
	        cookieBanner.remove();
	        var expireDate = new Date();
	        //expire date = 365 days
	        expireDate.setTime(expireDate.getTime() + 31536000000);
	        var expires = "expires=" + expireDate.toUTCString();
	        //set this cookie, so the bar is no longer showed
	        document.cookie = 'dw_cookies_accepted' + ";" + expires + ";path=/";
	    });
	};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var cart = __webpack_require__(116);

	var updateMiniCart = true;
	var updateMiniWishlistCart = true;

	function openMiniCart(data, hideProceedToCheckout) {
	    $('.minicart .cc-minicart-overlay').addClass('show');
	    $('.minicart .cc-minicart-overlay').spinner().start();
	    $('.minicart .cc-minicart-overlay').empty();
	    $('.minicart .cc-minicart-overlay').append(data.miniCartPopUpTemplate);
	    if (hideProceedToCheckout) {
	        $('.js-proceed-checkout').addClass('d-none');
	        $('.js-view-cart').removeClass('cc-link-type-1');
	        $('.js-view-cart').addClass('cc-button-type-1');
	    } else {
	        $('.js-proceed-checkout').removeClass('d-none');
	        $('.js-view-cart').addClass('cc-link-type-1');
	        $('.js-view-cart').removeClass('cc-button-type-1');
	    }
	    // analytics event
	    $('body').trigger('analytics:viewMiniCart');
	}

	function openMiniWishlistCart(data) {
	    var $wishlistMinicart = $('.minicart .js-minicart-wishlist-overlay');
	    $wishlistMinicart.addClass('show');
	    $wishlistMinicart.spinner().start();
	    $wishlistMinicart.empty();
	    $wishlistMinicart.append(data.wishlistPopupTemplate);
	    $('.js-proceed-checkout').removeClass('d-none');
	    $('.js-view-cart').addClass('cc-link-type-1');
	    $('.js-view-cart').removeClass('cc-button-type-1');
	}

	function showMiniCart(e, data) {
	    var count = parseInt($('.minicart .minicart-quantity').text(), 10);
	    var hideProceedToCheckout = $('.minicart .minicart-link').data('hide-checkout-btn');
	    e.stopPropagation();
	    if (count !== 0 && $('.minicart .cc-minicart-overlay.show').length === 0) {
	        if (!updateMiniCart) {
	            $('.minicart .cc-minicart-overlay').addClass('show');
	            return;
	        }
	        if (window.isDesktop) {
	            var headerHeigth = $('.js-header').height();
	            var $breadcrumbContainer = $('.js-breadcrumbContainer');
	            var $filterWrapper = $('.cc-plp--filters--sticky');
	            var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	            var $categoryWrapperInner = $('.js-categoryPills');
	            var $categoryWrapper = $('.cc-plp--categories--sticky');
	            var heightFilter = 52;
	            var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	            // Check if we're on brandHomepage
	            var isBrandHomepage = $('.cc-brandHomepage').length > 0;

	            if (isBrandHomepage) {
	                // For brandHomepage, show full header and position miniCart relative to all visible header elements
	                $('.js-header').addClass('cc-header__tag__viewHeader');
	                $('.js-header').removeClass('cc-header__tag__scrollDown');

	                // Set miniCart to 100% of header - it will automatically follow the header

	                // Position intro component below the header
	                var $header = $('.js-header');
	                var $announcementBar = $('.cc-header--banner');

	                var introTopHeight = $header.outerHeight();
	                // if ($announcementBar.length > 0 && $announcementBar.is(':visible')) {
	                //     introTopHeight += $announcementBar.outerHeight() || 0;
	                // }

	                $('.experience-commerce_layouts-intro').css('top', introTopHeight + 'px');
	                $('.cc-minicart-overlay').css('top', introTopHeight + 'px');
	            } else {
	                // For PLP pages, use existing logic
	                $('.js-header').addClass('cc-header__tag__viewHeader');
	                $breadcrumbContainer.css('top', headerHeigth);
	                if ($categoryWrapperInner.length > 0) {
	                    $categoryWrapper.css('top', 42 + headerHeigth - breadcrumbHeigth);
	                    $filterWrapper.css('top', 117 + headerHeigth + logoHeight - breadcrumbHeigth);
	                } else {
	                    if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                        $filterWrapper.css('top', 0);
	                    } else {
	                        $filterWrapper.css('top', heightFilter + headerHeigth - breadcrumbHeigth);
	                    }
	                }
	            }
	        }

	        $('.js-header').removeClass('cc-header__tag__scrollDown');
	        openMiniCart(data, hideProceedToCheckout);

	        updateMiniCart = false;
	        $.spinner().stop();
	    }
	    return false;
	}

	// THis function mimics the existed minicart functionality.
	function showMiniWishlistCart(e, data) {
	    e.stopPropagation();
	    if ($('.minicart .js-minicart-wishlist-overlay.show').length === 0) {
	        if (!updateMiniWishlistCart) {
	            $('.minicart .js-minicart-wishlist-overlay').addClass('show');
	            return;
	        }
	        if (window.isDesktop) {
	            var headerHeigth = $('.js-header').height();
	            var $breadcrumbContainer = $('.js-breadcrumbContainer');
	            var $filterWrapper = $('.cc-plp--filters--sticky');
	            var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	            var $categoryWrapperInner = $('.js-categoryPills');
	            var $categoryWrapper = $('.cc-plp--categories--sticky');
	            var heightFilter = 52;
	            var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	            $('.js-header').addClass('cc-header__tag__viewHeader');
	            $breadcrumbContainer.css('top', headerHeigth);
	            if ($categoryWrapperInner.length > 0) {
	                $categoryWrapper.css('top', 42 + headerHeigth - breadcrumbHeigth);
	                $filterWrapper.css('top', 117 + headerHeigth + logoHeight - breadcrumbHeigth);
	            } else {
	                if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                    $filterWrapper.css('top', 0);
	                } else {
	                    $filterWrapper.css('top', heightFilter + headerHeigth - breadcrumbHeigth);
	                }
	            }
	        }

	        $('.js-header').removeClass('cc-header__tag__scrollDown');
	        openMiniWishlistCart(data);

	        updateMiniWishlistCart = false;
	        $.spinner().stop();
	    }
	    return false;
	}

	/**
	 * move items from Cart to wishlist
	 * returns json object with success or error message
	 */
	function moveToWishlist() {
	    $('body').on('click', '.product-move .move', function (e) {
	        e.preventDefault();
	        var addUrl = $(this).attr('href');
	        var removeUrl = $(this).data('remove-href');
	        var pid = $(this).data('pid');
	        var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
	        var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
	        var anchor = $(this);
	        optionId = optionId || null;
	        optionVal = optionVal || null;
	        if (!addUrl || !removeUrl || !pid) {
	            return;
	        }

	        $.spinner().start();

	        if (anchor.hasClass('to-add')) {
	            $.ajax({
	                url: addUrl,
	                type: 'post',
	                dataType: 'json',
	                data: {
	                    pid: pid,
	                    optionId: optionId,
	                    optionVal: optionVal
	                },
	                success: function success(data) {
	                    $.spinner().stop();
	                    if (data.success) {
	                        anchor.css('color', 'red');
	                        anchor.removeClass('to-add').addClass('to-remove');
	                        var counter = parseInt($('.js-wishlistNumber').text(), 10);
	                        counter++;
	                        if (counter > 0) {
	                            $('.js-wishlistNumber').removeClass('d-none');
	                        }
	                        $('.js-wishlistNumber').text(counter);
	                    } else {
	                        if (data.isFull) {
	                            $('#wishlist-modal').modal('show');
	                        }
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        } else {
	            $.ajax({
	                url: removeUrl,
	                type: 'get',
	                dataType: 'json',
	                data: {},
	                success: function success() {
	                    $.spinner().stop();
	                    anchor.css('color', '#0070d2');
	                    anchor.removeClass('to-remove').addClass('to-add');
	                    var counter = parseInt($('.js-wishlistNumber').text(), 10);
	                    counter--;
	                    if (parseInt(counter) === 0) {
	                        $('.js-wishlistNumber').addClass('d-none');
	                    }
	                    $('.js-wishlistNumber').text(counter);
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        }
	    });
	}

	module.exports = function () {
	    cart();
	    moveToWishlist();

	    // close login modal if forgot password modal is open
	    $('body').on('click', '.js-close-loginModal', function () {
	        $('#loginDrawerModal').modal('hide');
	    });

	    $('body').on('count:update', '.minicart', function (event, count) {
	        if (count && $.isNumeric(count.quantityTotal)) {
	            $('.minicart .minicart-quantity').text(count.quantityTotal);
	            $('.minicart .minicart-quantity').removeClass('d-none');
	            $('.minicart .minicart-link').attr({
	                'aria-label': count.minicartCountOfItems
	            });
	        }
	    });

	    $(document).on('click', '.js-miniCartCheckOut', function () {
	        var minicart = $('.js-miniCartCheckOut');
	        var checkoutUrl = minicart.data('checkout');

	        //analytics cartSubmit event
	        $('body').trigger('analytics:cartSubmit');

	        window.location.href = checkoutUrl;
	    });

	    $(document).on('click', '.cc-header #closeMiniCartButton', function (e) {
	        e.stopPropagation();
	        $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	        $('body').removeClass('cc-no-scroll');
	        $('.cc-header .minicart .cc-minicart-overlay').removeClass('show');
	    });
	    // Wishlist minicart closing event. It will be used for the automatic closure of the pop up or when the customer clicks directly on it.
	    $(document).on('click', '#closeMiniWishlistCartButton', function (e) {
	        e.stopPropagation();
	        $('.js-minicart-wishlist-overlay').removeClass('js-opened-by-add-to-minicart');
	        $('body').removeClass('cc-no-scroll');
	        $('.cc-header .minicart .js-minicart-wishlist-overlay').removeClass('show');
	    });

	    $(document).on('click', '.js-minicart-login', function (e) {

	        var buttonTriggered = $('.js-minicart-login');
	        var url = buttonTriggered.data('minicart-redirect');

	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'post',
	            success: function success(data) {
	                $.spinner().stop();
	                // Appending after body element because it is a modal and if I try to include it inside a div I will not bypass the backdrop effect of modal
	                $('body').append(data);
	                $('#loginDrawerModal').modal('show');
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    });

	    $(document).on('click', 'body', function (e) {
	        if (($('.cc-header .minicart .cc-content-minicart').has(e.target).length <= 0 || $('.cc-header .minicart .minicart-link').has(e.target).length <= 0) && !$(e.target).closest('.cc-content-minicart').length) {
	            //remove class for automatic close of minicart
	            $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	            $('body').removeClass('cc-no-scroll');
	            $('.cc-header .minicart .cc-minicart-overlay').removeClass('show');
	        }
	    });

	    $('body').on('change', '.minicart .quantity', function () {
	        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
	            location.reload();
	        }
	    });
	    $('body').on('product:afterAddToCart', function (e, data) {
	        updateMiniCart = true;
	        showMiniCart(e, data);
	    });
	    // Wishlist minicart starting point - called uppon triggering in any part of the site
	    $('body').on('product:afterAddToWishlist', function (e, data) {
	        updateMiniWishlistCart = true;
	        showMiniWishlistCart(e, data);
	    });
	    $('body').on('cart:update', function () {
	        updateMiniCart = true;
	    });

	    $(document).on('keydown', '#minicartIcon', function (e) {
	        if (e.key === 'Enter' || e.key === 'Space') {
	            e.preventDefault();
	            var redirectUrl = $(this).data('redirect');
	            if (redirectUrl) {
	                window.location.href = redirectUrl;
	            }
	        }
	    });

	    $(document).on('click', '#minicartIcon', function () {
	        var redirectUrl = $(this).data('redirect');
	        if (redirectUrl) {
	            window.location.href = redirectUrl;
	        }
	    });
	};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _stickyFunction = __webpack_require__(117);

	var base = __webpack_require__(118);
	var focusHelper = __webpack_require__(113);
	var debounce = __webpack_require__(121);
	var billingHelpers = __webpack_require__(95);
	var bonusProductHelpers = __webpack_require__(135);


	/**
	 * appends params to a url
	 * @param {string} url - Original url
	 * @param {Object} params - Parameters to append
	 * @returns {string} result url with appended parameters
	 */
	function appendToUrl(url, params) {
	    var newUrl = url;
	    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
	        return key + '=' + encodeURIComponent(params[key]);
	    }).join('&');

	    return newUrl;
	}

	function retrieveRenderedProgressBars() {
	    var $progressBars = $('.js-promotion-progress-bar-main:not(#template-bar)');

	    var objectToReturn = {};

	    if ($progressBars.length > 0) {
	        for (var i = 0; i < $progressBars.length; i++) {
	            objectToReturn[$progressBars[i].id] = {
	                toBeDeleted: true,
	                $element: $($progressBars[i])
	            };
	        }
	    }

	    return objectToReturn;
	}

	/**
	 * Checks whether the basket is valid. if invalid displays error message and disables
	 * checkout button
	 * @param {Object} data - AJAX response from the server
	 */
	function validateBasket(data) {
	    var $checkoutButton = $("#cart-page-checkout-btn");
	    var $stickyBarButton = $('.cc-cart__stickyBtn__wrapper button');
	    if (data.valid.error) {
	        if (data.valid.message) {
	            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' + 'fade show" role="alert">' + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + '</button>' + data.valid.message + '</div>';

	            $('.cart-error').html(errorHtml);
	        } else {
	            $('.cart').empty().append('<div class="row"> ' + '<div class="col-12 text-center"> ' + '<h1>' + data.resources.emptyCartMsg + '</h1> ' + '</div> ' + '</div>');
	            $('.number-of-items').empty().append(data.resources.numberOfItems);
	            if ($('.minicart-quantity').length > 0) {
	                $('.minicart-quantity').empty().append(data.resources.numberOfItemsMinicart);
	            }
	            $('.minicart-link').attr({
	                'aria-label': data.resources.minicartCountOfItems
	            });
	            $('.minicart .popover').empty();
	            $('.minicart .popover').removeClass('show');
	        }

	        $checkoutButton.addClass("cc-disabled");
	        $checkoutButton.prop("disabled", true);
	        $stickyBarButton.addClass("cc-disabled");
	        $stickyBarButton.prop("disabled", true);
	    } else {
	        $checkoutButton.removeClass("cc-disabled");
	        $checkoutButton.prop("disabled", false);
	        $stickyBarButton.removeClass("cc-disabled");
	        $stickyBarButton.prop("disabled", false);

	        $('.cart-error').html('');
	    }
	}

	/**
	 * It calculates and display in the summary the shipping cost.
	 * @param {Boolean} useshippingdiscounts - It is set to true if a shipping discount has been applied
	 * @param {Object} data - AJAX response from the server
	 */
	function updateShippingCost(useshippingdiscounts, data) {
	    if (useshippingdiscounts) {
	        //Update Cart shipping total and discount
	        if (data.totals.shippingTotalAfterDiscountValue !== data.totals.totalShippingCostDecimal) {
	            if (!$('.js-shipping-total-value').find('span.cc-price').length) {
	                $('.js-shipping-total-value').empty();
	                var spanShippingTotal = $('<span />').addClass('cc-price');
	                $('.js-shipping-total-value').append(spanShippingTotal);
	            }
	            $('.js-shipping-total-value').find('.cc-price').addClass('cc-price-reduced').empty().html(data.totals.totalShippingCost);

	            if (!$('.js-shipping-total-value').find('.js-shipping-discount').length) {
	                var spanShippingTotalAfterDiscount = $('<span />').addClass('js-shipping-discount').addClass('cc-shipping-discount');
	                $('.js-shipping-total-value').append(spanShippingTotalAfterDiscount);
	            }
	            $('.js-shipping-total-value').find('.js-shipping-discount').empty().html(data.totals.shippingTotalAfterDiscountString);
	        } else {
	            if (data.totals.totalShippingCostDecimal === 0) {
	                $('.js-shipping-total-value').empty().append(data.totals.shippingTotalAfterDiscountString);
	            } else {
	                $('.js-shipping-total-value').empty().append(data.totals.totalShippingCost);
	            }
	        }
	    } else {
	        $('.js-shipping-total-value').empty().append(data.totals.totalShippingCost);
	    }
	}

	/**
	 * re-renders the order totals and the number of items in the cart
	 * @param {Object} data - AJAX response from the server
	 */
	function updateCartTotals(data) {
	    var useshippingdiscounts = $('.js-useshippingdiscounts').data('useshippingdiscounts') === true;
	    //update the minicart price total
	    if ($('.minicartIconPrice').length > 0) {
	        $('.minicartIconPrice').html(data.totals && data.totals.subTotal);
	    }
	    $('#analytics-cartInfo').data('value', data.totals && data.totals.grandTotalDecimal);
	    $('#analytics-cartInfo').data('couponsName', data.couponNamesString);
	    $('.number-of-items').empty().append(data.resources.numberOfItems);

	    updateShippingCost(useshippingdiscounts, data);

	    $('.tax-total').empty().append(data.totals.totalTax);
	    $('.js-grand-total').empty().append(data.totals.grandTotal);
	    $('.sub-total').empty().append(data.totals.subTotal);
	    $('.minicart-link').attr({
	        'aria-label': data.resources.minicartCountOfItems
	    });
	    if ($('.minicart-quantity').length > 0) {
	        $('.minicart-quantity').empty().append(data.numItems);
	    }
	    if (data.totals.orderLevelDiscountTotal.value > 0 || data.totals.hasOwnProperty('gst') && data.totals.gstValue > 0) {
	        $('.initial-cart-value').removeClass('d-none');
	        $('.initial-cart-value-total').text(data.totals.initialCartValueFormatted);
	    } else {
	        $('.initial-cart-value').addClass('d-none');
	    }

	    if (data.totals.orderLevelDiscountTotal.value > 0) {
	        $('.order-discount').removeClass('hide-order-discount');
	        $('.order-discount-total').empty().append(data.totals.orderLevelDiscountTotal.negativeFormatted);
	    } else {
	        $('.order-discount').addClass('hide-order-discount');
	    }

	    if (data.totals.hasOwnProperty('gst') && data.totals.gstValue > 0) {
	        $('.gst-benefit').removeClass('d-none');
	        $('.gst-benefit-total').text(data.totals.negativeGstFormatted);
	    } else {
	        $('.gst-benefit').addClass('d-none');
	    }

	    if (data.totals.shippingLevelDiscountTotal.value > 0) {
	        $('.shipping-discount').removeClass('hide-shipping-discount');
	        $('.shipping-discount-total').empty().append('- ' + data.totals.shippingLevelDiscountTotal.formatted);
	    } else {
	        $('.shipping-discount').addClass('hide-shipping-discount');
	    }

	    data.items.forEach(function (item) {
	        if (item.renderedPromotions) {
	            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
	        }

	        if (item.priceTotal && item.priceTotal.renderedPrice) {
	            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
	        }
	    });

	    //Update shipping promotion callout message and approaching discount alert
	    if (useshippingdiscounts) {

	        var renderedProgressBarsObj = retrieveRenderedProgressBars();

	        var isAnyPromotionAvailable = false;

	        // Achieved discounts
	        if (data.totals.discounts && data.totals.discounts.length > 0 && $('.js-cart-promotion-bars').length > 0 /* If the promotion progress bar container doesn't exist, then it means that it was disabled*/) {
	                data.totals.discounts.forEach(function (discount) {
	                    if (discount.promotionInfo && discount.promotionInfo.isShippingPromotion) {

	                        isAnyPromotionAvailable = true;
	                        var discountId = discount.promotionID + '-bar';
	                        var $discountProgressBar;

	                        if (discountId in renderedProgressBarsObj) {
	                            renderedProgressBarsObj[discountId].toBeDeleted = false;
	                            $discountProgressBar = renderedProgressBarsObj[discountId].$element;
	                        } else {
	                            $discountProgressBar = $('#template-bar').clone().attr('id', discountId); // create a new progress bar
	                            $('.js-cart-promotion-bars').append($discountProgressBar);
	                        }
	                        $discountProgressBar.addClass('cc-promotion-progress-bar__full');
	                        $discountProgressBar.find('.js-promotion-progress-bar-label').text(discount.callOutMsg);
	                        $discountProgressBar.find('.js-promotion-progress-bar-percentage').width('100%');
	                    }
	                });
	            }

	        // Approaching discounts
	        if (data.approachingDiscounts && data.approachingDiscounts.length > 0 && $('.js-cart-promotion-bars').length > 0) {
	            data.approachingDiscounts.forEach(function (approachingDiscount) {

	                isAnyPromotionAvailable = true;
	                var approachingDiscountId = approachingDiscount.id + '-bar';
	                var $approachingDiscountProgressBar;

	                if (approachingDiscountId in renderedProgressBarsObj) {
	                    renderedProgressBarsObj[approachingDiscountId].toBeDeleted = false;
	                    $approachingDiscountProgressBar = renderedProgressBarsObj[approachingDiscountId].$element;
	                } else {
	                    $approachingDiscountProgressBar = $('#template-bar').clone().attr('id', approachingDiscountId); // create a new progress bar
	                    $('.js-cart-promotion-bars').append($approachingDiscountProgressBar);
	                }
	                $approachingDiscountProgressBar.removeClass('cc-promotion-progress-bar__full');
	                $approachingDiscountProgressBar.find('.js-promotion-progress-bar-label').text(approachingDiscount.discountMsg);
	                $approachingDiscountProgressBar.find('.js-promotion-progress-bar-percentage').width(approachingDiscount.percentageOffThreshold + '%');
	            });
	        }

	        if (isAnyPromotionAvailable) {
	            // Remove progress bars that were not updated
	            Object.keys(renderedProgressBarsObj).forEach(function (key) {
	                if (renderedProgressBarsObj[key].toBeDeleted) {
	                    renderedProgressBarsObj[key].$element.remove();
	                }
	            });
	            $('.js-cart-promotion-bars').removeClass('d-none');
	        } else {
	            $('.js-cart-promotion-bars').empty();
	            $('.js-cart-promotion-bars').addClass('d-none');
	        }
	    }
	}

	/**
	 * re-renders the order totals and the number of items in the cart
	 * @param {Object} message - Error message to display
	 */
	function createErrorNotification(message) {
	    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' + 'fade show" role="alert">' + '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' + '<span aria-hidden="true">&times;</span>' + '</button>' + message + '</div>';

	    $('.cart-error').html(errorHtml);
	}

	/**
	 * re-renders the approaching discount messages
	 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
	 */
	function updateApproachingDiscounts(approachingDiscounts) {
	    var html = '';
	    $('.approaching-discounts').empty();
	    if (approachingDiscounts.length > 0) {
	        approachingDiscounts.forEach(function (item) {
	            html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
	        });
	    }
	    $('.approaching-discounts').append(html);
	}

	/**
	 * Updates the availability of a product line item
	 * @param {Object} data - AJAX response from the server
	 * @param {string} uuid - The uuid of the product line item to update
	 */
	function updateAvailability(data, uuid) {
	    var lineItem;
	    var messages = '';

	    for (var i = 0; i < data.items.length; i++) {
	        if (data.items[i].UUID === uuid) {
	            lineItem = data.items[i];
	            break;
	        }
	    }

	    $('.availability-' + lineItem.UUID).empty();

	    if (lineItem.availability) {
	        if (lineItem.availability.messages) {
	            lineItem.availability.messages.forEach(function (message) {
	                messages += '<span class="cc-attribute-value cc-attribute-value-availability line-item-attributes';
	                if (!lineItem.availability.levelsResult.inStock) {
	                    messages += ' cc-attribute-value-lowstock-nostock';
	                }
	                messages += '">' + message + '</span>';
	            });
	        }

	        if (lineItem.availability.inStockDate) {
	            messages += '<span class="cc-attribute-value cc-attribute-value-instock-date line-item-attributes line-item-instock-date">';
	            messages += lineItem.availability.inStockDate;
	            messages += '</span>';
	        }
	    }
	    if (!data.isLineItemQtyLimit) {
	        $('.availability-' + lineItem.UUID).html(messages);
	    }
	}

	/**
	 * Finds an element in the array that matches search parameter
	 * @param {array} array - array of items to search
	 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
	 * @returns {Object|null} - returns an element of the array that matched the query.
	 */
	function findItem(array, match) {
	    for (var i = 0, l = array.length; i < l; i++) {
	        if (match.call(this, array[i])) {
	            return array[i];
	        }
	    }
	    return null;
	}

	/**
	 * Updates details of a product line item
	 * @param {Object} data - AJAX response from the server
	 * @param {string} uuid - The uuid of the product line item to update
	 */
	function updateProductDetails(data, uuid) {
	    var lineItem = findItem(data.cartModel.items, function (item) {
	        return item.UUID === uuid;
	    });

	    if (lineItem.variationAttributes) {
	        var colorAttr = findItem(lineItem.variationAttributes, function (attr) {
	            return attr.attributeId === 'color';
	        });

	        if (colorAttr) {
	            var colorSelector = '.Color-' + uuid;
	            var newColor = 'Color: ' + colorAttr.displayValue;
	            $(colorSelector).text(newColor);
	        }

	        var sizeAttr = findItem(lineItem.variationAttributes, function (attr) {
	            return attr.attributeId === 'size';
	        });

	        if (sizeAttr) {
	            var sizeSelector = '.Size-' + uuid;
	            var newSize = 'Size: ' + sizeAttr.displayValue;
	            $(sizeSelector).text(newSize);
	        }

	        var imageSelector = '.card.product-info.uuid-' + uuid + ' .item-image > img';
	        $(imageSelector).attr('src', lineItem.images.small[0].url);
	        $(imageSelector).attr('alt', lineItem.images.small[0].alt);
	        $(imageSelector).attr('title', lineItem.images.small[0].title);
	    }

	    if (lineItem.options && lineItem.options.length) {
	        var option = lineItem.options[0];
	        var optSelector = '.lineItem-options-values[data-option-id="' + option.optionId + '"]';
	        $(optSelector).data('value-id', option.selectedValueId);
	        $(optSelector + ' .line-item-attributes').text(option.displayName);
	    }

	    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
	    $(qtySelector).val(lineItem.quantity);
	    $(qtySelector).data('pid', data.newProductId);

	    $('.js-action-button-remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);
	    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
	    $(priceSelector).text(lineItem.price.sales.formatted);
	    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

	    if (lineItem.price.list) {
	        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
	        $(listPriceSelector).text(lineItem.price.list.formatted);
	        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
	    }
	}

	/**
	 * Generates the modal window on the first call.
	 *
	 */
	function getModalHtmlElement() {
	    if ($('#editProductModal').length !== 0) {
	        $('#editProductModal').remove();
	    }
	    var htmlString = '<!-- Modal -->' + '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog quick-view-dialog">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '    <button type="button" class="close pull-right" data-dismiss="modal">' + '        <span aria-hidden="true">&times;</span>' + '        <span class="sr-only"> </span>' + '    </button>' + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer"></div>' + '</div>' + '</div>' + '</div>';
	    $('body').append(htmlString);
	}

	/**
	 * Parses the html for a modal window
	 * @param {string} html - representing the body and footer of the modal window
	 *
	 * @return {Object} - Object with properties body and footer.
	 */
	function parseHtml(html) {
	    var $html = $('<div>').append($.parseHTML(html));

	    var body = $html.find('.product-quickview');
	    var footer = $html.find('.modal-footer').children();

	    return {
	        body: body,
	        footer: footer
	    };
	}

	/**
	 * replaces the content in the modal window for product variation to be edited.
	 * @param {string} editProductUrl - url to be used to retrieve a new product model
	 */
	function fillModalElement(editProductUrl) {
	    $('.modal-body').spinner().start();
	    $.ajax({
	        url: editProductUrl,
	        method: 'GET',
	        dataType: 'json',
	        success: function success(data) {
	            var parsedHtml = parseHtml(data.renderedTemplate);

	            $('#editProductModal .modal-body').empty();
	            $('#editProductModal .modal-body').html(parsedHtml.body);
	            $('#editProductModal .modal-footer').html(parsedHtml.footer);
	            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
	            $('#editProductModal .enter-message').text(data.enterDialogMessage);
	            $('#editProductModal').modal('show');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	/**
	 * replace content of modal
	 * @param {string} actionUrl - url to be used to remove product
	 * @param {string} productID - pid
	 * @param {string} productName - product name
	 * @param {string} uuid - uuid
	 */
	function confirmDelete(actionUrl, productID, productName, uuid) {
	    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
	    var $productToRemoveSpan = $('.product-to-remove');

	    $deleteConfirmBtn.data('pid', productID);
	    $deleteConfirmBtn.data('action', actionUrl);
	    $deleteConfirmBtn.data('uuid', uuid);

	    $productToRemoveSpan.empty().append(productName);
	}

	function handleWishlistButtonInTile($element, isInWishlist, isAddToCartDisabled) {
	    var $button = $element;
	    var $spanAdd = $button.find('span.wishlist-content-add').length !== 0 ? $button.find('span.wishlist-content-add') : $button.find('.wishlist-content-add');
	    var $spanRemove = $button.find('span.wishlist-content-remove').length !== 0 ? $button.find('span.wishlist-content-remove') : $button.find('.wishlist-content-remove');

	    if (!isAddToCartDisabled) {
	        if (isInWishlist) {
	            $button.addClass('to-remove');
	            $button.removeClass('to-add');

	            $spanAdd.addClass('d-none');
	            $spanRemove.removeClass('d-none');
	        } else {
	            $button.addClass('to-add');
	            $button.removeClass('to-remove');

	            $spanRemove.addClass('d-none');
	            $spanAdd.removeClass('d-none');
	        }
	    }
	}

	//This function checks if the pid in argument is included in the array of products' PID in wishlist
	function checkInWishlist(pid, isAddToCartDisabled, wishlistButton) {
	    var productArr = window.ProductsInWishlist;
	    if (!productArr) {
	        return false;
	    }
	    if (productArr.indexOf(pid) > -1) {
	        handleWishlistButtonInTile(wishlistButton, true, isAddToCartDisabled);
	    } else {
	        handleWishlistButtonInTile(wishlistButton, false, isAddToCartDisabled);
	    }
	}

	/**
	 * appends params to a url
	 * @description populate all the wishlist buttons in the cart tiles
	 */
	function updateWishlistButtons() {
	    $('.js-action-button-wishlist').each(function () {
	        var pid = $(this).data('pid');
	        var wishlistButton = $(this);
	        checkInWishlist(pid, false, wishlistButton);
	    });
	}

	/**
	 * appends params to a url
	 * @description populate all the wishlist buttons in the cart tiles
	 * @param {int} counter - the wishlist counter that will replace the old one
	 * @param {String} productArr - an array of product's ID that rapresent the wishlist, need to be parsed
	 */
	function updateWishlist(counter, productArr) {
	    if (counter > 0) {
	        $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').removeClass('d-none');
	    }
	    $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	    var productObj = JSON.parse(productArr);
	    window.ProductsInWishlist = productObj.result;
	    updateWishlistButtons();
	}

	function customizeScalapayWidget() {
	    var customLabel = $('.js-scalapay-widget').data('scalapay-custom-label');
	    var $scalapayWidget = $('.scalapay-widget-cart');

	    if ($scalapayWidget.length > 0) {
	        $($scalapayWidget[0].shadowRoot).find('.sp--nowrap')[2].outerText = customLabel;
	        $($scalapayWidget[0].shadowRoot).find('#sp-icon').css("color", "rgba(230, 0, 0, 0.85)");

	        var checkExist = setInterval(function () {
	            var $modalLogo = $('#sp_modal__logo');
	            var $modalClose = $('.sp_modal__close');
	            var isClearInterval1 = false;
	            var isClearInterval2 = false;

	            if ($modalLogo.length) {
	                $('.sp_modal__logo_image').remove();
	                $('.sp_modal__heading').append($modalLogo);
	                isClearInterval1 = true;
	            }
	            if ($modalClose.length) {
	                $modalClose.html('<span aria-hidden="true" class="icon-close-remove"></span>');
	                isClearInterval2 = true;
	            }
	            if (isClearInterval1 && isClearInterval2) {
	                clearInterval(checkExist);
	            }
	        }, 500);
	    }
	}

	function refreshScalapayWidget(scalapayWidgetTmpl) {
	    $('.js-scalapay-widget').empty().html(scalapayWidgetTmpl);
	    customizeScalapayWidget();
	}

	function updateQuantityLineItemInCart($thisParent, quantity, action) {
	    var productID = $thisParent.data('pid');
	    var url = $thisParent.data('action');
	    var uuid = $thisParent.data('uuid');
	    $('body').trigger('cart:beforeUpdate');

	    var urlParams = {
	        pid: productID,
	        quantity: quantity,
	        uuid: uuid
	    };
	    url = appendToUrl(url, urlParams);

	    // $thisParent.parents('.card').spinner().start();

	    $.ajax({
	        url: url,
	        type: 'get',
	        context: this,
	        dataType: 'json',
	        success: function success(data) {
	            $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
	            updateCartTotals(data);
	            updateApproachingDiscounts(data.approachingDiscounts);
	            updateAvailability(data, uuid);

	            var scalapayWidgetTmpl = $('.js-scalapay-widget').html();

	            //Cart order summary template refresh
	            $('.js-order-summary-refresh').empty().html(data.orderSummaryTemplate);

	            $('#cartLineItems').empty().html(data.orderCartProductListTemplate);

	            //Cart order summary Scalapay widget refresh
	            if (scalapayWidgetTmpl && data.scalaPayEnabled) {
	                refreshScalapayWidget(scalapayWidgetTmpl);
	            }

	            // $thisParent.data('original-pre-select-qty', quantity);
	            if (data.isLineItemQtyLimit && data.valueLineItemQtyLimit) {
	                $thisParent.data('pre-select-qty', data.valueLineItemQtyLimit);
	                $('.quantity[data-uuid="' + uuid + '"]').val(data.valueLineItemQtyLimit);
	                $('.quantity-form-' + uuid + ' .js-itemQuantity').text(data.valueLineItemQtyLimit);
	                var errorHtml = data.customErrorLineItemQtyLimit;
	            }
	            if (data.isLineItemQtyLimit) {
	                $('.quantity-form-' + uuid + ' .error-line-item-qty-limit').html(errorHtml);
	            } else {
	                $('.quantity-form-' + uuid + ' .error-line-item-qty-limit').html('');
	            }
	            validateBasket(data);
	            $('.cc-cart-title .js-number').empty().text('[' + data.numItems + ']');

	            $('body').trigger('cart:update', data);

	            if (action === 'up') {
	                $('body').trigger('analytics:addToCart', {
	                    productID: productID,
	                    pageType: 'cart'
	                });
	            } else if (action === 'down') {
	                $('body').trigger('analytics:removeFromCart', {
	                    productID: productID,
	                    pageType: 'cart',
	                    singleItem: true
	                });
	            }

	            //trigger the analytics update quantity event to prevent
	            $('body').trigger('analytics:updateProductQuantity', {
	                pid: productID,
	                qty: quantity
	            });
	            updateWishlistButtons();

	            $.spinner().stop();
	            if ($thisParent.parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
	                location.reload();
	            }
	        },
	        error: function error(err) {
	            if (err.responseJSON.redirectUrl) {
	                window.location.href = err.responseJSON.redirectUrl;
	            } else {
	                createErrorNotification(err.responseJSON.errorMessage);
	                //console.log(err.responseJSON.availableToSell);
	                $.spinner().stop();
	            }
	        }
	    });
	}

	function updateCouponSectionFromCouponResponse(classToUpdate, discountList) {
	    $(classToUpdate).empty().addClass("d-none");
	    if (discountList.length > 0) {

	        discountList.forEach(function (item) {

	            var discountItemNext = void 0;

	            if (item.promoFetchedByCoupon) {
	                discountItemNext = $('\n                    <div class="cc-summary-item">\n                        <div class="cc-summary-label">\n                            <span class="cc-number-products-label">' + item.discounCodeLabel + ' ' + item.promoFetchedByCoupon + '</span>\n                        </div>\n                        <div class="cc-summary-value sub-total">' + item.promoAppliedDiscount + '</div>\n                    </div>\n                ');
	            }

	            $(classToUpdate).append(discountItemNext);
	        });

	        var hasAtLeastOneCouponApplied = discountList.some(function (item) {
	            return item.promoFetchedByCoupon !== false;
	        });

	        if (hasAtLeastOneCouponApplied) {
	            $(classToUpdate).removeClass("d-none");
	        }
	    }
	}

	function updateCartPageFromCouponResponse(data, uuid) {
	    if (uuid) {
	        // coupon removed
	        $('.coupon-uuid-' + uuid).remove();
	    }
	    $('.coupons-and-promos').empty().append(data.basketModel.totals.discountsHtml);
	    updateCartTotals(data.basketModel);
	    // Fetch the discount informations based on coupons and display them in front end.
	    updateCouponSectionFromCouponResponse('.cc-summary-item-coupons-order-level', data.basketModel.totals.orderLevelDiscountTotal.orderLevelDiscountInformation);
	    updateCouponSectionFromCouponResponse('.cc-summary-item-coupons-product-level', data.basketModel.totals.productLevelDiscountTotal.productLevelDiscountInformation);
	    updateApproachingDiscounts(data.basketModel.approachingDiscounts);
	    validateBasket(data.basketModel);
	    $('.cc-cart-title .js-number').empty().text(data.basketModel.resources.minicartCountOfItems);
	    $('#cartLineItems').empty().html(data.template);

	    //update the product in wishlist only if the customer is logged
	    if (data.wishilistProductsArr) {
	        updateWishlist(data.wishlistCounter, data.wishilistProductsArr);
	    }
	}

	function updateCheckoutPageFromCouponResponse(data, uuid) {
	    if (uuid) {
	        // coupon removed
	        $('.coupon-uuid-' + uuid).remove();
	    }
	    //update the minicart price total
	    if ($('.minicartIconPrice').length > 0) {
	        $('.minicartIconPrice').html(data.order.totals.subTotal);
	    }
	    $('#analytics-cartInfo').data('value', data.order.totals.grandTotalDecimal);
	    $('#analytics-cartInfo').data('couponsName', data.order.couponsName);
	    $('.coupons-and-promos').empty().append(data.order.totals.discountsHtml);
	    var $couponStatus = $('#coupon-status'); // SR-only region
	    var successMessage = $('#customerForm').data('success-message');
	    if (data.order.couponsName) {
	        $('#giftcard-error').empty();
	        $couponStatus.text('couponName' + data.order.couponsName + successMessage);
	    } else {
	        $couponStatus.empty();
	    }

	    var updateScalapayWidgetText = data.order && data.order.totals && 'scalapayTotals' in data.order.totals;

	    $('body').trigger('checkout:updateCheckoutView', {
	        order: data.order,
	        customer: data.customer,
	        template: data.template,
	        updateOrderSummary: true,
	        updatePoints: true,
	        updateScalapayText: updateScalapayWidgetText,
	        preserveShippingFormData: true,
	        shippingMethodsData: data.template.shippingMethodsData
	    });
	    billingHelpers.methods.refreshBlockPaymentMethod(data.refreshPaymentMethodObj);
	    $('body').trigger('mercadopago:refreshFormAfterResponse', data.order.totals.grandTotalDecimal.toString());
	}

	function expressCheckoutOrderPlacementListener() {
	    $('body').on('cart:orderConfirm', function (e, params) {
	        var orderID = params.orderID,
	            orderToken = params.orderToken,
	            url = params.url;
	        if (orderID && orderToken && url) {
	            var redirect = $('<form>').appendTo(document.body).attr({
	                method: 'POST',
	                action: url
	            });
	            $('<input>').appendTo(redirect).attr({
	                name: 'orderID',
	                value: orderID
	            });
	            $('<input>').appendTo(redirect).attr({
	                name: 'orderToken',
	                value: orderToken
	            });
	            redirect.submit();
	        }
	    });
	}

	module.exports = function () {
	    // productsInWishlistOnDOMReadyCartPage
	    $(document).ready(function () {
	        (0, _stickyFunction.setStickyFixed)('.js-progressButton', 'bottom', ['mobile', 'tablet'], true, false);
	        (0, _stickyFunction.setStickyFixed)('.js-next-step-button', 'bottom', ['mobile', 'tablet'], true, false);
	        //setStickyFixed('.cc-summary-content-container', 'top', ['desktop'], false);
	        //summaryHelpers.updateProdsDetailHeight();
	    });

	    $('body').on('headerBar:loaded', function () {
	        window.ProductsInWishlist = [];
	        var productArrString = $('.wishlist-list.products-in-wishlist').attr('data-products-in-wishlist');

	        if (productArrString) {
	            var productObj = JSON.parse(productArrString);
	            var productArr = productObj.result;
	            if (!productArr) {
	                productArrString = $('.wishlist-list.products-in-wishlist').attr('data-products-in-wishlist');
	                if (productArrString) {
	                    productObj = JSON.parse(productArrString);
	                    productArr = productObj.result;
	                }
	            }
	            window.ProductsInWishlist = productArr || [];
	        } else {
	            window.ProductsInWishlist = [];
	        }
	        updateWishlistButtons();
	    });

	    $('body').on('afterRemoveFromCart', function (e, data) {
	        e.preventDefault();
	        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
	    });

	    $('.optional-promo').click(function (e) {
	        e.preventDefault();
	        $('.promo-code-form').toggle();
	    });

	    $('body').on('click', '.js-action-button-wishlist', function (e) {
	        e.preventDefault();
	        var addUrl = $(this).data('add-href');
	        var removeUrl = $(this).data('remove-href');
	        var pid = $(this).data('pid');
	        var optionId = null;
	        var optionVal = null;
	        removeUrl = removeUrl + '?pid=' + pid;

	        if (!addUrl || !removeUrl || !pid) {
	            return;
	        }

	        var pidElementsClass = '.js-action-button-wishlist-pid-'.concat(pid);
	        var pidElements = $(pidElementsClass);
	        var $wishlistButton = $(this);

	        var isRedirectToLogin = false;
	        var isAddToWishlist = $(this).hasClass("to-add");
	        var isRemoveFromWishlist = $(this).hasClass('to-remove');

	        // Handling also isSizeSelected as null (VG cases)
	        if (isAddToWishlist) {

	            //analytics add to wishlist event
	            $('body').trigger('analytics:addToWishlist', pid);

	            $.spinner().start();
	            $.ajax({
	                url: addUrl,
	                type: 'post',
	                dataType: 'json',
	                data: {
	                    pid: pid,
	                    optionId: optionId,
	                    optionVal: optionVal
	                },
	                success: function success(data) {
	                    //see Wishlist-AddProduct
	                    if (isRedirectToLogin) {
	                        isRedirectToLogin = false;
	                        if (data.redirectUrl) {
	                            window.location.href = data.redirectUrl;
	                        }
	                        return;
	                    }
	                    $.spinner().stop();
	                    if (!data.success && data.isFull) {
	                        $('#wishlist-modal-body').text(data.maxProductsMessage);
	                        $('#wishlist-modal').modal('show');
	                    } else if (data.success) {
	                        pidElements.each(function () {
	                            $(this).find('.wishlist-content-add').addClass('d-none');
	                            $(this).find('.wishlist-content-remove').removeClass('d-none');
	                            $(this).removeClass('to-add').addClass('to-remove');
	                        });

	                        // Wishlist minicart will be called after the sucessful adding of the item to the wishlist
	                        $('body').trigger('product:afterAddToWishlist', data);
	                    }
	                    $('.js-tileWrapper').removeClass('js-tileWrapperHover');
	                    $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	                    $wishlistButton.data("is-size-selected", null);
	                    window.ProductsInWishlist = data.productsArr;
	                    var counter = parseInt(data.wishlistSize);
	                    if (counter > 0) {
	                        $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').removeClass('d-none');
	                    }
	                    $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                    // Update wishlist counter for mobile
	                    if ($('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').length) {
	                        if (counter > 0) {
	                            $('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').removeClass('d-none');
	                        }
	                        $('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').html(counter);
	                    }

	                    // After the wishlist minicart is displayed, if it was opened automatically, it will close after a timeout.
	                    $('.js-minicart-wishlist-overlay').addClass('js-opened-by-add-to-minicart');
	                    var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));
	                    if (minicartTimeout > 0) {
	                        setTimeout(function () {
	                            if ($('.cc-minicart-overlay').hasClass('js-opened-by-add-to-minicart')) {
	                                //close minicart only of is opened automatically from pdp or plp or wishlist
	                                $('#closeMiniWishlistCartButton').click();
	                                $('.cc-minicart-overlay').removeClass('js-opened-by-add-to-minicart');
	                            }
	                        }, minicartTimeout);
	                    }
	                },
	                error: function error(err) {
	                    if (err.responseJSON.redirectUrl) {
	                        window.location.href = err.responseJSON.redirectUrl;
	                    }
	                }
	            });
	        } else if (isRemoveFromWishlist) {

	            //analytics remove from wishlist event
	            $('body').trigger('analytics:removeFromWishlist', pid);

	            $.spinner().start();
	            $.ajax({
	                url: removeUrl,
	                type: 'get',
	                dataType: 'json',
	                data: {},
	                success: function success(data) {
	                    //see Wishlist-RemoveProduct
	                    $.spinner().stop();
	                    pidElements.each(function () {
	                        $(this).find('.wishlist-content-add').removeClass('d-none');
	                        $(this).find('.wishlist-content-remove').addClass('d-none');
	                        $(this).removeClass('to-remove').addClass('to-add');
	                    });
	                    window.ProductsInWishlist = data.productsArr;
	                    $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	                    var counter = parseInt(data.wishlistSize);
	                    $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').html(counter);
	                    if (counter > 0) {
	                        $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').removeClass('d-none');
	                    }
	                    // Update wishlist counter for mobile
	                    if ($('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').length) {
	                        $('.cc-header-mobileMenu-footer-link.js-wishlistLink .js-wishlistNumber').html(counter);
	                        if (counter > 0) {
	                            $('.cc-headerBar-link.wishlistLink .js-wishlistNumber').removeClass('d-none');
	                        }
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        }
	    });

	    $('body').on('click', '.js-action-button-remove-product', function (e) {
	        e.preventDefault();

	        // disable button to prevent double click
	        $(this).prop('disabled', true);

	        var productID = $(this).data('pid');
	        var url = $(this).data('action');
	        var uuid = $(this).data('uuid');
	        var urlParams = {
	            pid: productID,
	            uuid: uuid
	        };

	        //analytics remove from cart event, the event is launched only from cart
	        var pageType = 'cart';
	        $('body').trigger('analytics:removeFromCart', {
	            productID: productID,
	            pageType: pageType
	        });

	        var pageReload = $('.container .cc-cart').data('iscartpage') === true;

	        url = appendToUrl(url, urlParams);

	        $('body > .modal-backdrop').remove();

	        // trigger inherit from SFRA update to 5.5.0 version, is not used directly by SFCC code
	        $('body').trigger('cart:beforeUpdate');

	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'get',
	            dataType: 'json',
	            success: function success(data) {
	                if (data.basket.items.length === 0) {
	                    if ($('.minicartIconPrice').length > 0) {
	                        $('.minicartIconPrice').html(data.basket.totals.subTotal);
	                    }
	                    $('#analytics-cartInfo').data('value', data.basket && data.basket.totals && data.basket.totals.grandTotalDecimal);
	                    $('#analytics-cartInfo').data('couponsName', data.basket && data.basket.couponNamesString);
	                    //close the mini-bag if it is empty
	                    if ($('#closeMiniCartButton').length > 0) {
	                        $('#closeMiniCartButton').click();
	                    }
	                    $('.cc-cart').empty().append('<div class="cc-cart-empty"> ' + '<h1 class="cc-cart-empty-title cc-h3--secondary">' + data.basket.resources.emptyCartMsgTitle + '</h1>' + '<p class="cc-cart-empty-description"><b>' + data.basket.resources.emptyCartMsg + '</b>' + data.basket.resources.emptyCartMsgText + '</p> ' + '<div class="cc-cart-empty-contentButtons">' + '<a class="cc-button-type-1" href="' + data.urlLinkShopNewIn +
	                    // ${URLUtils.url('Search-Show', 'cgid', pdict.categoryLandingPage)} +
	                    '" title="' + data.labelLinkShopNewIn +
	                    // ${Resource.msg('link.shop.new.in','cart',null)} +
	                    '">' + data.labelLinkShopNewIn +
	                    // ${Resource.msg('link.shop.new.in','cart',null)} +
	                    '</a>' + '<a class="cc-button-type-1" href="' + data.linkHomePage +
	                    // ${URLUtils.url('Home-Show')} +
	                    '" title="' + data.labelHomePage +
	                    // ${Resource.msg('link.home.page','cart',null)} +
	                    '">' + data.labelHomePage +
	                    // ${Resource.msg('link.home.page','cart',null)} +
	                    '</a>' + '</div>');
	                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
	                    $('.minicart-quantity').empty().append(data.basket.numItems);
	                    $('.minicart-link').attr({
	                        'aria-label': data.basket.resources.minicartCountOfItems
	                    });
	                    $('.minicart .popover').empty();
	                    $('.minicart .popover').removeClass('show');
	                    $('body').removeClass('modal-open');
	                    $('html').removeClass('veiled');
	                } else {
	                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
	                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
	                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
	                        }
	                    }
	                    $('.uuid-' + uuid).remove();
	                    if (!data.basket.hasBonusProduct) {
	                        $('.bonus-product').remove();
	                    }
	                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
	                    updateCartTotals(data.basket);
	                    updateApproachingDiscounts(data.basket.approachingDiscounts);
	                    $('.js-order-summary-refresh').empty().html(data.orderSummaryTemplate);
	                    $('body').trigger('setShippingMethodSelection', data.basket);
	                    //validate basket on delete products whenever is not the minicart
	                    if (!$('.cc-content-minicart').length > 0) {
	                        validateBasket(data.basket);
	                    }
	                    $('.cc-cart-title .js-number').empty().text(data.minicartCountOfItems);
	                    $('#cartLineItems').empty().html(data.basket.orderCartProductListTemplate);
	                }

	                // trigger inherit from SFRA update to 5.5.0 version, is not used directly by SFCC code
	                $('body').trigger('cart:update', data);

	                // In case product gets reloaded, we check for wishlisted items again.
	                updateWishlistButtons();

	                if (pageReload) {
	                    location.reload();
	                } else {
	                    $.spinner().stop();
	                }
	            },
	            error: function error(err) {
	                if (err.responseJSON.redirectUrl) {
	                    window.location.href = err.responseJSON.redirectUrl;
	                } else {
	                    createErrorNotification(err.responseJSON.errorMessage);
	                    // if we are in cart page, reload the page to avoid data inconsistecy
	                    if (pageReload) {
	                        location.reload();
	                    }
	                    $.spinner().stop();
	                }
	            }
	        });
	    });

	    var debouncedUpdateQuantityLineItemInCart = debounce(updateQuantityLineItemInCart, 400);

	    // update cart product quantity
	    $('body').on('click', '.quantity-form .js-qty-button', function () {
	        var $button = $(this);
	        if ($button.hasClass('disabled')) {
	            return;
	        }
	        var $thisParent = $(this).parent();
	        var preSelectQty = $thisParent.data('pre-select-qty');
	        var preSelectQtyInt = parseInt(preSelectQty, 10);
	        var uuid = $thisParent.data('uuid');
	        var quantity;
	        var buttonAction = $button.data('action');

	        if (buttonAction === 'up') {
	            var limit = parseInt($('#cartLineItems').data('itemlimit'), 10);
	            if (limit !== 0 && preSelectQty === limit - 1) {
	                $button.addClass('disabled');
	            }
	            quantity = preSelectQtyInt + 1;
	        } else {
	            $thisParent.find('.js-qty-button[data-action="up"]').removeClass('disabled');
	            quantity = preSelectQtyInt - 1;
	        }
	        if (quantity < 1) {
	            $('#remove-' + uuid).click();
	            return;
	        }

	        $thisParent.data('pre-select-qty', quantity);
	        $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
	        $('.quantity-form-' + uuid + ' .js-itemQuantity').text(quantity);
	        debouncedUpdateQuantityLineItemInCart($thisParent, quantity, buttonAction);
	    });

	    $('.shippingMethods').change(function () {
	        var url = $(this).attr('data-actionUrl');
	        var urlParams = {
	            methodID: $(this).find(':selected').attr('data-shipping-id')
	        };
	        // url = appendToUrl(url, urlParams);

	        $('.totals').spinner().start();
	        $.ajax({
	            url: url,
	            type: 'post',
	            dataType: 'json',
	            data: urlParams,
	            success: function success(data) {
	                if (data.error) {
	                    window.location.href = data.redirectUrl;
	                } else {
	                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
	                    updateCartTotals(data);
	                    updateApproachingDiscounts(data.approachingDiscounts);
	                    validateBasket(data);
	                }
	                $.spinner().stop();
	            },
	            error: function error(err) {
	                if (err.redirectUrl) {
	                    window.location.href = err.redirectUrl;
	                } else {
	                    createErrorNotification(err.responseJSON.errorMessage);
	                    $.spinner().stop();
	                }
	            }
	        });
	    });

	    $('#fakeCouponApplyButton').click(function () {
	        $('#couponCode').val($('#fakeCouponCode').val());
	        $('.promo-code-form').submit();
	    });

	    $('.promo-code-form').submit(function (e) {
	        e.preventDefault();
	        $.spinner().start();
	        var $couponCodeForm = $('.promo-code-form'),
	            $couponErrorMessage = $('.coupon-error-message');
	        var $couponCodeFormControl = $couponCodeForm.find('.form-control');
	        $('.coupon-missing-error').removeClass('d-block');
	        $couponErrorMessage.removeClass('d-block');
	        $('.cc-button-remove-error').removeClass('d-block');
	        $couponErrorMessage.empty();
	        var $couponError = $('#coupon-error'); // SR-only region
	        var missingMessage = $('.coupon-missing-error').data('message');

	        if (!$('.coupon-code-field').val()) {
	            $('.promo-code-form .form-control, .cc-fake-promo-code .form-control').addClass('is-invalid');
	            $couponCodeFormControl.attr('aria-describedby', 'missingCouponCode');
	            $('.coupon-missing-error').addClass('d-block');
	            $('.cc-button-remove-error').addClass('d-block');
	            $couponError.text(missingMessage);

	            $.spinner().stop();
	            return false;
	        }
	        var isCheckout = $('body').hasClass('checkOutPage');
	        var additionalCheckoutData = {
	            isCheckout: isCheckout
	        };
	        // enhance eventually data with useful attributes (like vouchers in checkout page)
	        $('body').trigger('cart:applyCoupon', additionalCheckoutData);
	        var data = $couponCodeForm.serializeArray();
	        data.push({
	            name: 'additionalCheckoutData',
	            value: JSON.stringify(additionalCheckoutData)
	        });
	        $couponCodeFormControl.removeClass('is-invalid');
	        $couponErrorMessage.empty();

	        $.ajax({
	            url: $couponCodeForm.attr('action'),
	            type: 'GET',
	            dataType: 'json',
	            data: data,
	            success: function success(data) {
	                if (data.error) {
	                    // invlid coupon
	                    $('.promo-code-form .form-control').addClass('is-invalid');
	                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
	                    $('.coupon-error-message').empty().append(data.errorMessage);
	                    $('.coupon-error-message').addClass('d-block');
	                    $('.cc-button-remove-error').addClass('d-block');
	                    $couponError.text(data.errorMessage);
	                } else {
	                    $couponError.empty();
	                    // coupon added successfully
	                    if (isCheckout) {
	                        // checkout page
	                        updateCheckoutPageFromCouponResponse(data);
	                        $('body').trigger('adyen:renderGenericComponent');
	                    } else {
	                        // cart page
	                        updateCartPageFromCouponResponse(data);
	                    }
	                }
	                $('.coupon-code-field').val('');
	                $.spinner().stop();
	            },
	            error: function error(err) {
	                if (err.responseJSON.redirectUrl) {
	                    window.location.href = err.responseJSON.redirectUrl;
	                } else {
	                    createErrorNotification(err.responseJSON.errorMessage);
	                    $.spinner().stop();
	                }
	            }
	        });
	        return false;
	    });

	    $('body').on('click', '.cc-button-remove-error', function () {
	        $(this).removeClass('d-block');
	        $('.coupon-missing-error').removeClass('d-block');
	        $('.coupon-error-message').removeClass('d-block');
	    });

	    $('body').on('click', '.remove-coupon', function (e) {
	        e.preventDefault();

	        var couponCode = $(this).data('code');
	        var uuid = $(this).data('uuid');
	        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
	        var $productToRemoveSpan = $('.coupon-to-remove');

	        $deleteConfirmBtn.data('uuid', uuid);
	        $deleteConfirmBtn.data('code', couponCode);

	        $productToRemoveSpan.empty().append(couponCode);
	    });

	    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
	        e.preventDefault();

	        var url = $(this).data('action');
	        var uuid = $(this).data('uuid');
	        var couponCode = $(this).data('code');
	        var isCheckout = $('body').hasClass('checkOutPage');
	        var urlParams = {
	            code: couponCode,
	            uuid: uuid,
	            isCheckout: isCheckout
	        };
	        // enhance eventually data with useful attributes (like vouchers in checkout page)
	        $('body').trigger('cart:removeCoupon', urlParams);
	        url = appendToUrl(url, urlParams);
	        $('body').trigger('promotion:beforeUpdate');
	        var couponItemBlockToRemove = '.coupon-item-' + couponCode;
	        $.spinner().start();
	        $.ajax({
	            url: url,
	            type: 'get',
	            dataType: 'json',
	            success: function success(data) {
	                if (isCheckout) {
	                    // checkout page
	                    updateCheckoutPageFromCouponResponse(data, uuid);
	                    $('body').trigger('adyen:renderGenericComponent');
	                } else {
	                    // cart page
	                    updateCartPageFromCouponResponse(data, uuid);
	                    $(couponItemBlockToRemove).parent().empty().addClass('d-none');
	                }
	                $.spinner().stop();
	                $('body').trigger('promotion:success', data);
	            },
	            error: function error(err) {
	                if (err.responseJSON.redirectUrl) {
	                    window.location.href = err.responseJSON.redirectUrl;
	                } else {
	                    createErrorNotification(err.responseJSON.errorMessage);
	                    $.spinner().stop();
	                }
	                $('body').trigger('promotion:error', err);
	            }
	        });
	    });
	    $('body').on('click', '.cart-page .bonus-product-button', function () {
	        $.spinner().start();
	        $(this).addClass('launched-modal');
	        $.ajax({
	            url: $(this).data('url'),
	            method: 'GET',
	            dataType: 'json',
	            success: function success(data) {
	                bonusProductHelpers.methods.editBonusProducts(data);
	                $.spinner().stop();
	            },
	            error: function error() {
	                $.spinner().stop();
	            }
	        });
	    });

	    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
	        $('#chooseBonusProductModal').remove();
	        $('.modal-backdrop').remove();
	        $('body').removeClass('modal-open');

	        if ($('.cart-page').length) {
	            $('.launched-modal .btn-outline-primary').trigger('focus');
	            $('.launched-modal').removeClass('launched-modal');
	        } else {
	            $('.product-detail .add-to-cart').focus();
	        }
	    });

	    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
	        e.preventDefault();

	        var editProductUrl = $(this).attr('href');
	        getModalHtmlElement();
	        fillModalElement(editProductUrl);
	    });

	    $('body').on('shown.bs.modal', '#editProductModal', function () {
	        $('#editProductModal').siblings().attr('aria-hidden', 'true');
	        $('#editProductModal .close').focus();
	    });

	    $('body').on('hidden.bs.modal', '#editProductModal', function () {
	        $('#editProductModal').siblings().attr('aria-hidden', 'false');
	    });

	    $('body').on('keydown', '#editProductModal', function (e) {
	        var focusParams = {
	            event: e,
	            containerSelector: '#editProductModal',
	            firstElementSelector: '.close',
	            lastElementSelector: '.update-cart-product-global',
	            nextToLastElementSelector: '.modal-footer .quantity-select'
	        };
	        focusHelper.setTabNextFocus(focusParams);
	    });

	    $('body').on('product:updateAddToCart', function (e, response) {
	        // update global add to cart (single products, bundles)
	        var dialog = $(response.$productContainer).closest('.quick-view-dialog');

	        $('.update-cart-product-global', dialog).attr('disabled', !$('.global-availability', dialog).data('ready-to-order') || !$('.global-availability', dialog).data('available'));
	    });

	    $('body').on('product:updateAvailability', function (e, response) {
	        // bundle individual products
	        $('.product-availability', response.$productContainer).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available).find('.availability-msg').empty().html(response.message);

	        var dialog = $(response.$productContainer).closest('.quick-view-dialog');

	        if ($('.product-availability', dialog).length) {
	            // bundle all products
	            var allAvailable = $('.product-availability', dialog).toArray().every(function (item) {
	                return $(item).data('available');
	            });

	            var allReady = $('.product-availability', dialog).toArray().every(function (item) {
	                return $(item).data('ready-to-order');
	            });

	            $('.global-availability', dialog).data('ready-to-order', allReady).data('available', allAvailable);

	            $('.global-availability .availability-msg', dialog).empty().html(allReady ? response.message : response.resources.info_selectforstock);
	        } else {
	            // single product
	            $('.global-availability', dialog).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available).find('.availability-msg').empty().html(response.message);
	        }
	    });

	    $('body').on('recommendationCarousel:loaded', function () {
	        updateWishlistButtons();
	    });

	    $('body').on('product:afterAttributeSelect', function (e, response) {
	        if ($('.modal.show .product-quickview .bundle-items').length) {
	            $('.modal.show').find(response.container).data('pid', response.data.product.id);
	            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
	        } else {
	            $('.modal.show .product-quickview').data('pid', response.data.product.id);
	        }
	    });

	    $('body').on('change', '.quantity-select', function () {
	        var selectedQuantity = $(this).val();
	        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
	    });

	    $('body').on('change', '.options-select', function () {
	        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
	        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
	    });

	    $('body').on('keydown', '.quantity-form .js-qty-button, .cc-image-link.js-analytics-productClick, .cc-cart-product-name.js-analytics-productClick', function (e) {
	        if (e.key === 'Enter' || e.key === 'Spacebar' || e.key === ' ' || e.key === 'Space') {
	            e.preventDefault();
	            $(this).trigger('click');
	        }
	    });

	    $('body').on('focus', '.cc-product__tooltip__wrapper__icon', function () {
	        $(this).closest('.cc-product-promo').addClass('hover');
	    });

	    $('body').on('blur', '.cc-product__tooltip__wrapper__icon', function () {
	        $(this).closest('.cc-product-promo').removeClass('hover');
	    });

	    $('body').on('click', '.update-cart-product-global', function (e) {
	        e.preventDefault();

	        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
	        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
	        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
	        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

	        var form = {
	            uuid: uuid,
	            pid: base.getPidValue($(this)),
	            quantity: selectedQuantity,
	            selectedOptionValueId: selectedOptionValueId
	        };

	        $(this).parents('.card').spinner().start();
	        if (updateProductUrl) {
	            $.ajax({
	                url: updateProductUrl,
	                type: 'post',
	                context: this,
	                data: form,
	                dataType: 'json',
	                success: function success(data) {
	                    $('#editProductModal').modal('hide');

	                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
	                    updateCartTotals(data.cartModel);
	                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
	                    updateAvailability(data.cartModel, uuid);
	                    updateProductDetails(data, uuid);

	                    if (data.uuidToBeDeleted) {
	                        $('.uuid-' + data.uuidToBeDeleted).remove();
	                    }

	                    validateBasket(data.cartModel);

	                    $('body').trigger('cart:update');

	                    $.spinner().stop();
	                },
	                error: function error(err) {
	                    if (err.responseJSON.redirectUrl) {
	                        window.location.href = err.responseJSON.redirectUrl;
	                    } else {
	                        createErrorNotification(err.responseJSON.errorMessage);
	                        $.spinner().stop();
	                    }
	                }
	            });
	        }
	    });

	    $('body').on('click', '#minicartIcon', function () {
	        window.location.href = $('#minicartIcon').data('redirect');
	    });

	    // close unavailable product modal
	    $('.js-close-unavailableProductsModal').on('click', function () {
	        $('#unavailableProductsModal').hide();
	    });

	    // go to checkout page/home page (two cart buttons)
	    $('#cart-page-checkout-btn, #cart-page-home-btn').on('click', function () {
	        window.location.href = $(this).data('url');
	    });

	    var $stickyBar = $('.cc-cart__stickyBtn__wrapper');
	    function stickyBar() {
	        window.addEventListener('scroll', function () {
	            if ($('.cc-cart-summary-buttonContainer').length === 0) {
	                return;
	            }

	            var currentScroll = $(this).scrollTop();
	            var windowHeight = $(window).height();
	            var buttonPosition = $('.cc-cart-summary-buttonContainer').offset().top - windowHeight + $('.cc-cart-summary-buttonContainer').height();

	            if (currentScroll < buttonPosition) {
	                $stickyBar.removeClass('cc-cart__stickyBtn__wrapper__scrollDown');
	            } else {
	                $stickyBar.addClass('cc-cart__stickyBtn__wrapper__scrollDown');
	            }
	        }, { passive: true });
	    }

	    $(document).ready(function () {
	        stickyBar();

	        if ($('.cc-cart-summary-buttonContainer').length === 0) {
	            return;
	        }

	        var windowHeight = $(window).height();
	        var initialScroll = $(this).scrollTop();
	        var buttonPosition = $('.cc-cart-summary-buttonContainer').offset().top - windowHeight + $('.cc-cart-summary-buttonContainer').height();

	        if (initialScroll < buttonPosition) {
	            $stickyBar.removeClass('cc-cart__stickyBtn__wrapper__scrollDown');
	        }
	    });

	    $(window).resize(function () {
	        stickyBar();
	    });

	    function closeSizeModal() {
	        $(document).on('click', '.js-close-size', function (e) {
	            e.stopPropagation();
	            e.preventDefault();
	            $(this).closest('.cc-tile-sizes').removeClass('cc-active');
	            $('body').removeClass('modal-open');
	        });

	        $(document).on('click', '.cc-tile-sizes.cc-active', function (e) {
	            e.stopPropagation();
	            e.preventDefault();

	            if (e.target !== e.currentTarget) {
	                return;
	            }

	            $(this).closest('.cc-tile-sizes').removeClass('cc-active');
	            $('body').removeClass('modal-open');
	        });
	    }

	    closeSizeModal();

	    customizeScalapayWidget();

	    expressCheckoutOrderPlacementListener();

	    // there is not edit modal for product items in cart
	    // base.selectAttribute();
	    // base.colorAttribute();
	    bonusProductHelpers.removeBonusProduct();
	    bonusProductHelpers.selectBonusProduct();
	    bonusProductHelpers.enableBonusProductSelection();
	    bonusProductHelpers.showMoreBonusProducts();
	    bonusProductHelpers.addBonusProductsToCart();
	    bonusProductHelpers.focusChooseBonusProductModal();
	    bonusProductHelpers.trapChooseBonusProductModalFocus();
	    bonusProductHelpers.onClosingChooseBonusProductModal();
	};

/***/ }),
/* 117 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	/**
	 * @description fix an html element position top or bottom in the page
	 * @param cssSelector {string} is the css selector of the element to fix in page.
	 * example: .js-element-in-page
	 * @param position {string} is the position (top or bottom).
	 * example: 'bottom'
	 * @param breakpoints {string[]} is the breakpoints list.
	 * example: ['mobile', 'tablet', 'desktop']
	 */

	var isMobile = void 0,
	    isTablet = void 0,
	    isDesktop = void 0,
	    isElemFullWidth = void 0,
	    isElemCheckOutsideParent = void 0,
	    elem = void 0,
	    elemPosition = void 0,
	    elemParent = void 0;
	var pageScrollHeight = 740;

	function setVars(cssSelector, position, breakpoints, isFullWidth, isCheckOutsideParent) {
	    isMobile = breakpoints.indexOf('mobile') >= 0;
	    isTablet = breakpoints.indexOf('tablet') >= 0;
	    isDesktop = breakpoints.indexOf('desktop') >= 0;
	    isElemFullWidth = isFullWidth;
	    isElemCheckOutsideParent = isCheckOutsideParent;
	    elem = document.querySelector(cssSelector);
	    elemPosition = position;
	    elemParent = elem.parentNode;
	}

	function getFixedBreakpoint() {
	    return isMobile && window.isMobile || isTablet && window.isTablet || isDesktop && window.isDesktop;
	}

	function getFixedOffset() {
	    var elemRect = elemParent.getBoundingClientRect(),
	        offsetBottom = elemRect.top + elem.offsetHeight >= window.innerHeight,
	        offsetTop = elemRect.top <= 0;
	    return elemPosition === 'bottom' ? offsetBottom : offsetTop;
	}

	function getIsTaller() {
	    return elem.clientHeight > window.innerHeight;
	}

	function getIsOutsideParent() {
	    return isElemCheckOutsideParent && -elemParent.getBoundingClientRect().y + elem.clientHeight > elemParent.getBoundingClientRect().height;
	}

	function skipSideBarDynamicPositioning() {
	    if (typeof elem === "undefined" || elem === null) {
	        return;
	    } else if (elem.classList.contains('cc-sticky-side-bar')) {
	        $('body').css('overflow-x', 'unset');
	    }
	    return;
	}

	function fixAbsoluteElem() {
	    skipSideBarDynamicPositioning();
	    var elemStyle = elem.style;
	    elemStyle.position = 'absolute';
	    if (!elem.matches('.cc-no-sticky-top') || !elem.matches('.cc-no-sticky-bottom')) {
	        elemStyle.top = elemParent.getBoundingClientRect().height - elem.clientHeight + 'px';
	    }
	}

	function unfixAbsoluteElem() {
	    var elemStyle = elem.style;
	    elemStyle.position = '';
	    elemStyle.top = '';
	}

	function fixElem() {
	    elem.classList.add('cc-sticky-fixed');
	    if (isElemFullWidth) {
	        elem.classList.add('full-width');
	    } else {
	        var stickyCategory = document.querySelector('.cc-sticky-fixed');
	        var csParent = getComputedStyle(elemParent);
	        var paddingX = parseFloat(csParent.paddingLeft) + parseFloat(csParent.paddingRight);
	        elem.style.width = elemParent.offsetWidth - paddingX + 'px';
	        stickyCategory.style.top = '0';
	        stickyCategory.style.bottom = '0';
	    }
	    if (elemPosition === 'bottom') {
	        elem.classList.add('cc-sticky-fixed-bottom');
	    } else {
	        elem.classList.add('cc-sticky-fixed-top');
	    }
	}

	// On window scroll, when the user arrives near the bottom of the page, the category list will display fixed to the dynamic screen height and then position itself at the bottom of the PDP
	window.onscroll = function () {
	    skipSideBarDynamicPositioning();
	    if (window.innerHeight + window.pageYOffset >= document.body.offsetHeight - pageScrollHeight) {
	        var stickyCategory = document.querySelector('.cc-sticky-fixed');
	        if (stickyCategory !== null && !window.isMobile) {
	            elem.style.removeProperty('top');
	            if (!stickyCategory.matches('.cc-no-sticky-bottom')) {
	                stickyCategory.style.position = 'absolute';
	            }
	            stickyCategory.style.bottom = '0';
	            if (!window.isTablet) {
	                elem.classList.add('cc-sticky-fixed-bottom');
	            }
	        }
	    }
	};

	function unfixElem() {
	    elem.classList.remove('cc-sticky-fixed');
	    elem.classList.remove('cc-sticky-fixed-bottom');
	    elem.classList.remove('cc-sticky-fixed-top');
	    elem.classList.remove('full-width');
	    elem.style.width = '';
	}

	function fixOrUnfixElem() {
	    var isFixedBreakpoint = getFixedBreakpoint();
	    var isFixedOffset = getFixedOffset();
	    var isTallerThanWindow = getIsTaller();
	    var isOutsideParent = getIsOutsideParent();

	    unfixAbsoluteElem();
	    if (isOutsideParent) {
	        fixAbsoluteElem();
	    } else if (isFixedBreakpoint && isFixedOffset && !isTallerThanWindow) {
	        fixElem();
	    } else {
	        unfixElem();
	    }
	}

	function bindEventListener() {
	    document.addEventListener('scroll', function () {
	        fixOrUnfixElem();
	    });
	    window.addEventListener('resize', function () {
	        fixOrUnfixElem();
	    });
	}

	function setStickyFixed(cssSelector, position, breakpoints, isFullWidth, isCheckOutsideParent) {
	    if (document.querySelector(cssSelector) !== null) {
	        setVars(cssSelector, position, breakpoints, isFullWidth, isCheckOutsideParent);
	        if (elem.matches('.cc-sticky-side-bar')) {
	            return;
	        }
	        if (!elem.classList.contains('cc-is-sticky-fixed') && !elem.matches('.cc-sticky-side-bar')) {
	            elem.classList.add('cc-is-sticky-fixed');
	            fixOrUnfixElem();
	            bindEventListener();
	        }
	    }
	}

	exports.setStickyFixed = setStickyFixed;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	//enables lazyload in pdp

	var picture_lazy_load = __webpack_require__(119);
	picture_lazy_load.init();

	function hideAddToWishlistButtonInPDP() {
	    $('.product-detail .prices-add-to-cart-actions .add-to-wish-list').hide();
	}
	hideAddToWishlistButtonInPDP();

	function selectASizeHintWishList() {
	    $('.container').on('click', '.add-to-wish-list', function () {
	        var $self = $(this);
	        if (!$self.hasClass('to-add to-remove')) {

	            var $overlay = $self.parents('.product-tile').find('.js-tile-open-overlay');
	            // PLP case for VG products to not open the size drawer.
	            if ($overlay.hasClass('js-noSize') || $self.attr('data-is-size-selected') === 'null') {
	                return;
	            } else {
	                $self.closest('.cc-col-tile').addClass('js-addWishlist');
	                $overlay.trigger('click');
	            }
	        }
	    });
	}

	selectASizeHintWishList();

	//this function is to use only if variationGroups have different type of size
	// function modifyUrlColorSwatchesToSingleVariant($sizeTile) {
	//     var urlVariantValue = $sizeTile.attr('value');
	//     var sizeValue = $sizeTile.attr('data-attr-value');
	//     var $colorSwatches = $('.attributes .swatches-container .color-attribute');
	//     var urlToReplace;
	//     $colorSwatches.each(function () {
	//         var element = $(this).find('.color-value');
	//         var colorValue = element.attr('data-attr-value');
	//         urlToReplace = urlVariantValue;
	//         urlToReplace = urlToReplace.replace(/(?<=size=)(.*?)((?=&)|(?=$))/, sizeValue);
	//         urlToReplace = urlToReplace.replace(/(?<=color=)(.*?)((?=&)|(?=$))/, colorValue);
	//         $(this).attr('data-url', urlToReplace);
	//     })
	// }

	/**
	 * Retrieves the relevant pid value
	 * @param {jquery} $el - DOM container for a given add to cart button
	 * @return {string} - value to be used when adding product to cart
	 */
	function getPidValue($el) {
	    var pid;

	    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length > 0) {
	        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
	    } else if ($($el).closest('.product-tile').length > 0) {
	        pid = $($el).data('pid');
	    } else if ($($el).closest('.product-set').length > 0 || $('.product-set').length > 0) {
	        pid = $($el).closest('.product-detail').find('.product-id').text();
	    } else {
	        pid = $('.product-detail:not(".bundle-item")').data('pid');
	    }

	    return pid;
	}

	/**
	 * Makes a call to the server to report the event of adding an item to the cart
	 *
	 * @param {string | boolean} url - a string representing the end point to hit so that the event can be recorded, or false
	 */
	function miniCartReportingUrl(url) {
	    if (url) {
	        $.ajax({
	            url: url,
	            method: 'GET',
	            success: function success() {
	                // reporting urls hit on the server
	            },
	            error: function error() {
	                // no reporting urls hit on the server
	            }
	        });
	    }
	}

	module.exports = {
	    getPidValue: getPidValue,
	    miniCartReportingUrl: miniCartReportingUrl
	};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = {
	    init: function init() {
	        //var featureDetect = require('./featureDetect');

	        var lazySizesConfig = window.lazySizesConfig = window.lazySizesConfig || {};
	        lazySizesConfig.init = false;
	        lazySizesConfig.loadMode = 2;
	        lazySizesConfig.preloadAfterLoad = false;
	        lazySizesConfig.ricTimeout = 250;
	        lazySizesConfig.expand = 700;
	        lazySizesConfig.loadHidden = false;
	        lazySizesConfig.srcAttr = 'data-lazy';
	        lazySizesConfig.srcsetAttr = 'data-srcset';
	        lazySizesConfig.sizesAttr = 'data-sizes';
	        lazySizesConfig.lazyClass = 'b-lazyload';
	        lazySizesConfig.loadingClass = 'b-lazyload_loading';
	        lazySizesConfig.loadedClass = 'b-lazyload_loaded';

	        var lazysizes = __webpack_require__(120);

	        document.addEventListener('lazybeforeunveil', function (e) {
	            var bg = e.target.getAttribute('data-bg');
	            if (bg) {
	                e.target.style.backgroundImage = 'url(' + bg + ')';
	            }
	        });

	        lazysizes.init();
	        // if (!featureDetect.hasPicture) {
	        //     import( /* webpackChunkName: "picturefill" */ 'picturefill').then((loadedModule) => {
	        //         loadedModule.default();
	        //         lazysizes.init();
	        //     });
	        // } else {
	        //     lazysizes.init();
	        // }

	    }
	};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	(function (window, factory) {
		var lazySizes = factory(window, window.document);
		window.lazySizes = lazySizes;
		if (( false ? 'undefined' : _typeof(module)) == 'object' && module.exports) {
			module.exports = lazySizes;
		}
	})(window, function l(window, document) {
		'use strict';
		/*jshint eqnull:true */

		if (!document.getElementsByClassName) {
			return;
		}

		var lazysizes, lazySizesConfig;

		var docElem = document.documentElement;

		var Date = window.Date;

		var supportPicture = window.HTMLPictureElement;

		var _addEventListener = 'addEventListener';

		var _getAttribute = 'getAttribute';

		var addEventListener = window[_addEventListener];

		var setTimeout = window.setTimeout;

		var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

		var requestIdleCallback = window.requestIdleCallback;

		var regPicture = /^picture$/i;

		var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

		var regClassCache = {};

		var forEach = Array.prototype.forEach;

		var hasClass = function hasClass(ele, cls) {
			if (!regClassCache[cls]) {
				regClassCache[cls] = new RegExp('(\\s|^)' + cls + '(\\s|$)');
			}
			return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
		};

		var addClass = function addClass(ele, cls) {
			if (!hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
			}
		};

		var removeClass = function removeClass(ele, cls) {
			var reg;
			if (reg = hasClass(ele, cls)) {
				ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
			}
		};

		var addRemoveLoadEvents = function addRemoveLoadEvents(dom, fn, add) {
			var action = add ? _addEventListener : 'removeEventListener';
			if (add) {
				addRemoveLoadEvents(dom, fn);
			}
			loadEvents.forEach(function (evt) {
				dom[action](evt, fn);
			});
		};

		var triggerEvent = function triggerEvent(elem, name, detail, noBubbles, noCancelable) {
			var event = document.createEvent('Event');

			if (!detail) {
				detail = {};
			}

			detail.instance = lazysizes;

			event.initEvent(name, !noBubbles, !noCancelable);

			event.detail = detail;

			elem.dispatchEvent(event);
			return event;
		};

		var updatePolyfill = function updatePolyfill(el, full) {
			var polyfill;
			if (!supportPicture && (polyfill = window.picturefill || lazySizesConfig.pf)) {
				if (full && full.src && !el[_getAttribute]('srcset')) {
					el.setAttribute('srcset', full.src);
				}
				polyfill({ reevaluate: true, elements: [el] });
			} else if (full && full.src) {
				el.src = full.src;
			}
		};

		var getCSS = function getCSS(elem, style) {
			return (getComputedStyle(elem, null) || {})[style];
		};

		var getWidth = function getWidth(elem, parent, width) {
			width = width || elem.offsetWidth;

			while (width < lazySizesConfig.minSize && parent && !elem._lazysizesWidth) {
				width = parent.offsetWidth;
				parent = parent.parentNode;
			}

			return width;
		};

		var rAF = function () {
			var running, waiting;
			var firstFns = [];
			var secondFns = [];
			var fns = firstFns;

			var run = function run() {
				var runFns = fns;

				fns = firstFns.length ? secondFns : firstFns;

				running = true;
				waiting = false;

				while (runFns.length) {
					runFns.shift()();
				}

				running = false;
			};

			var rafBatch = function rafBatch(fn, queue) {
				if (running && !queue) {
					fn.apply(this, arguments);
				} else {
					fns.push(fn);

					if (!waiting) {
						waiting = true;
						(document.hidden ? setTimeout : requestAnimationFrame)(run);
					}
				}
			};

			rafBatch._lsFlush = run;

			return rafBatch;
		}();

		var rAFIt = function rAFIt(fn, simple) {
			return simple ? function () {
				rAF(fn);
			} : function () {
				var that = this;
				var args = arguments;
				rAF(function () {
					fn.apply(that, args);
				});
			};
		};

		var throttle = function throttle(fn) {
			var running;
			var lastTime = 0;
			var gDelay = lazySizesConfig.throttleDelay;
			var rICTimeout = lazySizesConfig.ricTimeout;
			var run = function run() {
				running = false;
				lastTime = Date.now();
				fn();
			};
			var idleCallback = requestIdleCallback && rICTimeout > 49 ? function () {
				requestIdleCallback(run, { timeout: rICTimeout });

				if (rICTimeout !== lazySizesConfig.ricTimeout) {
					rICTimeout = lazySizesConfig.ricTimeout;
				}
			} : rAFIt(function () {
				setTimeout(run);
			}, true);

			return function (isPriority) {
				var delay;

				if (isPriority = isPriority === true) {
					rICTimeout = 33;
				}

				if (running) {
					return;
				}

				running = true;

				delay = gDelay - (Date.now() - lastTime);

				if (delay < 0) {
					delay = 0;
				}

				if (isPriority || delay < 9) {
					idleCallback();
				} else {
					setTimeout(idleCallback, delay);
				}
			};
		};

		//based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
		var debounce = function debounce(func) {
			var timeout, timestamp;
			var wait = 99;
			var run = function run() {
				timeout = null;
				func();
			};
			var later = function later() {
				var last = Date.now() - timestamp;

				if (last < wait) {
					setTimeout(later, wait - last);
				} else {
					(requestIdleCallback || run)(run);
				}
			};

			return function () {
				timestamp = Date.now();

				if (!timeout) {
					timeout = setTimeout(later, wait);
				}
			};
		};

		(function () {
			var prop;

			var lazySizesDefaults = {
				lazyClass: 'lazyload',
				loadedClass: 'lazyloaded',
				loadingClass: 'lazyloading',
				preloadClass: 'lazypreload',
				errorClass: 'lazyerror',
				//strictClass: 'lazystrict',
				autosizesClass: 'lazyautosizes',
				srcAttr: 'data-src',
				srcsetAttr: 'data-srcset',
				sizesAttr: 'data-sizes',
				//preloadAfterLoad: false,
				minSize: 40,
				customMedia: {},
				init: true,
				expFactor: 1.5,
				hFac: 0.8,
				loadMode: 2,
				loadHidden: true,
				ricTimeout: 0,
				throttleDelay: 125
			};

			lazySizesConfig = window.lazySizesConfig || window.lazysizesConfig || {};

			for (prop in lazySizesDefaults) {
				if (!(prop in lazySizesConfig)) {
					lazySizesConfig[prop] = lazySizesDefaults[prop];
				}
			}

			window.lazySizesConfig = lazySizesConfig;

			setTimeout(function () {
				if (lazySizesConfig.init) {
					init();
				}
			});
		})();

		var loader = function () {
			var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

			var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

			var regImg = /^img$/i;
			var regIframe = /^iframe$/i;

			var supportScroll = 'onscroll' in window && !/(gle|ing)bot/.test(navigator.userAgent);

			var shrinkExpand = 0;
			var currentExpand = 0;

			var isLoading = 0;
			var lowRuns = -1;

			var resetPreloading = function resetPreloading(e) {
				isLoading--;
				if (!e || isLoading < 0 || !e.target) {
					isLoading = 0;
				}
			};

			var isVisible = function isVisible(elem) {
				if (isBodyHidden == null) {
					isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
				}

				return isBodyHidden || getCSS(elem.parentNode, 'visibility') != 'hidden' && getCSS(elem, 'visibility') != 'hidden';
			};

			var isNestedVisible = function isNestedVisible(elem, elemExpand) {
				var outerRect;
				var parent = elem;
				var visible = isVisible(elem);

				eLtop -= elemExpand;
				eLbottom += elemExpand;
				eLleft -= elemExpand;
				eLright += elemExpand;

				while (visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem) {
					visible = (getCSS(parent, 'opacity') || 1) > 0;

					if (visible && getCSS(parent, 'overflow') != 'visible') {
						outerRect = parent.getBoundingClientRect();
						visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
					}
				}

				return visible;
			};

			var checkElements = function checkElements() {
				var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
				var lazyloadElems = lazysizes.elements;

				if ((loadMode = lazySizesConfig.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {

					i = 0;

					lowRuns++;

					defaultExpand = !lazySizesConfig.expand || lazySizesConfig.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesConfig.expand;

					lazysizes._defEx = defaultExpand;

					preloadExpand = defaultExpand * lazySizesConfig.expFactor;
					hFac = lazySizesConfig.hFac;
					isBodyHidden = null;

					if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden) {
						currentExpand = preloadExpand;
						lowRuns = 0;
					} else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
						currentExpand = defaultExpand;
					} else {
						currentExpand = shrinkExpand;
					}

					for (; i < eLlen; i++) {

						if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
							continue;
						}

						if (!supportScroll) {
							unveilElement(lazyloadElems[i]);continue;
						}

						if (!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)) {
							elemExpand = currentExpand;
						}

						if (beforeExpandVal !== elemExpand) {
							eLvW = innerWidth + elemExpand * hFac;
							elvH = innerHeight + elemExpand;
							elemNegativeExpand = elemExpand * -1;
							beforeExpandVal = elemExpand;
						}

						rect = lazyloadElems[i].getBoundingClientRect();

						if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesConfig.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
							unveilElement(lazyloadElems[i]);
							loadedSomething = true;
							if (isLoading > 9) {
								break;
							}
						} else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesConfig.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesConfig.sizesAttr) != 'auto'))) {
							autoLoadElem = preloadElems[0] || lazyloadElems[i];
						}
					}

					if (autoLoadElem && !loadedSomething) {
						unveilElement(autoLoadElem);
					}
				}
			};

			var throttledCheckElements = throttle(checkElements);

			var switchLoadingClass = function switchLoadingClass(e) {
				var elem = e.target;

				if (elem._lazyCache) {
					delete elem._lazyCache;
					return;
				}

				resetPreloading(e);
				addClass(elem, lazySizesConfig.loadedClass);
				removeClass(elem, lazySizesConfig.loadingClass);
				addRemoveLoadEvents(elem, rafSwitchLoadingClass);
				triggerEvent(elem, 'lazyloaded');
			};
			var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
			var rafSwitchLoadingClass = function rafSwitchLoadingClass(e) {
				rafedSwitchLoadingClass({ target: e.target });
			};

			var changeIframeSrc = function changeIframeSrc(elem, src) {
				try {
					elem.contentWindow.location.replace(src);
				} catch (e) {
					elem.src = src;
				}
			};

			var handleSources = function handleSources(source) {
				var customMedia;

				var sourceSrcset = source[_getAttribute](lazySizesConfig.srcsetAttr);

				if (customMedia = lazySizesConfig.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) {
					source.setAttribute('media', customMedia);
				}

				if (sourceSrcset) {
					source.setAttribute('srcset', sourceSrcset);
				}
			};

			var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg) {
				var src, srcset, parent, isPicture, event, firesLoad;

				if (!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented) {

					if (sizes) {
						if (isAuto) {
							addClass(elem, lazySizesConfig.autosizesClass);
						} else {
							elem.setAttribute('sizes', sizes);
						}
					}

					srcset = elem[_getAttribute](lazySizesConfig.srcsetAttr);
					src = elem[_getAttribute](lazySizesConfig.srcAttr);

					if (isImg) {
						parent = elem.parentNode;
						isPicture = parent && regPicture.test(parent.nodeName || '');
					}

					firesLoad = detail.firesLoad || 'src' in elem && (srcset || src || isPicture);

					event = { target: elem };

					addClass(elem, lazySizesConfig.loadingClass);

					if (firesLoad) {
						clearTimeout(resetPreloadingTimer);
						resetPreloadingTimer = setTimeout(resetPreloading, 2500);
						addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
					}

					if (isPicture) {
						forEach.call(parent.getElementsByTagName('source'), handleSources);
					}

					if (srcset) {
						elem.setAttribute('srcset', srcset);
					} else if (src && !isPicture) {
						if (regIframe.test(elem.nodeName)) {
							changeIframeSrc(elem, src);
						} else {
							elem.src = src;
						}
					}

					if (isImg && (srcset || isPicture)) {
						updatePolyfill(elem, { src: src });
					}
				}

				if (elem._lazyRace) {
					delete elem._lazyRace;
				}
				removeClass(elem, lazySizesConfig.lazyClass);

				rAF(function () {
					// Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
					var isLoaded = elem.complete && elem.naturalWidth > 1;

					if (!firesLoad || isLoaded) {
						if (isLoaded) {
							addClass(elem, 'ls-is-cached');
						}
						switchLoadingClass(event);
						elem._lazyCache = true;
						setTimeout(function () {
							if ('_lazyCache' in elem) {
								delete elem._lazyCache;
							}
						}, 9);
					}
				}, true);
			});

			var unveilElement = function unveilElement(elem) {
				var detail;

				var isImg = regImg.test(elem.nodeName);

				//allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
				var sizes = isImg && (elem[_getAttribute](lazySizesConfig.sizesAttr) || elem[_getAttribute]('sizes'));
				var isAuto = sizes == 'auto';

				if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesConfig.errorClass) && hasClass(elem, lazySizesConfig.lazyClass)) {
					return;
				}

				detail = triggerEvent(elem, 'lazyunveilread').detail;

				if (isAuto) {
					autoSizer.updateElem(elem, true, elem.offsetWidth);
				}

				elem._lazyRace = true;
				isLoading++;

				lazyUnveil(elem, detail, isAuto, sizes, isImg);
			};

			var onload = function onload() {
				if (isCompleted) {
					return;
				}
				if (Date.now() - started < 999) {
					setTimeout(onload, 999);
					return;
				}
				var afterScroll = debounce(function () {
					lazySizesConfig.loadMode = 3;
					throttledCheckElements();
				});

				isCompleted = true;

				lazySizesConfig.loadMode = 3;

				throttledCheckElements();

				addEventListener('scroll', function () {
					if (lazySizesConfig.loadMode == 3) {
						lazySizesConfig.loadMode = 2;
					}
					afterScroll();
				}, true);
			};

			return {
				_: function _() {
					started = Date.now();

					lazysizes.elements = document.getElementsByClassName(lazySizesConfig.lazyClass);
					preloadElems = document.getElementsByClassName(lazySizesConfig.lazyClass + ' ' + lazySizesConfig.preloadClass);

					addEventListener('scroll', throttledCheckElements, true);

					addEventListener('resize', throttledCheckElements, true);

					if (window.MutationObserver) {
						new MutationObserver(throttledCheckElements).observe(docElem, { childList: true, subtree: true, attributes: true });
					} else {
						docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
						docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
						setInterval(throttledCheckElements, 999);
					}

					addEventListener('hashchange', throttledCheckElements, true);

					//, 'fullscreenchange'
					['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend', 'webkitAnimationEnd'].forEach(function (name) {
						document[_addEventListener](name, throttledCheckElements, true);
					});

					if (/d$|^c/.test(document.readyState)) {
						onload();
					} else {
						addEventListener('load', onload);
						document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
						setTimeout(onload, 20000);
					}

					if (lazysizes.elements.length) {
						checkElements();
						rAF._lsFlush();
					} else {
						throttledCheckElements();
					}
				},
				checkElems: throttledCheckElements,
				unveil: unveilElement
			};
		}();

		var autoSizer = function () {
			var autosizesElems;

			var sizeElement = rAFIt(function (elem, parent, event, width) {
				var sources, i, len;
				elem._lazysizesWidth = width;
				width += 'px';

				elem.setAttribute('sizes', width);

				if (regPicture.test(parent.nodeName || '')) {
					sources = parent.getElementsByTagName('source');
					for (i = 0, len = sources.length; i < len; i++) {
						sources[i].setAttribute('sizes', width);
					}
				}

				if (!event.detail.dataAttr) {
					updatePolyfill(elem, event.detail);
				}
			});
			var getSizeElement = function getSizeElement(elem, dataAttr, width) {
				var event;
				var parent = elem.parentNode;

				if (parent) {
					width = getWidth(elem, parent, width);
					event = triggerEvent(elem, 'lazybeforesizes', { width: width, dataAttr: !!dataAttr });

					if (!event.defaultPrevented) {
						width = event.detail.width;

						if (width && width !== elem._lazysizesWidth) {
							sizeElement(elem, parent, event, width);
						}
					}
				}
			};

			var updateElementsSizes = function updateElementsSizes() {
				var i;
				var len = autosizesElems.length;
				if (len) {
					i = 0;

					for (; i < len; i++) {
						getSizeElement(autosizesElems[i]);
					}
				}
			};

			var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

			return {
				_: function _() {
					autosizesElems = document.getElementsByClassName(lazySizesConfig.autosizesClass);
					addEventListener('resize', debouncedUpdateElementsSizes);
				},
				checkElems: debouncedUpdateElementsSizes,
				updateElem: getSizeElement
			};
		}();

		var init = function init() {
			if (!init.i) {
				init.i = true;
				autoSizer._();
				loader._();
			}
		};

		lazysizes = {
			cfg: lazySizesConfig,
			autoSizer: autoSizer,
			loader: loader,
			init: init,
			uP: updatePolyfill,
			aC: addClass,
			rC: removeClass,
			hC: hasClass,
			fire: triggerEvent,
			gW: getWidth,
			rAF: rAF
		};

		return lazysizes;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(98)(module)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var isObject = __webpack_require__(122),
	    now = __webpack_require__(123),
	    toNumber = __webpack_require__(126);

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;

	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;

	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }

	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;

	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }

	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }

	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;

	    return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
	  }

	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;

	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
	  }

	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }

	  function trailingEdge(time) {
	    timerId = undefined;

	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }

	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }

	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }

	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);

	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;

	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}

	module.exports = debounce;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  return value != null && (type == 'object' || type == 'function');
	}

	module.exports = isObject;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var root = __webpack_require__(124);

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function now() {
	  return root.Date.now();
	};

	module.exports = now;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var freeGlobal = __webpack_require__(125);

	/** Detect free variable `self`. */
	var freeSelf = (typeof self === 'undefined' ? 'undefined' : _typeof(self)) == 'object' && self && self.Object === Object && self;

	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();

	module.exports = root;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/** Detect free variable `global` from Node.js. */
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global && global.Object === Object && global;

	module.exports = freeGlobal;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var baseTrim = __webpack_require__(127),
	    isObject = __webpack_require__(122),
	    isSymbol = __webpack_require__(129);

	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;

	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;

	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;

	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;

	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? other + '' : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}

	module.exports = toNumber;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var trimmedEndIndex = __webpack_require__(128);

	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;

	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
	}

	module.exports = baseTrim;

/***/ }),
/* 128 */
/***/ (function(module, exports) {

	"use strict";

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;

	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;

	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}

	module.exports = trimmedEndIndex;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var baseGetTag = __webpack_require__(130),
	    isObjectLike = __webpack_require__(134);

	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';

	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
	}

	module.exports = isSymbol;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Symbol = __webpack_require__(131),
	    getRawTag = __webpack_require__(132),
	    objectToString = __webpack_require__(133);

	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';

	/** Built-in value references. */
	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	    if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	    }
	    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
	}

	module.exports = baseGetTag;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var root = __webpack_require__(124);

	/** Built-in value references. */
	var _Symbol = root.Symbol;

	module.exports = _Symbol;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _Symbol = __webpack_require__(131);

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/** Built-in value references. */
	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}

	module.exports = getRawTag;

/***/ }),
/* 133 */
/***/ (function(module, exports) {

	"use strict";

	/** Used for built-in method references. */
	var objectProto = Object.prototype;

	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;

	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}

	module.exports = objectToString;

/***/ }),
/* 134 */
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) == 'object';
	}

	module.exports = isObjectLike;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var focusHelper = __webpack_require__(113);

	/**
	 * Parses the html for a modal window
	 * @param {string} html - representing the body and footer of the modal window
	 *
	 * @return {Object} - Object with properties body and footer.
	 */
	function parseHtml(html) {
	    var $html = $('<div>').append($.parseHTML(html));

	    var body = $html.find('.choice-of-bonus-product');
	    var footer = $html.find('.modal-footer').children();

	    return {
	        body: body,
	        footer: footer
	    };
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @param {Object} data - data object used to fill in dynamic portions of the html
	 */
	function chooseBonusProducts(data) {
	    $('.modal-body').spinner().start();

	    if ($('#chooseBonusProductModal').length !== 0) {
	        $('#chooseBonusProductModal').remove();
	    }
	    var bonusUrl;
	    if (data.bonusChoiceRuleBased) {
	        bonusUrl = data.showProductsUrlRuleBased;
	    } else {
	        bonusUrl = data.showProductsUrlListBased;
	    }

	    var htmlString = '<!-- Modal -->' + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">' + '<span class="enter-message sr-only" ></span>' + '<div class="modal-dialog choose-bonus-product-dialog" ' + 'data-total-qty="' + data.maxBonusItems + '"' + 'data-UUID="' + data.uuid + '"' + 'data-pliUUID="' + data.pliUUID + '"' + 'data-addToCartUrl="' + data.addToCartUrl + '"' + 'data-pageStart="0"' + 'data-pageSize="' + data.pageSize + '"' + 'data-moreURL="' + data.showProductsUrlRuleBased + '"' + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">' + '<!-- Modal content-->' + '<div class="modal-content">' + '<div class="modal-header">' + '    <span class="">' + data.labels.selectprods + '</span>' + '    <button type="button" class="close pull-right" data-dismiss="modal">' + '        <span aria-hidden="true">&times;</span>' + '        <span class="sr-only"> </span>' + '    </button>' + '</div>' + '<div class="modal-body"></div>' + '<div class="modal-footer"></div>' + '</div>' + '</div>' + '</div>';
	    $('body').append(htmlString);
	    $('.modal-body').spinner().start();

	    $.ajax({
	        url: bonusUrl,
	        method: 'GET',
	        dataType: 'json',
	        success: function success(response) {
	            var parsedHtml = parseHtml(response.renderedTemplate);
	            $('#chooseBonusProductModal .modal-body').empty();
	            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
	            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
	            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
	            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
	            $('#chooseBonusProductModal').modal('show');
	            $.spinner().stop();
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	}

	module.exports = {

	    methods: {
	        editBonusProducts: function editBonusProducts(data) {
	            chooseBonusProducts(data);
	        }
	    },

	    chooseBonusProducts: chooseBonusProducts,

	    focusChooseBonusProductModal: function focusChooseBonusProductModal() {
	        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'true');
	            $('#chooseBonusProductModal .close').focus();
	        });
	    },

	    onClosingChooseBonusProductModal: function onClosingChooseBonusProductModal() {
	        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
	            $('#chooseBonusProductModal').siblings().attr('aria-hidden', 'false');
	        });
	    },

	    trapChooseBonusProductModalFocus: function trapChooseBonusProductModalFocus() {
	        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
	            var focusParams = {
	                event: e,
	                containerSelector: '#chooseBonusProductModal',
	                firstElementSelector: '.close',
	                lastElementSelector: '.add-bonus-products'
	            };
	            focusHelper.setTabNextFocus(focusParams);
	        });
	    },

	    selectBonusProduct: function selectBonusProduct() {
	        $(document).on('click', '.select-bonus-product', function () {
	            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
	            var pid = $(this).data('pid');
	            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
	            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
	            var totalQty = 0;
	            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
	                totalQty += $(this).data('qty');
	            });
	            totalQty += submittedQty;
	            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
	            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
	            if (totalQty <= maxPids) {
	                var selectedBonusProductHtml = '' + '<div class="selected-pid row" ' + 'data-pid="' + pid + '"' + 'data-qty="' + submittedQty + '"' + 'data-optionID="' + (optionID || '') + '"' + 'data-option-selected-value="' + (valueId || '') + '"' + '>' + '<div class="col-sm-11 col-9 bonus-product-name" >' + $choiceOfBonusProduct.find('.product-name').html() + '</div>' + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>' + '</div>';
	                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
	                $('.pre-cart-products').html(totalQty);
	                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	            } else {
	                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
	            }
	        });
	    },
	    removeBonusProduct: function removeBonusProduct() {
	        $(document).on('click', '.selected-pid', function () {
	            $(this).remove();
	            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
	            var count = 0;
	            if ($selected.length) {
	                $selected.each(function () {
	                    count += parseInt($(this).data('qty'), 10);
	                });
	            }

	            $('.pre-cart-products').html(count);
	            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
	        });
	    },
	    enableBonusProductSelection: function enableBonusProductSelection() {
	        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
	            $('button.select-bonus-product', response.$productContainer).attr('disabled', !response.product.readyToOrder || !response.product.available);
	            var pid = response.product.id;
	            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
	        });
	    },
	    showMoreBonusProducts: function showMoreBonusProducts() {
	        $(document).on('click', '.show-more-bonus-products', function () {
	            var url = $(this).data('url');
	            $('.modal-content').spinner().start();
	            $.ajax({
	                url: url,
	                method: 'GET',
	                success: function success(html) {
	                    var parsedHtml = parseHtml(html);
	                    $('.modal-body').append(parsedHtml.body);
	                    $('.show-more-bonus-products:first').remove();
	                    $('.modal-content').spinner().stop();
	                },
	                error: function error() {
	                    $('.modal-content').spinner().stop();
	                }
	            });
	        });
	    },
	    addBonusProductsToCart: function addBonusProductsToCart() {
	        $(document).on('click', '.add-bonus-products', function () {
	            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
	            var queryString = '?pids=';
	            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
	            var pidsObject = {
	                bonusProducts: []
	            };

	            $.each($readyToOrderBonusProducts, function () {
	                var qtyOption = parseInt($(this).data('qty'), 10);

	                var option = null;
	                if (qtyOption > 0) {
	                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
	                        option = {};
	                        option.optionId = $(this).data('optionid');
	                        option.productId = $(this).data('pid');
	                        option.selectedValueId = $(this).data('option-selected-value');
	                    }
	                    pidsObject.bonusProducts.push({
	                        pid: $(this).data('pid'),
	                        qty: qtyOption,
	                        options: [option]
	                    });
	                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
	                }
	            });
	            queryString += JSON.stringify(pidsObject);
	            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
	            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
	            $.spinner().start();
	            $.ajax({
	                url: url + queryString,
	                method: 'POST',
	                success: function success(data) {
	                    $.spinner().stop();
	                    if (data.error) {
	                        $('#chooseBonusProductModal').modal('hide');
	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.add-to-cart-messages').append('<div class="alert alert-danger add-to-basket-alert text-center"' + ' role="alert">' + data.errorMessage + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                        }, 3000);
	                    } else {
	                        $('.configure-bonus-product-attributes').html(data);
	                        $('.bonus-products-step2').removeClass('hidden-xl-down');
	                        $('#chooseBonusProductModal').modal('hide');

	                        if ($('.add-to-cart-messages').length === 0) {
	                            $('body').append('<div class="add-to-cart-messages"></div>');
	                        }
	                        $('.minicart-quantity').html(data.totalQty);
	                        $('.add-to-cart-messages').append('<div class="alert alert-success add-to-basket-alert text-center"' + ' role="alert">' + data.msgSuccess + '</div>');
	                        setTimeout(function () {
	                            $('.add-to-basket-alert').remove();
	                            if ($('.cart-page').length) {
	                                location.reload();
	                            }
	                        }, 1500);
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        });
	    }
	};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	    var sizes = ['xs', 'sm', 'md', 'lg', 'xl'];

	    sizes.forEach(function (size) {
	        var selector = '.collapsible-' + size + ' .title';
	        $('body').on('click', selector, function (e) {
	            e.preventDefault();
	            $(this).parents('.collapsible-' + size).toggleClass('active');

	            if ($(this).parents('.collapsible-' + size).hasClass('active')) {
	                $(this).attr('aria-expanded', true);
	            } else {
	                $(this).attr('aria-expanded', false);
	            }
	        });
	    });
	};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _exportSearchFunction = __webpack_require__(138);

	var debounce = __webpack_require__(121);
	var endpoint = $('.suggestions-wrapper').data('url');
	var minChars = 1;
	var UP_KEY = 38;
	var DOWN_KEY = 40;
	var TAB_KEY = 9;
	var DIRECTION_DOWN = 1;
	var DIRECTION_UP = -1;
	var IS_SEARCHING = false;

	/**
	 * Retrieves Suggestions element relative to scope
	 *
	 * @param {Object} scope - Search input field DOM element
	 * @return {JQuery} - .suggestions-wrapper element
	 */
	function getSuggestionsWrapper(scope) {
	    return $(scope).closest('.cc-input-wrp').siblings('.suggestions-wrapper');
	}

	/**
	 * Determines whether DOM element is inside the .search-mobile class
	 *
	 * @param {Object} scope - DOM element, usually the input.search-field element
	 * @return {boolean} - Whether DOM element is inside  div.search-mobile
	 */
	function isMobileSearch(scope) {
	    return !!$(scope).closest('.search-mobile').length;
	}

	/**
	 * Remove modal classes needed for mobile suggestions
	 *
	 */
	function clearModals() {}

	/**
	 * Apply modal classes needed for mobile suggestions
	 *
	 * @param {Object} scope - Search input field DOM element
	 */
	function applyModals(scope) {
	    if (isMobileSearch(scope)) {
	        $('body').addClass('modal-open');
	        $('header').siblings().attr('aria-hidden', 'true');
	        getSuggestionsWrapper(scope).find('.suggestions').addClass('modal');
	    }
	}

	/**
	 * Tear down Suggestions panel
	 */
	function tearDownSuggestions() {
	    $('input.search-field').val('');
	    clearModals();
	    $('.search-mobile .suggestions').unbind('scroll');
	    $('.suggestions-wrapper').empty();
	}

	/**
	 * Toggle search field icon from search to close and vice-versa
	 *
	 * @param {string} action - Action to toggle to
	 */
	function toggleSuggestionsIcon(action) {
	    var mobileSearchIcon = '.search-mobile button.';
	    var iconSearch = 'fa-search';
	    var iconSearchClose = 'fa-close';

	    if (action === 'close') {
	        $(mobileSearchIcon + iconSearch).removeClass(iconSearch).addClass(iconSearchClose).attr('type', 'button');
	    } else {
	        $(mobileSearchIcon + iconSearchClose).removeClass(iconSearchClose).addClass(iconSearch).attr('type', 'submit');
	    }
	}

	/**
	 * Determines whether the "More Content Below" icon should be displayed
	 *
	 * @param {Object} scope - DOM element, usually the input.search-field element
	 */
	function handleMoreContentBelowIcon(scope) {
	    if ($(scope).scrollTop() + $(scope).innerHeight() >= $(scope)[0].scrollHeight) {
	        $('.more-below').fadeOut();
	    } else {
	        $('.more-below').fadeIn();
	    }
	}

	/**
	 * Positions Suggestions panel on page
	 *
	 * @param {Object} scope - DOM element, usually the input.search-field element
	 */
	function positionSuggestions(scope) {
	    var outerHeight;
	    var $scope;
	    var $suggestions;
	    var top;

	    if (isMobileSearch(scope)) {
	        $scope = $(scope);
	        top = $scope.offset().top;
	        outerHeight = $scope.outerHeight();
	        $suggestions = getSuggestionsWrapper(scope).find('.suggestions');
	        $suggestions.css('top', top + outerHeight);

	        handleMoreContentBelowIcon(scope);

	        // Unfortunately, we have to bind this dynamically, as the live scroll event was not
	        // properly detecting dynamic suggestions element's scroll event
	        $suggestions.scroll(function () {
	            handleMoreContentBelowIcon(this);
	        });
	    }
	}

	/**
	 * Process Ajax response for SearchServices-GetSuggestions
	 *
	 * @param {Object|string} response - Empty object literal if null response or string with rendered
	 *                                   suggestions template contents
	 */
	function processResponse(response) {
	    IS_SEARCHING = false;
	    var $suggestionsWrapper = getSuggestionsWrapper(this);
	    $.spinner().stop();

	    if (!((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object')) {
	        $suggestionsWrapper.empty().append(response).show();
	        $(this).siblings('.reset-button').addClass('d-sm-block');
	        positionSuggestions(this);

	        toggleSuggestionsIcon('close');
	        applyModals(this);

	        // Trigger screen reader by setting aria-describedby with the new suggestion message.
	        var suggestionsList = $('.suggestions .item');
	        if ($(suggestionsList).length) {
	            $('input.search-field').attr('aria-describedby', 'search-result-count');
	        } else {
	            $('input.search-field').removeAttr('aria-describedby');
	        }
	    } else {
	        $suggestionsWrapper.hide();
	    }

	    //register the impressions of the new products loaded
	    var searchTerm = $('input.js-bar-search-input').val();
	    $('body').trigger('analytics:searchProductLoaded', searchTerm);
	}

	/**
	 * Retrieve suggestions
	 *
	 * @param {Object} scope - Search field DOM element
	 */
	function getSuggestions(scope) {
	    if ($(scope).val().length >= minChars || $(scope).val().length === 0) {
	        if (!IS_SEARCHING && $(scope).val().length > 0) {
	            $.spinner().start();
	        }
	        IS_SEARCHING = true;
	        $.ajax({
	            context: scope,
	            url: endpoint + encodeURIComponent($(scope).val()),
	            method: 'GET',
	            success: processResponse,
	            error: function error() {
	                IS_SEARCHING = false;
	                $.spinner().stop();
	            }
	        });
	    } else {
	        $('.suggestions .suggestions-quick-links-no-results').removeClass('d-none');
	        $('.suggestions .suggestions-no-results').removeClass('d-none');
	        $('.suggestions .cc-col-suggestions').addClass('d-none');
	        $('.suggestions .cc-col-no-products').addClass('d-none');
	        $('.suggestions #search-results').addClass('d-none');
	        if ($(scope).val().length === 0) {
	            $('.suggestions .suggestions-no-products-found').addClass('d-none');
	        }
	    }
	}

	/**
	 * Handle Tab Navigation from suggestions to close button
	 *
	 * @param {Event} event - The keydown event
	 */
	function handleSuggestionTabNavigation(event) {
	    var suggestionsWrapper = $('#suggestions-wrapper');
	    if (suggestionsWrapper.hasClass('d-none')) {
	        return; // Don't handle tab if suggestions are not visible
	    }

	    // Check if we're currently inside the suggestions wrapper
	    var currentElement = $(document.activeElement);
	    var isInsideSuggestions = currentElement.closest('#suggestions-wrapper').length > 0;

	    if (isInsideSuggestions && !event.shiftKey) {
	        // Find all focusable elements within suggestions wrapper
	        var focusableElements = suggestionsWrapper.find('a[href], button:not([disabled])').filter(':visible');
	        var currentIndex = focusableElements.index(currentElement);

	        // If we're on the last focusable element in suggestions wrapper, tab to close button
	        if (currentIndex === focusableElements.length - 1) {
	            event.preventDefault();
	            var closeButton = $('.js-closeSearch');
	            if (closeButton.length) {
	                closeButton.focus();
	            }
	        }
	    }
	}

	/**
	 * Handle Search Suggestion Keyboard Arrow Keys
	 *
	 * @param {Integer} direction takes positive or negative number constant, DIRECTION_UP (-1) or DIRECTION_DOWN (+1)
	 */
	function handleArrow(direction) {
	    // get all li elements in the suggestions list
	    var suggestionsList = $('.suggestions .item');
	    if (suggestionsList.filter('.selected').length === 0) {
	        suggestionsList.first().addClass('selected');
	        $('input.search-field').each(function () {
	            $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
	        });
	    } else {
	        suggestionsList.each(function (index) {
	            var idx = index + direction;
	            if ($(this).hasClass('selected')) {
	                $(this).removeClass('selected');
	                $(this).removeAttr('aria-selected');
	                if (suggestionsList.eq(idx).length !== 0) {
	                    suggestionsList.eq(idx).addClass('selected');
	                    suggestionsList.eq(idx).attr('aria-selected', true);
	                    $(this).removeProp('aria-selected');
	                    $('input.search-field').each(function () {
	                        $(this).attr('aria-activedescendant', suggestionsList.eq(idx)[0].id);
	                    });
	                } else {
	                    suggestionsList.first().addClass('selected');
	                    suggestionsList.first().attr('aria-selected', true);
	                    $('input.search-field').each(function () {
	                        $(this).attr('aria-activedescendant', suggestionsList.first()[0].id);
	                    });
	                }
	                return false;
	            }
	            return true;
	        });
	    }
	}

	module.exports = function () {
	    $('form[name="simpleSearch"]').submit(function (e) {
	        var suggestionsList = $('.suggestions .item');
	        if (suggestionsList.filter('.selected').length !== 0) {
	            suggestionsList.filter('.selected').find('a')[0].click();
	            e.preventDefault();
	        }
	    });

	    var searchTerm = $(this).find('.search-field').val();
	    if (searchTerm && searchTerm.length) {
	        $('body').trigger('analytics:searchProduct', searchTerm);
	    }

	    /**
	     * Use debounce to avoid making an Ajax call on every single key press by waiting a few
	     * hundred milliseconds before making the request. Without debounce, the user sees the
	     * browser blink with every key press.
	     */
	    var debounceSuggestions = debounce(getSuggestions, 300);
	    $('#search-input-top-bar').on('keyup focus', function (e) {
	        // Capture Down/Up Arrow Key Events
	        switch (e.which) {
	            case DOWN_KEY:
	                handleArrow(DIRECTION_DOWN);
	                e.preventDefault(); // prevent moving the cursor
	                break;
	            case UP_KEY:
	                handleArrow(DIRECTION_UP);
	                e.preventDefault(); // prevent moving the cursor
	                break;
	            default:
	                debounceSuggestions(this, e);
	        }
	    });
	    $('#search-input-top-bar').on('focus', function (e) {
	        $('#suggestions-wrapper').removeClass('d-none');
	    });

	    // Handle Tab navigation from suggestions to close button
	    $(document).on('keydown', function (e) {
	        if (e.which === TAB_KEY) {
	            handleSuggestionTabNavigation(e);
	        }
	    });

	    // Mobile version
	    $('.cc-content-search-mobile #search-input-top-bar-mobile').on('keyup', function (e) {
	        // Capture Down/Up Arrow Key Events
	        switch (e.which) {
	            case DOWN_KEY:
	                handleArrow(DIRECTION_DOWN);
	                e.preventDefault(); // prevent moving the cursor
	                break;
	            case UP_KEY:
	                handleArrow(DIRECTION_UP);
	                e.preventDefault(); // prevent moving the cursor
	                break;
	            default:
	                debounceSuggestions(this, e);
	        }
	    });
	    // Mobile version
	    $('.cc-content-search-mobile #search-input-top-bar-mobile').on('focus', function () {
	        if (!(0, _exportSearchFunction.isOpenSearchBarMobile)()) {
	            (0, _exportSearchFunction.toggleSearchBarMobile)();
	        }
	    });

	    $('body').on('click touchend', '.search-mobile button.fa-close', function (e) {
	        e.preventDefault();
	        $('.suggestions').hide();
	        toggleSuggestionsIcon('search');
	        tearDownSuggestions();
	    });

	    $('body').on('click', '.js-resetSearch', function (e) {
	        e.preventDefault();
	        $('input.search-field').val('');
	        $('.cc-content-search-mobile #search-input-top-bar-mobile').trigger('keyup');
	        // Return focus to the search input for accessibility
	        $('input.search-field').focus();
	    });

	    $('.site-search .reset-button').on('click', function () {
	        $(this).removeClass('d-sm-block');
	    });
	};

/***/ }),
/* 138 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	function isOpenSearchBarMobile() {
	    return $('.js-searchBarMobile').hasClass('cc-open') ? true : false;
	}

	function toggleSearchBarMobile() {
	    var header = $('.js-header');
	    var searchBarMobile = header.find('.js-searchBarMobile');
	    var isDesktop = window.innerWidth >= 1200;

	    searchBarMobile.toggleClass('cc-open');
	    if (searchBarMobile.hasClass('cc-open')) {
	        if (isDesktop) {
	            $('.js-searchBarMobile').removeAttr('inert');
	        }
	        header.addClass('suggestionIsOpen');
	        $('html').addClass('cc-no-scroll');
	        setTimeout(function () {
	            $('.js-searchInput').trigger('focus');
	        }, 600);
	    } else {
	        header.removeClass('suggestionIsOpen');
	        $('html').removeClass('cc-no-scroll');
	        if (isDesktop) {
	            $('.js-searchBarMobile').attr('inert', '');
	        }
	        $('.js-headerSearchButton').trigger('focus');
	    }
	}

	$(document).on('click', '.cc-content-search-mobile', function (e) {
	    if ($(e.target).prop('class') === 'cc-content-search-mobile js-searchBarMobile cc-open') {
	        $('.js-closeSearch').trigger('click');
	    }
	});

	$(document).keydown(function (event) {
	    if (event.keyCode === 27 && $('.js-searchBarMobile').hasClass('cc-open')) {
	        $('.js-closeSearch').trigger('click');
	    }
	});

	exports.toggleSearchBarMobile = toggleSearchBarMobile;
	exports.isOpenSearchBarMobile = isOpenSearchBarMobile;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var keyboardAccessibility = __webpack_require__(111);

	// In splash page we have to set up the kookie in case of automatic redirect enabled
	$('body').on('click', 'a.js-country-link:not(.external-site)', function (e) {
	    e.preventDefault();
	    var $country = $(this);
	    var localeCode = $country.data('locale');
	    $('body').trigger('countrySelector:countrySelected', { targetLocale: localeCode });
	    window.location.href = $country.attr('href');
	});

	module.exports = function () {
	    // landing page
	    $('.cc-country-selector .selectpicker').on('changed.bs.select', function () {
	        var $btn = $('.cc-country-selector .cc-btn'),
	            $selected = $('option:selected', this),
	            localeUrl = $selected.data('url'),
	            isExternal = $selected.hasClass('external-site');

	        if (isExternal) {
	            $btn.addClass('external-site');
	            $btn.attr('href', localeUrl);
	        } else {
	            $btn.removeClass('external-site');
	            $btn.attr('href', '');
	        }
	    });

	    // open the modal - if present
	    $('body').on('click', '.country-selector-icon', function () {
	        if ($(this).hasClass('cc-header-mobileMenu-body-link')) {
	            $('.js-close-button').click();
	        }
	        $('#countrySelectorModal').modal('show');
	    });

	    // select a new language

	    $('body').on('click', '.js-country-select:not(.external-site), .js-country-selector .cc-btn:not(.external-site)', function (e) {
	        e.preventDefault();
	        var self = $(this).hasClass('cc-btn') ? $('.js-country-selector option:selected') : $(this);
	        if (self.parent().hasClass('js-selected-language')) {
	            $('#countrySelectorModal').modal('hide');
	        } else {
	            $.spinner().start();
	            var action = $('.page').data('action');
	            if (action.split('-').length !== 2 || self.closest('.js-country-selector').length) {
	                // to exclude cases in which 'action' carries something different than 'Controller-Method' (as for the home page, in which the action is 'Sites-bata-xx-Site')
	                action = 'Home-Show';
	            }
	            var localeCode = self.data('locale'),
	                localeCurrencyCode = self.data('currencycode'),
	                queryString = $('.page').data('querystring'),
	                url = $('.country-selector, .js-georedirect-container').data('url'),
	                siteId = self.data('site-id');
	            $('body').trigger('countrySelector:countrySelected', { targetLocale: localeCode });

	            $.ajax({
	                url: url,
	                type: 'get',
	                dataType: 'json',
	                data: {
	                    code: localeCode,
	                    queryString: queryString,
	                    CurrencyCode: localeCurrencyCode,
	                    action: action,
	                    siteId: siteId
	                },
	                success: function success(response) {
	                    $.spinner().stop();
	                    if (response && response.redirectUrl) {
	                        window.location.href = response.redirectUrl;
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        }
	    });

	    keyboardAccessibility('.navbar-header .country-selector', {
	        40: function _($countryOptions) {
	            // down
	            if ($(this).is(':focus')) {
	                $countryOptions.first().focus();
	            } else {
	                $(':focus').next().focus();
	            }
	        },
	        38: function _($countryOptions) {
	            // up
	            if ($countryOptions.first().is(':focus') || $(this).is(':focus')) {
	                $(this).focus();
	                $(this).removeClass('show');
	            } else {
	                $(':focus').prev().focus();
	            }
	        },
	        27: function _() {
	            // escape
	            $(this).focus();
	            $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
	        },
	        9: function _() {
	            // tab
	            $(this).removeClass('show').children('.dropdown-menu').removeClass('show');
	        }
	    }, function () {
	        if (!$(this).hasClass('show')) {
	            $(this).addClass('show');
	        }
	        return $(this).find('.dropdown-country-selector').children('a');
	    });

	    $('.navbar-header .country-selector').on('focusin', function () {
	        $(this).addClass('show').children('.dropdown-menu').addClass('show');
	    });

	    if ($('.js-locale-remove-space').length) {
	        $('.js-locale-remove-space').each(function () {
	            $(this).text($(this).text().replace(/[ \n\r]/g, ''));
	        });
	    }

	    // Redesign
	    // Cache DOM elements
	    var $continentSelect = $('.cc-cs-continent-select:not(.cc-cs-continent-select--brands)');
	    var $countrySelectContainer = $('.cc-cs-country-select-container:not(.cc-cs-country-select-container--brands)');
	    var $countrySelect = $('.cc-cs-country-select:not(.cc-cs-country-select--brands)');
	    var $localeSelectContainer = $('.cc-cs-locale-select-container:not(.cc-cs-locale-select-container--brands)');
	    var $localeSelect = $('.cc-cs-locale-select:not(.cc-cs-locale-select--brands)');
	    var $buttonContainer = $('.cc-cs-button-container:not(.cc-cs-button-container--brands)');
	    var $goButton = $('.cc-cs-go-button:not(.cc-cs-go-button--brands)');

	    // Cache the default option texts
	    var countryPlaceholder = $('.cc-cs-country-select option:first-child').text();
	    var localePlaceholder = $('.cc-cs-locale-select option:first-child').text();

	    // Store the current selection
	    var currentSelection = {
	        continent: '',
	        country: '',
	        countryCode: '',
	        locale: '',
	        url: '',
	        isRedirect: false
	    };

	    // Handle continent selection
	    $continentSelect.on('changed.bs.select', function () {
	        var selectedContinent = $(this).val();
	        currentSelection.continent = selectedContinent;

	        // Clear subsequent selections
	        currentSelection.country = '';
	        currentSelection.countryCode = '';
	        currentSelection.locale = '';
	        currentSelection.url = '';

	        // Reset and hide country-dependent elements
	        $countrySelect.empty().append('<option value="">' + countryPlaceholder + '</option>');
	        $countrySelect.selectpicker('refresh');

	        $localeSelect.empty().append('<option value="">' + localePlaceholder + '</option>');
	        $localeSelect.selectpicker('refresh');

	        $localeSelectContainer.addClass('h-hidden');
	        $goButton.prop('disabled', true);

	        if (selectedContinent) {
	            // Populate the country select
	            var $countryData = $('.cc-cs-continent-data[data-continent="' + selectedContinent + '"] .cc-cs-country-data');

	            $countryData.each(function () {
	                var countryCode = $(this).data('country-code');
	                var countryName = $(this).data('country-name');
	                var iconClass = $(this).data('icon-class');

	                // Creating option with data attributes for Bootstrap Selectpicker
	                var $option = $('<option>', {
	                    value: countryCode,
	                    text: countryName,
	                    'data-content': '<span class="' + iconClass + '"></span> ' + countryName
	                });

	                $countrySelect.append($option);
	            });

	            // Update the selectpicker
	            $countrySelect.selectpicker('refresh');

	            // Show the country select
	            $countrySelectContainer.removeClass('h-hidden');
	        } else {
	            $countrySelectContainer.addClass('h-hidden');
	            $buttonContainer.addClass('h-hidden');
	        }
	    });

	    // Handle country selection
	    $countrySelect.on('changed.bs.select', function () {
	        var selectedCountryCode = $(this).val();
	        currentSelection.countryCode = selectedCountryCode;

	        // Clear locale selection
	        currentSelection.locale = '';
	        $localeSelect.empty().append('<option value="">' + localePlaceholder + '</option>');
	        $localeSelect.selectpicker('refresh');

	        if (selectedCountryCode) {
	            // Find the country data
	            var $selectedCountry = $('.cc-cs-country-data[data-country-code="' + selectedCountryCode + '"]');

	            // Set current selection data
	            currentSelection.country = selectedCountryCode;
	            currentSelection.isRedirect = $selectedCountry.data('is-redirect') === 'true';

	            // Check if country has multiple locales
	            var $locales = $selectedCountry.find('.cc-cs-locale-data');

	            if ($locales.length > 0) {
	                // Populate locale select
	                $locales.each(function () {
	                    var locale = $(this).data('locale');
	                    var localeName = $(this).data('locale-name');

	                    $localeSelect.append('<option value="' + locale + '">' + localeName + '</option>');
	                });

	                // Update the selectpicker
	                $localeSelect.selectpicker('refresh');

	                // Show locale select, hide button until a locale is selected
	                $localeSelectContainer.removeClass('h-hidden');
	                $buttonContainer.removeClass('h-hidden');
	                $goButton.prop('disabled', true);
	            } else {
	                // No locales, use default locale
	                currentSelection.locale = $selectedCountry.data('default-locale');
	                currentSelection.url = $selectedCountry.data('default-url');

	                // Hide locale select, show and enable button
	                $localeSelectContainer.addClass('h-hidden');
	                $buttonContainer.removeClass('h-hidden');
	                $goButton.prop('disabled', false);
	            }
	        } else {
	            // No country selected
	            $localeSelectContainer.addClass('h-hidden');
	            $buttonContainer.addClass('h-hidden');
	        }
	    });

	    // Handle locale selection
	    $localeSelect.on('changed.bs.select', function () {
	        var selectedLocale = $(this).val();

	        if (selectedLocale) {
	            var $selectedCountry = $('.cc-cs-country-data[data-country-code="' + currentSelection.countryCode + '"]');
	            var $selectedLocale = $selectedCountry.find('.cc-cs-locale-data[data-locale="' + selectedLocale + '"]');

	            // Set current selection data
	            currentSelection.locale = selectedLocale;
	            currentSelection.url = $selectedLocale.data('locale-url');

	            // Show and enable button
	            $buttonContainer.removeClass('h-hidden');
	            $goButton.prop('disabled', false);
	        } else {
	            // No locale selected
	            $buttonContainer.removeClass('h-hidden');
	            $goButton.prop('disabled', true);
	        }
	    });

	    // Handle button click
	    $goButton.on('click', function () {
	        if (!$(this).prop('disabled')) {
	            var localeCode = currentSelection.locale;

	            // Trigger the same event as in the original code
	            $('body').trigger('countrySelector:countrySelected', { targetLocale: localeCode });

	            // Redirect to the selected URL
	            window.location.href = currentSelection.url;
	        }
	    });

	    // Pre-select current continent/country if available
	    function initializeSelectors() {

	        // Initialize all selectpickers first
	        $('.selectpicker').selectpicker();

	        // First find the user's country
	        var $userCountry = $('.cc-cs-country-data[data-is-customer-country="true"]');

	        if ($userCountry.length > 0) {
	            // Get the continent of the user's country
	            var userContinent = $userCountry.closest('.cc-cs-continent-data').data('continent');
	            var userCountryCode = $userCountry.data('country-code');

	            // Select the continent first (this will populate countries)
	            if (userContinent) {
	                // Function to update select element and return a promise
	                var updateSelect = function updateSelect(select, value) {
	                    return new Promise(function (resolve) {
	                        select.val(value);
	                        select.selectpicker('refresh');
	                        select.trigger('changed.bs.select');

	                        // Add event listener for completion of the change
	                        select.one('loaded.bs.select', function () {
	                            resolve();
	                        });

	                        // Fallback in case the event is not triggered
	                        setTimeout(resolve, 100);
	                    });
	                };

	                // First update the continent
	                updateSelect($continentSelect, userContinent).then(function () {
	                    // Then update the country
	                    return updateSelect($countrySelect, userCountryCode);
	                }).then(function () {
	                    // Finally update the locale if available
	                    var defaultLocale = $userCountry.data('default-locale');
	                    if (defaultLocale && !$localeSelectContainer.hasClass('h-hidden')) {
	                        return updateSelect($localeSelect, defaultLocale);
	                    }
	                }).catch(function (error) {
	                    console.error('Error updating selection:', error);
	                });
	            }
	        } else {
	            // Fallback to the existing logic if no user country is found
	            if ($continentSelect.find('option:selected').val()) {
	                $continentSelect.trigger('changed.bs.select');
	            }
	        }
	    }

	    // Initialize on page load
	    initializeSelectors();
	};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var keyboardAccessibility = __webpack_require__(111);

	module.exports = function () {
	    // Redesign
	    // Cache DOM elements
	    var $continentSelect = $('.cc-gc-continent-select');
	    var $countrySelectContainer = $('.cc-gc-country-select-container');
	    var $countrySelect = $('.cc-gc-country-select');

	    // Cache the default option texts
	    var countryPlaceholder = $('.cc-gc-country-select option:first-child').text();

	    // Store the current selection
	    var currentSelection = {
	        continent: '',
	        country: '',
	        countryCode: ''
	    };

	    // Handle continent selection
	    $continentSelect.on('changed.bs.select', function () {
	        var selectedContinent = $(this).val();
	        currentSelection.continent = selectedContinent;

	        // Clear subsequent selections
	        currentSelection.country = '';
	        currentSelection.countryCode = '';

	        // Reset and hide country-dependent elements
	        $countrySelect.empty().append('<option value="">' + countryPlaceholder + '</option>');
	        $countrySelect.selectpicker('refresh');

	        if (selectedContinent) {
	            // Populate the country select
	            var $countryData = $('.cc-gc-continent-data[data-continent="' + selectedContinent + '"] .cc-gc-country-data');

	            $countryData.each(function () {
	                var countryCode = $(this).data('country-code');
	                var countryName = $(this).data('country-name');
	                var iconClass = $(this).data('icon-class');

	                // Creating option with data attributes for Bootstrap Selectpicker
	                var $option = $('<option>', {
	                    value: countryCode,
	                    text: countryName,
	                    'data-content': '<span class="' + iconClass + '"></span> ' + countryName
	                });

	                $countrySelect.append($option);
	            });

	            // Update the selectpicker
	            $countrySelect.selectpicker('refresh');

	            // Show the country select
	            $countrySelect.prop("disabled", false);
	            $countrySelect.selectpicker('refresh');
	            $('.cc-gc-contact-email').addClass('h-hidden');
	            $('.cc-gc-contact-phone').addClass('h-hidden');
	        } else {
	            $countrySelect.prop("disabled", true);
	            $countrySelect.selectpicker('refresh');
	            $('.cc-gc-contact-email').addClass('h-hidden');
	            $('.cc-gc-contact-phone').addClass('h-hidden');
	        }
	    });

	    // Handle country selection
	    $countrySelect.on('changed.bs.select', function () {
	        var selectedCountryCode = $(this).val();
	        currentSelection.countryCode = selectedCountryCode;

	        if (selectedCountryCode) {
	            var $selectedCountry = $('.cc-gc-country-data[data-country-code="' + selectedCountryCode + '"]');
	            currentSelection.country = selectedCountryCode;
	            var $email = $selectedCountry.data('email');
	            var $phone = $selectedCountry.data('phone');

	            $('#gc-contact-email').html($email).attr('href', 'mailto:' + $email);
	            $('.cc-gc-contact-email').removeClass('h-hidden');

	            if ($phone) {
	                $('#gc-contact-phone').html($phone).attr('href', 'tel:' + $phone);
	                $('.cc-gc-contact-phone').removeClass('h-hidden');
	            } else {
	                $('.cc-gc-contact-phone').addClass('h-hidden');
	            }
	        } else {
	            $('.cc-gc-contact-email').addClass('h-hidden');
	            $('.cc-gc-contact-phone').addClass('h-hidden');
	        }
	    });

	    // Pre-select current continent/country if available
	    function initializeSelectors() {
	        // Initialize all selectpickers first
	        $('.globalContactInfoPicker').selectpicker();

	        // First find the user's country
	        var $userCountry = $('.cc-gc-country-data[data-is-customer-country="true"]');

	        if ($userCountry.length > 0) {
	            // Get the continent of the user's country
	            var userContinent = $userCountry.closest('.cc-gc-continent-data').data('continent');
	            var userCountryCode = $userCountry.data('country-code');

	            // Select the continent first (this will populate countries)
	            if (userContinent) {
	                // Function to update select element and return a promise
	                var updateSelect = function updateSelect(select, value) {
	                    return new Promise(function (resolve) {
	                        select.val(value);
	                        select.selectpicker('refresh');
	                        select.trigger('changed.bs.select');

	                        // Add event listener for completion of the change
	                        select.one('loaded.gc.select', function () {
	                            resolve();
	                        });

	                        // Fallback in case the event is not triggered
	                        setTimeout(resolve, 100);
	                    });
	                };

	                // First update the continent
	                updateSelect($continentSelect, userContinent).then(function () {
	                    // Then update the country
	                    return updateSelect($countrySelect, userCountryCode);
	                }).catch(function (error) {
	                    console.error('Error updating selection:', error);
	                });
	            }
	        } else {
	            // Fallback to the existing logic if no user country is found
	            if ($continentSelect.find('option:selected').val()) {
	                $continentSelect.trigger('changed.bs.select');
	            }
	        }
	    }

	    // Initialize on page load
	    initializeSelectors();
	};

/***/ }),
/* 141 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function () {
	    $('.info-icon').on('mouseenter focusin', function () {
	        $(this).find('.tooltip').removeClass('d-none');
	    });

	    $('.info-icon').on('mouseleave focusout', function () {
	        $(this).find('.tooltip').addClass('d-none');
	    });
	};

/***/ }),
/* 142 */
/***/ (function(module, exports) {

	'use strict';

	var CookieKey = 'lastVisitedLocale',
	    ClosingCookieKey = '-isHidedFor-';
	/**
	 * Create cookie using the specified name, value and duration
	 * @param {string} name - cookie name of the cookie
	 * @param {string} value - cookie value of the cookie
	 * @param {string} days - cookie duration in days
	 */
	function createCookie(name, value, days) {
	    var expires = '',
	        secondsToLast = 31536000; //a year in seconds
	    if (days) {
	        var date = new Date();
	        secondsToLast = days * 24 * 60 * 60;
	        date.setTime(date.getTime() + secondsToLast * 1000);
	        expires = '; expires=' + date.toGMTString();
	    }
	    document.cookie = name + '=' + value + expires + ';max-age=' + secondsToLast + '; path=/';
	}

	/**
	 * Get cookie value by cookie name
	 * @param {string} name - cookie name
	 * @returns {string} cookie value if a matching name is found, null otherwise
	 */
	function readCookie(name) {
	    var nameEQ = encodeURIComponent(name) + '=';
	    var ca = document.cookie.split(';');
	    for (var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) === ' ') {
	            c = c.substring(1, c.length);
	        }
	        if (c.indexOf(nameEQ) === 0) {
	            return decodeURIComponent(c.substring(nameEQ.length, c.length));
	        }
	    }
	    return null;
	}

	function getNavigationLocale() {
	    return $('.js-georedirect-container').data('navigation-locale') || '';
	}

	function getTargetLocale() {
	    return $('.js-georedirect-container').data('target-locale') || '';
	}

	/**
	 * @description generates the cookie in order to remeber the last locale selected by the user
	 */
	$('body').on('countrySelector:countrySelected', function (e, data) {
	    var targetLocale = getNavigationLocale(),
	        key = CookieKey;
	    if (data) {
	        if (data.targetLocale) {
	            targetLocale = data.targetLocale;
	        }
	        if (data.cookieName) {
	            key = data.cookieName;
	        }
	    }
	    createCookie(key, targetLocale, 365);
	});

	module.exports = function () {
	    if ($('.js-georedirect-container').length > 0) {
	        if (navigator.cookieEnabled) {
	            var targetLocale = getTargetLocale();
	            var navigationLocale = getNavigationLocale();

	            // when redirect proposal is rejected, save navigation locale to prevent the suggestion from rendering again
	            $('.js-georedirect-close').on('click', function () {
	                $('body').trigger('countrySelector:countrySelected', { cookieName: targetLocale + ClosingCookieKey + navigationLocale });
	                $('.js-georedirect-container').addClass('d-none');
	                $('.js-promoBannerSmall').addClass('active');
	            });

	            var isHidedForThisLocale = readCookie(targetLocale + ClosingCookieKey + navigationLocale);

	            if (isHidedForThisLocale === navigationLocale) {
	                // hide the banner
	                $('.js-georedirect-container').addClass('d-none');
	                $('.js-promoBannerSmall').addClass('active');
	            } else if (navigationLocale !== targetLocale) {
	                // show redirect suggestion when navigating on a locale different from the location detected
	                $('.js-georedirect-container').removeClass('d-none');
	                $('.js-promoBannerSmall').removeClass('active');
	            }
	        } else {
	            $('.js-georedirect-container').addClass('d-none');
	            $('.js-promoBannerSmall').addClass('active');
	        }
	    }
	};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Submit Newsletter Popup
	 */

	function submitNewsletterPopup() {
	    $('body').on('submit', '#NewsletterSubscriptionFormPopup', function (e) {
	        e.preventDefault();
	        var url = $('#NewsletterSubscriptionFormPopup').attr('action');
	        var form = $("#NewsletterSubscriptionFormPopup");

	        if ($('.custom-error').length === 0) {
	            $.spinner().start();
	            $.ajax({
	                url: url,
	                type: 'POST',
	                data: form.serialize(),
	                success: function success(data) {
	                    if (data) {
	                        $('#viewNewsletterModalBody').html(data);
	                        $.spinner().stop();
	                    }
	                },
	                error: function error() {
	                    $.spinner().stop();
	                }
	            });
	        }
	    });
	}

	function emailVerification() {
	    var $newsletterEmail = $(this);
	    var email = $newsletterEmail.val();
	    var $warningFeedback = $('.js-warning-feedback');
	    var url = $newsletterEmail.data('email-verification-url');
	    var data = {
	        email: email
	    };

	    var regexEmailString = $newsletterEmail.attr('pattern');
	    var regexEmail = new RegExp(regexEmailString);
	    var isEmailValid = false;

	    if (email) {
	        isEmailValid = regexEmail.test(email);
	    } else {
	        if (!$newsletterEmail.hasClass('js-validate-on-change')) {
	            $newsletterEmail.removeClass('is-invalid');
	            $newsletterEmail.closest('.cc-content-input').find('.invalid-feedback .cc-text-message').text('');
	            return;
	        }
	    }

	    if (isEmailValid) {
	        $.ajax({
	            url: url,
	            type: 'post',
	            dataType: 'json',
	            data: data,
	            success: function success(data) {
	                if (data.warning) {
	                    $newsletterEmail.removeClass('is-invalid');
	                    $newsletterEmail.removeClass('custom-error verification-error');
	                    $newsletterEmail.closest('.cc-content-input').find('.invalid-feedback .cc-text-message').text('');
	                    $warningFeedback.removeClass('d-none');
	                    $warningFeedback.text(data.message);
	                } else {
	                    $warningFeedback.addClass('d-none');
	                    $warningFeedback.text('');
	                    if (!data.success) {
	                        $newsletterEmail.addClass('is-invalid');
	                        $newsletterEmail.addClass('custom-error verification-error');
	                        $newsletterEmail.closest('.cc-content-input').find('.invalid-feedback .cc-text-message').text(data.message);
	                    } else {
	                        $newsletterEmail.removeClass('is-invalid');
	                        $newsletterEmail.removeClass('custom-error verification-error');
	                        $newsletterEmail.closest('.cc-content-input').find('.invalid-feedback .cc-text-message').text('');
	                    }
	                }
	            },
	            error: function error() {
	                return;
	            }
	        });
	    } else {
	        $warningFeedback.addClass('d-none');
	        $warningFeedback.text('');
	        if (!$newsletterEmail.hasClass('js-validate-on-change')) {
	            $newsletterEmail.addClass('is-invalid');
	            $newsletterEmail.closest('.cc-content-input').find('.invalid-feedback .cc-text-message').text($newsletterEmail.data('pattern-mismatch'));
	        }
	    }
	}

	// Trigger Newsletter Popup
	function setCookie(name, value) {
	    var date = new Date();
	    date.setTime(date.getTime());
	    document.cookie = name + "=" + (value || "") + '; path=/';
	}

	$(document).ready(function () {
	    var $viewNewsletterModal = $('#viewNewsletterModal');
	    var triggerinterval = $viewNewsletterModal.data('newsletterpopuptriggerinterval');
	    if (document.cookie.indexOf('triggerNewsletterPopup') === -1) {
	        setTimeout(function () {
	            $viewNewsletterModal.modal('show');
	            setCookie('triggerNewsletterPopup', '');
	        }, triggerinterval * 1000);
	    }
	});

	submitNewsletterPopup();

	$('body').on('change', '.js-email-verification', emailVerification);

/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

	'use strict';

	var lastScroll = 0;
	window.addEventListener('scroll', function () {
	    var $onTopBtn = $('.js-toTopButtonCorp');
	    var currentScroll = $(this).scrollTop();
	    lastScroll = currentScroll;

	    if (currentScroll > 200) {
	        $onTopBtn.addClass('cc-page-designer--toTopBtn--show');
	    } else {
	        $onTopBtn.removeClass('cc-page-designer--toTopBtn--show');
	    }
	}, { passive: true });

	$('body').on('click', '.js-toTopButtonCorp', function () {
	    $('html, body').animate({
	        scrollTop: 0
	    }, 300);
	});

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var addToCartHelper = __webpack_require__(147);

	function actionAfterSelectSize(classToRefresh) {
	    var $objTile = $('.' + classToRefresh.replaceAll(' ', '.'));
	    var $btnAddToCart = $objTile.find('.add-to-cart');
	    var $wishlistBtn = $objTile.find('.add-to-wish-list');

	    if ($objTile.closest('.cc-col-tile').hasClass('js-addWishlist')) {
	        $wishlistBtn.trigger('click');
	        $objTile.closest('.cc-col-tile').removeClass('js-addWishlist');
	    } else {
	        $btnAddToCart.trigger('click');
	    }

	    $('.js-sizeBtn').removeClass('active');
	    $('body').removeClass('modal-open');
	}

	//Modify the wishlist-add button like normal behavior, if the product can be added or not
	function handleWishlistButtonInTile($element, isInWishlist) {

	    var $button = $element.find('button.add-to-wish-list');
	    var isSizeSelected = !!$button.data('is-size-selected');
	    var $spanAdd = $button.find('span.wishlist-content-add');
	    var $spanRemove = $button.find('span.wishlist-content-remove');

	    if (isSizeSelected) {
	        if (isInWishlist) {
	            $button.addClass('to-remove');
	            $button.removeClass('to-add');

	            $spanAdd.addClass('d-none');
	            $spanRemove.removeClass('d-none');
	        } else {
	            $button.addClass('to-add');
	            $button.removeClass('to-remove');

	            $spanRemove.addClass('d-none');
	            $spanAdd.removeClass('d-none');
	        }
	    }
	}

	//this function check if the pid in argument is included in the array of products' PID in wishlist
	function checkInWishlist(classToRefresh) {
	    var productArr = window.ProductsInWishlist;

	    if (!productArr) {
	        return false;
	    }

	    var $element = $('.' + classToRefresh.replaceAll(' ', '.')).find('.product.product-tile');
	    var newPid = $element.data('pid');
	    if (productArr.indexOf(newPid) > -1) {
	        handleWishlistButtonInTile($element, true);
	    } else {
	        handleWishlistButtonInTile($element, false);
	    }
	}

	function scrollActiveColorsIntoView() {
	    $('.cc-color-link-content-activate.active').each(function () {
	        var $selectedColor = $(this);
	        var $colorContainer = $selectedColor.closest('.cc-color');
	        if ($colorContainer.length > 0) {
	            var containerWidth = $colorContainer.width();
	            var selectedColorLeft = $selectedColor.position().left;
	            var selectedColorWidth = $selectedColor.outerWidth();

	            if (selectedColorLeft < 0 || selectedColorLeft + selectedColorWidth > containerWidth) {
	                var scrollTo = selectedColorLeft - containerWidth / 2 + selectedColorWidth / 2;
	                $colorContainer.scrollLeft(Math.max(0, scrollTo));
	            }
	        }
	    });
	}

	$('.cc-recommended-slider, .js-slider, .cc-cart-container, .js-editorial-pdp').on('click', '.changeTileSelection a', function (e) {
	    e.preventDefault();
	    e.stopPropagation();

	    var classToRefresh = $(this).closest('.js-tile').length > 0 ? $(this).closest('.js-tile').attr('class') : $(this).closest('.cc-col-tile').attr('class');

	    var isSize = true;
	    var attrColor = $(this).attr('data-color');
	    if (typeof attrColor !== 'undefined' && attrColor !== false) {
	        isSize = false;
	    }

	    $.ajax({
	        url: $(this).data('refreshtileurl'),
	        data: {
	            selectedUrl: $(this).data('refreshtileurl'),
	            classToRefresh: classToRefresh,
	            isAjax: true,
	            isSize: isSize
	        },
	        method: 'GET',
	        success: function success(response) {
	            $('.' + classToRefresh.replaceAll(' ', '.')).find('.js-tileWrapper').empty().html(response);
	            checkInWishlist(classToRefresh);
	            var $tile = $('.' + classToRefresh.replaceAll(' ', '.'));
	            var $wishlistBtn = $tile.find('.add-to-wish-list');
	            var $productTile = $wishlistBtn.closest('.product-tile');
	            if ($wishlistBtn.length && !$productTile.hasClass('to-add')) {
	                $productTile.find('.cc-tile-add-to-wishlist').addClass('to-add');
	            }
	            // Add manual club price product badge icon
	            $('.cc-label-clubprice').addClass('icon-bata-club-price-cz');

	            if (isSize) {
	                actionAfterSelectSize(classToRefresh);
	            } else {
	                scrollActiveColorsIntoView();
	            }
	        },
	        error: function error() {
	            $.spinner().stop();
	        }
	    });
	});

	// Tile sizes
	$(document).on('click', '.cc-recommended-grid__item .js-tile-open-overlay, .cc-page-designer .js-tile-open-overlay', function (e) {
	    e.stopPropagation();
	    e.preventDefault();

	    var $self = $(this);
	    if ($self.hasClass('js-noSize')) {
	        $self.closest('.cc-col-tile').find('.add-to-cart').trigger('click');
	    } else {
	        $('.js-tileWrapper').removeClass('js-tileWrapperHover');
	        $('.cc-tile-sizes.cc-active').removeClass('cc-active');
	        $self.closest('.cc-col-tile').find('.cc-tile-sizes').addClass('cc-active');
	        $self.closest('.js-tileWrapper').addClass('js-tileWrapperHover');

	        if (!window.isDesktop) {
	            $('body').addClass('modal-open');
	        }
	    }
	});

	$('.container, .js-editorial-pdp').on('mouseleave', '.js-tileWrapperHover', function () {
	    if (window.isDesktop) {
	        var $self = $(this);

	        $self.removeClass('js-tileWrapperHover');
	        $self.find('.cc-tile-sizes').removeClass('cc-active');
	    }
	});

	$(document).on('click', '.js-arrow-next', function () {
	    var $slider = $('.js-recommendedSlider');
	    var scrollStep = 200;

	    $slider.animate({
	        scrollLeft: $slider.scrollLeft() + scrollStep
	    }, 300, function () {
	        var scrollLeft = $slider.scrollLeft();
	        var scrollWidth = $slider[0].scrollWidth;
	        var offsetWidth = $slider[0].offsetWidth;

	        if (scrollLeft + offsetWidth >= scrollWidth - 5) {
	            $('.js-arrow-next').addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        } else {
	            $('.js-arrow-next').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        }

	        $('.js-arrow-prev').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    });
	});

	$(document).on('click', '.js-arrow-prev', function () {
	    var $this = $(this);
	    var $slider = $('.js-recommendedSlider');
	    var scrollStep = 200;

	    $slider.animate({
	        scrollLeft: $slider.scrollLeft() - scrollStep
	    }, 300, function () {
	        var scrollLeft = $slider.scrollLeft();

	        if (scrollLeft <= 5) {
	            $this.addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        } else {
	            $this.removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	        }

	        $('.js-arrow-next').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    });
	});

	$('.js-recommendedSlider').on('scroll', function () {
	    var $slider = $(this);
	    var scrollLeft = $slider.scrollLeft();
	    var scrollWidth = $slider[0].scrollWidth;
	    var offsetWidth = $slider[0].offsetWidth;

	    if (scrollLeft + offsetWidth >= scrollWidth - 5) {
	        $('.js-arrow-next').addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    } else {
	        $('.js-arrow-next').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    }

	    if (scrollLeft <= 5) {
	        $('.js-arrow-prev').addClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    } else {
	        $('.js-arrow-prev').removeClass('cc-recommended-grid__carousel__slideOnMobile__arrow__disabled');
	    }
	});

	$(function () {
	    scrollActiveColorsIntoView();
	});

	module.exports = {
	    addToCart: addToCartHelper.addToCart
	};

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var base = __webpack_require__(118),
	    bonusProductHelpers = __webpack_require__(135),
	    detectDevice = __webpack_require__(148);

	function sizeIsSelectedFunc($elem) {
	    var isDisabled = $elem.data('is-disabled');
	    var isOneSizePLP = $elem.parents('.cc-content-button').prev('.color-swatches').find('.select-size').length <= 0;
	    var isOneSizePDP = $elem.parents('.pdp-col-description').find('.container-size-list').length <= 0;

	    if ((isDisabled === true || isDisabled === 'true') && (!isOneSizePLP || !isOneSizePDP)) {
	        // if button is disabled and prod is not a oneSize prod, no msg hint'll be shown
	        $elem.parents('.product-detail').find('.availability-msg .availability-msg-hint').removeClass('d-none'); // pdp size hint logic
	        $elem.parents('.container-tile-hover').find('.availability-msg .availability-msg-hint').removeClass('d-none'); // plp size hint logic
	        return false;
	    } else {
	        return true;
	    }
	}

	/**
	 * Retrieve product options
	 *
	 * @param {jQuery} $productContainer - DOM element for current product
	 * @return {string} - Product options and their selected values
	 */
	function getOptions($productContainer) {
	    var options = $productContainer.find('.product-option').map(function () {
	        var $elOption = $(this).find('.options-select');
	        var urlValue = $elOption.val();
	        var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
	        return {
	            optionId: $(this).data('option-id'),
	            selectedValueId: selectedValueId
	        };
	    }).toArray();

	    return JSON.stringify(options);
	}

	/**
	 * Retrieves url to use when adding a product to the cart
	 *
	 * @return {string} - The provided URL to use when adding a product to the cart
	 */
	function getAddToCartUrl() {
	    return $('.add-to-cart-url').val();
	}

	/**
	 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
	 * items with their selected variants
	 *
	 * @return {string[]} - List of selected bundle product item ID's
	 */
	function getChildProducts() {
	    var childProducts = [];
	    $('.bundle-item').each(function () {
	        childProducts.push({
	            pid: $(this).find('.product-id').text(),
	            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
	        });
	    });

	    return childProducts.length ? JSON.stringify(childProducts) : [];
	}

	/**
	 * Retrieve contextual quantity selector
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {jquery} - quantity selector DOM container
	 */
	function getQuantitySelector($el) {
	    return $el && $('.set-items').length ? $($el).closest('.product-detail').find('.quantity-select') : $('.quantity-select');
	}

	/**
	 * Retrieves the value associated with the Quantity pull-down menu
	 * @param {jquery} $el - DOM container for the relevant quantity
	 * @return {string} - value found in the quantity input
	 */
	function getQuantitySelected($el) {
	    return getQuantitySelector($el).val();
	}

	/**
	 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
	 * @param {string} response - ajax response from clicking the add to cart button
	 */
	function handlePostCartAdd(response) {
	    $('.minicart').trigger('count:update', response);
	    var messageType = response.error ? 'alert-danger' : 'alert-success';
	    // show add to cart toast
	    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
	        bonusProductHelpers.chooseBonusProducts(response.newBonusDiscountLineItem);
	    } else {
	        if ($('.add-to-cart-messages').length === 0) {
	            $('body').append('<div class="add-to-cart-messages"></div>');
	        }

	        $('.add-to-cart-messages').append('<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' + response.message + '</div>');

	        setTimeout(function () {
	            $('.add-to-basket-alert').remove();
	        }, 5000);
	    }
	}

	function showMiniCart(reportingURL) {
	    return new $.Deferred(function (deferred) {
	        base.miniCartReportingUrl(reportingURL);
	        $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	        var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	        if (minicartTimeout > 0) {
	            setTimeout(function () {
	                if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                    $('#closeMiniCartButton').click();
	                    $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                    deferred.resolve();
	                }

	                if ($('.js-header').hasClass('cc-header__tag__viewHeader') && window.isDesktop) {
	                    $('.js-header').removeClass('cc-header__tag__viewHeader');

	                    // Check if we're on brandHomepage
	                    var isBrandHomepage = $('.cc-brandHomepage').length > 0;

	                    if (isBrandHomepage) {
	                        // For brandHomepage, reset miniCart and intro positioning
	                        $('.cc-minicart-overlay').css('top', '');
	                        $('.experience-commerce_layouts-intro').css('top', '-1px');
	                    } else {
	                        // For PLP pages, use existing cleanup logic
	                        var $breadcrumbContainer = $('.js-breadcrumbContainer');
	                        var $filterWrapper = $('.cc-plp--filters--sticky');
	                        var breadcrumbHeigth = $breadcrumbContainer.find('.cc-breadcrumb--container').height() > 0 ? 0 : 42;
	                        var $categoryWrapperInner = $('.js-categoryPills');
	                        var $categoryWrapper = $('.cc-plp--categories--sticky');
	                        var heightFilter = 52;
	                        var logoHeight = $('.cc-plp--filters--brandLogo').length > 0 && $('.cc-plp--categories--dropdown--withLogo--withoutCategories').length === 0 && $(window).width() < 1201 ? $('.cc-plp--filters--brandLogo').height() + 4 : 0;

	                        $breadcrumbContainer.css('top', 0);
	                        if ($categoryWrapperInner.length > 0) {
	                            $categoryWrapper.css('top', 42 - breadcrumbHeigth);
	                            $filterWrapper.css('top', 117 + logoHeight - breadcrumbHeigth);
	                        } else {
	                            if ($breadcrumbContainer.find('.cc-breadcrumb--container').length === 0) {
	                                $filterWrapper.css('top', 0);
	                            } else {
	                                $filterWrapper.css('top', heightFilter - breadcrumbHeigth);
	                            }
	                        }
	                    }
	                }
	            }, minicartTimeout);
	        }
	    }).promise();
	}

	module.exports = {
	    addToCart: function addToCart() {
	        $('.container').on('click', 'button.add-to-cart, button.add-to-cart-global', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            e.stopImmediatePropagation();

	            var addToCartUrl;
	            var pid;
	            var pidsObj;
	            var setPids;

	            var $self = $(this);

	            var sizeIsSelected = sizeIsSelectedFunc($self);
	            if (!sizeIsSelected) {
	                return;
	            }

	            $('body').trigger('product:beforeAddToCart', this);

	            if ($('.set-items').length && $self.hasClass('add-to-cart-global')) {
	                setPids = [];

	                $('.product-detail').each(function () {
	                    if (!$self.hasClass('product-set-detail')) {
	                        setPids.push({
	                            pid: $self.find('.product-id').text(),
	                            qty: $self.find('.quantity-select').val(),
	                            options: getOptions($self)
	                        });
	                    }
	                });
	                pidsObj = JSON.stringify(setPids);
	            }

	            pid = base.getPidValue($self);

	            var $productContainer = $self.closest('.product-detail');
	            if (!$productContainer.length) {
	                $productContainer = $self.closest('.quick-view-dialog').find('.product-detail');
	            }

	            addToCartUrl = getAddToCartUrl();

	            var form = {
	                pid: pid,
	                pidsObj: pidsObj,
	                childProducts: getChildProducts(),
	                quantity: getQuantitySelected($self) || 1
	            };

	            if ($('body').hasClass('checkOutPage')) {
	                form.checkOutPage = true;
	            }

	            if (!$('.bundle-item').length) {
	                form.options = getOptions($productContainer);
	            }

	            //IN-AR TRY ON
	            var tryOnButton = $('.js-tryOn-button'),
	                dataEvent = {};

	            if (tryOnButton && tryOnButton.length > 0) {
	                var tryOnDesktopClick = 'false',
	                    tryOnMobileRedirect = 'false';
	                //If the device is Mobile/Tablet we will have the info of the Try-on usage in a specific div
	                if (detectDevice.detectMobile()) {
	                    tryOnMobileRedirect = $('.try-on-redirected').attr('data-used-try-on');
	                }
	                //If the device is Desktop we will have the info of the Try-on button clicked in the button itself
	                else {
	                        if (tryOnButton.length > 0) {
	                            tryOnDesktopClick = $('.js-tryOn-button').attr('data-ga-cliked');
	                        }
	                    }

	                form.tryOnDesktopClick = tryOnDesktopClick;
	                form.tryOnMobileRedirect = tryOnMobileRedirect;
	            }

	            // Analytics data
	            $('body').trigger('analytics:addToCartSubmitting', form);

	            $(this).trigger('updateAddToCartFormData', form);
	            if (addToCartUrl) {
	                $.ajax({
	                    url: addToCartUrl,
	                    method: 'POST',
	                    data: form,
	                    success: function success(data) {
	                        if (data.limitMessage || data.unavailableItemAdded) {
	                            $('#cartLimit-modal-body').text(data.limitMessage || '');
	                            $('#cartLimit-modal').modal('show');
	                            $.spinner().stop();
	                        } else {
	                            //normal behavior
	                            handlePostCartAdd(data);
	                            //update the minicart price total
	                            $('.js-header').removeClass('cc-header__tag__scrollDown');
	                            if ($('.minicartIconPrice').length > 0) {
	                                $('.minicartIconPrice').html(data.cart.totals.subTotal);
	                            }
	                            $('#analytics-cartInfo').data('value', data.cart && data.cart.totals && data.cart.totals.grandTotalDecimal);
	                            $('#analytics-cartInfo').data('couponsName', data.cart && data.cart.couponNamesString);
	                            $('body').trigger('product:afterAddToCart', data);

	                            //analytics event
	                            dataEvent.productID = pid;
	                            if (tryOnButton && tryOnButton.length > 0) {
	                                dataEvent.tryOnDesktopClick = tryOnDesktopClick;
	                                dataEvent.tryOnMobileRedirect = tryOnMobileRedirect;
	                            }

	                            $('body').trigger('analytics:addToCart', dataEvent);

	                            $.spinner().stop();
	                            base.miniCartReportingUrl(data.reportingURL);
	                            $('.cc-minicart-overlay').addClass('opened-by-add-to-bag');
	                            var minicartTimeout = parseInt($('#minicartIcon').data('timeout'));

	                            // if (minicartTimeout > 0) {
	                            //     setTimeout(function() {
	                            //         if ($('.cc-minicart-overlay').hasClass('opened-by-add-to-bag')) {
	                            //             //close minicart only of is opened automatically from pdp or plp or wishlist
	                            //             $('#closeMiniCartButton').click();
	                            //             $('.cc-minicart-overlay').removeClass('opened-by-add-to-bag');
	                            //         }
	                            //     }, minicartTimeout);
	                            // }

	                            var isCartPage = $('.cc-cart-container');

	                            showMiniCart(data.reportingURL).then(function () {
	                                if (isCartPage.length > 0) {
	                                    window.location.reload();
	                                }
	                            });
	                        }
	                    },
	                    error: function error() {
	                        $.spinner().stop();
	                    }
	                });
	            }
	        });
	    }
	};

/***/ }),
/* 148 */
/***/ (function(module, exports) {

	"use strict";

	/**
	 * A function that detects user's device.
	 * @returns {Boolean} Returns `true` if user's device is mobile/tablet.
	 */
	function detectMobile() {
	    var toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

	    return toMatch.some(function (toMatchItem) {
	        return navigator.userAgent.match(toMatchItem);
	    });
	}

	module.exports = {
	    detectMobile: detectMobile
	};

/***/ }),
/* 149 */,
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	__webpack_require__(151);
	__webpack_require__(152);
	// require('bootstrap/js/src/button.js');
	__webpack_require__(153);
	__webpack_require__(154);
	__webpack_require__(155);
	__webpack_require__(157);
	__webpack_require__(158);
	__webpack_require__(159);
	__webpack_require__(160);
	// require('bootstrap/js/src/popover.js');

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	/**
	 * ------------------------------------------------------------------------
	 * Private TransitionEnd Helpers
	 * ------------------------------------------------------------------------
	 */

	var TRANSITION_END = 'transitionend'; /**
	                                       * --------------------------------------------------------------------------
	                                       * Bootstrap (v4.3.1): util.js
	                                       * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                       * --------------------------------------------------------------------------
	                                       */

	var MAX_UID = 1000000;
	var MILLISECONDS_MULTIPLIER = 1000;

	// Shoutout AngusCroll (https://goo.gl/pxwQGp)
	function toType(obj) {
	  return {}.toString.call(obj).match(/\s([a-z]+)/i)[1].toLowerCase();
	}

	function getSpecialTransitionEndEvent() {
	  return {
	    bindType: TRANSITION_END,
	    delegateType: TRANSITION_END,
	    handle: function handle(event) {
	      if ((0, _jquery2.default)(event.target).is(this)) {
	        return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
	      }
	      return undefined; // eslint-disable-line no-undefined
	    }
	  };
	}

	function transitionEndEmulator(duration) {
	  var _this = this;

	  var called = false;

	  (0, _jquery2.default)(this).one(Util.TRANSITION_END, function () {
	    called = true;
	  });

	  setTimeout(function () {
	    if (!called) {
	      Util.triggerTransitionEnd(_this);
	    }
	  }, duration);

	  return this;
	}

	function setTransitionEndSupport() {
	  _jquery2.default.fn.emulateTransitionEnd = transitionEndEmulator;
	  _jquery2.default.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
	}

	/**
	 * --------------------------------------------------------------------------
	 * Public Util Api
	 * --------------------------------------------------------------------------
	 */

	var Util = {

	  TRANSITION_END: 'bsTransitionEnd',

	  getUID: function getUID(prefix) {
	    do {
	      // eslint-disable-next-line no-bitwise
	      prefix += ~~(Math.random() * MAX_UID); // "~~" acts like a faster Math.floor() here
	    } while (document.getElementById(prefix));
	    return prefix;
	  },
	  getSelectorFromElement: function getSelectorFromElement(element) {
	    var selector = element.getAttribute('data-target');

	    if (!selector || selector === '#') {
	      var hrefAttr = element.getAttribute('href');
	      selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : '';
	    }

	    try {
	      return document.querySelector(selector) ? selector : null;
	    } catch (err) {
	      return null;
	    }
	  },
	  getTransitionDurationFromElement: function getTransitionDurationFromElement(element) {
	    if (!element) {
	      return 0;
	    }

	    // Get transition-duration of the element
	    var transitionDuration = (0, _jquery2.default)(element).css('transition-duration');
	    var transitionDelay = (0, _jquery2.default)(element).css('transition-delay');

	    var floatTransitionDuration = parseFloat(transitionDuration);
	    var floatTransitionDelay = parseFloat(transitionDelay);

	    // Return 0 if element or transition duration is not found
	    if (!floatTransitionDuration && !floatTransitionDelay) {
	      return 0;
	    }

	    // If multiple durations are defined, take the first
	    transitionDuration = transitionDuration.split(',')[0];
	    transitionDelay = transitionDelay.split(',')[0];

	    return (parseFloat(transitionDuration) + parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
	  },
	  reflow: function reflow(element) {
	    return element.offsetHeight;
	  },
	  triggerTransitionEnd: function triggerTransitionEnd(element) {
	    (0, _jquery2.default)(element).trigger(TRANSITION_END);
	  },


	  // TODO: Remove in v5
	  supportsTransitionEnd: function supportsTransitionEnd() {
	    return Boolean(TRANSITION_END);
	  },
	  isElement: function isElement(obj) {
	    return (obj[0] || obj).nodeType;
	  },
	  typeCheckConfig: function typeCheckConfig(componentName, config, configTypes) {
	    for (var property in configTypes) {
	      if (Object.prototype.hasOwnProperty.call(configTypes, property)) {
	        var expectedTypes = configTypes[property];
	        var value = config[property];
	        var valueType = value && Util.isElement(value) ? 'element' : toType(value);

	        if (!new RegExp(expectedTypes).test(valueType)) {
	          throw new Error(componentName.toUpperCase() + ': ' + ('Option "' + property + '" provided type "' + valueType + '" ') + ('but expected type "' + expectedTypes + '".'));
	        }
	      }
	    }
	  },
	  findShadowRoot: function findShadowRoot(element) {
	    if (!document.documentElement.attachShadow) {
	      return null;
	    }

	    // Can find the shadow root otherwise it'll return the document
	    if (typeof element.getRootNode === 'function') {
	      var root = element.getRootNode();
	      return root instanceof ShadowRoot ? root : null;
	    }

	    if (element instanceof ShadowRoot) {
	      return element;
	    }

	    // when we don't find a shadow root
	    if (!element.parentNode) {
	      return null;
	    }

	    return Util.findShadowRoot(element.parentNode);
	  }
	};

	setTransitionEndSupport();

	exports.default = Util;

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): alert.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'alert';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.alert';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];

	var Selector = {
	  DISMISS: '[data-dismiss="alert"]'
	};

	var Event = {
	  CLOSE: 'close' + EVENT_KEY,
	  CLOSED: 'closed' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  ALERT: 'alert',
	  FADE: 'fade',
	  SHOW: 'show'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var Alert = function () {
	  function Alert(element) {
	    _classCallCheck(this, Alert);

	    this._element = element;
	  }

	  // Getters

	  _createClass(Alert, [{
	    key: 'close',


	    // Public

	    value: function close(element) {
	      var rootElement = this._element;
	      if (element) {
	        rootElement = this._getRootElement(element);
	      }

	      var customEvent = this._triggerCloseEvent(rootElement);

	      if (customEvent.isDefaultPrevented()) {
	        return;
	      }

	      this._removeElement(rootElement);
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _jquery2.default.removeData(this._element, DATA_KEY);
	      this._element = null;
	    }

	    // Private

	  }, {
	    key: '_getRootElement',
	    value: function _getRootElement(element) {
	      var selector = _util2.default.getSelectorFromElement(element);
	      var parent = false;

	      if (selector) {
	        parent = document.querySelector(selector);
	      }

	      if (!parent) {
	        parent = (0, _jquery2.default)(element).closest('.' + ClassName.ALERT)[0];
	      }

	      return parent;
	    }
	  }, {
	    key: '_triggerCloseEvent',
	    value: function _triggerCloseEvent(element) {
	      var closeEvent = _jquery2.default.Event(Event.CLOSE);

	      (0, _jquery2.default)(element).trigger(closeEvent);
	      return closeEvent;
	    }
	  }, {
	    key: '_removeElement',
	    value: function _removeElement(element) {
	      var _this = this;

	      (0, _jquery2.default)(element).removeClass(ClassName.SHOW);

	      if (!(0, _jquery2.default)(element).hasClass(ClassName.FADE)) {
	        this._destroyElement(element);
	        return;
	      }

	      var transitionDuration = _util2.default.getTransitionDurationFromElement(element);

	      (0, _jquery2.default)(element).one(_util2.default.TRANSITION_END, function (event) {
	        return _this._destroyElement(element, event);
	      }).emulateTransitionEnd(transitionDuration);
	    }
	  }, {
	    key: '_destroyElement',
	    value: function _destroyElement(element) {
	      (0, _jquery2.default)(element).detach().trigger(Event.CLOSED).remove();
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var $element = (0, _jquery2.default)(this);
	        var data = $element.data(DATA_KEY);

	        if (!data) {
	          data = new Alert(this);
	          $element.data(DATA_KEY, data);
	        }

	        if (config === 'close') {
	          data[config](this);
	        }
	      });
	    }
	  }, {
	    key: '_handleDismiss',
	    value: function _handleDismiss(alertInstance) {
	      return function (event) {
	        if (event) {
	          event.preventDefault();
	        }

	        alertInstance.close(this);
	      };
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);

	  return Alert;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(document).on(Event.CLICK_DATA_API, Selector.DISMISS, Alert._handleDismiss(new Alert()));

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Alert._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Alert;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Alert._jQueryInterface;
	};

	exports.default = Alert;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): carousel.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'carousel';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.carousel';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];
	var ARROW_LEFT_KEYCODE = 37; // KeyboardEvent.which value for left arrow key
	var ARROW_RIGHT_KEYCODE = 39; // KeyboardEvent.which value for right arrow key
	var TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
	var SWIPE_THRESHOLD = 40;

	var Default = {
	  interval: 5000,
	  keyboard: true,
	  slide: false,
	  pause: 'hover',
	  wrap: true,
	  touch: true
	};

	var DefaultType = {
	  interval: '(number|boolean)',
	  keyboard: 'boolean',
	  slide: '(boolean|string)',
	  pause: '(string|boolean)',
	  wrap: 'boolean',
	  touch: 'boolean'
	};

	var Direction = {
	  NEXT: 'next',
	  PREV: 'prev',
	  LEFT: 'left',
	  RIGHT: 'right'
	};

	var Event = {
	  SLIDE: 'slide' + EVENT_KEY,
	  SLID: 'slid' + EVENT_KEY,
	  KEYDOWN: 'keydown' + EVENT_KEY,
	  MOUSEENTER: 'mouseenter' + EVENT_KEY,
	  MOUSELEAVE: 'mouseleave' + EVENT_KEY,
	  TOUCHSTART: 'touchstart' + EVENT_KEY,
	  TOUCHMOVE: 'touchmove' + EVENT_KEY,
	  TOUCHEND: 'touchend' + EVENT_KEY,
	  POINTERDOWN: 'pointerdown' + EVENT_KEY,
	  POINTERUP: 'pointerup' + EVENT_KEY,
	  DRAG_START: 'dragstart' + EVENT_KEY,
	  LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  CAROUSEL: 'carousel',
	  ACTIVE: 'active',
	  SLIDE: 'slide',
	  RIGHT: 'carousel-item-right',
	  LEFT: 'carousel-item-left',
	  NEXT: 'carousel-item-next',
	  PREV: 'carousel-item-prev',
	  ITEM: 'carousel-item',
	  POINTER_EVENT: 'pointer-event'
	};

	var Selector = {
	  ACTIVE: '.active',
	  ACTIVE_ITEM: '.active.carousel-item',
	  ITEM: '.carousel-item',
	  ITEM_IMG: '.carousel-item img',
	  NEXT_PREV: '.carousel-item-next, .carousel-item-prev',
	  INDICATORS: '.carousel-indicators',
	  DATA_SLIDE: '[data-slide], [data-slide-to]',
	  DATA_RIDE: '[data-ride="carousel"]'
	};

	var PointerType = {
	  TOUCH: 'touch',
	  PEN: 'pen'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */
	};
	var Carousel = function () {
	  function Carousel(element, config) {
	    _classCallCheck(this, Carousel);

	    this._items = null;
	    this._interval = null;
	    this._activeElement = null;
	    this._isPaused = false;
	    this._isSliding = false;
	    this.touchTimeout = null;
	    this.touchStartX = 0;
	    this.touchDeltaX = 0;

	    this._config = this._getConfig(config);
	    this._element = element;
	    this._indicatorsElement = this._element.querySelector(Selector.INDICATORS);
	    this._touchSupported = 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
	    this._pointerEvent = Boolean(window.PointerEvent || window.MSPointerEvent);

	    this._addEventListeners();
	  }

	  // Getters

	  _createClass(Carousel, [{
	    key: 'next',


	    // Public

	    value: function next() {
	      if (!this._isSliding) {
	        this._slide(Direction.NEXT);
	      }
	    }
	  }, {
	    key: 'nextWhenVisible',
	    value: function nextWhenVisible() {
	      // Don't call next when the page isn't visible
	      // or the carousel or its parent isn't visible
	      if (!document.hidden && (0, _jquery2.default)(this._element).is(':visible') && (0, _jquery2.default)(this._element).css('visibility') !== 'hidden') {
	        this.next();
	      }
	    }
	  }, {
	    key: 'prev',
	    value: function prev() {
	      if (!this._isSliding) {
	        this._slide(Direction.PREV);
	      }
	    }
	  }, {
	    key: 'pause',
	    value: function pause(event) {
	      if (!event) {
	        this._isPaused = true;
	      }

	      if (this._element.querySelector(Selector.NEXT_PREV)) {
	        _util2.default.triggerTransitionEnd(this._element);
	        this.cycle(true);
	      }

	      clearInterval(this._interval);
	      this._interval = null;
	    }
	  }, {
	    key: 'cycle',
	    value: function cycle(event) {
	      if (!event) {
	        this._isPaused = false;
	      }

	      if (this._interval) {
	        clearInterval(this._interval);
	        this._interval = null;
	      }

	      if (this._config.interval && !this._isPaused) {
	        this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
	      }
	    }
	  }, {
	    key: 'to',
	    value: function to(index) {
	      var _this = this;

	      this._activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);

	      var activeIndex = this._getItemIndex(this._activeElement);

	      if (index > this._items.length - 1 || index < 0) {
	        return;
	      }

	      if (this._isSliding) {
	        (0, _jquery2.default)(this._element).one(Event.SLID, function () {
	          return _this.to(index);
	        });
	        return;
	      }

	      if (activeIndex === index) {
	        this.pause();
	        this.cycle();
	        return;
	      }

	      var direction = index > activeIndex ? Direction.NEXT : Direction.PREV;

	      this._slide(direction, this._items[index]);
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      (0, _jquery2.default)(this._element).off(EVENT_KEY);
	      _jquery2.default.removeData(this._element, DATA_KEY);

	      this._items = null;
	      this._config = null;
	      this._element = null;
	      this._interval = null;
	      this._isPaused = null;
	      this._isSliding = null;
	      this._activeElement = null;
	      this._indicatorsElement = null;
	    }

	    // Private

	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, config);
	      _util2.default.typeCheckConfig(NAME, config, DefaultType);
	      return config;
	    }
	  }, {
	    key: '_handleSwipe',
	    value: function _handleSwipe() {
	      var absDeltax = Math.abs(this.touchDeltaX);

	      if (absDeltax <= SWIPE_THRESHOLD) {
	        return;
	      }

	      var direction = absDeltax / this.touchDeltaX;

	      // swipe left
	      if (direction > 0) {
	        this.prev();
	      }

	      // swipe right
	      if (direction < 0) {
	        this.next();
	      }
	    }
	  }, {
	    key: '_addEventListeners',
	    value: function _addEventListeners() {
	      var _this2 = this;

	      if (this._config.keyboard) {
	        (0, _jquery2.default)(this._element).on(Event.KEYDOWN, function (event) {
	          return _this2._keydown(event);
	        });
	      }

	      if (this._config.pause === 'hover') {
	        (0, _jquery2.default)(this._element).on(Event.MOUSEENTER, function (event) {
	          return _this2.pause(event);
	        }).on(Event.MOUSELEAVE, function (event) {
	          return _this2.cycle(event);
	        });
	      }

	      if (this._config.touch) {
	        this._addTouchEventListeners();
	      }
	    }
	  }, {
	    key: '_addTouchEventListeners',
	    value: function _addTouchEventListeners() {
	      var _this3 = this;

	      if (!this._touchSupported) {
	        return;
	      }

	      var start = function start(event) {
	        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
	          _this3.touchStartX = event.originalEvent.clientX;
	        } else if (!_this3._pointerEvent) {
	          _this3.touchStartX = event.originalEvent.touches[0].clientX;
	        }
	      };

	      var move = function move(event) {
	        // ensure swiping with one touch and not pinching
	        if (event.originalEvent.touches && event.originalEvent.touches.length > 1) {
	          _this3.touchDeltaX = 0;
	        } else {
	          _this3.touchDeltaX = event.originalEvent.touches[0].clientX - _this3.touchStartX;
	        }
	      };

	      var end = function end(event) {
	        if (_this3._pointerEvent && PointerType[event.originalEvent.pointerType.toUpperCase()]) {
	          _this3.touchDeltaX = event.originalEvent.clientX - _this3.touchStartX;
	        }

	        _this3._handleSwipe();
	        if (_this3._config.pause === 'hover') {
	          // If it's a touch-enabled device, mouseenter/leave are fired as
	          // part of the mouse compatibility events on first tap - the carousel
	          // would stop cycling until user tapped out of it;
	          // here, we listen for touchend, explicitly pause the carousel
	          // (as if it's the second time we tap on it, mouseenter compat event
	          // is NOT fired) and after a timeout (to allow for mouse compatibility
	          // events to fire) we explicitly restart cycling

	          _this3.pause();
	          if (_this3.touchTimeout) {
	            clearTimeout(_this3.touchTimeout);
	          }
	          _this3.touchTimeout = setTimeout(function (event) {
	            return _this3.cycle(event);
	          }, TOUCHEVENT_COMPAT_WAIT + _this3._config.interval);
	        }
	      };

	      (0, _jquery2.default)(this._element.querySelectorAll(Selector.ITEM_IMG)).on(Event.DRAG_START, function (e) {
	        return e.preventDefault();
	      });
	      if (this._pointerEvent) {
	        (0, _jquery2.default)(this._element).on(Event.POINTERDOWN, function (event) {
	          return start(event);
	        });
	        (0, _jquery2.default)(this._element).on(Event.POINTERUP, function (event) {
	          return end(event);
	        });

	        this._element.classList.add(ClassName.POINTER_EVENT);
	      } else {
	        (0, _jquery2.default)(this._element).on(Event.TOUCHSTART, function (event) {
	          return start(event);
	        });
	        (0, _jquery2.default)(this._element).on(Event.TOUCHMOVE, function (event) {
	          return move(event);
	        });
	        (0, _jquery2.default)(this._element).on(Event.TOUCHEND, function (event) {
	          return end(event);
	        });
	      }
	    }
	  }, {
	    key: '_keydown',
	    value: function _keydown(event) {
	      if (/input|textarea/i.test(event.target.tagName)) {
	        return;
	      }

	      switch (event.which) {
	        case ARROW_LEFT_KEYCODE:
	          event.preventDefault();
	          this.prev();
	          break;
	        case ARROW_RIGHT_KEYCODE:
	          event.preventDefault();
	          this.next();
	          break;
	        default:
	      }
	    }
	  }, {
	    key: '_getItemIndex',
	    value: function _getItemIndex(element) {
	      this._items = element && element.parentNode ? [].slice.call(element.parentNode.querySelectorAll(Selector.ITEM)) : [];
	      return this._items.indexOf(element);
	    }
	  }, {
	    key: '_getItemByDirection',
	    value: function _getItemByDirection(direction, activeElement) {
	      var isNextDirection = direction === Direction.NEXT;
	      var isPrevDirection = direction === Direction.PREV;
	      var activeIndex = this._getItemIndex(activeElement);
	      var lastItemIndex = this._items.length - 1;
	      var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;

	      if (isGoingToWrap && !this._config.wrap) {
	        return activeElement;
	      }

	      var delta = direction === Direction.PREV ? -1 : 1;
	      var itemIndex = (activeIndex + delta) % this._items.length;

	      return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
	    }
	  }, {
	    key: '_triggerSlideEvent',
	    value: function _triggerSlideEvent(relatedTarget, eventDirectionName) {
	      var targetIndex = this._getItemIndex(relatedTarget);
	      var fromIndex = this._getItemIndex(this._element.querySelector(Selector.ACTIVE_ITEM));
	      var slideEvent = _jquery2.default.Event(Event.SLIDE, {
	        relatedTarget: relatedTarget,
	        direction: eventDirectionName,
	        from: fromIndex,
	        to: targetIndex
	      });

	      (0, _jquery2.default)(this._element).trigger(slideEvent);

	      return slideEvent;
	    }
	  }, {
	    key: '_setActiveIndicatorElement',
	    value: function _setActiveIndicatorElement(element) {
	      if (this._indicatorsElement) {
	        var indicators = [].slice.call(this._indicatorsElement.querySelectorAll(Selector.ACTIVE));
	        (0, _jquery2.default)(indicators).removeClass(ClassName.ACTIVE);

	        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];

	        if (nextIndicator) {
	          (0, _jquery2.default)(nextIndicator).addClass(ClassName.ACTIVE);
	        }
	      }
	    }
	  }, {
	    key: '_slide',
	    value: function _slide(direction, element) {
	      var _this4 = this;

	      var activeElement = this._element.querySelector(Selector.ACTIVE_ITEM);
	      var activeElementIndex = this._getItemIndex(activeElement);
	      var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
	      var nextElementIndex = this._getItemIndex(nextElement);
	      var isCycling = Boolean(this._interval);

	      var directionalClassName = void 0;
	      var orderClassName = void 0;
	      var eventDirectionName = void 0;

	      if (direction === Direction.NEXT) {
	        directionalClassName = ClassName.LEFT;
	        orderClassName = ClassName.NEXT;
	        eventDirectionName = Direction.LEFT;
	      } else {
	        directionalClassName = ClassName.RIGHT;
	        orderClassName = ClassName.PREV;
	        eventDirectionName = Direction.RIGHT;
	      }

	      if (nextElement && (0, _jquery2.default)(nextElement).hasClass(ClassName.ACTIVE)) {
	        this._isSliding = false;
	        return;
	      }

	      var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
	      if (slideEvent.isDefaultPrevented()) {
	        return;
	      }

	      if (!activeElement || !nextElement) {
	        // Some weirdness is happening, so we bail
	        return;
	      }

	      this._isSliding = true;

	      if (isCycling) {
	        this.pause();
	      }

	      this._setActiveIndicatorElement(nextElement);

	      var slidEvent = _jquery2.default.Event(Event.SLID, {
	        relatedTarget: nextElement,
	        direction: eventDirectionName,
	        from: activeElementIndex,
	        to: nextElementIndex
	      });

	      if ((0, _jquery2.default)(this._element).hasClass(ClassName.SLIDE)) {
	        (0, _jquery2.default)(nextElement).addClass(orderClassName);

	        _util2.default.reflow(nextElement);

	        (0, _jquery2.default)(activeElement).addClass(directionalClassName);
	        (0, _jquery2.default)(nextElement).addClass(directionalClassName);

	        var nextElementInterval = parseInt(nextElement.getAttribute('data-interval'), 10);
	        if (nextElementInterval) {
	          this._config.defaultInterval = this._config.defaultInterval || this._config.interval;
	          this._config.interval = nextElementInterval;
	        } else {
	          this._config.interval = this._config.defaultInterval || this._config.interval;
	        }

	        var transitionDuration = _util2.default.getTransitionDurationFromElement(activeElement);

	        (0, _jquery2.default)(activeElement).one(_util2.default.TRANSITION_END, function () {
	          (0, _jquery2.default)(nextElement).removeClass(directionalClassName + ' ' + orderClassName).addClass(ClassName.ACTIVE);

	          (0, _jquery2.default)(activeElement).removeClass(ClassName.ACTIVE + ' ' + orderClassName + ' ' + directionalClassName);

	          _this4._isSliding = false;

	          setTimeout(function () {
	            return (0, _jquery2.default)(_this4._element).trigger(slidEvent);
	          }, 0);
	        }).emulateTransitionEnd(transitionDuration);
	      } else {
	        (0, _jquery2.default)(activeElement).removeClass(ClassName.ACTIVE);
	        (0, _jquery2.default)(nextElement).addClass(ClassName.ACTIVE);

	        this._isSliding = false;
	        (0, _jquery2.default)(this._element).trigger(slidEvent);
	      }

	      if (isCycling) {
	        this.cycle();
	      }
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = (0, _jquery2.default)(this).data(DATA_KEY);
	        var _config = _extends({}, Default, (0, _jquery2.default)(this).data());

	        if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object') {
	          _config = _extends({}, _config, config);
	        }

	        var action = typeof config === 'string' ? config : _config.slide;

	        if (!data) {
	          data = new Carousel(this, _config);
	          (0, _jquery2.default)(this).data(DATA_KEY, data);
	        }

	        if (typeof config === 'number') {
	          data.to(config);
	        } else if (typeof action === 'string') {
	          if (typeof data[action] === 'undefined') {
	            throw new TypeError('No method named "' + action + '"');
	          }
	          data[action]();
	        } else if (_config.interval && _config.ride) {
	          data.pause();
	          data.cycle();
	        }
	      });
	    }
	  }, {
	    key: '_dataApiClickHandler',
	    value: function _dataApiClickHandler(event) {
	      var selector = _util2.default.getSelectorFromElement(this);

	      if (!selector) {
	        return;
	      }

	      var target = (0, _jquery2.default)(selector)[0];

	      if (!target || !(0, _jquery2.default)(target).hasClass(ClassName.CAROUSEL)) {
	        return;
	      }

	      var config = _extends({}, (0, _jquery2.default)(target).data(), (0, _jquery2.default)(this).data());
	      var slideIndex = this.getAttribute('data-slide-to');

	      if (slideIndex) {
	        config.interval = false;
	      }

	      Carousel._jQueryInterface.call((0, _jquery2.default)(target), config);

	      if (slideIndex) {
	        (0, _jquery2.default)(target).data(DATA_KEY).to(slideIndex);
	      }

	      event.preventDefault();
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);

	  return Carousel;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);

	(0, _jquery2.default)(window).on(Event.LOAD_DATA_API, function () {
	  var carousels = [].slice.call(document.querySelectorAll(Selector.DATA_RIDE));
	  for (var i = 0, len = carousels.length; i < len; i++) {
	    var $carousel = (0, _jquery2.default)(carousels[i]);
	    Carousel._jQueryInterface.call($carousel, $carousel.data());
	  }
	});

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Carousel._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Carousel;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Carousel._jQueryInterface;
	};

	exports.default = Carousel;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): collapse.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'collapse';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.collapse';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];

	var Default = {
	  toggle: true,
	  parent: ''
	};

	var DefaultType = {
	  toggle: 'boolean',
	  parent: '(string|element)'
	};

	var Event = {
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  SHOW: 'show',
	  COLLAPSE: 'collapse',
	  COLLAPSING: 'collapsing',
	  COLLAPSED: 'collapsed'
	};

	var Dimension = {
	  WIDTH: 'width',
	  HEIGHT: 'height'
	};

	var Selector = {
	  ACTIVES: '.show, .collapsing',
	  DATA_TOGGLE: '[data-toggle="collapse"]'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var Collapse = function () {
	  function Collapse(element, config) {
	    _classCallCheck(this, Collapse);

	    this._isTransitioning = false;
	    this._element = element;
	    this._config = this._getConfig(config);
	    this._triggerArray = [].slice.call(document.querySelectorAll('[data-toggle="collapse"][href="#' + element.id + '"],' + ('[data-toggle="collapse"][data-target="#' + element.id + '"]')));

	    var toggleList = [].slice.call(document.querySelectorAll(Selector.DATA_TOGGLE));
	    for (var i = 0, len = toggleList.length; i < len; i++) {
	      var elem = toggleList[i];
	      var selector = _util2.default.getSelectorFromElement(elem);
	      var filterElement = [].slice.call(document.querySelectorAll(selector)).filter(function (foundElem) {
	        return foundElem === element;
	      });

	      if (selector !== null && filterElement.length > 0) {
	        this._selector = selector;
	        this._triggerArray.push(elem);
	      }
	    }

	    this._parent = this._config.parent ? this._getParent() : null;

	    if (!this._config.parent) {
	      this._addAriaAndCollapsedClass(this._element, this._triggerArray);
	    }

	    if (this._config.toggle) {
	      this.toggle();
	    }
	  }

	  // Getters

	  _createClass(Collapse, [{
	    key: 'toggle',


	    // Public

	    value: function toggle() {
	      if ((0, _jquery2.default)(this._element).hasClass(ClassName.SHOW)) {
	        this.hide();
	      } else {
	        this.show();
	      }
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this = this;

	      if (this._isTransitioning || (0, _jquery2.default)(this._element).hasClass(ClassName.SHOW)) {
	        return;
	      }

	      var actives = void 0;
	      var activesData = void 0;

	      if (this._parent) {
	        actives = [].slice.call(this._parent.querySelectorAll(Selector.ACTIVES)).filter(function (elem) {
	          if (typeof _this._config.parent === 'string') {
	            return elem.getAttribute('data-parent') === _this._config.parent;
	          }

	          return elem.classList.contains(ClassName.COLLAPSE);
	        });

	        if (actives.length === 0) {
	          actives = null;
	        }
	      }

	      if (actives) {
	        activesData = (0, _jquery2.default)(actives).not(this._selector).data(DATA_KEY);
	        if (activesData && activesData._isTransitioning) {
	          return;
	        }
	      }

	      var startEvent = _jquery2.default.Event(Event.SHOW);
	      (0, _jquery2.default)(this._element).trigger(startEvent);
	      if (startEvent.isDefaultPrevented()) {
	        return;
	      }

	      if (actives) {
	        Collapse._jQueryInterface.call((0, _jquery2.default)(actives).not(this._selector), 'hide');
	        if (!activesData) {
	          (0, _jquery2.default)(actives).data(DATA_KEY, null);
	        }
	      }

	      var dimension = this._getDimension();

	      (0, _jquery2.default)(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);

	      this._element.style[dimension] = 0;

	      if (this._triggerArray.length) {
	        (0, _jquery2.default)(this._triggerArray).removeClass(ClassName.COLLAPSED).attr('aria-expanded', true);
	      }

	      this.setTransitioning(true);

	      var complete = function complete() {
	        (0, _jquery2.default)(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);

	        _this._element.style[dimension] = '';

	        _this.setTransitioning(false);

	        (0, _jquery2.default)(_this._element).trigger(Event.SHOWN);
	      };

	      var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
	      var scrollSize = 'scroll' + capitalizedDimension;
	      var transitionDuration = _util2.default.getTransitionDurationFromElement(this._element);

	      (0, _jquery2.default)(this._element).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);

	      this._element.style[dimension] = this._element[scrollSize] + 'px';
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      var _this2 = this;

	      if (this._isTransitioning || !(0, _jquery2.default)(this._element).hasClass(ClassName.SHOW)) {
	        return;
	      }

	      var startEvent = _jquery2.default.Event(Event.HIDE);
	      (0, _jquery2.default)(this._element).trigger(startEvent);
	      if (startEvent.isDefaultPrevented()) {
	        return;
	      }

	      var dimension = this._getDimension();

	      this._element.style[dimension] = this._element.getBoundingClientRect()[dimension] + 'px';

	      _util2.default.reflow(this._element);

	      (0, _jquery2.default)(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);

	      var triggerArrayLength = this._triggerArray.length;
	      if (triggerArrayLength > 0) {
	        for (var i = 0; i < triggerArrayLength; i++) {
	          var trigger = this._triggerArray[i];
	          var selector = _util2.default.getSelectorFromElement(trigger);

	          if (selector !== null) {
	            var $elem = (0, _jquery2.default)([].slice.call(document.querySelectorAll(selector)));
	            if (!$elem.hasClass(ClassName.SHOW)) {
	              (0, _jquery2.default)(trigger).addClass(ClassName.COLLAPSED).attr('aria-expanded', false);
	            }
	          }
	        }
	      }

	      this.setTransitioning(true);

	      var complete = function complete() {
	        _this2.setTransitioning(false);
	        (0, _jquery2.default)(_this2._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
	      };

	      this._element.style[dimension] = '';
	      var transitionDuration = _util2.default.getTransitionDurationFromElement(this._element);

	      (0, _jquery2.default)(this._element).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	    }
	  }, {
	    key: 'setTransitioning',
	    value: function setTransitioning(isTransitioning) {
	      this._isTransitioning = isTransitioning;
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _jquery2.default.removeData(this._element, DATA_KEY);

	      this._config = null;
	      this._parent = null;
	      this._element = null;
	      this._triggerArray = null;
	      this._isTransitioning = null;
	    }

	    // Private

	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, config);
	      config.toggle = Boolean(config.toggle); // Coerce string values
	      _util2.default.typeCheckConfig(NAME, config, DefaultType);
	      return config;
	    }
	  }, {
	    key: '_getDimension',
	    value: function _getDimension() {
	      var hasWidth = (0, _jquery2.default)(this._element).hasClass(Dimension.WIDTH);
	      return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
	    }
	  }, {
	    key: '_getParent',
	    value: function _getParent() {
	      var _this3 = this;

	      var parent = void 0;

	      if (_util2.default.isElement(this._config.parent)) {
	        parent = this._config.parent;

	        // It's a jQuery object
	        if (typeof this._config.parent.jquery !== 'undefined') {
	          parent = this._config.parent[0];
	        }
	      } else {
	        parent = document.querySelector(this._config.parent);
	      }

	      var selector = '[data-toggle="collapse"][data-parent="' + this._config.parent + '"]';

	      var children = [].slice.call(parent.querySelectorAll(selector));
	      (0, _jquery2.default)(children).each(function (i, element) {
	        _this3._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [element]);
	      });

	      return parent;
	    }
	  }, {
	    key: '_addAriaAndCollapsedClass',
	    value: function _addAriaAndCollapsedClass(element, triggerArray) {
	      var isOpen = (0, _jquery2.default)(element).hasClass(ClassName.SHOW);

	      if (triggerArray.length) {
	        (0, _jquery2.default)(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr('aria-expanded', isOpen);
	      }
	    }

	    // Static

	  }], [{
	    key: '_getTargetFromElement',
	    value: function _getTargetFromElement(element) {
	      var selector = _util2.default.getSelectorFromElement(element);
	      return selector ? document.querySelector(selector) : null;
	    }
	  }, {
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var data = $this.data(DATA_KEY);
	        var _config = _extends({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

	        if (!data && _config.toggle && /show|hide/.test(config)) {
	          _config.toggle = false;
	        }

	        if (!data) {
	          data = new Collapse(this, _config);
	          $this.data(DATA_KEY, data);
	        }

	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);

	  return Collapse;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
	  if (event.currentTarget.tagName === 'A') {
	    event.preventDefault();
	  }

	  var $trigger = (0, _jquery2.default)(this);
	  var selector = _util2.default.getSelectorFromElement(this);
	  var selectors = [].slice.call(document.querySelectorAll(selector));

	  (0, _jquery2.default)(selectors).each(function () {
	    var $target = (0, _jquery2.default)(this);
	    var data = $target.data(DATA_KEY);
	    var config = data ? 'toggle' : $trigger.data();
	    Collapse._jQueryInterface.call($target, config);
	  });
	});

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Collapse._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Collapse;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Collapse._jQueryInterface;
	};

	exports.default = Collapse;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): dropdown.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _popper = __webpack_require__(156);

	var _popper2 = _interopRequireDefault(_popper);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'dropdown';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.dropdown';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];
	var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key
	var SPACE_KEYCODE = 32; // KeyboardEvent.which value for space key
	var TAB_KEYCODE = 9; // KeyboardEvent.which value for tab key
	var ARROW_UP_KEYCODE = 38; // KeyboardEvent.which value for up arrow key
	var ARROW_DOWN_KEYCODE = 40; // KeyboardEvent.which value for down arrow key
	var RIGHT_MOUSE_BUTTON_WHICH = 3; // MouseEvent.which value for the right button (assuming a right-handed mouse)
	var REGEXP_KEYDOWN = new RegExp(ARROW_UP_KEYCODE + '|' + ARROW_DOWN_KEYCODE + '|' + ESCAPE_KEYCODE);

	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  CLICK: 'click' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY,
	  KEYDOWN_DATA_API: 'keydown' + EVENT_KEY + DATA_API_KEY,
	  KEYUP_DATA_API: 'keyup' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  DISABLED: 'disabled',
	  SHOW: 'show',
	  DROPUP: 'dropup',
	  DROPRIGHT: 'dropright',
	  DROPLEFT: 'dropleft',
	  MENURIGHT: 'dropdown-menu-right',
	  MENULEFT: 'dropdown-menu-left',
	  POSITION_STATIC: 'position-static'
	};

	var Selector = {
	  DATA_TOGGLE: '[data-toggle="dropdown"]',
	  FORM_CHILD: '.dropdown form',
	  MENU: '.dropdown-menu',
	  NAVBAR_NAV: '.navbar-nav',
	  VISIBLE_ITEMS: '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)'
	};

	var AttachmentMap = {
	  TOP: 'top-start',
	  TOPEND: 'top-end',
	  BOTTOM: 'bottom-start',
	  BOTTOMEND: 'bottom-end',
	  RIGHT: 'right-start',
	  RIGHTEND: 'right-end',
	  LEFT: 'left-start',
	  LEFTEND: 'left-end'
	};

	var Default = {
	  offset: 0,
	  flip: true,
	  boundary: 'scrollParent',
	  reference: 'toggle',
	  display: 'dynamic'
	};

	var DefaultType = {
	  offset: '(number|string|function)',
	  flip: 'boolean',
	  boundary: '(string|element)',
	  reference: '(string|element)',
	  display: 'string'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var Dropdown = function () {
	  function Dropdown(element, config) {
	    _classCallCheck(this, Dropdown);

	    this._element = element;
	    this._popper = null;
	    this._config = this._getConfig(config);
	    this._menu = this._getMenuElement();
	    this._inNavbar = this._detectNavbar();

	    this._addEventListeners();
	  }

	  // Getters

	  _createClass(Dropdown, [{
	    key: 'toggle',


	    // Public

	    value: function toggle() {
	      if (this._element.disabled || (0, _jquery2.default)(this._element).hasClass(ClassName.DISABLED)) {
	        return;
	      }

	      var parent = Dropdown._getParentFromElement(this._element);
	      var isActive = (0, _jquery2.default)(this._menu).hasClass(ClassName.SHOW);

	      Dropdown._clearMenus();

	      if (isActive) {
	        return;
	      }

	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var showEvent = _jquery2.default.Event(Event.SHOW, relatedTarget);

	      (0, _jquery2.default)(parent).trigger(showEvent);

	      if (showEvent.isDefaultPrevented()) {
	        return;
	      }

	      // Disable totally Popper.js for Dropdown in Navbar
	      if (!this._inNavbar) {
	        /**
	         * Check for Popper dependency
	         * Popper - https://popper.js.org
	         */
	        if (typeof _popper2.default === 'undefined') {
	          throw new TypeError('Bootstrap\'s dropdowns require Popper.js (https://popper.js.org/)');
	        }

	        var referenceElement = this._element;

	        if (this._config.reference === 'parent') {
	          referenceElement = parent;
	        } else if (_util2.default.isElement(this._config.reference)) {
	          referenceElement = this._config.reference;

	          // Check if it's jQuery element
	          if (typeof this._config.reference.jquery !== 'undefined') {
	            referenceElement = this._config.reference[0];
	          }
	        }

	        // If boundary is not `scrollParent`, then set position to `static`
	        // to allow the menu to "escape" the scroll parent's boundaries
	        // https://github.com/twbs/bootstrap/issues/24251
	        if (this._config.boundary !== 'scrollParent') {
	          (0, _jquery2.default)(parent).addClass(ClassName.POSITION_STATIC);
	        }
	        this._popper = new _popper2.default(referenceElement, this._menu, this._getPopperConfig());
	      }

	      // If this is a touch-enabled device we add extra
	      // empty mouseover listeners to the body's immediate children;
	      // only needed because of broken event delegation on iOS
	      // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	      if ('ontouchstart' in document.documentElement && (0, _jquery2.default)(parent).closest(Selector.NAVBAR_NAV).length === 0) {
	        (0, _jquery2.default)(document.body).children().on('mouseover', null, _jquery2.default.noop);
	      }

	      this._element.focus();
	      this._element.setAttribute('aria-expanded', true);

	      (0, _jquery2.default)(this._menu).toggleClass(ClassName.SHOW);
	      (0, _jquery2.default)(parent).toggleClass(ClassName.SHOW).trigger(_jquery2.default.Event(Event.SHOWN, relatedTarget));
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      if (this._element.disabled || (0, _jquery2.default)(this._element).hasClass(ClassName.DISABLED) || (0, _jquery2.default)(this._menu).hasClass(ClassName.SHOW)) {
	        return;
	      }

	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var showEvent = _jquery2.default.Event(Event.SHOW, relatedTarget);
	      var parent = Dropdown._getParentFromElement(this._element);

	      (0, _jquery2.default)(parent).trigger(showEvent);

	      if (showEvent.isDefaultPrevented()) {
	        return;
	      }

	      (0, _jquery2.default)(this._menu).toggleClass(ClassName.SHOW);
	      (0, _jquery2.default)(parent).toggleClass(ClassName.SHOW).trigger(_jquery2.default.Event(Event.SHOWN, relatedTarget));
	    }
	  }, {
	    key: 'hide',
	    value: function hide() {
	      if (this._element.disabled || (0, _jquery2.default)(this._element).hasClass(ClassName.DISABLED) || !(0, _jquery2.default)(this._menu).hasClass(ClassName.SHOW)) {
	        return;
	      }

	      var relatedTarget = {
	        relatedTarget: this._element
	      };
	      var hideEvent = _jquery2.default.Event(Event.HIDE, relatedTarget);
	      var parent = Dropdown._getParentFromElement(this._element);

	      (0, _jquery2.default)(parent).trigger(hideEvent);

	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }

	      (0, _jquery2.default)(this._menu).toggleClass(ClassName.SHOW);
	      (0, _jquery2.default)(parent).toggleClass(ClassName.SHOW).trigger(_jquery2.default.Event(Event.HIDDEN, relatedTarget));
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _jquery2.default.removeData(this._element, DATA_KEY);
	      (0, _jquery2.default)(this._element).off(EVENT_KEY);
	      this._element = null;
	      this._menu = null;
	      if (this._popper !== null) {
	        this._popper.destroy();
	        this._popper = null;
	      }
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      this._inNavbar = this._detectNavbar();
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    }

	    // Private

	  }, {
	    key: '_addEventListeners',
	    value: function _addEventListeners() {
	      var _this = this;

	      (0, _jquery2.default)(this._element).on(Event.CLICK, function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	        _this.toggle();
	      });
	    }
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, this.constructor.Default, (0, _jquery2.default)(this._element).data(), config);

	      _util2.default.typeCheckConfig(NAME, config, this.constructor.DefaultType);

	      return config;
	    }
	  }, {
	    key: '_getMenuElement',
	    value: function _getMenuElement() {
	      if (!this._menu) {
	        var parent = Dropdown._getParentFromElement(this._element);

	        if (parent) {
	          this._menu = parent.querySelector(Selector.MENU);
	        }
	      }
	      return this._menu;
	    }
	  }, {
	    key: '_getPlacement',
	    value: function _getPlacement() {
	      var $parentDropdown = (0, _jquery2.default)(this._element.parentNode);
	      var placement = AttachmentMap.BOTTOM;

	      // Handle dropup
	      if ($parentDropdown.hasClass(ClassName.DROPUP)) {
	        placement = AttachmentMap.TOP;
	        if ((0, _jquery2.default)(this._menu).hasClass(ClassName.MENURIGHT)) {
	          placement = AttachmentMap.TOPEND;
	        }
	      } else if ($parentDropdown.hasClass(ClassName.DROPRIGHT)) {
	        placement = AttachmentMap.RIGHT;
	      } else if ($parentDropdown.hasClass(ClassName.DROPLEFT)) {
	        placement = AttachmentMap.LEFT;
	      } else if ((0, _jquery2.default)(this._menu).hasClass(ClassName.MENURIGHT)) {
	        placement = AttachmentMap.BOTTOMEND;
	      }
	      return placement;
	    }
	  }, {
	    key: '_detectNavbar',
	    value: function _detectNavbar() {
	      return (0, _jquery2.default)(this._element).closest('.navbar').length > 0;
	    }
	  }, {
	    key: '_getOffset',
	    value: function _getOffset() {
	      var _this2 = this;

	      var offset = {};

	      if (typeof this._config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this2._config.offset(data.offsets, _this2._element) || {});

	          return data;
	        };
	      } else {
	        offset.offset = this._config.offset;
	      }

	      return offset;
	    }
	  }, {
	    key: '_getPopperConfig',
	    value: function _getPopperConfig() {
	      var popperConfig = {
	        placement: this._getPlacement(),
	        modifiers: {
	          offset: this._getOffset(),
	          flip: {
	            enabled: this._config.flip
	          },
	          preventOverflow: {
	            boundariesElement: this._config.boundary
	          }
	        }

	        // Disable Popper.js if we have a static display
	      };if (this._config.display === 'static') {
	        popperConfig.modifiers.applyStyle = {
	          enabled: false
	        };
	      }

	      return popperConfig;
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = (0, _jquery2.default)(this).data(DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' ? config : null;

	        if (!data) {
	          data = new Dropdown(this, _config);
	          (0, _jquery2.default)(this).data(DATA_KEY, data);
	        }

	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: '_clearMenus',
	    value: function _clearMenus(event) {
	      if (event && (event.which === RIGHT_MOUSE_BUTTON_WHICH || event.type === 'keyup' && event.which !== TAB_KEYCODE)) {
	        return;
	      }

	      var toggles = [].slice.call(document.querySelectorAll(Selector.DATA_TOGGLE));

	      for (var i = 0, len = toggles.length; i < len; i++) {
	        var parent = Dropdown._getParentFromElement(toggles[i]);
	        var context = (0, _jquery2.default)(toggles[i]).data(DATA_KEY);
	        var relatedTarget = {
	          relatedTarget: toggles[i]
	        };

	        if (event && event.type === 'click') {
	          relatedTarget.clickEvent = event;
	        }

	        if (!context) {
	          continue;
	        }

	        var dropdownMenu = context._menu;
	        if (!(0, _jquery2.default)(parent).hasClass(ClassName.SHOW)) {
	          continue;
	        }

	        if (event && (event.type === 'click' && /input|textarea/i.test(event.target.tagName) || event.type === 'keyup' && event.which === TAB_KEYCODE) && _jquery2.default.contains(parent, event.target)) {
	          continue;
	        }

	        var hideEvent = _jquery2.default.Event(Event.HIDE, relatedTarget);
	        (0, _jquery2.default)(parent).trigger(hideEvent);
	        if (hideEvent.isDefaultPrevented()) {
	          continue;
	        }

	        // If this is a touch-enabled device we remove the extra
	        // empty mouseover listeners we added for iOS support
	        if ('ontouchstart' in document.documentElement) {
	          (0, _jquery2.default)(document.body).children().off('mouseover', null, _jquery2.default.noop);
	        }

	        toggles[i].setAttribute('aria-expanded', 'false');

	        (0, _jquery2.default)(dropdownMenu).removeClass(ClassName.SHOW);
	        (0, _jquery2.default)(parent).removeClass(ClassName.SHOW).trigger(_jquery2.default.Event(Event.HIDDEN, relatedTarget));
	      }
	    }
	  }, {
	    key: '_getParentFromElement',
	    value: function _getParentFromElement(element) {
	      var parent = void 0;
	      var selector = _util2.default.getSelectorFromElement(element);

	      if (selector) {
	        parent = document.querySelector(selector);
	      }

	      return parent || element.parentNode;
	    }

	    // eslint-disable-next-line complexity

	  }, {
	    key: '_dataApiKeydownHandler',
	    value: function _dataApiKeydownHandler(event) {
	      // If not input/textarea:
	      //  - And not a key in REGEXP_KEYDOWN => not a dropdown command
	      // If input/textarea:
	      //  - If space key => not a dropdown command
	      //  - If key is other than escape
	      //    - If key is not up or down => not a dropdown command
	      //    - If trigger inside the menu => not a dropdown command
	      if (/input|textarea/i.test(event.target.tagName) ? event.which === SPACE_KEYCODE || event.which !== ESCAPE_KEYCODE && (event.which !== ARROW_DOWN_KEYCODE && event.which !== ARROW_UP_KEYCODE || (0, _jquery2.default)(event.target).closest(Selector.MENU).length) : !REGEXP_KEYDOWN.test(event.which)) {
	        return;
	      }

	      event.preventDefault();
	      event.stopPropagation();

	      if (this.disabled || (0, _jquery2.default)(this).hasClass(ClassName.DISABLED)) {
	        return;
	      }

	      var parent = Dropdown._getParentFromElement(this);
	      var isActive = (0, _jquery2.default)(parent).hasClass(ClassName.SHOW);

	      if (!isActive || isActive && (event.which === ESCAPE_KEYCODE || event.which === SPACE_KEYCODE)) {
	        if (event.which === ESCAPE_KEYCODE) {
	          var toggle = parent.querySelector(Selector.DATA_TOGGLE);
	          (0, _jquery2.default)(toggle).trigger('focus');
	        }

	        (0, _jquery2.default)(this).trigger('click');
	        return;
	      }

	      var items = [].slice.call(parent.querySelectorAll(Selector.VISIBLE_ITEMS));

	      if (items.length === 0) {
	        return;
	      }

	      var index = items.indexOf(event.target);

	      if (event.which === ARROW_UP_KEYCODE && index > 0) {
	        // Up
	        index--;
	      }

	      if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) {
	        // Down
	        index++;
	      }

	      if (index < 0) {
	        index = 0;
	      }

	      items[index].focus();
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }, {
	    key: 'DefaultType',
	    get: function get() {
	      return DefaultType;
	    }
	  }]);

	  return Dropdown;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.MENU, Dropdown._dataApiKeydownHandler).on(Event.CLICK_DATA_API + ' ' + Event.KEYUP_DATA_API, Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  event.preventDefault();
	  event.stopPropagation();
	  Dropdown._jQueryInterface.call((0, _jquery2.default)(this), 'toggle');
	}).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function (e) {
	  e.stopPropagation();
	});

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Dropdown._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Dropdown;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Dropdown._jQueryInterface;
	};

	exports.default = Dropdown;

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
	  ( false ? 'undefined' : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() :  true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) : global.Popper = factory();
	})(undefined, function () {
	  'use strict';

	  var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

	  var timeoutDuration = function () {
	    var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	    for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	      if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	        return 1;
	      }
	    }
	    return 0;
	  }();

	  function microtaskDebounce(fn) {
	    var called = false;
	    return function () {
	      if (called) {
	        return;
	      }
	      called = true;
	      window.Promise.resolve().then(function () {
	        called = false;
	        fn();
	      });
	    };
	  }

	  function taskDebounce(fn) {
	    var scheduled = false;
	    return function () {
	      if (!scheduled) {
	        scheduled = true;
	        setTimeout(function () {
	          scheduled = false;
	          fn();
	        }, timeoutDuration);
	      }
	    };
	  }

	  var supportsMicroTasks = isBrowser && window.Promise;

	  /**
	  * Create a debounced version of a method, that's asynchronously deferred
	  * but called in the minimum time possible.
	  *
	  * @method
	  * @memberof Popper.Utils
	  * @argument {Function} fn
	  * @returns {Function}
	  */
	  var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

	  /**
	   * Check if the given variable is a function
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Any} functionToCheck - variable to check
	   * @returns {Boolean} answer to: is a function?
	   */
	  function isFunction(functionToCheck) {
	    var getType = {};
	    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	  }

	  /**
	   * Get CSS computed property of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Eement} element
	   * @argument {String} property
	   */
	  function getStyleComputedProperty(element, property) {
	    if (element.nodeType !== 1) {
	      return [];
	    }
	    // NOTE: 1 DOM access here
	    var window = element.ownerDocument.defaultView;
	    var css = window.getComputedStyle(element, null);
	    return property ? css[property] : css;
	  }

	  /**
	   * Returns the parentNode or the host of the element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} parent
	   */
	  function getParentNode(element) {
	    if (element.nodeName === 'HTML') {
	      return element;
	    }
	    return element.parentNode || element.host;
	  }

	  /**
	   * Returns the scrolling parent of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} scroll parent
	   */
	  function getScrollParent(element) {
	    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	    if (!element) {
	      return document.body;
	    }

	    switch (element.nodeName) {
	      case 'HTML':
	      case 'BODY':
	        return element.ownerDocument.body;
	      case '#document':
	        return element.body;
	    }

	    // Firefox want us to check `-x` and `-y` variations as well

	    var _getStyleComputedProp = getStyleComputedProperty(element),
	        overflow = _getStyleComputedProp.overflow,
	        overflowX = _getStyleComputedProp.overflowX,
	        overflowY = _getStyleComputedProp.overflowY;

	    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	      return element;
	    }

	    return getScrollParent(getParentNode(element));
	  }

	  /**
	   * Returns the reference node of the reference object, or the reference object itself.
	   * @method
	   * @memberof Popper.Utils
	   * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	   * @returns {Element} parent
	   */
	  function getReferenceNode(reference) {
	    return reference && reference.referenceNode ? reference.referenceNode : reference;
	  }

	  var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	  var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

	  /**
	   * Determines if the browser is Internet Explorer
	   * @method
	   * @memberof Popper.Utils
	   * @param {Number} version to check
	   * @returns {Boolean} isIE
	   */
	  function isIE(version) {
	    if (version === 11) {
	      return isIE11;
	    }
	    if (version === 10) {
	      return isIE10;
	    }
	    return isIE11 || isIE10;
	  }

	  /**
	   * Returns the offset parent of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} offset parent
	   */
	  function getOffsetParent(element) {
	    if (!element) {
	      return document.documentElement;
	    }

	    var noOffsetParent = isIE(10) ? document.body : null;

	    // NOTE: 1 DOM access here
	    var offsetParent = element.offsetParent || null;
	    // Skip hidden elements which don't have an offsetParent
	    while (offsetParent === noOffsetParent && element.nextElementSibling) {
	      offsetParent = (element = element.nextElementSibling).offsetParent;
	    }

	    var nodeName = offsetParent && offsetParent.nodeName;

	    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	      return element ? element.ownerDocument.documentElement : document.documentElement;
	    }

	    // .offsetParent will return the closest TH, TD or TABLE in case
	    // no offsetParent is present, I hate this job...
	    if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	      return getOffsetParent(offsetParent);
	    }

	    return offsetParent;
	  }

	  function isOffsetContainer(element) {
	    var nodeName = element.nodeName;

	    if (nodeName === 'BODY') {
	      return false;
	    }
	    return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	  }

	  /**
	   * Finds the root node (document, shadowDOM root) of the given element
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} node
	   * @returns {Element} root node
	   */
	  function getRoot(node) {
	    if (node.parentNode !== null) {
	      return getRoot(node.parentNode);
	    }

	    return node;
	  }

	  /**
	   * Finds the offset parent common to the two provided nodes
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element1
	   * @argument {Element} element2
	   * @returns {Element} common offset parent
	   */
	  function findCommonOffsetParent(element1, element2) {
	    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	      return document.documentElement;
	    }

	    // Here we make sure to give as "start" the element that comes first in the DOM
	    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	    var start = order ? element1 : element2;
	    var end = order ? element2 : element1;

	    // Get common ancestor container
	    var range = document.createRange();
	    range.setStart(start, 0);
	    range.setEnd(end, 0);
	    var commonAncestorContainer = range.commonAncestorContainer;

	    // Both nodes are inside #document

	    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	      if (isOffsetContainer(commonAncestorContainer)) {
	        return commonAncestorContainer;
	      }

	      return getOffsetParent(commonAncestorContainer);
	    }

	    // one of the nodes is inside shadowDOM, find which one
	    var element1root = getRoot(element1);
	    if (element1root.host) {
	      return findCommonOffsetParent(element1root.host, element2);
	    } else {
	      return findCommonOffsetParent(element1, getRoot(element2).host);
	    }
	  }

	  /**
	   * Gets the scroll value of the given element in the given side (top and left)
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @argument {String} side `top` or `left`
	   * @returns {number} amount of scrolled pixels
	   */
	  function getScroll(element) {
	    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

	    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	    var nodeName = element.nodeName;

	    if (nodeName === 'BODY' || nodeName === 'HTML') {
	      var html = element.ownerDocument.documentElement;
	      var scrollingElement = element.ownerDocument.scrollingElement || html;
	      return scrollingElement[upperSide];
	    }

	    return element[upperSide];
	  }

	  /*
	   * Sum or subtract the element scroll values (left and top) from a given rect object
	   * @method
	   * @memberof Popper.Utils
	   * @param {Object} rect - Rect object you want to change
	   * @param {HTMLElement} element - The element from the function reads the scroll values
	   * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	   * @return {Object} rect - The modifier rect object
	   */
	  function includeScroll(rect, element) {
	    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	    var scrollTop = getScroll(element, 'top');
	    var scrollLeft = getScroll(element, 'left');
	    var modifier = subtract ? -1 : 1;
	    rect.top += scrollTop * modifier;
	    rect.bottom += scrollTop * modifier;
	    rect.left += scrollLeft * modifier;
	    rect.right += scrollLeft * modifier;
	    return rect;
	  }

	  /*
	   * Helper to detect borders of a given element
	   * @method
	   * @memberof Popper.Utils
	   * @param {CSSStyleDeclaration} styles
	   * Result of `getStyleComputedProperty` on the given element
	   * @param {String} axis - `x` or `y`
	   * @return {number} borders - The borders size of the given axis
	   */

	  function getBordersSize(styles, axis) {
	    var sideA = axis === 'x' ? 'Left' : 'Top';
	    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

	    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	  }

	  function getSize(axis, body, html, computedStyle) {
	    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	  }

	  function getWindowSizes(document) {
	    var body = document.body;
	    var html = document.documentElement;
	    var computedStyle = isIE(10) && getComputedStyle(html);

	    return {
	      height: getSize('Height', body, html, computedStyle),
	      width: getSize('Width', body, html, computedStyle)
	    };
	  }

	  var classCallCheck = function classCallCheck(instance, Constructor) {
	    if (!(instance instanceof Constructor)) {
	      throw new TypeError("Cannot call a class as a function");
	    }
	  };

	  var createClass = function () {
	    function defineProperties(target, props) {
	      for (var i = 0; i < props.length; i++) {
	        var descriptor = props[i];
	        descriptor.enumerable = descriptor.enumerable || false;
	        descriptor.configurable = true;
	        if ("value" in descriptor) descriptor.writable = true;
	        Object.defineProperty(target, descriptor.key, descriptor);
	      }
	    }

	    return function (Constructor, protoProps, staticProps) {
	      if (protoProps) defineProperties(Constructor.prototype, protoProps);
	      if (staticProps) defineProperties(Constructor, staticProps);
	      return Constructor;
	    };
	  }();

	  var defineProperty = function defineProperty(obj, key, value) {
	    if (key in obj) {
	      Object.defineProperty(obj, key, {
	        value: value,
	        enumerable: true,
	        configurable: true,
	        writable: true
	      });
	    } else {
	      obj[key] = value;
	    }

	    return obj;
	  };

	  var _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];

	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }

	    return target;
	  };

	  /**
	   * Given element offsets, generate an output similar to getBoundingClientRect
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Object} offsets
	   * @returns {Object} ClientRect like output
	   */
	  function getClientRect(offsets) {
	    return _extends({}, offsets, {
	      right: offsets.left + offsets.width,
	      bottom: offsets.top + offsets.height
	    });
	  }

	  /**
	   * Get bounding client rect of given element
	   * @method
	   * @memberof Popper.Utils
	   * @param {HTMLElement} element
	   * @return {Object} client rect
	   */
	  function getBoundingClientRect(element) {
	    var rect = {};

	    // IE10 10 FIX: Please, don't ask, the element isn't
	    // considered in DOM in some circumstances...
	    // This isn't reproducible in IE10 compatibility mode of IE11
	    try {
	      if (isIE(10)) {
	        rect = element.getBoundingClientRect();
	        var scrollTop = getScroll(element, 'top');
	        var scrollLeft = getScroll(element, 'left');
	        rect.top += scrollTop;
	        rect.left += scrollLeft;
	        rect.bottom += scrollTop;
	        rect.right += scrollLeft;
	      } else {
	        rect = element.getBoundingClientRect();
	      }
	    } catch (e) {}

	    var result = {
	      left: rect.left,
	      top: rect.top,
	      width: rect.right - rect.left,
	      height: rect.bottom - rect.top
	    };

	    // subtract scrollbar size from sizes
	    var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	    var width = sizes.width || element.clientWidth || result.width;
	    var height = sizes.height || element.clientHeight || result.height;

	    var horizScrollbar = element.offsetWidth - width;
	    var vertScrollbar = element.offsetHeight - height;

	    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	    // we make this check conditional for performance reasons
	    if (horizScrollbar || vertScrollbar) {
	      var styles = getStyleComputedProperty(element);
	      horizScrollbar -= getBordersSize(styles, 'x');
	      vertScrollbar -= getBordersSize(styles, 'y');

	      result.width -= horizScrollbar;
	      result.height -= vertScrollbar;
	    }

	    return getClientRect(result);
	  }

	  function getOffsetRectRelativeToArbitraryNode(children, parent) {
	    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	    var isIE10 = isIE(10);
	    var isHTML = parent.nodeName === 'HTML';
	    var childrenRect = getBoundingClientRect(children);
	    var parentRect = getBoundingClientRect(parent);
	    var scrollParent = getScrollParent(children);

	    var styles = getStyleComputedProperty(parent);
	    var borderTopWidth = parseFloat(styles.borderTopWidth);
	    var borderLeftWidth = parseFloat(styles.borderLeftWidth);

	    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	    if (fixedPosition && isHTML) {
	      parentRect.top = Math.max(parentRect.top, 0);
	      parentRect.left = Math.max(parentRect.left, 0);
	    }
	    var offsets = getClientRect({
	      top: childrenRect.top - parentRect.top - borderTopWidth,
	      left: childrenRect.left - parentRect.left - borderLeftWidth,
	      width: childrenRect.width,
	      height: childrenRect.height
	    });
	    offsets.marginTop = 0;
	    offsets.marginLeft = 0;

	    // Subtract margins of documentElement in case it's being used as parent
	    // we do this only on HTML because it's the only element that behaves
	    // differently when margins are applied to it. The margins are included in
	    // the box of the documentElement, in the other cases not.
	    if (!isIE10 && isHTML) {
	      var marginTop = parseFloat(styles.marginTop);
	      var marginLeft = parseFloat(styles.marginLeft);

	      offsets.top -= borderTopWidth - marginTop;
	      offsets.bottom -= borderTopWidth - marginTop;
	      offsets.left -= borderLeftWidth - marginLeft;
	      offsets.right -= borderLeftWidth - marginLeft;

	      // Attach marginTop and marginLeft because in some circumstances we may need them
	      offsets.marginTop = marginTop;
	      offsets.marginLeft = marginLeft;
	    }

	    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	      offsets = includeScroll(offsets, parent);
	    }

	    return offsets;
	  }

	  function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	    var html = element.ownerDocument.documentElement;
	    var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	    var width = Math.max(html.clientWidth, window.innerWidth || 0);
	    var height = Math.max(html.clientHeight, window.innerHeight || 0);

	    var scrollTop = !excludeScroll ? getScroll(html) : 0;
	    var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

	    var offset = {
	      top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	      left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	      width: width,
	      height: height
	    };

	    return getClientRect(offset);
	  }

	  /**
	   * Check if the given element is fixed or is inside a fixed parent
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @argument {Element} customContainer
	   * @returns {Boolean} answer to "isFixed?"
	   */
	  function isFixed(element) {
	    var nodeName = element.nodeName;
	    if (nodeName === 'BODY' || nodeName === 'HTML') {
	      return false;
	    }
	    if (getStyleComputedProperty(element, 'position') === 'fixed') {
	      return true;
	    }
	    var parentNode = getParentNode(element);
	    if (!parentNode) {
	      return false;
	    }
	    return isFixed(parentNode);
	  }

	  /**
	   * Finds the first parent of an element that has a transformed property defined
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Element} first transformed parent or documentElement
	   */

	  function getFixedPositionOffsetParent(element) {
	    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	    if (!element || !element.parentElement || isIE()) {
	      return document.documentElement;
	    }
	    var el = element.parentElement;
	    while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	      el = el.parentElement;
	    }
	    return el || document.documentElement;
	  }

	  /**
	   * Computed the boundaries limits and return them
	   * @method
	   * @memberof Popper.Utils
	   * @param {HTMLElement} popper
	   * @param {HTMLElement} reference
	   * @param {number} padding
	   * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	   * @param {Boolean} fixedPosition - Is in fixed position mode
	   * @returns {Object} Coordinates of the boundaries
	   */
	  function getBoundaries(popper, reference, padding, boundariesElement) {
	    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

	    // NOTE: 1 DOM access here

	    var boundaries = { top: 0, left: 0 };
	    var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

	    // Handle viewport case
	    if (boundariesElement === 'viewport') {
	      boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	    } else {
	      // Handle other cases based on DOM element used as boundaries
	      var boundariesNode = void 0;
	      if (boundariesElement === 'scrollParent') {
	        boundariesNode = getScrollParent(getParentNode(reference));
	        if (boundariesNode.nodeName === 'BODY') {
	          boundariesNode = popper.ownerDocument.documentElement;
	        }
	      } else if (boundariesElement === 'window') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      } else {
	        boundariesNode = boundariesElement;
	      }

	      var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

	      // In case of HTML, we need a different computation
	      if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	        var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	            height = _getWindowSizes.height,
	            width = _getWindowSizes.width;

	        boundaries.top += offsets.top - offsets.marginTop;
	        boundaries.bottom = height + offsets.top;
	        boundaries.left += offsets.left - offsets.marginLeft;
	        boundaries.right = width + offsets.left;
	      } else {
	        // for all the other DOM elements, this one is good
	        boundaries = offsets;
	      }
	    }

	    // Add paddings
	    padding = padding || 0;
	    var isPaddingNumber = typeof padding === 'number';
	    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

	    return boundaries;
	  }

	  function getArea(_ref) {
	    var width = _ref.width,
	        height = _ref.height;

	    return width * height;
	  }

	  /**
	   * Utility used to transform the `auto` placement to the placement with more
	   * available space.
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

	    if (placement.indexOf('auto') === -1) {
	      return placement;
	    }

	    var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

	    var rects = {
	      top: {
	        width: boundaries.width,
	        height: refRect.top - boundaries.top
	      },
	      right: {
	        width: boundaries.right - refRect.right,
	        height: boundaries.height
	      },
	      bottom: {
	        width: boundaries.width,
	        height: boundaries.bottom - refRect.bottom
	      },
	      left: {
	        width: refRect.left - boundaries.left,
	        height: boundaries.height
	      }
	    };

	    var sortedAreas = Object.keys(rects).map(function (key) {
	      return _extends({
	        key: key
	      }, rects[key], {
	        area: getArea(rects[key])
	      });
	    }).sort(function (a, b) {
	      return b.area - a.area;
	    });

	    var filteredAreas = sortedAreas.filter(function (_ref2) {
	      var width = _ref2.width,
	          height = _ref2.height;
	      return width >= popper.clientWidth && height >= popper.clientHeight;
	    });

	    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

	    var variation = placement.split('-')[1];

	    return computedPlacement + (variation ? '-' + variation : '');
	  }

	  /**
	   * Get offsets to the reference element
	   * @method
	   * @memberof Popper.Utils
	   * @param {Object} state
	   * @param {Element} popper - the popper element
	   * @param {Element} reference - the reference element (the popper will be relative to this)
	   * @param {Element} fixedPosition - is in fixed position mode
	   * @returns {Object} An object containing the offsets which will be applied to the popper
	   */
	  function getReferenceOffsets(state, popper, reference) {
	    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

	    var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	    return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	  }

	  /**
	   * Get the outer sizes of the given element (offset size + margins)
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element
	   * @returns {Object} object containing width and height properties
	   */
	  function getOuterSizes(element) {
	    var window = element.ownerDocument.defaultView;
	    var styles = window.getComputedStyle(element);
	    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	    var result = {
	      width: element.offsetWidth + y,
	      height: element.offsetHeight + x
	    };
	    return result;
	  }

	  /**
	   * Get the opposite placement of the given one
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} placement
	   * @returns {String} flipped placement
	   */
	  function getOppositePlacement(placement) {
	    var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	    return placement.replace(/left|right|bottom|top/g, function (matched) {
	      return hash[matched];
	    });
	  }

	  /**
	   * Get offsets to the popper
	   * @method
	   * @memberof Popper.Utils
	   * @param {Object} position - CSS position the Popper will get applied
	   * @param {HTMLElement} popper - the popper element
	   * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	   * @param {String} placement - one of the valid placement options
	   * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	   */
	  function getPopperOffsets(popper, referenceOffsets, placement) {
	    placement = placement.split('-')[0];

	    // Get popper node sizes
	    var popperRect = getOuterSizes(popper);

	    // Add position, width and height to our offsets object
	    var popperOffsets = {
	      width: popperRect.width,
	      height: popperRect.height
	    };

	    // depending by the popper placement we have to compute its offsets slightly differently
	    var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	    var mainSide = isHoriz ? 'top' : 'left';
	    var secondarySide = isHoriz ? 'left' : 'top';
	    var measurement = isHoriz ? 'height' : 'width';
	    var secondaryMeasurement = !isHoriz ? 'height' : 'width';

	    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	    if (placement === secondarySide) {
	      popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	    } else {
	      popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	    }

	    return popperOffsets;
	  }

	  /**
	   * Mimics the `find` method of Array
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Array} arr
	   * @argument prop
	   * @argument value
	   * @returns index or -1
	   */
	  function find(arr, check) {
	    // use native find if supported
	    if (Array.prototype.find) {
	      return arr.find(check);
	    }

	    // use `filter` to obtain the same behavior of `find`
	    return arr.filter(check)[0];
	  }

	  /**
	   * Return the index of the matching object
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Array} arr
	   * @argument prop
	   * @argument value
	   * @returns index or -1
	   */
	  function findIndex(arr, prop, value) {
	    // use native findIndex if supported
	    if (Array.prototype.findIndex) {
	      return arr.findIndex(function (cur) {
	        return cur[prop] === value;
	      });
	    }

	    // use `find` + `indexOf` if `findIndex` isn't supported
	    var match = find(arr, function (obj) {
	      return obj[prop] === value;
	    });
	    return arr.indexOf(match);
	  }

	  /**
	   * Loop trough the list of modifiers and run them in order,
	   * each of them will then edit the data object.
	   * @method
	   * @memberof Popper.Utils
	   * @param {dataObject} data
	   * @param {Array} modifiers
	   * @param {String} ends - Optional modifier name used as stopper
	   * @returns {dataObject}
	   */
	  function runModifiers(modifiers, data, ends) {
	    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

	    modifiersToRun.forEach(function (modifier) {
	      if (modifier['function']) {
	        // eslint-disable-line dot-notation
	        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	      }
	      var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	      if (modifier.enabled && isFunction(fn)) {
	        // Add properties to offsets to make them a complete clientRect object
	        // we do this before each modifier to make sure the previous one doesn't
	        // mess with these values
	        data.offsets.popper = getClientRect(data.offsets.popper);
	        data.offsets.reference = getClientRect(data.offsets.reference);

	        data = fn(data, modifier);
	      }
	    });

	    return data;
	  }

	  /**
	   * Updates the position of the popper, computing the new offsets and applying
	   * the new style.<br />
	   * Prefer `scheduleUpdate` over `update` because of performance reasons.
	   * @method
	   * @memberof Popper
	   */
	  function update() {
	    // if popper is destroyed, don't perform any further update
	    if (this.state.isDestroyed) {
	      return;
	    }

	    var data = {
	      instance: this,
	      styles: {},
	      arrowStyles: {},
	      attributes: {},
	      flipped: false,
	      offsets: {}
	    };

	    // compute reference element offsets
	    data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

	    // compute auto placement, store placement inside the data object,
	    // modifiers will be able to edit `placement` if needed
	    // and refer to originalPlacement to know the original value
	    data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

	    // store the computed placement inside `originalPlacement`
	    data.originalPlacement = data.placement;

	    data.positionFixed = this.options.positionFixed;

	    // compute the popper offsets
	    data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

	    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

	    // run the modifiers
	    data = runModifiers(this.modifiers, data);

	    // the first `update` will call `onCreate` callback
	    // the other ones will call `onUpdate` callback
	    if (!this.state.isCreated) {
	      this.state.isCreated = true;
	      this.options.onCreate(data);
	    } else {
	      this.options.onUpdate(data);
	    }
	  }

	  /**
	   * Helper used to know if the given modifier is enabled.
	   * @method
	   * @memberof Popper.Utils
	   * @returns {Boolean}
	   */
	  function isModifierEnabled(modifiers, modifierName) {
	    return modifiers.some(function (_ref) {
	      var name = _ref.name,
	          enabled = _ref.enabled;
	      return enabled && name === modifierName;
	    });
	  }

	  /**
	   * Get the prefixed supported property name
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} property (camelCase)
	   * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	   */
	  function getSupportedPropertyName(property) {
	    var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

	    for (var i = 0; i < prefixes.length; i++) {
	      var prefix = prefixes[i];
	      var toCheck = prefix ? '' + prefix + upperProp : property;
	      if (typeof document.body.style[toCheck] !== 'undefined') {
	        return toCheck;
	      }
	    }
	    return null;
	  }

	  /**
	   * Destroys the popper.
	   * @method
	   * @memberof Popper
	   */
	  function destroy() {
	    this.state.isDestroyed = true;

	    // touch DOM only if `applyStyle` modifier is enabled
	    if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	      this.popper.removeAttribute('x-placement');
	      this.popper.style.position = '';
	      this.popper.style.top = '';
	      this.popper.style.left = '';
	      this.popper.style.right = '';
	      this.popper.style.bottom = '';
	      this.popper.style.willChange = '';
	      this.popper.style[getSupportedPropertyName('transform')] = '';
	    }

	    this.disableEventListeners();

	    // remove the popper if user explicitly asked for the deletion on destroy
	    // do not use `remove` because IE11 doesn't support it
	    if (this.options.removeOnDestroy) {
	      this.popper.parentNode.removeChild(this.popper);
	    }
	    return this;
	  }

	  /**
	   * Get the window associated with the element
	   * @argument {Element} element
	   * @returns {Window}
	   */
	  function getWindow(element) {
	    var ownerDocument = element.ownerDocument;
	    return ownerDocument ? ownerDocument.defaultView : window;
	  }

	  function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	    var isBody = scrollParent.nodeName === 'BODY';
	    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	    target.addEventListener(event, callback, { passive: true });

	    if (!isBody) {
	      attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	    }
	    scrollParents.push(target);
	  }

	  /**
	   * Setup needed event listeners used to update the popper position
	   * @method
	   * @memberof Popper.Utils
	   * @private
	   */
	  function setupEventListeners(reference, options, state, updateBound) {
	    // Resize event listener on window
	    state.updateBound = updateBound;
	    getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

	    // Scroll event listener on scroll parents
	    var scrollElement = getScrollParent(reference);
	    attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	    state.scrollElement = scrollElement;
	    state.eventsEnabled = true;

	    return state;
	  }

	  /**
	   * It will add resize/scroll events and start recalculating
	   * position of the popper element when they are triggered.
	   * @method
	   * @memberof Popper
	   */
	  function enableEventListeners() {
	    if (!this.state.eventsEnabled) {
	      this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	    }
	  }

	  /**
	   * Remove event listeners used to update the popper position
	   * @method
	   * @memberof Popper.Utils
	   * @private
	   */
	  function removeEventListeners(reference, state) {
	    // Remove resize event listener on window
	    getWindow(reference).removeEventListener('resize', state.updateBound);

	    // Remove scroll event listener on scroll parents
	    state.scrollParents.forEach(function (target) {
	      target.removeEventListener('scroll', state.updateBound);
	    });

	    // Reset state
	    state.updateBound = null;
	    state.scrollParents = [];
	    state.scrollElement = null;
	    state.eventsEnabled = false;
	    return state;
	  }

	  /**
	   * It will remove resize/scroll events and won't recalculate popper position
	   * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	   * unless you call `update` method manually.
	   * @method
	   * @memberof Popper
	   */
	  function disableEventListeners() {
	    if (this.state.eventsEnabled) {
	      cancelAnimationFrame(this.scheduleUpdate);
	      this.state = removeEventListeners(this.reference, this.state);
	    }
	  }

	  /**
	   * Tells if a given input is a number
	   * @method
	   * @memberof Popper.Utils
	   * @param {*} input to check
	   * @return {Boolean}
	   */
	  function isNumeric(n) {
	    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	  }

	  /**
	   * Set the style to the given popper
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element - Element to apply the style to
	   * @argument {Object} styles
	   * Object with a list of properties and values which will be applied to the element
	   */
	  function setStyles(element, styles) {
	    Object.keys(styles).forEach(function (prop) {
	      var unit = '';
	      // add unit if the value is numeric and is one of the following
	      if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	        unit = 'px';
	      }
	      element.style[prop] = styles[prop] + unit;
	    });
	  }

	  /**
	   * Set the attributes to the given popper
	   * @method
	   * @memberof Popper.Utils
	   * @argument {Element} element - Element to apply the attributes to
	   * @argument {Object} styles
	   * Object with a list of properties and values which will be applied to the element
	   */
	  function setAttributes(element, attributes) {
	    Object.keys(attributes).forEach(function (prop) {
	      var value = attributes[prop];
	      if (value !== false) {
	        element.setAttribute(prop, attributes[prop]);
	      } else {
	        element.removeAttribute(prop);
	      }
	    });
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} data.styles - List of style properties - values to apply to popper element
	   * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The same data object
	   */
	  function applyStyle(data) {
	    // any property present in `data.styles` will be applied to the popper,
	    // in this way we can make the 3rd party modifiers add custom styles to it
	    // Be aware, modifiers could override the properties defined in the previous
	    // lines of this modifier!
	    setStyles(data.instance.popper, data.styles);

	    // any property present in `data.attributes` will be applied to the popper,
	    // they will be set as HTML attributes of the element
	    setAttributes(data.instance.popper, data.attributes);

	    // if arrowElement is defined and arrowStyles has some properties
	    if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	      setStyles(data.arrowElement, data.arrowStyles);
	    }

	    return data;
	  }

	  /**
	   * Set the x-placement attribute before everything else because it could be used
	   * to add margins to the popper margins needs to be calculated to get the
	   * correct popper offsets.
	   * @method
	   * @memberof Popper.modifiers
	   * @param {HTMLElement} reference - The reference element used to position the popper
	   * @param {HTMLElement} popper - The HTML element used as popper
	   * @param {Object} options - Popper.js options
	   */
	  function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	    // compute reference element offsets
	    var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

	    // compute auto placement, store placement inside the data object,
	    // modifiers will be able to edit `placement` if needed
	    // and refer to originalPlacement to know the original value
	    var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

	    popper.setAttribute('x-placement', placement);

	    // Apply `position` to popper before anything else because
	    // without the position applied we can't guarantee correct computations
	    setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

	    return options;
	  }

	  /**
	   * @function
	   * @memberof Popper.Utils
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	   * @returns {Object} The popper's position offsets rounded
	   *
	   * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	   * good as it can be within reason.
	   * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	   *
	   * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	   * as well on High DPI screens).
	   *
	   * Firefox prefers no rounding for positioning and does not have blurriness on
	   * high DPI screens.
	   *
	   * Only horizontal placement and left/right values need to be considered.
	   */
	  function getRoundedOffsets(data, shouldRound) {
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;
	    var round = Math.round,
	        floor = Math.floor;

	    var noRound = function noRound(v) {
	      return v;
	    };

	    var referenceWidth = round(reference.width);
	    var popperWidth = round(popper.width);

	    var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	    var isVariation = data.placement.indexOf('-') !== -1;
	    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

	    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	    var verticalToInteger = !shouldRound ? noRound : round;

	    return {
	      left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	      top: verticalToInteger(popper.top),
	      bottom: verticalToInteger(popper.bottom),
	      right: horizontalToInteger(popper.right)
	    };
	  }

	  var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function computeStyle(data, options) {
	    var x = options.x,
	        y = options.y;
	    var popper = data.offsets.popper;

	    // Remove this legacy support in Popper.js v2

	    var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	      return modifier.name === 'applyStyle';
	    }).gpuAcceleration;
	    if (legacyGpuAccelerationOption !== undefined) {
	      console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	    }
	    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

	    var offsetParent = getOffsetParent(data.instance.popper);
	    var offsetParentRect = getBoundingClientRect(offsetParent);

	    // Styles
	    var styles = {
	      position: popper.position
	    };

	    var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

	    var sideA = x === 'bottom' ? 'top' : 'bottom';
	    var sideB = y === 'right' ? 'left' : 'right';

	    // if gpuAcceleration is set to `true` and transform is supported,
	    //  we use `translate3d` to apply the position to the popper we
	    // automatically use the supported prefixed version if needed
	    var prefixedProperty = getSupportedPropertyName('transform');

	    // now, let's make a step back and look at this code closely (wtf?)
	    // If the content of the popper grows once it's been positioned, it
	    // may happen that the popper gets misplaced because of the new content
	    // overflowing its reference element
	    // To avoid this problem, we provide two options (x and y), which allow
	    // the consumer to define the offset origin.
	    // If we position a popper on top of a reference element, we can set
	    // `x` to `top` to make the popper grow towards its top instead of
	    // its bottom.
	    var left = void 0,
	        top = void 0;
	    if (sideA === 'bottom') {
	      // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	      // and not the bottom of the html element
	      if (offsetParent.nodeName === 'HTML') {
	        top = -offsetParent.clientHeight + offsets.bottom;
	      } else {
	        top = -offsetParentRect.height + offsets.bottom;
	      }
	    } else {
	      top = offsets.top;
	    }
	    if (sideB === 'right') {
	      if (offsetParent.nodeName === 'HTML') {
	        left = -offsetParent.clientWidth + offsets.right;
	      } else {
	        left = -offsetParentRect.width + offsets.right;
	      }
	    } else {
	      left = offsets.left;
	    }
	    if (gpuAcceleration && prefixedProperty) {
	      styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	      styles[sideA] = 0;
	      styles[sideB] = 0;
	      styles.willChange = 'transform';
	    } else {
	      // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	      var invertTop = sideA === 'bottom' ? -1 : 1;
	      var invertLeft = sideB === 'right' ? -1 : 1;
	      styles[sideA] = top * invertTop;
	      styles[sideB] = left * invertLeft;
	      styles.willChange = sideA + ', ' + sideB;
	    }

	    // Attributes
	    var attributes = {
	      'x-placement': data.placement
	    };

	    // Update `data` attributes, styles and arrowStyles
	    data.attributes = _extends({}, attributes, data.attributes);
	    data.styles = _extends({}, styles, data.styles);
	    data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

	    return data;
	  }

	  /**
	   * Helper used to know if the given modifier depends from another one.<br />
	   * It checks if the needed modifier is listed and enabled.
	   * @method
	   * @memberof Popper.Utils
	   * @param {Array} modifiers - list of modifiers
	   * @param {String} requestingName - name of requesting modifier
	   * @param {String} requestedName - name of requested modifier
	   * @returns {Boolean}
	   */
	  function isModifierRequired(modifiers, requestingName, requestedName) {
	    var requesting = find(modifiers, function (_ref) {
	      var name = _ref.name;
	      return name === requestingName;
	    });

	    var isRequired = !!requesting && modifiers.some(function (modifier) {
	      return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	    });

	    if (!isRequired) {
	      var _requesting = '`' + requestingName + '`';
	      var requested = '`' + requestedName + '`';
	      console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	    }
	    return isRequired;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function arrow(data, options) {
	    var _data$offsets$arrow;

	    // arrow depends on keepTogether in order to work
	    if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	      return data;
	    }

	    var arrowElement = options.element;

	    // if arrowElement is a string, suppose it's a CSS selector
	    if (typeof arrowElement === 'string') {
	      arrowElement = data.instance.popper.querySelector(arrowElement);

	      // if arrowElement is not found, don't run the modifier
	      if (!arrowElement) {
	        return data;
	      }
	    } else {
	      // if the arrowElement isn't a query selector we must check that the
	      // provided DOM node is child of its popper node
	      if (!data.instance.popper.contains(arrowElement)) {
	        console.warn('WARNING: `arrow.element` must be child of its popper element!');
	        return data;
	      }
	    }

	    var placement = data.placement.split('-')[0];
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;

	    var isVertical = ['left', 'right'].indexOf(placement) !== -1;

	    var len = isVertical ? 'height' : 'width';
	    var sideCapitalized = isVertical ? 'Top' : 'Left';
	    var side = sideCapitalized.toLowerCase();
	    var altSide = isVertical ? 'left' : 'top';
	    var opSide = isVertical ? 'bottom' : 'right';
	    var arrowElementSize = getOuterSizes(arrowElement)[len];

	    //
	    // extends keepTogether behavior making sure the popper and its
	    // reference have enough pixels in conjunction
	    //

	    // top/left side
	    if (reference[opSide] - arrowElementSize < popper[side]) {
	      data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	    }
	    // bottom/right side
	    if (reference[side] + arrowElementSize > popper[opSide]) {
	      data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	    }
	    data.offsets.popper = getClientRect(data.offsets.popper);

	    // compute center of the popper
	    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

	    // Compute the sideValue using the updated popper offsets
	    // take popper margin in account because we don't have this info available
	    var css = getStyleComputedProperty(data.instance.popper);
	    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

	    // prevent arrowElement from being placed not contiguously to its popper
	    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

	    data.arrowElement = arrowElement;
	    data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

	    return data;
	  }

	  /**
	   * Get the opposite placement variation of the given one
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} placement variation
	   * @returns {String} flipped placement variation
	   */
	  function getOppositeVariation(variation) {
	    if (variation === 'end') {
	      return 'start';
	    } else if (variation === 'start') {
	      return 'end';
	    }
	    return variation;
	  }

	  /**
	   * List of accepted placements to use as values of the `placement` option.<br />
	   * Valid placements are:
	   * - `auto`
	   * - `top`
	   * - `right`
	   * - `bottom`
	   * - `left`
	   *
	   * Each placement can have a variation from this list:
	   * - `-start`
	   * - `-end`
	   *
	   * Variations are interpreted easily if you think of them as the left to right
	   * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	   * is right.<br />
	   * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	   *
	   * Some valid examples are:
	   * - `top-end` (on top of reference, right aligned)
	   * - `right-start` (on right of reference, top aligned)
	   * - `bottom` (on bottom, centered)
	   * - `auto-end` (on the side with more space available, alignment depends by placement)
	   *
	   * @static
	   * @type {Array}
	   * @enum {String}
	   * @readonly
	   * @method placements
	   * @memberof Popper
	   */
	  var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

	  // Get rid of `auto` `auto-start` and `auto-end`
	  var validPlacements = placements.slice(3);

	  /**
	   * Given an initial placement, returns all the subsequent placements
	   * clockwise (or counter-clockwise).
	   *
	   * @method
	   * @memberof Popper.Utils
	   * @argument {String} placement - A valid placement (it accepts variations)
	   * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	   * @returns {Array} placements including their variations
	   */
	  function clockwise(placement) {
	    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	    var index = validPlacements.indexOf(placement);
	    var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	    return counter ? arr.reverse() : arr;
	  }

	  var BEHAVIORS = {
	    FLIP: 'flip',
	    CLOCKWISE: 'clockwise',
	    COUNTERCLOCKWISE: 'counterclockwise'
	  };

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function flip(data, options) {
	    // if `inner` modifier is enabled, we can't use the `flip` modifier
	    if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	      return data;
	    }

	    if (data.flipped && data.placement === data.originalPlacement) {
	      // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	      return data;
	    }

	    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

	    var placement = data.placement.split('-')[0];
	    var placementOpposite = getOppositePlacement(placement);
	    var variation = data.placement.split('-')[1] || '';

	    var flipOrder = [];

	    switch (options.behavior) {
	      case BEHAVIORS.FLIP:
	        flipOrder = [placement, placementOpposite];
	        break;
	      case BEHAVIORS.CLOCKWISE:
	        flipOrder = clockwise(placement);
	        break;
	      case BEHAVIORS.COUNTERCLOCKWISE:
	        flipOrder = clockwise(placement, true);
	        break;
	      default:
	        flipOrder = options.behavior;
	    }

	    flipOrder.forEach(function (step, index) {
	      if (placement !== step || flipOrder.length === index + 1) {
	        return data;
	      }

	      placement = data.placement.split('-')[0];
	      placementOpposite = getOppositePlacement(placement);

	      var popperOffsets = data.offsets.popper;
	      var refOffsets = data.offsets.reference;

	      // using floor because the reference offsets may contain decimals we are not going to consider here
	      var floor = Math.floor;
	      var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

	      var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	      var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	      var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	      var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

	      var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

	      // flip the variation if required
	      var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

	      // flips variation if reference element overflows boundaries
	      var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

	      // flips variation if popper content overflows boundaries
	      var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

	      var flippedVariation = flippedVariationByRef || flippedVariationByContent;

	      if (overlapsRef || overflowsBoundaries || flippedVariation) {
	        // this boolean to detect any flip loop
	        data.flipped = true;

	        if (overlapsRef || overflowsBoundaries) {
	          placement = flipOrder[index + 1];
	        }

	        if (flippedVariation) {
	          variation = getOppositeVariation(variation);
	        }

	        data.placement = placement + (variation ? '-' + variation : '');

	        // this object contains `position`, we want to preserve it along with
	        // any additional property we may add in the future
	        data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

	        data = runModifiers(data.instance.modifiers, data, 'flip');
	      }
	    });
	    return data;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function keepTogether(data) {
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;

	    var placement = data.placement.split('-')[0];
	    var floor = Math.floor;
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	    var side = isVertical ? 'right' : 'bottom';
	    var opSide = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';

	    if (popper[side] < floor(reference[opSide])) {
	      data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	    }
	    if (popper[opSide] > floor(reference[side])) {
	      data.offsets.popper[opSide] = floor(reference[side]);
	    }

	    return data;
	  }

	  /**
	   * Converts a string containing value + unit into a px value number
	   * @function
	   * @memberof {modifiers~offset}
	   * @private
	   * @argument {String} str - Value + unit string
	   * @argument {String} measurement - `height` or `width`
	   * @argument {Object} popperOffsets
	   * @argument {Object} referenceOffsets
	   * @returns {Number|String}
	   * Value in pixels, or original string if no values were extracted
	   */
	  function toValue(str, measurement, popperOffsets, referenceOffsets) {
	    // separate value from unit
	    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	    var value = +split[1];
	    var unit = split[2];

	    // If it's not a number it's an operator, I guess
	    if (!value) {
	      return str;
	    }

	    if (unit.indexOf('%') === 0) {
	      var element = void 0;
	      switch (unit) {
	        case '%p':
	          element = popperOffsets;
	          break;
	        case '%':
	        case '%r':
	        default:
	          element = referenceOffsets;
	      }

	      var rect = getClientRect(element);
	      return rect[measurement] / 100 * value;
	    } else if (unit === 'vh' || unit === 'vw') {
	      // if is a vh or vw, we calculate the size based on the viewport
	      var size = void 0;
	      if (unit === 'vh') {
	        size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	      } else {
	        size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	      }
	      return size / 100 * value;
	    } else {
	      // if is an explicit pixel unit, we get rid of the unit and keep the value
	      // if is an implicit unit, it's px, and we return just the value
	      return value;
	    }
	  }

	  /**
	   * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	   * @function
	   * @memberof {modifiers~offset}
	   * @private
	   * @argument {String} offset
	   * @argument {Object} popperOffsets
	   * @argument {Object} referenceOffsets
	   * @argument {String} basePlacement
	   * @returns {Array} a two cells array with x and y offsets in numbers
	   */
	  function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	    var offsets = [0, 0];

	    // Use height if placement is left or right and index is 0 otherwise use width
	    // in this way the first offset will use an axis and the second one
	    // will use the other one
	    var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

	    // Split the offset string to obtain a list of values and operands
	    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	    var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	      return frag.trim();
	    });

	    // Detect if the offset string contains a pair of values or a single one
	    // they could be separated by comma or space
	    var divider = fragments.indexOf(find(fragments, function (frag) {
	      return frag.search(/,|\s/) !== -1;
	    }));

	    if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	      console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	    }

	    // If divider is found, we divide the list of values and operands to divide
	    // them by ofset X and Y.
	    var splitRegex = /\s*,\s*|\s+/;
	    var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

	    // Convert the values with units to absolute pixels to allow our computations
	    ops = ops.map(function (op, index) {
	      // Most of the units rely on the orientation of the popper
	      var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	      var mergeWithPrevious = false;
	      return op
	      // This aggregates any `+` or `-` sign that aren't considered operators
	      // e.g.: 10 + +5 => [10, +, +5]
	      .reduce(function (a, b) {
	        if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	          a[a.length - 1] = b;
	          mergeWithPrevious = true;
	          return a;
	        } else if (mergeWithPrevious) {
	          a[a.length - 1] += b;
	          mergeWithPrevious = false;
	          return a;
	        } else {
	          return a.concat(b);
	        }
	      }, [])
	      // Here we convert the string values into number values (in px)
	      .map(function (str) {
	        return toValue(str, measurement, popperOffsets, referenceOffsets);
	      });
	    });

	    // Loop trough the offsets arrays and execute the operations
	    ops.forEach(function (op, index) {
	      op.forEach(function (frag, index2) {
	        if (isNumeric(frag)) {
	          offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	        }
	      });
	    });
	    return offsets;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @argument {Number|String} options.offset=0
	   * The offset value as described in the modifier description
	   * @returns {Object} The data object, properly modified
	   */
	  function offset(data, _ref) {
	    var offset = _ref.offset;
	    var placement = data.placement,
	        _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;

	    var basePlacement = placement.split('-')[0];

	    var offsets = void 0;
	    if (isNumeric(+offset)) {
	      offsets = [+offset, 0];
	    } else {
	      offsets = parseOffset(offset, popper, reference, basePlacement);
	    }

	    if (basePlacement === 'left') {
	      popper.top += offsets[0];
	      popper.left -= offsets[1];
	    } else if (basePlacement === 'right') {
	      popper.top += offsets[0];
	      popper.left += offsets[1];
	    } else if (basePlacement === 'top') {
	      popper.left += offsets[0];
	      popper.top -= offsets[1];
	    } else if (basePlacement === 'bottom') {
	      popper.left += offsets[0];
	      popper.top += offsets[1];
	    }

	    data.popper = popper;
	    return data;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function preventOverflow(data, options) {
	    var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

	    // If offsetParent is the reference element, we really want to
	    // go one step up and use the next offsetParent as reference to
	    // avoid to make this modifier completely useless and look like broken
	    if (data.instance.reference === boundariesElement) {
	      boundariesElement = getOffsetParent(boundariesElement);
	    }

	    // NOTE: DOM access here
	    // resets the popper's position so that the document size can be calculated excluding
	    // the size of the popper element itself
	    var transformProp = getSupportedPropertyName('transform');
	    var popperStyles = data.instance.popper.style; // assignment to help minification
	    var top = popperStyles.top,
	        left = popperStyles.left,
	        transform = popperStyles[transformProp];

	    popperStyles.top = '';
	    popperStyles.left = '';
	    popperStyles[transformProp] = '';

	    var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

	    // NOTE: DOM access here
	    // restores the original style properties after the offsets have been computed
	    popperStyles.top = top;
	    popperStyles.left = left;
	    popperStyles[transformProp] = transform;

	    options.boundaries = boundaries;

	    var order = options.priority;
	    var popper = data.offsets.popper;

	    var check = {
	      primary: function primary(placement) {
	        var value = popper[placement];
	        if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	          value = Math.max(popper[placement], boundaries[placement]);
	        }
	        return defineProperty({}, placement, value);
	      },
	      secondary: function secondary(placement) {
	        var mainSide = placement === 'right' ? 'left' : 'top';
	        var value = popper[mainSide];
	        if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	          value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	        }
	        return defineProperty({}, mainSide, value);
	      }
	    };

	    order.forEach(function (placement) {
	      var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	      popper = _extends({}, popper, check[side](placement));
	    });

	    data.offsets.popper = popper;

	    return data;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function shift(data) {
	    var placement = data.placement;
	    var basePlacement = placement.split('-')[0];
	    var shiftvariation = placement.split('-')[1];

	    // if shift shiftvariation is specified, run the modifier
	    if (shiftvariation) {
	      var _data$offsets = data.offsets,
	          reference = _data$offsets.reference,
	          popper = _data$offsets.popper;

	      var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	      var side = isVertical ? 'left' : 'top';
	      var measurement = isVertical ? 'width' : 'height';

	      var shiftOffsets = {
	        start: defineProperty({}, side, reference[side]),
	        end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	      };

	      data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	    }

	    return data;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by update method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function hide(data) {
	    if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	      return data;
	    }

	    var refRect = data.offsets.reference;
	    var bound = find(data.instance.modifiers, function (modifier) {
	      return modifier.name === 'preventOverflow';
	    }).boundaries;

	    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	      // Avoid unnecessary DOM access if visibility hasn't changed
	      if (data.hide === true) {
	        return data;
	      }

	      data.hide = true;
	      data.attributes['x-out-of-boundaries'] = '';
	    } else {
	      // Avoid unnecessary DOM access if visibility hasn't changed
	      if (data.hide === false) {
	        return data;
	      }

	      data.hide = false;
	      data.attributes['x-out-of-boundaries'] = false;
	    }

	    return data;
	  }

	  /**
	   * @function
	   * @memberof Modifiers
	   * @argument {Object} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {Object} The data object, properly modified
	   */
	  function inner(data) {
	    var placement = data.placement;
	    var basePlacement = placement.split('-')[0];
	    var _data$offsets = data.offsets,
	        popper = _data$offsets.popper,
	        reference = _data$offsets.reference;

	    var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

	    var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

	    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

	    data.placement = getOppositePlacement(placement);
	    data.offsets.popper = getClientRect(popper);

	    return data;
	  }

	  /**
	   * Modifier function, each modifier can have a function of this type assigned
	   * to its `fn` property.<br />
	   * These functions will be called on each update, this means that you must
	   * make sure they are performant enough to avoid performance bottlenecks.
	   *
	   * @function ModifierFn
	   * @argument {dataObject} data - The data object generated by `update` method
	   * @argument {Object} options - Modifiers configuration and options
	   * @returns {dataObject} The data object, properly modified
	   */

	  /**
	   * Modifiers are plugins used to alter the behavior of your poppers.<br />
	   * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	   * needed by the library.
	   *
	   * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	   * All the other properties are configurations that could be tweaked.
	   * @namespace modifiers
	   */
	  var modifiers = {
	    /**
	     * Modifier used to shift the popper on the start or end of its reference
	     * element.<br />
	     * It will read the variation of the `placement` property.<br />
	     * It can be one either `-end` or `-start`.
	     * @memberof modifiers
	     * @inner
	     */
	    shift: {
	      /** @prop {number} order=100 - Index used to define the order of execution */
	      order: 100,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: shift
	    },

	    /**
	     * The `offset` modifier can shift your popper on both its axis.
	     *
	     * It accepts the following units:
	     * - `px` or unit-less, interpreted as pixels
	     * - `%` or `%r`, percentage relative to the length of the reference element
	     * - `%p`, percentage relative to the length of the popper element
	     * - `vw`, CSS viewport width unit
	     * - `vh`, CSS viewport height unit
	     *
	     * For length is intended the main axis relative to the placement of the popper.<br />
	     * This means that if the placement is `top` or `bottom`, the length will be the
	     * `width`. In case of `left` or `right`, it will be the `height`.
	     *
	     * You can provide a single value (as `Number` or `String`), or a pair of values
	     * as `String` divided by a comma or one (or more) white spaces.<br />
	     * The latter is a deprecated method because it leads to confusion and will be
	     * removed in v2.<br />
	     * Additionally, it accepts additions and subtractions between different units.
	     * Note that multiplications and divisions aren't supported.
	     *
	     * Valid examples are:
	     * ```
	     * 10
	     * '10%'
	     * '10, 10'
	     * '10%, 10'
	     * '10 + 10%'
	     * '10 - 5vh + 3%'
	     * '-10px + 5vh, 5px - 6%'
	     * ```
	     * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	     * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	     * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    offset: {
	      /** @prop {number} order=200 - Index used to define the order of execution */
	      order: 200,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: offset,
	      /** @prop {Number|String} offset=0
	       * The offset value as described in the modifier description
	       */
	      offset: 0
	    },

	    /**
	     * Modifier used to prevent the popper from being positioned outside the boundary.
	     *
	     * A scenario exists where the reference itself is not within the boundaries.<br />
	     * We can say it has "escaped the boundaries" — or just "escaped".<br />
	     * In this case we need to decide whether the popper should either:
	     *
	     * - detach from the reference and remain "trapped" in the boundaries, or
	     * - if it should ignore the boundary and "escape with its reference"
	     *
	     * When `escapeWithReference` is set to`true` and reference is completely
	     * outside its boundaries, the popper will overflow (or completely leave)
	     * the boundaries in order to remain attached to the edge of the reference.
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    preventOverflow: {
	      /** @prop {number} order=300 - Index used to define the order of execution */
	      order: 300,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: preventOverflow,
	      /**
	       * @prop {Array} [priority=['left','right','top','bottom']]
	       * Popper will try to prevent overflow following these priorities by default,
	       * then, it could overflow on the left and on top of the `boundariesElement`
	       */
	      priority: ['left', 'right', 'top', 'bottom'],
	      /**
	       * @prop {number} padding=5
	       * Amount of pixel used to define a minimum distance between the boundaries
	       * and the popper. This makes sure the popper always has a little padding
	       * between the edges of its container
	       */
	      padding: 5,
	      /**
	       * @prop {String|HTMLElement} boundariesElement='scrollParent'
	       * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	       * `viewport` or any DOM element.
	       */
	      boundariesElement: 'scrollParent'
	    },

	    /**
	     * Modifier used to make sure the reference and its popper stay near each other
	     * without leaving any gap between the two. Especially useful when the arrow is
	     * enabled and you want to ensure that it points to its reference element.
	     * It cares only about the first axis. You can still have poppers with margin
	     * between the popper and its reference element.
	     * @memberof modifiers
	     * @inner
	     */
	    keepTogether: {
	      /** @prop {number} order=400 - Index used to define the order of execution */
	      order: 400,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: keepTogether
	    },

	    /**
	     * This modifier is used to move the `arrowElement` of the popper to make
	     * sure it is positioned between the reference element and its popper element.
	     * It will read the outer size of the `arrowElement` node to detect how many
	     * pixels of conjunction are needed.
	     *
	     * It has no effect if no `arrowElement` is provided.
	     * @memberof modifiers
	     * @inner
	     */
	    arrow: {
	      /** @prop {number} order=500 - Index used to define the order of execution */
	      order: 500,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: arrow,
	      /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	      element: '[x-arrow]'
	    },

	    /**
	     * Modifier used to flip the popper's placement when it starts to overlap its
	     * reference element.
	     *
	     * Requires the `preventOverflow` modifier before it in order to work.
	     *
	     * **NOTE:** this modifier will interrupt the current update cycle and will
	     * restart it if it detects the need to flip the placement.
	     * @memberof modifiers
	     * @inner
	     */
	    flip: {
	      /** @prop {number} order=600 - Index used to define the order of execution */
	      order: 600,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: flip,
	      /**
	       * @prop {String|Array} behavior='flip'
	       * The behavior used to change the popper's placement. It can be one of
	       * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	       * placements (with optional variations)
	       */
	      behavior: 'flip',
	      /**
	       * @prop {number} padding=5
	       * The popper will flip if it hits the edges of the `boundariesElement`
	       */
	      padding: 5,
	      /**
	       * @prop {String|HTMLElement} boundariesElement='viewport'
	       * The element which will define the boundaries of the popper position.
	       * The popper will never be placed outside of the defined boundaries
	       * (except if `keepTogether` is enabled)
	       */
	      boundariesElement: 'viewport',
	      /**
	       * @prop {Boolean} flipVariations=false
	       * The popper will switch placement variation between `-start` and `-end` when
	       * the reference element overlaps its boundaries.
	       *
	       * The original placement should have a set variation.
	       */
	      flipVariations: false,
	      /**
	       * @prop {Boolean} flipVariationsByContent=false
	       * The popper will switch placement variation between `-start` and `-end` when
	       * the popper element overlaps its reference boundaries.
	       *
	       * The original placement should have a set variation.
	       */
	      flipVariationsByContent: false
	    },

	    /**
	     * Modifier used to make the popper flow toward the inner of the reference element.
	     * By default, when this modifier is disabled, the popper will be placed outside
	     * the reference element.
	     * @memberof modifiers
	     * @inner
	     */
	    inner: {
	      /** @prop {number} order=700 - Index used to define the order of execution */
	      order: 700,
	      /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	      enabled: false,
	      /** @prop {ModifierFn} */
	      fn: inner
	    },

	    /**
	     * Modifier used to hide the popper when its reference element is outside of the
	     * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	     * be used to hide with a CSS selector the popper when its reference is
	     * out of boundaries.
	     *
	     * Requires the `preventOverflow` modifier before it in order to work.
	     * @memberof modifiers
	     * @inner
	     */
	    hide: {
	      /** @prop {number} order=800 - Index used to define the order of execution */
	      order: 800,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: hide
	    },

	    /**
	     * Computes the style that will be applied to the popper element to gets
	     * properly positioned.
	     *
	     * Note that this modifier will not touch the DOM, it just prepares the styles
	     * so that `applyStyle` modifier can apply it. This separation is useful
	     * in case you need to replace `applyStyle` with a custom implementation.
	     *
	     * This modifier has `850` as `order` value to maintain backward compatibility
	     * with previous versions of Popper.js. Expect the modifiers ordering method
	     * to change in future major versions of the library.
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    computeStyle: {
	      /** @prop {number} order=850 - Index used to define the order of execution */
	      order: 850,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: computeStyle,
	      /**
	       * @prop {Boolean} gpuAcceleration=true
	       * If true, it uses the CSS 3D transformation to position the popper.
	       * Otherwise, it will use the `top` and `left` properties
	       */
	      gpuAcceleration: true,
	      /**
	       * @prop {string} [x='bottom']
	       * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	       * Change this if your popper should grow in a direction different from `bottom`
	       */
	      x: 'bottom',
	      /**
	       * @prop {string} [x='left']
	       * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	       * Change this if your popper should grow in a direction different from `right`
	       */
	      y: 'right'
	    },

	    /**
	     * Applies the computed styles to the popper element.
	     *
	     * All the DOM manipulations are limited to this modifier. This is useful in case
	     * you want to integrate Popper.js inside a framework or view library and you
	     * want to delegate all the DOM manipulations to it.
	     *
	     * Note that if you disable this modifier, you must make sure the popper element
	     * has its position set to `absolute` before Popper.js can do its work!
	     *
	     * Just disable this modifier and define your own to achieve the desired effect.
	     *
	     * @memberof modifiers
	     * @inner
	     */
	    applyStyle: {
	      /** @prop {number} order=900 - Index used to define the order of execution */
	      order: 900,
	      /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	      enabled: true,
	      /** @prop {ModifierFn} */
	      fn: applyStyle,
	      /** @prop {Function} */
	      onLoad: applyStyleOnLoad,
	      /**
	       * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	       * @prop {Boolean} gpuAcceleration=true
	       * If true, it uses the CSS 3D transformation to position the popper.
	       * Otherwise, it will use the `top` and `left` properties
	       */
	      gpuAcceleration: undefined
	    }
	  };

	  /**
	   * The `dataObject` is an object containing all the information used by Popper.js.
	   * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	   * @name dataObject
	   * @property {Object} data.instance The Popper.js instance
	   * @property {String} data.placement Placement applied to popper
	   * @property {String} data.originalPlacement Placement originally defined on init
	   * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	   * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	   * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	   * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	   * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	   * @property {Object} data.boundaries Offsets of the popper boundaries
	   * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	   * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	   * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	   * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	   */

	  /**
	   * Default options provided to Popper.js constructor.<br />
	   * These can be overridden using the `options` argument of Popper.js.<br />
	   * To override an option, simply pass an object with the same
	   * structure of the `options` object, as the 3rd argument. For example:
	   * ```
	   * new Popper(ref, pop, {
	   *   modifiers: {
	   *     preventOverflow: { enabled: false }
	   *   }
	   * })
	   * ```
	   * @type {Object}
	   * @static
	   * @memberof Popper
	   */
	  var Defaults = {
	    /**
	     * Popper's placement.
	     * @prop {Popper.placements} placement='bottom'
	     */
	    placement: 'bottom',

	    /**
	     * Set this to true if you want popper to position it self in 'fixed' mode
	     * @prop {Boolean} positionFixed=false
	     */
	    positionFixed: false,

	    /**
	     * Whether events (resize, scroll) are initially enabled.
	     * @prop {Boolean} eventsEnabled=true
	     */
	    eventsEnabled: true,

	    /**
	     * Set to true if you want to automatically remove the popper when
	     * you call the `destroy` method.
	     * @prop {Boolean} removeOnDestroy=false
	     */
	    removeOnDestroy: false,

	    /**
	     * Callback called when the popper is created.<br />
	     * By default, it is set to no-op.<br />
	     * Access Popper.js instance with `data.instance`.
	     * @prop {onCreate}
	     */
	    onCreate: function onCreate() {},

	    /**
	     * Callback called when the popper is updated. This callback is not called
	     * on the initialization/creation of the popper, but only on subsequent
	     * updates.<br />
	     * By default, it is set to no-op.<br />
	     * Access Popper.js instance with `data.instance`.
	     * @prop {onUpdate}
	     */
	    onUpdate: function onUpdate() {},

	    /**
	     * List of modifiers used to modify the offsets before they are applied to the popper.
	     * They provide most of the functionalities of Popper.js.
	     * @prop {modifiers}
	     */
	    modifiers: modifiers
	  };

	  /**
	   * @callback onCreate
	   * @param {dataObject} data
	   */

	  /**
	   * @callback onUpdate
	   * @param {dataObject} data
	   */

	  // Utils
	  // Methods
	  var Popper = function () {
	    /**
	     * Creates a new Popper.js instance.
	     * @class Popper
	     * @param {Element|referenceObject} reference - The reference element used to position the popper
	     * @param {Element} popper - The HTML / XML element used as the popper
	     * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	     * @return {Object} instance - The generated Popper.js instance
	     */
	    function Popper(reference, popper) {
	      var _this = this;

	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      classCallCheck(this, Popper);

	      this.scheduleUpdate = function () {
	        return requestAnimationFrame(_this.update);
	      };

	      // make update() debounced, so that it only runs at most once-per-tick
	      this.update = debounce(this.update.bind(this));

	      // with {} we create a new object with the options inside it
	      this.options = _extends({}, Popper.Defaults, options);

	      // init state
	      this.state = {
	        isDestroyed: false,
	        isCreated: false,
	        scrollParents: []
	      };

	      // get reference and popper elements (allow jQuery wrappers)
	      this.reference = reference && reference.jquery ? reference[0] : reference;
	      this.popper = popper && popper.jquery ? popper[0] : popper;

	      // Deep merge modifiers options
	      this.options.modifiers = {};
	      Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	        _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	      });

	      // Refactoring modifiers' list (Object => Array)
	      this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	        return _extends({
	          name: name
	        }, _this.options.modifiers[name]);
	      })
	      // sort the modifiers by order
	      .sort(function (a, b) {
	        return a.order - b.order;
	      });

	      // modifiers have the ability to execute arbitrary code when Popper.js get inited
	      // such code is executed in the same order of its modifier
	      // they could add new properties to their options configuration
	      // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	      this.modifiers.forEach(function (modifierOptions) {
	        if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	          modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	        }
	      });

	      // fire the first update to position the popper in the right place
	      this.update();

	      var eventsEnabled = this.options.eventsEnabled;
	      if (eventsEnabled) {
	        // setup event listeners, they will take care of update the position in specific situations
	        this.enableEventListeners();
	      }

	      this.state.eventsEnabled = eventsEnabled;
	    }

	    // We can't use class properties because they don't get listed in the
	    // class prototype and break stuff like Sinon stubs


	    createClass(Popper, [{
	      key: 'update',
	      value: function update$$1() {
	        return update.call(this);
	      }
	    }, {
	      key: 'destroy',
	      value: function destroy$$1() {
	        return destroy.call(this);
	      }
	    }, {
	      key: 'enableEventListeners',
	      value: function enableEventListeners$$1() {
	        return enableEventListeners.call(this);
	      }
	    }, {
	      key: 'disableEventListeners',
	      value: function disableEventListeners$$1() {
	        return disableEventListeners.call(this);
	      }

	      /**
	       * Schedules an update. It will run on the next UI update available.
	       * @method scheduleUpdate
	       * @memberof Popper
	       */

	      /**
	       * Collection of utilities useful when writing custom modifiers.
	       * Starting from version 1.7, this method is available only if you
	       * include `popper-utils.js` before `popper.js`.
	       *
	       * **DEPRECATION**: This way to access PopperUtils is deprecated
	       * and will be removed in v2! Use the PopperUtils module directly instead.
	       * Due to the high instability of the methods contained in Utils, we can't
	       * guarantee them to follow semver. Use them at your own risk!
	       * @static
	       * @private
	       * @type {Object}
	       * @deprecated since version 1.8
	       * @member Utils
	       * @memberof Popper
	       */

	    }]);
	    return Popper;
	  }();

	  /**
	   * The `referenceObject` is an object that provides an interface compatible with Popper.js
	   * and lets you use it as replacement of a real DOM node.<br />
	   * You can use this method to position a popper relatively to a set of coordinates
	   * in case you don't have a DOM node to use as reference.
	   *
	   * ```
	   * new Popper(referenceObject, popperNode);
	   * ```
	   *
	   * NB: This feature isn't supported in Internet Explorer 10.
	   * @name referenceObject
	   * @property {Function} data.getBoundingClientRect
	   * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	   * @property {number} data.clientWidth
	   * An ES6 getter that will return the width of the virtual reference element.
	   * @property {number} data.clientHeight
	   * An ES6 getter that will return the height of the virtual reference element.
	   */

	  Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	  Popper.placements = placements;
	  Popper.Defaults = Defaults;

	  return Popper;
	});
	//# sourceMappingURL=popper.js.map
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): modal.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'modal';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.modal';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];
	var ESCAPE_KEYCODE = 27; // KeyboardEvent.which value for Escape (Esc) key

	var Default = {
	  backdrop: true,
	  keyboard: true,
	  focus: true,
	  show: true
	};

	var DefaultType = {
	  backdrop: '(boolean|string)',
	  keyboard: 'boolean',
	  focus: 'boolean',
	  show: 'boolean'
	};

	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  FOCUSIN: 'focusin' + EVENT_KEY,
	  RESIZE: 'resize' + EVENT_KEY,
	  CLICK_DISMISS: 'click.dismiss' + EVENT_KEY,
	  KEYDOWN_DISMISS: 'keydown.dismiss' + EVENT_KEY,
	  MOUSEUP_DISMISS: 'mouseup.dismiss' + EVENT_KEY,
	  MOUSEDOWN_DISMISS: 'mousedown.dismiss' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  SCROLLABLE: 'modal-dialog-scrollable',
	  SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
	  BACKDROP: 'modal-backdrop',
	  OPEN: 'modal-open',
	  FADE: 'fade',
	  SHOW: 'show'
	};

	var Selector = {
	  DIALOG: '.modal-dialog',
	  MODAL_BODY: '.modal-body',
	  DATA_TOGGLE: '[data-toggle="modal"]',
	  DATA_DISMISS: '[data-dismiss="modal"]',
	  FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
	  STICKY_CONTENT: '.sticky-top'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var Modal = function () {
	  function Modal(element, config) {
	    _classCallCheck(this, Modal);

	    this._config = this._getConfig(config);
	    this._element = element;
	    this._dialog = element.querySelector(Selector.DIALOG);
	    this._backdrop = null;
	    this._isShown = false;
	    this._isBodyOverflowing = false;
	    this._ignoreBackdropClick = false;
	    this._isTransitioning = false;
	    this._scrollbarWidth = 0;
	  }

	  // Getters

	  _createClass(Modal, [{
	    key: 'toggle',


	    // Public

	    value: function toggle(relatedTarget) {
	      return this._isShown ? this.hide() : this.show(relatedTarget);
	    }
	  }, {
	    key: 'show',
	    value: function show(relatedTarget) {
	      var _this = this;

	      if (this._isShown || this._isTransitioning) {
	        return;
	      }

	      if ((0, _jquery2.default)(this._element).hasClass(ClassName.FADE)) {
	        this._isTransitioning = true;
	      }

	      var showEvent = _jquery2.default.Event(Event.SHOW, {
	        relatedTarget: relatedTarget
	      });

	      (0, _jquery2.default)(this._element).trigger(showEvent);

	      if (this._isShown || showEvent.isDefaultPrevented()) {
	        return;
	      }

	      this._isShown = true;

	      this._checkScrollbar();
	      this._setScrollbar();

	      this._adjustDialog();

	      this._setEscapeEvent();
	      this._setResizeEvent();

	      (0, _jquery2.default)(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function (event) {
	        return _this.hide(event);
	      });

	      (0, _jquery2.default)(this._dialog).on(Event.MOUSEDOWN_DISMISS, function () {
	        (0, _jquery2.default)(_this._element).one(Event.MOUSEUP_DISMISS, function (event) {
	          if ((0, _jquery2.default)(event.target).is(_this._element)) {
	            _this._ignoreBackdropClick = true;
	          }
	        });
	      });

	      this._showBackdrop(function () {
	        return _this._showElement(relatedTarget);
	      });
	    }
	  }, {
	    key: 'hide',
	    value: function hide(event) {
	      var _this2 = this;

	      if (event) {
	        event.preventDefault();
	      }

	      if (!this._isShown || this._isTransitioning) {
	        return;
	      }

	      var hideEvent = _jquery2.default.Event(Event.HIDE);

	      (0, _jquery2.default)(this._element).trigger(hideEvent);

	      if (!this._isShown || hideEvent.isDefaultPrevented()) {
	        return;
	      }

	      this._isShown = false;
	      var transition = (0, _jquery2.default)(this._element).hasClass(ClassName.FADE);

	      if (transition) {
	        this._isTransitioning = true;
	      }

	      this._setEscapeEvent();
	      this._setResizeEvent();

	      (0, _jquery2.default)(document).off(Event.FOCUSIN);

	      (0, _jquery2.default)(this._element).removeClass(ClassName.SHOW);

	      (0, _jquery2.default)(this._element).off(Event.CLICK_DISMISS);
	      (0, _jquery2.default)(this._dialog).off(Event.MOUSEDOWN_DISMISS);

	      if (transition) {
	        var transitionDuration = _util2.default.getTransitionDurationFromElement(this._element);

	        (0, _jquery2.default)(this._element).one(_util2.default.TRANSITION_END, function (event) {
	          return _this2._hideModal(event);
	        }).emulateTransitionEnd(transitionDuration);
	      } else {
	        this._hideModal();
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      [window, this._element, this._dialog].forEach(function (htmlElement) {
	        return (0, _jquery2.default)(htmlElement).off(EVENT_KEY);
	      });

	      /**
	       * `document` has 2 events `Event.FOCUSIN` and `Event.CLICK_DATA_API`
	       * Do not move `document` in `htmlElements` array
	       * It will remove `Event.CLICK_DATA_API` event that should remain
	       */
	      (0, _jquery2.default)(document).off(Event.FOCUSIN);

	      _jquery2.default.removeData(this._element, DATA_KEY);

	      this._config = null;
	      this._element = null;
	      this._dialog = null;
	      this._backdrop = null;
	      this._isShown = null;
	      this._isBodyOverflowing = null;
	      this._ignoreBackdropClick = null;
	      this._isTransitioning = null;
	      this._scrollbarWidth = null;
	    }
	  }, {
	    key: 'handleUpdate',
	    value: function handleUpdate() {
	      this._adjustDialog();
	    }

	    // Private

	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, config);
	      _util2.default.typeCheckConfig(NAME, config, DefaultType);
	      return config;
	    }
	  }, {
	    key: '_showElement',
	    value: function _showElement(relatedTarget) {
	      var _this3 = this;

	      var transition = (0, _jquery2.default)(this._element).hasClass(ClassName.FADE);

	      if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
	        // Don't move modal's DOM position
	        document.body.appendChild(this._element);
	      }

	      this._element.style.display = 'block';
	      this._element.removeAttribute('aria-hidden');
	      this._element.setAttribute('aria-modal', true);

	      if ((0, _jquery2.default)(this._dialog).hasClass(ClassName.SCROLLABLE)) {
	        this._dialog.querySelector(Selector.MODAL_BODY).scrollTop = 0;
	      } else {
	        this._element.scrollTop = 0;
	      }

	      if (transition) {
	        _util2.default.reflow(this._element);
	      }

	      (0, _jquery2.default)(this._element).addClass(ClassName.SHOW);

	      if (this._config.focus) {
	        this._enforceFocus();
	      }

	      var shownEvent = _jquery2.default.Event(Event.SHOWN, {
	        relatedTarget: relatedTarget
	      });

	      var transitionComplete = function transitionComplete() {
	        if (_this3._config.focus) {
	          _this3._element.focus();
	        }
	        _this3._isTransitioning = false;
	        (0, _jquery2.default)(_this3._element).trigger(shownEvent);
	      };

	      if (transition) {
	        var transitionDuration = _util2.default.getTransitionDurationFromElement(this._dialog);

	        (0, _jquery2.default)(this._dialog).one(_util2.default.TRANSITION_END, transitionComplete).emulateTransitionEnd(transitionDuration);
	      } else {
	        transitionComplete();
	      }
	    }
	  }, {
	    key: '_enforceFocus',
	    value: function _enforceFocus() {
	      var _this4 = this;

	      (0, _jquery2.default)(document).off(Event.FOCUSIN) // Guard against infinite focus loop
	      .on(Event.FOCUSIN, function (event) {
	        if (document !== event.target && _this4._element !== event.target && (0, _jquery2.default)(_this4._element).has(event.target).length === 0) {
	          _this4._element.focus();
	        }
	      });
	    }
	  }, {
	    key: '_setEscapeEvent',
	    value: function _setEscapeEvent() {
	      var _this5 = this;

	      if (this._isShown && this._config.keyboard) {
	        (0, _jquery2.default)(this._element).on(Event.KEYDOWN_DISMISS, function (event) {
	          if (event.which === ESCAPE_KEYCODE) {
	            event.preventDefault();
	            _this5.hide();
	          }
	        });
	      } else if (!this._isShown) {
	        (0, _jquery2.default)(this._element).off(Event.KEYDOWN_DISMISS);
	      }
	    }
	  }, {
	    key: '_setResizeEvent',
	    value: function _setResizeEvent() {
	      var _this6 = this;

	      if (this._isShown) {
	        (0, _jquery2.default)(window).on(Event.RESIZE, function (event) {
	          return _this6.handleUpdate(event);
	        });
	      } else {
	        (0, _jquery2.default)(window).off(Event.RESIZE);
	      }
	    }
	  }, {
	    key: '_hideModal',
	    value: function _hideModal() {
	      var _this7 = this;

	      this._element.style.display = 'none';
	      this._element.setAttribute('aria-hidden', true);
	      this._element.removeAttribute('aria-modal');
	      this._isTransitioning = false;
	      this._showBackdrop(function () {
	        (0, _jquery2.default)(document.body).removeClass(ClassName.OPEN);
	        _this7._resetAdjustments();
	        _this7._resetScrollbar();
	        (0, _jquery2.default)(_this7._element).trigger(Event.HIDDEN);
	      });
	    }
	  }, {
	    key: '_removeBackdrop',
	    value: function _removeBackdrop() {
	      if (this._backdrop) {
	        (0, _jquery2.default)(this._backdrop).remove();
	        this._backdrop = null;
	      }
	    }
	  }, {
	    key: '_showBackdrop',
	    value: function _showBackdrop(callback) {
	      var _this8 = this;

	      var animate = (0, _jquery2.default)(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

	      if (this._isShown && this._config.backdrop) {
	        this._backdrop = document.createElement('div');
	        this._backdrop.className = ClassName.BACKDROP;

	        if (animate) {
	          this._backdrop.classList.add(animate);
	        }

	        (0, _jquery2.default)(this._backdrop).appendTo(document.body);

	        (0, _jquery2.default)(this._element).on(Event.CLICK_DISMISS, function (event) {
	          if (_this8._ignoreBackdropClick) {
	            _this8._ignoreBackdropClick = false;
	            return;
	          }
	          if (event.target !== event.currentTarget) {
	            return;
	          }
	          if (_this8._config.backdrop === 'static') {
	            _this8._element.focus();
	          } else {
	            _this8.hide();
	          }
	        });

	        if (animate) {
	          _util2.default.reflow(this._backdrop);
	        }

	        (0, _jquery2.default)(this._backdrop).addClass(ClassName.SHOW);

	        if (!callback) {
	          return;
	        }

	        if (!animate) {
	          callback();
	          return;
	        }

	        var backdropTransitionDuration = _util2.default.getTransitionDurationFromElement(this._backdrop);

	        (0, _jquery2.default)(this._backdrop).one(_util2.default.TRANSITION_END, callback).emulateTransitionEnd(backdropTransitionDuration);
	      } else if (!this._isShown && this._backdrop) {
	        (0, _jquery2.default)(this._backdrop).removeClass(ClassName.SHOW);

	        var callbackRemove = function callbackRemove() {
	          _this8._removeBackdrop();
	          if (callback) {
	            callback();
	          }
	        };

	        if ((0, _jquery2.default)(this._element).hasClass(ClassName.FADE)) {
	          var _backdropTransitionDuration = _util2.default.getTransitionDurationFromElement(this._backdrop);

	          (0, _jquery2.default)(this._backdrop).one(_util2.default.TRANSITION_END, callbackRemove).emulateTransitionEnd(_backdropTransitionDuration);
	        } else {
	          callbackRemove();
	        }
	      } else if (callback) {
	        callback();
	      }
	    }

	    // ----------------------------------------------------------------------
	    // the following methods are used to handle overflowing modals
	    // todo (fat): these should probably be refactored out of modal.js
	    // ----------------------------------------------------------------------

	  }, {
	    key: '_adjustDialog',
	    value: function _adjustDialog() {
	      var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;

	      if (!this._isBodyOverflowing && isModalOverflowing) {
	        this._element.style.paddingLeft = this._scrollbarWidth + 'px';
	      }

	      if (this._isBodyOverflowing && !isModalOverflowing) {
	        this._element.style.paddingRight = this._scrollbarWidth + 'px';
	      }
	    }
	  }, {
	    key: '_resetAdjustments',
	    value: function _resetAdjustments() {
	      this._element.style.paddingLeft = '';
	      this._element.style.paddingRight = '';
	    }
	  }, {
	    key: '_checkScrollbar',
	    value: function _checkScrollbar() {
	      var rect = document.body.getBoundingClientRect();
	      this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
	      this._scrollbarWidth = this._getScrollbarWidth();
	    }
	  }, {
	    key: '_setScrollbar',
	    value: function _setScrollbar() {
	      var _this9 = this;

	      if (this._isBodyOverflowing) {
	        // Note: DOMNode.style.paddingRight returns the actual value or '' if not set
	        //   while $(DOMNode).css('padding-right') returns the calculated value or 0 if not set
	        var fixedContent = [].slice.call(document.querySelectorAll(Selector.FIXED_CONTENT));
	        var stickyContent = [].slice.call(document.querySelectorAll(Selector.STICKY_CONTENT));

	        // Adjust fixed content padding
	        (0, _jquery2.default)(fixedContent).each(function (index, element) {
	          var actualPadding = element.style.paddingRight;
	          var calculatedPadding = (0, _jquery2.default)(element).css('padding-right');
	          (0, _jquery2.default)(element).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + _this9._scrollbarWidth + 'px');
	        });

	        // Adjust sticky content margin
	        (0, _jquery2.default)(stickyContent).each(function (index, element) {
	          var actualMargin = element.style.marginRight;
	          var calculatedMargin = (0, _jquery2.default)(element).css('margin-right');
	          (0, _jquery2.default)(element).data('margin-right', actualMargin).css('margin-right', parseFloat(calculatedMargin) - _this9._scrollbarWidth + 'px');
	        });

	        // Adjust body padding
	        var actualPadding = document.body.style.paddingRight;
	        var calculatedPadding = (0, _jquery2.default)(document.body).css('padding-right');
	        (0, _jquery2.default)(document.body).data('padding-right', actualPadding).css('padding-right', parseFloat(calculatedPadding) + this._scrollbarWidth + 'px');
	      }

	      (0, _jquery2.default)(document.body).addClass(ClassName.OPEN);
	    }
	  }, {
	    key: '_resetScrollbar',
	    value: function _resetScrollbar() {
	      // Restore fixed content padding
	      var fixedContent = [].slice.call(document.querySelectorAll(Selector.FIXED_CONTENT));
	      (0, _jquery2.default)(fixedContent).each(function (index, element) {
	        var padding = (0, _jquery2.default)(element).data('padding-right');
	        (0, _jquery2.default)(element).removeData('padding-right');
	        element.style.paddingRight = padding ? padding : '';
	      });

	      // Restore sticky content
	      var elements = [].slice.call(document.querySelectorAll('' + Selector.STICKY_CONTENT));
	      (0, _jquery2.default)(elements).each(function (index, element) {
	        var margin = (0, _jquery2.default)(element).data('margin-right');
	        if (typeof margin !== 'undefined') {
	          (0, _jquery2.default)(element).css('margin-right', margin).removeData('margin-right');
	        }
	      });

	      // Restore body padding
	      var padding = (0, _jquery2.default)(document.body).data('padding-right');
	      (0, _jquery2.default)(document.body).removeData('padding-right');
	      document.body.style.paddingRight = padding ? padding : '';
	    }
	  }, {
	    key: '_getScrollbarWidth',
	    value: function _getScrollbarWidth() {
	      // thx d.walsh
	      var scrollDiv = document.createElement('div');
	      scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
	      document.body.appendChild(scrollDiv);
	      var scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
	      document.body.removeChild(scrollDiv);
	      return scrollbarWidth;
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config, relatedTarget) {
	      return this.each(function () {
	        var data = (0, _jquery2.default)(this).data(DATA_KEY);
	        var _config = _extends({}, Default, (0, _jquery2.default)(this).data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

	        if (!data) {
	          data = new Modal(this, _config);
	          (0, _jquery2.default)(this).data(DATA_KEY, data);
	        }

	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	          data[config](relatedTarget);
	        } else if (_config.show) {
	          data.show(relatedTarget);
	        }
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);

	  return Modal;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  var _this10 = this;

	  var target = void 0;
	  var selector = _util2.default.getSelectorFromElement(this);

	  if (selector) {
	    target = document.querySelector(selector);
	  }

	  var config = (0, _jquery2.default)(target).data(DATA_KEY) ? 'toggle' : _extends({}, (0, _jquery2.default)(target).data(), (0, _jquery2.default)(this).data());

	  if (this.tagName === 'A' || this.tagName === 'AREA') {
	    event.preventDefault();
	  }

	  var $target = (0, _jquery2.default)(target).one(Event.SHOW, function (showEvent) {
	    if (showEvent.isDefaultPrevented()) {
	      // Only register focus restorer if modal will actually get shown
	      return;
	    }

	    $target.one(Event.HIDDEN, function () {
	      if ((0, _jquery2.default)(_this10).is(':visible')) {
	        _this10.focus();
	      }
	    });
	  });

	  Modal._jQueryInterface.call((0, _jquery2.default)(target), config, this);
	});

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Modal._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Modal;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Modal._jQueryInterface;
	};

	exports.default = Modal;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): scrollspy.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'scrollspy';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.scrollspy';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];

	var Default = {
	  offset: 10,
	  method: 'auto',
	  target: ''
	};

	var DefaultType = {
	  offset: 'number',
	  method: 'string',
	  target: '(string|element)'
	};

	var Event = {
	  ACTIVATE: 'activate' + EVENT_KEY,
	  SCROLL: 'scroll' + EVENT_KEY,
	  LOAD_DATA_API: 'load' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  DROPDOWN_ITEM: 'dropdown-item',
	  DROPDOWN_MENU: 'dropdown-menu',
	  ACTIVE: 'active'
	};

	var Selector = {
	  DATA_SPY: '[data-spy="scroll"]',
	  ACTIVE: '.active',
	  NAV_LIST_GROUP: '.nav, .list-group',
	  NAV_LINKS: '.nav-link',
	  NAV_ITEMS: '.nav-item',
	  LIST_ITEMS: '.list-group-item',
	  DROPDOWN: '.dropdown',
	  DROPDOWN_ITEMS: '.dropdown-item',
	  DROPDOWN_TOGGLE: '.dropdown-toggle'
	};

	var OffsetMethod = {
	  OFFSET: 'offset',
	  POSITION: 'position'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var ScrollSpy = function () {
	  function ScrollSpy(element, config) {
	    var _this = this;

	    _classCallCheck(this, ScrollSpy);

	    this._element = element;
	    this._scrollElement = element.tagName === 'BODY' ? window : element;
	    this._config = this._getConfig(config);
	    this._selector = this._config.target + ' ' + Selector.NAV_LINKS + ',' + (this._config.target + ' ' + Selector.LIST_ITEMS + ',') + (this._config.target + ' ' + Selector.DROPDOWN_ITEMS);
	    this._offsets = [];
	    this._targets = [];
	    this._activeTarget = null;
	    this._scrollHeight = 0;

	    (0, _jquery2.default)(this._scrollElement).on(Event.SCROLL, function (event) {
	      return _this._process(event);
	    });

	    this.refresh();
	    this._process();
	  }

	  // Getters

	  _createClass(ScrollSpy, [{
	    key: 'refresh',


	    // Public

	    value: function refresh() {
	      var _this2 = this;

	      var autoMethod = this._scrollElement === this._scrollElement.window ? OffsetMethod.OFFSET : OffsetMethod.POSITION;

	      var offsetMethod = this._config.method === 'auto' ? autoMethod : this._config.method;

	      var offsetBase = offsetMethod === OffsetMethod.POSITION ? this._getScrollTop() : 0;

	      this._offsets = [];
	      this._targets = [];

	      this._scrollHeight = this._getScrollHeight();

	      var targets = [].slice.call(document.querySelectorAll(this._selector));

	      targets.map(function (element) {
	        var target = void 0;
	        var targetSelector = _util2.default.getSelectorFromElement(element);

	        if (targetSelector) {
	          target = document.querySelector(targetSelector);
	        }

	        if (target) {
	          var targetBCR = target.getBoundingClientRect();
	          if (targetBCR.width || targetBCR.height) {
	            // TODO (fat): remove sketch reliance on jQuery position/offset
	            return [(0, _jquery2.default)(target)[offsetMethod]().top + offsetBase, targetSelector];
	          }
	        }
	        return null;
	      }).filter(function (item) {
	        return item;
	      }).sort(function (a, b) {
	        return a[0] - b[0];
	      }).forEach(function (item) {
	        _this2._offsets.push(item[0]);
	        _this2._targets.push(item[1]);
	      });
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _jquery2.default.removeData(this._element, DATA_KEY);
	      (0, _jquery2.default)(this._scrollElement).off(EVENT_KEY);

	      this._element = null;
	      this._scrollElement = null;
	      this._config = null;
	      this._selector = null;
	      this._offsets = null;
	      this._targets = null;
	      this._activeTarget = null;
	      this._scrollHeight = null;
	    }

	    // Private

	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      config = _extends({}, Default, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

	      if (typeof config.target !== 'string') {
	        var id = (0, _jquery2.default)(config.target).attr('id');
	        if (!id) {
	          id = _util2.default.getUID(NAME);
	          (0, _jquery2.default)(config.target).attr('id', id);
	        }
	        config.target = '#' + id;
	      }

	      _util2.default.typeCheckConfig(NAME, config, DefaultType);

	      return config;
	    }
	  }, {
	    key: '_getScrollTop',
	    value: function _getScrollTop() {
	      return this._scrollElement === window ? this._scrollElement.pageYOffset : this._scrollElement.scrollTop;
	    }
	  }, {
	    key: '_getScrollHeight',
	    value: function _getScrollHeight() {
	      return this._scrollElement.scrollHeight || Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
	    }
	  }, {
	    key: '_getOffsetHeight',
	    value: function _getOffsetHeight() {
	      return this._scrollElement === window ? window.innerHeight : this._scrollElement.getBoundingClientRect().height;
	    }
	  }, {
	    key: '_process',
	    value: function _process() {
	      var scrollTop = this._getScrollTop() + this._config.offset;
	      var scrollHeight = this._getScrollHeight();
	      var maxScroll = this._config.offset + scrollHeight - this._getOffsetHeight();

	      if (this._scrollHeight !== scrollHeight) {
	        this.refresh();
	      }

	      if (scrollTop >= maxScroll) {
	        var target = this._targets[this._targets.length - 1];

	        if (this._activeTarget !== target) {
	          this._activate(target);
	        }
	        return;
	      }

	      if (this._activeTarget && scrollTop < this._offsets[0] && this._offsets[0] > 0) {
	        this._activeTarget = null;
	        this._clear();
	        return;
	      }

	      var offsetLength = this._offsets.length;
	      for (var i = offsetLength; i--;) {
	        var isActiveTarget = this._activeTarget !== this._targets[i] && scrollTop >= this._offsets[i] && (typeof this._offsets[i + 1] === 'undefined' || scrollTop < this._offsets[i + 1]);

	        if (isActiveTarget) {
	          this._activate(this._targets[i]);
	        }
	      }
	    }
	  }, {
	    key: '_activate',
	    value: function _activate(target) {
	      this._activeTarget = target;

	      this._clear();

	      var queries = this._selector.split(',').map(function (selector) {
	        return selector + '[data-target="' + target + '"],' + selector + '[href="' + target + '"]';
	      });

	      var $link = (0, _jquery2.default)([].slice.call(document.querySelectorAll(queries.join(','))));

	      if ($link.hasClass(ClassName.DROPDOWN_ITEM)) {
	        $link.closest(Selector.DROPDOWN).find(Selector.DROPDOWN_TOGGLE).addClass(ClassName.ACTIVE);
	        $link.addClass(ClassName.ACTIVE);
	      } else {
	        // Set triggered link as active
	        $link.addClass(ClassName.ACTIVE);
	        // Set triggered links parents as active
	        // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
	        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_LINKS + ', ' + Selector.LIST_ITEMS).addClass(ClassName.ACTIVE);
	        // Handle special case when .nav-link is inside .nav-item
	        $link.parents(Selector.NAV_LIST_GROUP).prev(Selector.NAV_ITEMS).children(Selector.NAV_LINKS).addClass(ClassName.ACTIVE);
	      }

	      (0, _jquery2.default)(this._scrollElement).trigger(Event.ACTIVATE, {
	        relatedTarget: target
	      });
	    }
	  }, {
	    key: '_clear',
	    value: function _clear() {
	      [].slice.call(document.querySelectorAll(this._selector)).filter(function (node) {
	        return node.classList.contains(ClassName.ACTIVE);
	      }).forEach(function (node) {
	        return node.classList.remove(ClassName.ACTIVE);
	      });
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = (0, _jquery2.default)(this).data(DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

	        if (!data) {
	          data = new ScrollSpy(this, _config);
	          (0, _jquery2.default)(this).data(DATA_KEY, data);
	        }

	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }]);

	  return ScrollSpy;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(window).on(Event.LOAD_DATA_API, function () {
	  var scrollSpys = [].slice.call(document.querySelectorAll(Selector.DATA_SPY));
	  var scrollSpysLength = scrollSpys.length;

	  for (var i = scrollSpysLength; i--;) {
	    var $spy = (0, _jquery2.default)(scrollSpys[i]);
	    ScrollSpy._jQueryInterface.call($spy, $spy.data());
	  }
	});

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = ScrollSpy._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = ScrollSpy;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return ScrollSpy._jQueryInterface;
	};

	exports.default = ScrollSpy;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): tab.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'tab';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.tab';
	var EVENT_KEY = '.' + DATA_KEY;
	var DATA_API_KEY = '.data-api';
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];

	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
	};

	var ClassName = {
	  DROPDOWN_MENU: 'dropdown-menu',
	  ACTIVE: 'active',
	  DISABLED: 'disabled',
	  FADE: 'fade',
	  SHOW: 'show'
	};

	var Selector = {
	  DROPDOWN: '.dropdown',
	  NAV_LIST_GROUP: '.nav, .list-group',
	  ACTIVE: '.active',
	  ACTIVE_UL: '> li > .active',
	  DATA_TOGGLE: '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
	  DROPDOWN_TOGGLE: '.dropdown-toggle',
	  DROPDOWN_ACTIVE_CHILD: '> .dropdown-menu .active'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var Tab = function () {
	  function Tab(element) {
	    _classCallCheck(this, Tab);

	    this._element = element;
	  }

	  // Getters

	  _createClass(Tab, [{
	    key: 'show',


	    // Public

	    value: function show() {
	      var _this = this;

	      if (this._element.parentNode && this._element.parentNode.nodeType === Node.ELEMENT_NODE && (0, _jquery2.default)(this._element).hasClass(ClassName.ACTIVE) || (0, _jquery2.default)(this._element).hasClass(ClassName.DISABLED)) {
	        return;
	      }

	      var target = void 0;
	      var previous = void 0;
	      var listElement = (0, _jquery2.default)(this._element).closest(Selector.NAV_LIST_GROUP)[0];
	      var selector = _util2.default.getSelectorFromElement(this._element);

	      if (listElement) {
	        var itemSelector = listElement.nodeName === 'UL' || listElement.nodeName === 'OL' ? Selector.ACTIVE_UL : Selector.ACTIVE;
	        previous = _jquery2.default.makeArray((0, _jquery2.default)(listElement).find(itemSelector));
	        previous = previous[previous.length - 1];
	      }

	      var hideEvent = _jquery2.default.Event(Event.HIDE, {
	        relatedTarget: this._element
	      });

	      var showEvent = _jquery2.default.Event(Event.SHOW, {
	        relatedTarget: previous
	      });

	      if (previous) {
	        (0, _jquery2.default)(previous).trigger(hideEvent);
	      }

	      (0, _jquery2.default)(this._element).trigger(showEvent);

	      if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) {
	        return;
	      }

	      if (selector) {
	        target = document.querySelector(selector);
	      }

	      this._activate(this._element, listElement);

	      var complete = function complete() {
	        var hiddenEvent = _jquery2.default.Event(Event.HIDDEN, {
	          relatedTarget: _this._element
	        });

	        var shownEvent = _jquery2.default.Event(Event.SHOWN, {
	          relatedTarget: previous
	        });

	        (0, _jquery2.default)(previous).trigger(hiddenEvent);
	        (0, _jquery2.default)(_this._element).trigger(shownEvent);
	      };

	      if (target) {
	        this._activate(target, target.parentNode, complete);
	      } else {
	        complete();
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      _jquery2.default.removeData(this._element, DATA_KEY);
	      this._element = null;
	    }

	    // Private

	  }, {
	    key: '_activate',
	    value: function _activate(element, container, callback) {
	      var _this2 = this;

	      var activeElements = container && (container.nodeName === 'UL' || container.nodeName === 'OL') ? (0, _jquery2.default)(container).find(Selector.ACTIVE_UL) : (0, _jquery2.default)(container).children(Selector.ACTIVE);

	      var active = activeElements[0];
	      var isTransitioning = callback && active && (0, _jquery2.default)(active).hasClass(ClassName.FADE);
	      var complete = function complete() {
	        return _this2._transitionComplete(element, active, callback);
	      };

	      if (active && isTransitioning) {
	        var transitionDuration = _util2.default.getTransitionDurationFromElement(active);

	        (0, _jquery2.default)(active).removeClass(ClassName.SHOW).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }
	    }
	  }, {
	    key: '_transitionComplete',
	    value: function _transitionComplete(element, active, callback) {
	      if (active) {
	        (0, _jquery2.default)(active).removeClass(ClassName.ACTIVE);

	        var dropdownChild = (0, _jquery2.default)(active.parentNode).find(Selector.DROPDOWN_ACTIVE_CHILD)[0];

	        if (dropdownChild) {
	          (0, _jquery2.default)(dropdownChild).removeClass(ClassName.ACTIVE);
	        }

	        if (active.getAttribute('role') === 'tab') {
	          active.setAttribute('aria-selected', false);
	        }
	      }

	      (0, _jquery2.default)(element).addClass(ClassName.ACTIVE);
	      if (element.getAttribute('role') === 'tab') {
	        element.setAttribute('aria-selected', true);
	      }

	      _util2.default.reflow(element);

	      if (element.classList.contains(ClassName.FADE)) {
	        element.classList.add(ClassName.SHOW);
	      }

	      if (element.parentNode && (0, _jquery2.default)(element.parentNode).hasClass(ClassName.DROPDOWN_MENU)) {
	        var dropdownElement = (0, _jquery2.default)(element).closest(Selector.DROPDOWN)[0];

	        if (dropdownElement) {
	          var dropdownToggleList = [].slice.call(dropdownElement.querySelectorAll(Selector.DROPDOWN_TOGGLE));

	          (0, _jquery2.default)(dropdownToggleList).addClass(ClassName.ACTIVE);
	        }

	        element.setAttribute('aria-expanded', true);
	      }

	      if (callback) {
	        callback();
	      }
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var $this = (0, _jquery2.default)(this);
	        var data = $this.data(DATA_KEY);

	        if (!data) {
	          data = new Tab(this);
	          $this.data(DATA_KEY, data);
	        }

	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }]);

	  return Tab;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * Data Api implementation
	 * ------------------------------------------------------------------------
	 */

	(0, _jquery2.default)(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function (event) {
	  event.preventDefault();
	  Tab._jQueryInterface.call((0, _jquery2.default)(this), 'show');
	});

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Tab._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Tab;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Tab._jQueryInterface;
	};

	exports.default = Tab;

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Bootstrap (v4.3.1): tooltip.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * --------------------------------------------------------------------------
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */

	var _sanitizer = __webpack_require__(161);

	var _jquery = __webpack_require__(109);

	var _jquery2 = _interopRequireDefault(_jquery);

	var _popper = __webpack_require__(156);

	var _popper2 = _interopRequireDefault(_popper);

	var _util = __webpack_require__(151);

	var _util2 = _interopRequireDefault(_util);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	/**
	 * ------------------------------------------------------------------------
	 * Constants
	 * ------------------------------------------------------------------------
	 */

	var NAME = 'tooltip';
	var VERSION = '4.3.1';
	var DATA_KEY = 'bs.tooltip';
	var EVENT_KEY = '.' + DATA_KEY;
	var JQUERY_NO_CONFLICT = _jquery2.default.fn[NAME];
	var CLASS_PREFIX = 'bs-tooltip';
	var BSCLS_PREFIX_REGEX = new RegExp('(^|\\s)' + CLASS_PREFIX + '\\S+', 'g');
	var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];

	var DefaultType = {
	  animation: 'boolean',
	  template: 'string',
	  title: '(string|element|function)',
	  trigger: 'string',
	  delay: '(number|object)',
	  html: 'boolean',
	  selector: '(string|boolean)',
	  placement: '(string|function)',
	  offset: '(number|string|function)',
	  container: '(string|element|boolean)',
	  fallbackPlacement: '(string|array)',
	  boundary: '(string|element)',
	  sanitize: 'boolean',
	  sanitizeFn: '(null|function)',
	  whiteList: 'object'
	};

	var AttachmentMap = {
	  AUTO: 'auto',
	  TOP: 'top',
	  RIGHT: 'right',
	  BOTTOM: 'bottom',
	  LEFT: 'left'
	};

	var Default = {
	  animation: true,
	  template: '<div class="tooltip" role="tooltip">' + '<div class="arrow"></div>' + '<div class="tooltip-inner"></div></div>',
	  trigger: 'hover focus',
	  title: '',
	  delay: 0,
	  html: false,
	  selector: false,
	  placement: 'top',
	  offset: 0,
	  container: false,
	  fallbackPlacement: 'flip',
	  boundary: 'scrollParent',
	  sanitize: true,
	  sanitizeFn: null,
	  whiteList: _sanitizer.DefaultWhitelist
	};

	var HoverState = {
	  SHOW: 'show',
	  OUT: 'out'
	};

	var Event = {
	  HIDE: 'hide' + EVENT_KEY,
	  HIDDEN: 'hidden' + EVENT_KEY,
	  SHOW: 'show' + EVENT_KEY,
	  SHOWN: 'shown' + EVENT_KEY,
	  INSERTED: 'inserted' + EVENT_KEY,
	  CLICK: 'click' + EVENT_KEY,
	  FOCUSIN: 'focusin' + EVENT_KEY,
	  FOCUSOUT: 'focusout' + EVENT_KEY,
	  MOUSEENTER: 'mouseenter' + EVENT_KEY,
	  MOUSELEAVE: 'mouseleave' + EVENT_KEY
	};

	var ClassName = {
	  FADE: 'fade',
	  SHOW: 'show'
	};

	var Selector = {
	  TOOLTIP: '.tooltip',
	  TOOLTIP_INNER: '.tooltip-inner',
	  ARROW: '.arrow'
	};

	var Trigger = {
	  HOVER: 'hover',
	  FOCUS: 'focus',
	  CLICK: 'click',
	  MANUAL: 'manual'

	  /**
	   * ------------------------------------------------------------------------
	   * Class Definition
	   * ------------------------------------------------------------------------
	   */

	};
	var Tooltip = function () {
	  function Tooltip(element, config) {
	    _classCallCheck(this, Tooltip);

	    /**
	     * Check for Popper dependency
	     * Popper - https://popper.js.org
	     */
	    if (typeof _popper2.default === 'undefined') {
	      throw new TypeError('Bootstrap\'s tooltips require Popper.js (https://popper.js.org/)');
	    }

	    // private
	    this._isEnabled = true;
	    this._timeout = 0;
	    this._hoverState = '';
	    this._activeTrigger = {};
	    this._popper = null;

	    // Protected
	    this.element = element;
	    this.config = this._getConfig(config);
	    this.tip = null;

	    this._setListeners();
	  }

	  // Getters

	  _createClass(Tooltip, [{
	    key: 'enable',


	    // Public

	    value: function enable() {
	      this._isEnabled = true;
	    }
	  }, {
	    key: 'disable',
	    value: function disable() {
	      this._isEnabled = false;
	    }
	  }, {
	    key: 'toggleEnabled',
	    value: function toggleEnabled() {
	      this._isEnabled = !this._isEnabled;
	    }
	  }, {
	    key: 'toggle',
	    value: function toggle(event) {
	      if (!this._isEnabled) {
	        return;
	      }

	      if (event) {
	        var dataKey = this.constructor.DATA_KEY;
	        var context = (0, _jquery2.default)(event.currentTarget).data(dataKey);

	        if (!context) {
	          context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	          (0, _jquery2.default)(event.currentTarget).data(dataKey, context);
	        }

	        context._activeTrigger.click = !context._activeTrigger.click;

	        if (context._isWithActiveTrigger()) {
	          context._enter(null, context);
	        } else {
	          context._leave(null, context);
	        }
	      } else {
	        if ((0, _jquery2.default)(this.getTipElement()).hasClass(ClassName.SHOW)) {
	          this._leave(null, this);
	          return;
	        }

	        this._enter(null, this);
	      }
	    }
	  }, {
	    key: 'dispose',
	    value: function dispose() {
	      clearTimeout(this._timeout);

	      _jquery2.default.removeData(this.element, this.constructor.DATA_KEY);

	      (0, _jquery2.default)(this.element).off(this.constructor.EVENT_KEY);
	      (0, _jquery2.default)(this.element).closest('.modal').off('hide.bs.modal');

	      if (this.tip) {
	        (0, _jquery2.default)(this.tip).remove();
	      }

	      this._isEnabled = null;
	      this._timeout = null;
	      this._hoverState = null;
	      this._activeTrigger = null;
	      if (this._popper !== null) {
	        this._popper.destroy();
	      }

	      this._popper = null;
	      this.element = null;
	      this.config = null;
	      this.tip = null;
	    }
	  }, {
	    key: 'show',
	    value: function show() {
	      var _this = this;

	      if ((0, _jquery2.default)(this.element).css('display') === 'none') {
	        throw new Error('Please use show on visible elements');
	      }

	      var showEvent = _jquery2.default.Event(this.constructor.Event.SHOW);
	      if (this.isWithContent() && this._isEnabled) {
	        (0, _jquery2.default)(this.element).trigger(showEvent);

	        var shadowRoot = _util2.default.findShadowRoot(this.element);
	        var isInTheDom = _jquery2.default.contains(shadowRoot !== null ? shadowRoot : this.element.ownerDocument.documentElement, this.element);

	        if (showEvent.isDefaultPrevented() || !isInTheDom) {
	          return;
	        }

	        var tip = this.getTipElement();
	        var tipId = _util2.default.getUID(this.constructor.NAME);

	        tip.setAttribute('id', tipId);
	        this.element.setAttribute('aria-describedby', tipId);

	        this.setContent();

	        if (this.config.animation) {
	          (0, _jquery2.default)(tip).addClass(ClassName.FADE);
	        }

	        var placement = typeof this.config.placement === 'function' ? this.config.placement.call(this, tip, this.element) : this.config.placement;

	        var attachment = this._getAttachment(placement);
	        this.addAttachmentClass(attachment);

	        var container = this._getContainer();
	        (0, _jquery2.default)(tip).data(this.constructor.DATA_KEY, this);

	        if (!_jquery2.default.contains(this.element.ownerDocument.documentElement, this.tip)) {
	          (0, _jquery2.default)(tip).appendTo(container);
	        }

	        (0, _jquery2.default)(this.element).trigger(this.constructor.Event.INSERTED);

	        this._popper = new _popper2.default(this.element, tip, {
	          placement: attachment,
	          modifiers: {
	            offset: this._getOffset(),
	            flip: {
	              behavior: this.config.fallbackPlacement
	            },
	            arrow: {
	              element: Selector.ARROW
	            },
	            preventOverflow: {
	              boundariesElement: this.config.boundary
	            }
	          },
	          onCreate: function onCreate(data) {
	            if (data.originalPlacement !== data.placement) {
	              _this._handlePopperPlacementChange(data);
	            }
	          },
	          onUpdate: function onUpdate(data) {
	            return _this._handlePopperPlacementChange(data);
	          }
	        });

	        (0, _jquery2.default)(tip).addClass(ClassName.SHOW);

	        // If this is a touch-enabled device we add extra
	        // empty mouseover listeners to the body's immediate children;
	        // only needed because of broken event delegation on iOS
	        // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
	        if ('ontouchstart' in document.documentElement) {
	          (0, _jquery2.default)(document.body).children().on('mouseover', null, _jquery2.default.noop);
	        }

	        var complete = function complete() {
	          if (_this.config.animation) {
	            _this._fixTransition();
	          }
	          var prevHoverState = _this._hoverState;
	          _this._hoverState = null;

	          (0, _jquery2.default)(_this.element).trigger(_this.constructor.Event.SHOWN);

	          if (prevHoverState === HoverState.OUT) {
	            _this._leave(null, _this);
	          }
	        };

	        if ((0, _jquery2.default)(this.tip).hasClass(ClassName.FADE)) {
	          var transitionDuration = _util2.default.getTransitionDurationFromElement(this.tip);

	          (0, _jquery2.default)(this.tip).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	        } else {
	          complete();
	        }
	      }
	    }
	  }, {
	    key: 'hide',
	    value: function hide(callback) {
	      var _this2 = this;

	      var tip = this.getTipElement();
	      var hideEvent = _jquery2.default.Event(this.constructor.Event.HIDE);
	      var complete = function complete() {
	        if (_this2._hoverState !== HoverState.SHOW && tip.parentNode) {
	          tip.parentNode.removeChild(tip);
	        }

	        _this2._cleanTipClass();
	        _this2.element.removeAttribute('aria-describedby');
	        (0, _jquery2.default)(_this2.element).trigger(_this2.constructor.Event.HIDDEN);
	        if (_this2._popper !== null) {
	          _this2._popper.destroy();
	        }

	        if (callback) {
	          callback();
	        }
	      };

	      (0, _jquery2.default)(this.element).trigger(hideEvent);

	      if (hideEvent.isDefaultPrevented()) {
	        return;
	      }

	      (0, _jquery2.default)(tip).removeClass(ClassName.SHOW);

	      // If this is a touch-enabled device we remove the extra
	      // empty mouseover listeners we added for iOS support
	      if ('ontouchstart' in document.documentElement) {
	        (0, _jquery2.default)(document.body).children().off('mouseover', null, _jquery2.default.noop);
	      }

	      this._activeTrigger[Trigger.CLICK] = false;
	      this._activeTrigger[Trigger.FOCUS] = false;
	      this._activeTrigger[Trigger.HOVER] = false;

	      if ((0, _jquery2.default)(this.tip).hasClass(ClassName.FADE)) {
	        var transitionDuration = _util2.default.getTransitionDurationFromElement(tip);

	        (0, _jquery2.default)(tip).one(_util2.default.TRANSITION_END, complete).emulateTransitionEnd(transitionDuration);
	      } else {
	        complete();
	      }

	      this._hoverState = '';
	    }
	  }, {
	    key: 'update',
	    value: function update() {
	      if (this._popper !== null) {
	        this._popper.scheduleUpdate();
	      }
	    }

	    // Protected

	  }, {
	    key: 'isWithContent',
	    value: function isWithContent() {
	      return Boolean(this.getTitle());
	    }
	  }, {
	    key: 'addAttachmentClass',
	    value: function addAttachmentClass(attachment) {
	      (0, _jquery2.default)(this.getTipElement()).addClass(CLASS_PREFIX + '-' + attachment);
	    }
	  }, {
	    key: 'getTipElement',
	    value: function getTipElement() {
	      this.tip = this.tip || (0, _jquery2.default)(this.config.template)[0];
	      return this.tip;
	    }
	  }, {
	    key: 'setContent',
	    value: function setContent() {
	      var tip = this.getTipElement();
	      this.setElementContent((0, _jquery2.default)(tip.querySelectorAll(Selector.TOOLTIP_INNER)), this.getTitle());
	      (0, _jquery2.default)(tip).removeClass(ClassName.FADE + ' ' + ClassName.SHOW);
	    }
	  }, {
	    key: 'setElementContent',
	    value: function setElementContent($element, content) {
	      if ((typeof content === 'undefined' ? 'undefined' : _typeof(content)) === 'object' && (content.nodeType || content.jquery)) {
	        // Content is a DOM node or a jQuery
	        if (this.config.html) {
	          if (!(0, _jquery2.default)(content).parent().is($element)) {
	            $element.empty().append(content);
	          }
	        } else {
	          $element.text((0, _jquery2.default)(content).text());
	        }

	        return;
	      }

	      if (this.config.html) {
	        if (this.config.sanitize) {
	          content = (0, _sanitizer.sanitizeHtml)(content, this.config.whiteList, this.config.sanitizeFn);
	        }

	        $element.html(content);
	      } else {
	        $element.text(content);
	      }
	    }
	  }, {
	    key: 'getTitle',
	    value: function getTitle() {
	      var title = this.element.getAttribute('data-original-title');

	      if (!title) {
	        title = typeof this.config.title === 'function' ? this.config.title.call(this.element) : this.config.title;
	      }

	      return title;
	    }

	    // Private

	  }, {
	    key: '_getOffset',
	    value: function _getOffset() {
	      var _this3 = this;

	      var offset = {};

	      if (typeof this.config.offset === 'function') {
	        offset.fn = function (data) {
	          data.offsets = _extends({}, data.offsets, _this3.config.offset(data.offsets, _this3.element) || {});

	          return data;
	        };
	      } else {
	        offset.offset = this.config.offset;
	      }

	      return offset;
	    }
	  }, {
	    key: '_getContainer',
	    value: function _getContainer() {
	      if (this.config.container === false) {
	        return document.body;
	      }

	      if (_util2.default.isElement(this.config.container)) {
	        return (0, _jquery2.default)(this.config.container);
	      }

	      return (0, _jquery2.default)(document).find(this.config.container);
	    }
	  }, {
	    key: '_getAttachment',
	    value: function _getAttachment(placement) {
	      return AttachmentMap[placement.toUpperCase()];
	    }
	  }, {
	    key: '_setListeners',
	    value: function _setListeners() {
	      var _this4 = this;

	      var triggers = this.config.trigger.split(' ');

	      triggers.forEach(function (trigger) {
	        if (trigger === 'click') {
	          (0, _jquery2.default)(_this4.element).on(_this4.constructor.Event.CLICK, _this4.config.selector, function (event) {
	            return _this4.toggle(event);
	          });
	        } else if (trigger !== Trigger.MANUAL) {
	          var eventIn = trigger === Trigger.HOVER ? _this4.constructor.Event.MOUSEENTER : _this4.constructor.Event.FOCUSIN;
	          var eventOut = trigger === Trigger.HOVER ? _this4.constructor.Event.MOUSELEAVE : _this4.constructor.Event.FOCUSOUT;

	          (0, _jquery2.default)(_this4.element).on(eventIn, _this4.config.selector, function (event) {
	            return _this4._enter(event);
	          }).on(eventOut, _this4.config.selector, function (event) {
	            return _this4._leave(event);
	          });
	        }
	      });

	      (0, _jquery2.default)(this.element).closest('.modal').on('hide.bs.modal', function () {
	        if (_this4.element) {
	          _this4.hide();
	        }
	      });

	      if (this.config.selector) {
	        this.config = _extends({}, this.config, {
	          trigger: 'manual',
	          selector: ''
	        });
	      } else {
	        this._fixTitle();
	      }
	    }
	  }, {
	    key: '_fixTitle',
	    value: function _fixTitle() {
	      var titleType = _typeof(this.element.getAttribute('data-original-title'));

	      if (this.element.getAttribute('title') || titleType !== 'string') {
	        this.element.setAttribute('data-original-title', this.element.getAttribute('title') || '');

	        this.element.setAttribute('title', '');
	      }
	    }
	  }, {
	    key: '_enter',
	    value: function _enter(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || (0, _jquery2.default)(event.currentTarget).data(dataKey);

	      if (!context) {
	        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	        (0, _jquery2.default)(event.currentTarget).data(dataKey, context);
	      }

	      if (event) {
	        context._activeTrigger[event.type === 'focusin' ? Trigger.FOCUS : Trigger.HOVER] = true;
	      }

	      if ((0, _jquery2.default)(context.getTipElement()).hasClass(ClassName.SHOW) || context._hoverState === HoverState.SHOW) {
	        context._hoverState = HoverState.SHOW;
	        return;
	      }

	      clearTimeout(context._timeout);

	      context._hoverState = HoverState.SHOW;

	      if (!context.config.delay || !context.config.delay.show) {
	        context.show();
	        return;
	      }

	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HoverState.SHOW) {
	          context.show();
	        }
	      }, context.config.delay.show);
	    }
	  }, {
	    key: '_leave',
	    value: function _leave(event, context) {
	      var dataKey = this.constructor.DATA_KEY;
	      context = context || (0, _jquery2.default)(event.currentTarget).data(dataKey);

	      if (!context) {
	        context = new this.constructor(event.currentTarget, this._getDelegateConfig());
	        (0, _jquery2.default)(event.currentTarget).data(dataKey, context);
	      }

	      if (event) {
	        context._activeTrigger[event.type === 'focusout' ? Trigger.FOCUS : Trigger.HOVER] = false;
	      }

	      if (context._isWithActiveTrigger()) {
	        return;
	      }

	      clearTimeout(context._timeout);

	      context._hoverState = HoverState.OUT;

	      if (!context.config.delay || !context.config.delay.hide) {
	        context.hide();
	        return;
	      }

	      context._timeout = setTimeout(function () {
	        if (context._hoverState === HoverState.OUT) {
	          context.hide();
	        }
	      }, context.config.delay.hide);
	    }
	  }, {
	    key: '_isWithActiveTrigger',
	    value: function _isWithActiveTrigger() {
	      for (var trigger in this._activeTrigger) {
	        if (this._activeTrigger[trigger]) {
	          return true;
	        }
	      }

	      return false;
	    }
	  }, {
	    key: '_getConfig',
	    value: function _getConfig(config) {
	      var dataAttributes = (0, _jquery2.default)(this.element).data();

	      Object.keys(dataAttributes).forEach(function (dataAttr) {
	        if (DISALLOWED_ATTRIBUTES.indexOf(dataAttr) !== -1) {
	          delete dataAttributes[dataAttr];
	        }
	      });

	      config = _extends({}, this.constructor.Default, dataAttributes, (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config ? config : {});

	      if (typeof config.delay === 'number') {
	        config.delay = {
	          show: config.delay,
	          hide: config.delay
	        };
	      }

	      if (typeof config.title === 'number') {
	        config.title = config.title.toString();
	      }

	      if (typeof config.content === 'number') {
	        config.content = config.content.toString();
	      }

	      _util2.default.typeCheckConfig(NAME, config, this.constructor.DefaultType);

	      if (config.sanitize) {
	        config.template = (0, _sanitizer.sanitizeHtml)(config.template, config.whiteList, config.sanitizeFn);
	      }

	      return config;
	    }
	  }, {
	    key: '_getDelegateConfig',
	    value: function _getDelegateConfig() {
	      var config = {};

	      if (this.config) {
	        for (var key in this.config) {
	          if (this.constructor.Default[key] !== this.config[key]) {
	            config[key] = this.config[key];
	          }
	        }
	      }

	      return config;
	    }
	  }, {
	    key: '_cleanTipClass',
	    value: function _cleanTipClass() {
	      var $tip = (0, _jquery2.default)(this.getTipElement());
	      var tabClass = $tip.attr('class').match(BSCLS_PREFIX_REGEX);
	      if (tabClass !== null && tabClass.length) {
	        $tip.removeClass(tabClass.join(''));
	      }
	    }
	  }, {
	    key: '_handlePopperPlacementChange',
	    value: function _handlePopperPlacementChange(popperData) {
	      var popperInstance = popperData.instance;
	      this.tip = popperInstance.popper;
	      this._cleanTipClass();
	      this.addAttachmentClass(this._getAttachment(popperData.placement));
	    }
	  }, {
	    key: '_fixTransition',
	    value: function _fixTransition() {
	      var tip = this.getTipElement();
	      var initConfigAnimation = this.config.animation;

	      if (tip.getAttribute('x-placement') !== null) {
	        return;
	      }

	      (0, _jquery2.default)(tip).removeClass(ClassName.FADE);
	      this.config.animation = false;
	      this.hide();
	      this.show();
	      this.config.animation = initConfigAnimation;
	    }

	    // Static

	  }], [{
	    key: '_jQueryInterface',
	    value: function _jQueryInterface(config) {
	      return this.each(function () {
	        var data = (0, _jquery2.default)(this).data(DATA_KEY);
	        var _config = (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config;

	        if (!data && /dispose|hide/.test(config)) {
	          return;
	        }

	        if (!data) {
	          data = new Tooltip(this, _config);
	          (0, _jquery2.default)(this).data(DATA_KEY, data);
	        }

	        if (typeof config === 'string') {
	          if (typeof data[config] === 'undefined') {
	            throw new TypeError('No method named "' + config + '"');
	          }
	          data[config]();
	        }
	      });
	    }
	  }, {
	    key: 'VERSION',
	    get: function get() {
	      return VERSION;
	    }
	  }, {
	    key: 'Default',
	    get: function get() {
	      return Default;
	    }
	  }, {
	    key: 'NAME',
	    get: function get() {
	      return NAME;
	    }
	  }, {
	    key: 'DATA_KEY',
	    get: function get() {
	      return DATA_KEY;
	    }
	  }, {
	    key: 'Event',
	    get: function get() {
	      return Event;
	    }
	  }, {
	    key: 'EVENT_KEY',
	    get: function get() {
	      return EVENT_KEY;
	    }
	  }, {
	    key: 'DefaultType',
	    get: function get() {
	      return DefaultType;
	    }
	  }]);

	  return Tooltip;
	}();

	/**
	 * ------------------------------------------------------------------------
	 * jQuery
	 * ------------------------------------------------------------------------
	 */

	_jquery2.default.fn[NAME] = Tooltip._jQueryInterface;
	_jquery2.default.fn[NAME].Constructor = Tooltip;
	_jquery2.default.fn[NAME].noConflict = function () {
	  _jquery2.default.fn[NAME] = JQUERY_NO_CONFLICT;
	  return Tooltip._jQueryInterface;
	};

	exports.default = Tooltip;

/***/ }),
/* 161 */
/***/ (function(module, exports) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.sanitizeHtml = sanitizeHtml;
	/**
	 * --------------------------------------------------------------------------
	 * Bootstrap (v4.3.1): tools/sanitizer.js
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * --------------------------------------------------------------------------
	 */

	var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];

	var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;

	var DefaultWhitelist = exports.DefaultWhitelist = {
	  // Global attributes allowed on any supplied element below.
	  '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
	  a: ['target', 'href', 'title', 'rel'],
	  area: [],
	  b: [],
	  br: [],
	  col: [],
	  code: [],
	  div: [],
	  em: [],
	  hr: [],
	  h1: [],
	  h2: [],
	  h3: [],
	  h4: [],
	  h5: [],
	  h6: [],
	  i: [],
	  img: ['src', 'alt', 'title', 'width', 'height'],
	  li: [],
	  ol: [],
	  p: [],
	  pre: [],
	  s: [],
	  small: [],
	  span: [],
	  sub: [],
	  sup: [],
	  strong: [],
	  u: [],
	  ul: []

	  /**
	   * A pattern that recognizes a commonly useful subset of URLs that are safe.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	};var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;

	/**
	 * A pattern that matches safe data URLs. Only matches image, video and audio types.
	 *
	 * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	 */
	var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

	function allowedAttribute(attr, allowedAttributeList) {
	  var attrName = attr.nodeName.toLowerCase();

	  if (allowedAttributeList.indexOf(attrName) !== -1) {
	    if (uriAttrs.indexOf(attrName) !== -1) {
	      return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
	    }

	    return true;
	  }

	  var regExp = allowedAttributeList.filter(function (attrRegex) {
	    return attrRegex instanceof RegExp;
	  });

	  // Check if a regular expression validates the attribute.
	  for (var i = 0, l = regExp.length; i < l; i++) {
	    if (attrName.match(regExp[i])) {
	      return true;
	    }
	  }

	  return false;
	}

	function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
	  if (unsafeHtml.length === 0) {
	    return unsafeHtml;
	  }

	  if (sanitizeFn && typeof sanitizeFn === 'function') {
	    return sanitizeFn(unsafeHtml);
	  }

	  var domParser = new window.DOMParser();
	  var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
	  var whitelistKeys = Object.keys(whiteList);
	  var elements = [].slice.call(createdDocument.body.querySelectorAll('*'));

	  var _loop = function _loop(i, len) {
	    var el = elements[i];
	    var elName = el.nodeName.toLowerCase();

	    if (whitelistKeys.indexOf(el.nodeName.toLowerCase()) === -1) {
	      el.parentNode.removeChild(el);

	      return 'continue';
	    }

	    var attributeList = [].slice.call(el.attributes);
	    var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);

	    attributeList.forEach(function (attr) {
	      if (!allowedAttribute(attr, whitelistedAttributes)) {
	        el.removeAttribute(attr.nodeName);
	      }
	    });
	  };

	  for (var i = 0, len = elements.length; i < len; i++) {
	    var _ret = _loop(i, len);

	    if (_ret === 'continue') continue;
	  }

	  return createdDocument.body.innerHTML;
	}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	(function ($) {
	  'use strict';

	  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn'];

	  var uriAttrs = ['background', 'cite', 'href', 'itemtype', 'longdesc', 'poster', 'src', 'xlink:href'];

	  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;

	  var DefaultWhitelist = {
	    // Global attributes allowed on any supplied element below.
	    '*': ['class', 'dir', 'id', 'lang', 'role', 'tabindex', 'style', ARIA_ATTRIBUTE_PATTERN],
	    a: ['target', 'href', 'title', 'rel'],
	    area: [],
	    b: [],
	    br: [],
	    col: [],
	    code: [],
	    div: [],
	    em: [],
	    hr: [],
	    h1: [],
	    h2: [],
	    h3: [],
	    h4: [],
	    h5: [],
	    h6: [],
	    i: [],
	    img: ['src', 'alt', 'title', 'width', 'height'],
	    li: [],
	    ol: [],
	    p: [],
	    pre: [],
	    s: [],
	    small: [],
	    span: [],
	    sub: [],
	    sup: [],
	    strong: [],
	    u: [],
	    ul: []

	    /**
	     * A pattern that recognizes a commonly useful subset of URLs that are safe.
	     *
	     * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	     */
	  };var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;

	  /**
	   * A pattern that matches safe data URLs. Only matches image, video and audio types.
	   *
	   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
	   */
	  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i;

	  function allowedAttribute(attr, allowedAttributeList) {
	    var attrName = attr.nodeName.toLowerCase();

	    if ($.inArray(attrName, allowedAttributeList) !== -1) {
	      if ($.inArray(attrName, uriAttrs) !== -1) {
	        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN));
	      }

	      return true;
	    }

	    var regExp = $(allowedAttributeList).filter(function (index, value) {
	      return value instanceof RegExp;
	    });

	    // Check if a regular expression validates the attribute.
	    for (var i = 0, l = regExp.length; i < l; i++) {
	      if (attrName.match(regExp[i])) {
	        return true;
	      }
	    }

	    return false;
	  }

	  function sanitizeHtml(unsafeElements, whiteList, sanitizeFn) {
	    if (sanitizeFn && typeof sanitizeFn === 'function') {
	      return sanitizeFn(unsafeElements);
	    }

	    var whitelistKeys = Object.keys(whiteList);

	    for (var i = 0, len = unsafeElements.length; i < len; i++) {
	      var elements = unsafeElements[i].querySelectorAll('*');

	      for (var j = 0, len2 = elements.length; j < len2; j++) {
	        var el = elements[j];
	        var elName = el.nodeName.toLowerCase();

	        if (whitelistKeys.indexOf(elName) === -1) {
	          el.parentNode.removeChild(el);

	          continue;
	        }

	        var attributeList = [].slice.call(el.attributes);
	        var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || []);

	        for (var k = 0, len3 = attributeList.length; k < len3; k++) {
	          var attr = attributeList[k];

	          if (!allowedAttribute(attr, whitelistedAttributes)) {
	            el.removeAttribute(attr.nodeName);
	          }
	        }
	      }
	    }
	  }

	  // Polyfill for browsers with no classList support
	  // Remove in v2
	  if (!('classList' in document.createElement('_'))) {
	    (function (view) {
	      if (!('Element' in view)) return;

	      var classListProp = 'classList',
	          protoProp = 'prototype',
	          elemCtrProto = view.Element[protoProp],
	          objCtr = Object,
	          classListGetter = function classListGetter() {
	        var $elem = $(this);

	        return {
	          add: function add(classes) {
	            classes = Array.prototype.slice.call(arguments).join(' ');
	            return $elem.addClass(classes);
	          },
	          remove: function remove(classes) {
	            classes = Array.prototype.slice.call(arguments).join(' ');
	            return $elem.removeClass(classes);
	          },
	          toggle: function toggle(classes, force) {
	            return $elem.toggleClass(classes, force);
	          },
	          contains: function contains(classes) {
	            return $elem.hasClass(classes);
	          }
	        };
	      };

	      if (objCtr.defineProperty) {
	        var classListPropDesc = {
	          get: classListGetter,
	          enumerable: true,
	          configurable: true
	        };
	        try {
	          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	        } catch (ex) {
	          // IE 8 doesn't support enumerable:true
	          // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
	          // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
	          if (ex.number === undefined || ex.number === -0x7FF5EC54) {
	            classListPropDesc.enumerable = false;
	            objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
	          }
	        }
	      } else if (objCtr[protoProp].__defineGetter__) {
	        elemCtrProto.__defineGetter__(classListProp, classListGetter);
	      }
	    })(window);
	  }

	  var testElement = document.createElement('_');

	  testElement.classList.add('c1', 'c2');

	  if (!testElement.classList.contains('c2')) {
	    var _add = DOMTokenList.prototype.add,
	        _remove = DOMTokenList.prototype.remove;

	    DOMTokenList.prototype.add = function () {
	      Array.prototype.forEach.call(arguments, _add.bind(this));
	    };

	    DOMTokenList.prototype.remove = function () {
	      Array.prototype.forEach.call(arguments, _remove.bind(this));
	    };
	  }

	  testElement.classList.toggle('c3', false);

	  // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
	  // support the second argument.
	  if (testElement.classList.contains('c3')) {
	    var _toggle = DOMTokenList.prototype.toggle;

	    DOMTokenList.prototype.toggle = function (token, force) {
	      if (1 in arguments && !this.contains(token) === !force) {
	        return force;
	      } else {
	        return _toggle.call(this, token);
	      }
	    };
	  }

	  testElement = null;

	  // shallow array comparison
	  function isEqual(array1, array2) {
	    return array1.length === array2.length && array1.every(function (element, index) {
	      return element === array2[index];
	    });
	  };

	  // <editor-fold desc="Shims">
	  if (!String.prototype.startsWith) {
	    (function () {
	      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`

	      var defineProperty = function () {
	        // IE 8 only supports `Object.defineProperty` on DOM elements
	        try {
	          var object = {};
	          var $defineProperty = Object.defineProperty;
	          var result = $defineProperty(object, object, object) && $defineProperty;
	        } catch (error) {}
	        return result;
	      }();
	      var toString = {}.toString;
	      var startsWith = function startsWith(search) {
	        if (this == null) {
	          throw new TypeError();
	        }
	        var string = String(this);
	        if (search && toString.call(search) == '[object RegExp]') {
	          throw new TypeError();
	        }
	        var stringLength = string.length;
	        var searchString = String(search);
	        var searchLength = searchString.length;
	        var position = arguments.length > 1 ? arguments[1] : undefined;
	        // `ToInteger`
	        var pos = position ? Number(position) : 0;
	        if (pos != pos) {
	          // better `isNaN`
	          pos = 0;
	        }
	        var start = Math.min(Math.max(pos, 0), stringLength);
	        // Avoid the `indexOf` call if no match is possible
	        if (searchLength + start > stringLength) {
	          return false;
	        }
	        var index = -1;
	        while (++index < searchLength) {
	          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
	            return false;
	          }
	        }
	        return true;
	      };
	      if (defineProperty) {
	        defineProperty(String.prototype, 'startsWith', {
	          'value': startsWith,
	          'configurable': true,
	          'writable': true
	        });
	      } else {
	        String.prototype.startsWith = startsWith;
	      }
	    })();
	  }

	  if (!Object.keys) {
	    Object.keys = function (o, // object
	    k, // key
	    r // result array
	    ) {
	      // initialize object and result
	      r = [];
	      // iterate over object keys
	      for (k in o) {
	        // fill result array with non-prototypical keys
	        r.hasOwnProperty.call(o, k) && r.push(k);
	      }
	      // return result
	      return r;
	    };
	  }

	  if (HTMLSelectElement && !HTMLSelectElement.prototype.hasOwnProperty('selectedOptions')) {
	    Object.defineProperty(HTMLSelectElement.prototype, 'selectedOptions', {
	      get: function get() {
	        return this.querySelectorAll(':checked');
	      }
	    });
	  }

	  function getSelectedOptions(select, ignoreDisabled) {
	    var selectedOptions = select.selectedOptions,
	        options = [],
	        opt;

	    if (ignoreDisabled) {
	      for (var i = 0, len = selectedOptions.length; i < len; i++) {
	        opt = selectedOptions[i];

	        if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
	          options.push(opt);
	        }
	      }

	      return options;
	    }

	    return selectedOptions;
	  }

	  // much faster than $.val()
	  function getSelectValues(select, selectedOptions) {
	    var value = [],
	        options = selectedOptions || select.selectedOptions,
	        opt;

	    for (var i = 0, len = options.length; i < len; i++) {
	      opt = options[i];

	      if (!(opt.disabled || opt.parentNode.tagName === 'OPTGROUP' && opt.parentNode.disabled)) {
	        value.push(opt.value);
	      }
	    }

	    if (!select.multiple) {
	      return !value.length ? null : value[0];
	    }

	    return value;
	  }

	  // set data-selected on select element if the value has been programmatically selected
	  // prior to initialization of bootstrap-select
	  // * consider removing or replacing an alternative method *
	  var valHooks = {
	    useDefault: false,
	    _set: $.valHooks.select.set
	  };

	  $.valHooks.select.set = function (elem, value) {
	    if (value && !valHooks.useDefault) $(elem).data('selected', true);

	    return valHooks._set.apply(this, arguments);
	  };

	  var changedArguments = null;

	  var EventIsSupported = function () {
	    try {
	      new Event('change');
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }();

	  $.fn.triggerNative = function (eventName) {
	    var el = this[0],
	        event;

	    if (el.dispatchEvent) {
	      // for modern browsers & IE9+
	      if (EventIsSupported) {
	        // For modern browsers
	        event = new Event(eventName, {
	          bubbles: true
	        });
	      } else {
	        // For IE since it doesn't support Event constructor
	        event = document.createEvent('Event');
	        event.initEvent(eventName, true, false);
	      }

	      el.dispatchEvent(event);
	    } else if (el.fireEvent) {
	      // for IE8
	      event = document.createEventObject();
	      event.eventType = eventName;
	      el.fireEvent('on' + eventName, event);
	    } else {
	      // fall back to jQuery.trigger
	      this.trigger(eventName);
	    }
	  };
	  // </editor-fold>

	  function stringSearch(li, searchString, method, normalize) {
	    var stringTypes = ['display', 'subtext', 'tokens'],
	        searchSuccess = false;

	    for (var i = 0; i < stringTypes.length; i++) {
	      var stringType = stringTypes[i],
	          string = li[stringType];

	      if (string) {
	        string = string.toString();

	        // Strip HTML tags. This isn't perfect, but it's much faster than any other method
	        if (stringType === 'display') {
	          string = string.replace(/<[^>]+>/g, '');
	        }

	        if (normalize) string = normalizeToBase(string);
	        string = string.toUpperCase();

	        if (method === 'contains') {
	          searchSuccess = string.indexOf(searchString) >= 0;
	        } else {
	          searchSuccess = string.startsWith(searchString);
	        }

	        if (searchSuccess) break;
	      }
	    }

	    return searchSuccess;
	  }

	  function toInteger(value) {
	    return parseInt(value, 10) || 0;
	  }

	  // Borrowed from Lodash (_.deburr)
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A', '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a', '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C', '\xe7': 'c',
	    '\xd0': 'D', '\xf0': 'd',
	    '\xc8': 'E', '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e', '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I', '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i', '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N', '\xf1': 'n',
	    '\xd2': 'O', '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o', '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U', '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u', '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y', '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A', '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a', '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C', '\u0108': 'C', '\u010A': 'C', '\u010C': 'C',
	    '\u0107': 'c', '\u0109': 'c', '\u010B': 'c', '\u010D': 'c',
	    '\u010E': 'D', '\u0110': 'D', '\u010F': 'd', '\u0111': 'd',
	    '\u0112': 'E', '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011A': 'E',
	    '\u0113': 'e', '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011B': 'e',
	    '\u011C': 'G', '\u011E': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011D': 'g', '\u011F': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H', '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I', '\u012A': 'I', '\u012C': 'I', '\u012E': 'I', '\u0130': 'I',
	    '\u0129': 'i', '\u012B': 'i', '\u012D': 'i', '\u012F': 'i', '\u0131': 'i',
	    '\u0134': 'J', '\u0135': 'j',
	    '\u0136': 'K', '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L', '\u013B': 'L', '\u013D': 'L', '\u013F': 'L', '\u0141': 'L',
	    '\u013A': 'l', '\u013C': 'l', '\u013E': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N', '\u0145': 'N', '\u0147': 'N', '\u014A': 'N',
	    '\u0144': 'n', '\u0146': 'n', '\u0148': 'n', '\u014B': 'n',
	    '\u014C': 'O', '\u014E': 'O', '\u0150': 'O',
	    '\u014D': 'o', '\u014F': 'o', '\u0151': 'o',
	    '\u0154': 'R', '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r', '\u0157': 'r', '\u0159': 'r',
	    '\u015A': 'S', '\u015C': 'S', '\u015E': 'S', '\u0160': 'S',
	    '\u015B': 's', '\u015D': 's', '\u015F': 's', '\u0161': 's',
	    '\u0162': 'T', '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't', '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U', '\u016A': 'U', '\u016C': 'U', '\u016E': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u', '\u016B': 'u', '\u016D': 'u', '\u016F': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W', '\u0175': 'w',
	    '\u0176': 'Y', '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z', '\u017B': 'Z', '\u017D': 'Z',
	    '\u017A': 'z', '\u017C': 'z', '\u017E': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017F': 's'
	  };

	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

	  /** Used to compose unicode character classes. */
	  var rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboMarksExtendedRange = '\\u1ab0-\\u1aff',
	      rsComboMarksSupplementRange = '\\u1dc0-\\u1dff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange + rsComboMarksExtendedRange + rsComboMarksSupplementRange;

	  /** Used to compose unicode capture groups. */
	  var rsCombo = '[' + rsComboRange + ']';

	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');

	  function deburrLetter(key) {
	    return deburredLetters[key];
	  };

	  function normalizeToBase(string) {
	    string = string.toString();
	    return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	  }

	  // List of HTML entities for escaping.
	  var escapeMap = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#x27;',
	    '`': '&#x60;'
	  };

	  // Functions for escaping and unescaping strings to/from HTML interpolation.
	  var createEscaper = function createEscaper(map) {
	    var escaper = function escaper(match) {
	      return map[match];
	    };
	    // Regexes for identifying a key that needs to be escaped.
	    var source = '(?:' + Object.keys(map).join('|') + ')';
	    var testRegexp = RegExp(source);
	    var replaceRegexp = RegExp(source, 'g');
	    return function (string) {
	      string = string == null ? '' : '' + string;
	      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	    };
	  };

	  var htmlEscape = createEscaper(escapeMap);

	  /**
	   * ------------------------------------------------------------------------
	   * Constants
	   * ------------------------------------------------------------------------
	   */

	  var keyCodeMap = {
	    32: ' ',
	    48: '0',
	    49: '1',
	    50: '2',
	    51: '3',
	    52: '4',
	    53: '5',
	    54: '6',
	    55: '7',
	    56: '8',
	    57: '9',
	    59: ';',
	    65: 'A',
	    66: 'B',
	    67: 'C',
	    68: 'D',
	    69: 'E',
	    70: 'F',
	    71: 'G',
	    72: 'H',
	    73: 'I',
	    74: 'J',
	    75: 'K',
	    76: 'L',
	    77: 'M',
	    78: 'N',
	    79: 'O',
	    80: 'P',
	    81: 'Q',
	    82: 'R',
	    83: 'S',
	    84: 'T',
	    85: 'U',
	    86: 'V',
	    87: 'W',
	    88: 'X',
	    89: 'Y',
	    90: 'Z',
	    96: '0',
	    97: '1',
	    98: '2',
	    99: '3',
	    100: '4',
	    101: '5',
	    102: '6',
	    103: '7',
	    104: '8',
	    105: '9'
	  };

	  var keyCodes = {
	    ESCAPE: 27, // KeyboardEvent.which value for Escape (Esc) key
	    ENTER: 13, // KeyboardEvent.which value for Enter key
	    SPACE: 32, // KeyboardEvent.which value for space key
	    TAB: 9, // KeyboardEvent.which value for tab key
	    ARROW_UP: 38, // KeyboardEvent.which value for up arrow key
	    ARROW_DOWN: 40 // KeyboardEvent.which value for down arrow key
	  };

	  var version = {
	    success: false,
	    major: '3'
	  };

	  try {
	    version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
	    version.major = version.full[0];
	    version.success = true;
	  } catch (err) {
	    // do nothing
	  }

	  var selectId = 0;

	  var EVENT_KEY = '.bs.select';

	  var classNames = {
	    DISABLED: 'disabled',
	    DIVIDER: 'divider',
	    SHOW: 'open',
	    DROPUP: 'dropup',
	    MENU: 'dropdown-menu',
	    MENURIGHT: 'dropdown-menu-right',
	    MENULEFT: 'dropdown-menu-left',
	    // to-do: replace with more advanced template/customization options
	    BUTTONCLASS: 'btn-default',
	    POPOVERHEADER: 'popover-title',
	    ICONBASE: 'glyphicon',
	    TICKICON: 'glyphicon-ok'
	  };

	  var Selector = {
	    MENU: '.' + classNames.MENU
	  };

	  var elementTemplates = {
	    div: document.createElement('div'),
	    span: document.createElement('span'),
	    i: document.createElement('i'),
	    subtext: document.createElement('small'),
	    a: document.createElement('a'),
	    li: document.createElement('li'),
	    whitespace: document.createTextNode('\xA0'),
	    fragment: document.createDocumentFragment()
	  };

	  elementTemplates.noResults = elementTemplates.li.cloneNode(false);
	  elementTemplates.noResults.className = 'no-results';

	  elementTemplates.a.setAttribute('role', 'option');
	  elementTemplates.a.className = 'dropdown-item';

	  elementTemplates.subtext.className = 'text-muted';

	  elementTemplates.text = elementTemplates.span.cloneNode(false);
	  elementTemplates.text.className = 'text';

	  elementTemplates.checkMark = elementTemplates.span.cloneNode(false);

	  var REGEXP_ARROW = new RegExp(keyCodes.ARROW_UP + '|' + keyCodes.ARROW_DOWN);
	  var REGEXP_TAB_OR_ESCAPE = new RegExp('^' + keyCodes.TAB + '$|' + keyCodes.ESCAPE);

	  var generateOption = {
	    li: function li(content, classes, optgroup) {
	      var li = elementTemplates.li.cloneNode(false);

	      if (content) {
	        if (content.nodeType === 1 || content.nodeType === 11) {
	          li.appendChild(content);
	        } else {
	          li.innerHTML = content;
	        }
	      }

	      if (typeof classes !== 'undefined' && classes !== '') li.className = classes;
	      if (typeof optgroup !== 'undefined' && optgroup !== null) li.classList.add('optgroup-' + optgroup);

	      return li;
	    },

	    a: function a(text, classes, inline) {
	      var a = elementTemplates.a.cloneNode(true);

	      if (text) {
	        if (text.nodeType === 11) {
	          a.appendChild(text);
	        } else {
	          a.insertAdjacentHTML('beforeend', text);
	        }
	      }

	      if (typeof classes !== 'undefined' && classes !== '') a.classList.add.apply(a.classList, classes.split(/\s+/));
	      if (inline) a.setAttribute('style', inline);

	      return a;
	    },

	    text: function text(options, useFragment) {
	      var textElement = elementTemplates.text.cloneNode(false),
	          subtextElement,
	          iconElement;

	      if (options.content) {
	        textElement.innerHTML = options.content;
	      } else {
	        textElement.textContent = options.text;

	        if (options.icon) {
	          var whitespace = elementTemplates.whitespace.cloneNode(false);

	          // need to use <i> for icons in the button to prevent a breaking change
	          // note: switch to span in next major release
	          iconElement = (useFragment === true ? elementTemplates.i : elementTemplates.span).cloneNode(false);
	          iconElement.className = this.options.iconBase + ' ' + options.icon;

	          elementTemplates.fragment.appendChild(iconElement);
	          elementTemplates.fragment.appendChild(whitespace);
	        }

	        if (options.subtext) {
	          subtextElement = elementTemplates.subtext.cloneNode(false);
	          subtextElement.textContent = options.subtext;
	          textElement.appendChild(subtextElement);
	        }
	      }

	      if (useFragment === true) {
	        while (textElement.childNodes.length > 0) {
	          elementTemplates.fragment.appendChild(textElement.childNodes[0]);
	        }
	      } else {
	        elementTemplates.fragment.appendChild(textElement);
	      }

	      return elementTemplates.fragment;
	    },

	    label: function label(options) {
	      var textElement = elementTemplates.text.cloneNode(false),
	          subtextElement,
	          iconElement;

	      textElement.innerHTML = options.display;

	      if (options.icon) {
	        var whitespace = elementTemplates.whitespace.cloneNode(false);

	        iconElement = elementTemplates.span.cloneNode(false);
	        iconElement.className = this.options.iconBase + ' ' + options.icon;

	        elementTemplates.fragment.appendChild(iconElement);
	        elementTemplates.fragment.appendChild(whitespace);
	      }

	      if (options.subtext) {
	        subtextElement = elementTemplates.subtext.cloneNode(false);
	        subtextElement.textContent = options.subtext;
	        textElement.appendChild(subtextElement);
	      }

	      elementTemplates.fragment.appendChild(textElement);

	      return elementTemplates.fragment;
	    }
	  };

	  function showNoResults(searchMatch, searchValue) {
	    if (!searchMatch.length) {
	      elementTemplates.noResults.innerHTML = this.options.noneResultsText.replace('{0}', '"' + htmlEscape(searchValue) + '"');
	      this.$menuInner[0].firstChild.appendChild(elementTemplates.noResults);
	    }
	  }

	  var Selectpicker = function Selectpicker(element, options) {
	    var that = this;

	    // bootstrap-select has been initialized - revert valHooks.select.set back to its original function
	    if (!valHooks.useDefault) {
	      $.valHooks.select.set = valHooks._set;
	      valHooks.useDefault = true;
	    }

	    this.$element = $(element);
	    this.$newElement = null;
	    this.$button = null;
	    this.$menu = null;
	    this.options = options;
	    this.selectpicker = {
	      main: {},
	      search: {},
	      current: {}, // current changes if a search is in progress
	      view: {},
	      isSearching: false,
	      keydown: {
	        keyHistory: '',
	        resetKeyHistory: {
	          start: function start() {
	            return setTimeout(function () {
	              that.selectpicker.keydown.keyHistory = '';
	            }, 800);
	          }
	        }
	      }
	    };

	    this.sizeInfo = {};

	    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
	    // data-attribute)
	    if (this.options.title === null) {
	      this.options.title = this.$element.attr('title');
	    }

	    // Format window padding
	    var winPad = this.options.windowPadding;
	    if (typeof winPad === 'number') {
	      this.options.windowPadding = [winPad, winPad, winPad, winPad];
	    }

	    // Expose public methods
	    this.val = Selectpicker.prototype.val;
	    this.render = Selectpicker.prototype.render;
	    this.refresh = Selectpicker.prototype.refresh;
	    this.setStyle = Selectpicker.prototype.setStyle;
	    this.selectAll = Selectpicker.prototype.selectAll;
	    this.deselectAll = Selectpicker.prototype.deselectAll;
	    this.destroy = Selectpicker.prototype.destroy;
	    this.remove = Selectpicker.prototype.remove;
	    this.show = Selectpicker.prototype.show;
	    this.hide = Selectpicker.prototype.hide;

	    this.init();
	  };

	  Selectpicker.VERSION = '1.13.18';

	  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
	  Selectpicker.DEFAULTS = {
	    noneSelectedText: 'Nothing selected',
	    noneResultsText: 'No results matched {0}',
	    countSelectedText: function countSelectedText(numSelected, numTotal) {
	      return numSelected == 1 ? '{0} item selected' : '{0} items selected';
	    },
	    maxOptionsText: function maxOptionsText(numAll, numGroup) {
	      return [numAll == 1 ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)', numGroup == 1 ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'];
	    },
	    selectAllText: 'Select All',
	    deselectAllText: 'Deselect All',
	    doneButton: false,
	    doneButtonText: 'Close',
	    multipleSeparator: ', ',
	    styleBase: 'btn',
	    style: classNames.BUTTONCLASS,
	    size: 'auto',
	    title: null,
	    selectedTextFormat: 'values',
	    width: false,
	    container: false,
	    hideDisabled: false,
	    showSubtext: false,
	    showIcon: true,
	    showContent: true,
	    dropupAuto: true,
	    header: false,
	    liveSearch: false,
	    liveSearchPlaceholder: null,
	    liveSearchNormalize: false,
	    liveSearchStyle: 'contains',
	    actionsBox: false,
	    iconBase: classNames.ICONBASE,
	    tickIcon: classNames.TICKICON,
	    showTick: false,
	    template: {
	      caret: '<span class="caret"></span>'
	    },
	    maxOptions: false,
	    mobile: false,
	    selectOnTab: false,
	    dropdownAlignRight: false,
	    windowPadding: 0,
	    virtualScroll: 600,
	    display: false,
	    sanitize: true,
	    sanitizeFn: null,
	    whiteList: DefaultWhitelist
	  };

	  Selectpicker.prototype = {

	    constructor: Selectpicker,

	    init: function init() {
	      var that = this,
	          id = this.$element.attr('id'),
	          element = this.$element[0],
	          form = element.form;

	      selectId++;
	      this.selectId = 'bs-select-' + selectId;

	      element.classList.add('bs-select-hidden');

	      this.multiple = this.$element.prop('multiple');
	      this.autofocus = this.$element.prop('autofocus');

	      if (element.classList.contains('show-tick')) {
	        this.options.showTick = true;
	      }

	      this.$newElement = this.createDropdown();
	      this.buildData();
	      this.$element.after(this.$newElement).prependTo(this.$newElement);

	      // ensure select is associated with form element if it got unlinked after moving it inside newElement
	      if (form && element.form === null) {
	        if (!form.id) form.id = 'form-' + this.selectId;
	        element.setAttribute('form', form.id);
	      }

	      this.$button = this.$newElement.children('button');
	      this.$menu = this.$newElement.children(Selector.MENU);
	      this.$menuInner = this.$menu.children('.inner');
	      this.$searchbox = this.$menu.find('input');

	      element.classList.remove('bs-select-hidden');

	      if (this.options.dropdownAlignRight === true) this.$menu[0].classList.add(classNames.MENURIGHT);

	      if (typeof id !== 'undefined') {
	        this.$button.attr('data-id', id);
	      }

	      this.checkDisabled();
	      this.clickListener();

	      if (this.options.liveSearch) {
	        this.liveSearchListener();
	        this.focusedParent = this.$searchbox[0];
	      } else {
	        this.focusedParent = this.$menuInner[0];
	      }

	      this.setStyle();
	      this.render();
	      this.setWidth();
	      if (this.options.container) {
	        this.selectPosition();
	      } else {
	        this.$element.on('hide' + EVENT_KEY, function () {
	          if (that.isVirtual()) {
	            // empty menu on close
	            var menuInner = that.$menuInner[0],
	                emptyMenu = menuInner.firstChild.cloneNode(false);

	            // replace the existing UL with an empty one - this is faster than $.empty() or innerHTML = ''
	            menuInner.replaceChild(emptyMenu, menuInner.firstChild);
	            menuInner.scrollTop = 0;
	          }
	        });
	      }
	      this.$menu.data('this', this);
	      this.$newElement.data('this', this);
	      if (this.options.mobile) this.mobile();

	      this.$newElement.on({
	        'hide.bs.dropdown': function hideBsDropdown(e) {
	          that.$element.trigger('hide' + EVENT_KEY, e);
	        },
	        'hidden.bs.dropdown': function hiddenBsDropdown(e) {
	          that.$element.trigger('hidden' + EVENT_KEY, e);
	        },
	        'show.bs.dropdown': function showBsDropdown(e) {
	          that.$element.trigger('show' + EVENT_KEY, e);
	        },
	        'shown.bs.dropdown': function shownBsDropdown(e) {
	          that.$element.trigger('shown' + EVENT_KEY, e);
	        }
	      });

	      if (element.hasAttribute('required')) {
	        this.$element.on('invalid' + EVENT_KEY, function () {
	          that.$button[0].classList.add('bs-invalid');

	          that.$element.on('shown' + EVENT_KEY + '.invalid', function () {
	            that.$element.val(that.$element.val()) // set the value to hide the validation message in Chrome when menu is opened
	            .off('shown' + EVENT_KEY + '.invalid');
	          }).on('rendered' + EVENT_KEY, function () {
	            // if select is no longer invalid, remove the bs-invalid class
	            if (this.validity.valid) that.$button[0].classList.remove('bs-invalid');
	            that.$element.off('rendered' + EVENT_KEY);
	          });

	          that.$button.on('blur' + EVENT_KEY, function () {
	            that.$element.trigger('focus').trigger('blur');
	            that.$button.off('blur' + EVENT_KEY);
	          });
	        });
	      }

	      setTimeout(function () {
	        that.buildList();
	        that.$element.trigger('loaded' + EVENT_KEY);
	      });
	    },

	    createDropdown: function createDropdown() {
	      // Options
	      // If we are multiple or showTick option is set, then add the show-tick class
	      var showTick = this.multiple || this.options.showTick ? ' show-tick' : '',
	          multiselectable = this.multiple ? ' aria-multiselectable="true"' : '',
	          inputGroup = '',
	          autofocus = this.autofocus ? ' autofocus' : '';

	      if (version.major < 4 && this.$element.parent().hasClass('input-group')) {
	        inputGroup = ' input-group-btn';
	      }

	      // Elements
	      var drop,
	          header = '',
	          searchbox = '',
	          actionsbox = '',
	          donebutton = '';

	      if (this.options.header) {
	        header = '<div class="' + classNames.POPOVERHEADER + '">' + '<button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + '</div>';
	      }

	      if (this.options.liveSearch) {
	        searchbox = '<div class="bs-searchbox">' + '<input type="search" class="form-control" autocomplete="off"' + (this.options.liveSearchPlaceholder === null ? '' : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + ' role="combobox" aria-label="Search" aria-controls="' + this.selectId + '" aria-autocomplete="list">' + '</div>';
	      }

	      if (this.multiple && this.options.actionsBox) {
	        actionsbox = '<div class="bs-actionsbox">' + '<div class="btn-group btn-group-sm btn-block">' + '<button type="button" class="actions-btn bs-select-all btn ' + classNames.BUTTONCLASS + '">' + this.options.selectAllText + '</button>' + '<button type="button" class="actions-btn bs-deselect-all btn ' + classNames.BUTTONCLASS + '">' + this.options.deselectAllText + '</button>' + '</div>' + '</div>';
	      }

	      if (this.multiple && this.options.doneButton) {
	        donebutton = '<div class="bs-donebutton">' + '<div class="btn-group btn-block">' + '<button type="button" class="btn btn-sm ' + classNames.BUTTONCLASS + '">' + this.options.doneButtonText + '</button>' + '</div>' + '</div>';
	      }

	      drop = '<div class="dropdown bootstrap-select' + showTick + inputGroup + '">' + '<button type="button" tabindex="-1" class="' + this.options.styleBase + ' dropdown-toggle" ' + (this.options.display === 'static' ? 'data-display="static"' : '') + 'data-toggle="dropdown"' + autofocus + ' role="combobox" aria-owns="' + this.selectId + '" aria-haspopup="listbox" aria-expanded="false">' + '<div class="filter-option">' + '<div class="filter-option-inner">' + '<div class="filter-option-inner-inner"></div>' + '</div> ' + '</div>' + (version.major === '4' ? '' : '<span class="bs-caret">' + this.options.template.caret + '</span>') + '</button>' + '<div class="' + classNames.MENU + ' ' + (version.major === '4' ? '' : classNames.SHOW) + '">' + header + searchbox + actionsbox + '<div class="inner ' + classNames.SHOW + '" role="listbox" id="' + this.selectId + '" tabindex="-1" ' + multiselectable + '>' + '<ul class="' + classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '') + '" role="presentation">' + '</ul>' + '</div>' + donebutton + '</div>' + '</div>';

	      return $(drop);
	    },

	    setPositionData: function setPositionData() {
	      this.selectpicker.view.canHighlight = [];
	      this.selectpicker.view.size = 0;
	      this.selectpicker.view.firstHighlightIndex = false;

	      for (var i = 0; i < this.selectpicker.current.data.length; i++) {
	        var li = this.selectpicker.current.data[i],
	            canHighlight = true;

	        if (li.type === 'divider') {
	          canHighlight = false;
	          li.height = this.sizeInfo.dividerHeight;
	        } else if (li.type === 'optgroup-label') {
	          canHighlight = false;
	          li.height = this.sizeInfo.dropdownHeaderHeight;
	        } else {
	          li.height = this.sizeInfo.liHeight;
	        }

	        if (li.disabled) canHighlight = false;

	        this.selectpicker.view.canHighlight.push(canHighlight);

	        if (canHighlight) {
	          this.selectpicker.view.size++;
	          li.posinset = this.selectpicker.view.size;
	          if (this.selectpicker.view.firstHighlightIndex === false) this.selectpicker.view.firstHighlightIndex = i;
	        }

	        li.position = (i === 0 ? 0 : this.selectpicker.current.data[i - 1].position) + li.height;
	      }
	    },

	    isVirtual: function isVirtual() {
	      return this.options.virtualScroll !== false && this.selectpicker.main.elements.length >= this.options.virtualScroll || this.options.virtualScroll === true;
	    },

	    createView: function createView(isSearching, setSize, refresh) {
	      var that = this,
	          scrollTop = 0,
	          active = [],
	          selected,
	          prevActive;

	      this.selectpicker.isSearching = isSearching;
	      this.selectpicker.current = isSearching ? this.selectpicker.search : this.selectpicker.main;

	      this.setPositionData();

	      if (setSize) {
	        if (refresh) {
	          scrollTop = this.$menuInner[0].scrollTop;
	        } else if (!that.multiple) {
	          var element = that.$element[0],
	              selectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

	          if (typeof selectedIndex === 'number' && that.options.size !== false) {
	            var selectedData = that.selectpicker.main.data[selectedIndex],
	                position = selectedData && selectedData.position;

	            if (position) {
	              scrollTop = position - (that.sizeInfo.menuInnerHeight + that.sizeInfo.liHeight) / 2;
	            }
	          }
	        }
	      }

	      scroll(scrollTop, true);

	      this.$menuInner.off('scroll.createView').on('scroll.createView', function (e, updateValue) {
	        if (!that.noScroll) scroll(this.scrollTop, updateValue);
	        that.noScroll = false;
	      });

	      function scroll(scrollTop, init) {
	        var size = that.selectpicker.current.elements.length,
	            chunks = [],
	            chunkSize,
	            chunkCount,
	            firstChunk,
	            lastChunk,
	            currentChunk,
	            prevPositions,
	            positionIsDifferent,
	            previousElements,
	            menuIsDifferent = true,
	            isVirtual = that.isVirtual();

	        that.selectpicker.view.scrollTop = scrollTop;

	        chunkSize = Math.ceil(that.sizeInfo.menuInnerHeight / that.sizeInfo.liHeight * 1.5); // number of options in a chunk
	        chunkCount = Math.round(size / chunkSize) || 1; // number of chunks

	        for (var i = 0; i < chunkCount; i++) {
	          var endOfChunk = (i + 1) * chunkSize;

	          if (i === chunkCount - 1) {
	            endOfChunk = size;
	          }

	          chunks[i] = [i * chunkSize + (!i ? 0 : 1), endOfChunk];

	          if (!size) break;

	          if (currentChunk === undefined && scrollTop - 1 <= that.selectpicker.current.data[endOfChunk - 1].position - that.sizeInfo.menuInnerHeight) {
	            currentChunk = i;
	          }
	        }

	        if (currentChunk === undefined) currentChunk = 0;

	        prevPositions = [that.selectpicker.view.position0, that.selectpicker.view.position1];

	        // always display previous, current, and next chunks
	        firstChunk = Math.max(0, currentChunk - 1);
	        lastChunk = Math.min(chunkCount - 1, currentChunk + 1);

	        that.selectpicker.view.position0 = isVirtual === false ? 0 : Math.max(0, chunks[firstChunk][0]) || 0;
	        that.selectpicker.view.position1 = isVirtual === false ? size : Math.min(size, chunks[lastChunk][1]) || 0;

	        positionIsDifferent = prevPositions[0] !== that.selectpicker.view.position0 || prevPositions[1] !== that.selectpicker.view.position1;

	        if (that.activeIndex !== undefined) {
	          prevActive = that.selectpicker.main.elements[that.prevActiveIndex];
	          active = that.selectpicker.main.elements[that.activeIndex];
	          selected = that.selectpicker.main.elements[that.selectedIndex];

	          if (init) {
	            if (that.activeIndex !== that.selectedIndex) {
	              that.defocusItem(active);
	            }
	            that.activeIndex = undefined;
	          }

	          if (that.activeIndex && that.activeIndex !== that.selectedIndex) {
	            that.defocusItem(selected);
	          }
	        }

	        if (that.prevActiveIndex !== undefined && that.prevActiveIndex !== that.activeIndex && that.prevActiveIndex !== that.selectedIndex) {
	          that.defocusItem(prevActive);
	        }

	        if (init || positionIsDifferent) {
	          previousElements = that.selectpicker.view.visibleElements ? that.selectpicker.view.visibleElements.slice() : [];

	          if (isVirtual === false) {
	            that.selectpicker.view.visibleElements = that.selectpicker.current.elements;
	          } else {
	            that.selectpicker.view.visibleElements = that.selectpicker.current.elements.slice(that.selectpicker.view.position0, that.selectpicker.view.position1);
	          }

	          that.setOptionStatus();

	          // if searching, check to make sure the list has actually been updated before updating DOM
	          // this prevents unnecessary repaints
	          if (isSearching || isVirtual === false && init) menuIsDifferent = !isEqual(previousElements, that.selectpicker.view.visibleElements);

	          // if virtual scroll is disabled and not searching,
	          // menu should never need to be updated more than once
	          if ((init || isVirtual === true) && menuIsDifferent) {
	            var menuInner = that.$menuInner[0],
	                menuFragment = document.createDocumentFragment(),
	                emptyMenu = menuInner.firstChild.cloneNode(false),
	                marginTop,
	                marginBottom,
	                elements = that.selectpicker.view.visibleElements,
	                toSanitize = [];

	            // replace the existing UL with an empty one - this is faster than $.empty()
	            menuInner.replaceChild(emptyMenu, menuInner.firstChild);

	            for (var i = 0, visibleElementsLen = elements.length; i < visibleElementsLen; i++) {
	              var element = elements[i],
	                  elText,
	                  elementData;

	              if (that.options.sanitize) {
	                elText = element.lastChild;

	                if (elText) {
	                  elementData = that.selectpicker.current.data[i + that.selectpicker.view.position0];

	                  if (elementData && elementData.content && !elementData.sanitized) {
	                    toSanitize.push(elText);
	                    elementData.sanitized = true;
	                  }
	                }
	              }

	              menuFragment.appendChild(element);
	            }

	            if (that.options.sanitize && toSanitize.length) {
	              sanitizeHtml(toSanitize, that.options.whiteList, that.options.sanitizeFn);
	            }

	            if (isVirtual === true) {
	              marginTop = that.selectpicker.view.position0 === 0 ? 0 : that.selectpicker.current.data[that.selectpicker.view.position0 - 1].position;
	              marginBottom = that.selectpicker.view.position1 > size - 1 ? 0 : that.selectpicker.current.data[size - 1].position - that.selectpicker.current.data[that.selectpicker.view.position1 - 1].position;

	              menuInner.firstChild.style.marginTop = marginTop + 'px';
	              menuInner.firstChild.style.marginBottom = marginBottom + 'px';
	            } else {
	              menuInner.firstChild.style.marginTop = 0;
	              menuInner.firstChild.style.marginBottom = 0;
	            }

	            menuInner.firstChild.appendChild(menuFragment);

	            // if an option is encountered that is wider than the current menu width, update the menu width accordingly
	            // switch to ResizeObserver with increased browser support
	            if (isVirtual === true && that.sizeInfo.hasScrollBar) {
	              var menuInnerInnerWidth = menuInner.firstChild.offsetWidth;

	              if (init && menuInnerInnerWidth < that.sizeInfo.menuInnerInnerWidth && that.sizeInfo.totalMenuWidth > that.sizeInfo.selectWidth) {
	                menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
	              } else if (menuInnerInnerWidth > that.sizeInfo.menuInnerInnerWidth) {
	                // set to 0 to get actual width of menu
	                that.$menu[0].style.minWidth = 0;

	                var actualMenuWidth = menuInner.firstChild.offsetWidth;

	                if (actualMenuWidth > that.sizeInfo.menuInnerInnerWidth) {
	                  that.sizeInfo.menuInnerInnerWidth = actualMenuWidth;
	                  menuInner.firstChild.style.minWidth = that.sizeInfo.menuInnerInnerWidth + 'px';
	                }

	                // reset to default CSS styling
	                that.$menu[0].style.minWidth = '';
	              }
	            }
	          }
	        }

	        that.prevActiveIndex = that.activeIndex;

	        if (!that.options.liveSearch) {
	          that.$menuInner.trigger('focus');
	        } else if (isSearching && init) {
	          var index = 0,
	              newActive;

	          if (!that.selectpicker.view.canHighlight[index]) {
	            index = 1 + that.selectpicker.view.canHighlight.slice(1).indexOf(true);
	          }

	          newActive = that.selectpicker.view.visibleElements[index];

	          that.defocusItem(that.selectpicker.view.currentActive);

	          that.activeIndex = (that.selectpicker.current.data[index] || {}).index;

	          that.focusItem(newActive);
	        }
	      }

	      $(window).off('resize' + EVENT_KEY + '.' + this.selectId + '.createView').on('resize' + EVENT_KEY + '.' + this.selectId + '.createView', function () {
	        var isActive = that.$newElement.hasClass(classNames.SHOW);

	        if (isActive) scroll(that.$menuInner[0].scrollTop);
	      });
	    },

	    focusItem: function focusItem(li, liData, noStyle) {
	      if (li) {
	        liData = liData || this.selectpicker.main.data[this.activeIndex];
	        var a = li.firstChild;

	        if (a) {
	          a.setAttribute('aria-setsize', this.selectpicker.view.size);
	          a.setAttribute('aria-posinset', liData.posinset);

	          if (noStyle !== true) {
	            this.focusedParent.setAttribute('aria-activedescendant', a.id);
	            li.classList.add('active');
	            a.classList.add('active');
	          }
	        }
	      }
	    },

	    defocusItem: function defocusItem(li) {
	      if (li) {
	        li.classList.remove('active');
	        if (li.firstChild) li.firstChild.classList.remove('active');
	      }
	    },

	    setPlaceholder: function setPlaceholder() {
	      var that = this,
	          updateIndex = false;

	      if (this.options.title && !this.multiple) {
	        if (!this.selectpicker.view.titleOption) this.selectpicker.view.titleOption = document.createElement('option');

	        // this option doesn't create a new <li> element, but does add a new option at the start,
	        // so startIndex should increase to prevent having to check every option for the bs-title-option class
	        updateIndex = true;

	        var element = this.$element[0],
	            selectTitleOption = false,
	            titleNotAppended = !this.selectpicker.view.titleOption.parentNode,
	            selectedIndex = element.selectedIndex,
	            selectedOption = element.options[selectedIndex],
	            navigation = window.performance && window.performance.getEntriesByType('navigation'),

	        // Safari doesn't support getEntriesByType('navigation') - fall back to performance.navigation
	        isNotBackForward = navigation && navigation.length ? navigation[0].type !== 'back_forward' : window.performance.navigation.type !== 2;

	        if (titleNotAppended) {
	          // Use native JS to prepend option (faster)
	          this.selectpicker.view.titleOption.className = 'bs-title-option';
	          this.selectpicker.view.titleOption.value = '';

	          // Check if selected or data-selected attribute is already set on an option. If not, select the titleOption option.
	          // the selected item may have been changed by user or programmatically before the bootstrap select plugin runs,
	          // if so, the select will have the data-selected attribute
	          selectTitleOption = !selectedOption || selectedIndex === 0 && selectedOption.defaultSelected === false && this.$element.data('selected') === undefined;
	        }

	        if (titleNotAppended || this.selectpicker.view.titleOption.index !== 0) {
	          element.insertBefore(this.selectpicker.view.titleOption, element.firstChild);
	        }

	        // Set selected *after* appending to select,
	        // otherwise the option doesn't get selected in IE
	        // set using selectedIndex, as setting the selected attr to true here doesn't work in IE11
	        if (selectTitleOption && isNotBackForward) {
	          element.selectedIndex = 0;
	        } else if (document.readyState !== 'complete') {
	          // if navigation type is back_forward, there's a chance the select will have its value set by BFCache
	          // wait for that value to be set, then run render again
	          window.addEventListener('pageshow', function () {
	            if (that.selectpicker.view.displayedValue !== element.value) that.render();
	          });
	        }
	      }

	      return updateIndex;
	    },

	    buildData: function buildData() {
	      var optionSelector = ':not([hidden]):not([data-hidden="true"])',
	          mainData = [],
	          optID = 0,
	          startIndex = this.setPlaceholder() ? 1 : 0; // append the titleOption if necessary and skip the first option in the loop

	      if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

	      var selectOptions = this.$element[0].querySelectorAll('select > *' + optionSelector);

	      function addDivider(config) {
	        var previousData = mainData[mainData.length - 1];

	        // ensure optgroup doesn't create back-to-back dividers
	        if (previousData && previousData.type === 'divider' && (previousData.optID || config.optID)) {
	          return;
	        }

	        config = config || {};
	        config.type = 'divider';

	        mainData.push(config);
	      }

	      function addOption(option, config) {
	        config = config || {};

	        config.divider = option.getAttribute('data-divider') === 'true';

	        if (config.divider) {
	          addDivider({
	            optID: config.optID
	          });
	        } else {
	          var liIndex = mainData.length,
	              cssText = option.style.cssText,
	              inlineStyle = cssText ? htmlEscape(cssText) : '',
	              optionClass = (option.className || '') + (config.optgroupClass || '');

	          if (config.optID) optionClass = 'opt ' + optionClass;

	          config.optionClass = optionClass.trim();
	          config.inlineStyle = inlineStyle;
	          config.text = option.textContent;

	          config.content = option.getAttribute('data-content');
	          config.tokens = option.getAttribute('data-tokens');
	          config.subtext = option.getAttribute('data-subtext');
	          config.icon = option.getAttribute('data-icon');

	          option.liIndex = liIndex;

	          config.display = config.content || config.text;
	          config.type = 'option';
	          config.index = liIndex;
	          config.option = option;
	          config.selected = !!option.selected;
	          config.disabled = config.disabled || !!option.disabled;

	          mainData.push(config);
	        }
	      }

	      function addOptgroup(index, selectOptions) {
	        var optgroup = selectOptions[index],

	        // skip placeholder option
	        previous = index - 1 < startIndex ? false : selectOptions[index - 1],
	            next = selectOptions[index + 1],
	            options = optgroup.querySelectorAll('option' + optionSelector);

	        if (!options.length) return;

	        var config = {
	          display: htmlEscape(optgroup.label),
	          subtext: optgroup.getAttribute('data-subtext'),
	          icon: optgroup.getAttribute('data-icon'),
	          type: 'optgroup-label',
	          optgroupClass: ' ' + (optgroup.className || '')
	        },
	            headerIndex,
	            lastIndex;

	        optID++;

	        if (previous) {
	          addDivider({ optID: optID });
	        }

	        config.optID = optID;

	        mainData.push(config);

	        for (var j = 0, len = options.length; j < len; j++) {
	          var option = options[j];

	          if (j === 0) {
	            headerIndex = mainData.length - 1;
	            lastIndex = headerIndex + len;
	          }

	          addOption(option, {
	            headerIndex: headerIndex,
	            lastIndex: lastIndex,
	            optID: config.optID,
	            optgroupClass: config.optgroupClass,
	            disabled: optgroup.disabled
	          });
	        }

	        if (next) {
	          addDivider({ optID: optID });
	        }
	      }

	      for (var len = selectOptions.length, i = startIndex; i < len; i++) {
	        var item = selectOptions[i];

	        if (item.tagName !== 'OPTGROUP') {
	          addOption(item, {});
	        } else {
	          addOptgroup(i, selectOptions);
	        }
	      }

	      this.selectpicker.main.data = this.selectpicker.current.data = mainData;
	    },

	    buildList: function buildList() {
	      var that = this,
	          selectData = this.selectpicker.main.data,
	          mainElements = [],
	          widestOptionLength = 0;

	      if ((that.options.showTick || that.multiple) && !elementTemplates.checkMark.parentNode) {
	        elementTemplates.checkMark.className = this.options.iconBase + ' ' + that.options.tickIcon + ' check-mark';
	        elementTemplates.a.appendChild(elementTemplates.checkMark);
	      }

	      function buildElement(item) {
	        var liElement,
	            combinedLength = 0;

	        switch (item.type) {
	          case 'divider':
	            liElement = generateOption.li(false, classNames.DIVIDER, item.optID ? item.optID + 'div' : undefined);

	            break;

	          case 'option':
	            liElement = generateOption.li(generateOption.a(generateOption.text.call(that, item), item.optionClass, item.inlineStyle), '', item.optID);

	            if (liElement.firstChild) {
	              liElement.firstChild.id = that.selectId + '-' + item.index;
	            }

	            break;

	          case 'optgroup-label':
	            liElement = generateOption.li(generateOption.label.call(that, item), 'dropdown-header' + item.optgroupClass, item.optID);

	            break;
	        }

	        item.element = liElement;
	        mainElements.push(liElement);

	        // count the number of characters in the option - not perfect, but should work in most cases
	        if (item.display) combinedLength += item.display.length;
	        if (item.subtext) combinedLength += item.subtext.length;
	        // if there is an icon, ensure this option's width is checked
	        if (item.icon) combinedLength += 1;

	        if (combinedLength > widestOptionLength) {
	          widestOptionLength = combinedLength;

	          // guess which option is the widest
	          // use this when calculating menu width
	          // not perfect, but it's fast, and the width will be updating accordingly when scrolling
	          that.selectpicker.view.widestOption = mainElements[mainElements.length - 1];
	        }
	      }

	      for (var len = selectData.length, i = 0; i < len; i++) {
	        var item = selectData[i];

	        buildElement(item);
	      }

	      this.selectpicker.main.elements = this.selectpicker.current.elements = mainElements;
	    },

	    findLis: function findLis() {
	      return this.$menuInner.find('.inner > li');
	    },

	    render: function render() {
	      var that = this,
	          element = this.$element[0],

	      // ensure titleOption is appended and selected (if necessary) before getting selectedOptions
	      placeholderSelected = this.setPlaceholder() && element.selectedIndex === 0,
	          selectedOptions = getSelectedOptions(element, this.options.hideDisabled),
	          selectedCount = selectedOptions.length,
	          button = this.$button[0],
	          buttonInner = button.querySelector('.filter-option-inner-inner'),
	          multipleSeparator = document.createTextNode(this.options.multipleSeparator),
	          titleFragment = elementTemplates.fragment.cloneNode(false),
	          showCount,
	          countMax,
	          hasContent = false;

	      button.classList.toggle('bs-placeholder', that.multiple ? !selectedCount : !getSelectValues(element, selectedOptions));

	      if (!that.multiple && selectedOptions.length === 1) {
	        that.selectpicker.view.displayedValue = getSelectValues(element, selectedOptions);
	      }

	      if (this.options.selectedTextFormat === 'static') {
	        titleFragment = generateOption.text.call(this, { text: this.options.title }, true);
	      } else {
	        showCount = this.multiple && this.options.selectedTextFormat.indexOf('count') !== -1 && selectedCount > 1;

	        // determine if the number of selected options will be shown (showCount === true)
	        if (showCount) {
	          countMax = this.options.selectedTextFormat.split('>');
	          showCount = countMax.length > 1 && selectedCount > countMax[1] || countMax.length === 1 && selectedCount >= 2;
	        }

	        // only loop through all selected options if the count won't be shown
	        if (showCount === false) {
	          if (!placeholderSelected) {
	            for (var selectedIndex = 0; selectedIndex < selectedCount; selectedIndex++) {
	              if (selectedIndex < 50) {
	                var option = selectedOptions[selectedIndex],
	                    thisData = this.selectpicker.main.data[option.liIndex],
	                    titleOptions = {};

	                if (this.multiple && selectedIndex > 0) {
	                  titleFragment.appendChild(multipleSeparator.cloneNode(false));
	                }

	                if (option.title) {
	                  titleOptions.text = option.title;
	                } else if (thisData) {
	                  if (thisData.content && that.options.showContent) {
	                    titleOptions.content = thisData.content.toString();
	                    hasContent = true;
	                  } else {
	                    if (that.options.showIcon) {
	                      titleOptions.icon = thisData.icon;
	                    }
	                    if (that.options.showSubtext && !that.multiple && thisData.subtext) titleOptions.subtext = ' ' + thisData.subtext;
	                    titleOptions.text = option.textContent.trim();
	                  }
	                }

	                titleFragment.appendChild(generateOption.text.call(this, titleOptions, true));
	              } else {
	                break;
	              }
	            }

	            // add ellipsis
	            if (selectedCount > 49) {
	              titleFragment.appendChild(document.createTextNode('...'));
	            }
	          }
	        } else {
	          var optionSelector = ':not([hidden]):not([data-hidden="true"]):not([data-divider="true"])';
	          if (this.options.hideDisabled) optionSelector += ':not(:disabled)';

	          // If this is a multiselect, and selectedTextFormat is count, then show 1 of 2 selected, etc.
	          var totalCount = this.$element[0].querySelectorAll('select > option' + optionSelector + ', optgroup' + optionSelector + ' option' + optionSelector).length,
	              tr8nText = typeof this.options.countSelectedText === 'function' ? this.options.countSelectedText(selectedCount, totalCount) : this.options.countSelectedText;

	          titleFragment = generateOption.text.call(this, {
	            text: tr8nText.replace('{0}', selectedCount.toString()).replace('{1}', totalCount.toString())
	          }, true);
	        }
	      }

	      if (this.options.title == undefined) {
	        // use .attr to ensure undefined is returned if title attribute is not set
	        this.options.title = this.$element.attr('title');
	      }

	      // If the select doesn't have a title, then use the default, or if nothing is set at all, use noneSelectedText
	      if (!titleFragment.childNodes.length) {
	        titleFragment = generateOption.text.call(this, {
	          text: typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText
	        }, true);
	      }

	      // strip all HTML tags and trim the result, then unescape any escaped tags
	      button.title = titleFragment.textContent.replace(/<[^>]*>?/g, '').trim();

	      if (this.options.sanitize && hasContent) {
	        sanitizeHtml([titleFragment], that.options.whiteList, that.options.sanitizeFn);
	      }

	      buttonInner.innerHTML = '';
	      buttonInner.appendChild(titleFragment);

	      if (version.major < 4 && this.$newElement[0].classList.contains('bs3-has-addon')) {
	        var filterExpand = button.querySelector('.filter-expand'),
	            clone = buttonInner.cloneNode(true);

	        clone.className = 'filter-expand';

	        if (filterExpand) {
	          button.replaceChild(clone, filterExpand);
	        } else {
	          button.appendChild(clone);
	        }
	      }

	      this.$element.trigger('rendered' + EVENT_KEY);
	    },

	    /**
	     * @param [style]
	     * @param [status]
	     */
	    setStyle: function setStyle(newStyle, status) {
	      var button = this.$button[0],
	          newElement = this.$newElement[0],
	          style = this.options.style.trim(),
	          buttonClass;

	      if (this.$element.attr('class')) {
	        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|bs-select-hidden|validate\[.*\]/gi, ''));
	      }

	      if (version.major < 4) {
	        newElement.classList.add('bs3');

	        if (newElement.parentNode.classList && newElement.parentNode.classList.contains('input-group') && (newElement.previousElementSibling || newElement.nextElementSibling) && (newElement.previousElementSibling || newElement.nextElementSibling).classList.contains('input-group-addon')) {
	          newElement.classList.add('bs3-has-addon');
	        }
	      }

	      if (newStyle) {
	        buttonClass = newStyle.trim();
	      } else {
	        buttonClass = style;
	      }

	      if (status == 'add') {
	        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
	      } else if (status == 'remove') {
	        if (buttonClass) button.classList.remove.apply(button.classList, buttonClass.split(' '));
	      } else {
	        if (style) button.classList.remove.apply(button.classList, style.split(' '));
	        if (buttonClass) button.classList.add.apply(button.classList, buttonClass.split(' '));
	      }
	    },

	    liHeight: function liHeight(refresh) {
	      if (!refresh && (this.options.size === false || Object.keys(this.sizeInfo).length)) return;

	      var newElement = elementTemplates.div.cloneNode(false),
	          menu = elementTemplates.div.cloneNode(false),
	          menuInner = elementTemplates.div.cloneNode(false),
	          menuInnerInner = document.createElement('ul'),
	          divider = elementTemplates.li.cloneNode(false),
	          dropdownHeader = elementTemplates.li.cloneNode(false),
	          li,
	          a = elementTemplates.a.cloneNode(false),
	          text = elementTemplates.span.cloneNode(false),
	          header = this.options.header && this.$menu.find('.' + classNames.POPOVERHEADER).length > 0 ? this.$menu.find('.' + classNames.POPOVERHEADER)[0].cloneNode(true) : null,
	          search = this.options.liveSearch ? elementTemplates.div.cloneNode(false) : null,
	          actions = this.options.actionsBox && this.multiple && this.$menu.find('.bs-actionsbox').length > 0 ? this.$menu.find('.bs-actionsbox')[0].cloneNode(true) : null,
	          doneButton = this.options.doneButton && this.multiple && this.$menu.find('.bs-donebutton').length > 0 ? this.$menu.find('.bs-donebutton')[0].cloneNode(true) : null,
	          firstOption = this.$element.find('option')[0];

	      this.sizeInfo.selectWidth = this.$newElement[0].offsetWidth;

	      text.className = 'text';
	      a.className = 'dropdown-item ' + (firstOption ? firstOption.className : '');
	      newElement.className = this.$menu[0].parentNode.className + ' ' + classNames.SHOW;
	      newElement.style.width = 0; // ensure button width doesn't affect natural width of menu when calculating
	      if (this.options.width === 'auto') menu.style.minWidth = 0;
	      menu.className = classNames.MENU + ' ' + classNames.SHOW;
	      menuInner.className = 'inner ' + classNames.SHOW;
	      menuInnerInner.className = classNames.MENU + ' inner ' + (version.major === '4' ? classNames.SHOW : '');
	      divider.className = classNames.DIVIDER;
	      dropdownHeader.className = 'dropdown-header';

	      text.appendChild(document.createTextNode('\u200B'));

	      if (this.selectpicker.current.data.length) {
	        for (var i = 0; i < this.selectpicker.current.data.length; i++) {
	          var data = this.selectpicker.current.data[i];
	          if (data.type === 'option') {
	            li = data.element;
	            break;
	          }
	        }
	      } else {
	        li = elementTemplates.li.cloneNode(false);
	        a.appendChild(text);
	        li.appendChild(a);
	      }

	      dropdownHeader.appendChild(text.cloneNode(true));

	      if (this.selectpicker.view.widestOption) {
	        menuInnerInner.appendChild(this.selectpicker.view.widestOption.cloneNode(true));
	      }

	      menuInnerInner.appendChild(li);
	      menuInnerInner.appendChild(divider);
	      menuInnerInner.appendChild(dropdownHeader);
	      if (header) menu.appendChild(header);
	      if (search) {
	        var input = document.createElement('input');
	        search.className = 'bs-searchbox';
	        input.className = 'form-control';
	        search.appendChild(input);
	        menu.appendChild(search);
	      }
	      if (actions) menu.appendChild(actions);
	      menuInner.appendChild(menuInnerInner);
	      menu.appendChild(menuInner);
	      if (doneButton) menu.appendChild(doneButton);
	      newElement.appendChild(menu);

	      document.body.appendChild(newElement);

	      var liHeight = 41,
	          dropdownHeaderHeight = dropdownHeader ? dropdownHeader.offsetHeight : 0,
	          headerHeight = header ? header.offsetHeight : 0,
	          searchHeight = search ? search.offsetHeight : 0,
	          actionsHeight = actions ? actions.offsetHeight : 0,
	          doneButtonHeight = doneButton ? doneButton.offsetHeight : 0,
	          dividerHeight = $(divider).outerHeight(true),

	      // fall back to jQuery if getComputedStyle is not supported
	      menuStyle = window.getComputedStyle ? window.getComputedStyle(menu) : false,
	          menuWidth = menu.offsetWidth,
	          $menu = menuStyle ? null : $(menu),
	          menuPadding = {
	        vert: toInteger(menuStyle ? menuStyle.paddingTop : $menu.css('paddingTop')) + toInteger(menuStyle ? menuStyle.paddingBottom : $menu.css('paddingBottom')) + toInteger(menuStyle ? menuStyle.borderTopWidth : $menu.css('borderTopWidth')) + toInteger(menuStyle ? menuStyle.borderBottomWidth : $menu.css('borderBottomWidth')),
	        horiz: toInteger(menuStyle ? menuStyle.paddingLeft : $menu.css('paddingLeft')) + toInteger(menuStyle ? menuStyle.paddingRight : $menu.css('paddingRight')) + toInteger(menuStyle ? menuStyle.borderLeftWidth : $menu.css('borderLeftWidth')) + toInteger(menuStyle ? menuStyle.borderRightWidth : $menu.css('borderRightWidth'))
	      },
	          menuExtras = {
	        vert: menuPadding.vert + toInteger(menuStyle ? menuStyle.marginTop : $menu.css('marginTop')) + toInteger(menuStyle ? menuStyle.marginBottom : $menu.css('marginBottom')) + 2,
	        horiz: menuPadding.horiz + toInteger(menuStyle ? menuStyle.marginLeft : $menu.css('marginLeft')) + toInteger(menuStyle ? menuStyle.marginRight : $menu.css('marginRight')) + 2
	      },
	          scrollBarWidth;

	      menuInner.style.overflowY = 'scroll';

	      scrollBarWidth = menu.offsetWidth - menuWidth;

	      document.body.removeChild(newElement);

	      this.sizeInfo.liHeight = liHeight;
	      this.sizeInfo.dropdownHeaderHeight = dropdownHeaderHeight;
	      this.sizeInfo.headerHeight = headerHeight;
	      this.sizeInfo.searchHeight = searchHeight;
	      this.sizeInfo.actionsHeight = actionsHeight;
	      this.sizeInfo.doneButtonHeight = doneButtonHeight;
	      this.sizeInfo.dividerHeight = dividerHeight;
	      this.sizeInfo.menuPadding = menuPadding;
	      this.sizeInfo.menuExtras = menuExtras;
	      this.sizeInfo.menuWidth = menuWidth;
	      this.sizeInfo.menuInnerInnerWidth = menuWidth - menuPadding.horiz;
	      this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth;
	      this.sizeInfo.scrollBarWidth = scrollBarWidth;
	      this.sizeInfo.selectHeight = this.$newElement[0].offsetHeight;

	      this.setPositionData();
	    },

	    getSelectPosition: function getSelectPosition() {
	      var that = this,
	          $window = $(window),
	          pos = that.$newElement.offset(),
	          $container = $(that.options.container),
	          containerPos;

	      if (that.options.container && $container.length && !$container.is('body')) {
	        containerPos = $container.offset();
	        containerPos.top += parseInt($container.css('borderTopWidth'));
	        containerPos.left += parseInt($container.css('borderLeftWidth'));
	      } else {
	        containerPos = { top: 0, left: 0 };
	      }

	      var winPad = that.options.windowPadding;

	      this.sizeInfo.selectOffsetTop = pos.top - containerPos.top - $window.scrollTop();
	      this.sizeInfo.selectOffsetBot = $window.height() - this.sizeInfo.selectOffsetTop - this.sizeInfo.selectHeight - containerPos.top - winPad[2];
	      this.sizeInfo.selectOffsetLeft = pos.left - containerPos.left - $window.scrollLeft();
	      this.sizeInfo.selectOffsetRight = $window.width() - this.sizeInfo.selectOffsetLeft - this.sizeInfo.selectWidth - containerPos.left - winPad[1];
	      this.sizeInfo.selectOffsetTop -= winPad[0];
	      this.sizeInfo.selectOffsetLeft -= winPad[3];
	    },

	    setMenuSize: function setMenuSize(isAuto) {
	      this.getSelectPosition();

	      var selectWidth = this.sizeInfo.selectWidth,
	          liHeight = this.sizeInfo.liHeight,
	          headerHeight = this.sizeInfo.headerHeight,
	          searchHeight = this.sizeInfo.searchHeight,
	          actionsHeight = this.sizeInfo.actionsHeight,
	          doneButtonHeight = this.sizeInfo.doneButtonHeight,
	          divHeight = this.sizeInfo.dividerHeight,
	          menuPadding = this.sizeInfo.menuPadding,
	          menuInnerHeight,
	          menuHeight,
	          divLength = 0,
	          minHeight,
	          _minHeight,
	          maxHeight,
	          menuInnerMinHeight,
	          estimate,
	          isDropup;

	      if (this.options.dropupAuto) {
	        // Get the estimated height of the menu without scrollbars.
	        // This is useful for smaller menus, where there might be plenty of room
	        // below the button without setting dropup, but we can't know
	        // the exact height of the menu until createView is called later
	        estimate = liHeight * this.selectpicker.current.elements.length + menuPadding.vert;

	        isDropup = this.sizeInfo.selectOffsetTop - this.sizeInfo.selectOffsetBot > this.sizeInfo.menuExtras.vert && estimate + this.sizeInfo.menuExtras.vert + 50 > this.sizeInfo.selectOffsetBot;

	        // ensure dropup doesn't change while searching (so menu doesn't bounce back and forth)
	        if (this.selectpicker.isSearching === true) {
	          isDropup = this.selectpicker.dropup;
	        }

	        this.$newElement.toggleClass(classNames.DROPUP, isDropup);
	        this.selectpicker.dropup = isDropup;
	      }

	      if (this.options.size === 'auto') {
	        _minHeight = this.selectpicker.current.elements.length > 3 ? this.sizeInfo.liHeight * 3 + this.sizeInfo.menuExtras.vert - 2 : 0;
	        menuHeight = this.sizeInfo.selectOffsetBot - this.sizeInfo.menuExtras.vert;
	        minHeight = _minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
	        menuInnerMinHeight = Math.max(_minHeight - menuPadding.vert, 0);

	        if (this.$newElement.hasClass(classNames.DROPUP)) {
	          menuHeight = this.sizeInfo.selectOffsetTop - this.sizeInfo.menuExtras.vert;
	        }

	        maxHeight = menuHeight;
	        menuInnerHeight = menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding.vert;
	      } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
	        for (var i = 0; i < this.options.size; i++) {
	          if (this.selectpicker.current.data[i].type === 'divider') divLength++;
	        }

	        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding.vert;
	        menuInnerHeight = menuHeight - menuPadding.vert;
	        maxHeight = menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight;
	        minHeight = menuInnerMinHeight = '';
	      }

	      this.$menu.css({
	        'max-height': maxHeight + 'px',
	        'overflow': 'hidden',
	        'min-height': minHeight + 'px'
	      });

	      this.$menuInner.css({
	        'max-height': menuInnerHeight + 'px',
	        'overflow-y': 'auto',
	        'min-height': menuInnerMinHeight + 'px'
	      });

	      // ensure menuInnerHeight is always a positive number to prevent issues calculating chunkSize in createView
	      this.sizeInfo.menuInnerHeight = Math.max(menuInnerHeight, 1);

	      if (this.selectpicker.current.data.length && this.selectpicker.current.data[this.selectpicker.current.data.length - 1].position > this.sizeInfo.menuInnerHeight) {
	        this.sizeInfo.hasScrollBar = true;
	        this.sizeInfo.totalMenuWidth = this.sizeInfo.menuWidth + this.sizeInfo.scrollBarWidth;
	      }

	      if (this.options.dropdownAlignRight === 'auto') {
	        this.$menu.toggleClass(classNames.MENURIGHT, this.sizeInfo.selectOffsetLeft > this.sizeInfo.selectOffsetRight && this.sizeInfo.selectOffsetRight < this.sizeInfo.totalMenuWidth - selectWidth);
	      }

	      if (this.dropdown && this.dropdown._popper) this.dropdown._popper.update();
	    },

	    setSize: function setSize(refresh) {
	      this.liHeight(refresh);

	      if (this.options.header) this.$menu.css('padding-top', 0);

	      if (this.options.size !== false) {
	        var that = this,
	            $window = $(window);

	        this.setMenuSize();

	        if (this.options.liveSearch) {
	          this.$searchbox.off('input.setMenuSize propertychange.setMenuSize').on('input.setMenuSize propertychange.setMenuSize', function () {
	            return that.setMenuSize();
	          });
	        }

	        if (this.options.size === 'auto') {
	          $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize').on('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize', function () {
	            return that.setMenuSize();
	          });
	        } else if (this.options.size && this.options.size != 'auto' && this.selectpicker.current.elements.length > this.options.size) {
	          $window.off('resize' + EVENT_KEY + '.' + this.selectId + '.setMenuSize' + ' scroll' + EVENT_KEY + '.' + this.selectId + '.setMenuSize');
	        }
	      }

	      this.createView(false, true, refresh);
	    },

	    setWidth: function setWidth() {
	      var that = this;

	      if (this.options.width === 'auto') {
	        requestAnimationFrame(function () {
	          that.$menu.css('min-width', '0');

	          that.$element.on('loaded' + EVENT_KEY, function () {
	            that.liHeight();
	            that.setMenuSize();

	            // Get correct width if element is hidden
	            var $selectClone = that.$newElement.clone().appendTo('body'),
	                btnWidth = $selectClone.css('width', 'auto').children('button').outerWidth();

	            $selectClone.remove();

	            // Set width to whatever's larger, button title or longest option
	            that.sizeInfo.selectWidth = Math.max(that.sizeInfo.totalMenuWidth, btnWidth);
	            that.$newElement.css('width', that.sizeInfo.selectWidth + 'px');
	          });
	        });
	      } else if (this.options.width === 'fit') {
	        // Remove inline min-width so width can be changed from 'auto'
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', '').addClass('fit-width');
	      } else if (this.options.width) {
	        // Remove inline min-width so width can be changed from 'auto'
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', this.options.width);
	      } else {
	        // Remove inline min-width/width so width can be changed
	        this.$menu.css('min-width', '');
	        this.$newElement.css('width', '');
	      }
	      // Remove fit-width class if width is changed programmatically
	      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
	        this.$newElement[0].classList.remove('fit-width');
	      }
	    },

	    selectPosition: function selectPosition() {
	      this.$bsContainer = $('<div class="bs-container" />');

	      var that = this,
	          $container = $(this.options.container),
	          pos,
	          containerPos,
	          actualHeight,
	          getPlacement = function getPlacement($element) {
	        var containerPosition = {},

	        // fall back to dropdown's default display setting if display is not manually set
	        display = that.options.display || (
	        // Bootstrap 3 doesn't have $.fn.dropdown.Constructor.Default
	        $.fn.dropdown.Constructor.Default ? $.fn.dropdown.Constructor.Default.display : false);

	        that.$bsContainer.addClass($element.attr('class').replace(/form-control|fit-width/gi, '')).toggleClass(classNames.DROPUP, $element.hasClass(classNames.DROPUP));
	        pos = $element.offset();

	        if (!$container.is('body')) {
	          containerPos = $container.offset();
	          containerPos.top += parseInt($container.css('borderTopWidth')) - $container.scrollTop();
	          containerPos.left += parseInt($container.css('borderLeftWidth')) - $container.scrollLeft();
	        } else {
	          containerPos = { top: 0, left: 0 };
	        }

	        actualHeight = $element.hasClass(classNames.DROPUP) ? 0 : $element[0].offsetHeight;

	        // Bootstrap 4+ uses Popper for menu positioning
	        if (version.major < 4 || display === 'static') {
	          containerPosition.top = pos.top - containerPos.top + actualHeight;
	          containerPosition.left = pos.left - containerPos.left;
	        }

	        containerPosition.width = $element[0].offsetWidth;

	        that.$bsContainer.css(containerPosition);
	      };

	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (that.isDisabled()) {
	          return;
	        }

	        getPlacement(that.$newElement);

	        that.$bsContainer.appendTo(that.options.container).toggleClass(classNames.SHOW, !that.$button.hasClass(classNames.SHOW)).append(that.$menu);
	      });

	      $(window).off('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId).on('resize' + EVENT_KEY + '.' + this.selectId + ' scroll' + EVENT_KEY + '.' + this.selectId, function () {
	        var isActive = that.$newElement.hasClass(classNames.SHOW);

	        if (isActive) getPlacement(that.$newElement);
	      });

	      this.$element.on('hide' + EVENT_KEY, function () {
	        that.$menu.data('height', that.$menu.height());
	        that.$bsContainer.detach();
	      });
	    },

	    setOptionStatus: function setOptionStatus(selectedOnly) {
	      var that = this;

	      that.noScroll = false;

	      if (that.selectpicker.view.visibleElements && that.selectpicker.view.visibleElements.length) {
	        for (var i = 0; i < that.selectpicker.view.visibleElements.length; i++) {
	          var liData = that.selectpicker.current.data[i + that.selectpicker.view.position0],
	              option = liData.option;

	          if (option) {
	            if (selectedOnly !== true) {
	              that.setDisabled(liData.index, liData.disabled);
	            }

	            that.setSelected(liData.index, option.selected);
	          }
	        }
	      }
	    },

	    /**
	     * @param {number} index - the index of the option that is being changed
	     * @param {boolean} selected - true if the option is being selected, false if being deselected
	     */
	    setSelected: function setSelected(index, selected) {
	      var li = this.selectpicker.main.elements[index],
	          liData = this.selectpicker.main.data[index],
	          activeIndexIsSet = this.activeIndex !== undefined,
	          thisIsActive = this.activeIndex === index,
	          prevActive,
	          a,

	      // if current option is already active
	      // OR
	      // if the current option is being selected, it's NOT multiple, and
	      // activeIndex is undefined:
	      //  - when the menu is first being opened, OR
	      //  - after a search has been performed, OR
	      //  - when retainActive is false when selecting a new option (i.e. index of the newly selected option is not the same as the current activeIndex)
	      keepActive = thisIsActive || selected && !this.multiple && !activeIndexIsSet;

	      liData.selected = selected;

	      a = li.firstChild;

	      if (selected) {
	        this.selectedIndex = index;
	      }

	      li.classList.toggle('selected', selected);

	      if (keepActive) {
	        this.focusItem(li, liData);
	        this.selectpicker.view.currentActive = li;
	        this.activeIndex = index;
	      } else {
	        this.defocusItem(li);
	      }

	      if (a) {
	        a.classList.toggle('selected', selected);

	        if (selected) {
	          a.setAttribute('aria-selected', true);
	        } else {
	          if (this.multiple) {
	            a.setAttribute('aria-selected', false);
	          } else {
	            a.removeAttribute('aria-selected');
	          }
	        }
	      }

	      if (!keepActive && !activeIndexIsSet && selected && this.prevActiveIndex !== undefined) {
	        prevActive = this.selectpicker.main.elements[this.prevActiveIndex];

	        this.defocusItem(prevActive);
	      }
	    },

	    /**
	     * @param {number} index - the index of the option that is being disabled
	     * @param {boolean} disabled - true if the option is being disabled, false if being enabled
	     */
	    setDisabled: function setDisabled(index, disabled) {
	      var li = this.selectpicker.main.elements[index],
	          a;

	      this.selectpicker.main.data[index].disabled = disabled;

	      a = li.firstChild;

	      li.classList.toggle(classNames.DISABLED, disabled);

	      if (a) {
	        if (version.major === '4') a.classList.toggle(classNames.DISABLED, disabled);

	        if (disabled) {
	          a.setAttribute('aria-disabled', disabled);
	          a.setAttribute('tabindex', -1);
	        } else {
	          a.removeAttribute('aria-disabled');
	          a.setAttribute('tabindex', 0);
	        }
	      }
	    },

	    isDisabled: function isDisabled() {
	      return this.$element[0].disabled;
	    },

	    checkDisabled: function checkDisabled() {
	      if (this.isDisabled()) {
	        this.$newElement[0].classList.add(classNames.DISABLED);
	        this.$button.addClass(classNames.DISABLED).attr('aria-disabled', true);
	      } else {
	        if (this.$button[0].classList.contains(classNames.DISABLED)) {
	          this.$newElement[0].classList.remove(classNames.DISABLED);
	          this.$button.removeClass(classNames.DISABLED).attr('aria-disabled', false);
	        }
	      }
	    },

	    clickListener: function clickListener() {
	      var that = this,
	          $document = $(document);

	      $document.data('spaceSelect', false);

	      this.$button.on('keyup', function (e) {
	        if (/(32)/.test(e.keyCode.toString(10)) && $document.data('spaceSelect')) {
	          e.preventDefault();
	          $document.data('spaceSelect', false);
	        }
	      });

	      this.$newElement.on('show.bs.dropdown', function () {
	        if (version.major > 3 && !that.dropdown) {
	          that.dropdown = that.$button.data('bs.dropdown');
	          that.dropdown._menu = that.$menu[0];
	        }
	      });

	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (!that.$newElement.hasClass(classNames.SHOW)) {
	          that.setSize();
	        }
	      });

	      function setFocus() {
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$menuInner.trigger('focus');
	        }
	      }

	      function checkPopperExists() {
	        if (that.dropdown && that.dropdown._popper && that.dropdown._popper.state.isCreated) {
	          setFocus();
	        } else {
	          requestAnimationFrame(checkPopperExists);
	        }
	      }

	      this.$element.on('shown' + EVENT_KEY, function () {
	        if (that.$menuInner[0].scrollTop !== that.selectpicker.view.scrollTop) {
	          that.$menuInner[0].scrollTop = that.selectpicker.view.scrollTop;
	        }

	        if (version.major > 3) {
	          requestAnimationFrame(checkPopperExists);
	        } else {
	          setFocus();
	        }
	      });

	      // ensure posinset and setsize are correct before selecting an option via a click
	      this.$menuInner.on('mouseenter', 'li a', function (e) {
	        var hoverLi = this.parentElement,
	            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
	            index = Array.prototype.indexOf.call(hoverLi.parentElement.children, hoverLi),
	            hoverData = that.selectpicker.current.data[index + position0];

	        that.focusItem(hoverLi, hoverData, true);
	      });

	      this.$menuInner.on('click', 'li a', function (e, retainActive) {
	        var $this = $(this),
	            element = that.$element[0],
	            position0 = that.isVirtual() ? that.selectpicker.view.position0 : 0,
	            clickedData = that.selectpicker.current.data[$this.parent().index() + position0],
	            clickedIndex = clickedData.index,
	            prevValue = getSelectValues(element),
	            prevIndex = element.selectedIndex,
	            prevOption = element.options[prevIndex],
	            triggerChange = true;

	        // Don't close on multi choice menu
	        if (that.multiple && that.options.maxOptions !== 1) {
	          e.stopPropagation();
	        }

	        e.preventDefault();

	        // Don't run if the select is disabled
	        if (!that.isDisabled() && !$this.parent().hasClass(classNames.DISABLED)) {
	          var option = clickedData.option,
	              $option = $(option),
	              state = option.selected,
	              $optgroup = $option.parent('optgroup'),
	              $optgroupOptions = $optgroup.find('option'),
	              maxOptions = that.options.maxOptions,
	              maxOptionsGrp = $optgroup.data('maxOptions') || false;

	          if (clickedIndex === that.activeIndex) retainActive = true;

	          if (!retainActive) {
	            that.prevActiveIndex = that.activeIndex;
	            that.activeIndex = undefined;
	          }

	          if (!that.multiple) {
	            // Deselect all others if not multi select box
	            if (prevOption) prevOption.selected = false;
	            option.selected = true;
	            that.setSelected(clickedIndex, true);
	          } else {
	            // Toggle the one we have chosen if we are multi select.
	            option.selected = !state;

	            that.setSelected(clickedIndex, !state);
	            that.focusedParent.focus();

	            if (maxOptions !== false || maxOptionsGrp !== false) {
	              var maxReached = maxOptions < getSelectedOptions(element).length,
	                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;

	              if (maxOptions && maxReached || maxOptionsGrp && maxReachedGrp) {
	                if (maxOptions && maxOptions == 1) {
	                  element.selectedIndex = -1;
	                  option.selected = true;
	                  that.setOptionStatus(true);
	                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
	                  for (var i = 0; i < $optgroupOptions.length; i++) {
	                    var _option = $optgroupOptions[i];
	                    _option.selected = false;
	                    that.setSelected(_option.liIndex, false);
	                  }

	                  option.selected = true;
	                  that.setSelected(clickedIndex, true);
	                } else {
	                  var maxOptionsText = typeof that.options.maxOptionsText === 'string' ? [that.options.maxOptionsText, that.options.maxOptionsText] : that.options.maxOptionsText,
	                      maxOptionsArr = typeof maxOptionsText === 'function' ? maxOptionsText(maxOptions, maxOptionsGrp) : maxOptionsText,
	                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
	                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
	                      $notify = $('<div class="notify"></div>');
	                  // If {var} is set in array, replace it
	                  /** @deprecated */
	                  if (maxOptionsArr[2]) {
	                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
	                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
	                  }

	                  option.selected = false;

	                  that.$menu.append($notify);

	                  if (maxOptions && maxReached) {
	                    $notify.append($('<div>' + maxTxt + '</div>'));
	                    triggerChange = false;
	                    that.$element.trigger('maxReached' + EVENT_KEY);
	                  }

	                  if (maxOptionsGrp && maxReachedGrp) {
	                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
	                    triggerChange = false;
	                    that.$element.trigger('maxReachedGrp' + EVENT_KEY);
	                  }

	                  setTimeout(function () {
	                    that.setSelected(clickedIndex, false);
	                  }, 10);

	                  $notify[0].classList.add('fadeOut');

	                  setTimeout(function () {
	                    $notify.remove();
	                  }, 1050);
	                }
	              }
	            }
	          }

	          if (!that.multiple || that.multiple && that.options.maxOptions === 1) {
	            that.$button.trigger('focus');
	          } else if (that.options.liveSearch) {
	            that.$searchbox.trigger('focus');
	          }

	          // Trigger select 'change'
	          if (triggerChange) {
	            if (that.multiple || prevIndex !== element.selectedIndex) {
	              // $option.prop('selected') is current option state (selected/unselected). prevValue is the value of the select prior to being changed.
	              changedArguments = [option.index, $option.prop('selected'), prevValue];
	              that.$element.triggerNative('change');
	            }
	          }
	        }
	      });

	      this.$menu.on('click', 'li.' + classNames.DISABLED + ' a, .' + classNames.POPOVERHEADER + ', .' + classNames.POPOVERHEADER + ' :not(.close)', function (e) {
	        if (e.currentTarget == this) {
	          e.preventDefault();
	          e.stopPropagation();
	          if (that.options.liveSearch && !$(e.target).hasClass('close')) {
	            that.$searchbox.trigger('focus');
	          } else {
	            that.$button.trigger('focus');
	          }
	        }
	      });

	      this.$menuInner.on('click', '.divider, .dropdown-header', function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$button.trigger('focus');
	        }
	      });

	      this.$menu.on('click', '.' + classNames.POPOVERHEADER + ' .close', function () {
	        that.$button.trigger('click');
	      });

	      this.$searchbox.on('click', function (e) {
	        e.stopPropagation();
	      });

	      this.$menu.on('click', '.actions-btn', function (e) {
	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          that.$button.trigger('focus');
	        }

	        e.preventDefault();
	        e.stopPropagation();

	        if ($(this).hasClass('bs-select-all')) {
	          that.selectAll();
	        } else {
	          that.deselectAll();
	        }
	      });

	      this.$button.on('focus' + EVENT_KEY, function (e) {
	        var tabindex = that.$element[0].getAttribute('tabindex');

	        // only change when button is actually focused
	        if (tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
	          // apply select element's tabindex to ensure correct order is followed when tabbing to the next element
	          this.setAttribute('tabindex', tabindex);
	          // set element's tabindex to -1 to allow for reverse tabbing
	          that.$element[0].setAttribute('tabindex', -1);
	          that.selectpicker.view.tabindex = tabindex;
	        }
	      }).on('blur' + EVENT_KEY, function (e) {
	        // revert everything to original tabindex
	        if (that.selectpicker.view.tabindex !== undefined && e.originalEvent && e.originalEvent.isTrusted) {
	          that.$element[0].setAttribute('tabindex', that.selectpicker.view.tabindex);
	          this.setAttribute('tabindex', -1);
	          that.selectpicker.view.tabindex = undefined;
	        }
	      });

	      this.$element.on('change' + EVENT_KEY, function () {
	        that.render();
	        that.$element.trigger('changed' + EVENT_KEY, changedArguments);
	        changedArguments = null;
	      }).on('focus' + EVENT_KEY, function () {
	        if (!that.options.mobile) that.$button[0].focus();
	      });
	    },

	    liveSearchListener: function liveSearchListener() {
	      var that = this;

	      this.$button.on('click.bs.dropdown.data-api', function () {
	        if (!!that.$searchbox.val()) {
	          that.$searchbox.val('');
	          that.selectpicker.search.previousValue = undefined;
	        }
	      });

	      this.$searchbox.on('click.bs.dropdown.data-api focus.bs.dropdown.data-api touchend.bs.dropdown.data-api', function (e) {
	        e.stopPropagation();
	      });

	      this.$searchbox.on('input propertychange', function () {
	        var searchValue = that.$searchbox[0].value;

	        that.selectpicker.search.elements = [];
	        that.selectpicker.search.data = [];

	        if (searchValue) {
	          var i,
	              searchMatch = [],
	              q = searchValue.toUpperCase(),
	              cache = {},
	              cacheArr = [],
	              searchStyle = that._searchStyle(),
	              normalizeSearch = that.options.liveSearchNormalize;

	          if (normalizeSearch) q = normalizeToBase(q);

	          for (var i = 0; i < that.selectpicker.main.data.length; i++) {
	            var li = that.selectpicker.main.data[i];

	            if (!cache[i]) {
	              cache[i] = stringSearch(li, q, searchStyle, normalizeSearch);
	            }

	            if (cache[i] && li.headerIndex !== undefined && cacheArr.indexOf(li.headerIndex) === -1) {
	              if (li.headerIndex > 0) {
	                cache[li.headerIndex - 1] = true;
	                cacheArr.push(li.headerIndex - 1);
	              }

	              cache[li.headerIndex] = true;
	              cacheArr.push(li.headerIndex);

	              cache[li.lastIndex + 1] = true;
	            }

	            if (cache[i] && li.type !== 'optgroup-label') cacheArr.push(i);
	          }

	          for (var i = 0, cacheLen = cacheArr.length; i < cacheLen; i++) {
	            var index = cacheArr[i],
	                prevIndex = cacheArr[i - 1],
	                li = that.selectpicker.main.data[index],
	                liPrev = that.selectpicker.main.data[prevIndex];

	            if (li.type !== 'divider' || li.type === 'divider' && liPrev && liPrev.type !== 'divider' && cacheLen - 1 !== i) {
	              that.selectpicker.search.data.push(li);
	              searchMatch.push(that.selectpicker.main.elements[index]);
	            }
	          }

	          that.activeIndex = undefined;
	          that.noScroll = true;
	          that.$menuInner.scrollTop(0);
	          that.selectpicker.search.elements = searchMatch;
	          that.createView(true);
	          showNoResults.call(that, searchMatch, searchValue);
	        } else if (that.selectpicker.search.previousValue) {
	          // for IE11 (#2402)
	          that.$menuInner.scrollTop(0);
	          that.createView(false);
	        }

	        that.selectpicker.search.previousValue = searchValue;
	      });
	    },

	    _searchStyle: function _searchStyle() {
	      return this.options.liveSearchStyle || 'contains';
	    },

	    val: function val(value) {
	      var element = this.$element[0];

	      if (typeof value !== 'undefined') {
	        var prevValue = getSelectValues(element);

	        changedArguments = [null, null, prevValue];

	        this.$element.val(value).trigger('changed' + EVENT_KEY, changedArguments);

	        if (this.$newElement.hasClass(classNames.SHOW)) {
	          if (this.multiple) {
	            this.setOptionStatus(true);
	          } else {
	            var liSelectedIndex = (element.options[element.selectedIndex] || {}).liIndex;

	            if (typeof liSelectedIndex === 'number') {
	              this.setSelected(this.selectedIndex, false);
	              this.setSelected(liSelectedIndex, true);
	            }
	          }
	        }

	        this.render();

	        changedArguments = null;

	        return this.$element;
	      } else {
	        return this.$element.val();
	      }
	    },

	    changeAll: function changeAll(status) {
	      if (!this.multiple) return;
	      if (typeof status === 'undefined') status = true;

	      var element = this.$element[0],
	          previousSelected = 0,
	          currentSelected = 0,
	          prevValue = getSelectValues(element);

	      element.classList.add('bs-select-hidden');

	      for (var i = 0, data = this.selectpicker.current.data, len = data.length; i < len; i++) {
	        var liData = data[i],
	            option = liData.option;

	        if (option && !liData.disabled && liData.type !== 'divider') {
	          if (liData.selected) previousSelected++;
	          option.selected = status;
	          if (status === true) currentSelected++;
	        }
	      }

	      element.classList.remove('bs-select-hidden');

	      if (previousSelected === currentSelected) return;

	      this.setOptionStatus();

	      changedArguments = [null, null, prevValue];

	      this.$element.triggerNative('change');
	    },

	    selectAll: function selectAll() {
	      return this.changeAll(true);
	    },

	    deselectAll: function deselectAll() {
	      return this.changeAll(false);
	    },

	    toggle: function toggle(e) {
	      e = e || window.event;

	      if (e) e.stopPropagation();

	      this.$button.trigger('click.bs.dropdown.data-api');
	    },

	    keydown: function keydown(e) {
	      var $this = $(this),
	          isToggle = $this.hasClass('dropdown-toggle'),
	          $parent = isToggle ? $this.closest('.dropdown') : $this.closest(Selector.MENU),
	          that = $parent.data('this'),
	          $items = that.findLis(),
	          index,
	          isActive,
	          liActive,
	          activeLi,
	          offset,
	          updateScroll = false,
	          downOnTab = e.which === keyCodes.TAB && !isToggle && !that.options.selectOnTab,
	          isArrowKey = REGEXP_ARROW.test(e.which) || downOnTab,
	          scrollTop = that.$menuInner[0].scrollTop,
	          isVirtual = that.isVirtual(),
	          position0 = isVirtual === true ? that.selectpicker.view.position0 : 0;

	      // do nothing if a function key is pressed
	      if (e.which >= 112 && e.which <= 123) return;

	      isActive = that.$newElement.hasClass(classNames.SHOW);

	      if (!isActive && (isArrowKey || e.which >= 48 && e.which <= 57 || e.which >= 96 && e.which <= 105 || e.which >= 65 && e.which <= 90)) {
	        that.$button.trigger('click.bs.dropdown.data-api');

	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	          return;
	        }
	      }

	      if (e.which === keyCodes.ESCAPE && isActive) {
	        e.preventDefault();
	        that.$button.trigger('click.bs.dropdown.data-api').trigger('focus');
	      }

	      if (isArrowKey) {
	        // if up or down
	        if (!$items.length) return;

	        liActive = that.selectpicker.main.elements[that.activeIndex];
	        index = liActive ? Array.prototype.indexOf.call(liActive.parentElement.children, liActive) : -1;

	        if (index !== -1) {
	          that.defocusItem(liActive);
	        }

	        if (e.which === keyCodes.ARROW_UP) {
	          // up
	          if (index !== -1) index--;
	          if (index + position0 < 0) index += $items.length;

	          if (!that.selectpicker.view.canHighlight[index + position0]) {
	            index = that.selectpicker.view.canHighlight.slice(0, index + position0).lastIndexOf(true) - position0;
	            if (index === -1) index = $items.length - 1;
	          }
	        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
	          // down
	          index++;
	          if (index + position0 >= that.selectpicker.view.canHighlight.length) index = that.selectpicker.view.firstHighlightIndex;

	          if (!that.selectpicker.view.canHighlight[index + position0]) {
	            index = index + 1 + that.selectpicker.view.canHighlight.slice(index + position0 + 1).indexOf(true);
	          }
	        }

	        e.preventDefault();

	        var liActiveIndex = position0 + index;

	        if (e.which === keyCodes.ARROW_UP) {
	          // up
	          // scroll to bottom and highlight last option
	          if (position0 === 0 && index === $items.length - 1) {
	            that.$menuInner[0].scrollTop = that.$menuInner[0].scrollHeight;

	            liActiveIndex = that.selectpicker.current.elements.length - 1;
	          } else {
	            activeLi = that.selectpicker.current.data[liActiveIndex];
	            offset = activeLi.position - activeLi.height;

	            updateScroll = offset < scrollTop;
	          }
	        } else if (e.which === keyCodes.ARROW_DOWN || downOnTab) {
	          // down
	          // scroll to top and highlight first option
	          if (index === that.selectpicker.view.firstHighlightIndex) {
	            that.$menuInner[0].scrollTop = 0;

	            liActiveIndex = that.selectpicker.view.firstHighlightIndex;
	          } else {
	            activeLi = that.selectpicker.current.data[liActiveIndex];
	            offset = activeLi.position - that.sizeInfo.menuInnerHeight;

	            updateScroll = offset > scrollTop;
	          }
	        }

	        liActive = that.selectpicker.current.elements[liActiveIndex];

	        that.activeIndex = that.selectpicker.current.data[liActiveIndex].index;

	        that.focusItem(liActive);

	        that.selectpicker.view.currentActive = liActive;

	        if (updateScroll) that.$menuInner[0].scrollTop = offset;

	        if (that.options.liveSearch) {
	          that.$searchbox.trigger('focus');
	        } else {
	          $this.trigger('focus');
	        }
	      } else if (!$this.is('input') && !REGEXP_TAB_OR_ESCAPE.test(e.which) || e.which === keyCodes.SPACE && that.selectpicker.keydown.keyHistory) {
	        var searchMatch,
	            matches = [],
	            keyHistory;

	        e.preventDefault();

	        that.selectpicker.keydown.keyHistory += keyCodeMap[e.which];

	        if (that.selectpicker.keydown.resetKeyHistory.cancel) clearTimeout(that.selectpicker.keydown.resetKeyHistory.cancel);
	        that.selectpicker.keydown.resetKeyHistory.cancel = that.selectpicker.keydown.resetKeyHistory.start();

	        keyHistory = that.selectpicker.keydown.keyHistory;

	        // if all letters are the same, set keyHistory to just the first character when searching
	        if (/^(.)\1+$/.test(keyHistory)) {
	          keyHistory = keyHistory.charAt(0);
	        }

	        // find matches
	        for (var i = 0; i < that.selectpicker.current.data.length; i++) {
	          var li = that.selectpicker.current.data[i],
	              hasMatch;

	          hasMatch = stringSearch(li, keyHistory, 'startsWith', true);

	          if (hasMatch && that.selectpicker.view.canHighlight[i]) {
	            matches.push(li.index);
	          }
	        }

	        if (matches.length) {
	          var matchIndex = 0;

	          $items.removeClass('active').find('a').removeClass('active');

	          // either only one key has been pressed or they are all the same key
	          if (keyHistory.length === 1) {
	            matchIndex = matches.indexOf(that.activeIndex);

	            if (matchIndex === -1 || matchIndex === matches.length - 1) {
	              matchIndex = 0;
	            } else {
	              matchIndex++;
	            }
	          }

	          searchMatch = matches[matchIndex];

	          activeLi = that.selectpicker.main.data[searchMatch];

	          if (scrollTop - activeLi.position > 0) {
	            offset = activeLi.position - activeLi.height;
	            updateScroll = true;
	          } else {
	            offset = activeLi.position - that.sizeInfo.menuInnerHeight;
	            // if the option is already visible at the current scroll position, just keep it the same
	            updateScroll = activeLi.position > scrollTop + that.sizeInfo.menuInnerHeight;
	          }

	          liActive = that.selectpicker.main.elements[searchMatch];

	          that.activeIndex = matches[matchIndex];

	          that.focusItem(liActive);

	          if (liActive) liActive.firstChild.focus();

	          if (updateScroll) that.$menuInner[0].scrollTop = offset;

	          $this.trigger('focus');
	        }
	      }

	      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
	      if (isActive && (e.which === keyCodes.SPACE && !that.selectpicker.keydown.keyHistory || e.which === keyCodes.ENTER || e.which === keyCodes.TAB && that.options.selectOnTab)) {
	        if (e.which !== keyCodes.SPACE) e.preventDefault();

	        if (!that.options.liveSearch || e.which !== keyCodes.SPACE) {
	          that.$menuInner.find('.active a').trigger('click', true); // retain active class
	          $this.trigger('focus');

	          if (!that.options.liveSearch) {
	            // Prevent screen from scrolling if the user hits the spacebar
	            e.preventDefault();
	            // Fixes spacebar selection of dropdown items in FF & IE
	            $(document).data('spaceSelect', true);
	          }
	        }
	      }
	    },

	    mobile: function mobile() {
	      // ensure mobile is set to true if mobile function is called after init
	      this.options.mobile = true;
	      this.$element[0].classList.add('mobile-device');
	    },

	    refresh: function refresh() {
	      // update options if data attributes have been changed
	      var config = $.extend({}, this.options, this.$element.data());
	      this.options = config;

	      this.checkDisabled();
	      this.buildData();
	      this.setStyle();
	      this.render();
	      this.buildList();
	      this.setWidth();

	      this.setSize(true);

	      this.$element.trigger('refreshed' + EVENT_KEY);
	    },

	    hide: function hide() {
	      this.$newElement.hide();
	    },

	    show: function show() {
	      this.$newElement.show();
	    },

	    remove: function remove() {
	      this.$newElement.remove();
	      this.$element.remove();
	    },

	    destroy: function destroy() {
	      this.$newElement.before(this.$element).remove();

	      if (this.$bsContainer) {
	        this.$bsContainer.remove();
	      } else {
	        this.$menu.remove();
	      }

	      if (this.selectpicker.view.titleOption && this.selectpicker.view.titleOption.parentNode) {
	        this.selectpicker.view.titleOption.parentNode.removeChild(this.selectpicker.view.titleOption);
	      }

	      this.$element.off(EVENT_KEY).removeData('selectpicker').removeClass('bs-select-hidden selectpicker');

	      $(window).off(EVENT_KEY + '.' + this.selectId);
	    }
	  };

	  // SELECTPICKER PLUGIN DEFINITION
	  // ==============================
	  function Plugin(option) {
	    // get the args of the outer function..
	    var args = arguments;
	    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
	    // to get lost/corrupted in android 2.3 and IE9 #715 #775
	    var _option = option;

	    [].shift.apply(args);

	    // if the version was not set successfully
	    if (!version.success) {
	      // try to retreive it again
	      try {
	        version.full = ($.fn.dropdown.Constructor.VERSION || '').split(' ')[0].split('.');
	      } catch (err) {
	        // fall back to use BootstrapVersion if set
	        if (Selectpicker.BootstrapVersion) {
	          version.full = Selectpicker.BootstrapVersion.split(' ')[0].split('.');
	        } else {
	          version.full = [version.major, '0', '0'];

	          console.warn('There was an issue retrieving Bootstrap\'s version. ' + 'Ensure Bootstrap is being loaded before bootstrap-select and there is no namespace collision. ' + 'If loading Bootstrap asynchronously, the version may need to be manually specified via $.fn.selectpicker.Constructor.BootstrapVersion.', err);
	        }
	      }

	      version.major = version.full[0];
	      version.success = true;
	    }

	    if (version.major === '4') {
	      // some defaults need to be changed if using Bootstrap 4
	      // check to see if they have already been manually changed before forcing them to update
	      var toUpdate = [];

	      if (Selectpicker.DEFAULTS.style === classNames.BUTTONCLASS) toUpdate.push({ name: 'style', className: 'BUTTONCLASS' });
	      if (Selectpicker.DEFAULTS.iconBase === classNames.ICONBASE) toUpdate.push({ name: 'iconBase', className: 'ICONBASE' });
	      if (Selectpicker.DEFAULTS.tickIcon === classNames.TICKICON) toUpdate.push({ name: 'tickIcon', className: 'TICKICON' });

	      classNames.DIVIDER = 'dropdown-divider';
	      classNames.SHOW = 'show';
	      classNames.BUTTONCLASS = 'btn-light';
	      classNames.POPOVERHEADER = 'popover-header';
	      classNames.ICONBASE = '';
	      classNames.TICKICON = 'bs-ok-default';

	      for (var i = 0; i < toUpdate.length; i++) {
	        var option = toUpdate[i];
	        Selectpicker.DEFAULTS[option.name] = classNames[option.className];
	      }
	    }

	    var value;
	    var chain = this.each(function () {
	      var $this = $(this);
	      if ($this.is('select')) {
	        var data = $this.data('selectpicker'),
	            options = (typeof _option === 'undefined' ? 'undefined' : _typeof(_option)) == 'object' && _option;

	        if (!data) {
	          var dataAttributes = $this.data();

	          for (var dataAttr in dataAttributes) {
	            if (Object.prototype.hasOwnProperty.call(dataAttributes, dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
	              delete dataAttributes[dataAttr];
	            }
	          }

	          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, dataAttributes, options);
	          config.template = $.extend({}, Selectpicker.DEFAULTS.template, $.fn.selectpicker.defaults ? $.fn.selectpicker.defaults.template : {}, dataAttributes.template, options.template);
	          $this.data('selectpicker', data = new Selectpicker(this, config));
	        } else if (options) {
	          for (var i in options) {
	            if (Object.prototype.hasOwnProperty.call(options, i)) {
	              data.options[i] = options[i];
	            }
	          }
	        }

	        if (typeof _option == 'string') {
	          if (data[_option] instanceof Function) {
	            value = data[_option].apply(data, args);
	          } else {
	            value = data.options[_option];
	          }
	        }
	      }
	    });

	    if (typeof value !== 'undefined') {
	      // noinspection JSUnusedAssignment
	      return value;
	    } else {
	      return chain;
	    }
	  }

	  var old = $.fn.selectpicker;
	  $.fn.selectpicker = Plugin;
	  $.fn.selectpicker.Constructor = Selectpicker;

	  // SELECTPICKER NO CONFLICT
	  // ========================
	  $.fn.selectpicker.noConflict = function () {
	    $.fn.selectpicker = old;
	    return this;
	  };

	  // get Bootstrap's keydown event handler for either Bootstrap 4 or Bootstrap 3
	  function keydownHandler() {
	    if ($.fn.dropdown) {
	      // wait to define until function is called in case Bootstrap isn't loaded yet
	      var bootstrapKeydown = $.fn.dropdown.Constructor._dataApiKeydownHandler || $.fn.dropdown.Constructor.prototype.keydown;
	      return bootstrapKeydown.apply(this, arguments);
	    }
	  }

	  $(document).off('keydown.bs.dropdown.data-api').on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > [data-toggle="dropdown"]', keydownHandler).on('keydown.bs.dropdown.data-api', ':not(.bootstrap-select) > .dropdown-menu', keydownHandler).on('keydown' + EVENT_KEY, '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', Selectpicker.prototype.keydown).on('focusin.modal', '.bootstrap-select [data-toggle="dropdown"], .bootstrap-select [role="listbox"], .bootstrap-select .bs-searchbox input', function (e) {
	    e.stopPropagation();
	  });

	  // SELECTPICKER DATA-API
	  // =====================
	  $(window).on('load' + EVENT_KEY + '.data-api', function () {
	    $('.selectpicker').each(function () {
	      var $selectpicker = $(this);
	      Plugin.call($selectpicker, $selectpicker.data());
	    });
	  });
	})(jQuery);

	// WEBPACK FOOTER //
	// ./~/bootstrap-select/js/bootstrap-select.js

/***/ }),
/* 163 */,
/* 164 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Show a spinner inside a given element
	 * @param {element} $target - Element to block by the veil and spinner.
	 *                            Pass body to block the whole page.
	 */

	function addSpinner($target) {
	    var $veil = $('<div class="veil"><div class="underlay"></div></div>');
	    $veil.append('<img src="/on/demandware.static/Sites-bata-in-Site/-/default/dwde59f196/images/loader.svg" alt="loader" class="spinner">');
	    if ($target.get(0).tagName === 'IMG') {
	        $target.after($veil);
	        $veil.css({ width: $target.width(), height: $target.height() });
	        if ($target.parent().css('position') === 'static') {
	            $target.parent().css('position', 'relative');
	        }
	    } else {
	        $target.append($veil);
	        if ($target.css('position') === 'static') {
	            $target.parent().css('position', 'relative');
	            $target.parent().addClass('veiled');
	        }
	        if ($target.get(0).tagName === 'BODY') {
	            $veil.find('.spinner').css('position', 'fixed');
	        }
	    }
	    $veil.click(function (e) {
	        e.stopPropagation();
	    });
	}

	/**
	 * Remove existing spinner
	 * @param  {element} $veil - jQuery pointer to the veil element
	 */
	function removeSpinner($veil) {
	    if ($veil.parent().hasClass('veiled')) {
	        $veil.parent().css('position', '');
	        $veil.parent().removeClass('veiled');
	    }
	    $veil.off('click');
	    $veil.remove();
	}

	// element level spinner:
	$.fn.spinner = function () {
	    var $element = $(this);
	    var Fn = function Fn() {
	        this.start = function () {
	            if ($element.length) {
	                addSpinner($element);
	            }
	        };
	        this.stop = function () {
	            if ($element.length) {
	                var $veil = $('.veil');
	                removeSpinner($veil);
	            }
	        };
	    };
	    return new Fn();
	};

	// page-level spinner:
	$.spinner = function () {
	    var Fn = function Fn() {
	        this.start = function () {
	            addSpinner($('body'));
	        };
	        this.stop = function () {
	            removeSpinner($('.veil'));
	        };
	    };
	    return new Fn();
	};

	$('body').on('spinner:start', function () {
	    addSpinner($('body'));
	});

	$('body').on('spinner:stop', function () {
	    removeSpinner($('.veil'));
	});

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	/*
	     _ _      _       _
	 ___| (_) ___| | __  (_)___
	/ __| | |/ __| |/ /  | / __|
	\__ \ | | (__|   < _ | \__ \
	|___/_|_|\___|_|\_(_)/ |___/
	                   |__/

	 Version: 1.8.1
	  Author: Ken Wheeler
	 Website: http://kenwheeler.github.io
	    Docs: http://kenwheeler.github.io/slick
	    Repo: http://github.com/kenwheeler/slick
	  Issues: http://github.com/kenwheeler/slick/issues

	 */
	/* global window, document, define, jQuery, setInterval, clearInterval */
	;(function (factory) {
	    'use strict';

	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(109)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports !== 'undefined') {
	        module.exports = factory(require('jquery'));
	    } else {
	        factory(jQuery);
	    }
	})(function ($) {
	    'use strict';

	    var Slick = window.Slick || {};

	    Slick = function () {

	        var instanceUid = 0;

	        function Slick(element, settings) {

	            var _ = this,
	                dataSettings;

	            _.defaults = {
	                accessibility: true,
	                adaptiveHeight: false,
	                appendArrows: $(element),
	                appendDots: $(element),
	                arrows: true,
	                asNavFor: null,
	                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
	                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
	                autoplay: false,
	                autoplaySpeed: 3000,
	                centerMode: false,
	                centerPadding: '50px',
	                cssEase: 'ease',
	                customPaging: function customPaging(slider, i) {
	                    return $('<button type="button" />').text(i + 1);
	                },
	                dots: false,
	                dotsClass: 'slick-dots',
	                draggable: true,
	                easing: 'linear',
	                edgeFriction: 0.35,
	                fade: false,
	                focusOnSelect: false,
	                focusOnChange: false,
	                infinite: true,
	                initialSlide: 0,
	                lazyLoad: 'ondemand',
	                mobileFirst: false,
	                pauseOnHover: true,
	                pauseOnFocus: true,
	                pauseOnDotsHover: false,
	                respondTo: 'window',
	                responsive: null,
	                rows: 1,
	                rtl: false,
	                slide: '',
	                slidesPerRow: 1,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                speed: 500,
	                swipe: true,
	                swipeToSlide: false,
	                touchMove: true,
	                touchThreshold: 5,
	                useCSS: true,
	                useTransform: true,
	                variableWidth: false,
	                vertical: false,
	                verticalSwiping: false,
	                waitForAnimate: true,
	                zIndex: 1000
	            };

	            _.initials = {
	                animating: false,
	                dragging: false,
	                autoPlayTimer: null,
	                currentDirection: 0,
	                currentLeft: null,
	                currentSlide: 0,
	                direction: 1,
	                $dots: null,
	                listWidth: null,
	                listHeight: null,
	                loadIndex: 0,
	                $nextArrow: null,
	                $prevArrow: null,
	                scrolling: false,
	                slideCount: null,
	                slideWidth: null,
	                $slideTrack: null,
	                $slides: null,
	                sliding: false,
	                slideOffset: 0,
	                swipeLeft: null,
	                swiping: false,
	                $list: null,
	                touchObject: {},
	                transformsEnabled: false,
	                unslicked: false
	            };

	            $.extend(_, _.initials);

	            _.activeBreakpoint = null;
	            _.animType = null;
	            _.animProp = null;
	            _.breakpoints = [];
	            _.breakpointSettings = [];
	            _.cssTransitions = false;
	            _.focussed = false;
	            _.interrupted = false;
	            _.hidden = 'hidden';
	            _.paused = true;
	            _.positionProp = null;
	            _.respondTo = null;
	            _.rowCount = 1;
	            _.shouldClick = true;
	            _.$slider = $(element);
	            _.$slidesCache = null;
	            _.transformType = null;
	            _.transitionType = null;
	            _.visibilityChange = 'visibilitychange';
	            _.windowWidth = 0;
	            _.windowTimer = null;

	            dataSettings = $(element).data('slick') || {};

	            _.options = $.extend({}, _.defaults, settings, dataSettings);

	            _.currentSlide = _.options.initialSlide;

	            _.originalSettings = _.options;

	            if (typeof document.mozHidden !== 'undefined') {
	                _.hidden = 'mozHidden';
	                _.visibilityChange = 'mozvisibilitychange';
	            } else if (typeof document.webkitHidden !== 'undefined') {
	                _.hidden = 'webkitHidden';
	                _.visibilityChange = 'webkitvisibilitychange';
	            }

	            _.autoPlay = $.proxy(_.autoPlay, _);
	            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
	            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
	            _.changeSlide = $.proxy(_.changeSlide, _);
	            _.clickHandler = $.proxy(_.clickHandler, _);
	            _.selectHandler = $.proxy(_.selectHandler, _);
	            _.setPosition = $.proxy(_.setPosition, _);
	            _.swipeHandler = $.proxy(_.swipeHandler, _);
	            _.dragHandler = $.proxy(_.dragHandler, _);
	            _.keyHandler = $.proxy(_.keyHandler, _);

	            _.instanceUid = instanceUid++;

	            // A simple way to check for HTML strings
	            // Strict HTML recognition (must start with <)
	            // Extracted from jQuery v1.11 source
	            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;

	            _.registerBreakpoints();
	            _.init(true);
	        }

	        return Slick;
	    }();

	    Slick.prototype.activateADA = function () {
	        var _ = this;

	        _.$slideTrack.find('.slick-active').attr({
	            'aria-hidden': 'false'
	        }).find('a, input, button, select').attr({
	            'tabindex': '0'
	        });
	    };

	    Slick.prototype.addSlide = Slick.prototype.slickAdd = function (markup, index, addBefore) {

	        var _ = this;

	        if (typeof index === 'boolean') {
	            addBefore = index;
	            index = null;
	        } else if (index < 0 || index >= _.slideCount) {
	            return false;
	        }

	        _.unload();

	        if (typeof index === 'number') {
	            if (index === 0 && _.$slides.length === 0) {
	                $(markup).appendTo(_.$slideTrack);
	            } else if (addBefore) {
	                $(markup).insertBefore(_.$slides.eq(index));
	            } else {
	                $(markup).insertAfter(_.$slides.eq(index));
	            }
	        } else {
	            if (addBefore === true) {
	                $(markup).prependTo(_.$slideTrack);
	            } else {
	                $(markup).appendTo(_.$slideTrack);
	            }
	        }

	        _.$slides = _.$slideTrack.children(this.options.slide);

	        _.$slideTrack.children(this.options.slide).detach();

	        _.$slideTrack.append(_.$slides);

	        _.$slides.each(function (index, element) {
	            $(element).attr('data-slick-index', index);
	        });

	        _.$slidesCache = _.$slides;

	        _.reinit();
	    };

	    Slick.prototype.animateHeight = function () {
	        var _ = this;
	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.animate({
	                height: targetHeight
	            }, _.options.speed);
	        }
	    };

	    Slick.prototype.animateSlide = function (targetLeft, callback) {

	        var animProps = {},
	            _ = this;

	        _.animateHeight();

	        if (_.options.rtl === true && _.options.vertical === false) {
	            targetLeft = -targetLeft;
	        }
	        if (_.transformsEnabled === false) {
	            if (_.options.vertical === false) {
	                _.$slideTrack.animate({
	                    left: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            } else {
	                _.$slideTrack.animate({
	                    top: targetLeft
	                }, _.options.speed, _.options.easing, callback);
	            }
	        } else {

	            if (_.cssTransitions === false) {
	                if (_.options.rtl === true) {
	                    _.currentLeft = -_.currentLeft;
	                }
	                $({
	                    animStart: _.currentLeft
	                }).animate({
	                    animStart: targetLeft
	                }, {
	                    duration: _.options.speed,
	                    easing: _.options.easing,
	                    step: function step(now) {
	                        now = Math.ceil(now);
	                        if (_.options.vertical === false) {
	                            animProps[_.animType] = 'translate(' + now + 'px, 0px)';
	                            _.$slideTrack.css(animProps);
	                        } else {
	                            animProps[_.animType] = 'translate(0px,' + now + 'px)';
	                            _.$slideTrack.css(animProps);
	                        }
	                    },
	                    complete: function complete() {
	                        if (callback) {
	                            callback.call();
	                        }
	                    }
	                });
	            } else {

	                _.applyTransition();
	                targetLeft = Math.ceil(targetLeft);

	                if (_.options.vertical === false) {
	                    animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
	                } else {
	                    animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
	                }
	                _.$slideTrack.css(animProps);

	                if (callback) {
	                    setTimeout(function () {

	                        _.disableTransition();

	                        callback.call();
	                    }, _.options.speed);
	                }
	            }
	        }
	    };

	    Slick.prototype.getNavTarget = function () {

	        var _ = this,
	            asNavFor = _.options.asNavFor;

	        if (asNavFor && asNavFor !== null) {
	            asNavFor = $(asNavFor).not(_.$slider);
	        }

	        return asNavFor;
	    };

	    Slick.prototype.asNavFor = function (index) {

	        var _ = this,
	            asNavFor = _.getNavTarget();

	        if (asNavFor !== null && (typeof asNavFor === 'undefined' ? 'undefined' : _typeof(asNavFor)) === 'object') {
	            asNavFor.each(function () {
	                var target = $(this).slick('getSlick');
	                if (!target.unslicked) {
	                    target.slideHandler(index, true);
	                }
	            });
	        }
	    };

	    Slick.prototype.applyTransition = function (slide) {

	        var _ = this,
	            transition = {};

	        if (_.options.fade === false) {
	            transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
	        } else {
	            transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
	        }

	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	    };

	    Slick.prototype.autoPlay = function () {

	        var _ = this;

	        _.autoPlayClear();

	        if (_.slideCount > _.options.slidesToShow) {
	            _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
	        }
	    };

	    Slick.prototype.autoPlayClear = function () {

	        var _ = this;

	        if (_.autoPlayTimer) {
	            clearInterval(_.autoPlayTimer);
	        }
	    };

	    Slick.prototype.autoPlayIterator = function () {

	        var _ = this,
	            slideTo = _.currentSlide + _.options.slidesToScroll;

	        if (!_.paused && !_.interrupted && !_.focussed) {

	            if (_.options.infinite === false) {

	                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) {
	                    _.direction = 0;
	                } else if (_.direction === 0) {

	                    slideTo = _.currentSlide - _.options.slidesToScroll;

	                    if (_.currentSlide - 1 === 0) {
	                        _.direction = 1;
	                    }
	                }
	            }

	            _.slideHandler(slideTo);
	        }
	    };

	    Slick.prototype.buildArrows = function () {

	        var _ = this;

	        if (_.options.arrows === true) {

	            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
	            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');

	            if (_.slideCount > _.options.slidesToShow) {

	                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
	                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');

	                if (_.htmlExpr.test(_.options.prevArrow)) {
	                    _.$prevArrow.prependTo(_.options.appendArrows);
	                }

	                if (_.htmlExpr.test(_.options.nextArrow)) {
	                    _.$nextArrow.appendTo(_.options.appendArrows);
	                }

	                if (_.options.infinite !== true) {
	                    _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                }
	            } else {

	                _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
	                    'aria-disabled': 'true',
	                    'tabindex': '-1'
	                });
	            }
	        }
	    };

	    Slick.prototype.buildDots = function () {

	        var _ = this,
	            i,
	            dot;

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

	            _.$slider.addClass('slick-dotted');

	            dot = $('<ul />').addClass(_.options.dotsClass);

	            for (i = 0; i <= _.getDotCount(); i += 1) {
	                dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
	            }

	            _.$dots = dot.appendTo(_.options.appendDots);

	            _.$dots.find('li').first().addClass('slick-active');
	        }
	    };

	    Slick.prototype.buildOut = function () {

	        var _ = this;

	        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');

	        _.slideCount = _.$slides.length;

	        _.$slides.each(function (index, element) {
	            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
	        });

	        _.$slider.addClass('slick-slider');

	        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();

	        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
	        _.$slideTrack.css('opacity', 0);

	        if (_.options.centerMode === true || _.options.swipeToSlide === true) {
	            _.options.slidesToScroll = 1;
	        }

	        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');

	        _.setupInfinite();

	        _.buildArrows();

	        _.buildDots();

	        _.updateDots();

	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

	        if (_.options.draggable === true) {
	            _.$list.addClass('draggable');
	        }
	    };

	    Slick.prototype.buildRows = function () {

	        var _ = this,
	            a,
	            b,
	            c,
	            newSlides,
	            numOfSlides,
	            originalSlides,
	            slidesPerSection;

	        newSlides = document.createDocumentFragment();
	        originalSlides = _.$slider.children();

	        if (_.options.rows > 0) {

	            slidesPerSection = _.options.slidesPerRow * _.options.rows;
	            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);

	            for (a = 0; a < numOfSlides; a++) {
	                var slide = document.createElement('div');
	                for (b = 0; b < _.options.rows; b++) {
	                    var row = document.createElement('div');
	                    for (c = 0; c < _.options.slidesPerRow; c++) {
	                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
	                        if (originalSlides.get(target)) {
	                            row.appendChild(originalSlides.get(target));
	                        }
	                    }
	                    slide.appendChild(row);
	                }
	                newSlides.appendChild(slide);
	            }

	            _.$slider.empty().append(newSlides);
	            _.$slider.children().children().children().css({
	                'width': 100 / _.options.slidesPerRow + '%',
	                'display': 'inline-block'
	            });
	        }
	    };

	    Slick.prototype.checkResponsive = function (initial, forceUpdate) {

	        var _ = this,
	            breakpoint,
	            targetBreakpoint,
	            respondToWidth,
	            triggerBreakpoint = false;
	        var sliderWidth = _.$slider.width();
	        var windowWidth = window.innerWidth || $(window).width();

	        if (_.respondTo === 'window') {
	            respondToWidth = windowWidth;
	        } else if (_.respondTo === 'slider') {
	            respondToWidth = sliderWidth;
	        } else if (_.respondTo === 'min') {
	            respondToWidth = Math.min(windowWidth, sliderWidth);
	        }

	        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {

	            targetBreakpoint = null;

	            for (breakpoint in _.breakpoints) {
	                if (_.breakpoints.hasOwnProperty(breakpoint)) {
	                    if (_.originalSettings.mobileFirst === false) {
	                        if (respondToWidth < _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    } else {
	                        if (respondToWidth > _.breakpoints[breakpoint]) {
	                            targetBreakpoint = _.breakpoints[breakpoint];
	                        }
	                    }
	                }
	            }

	            if (targetBreakpoint !== null) {
	                if (_.activeBreakpoint !== null) {
	                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
	                        _.activeBreakpoint = targetBreakpoint;
	                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                            _.unslick(targetBreakpoint);
	                        } else {
	                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
	                            if (initial === true) {
	                                _.currentSlide = _.options.initialSlide;
	                            }
	                            _.refresh(initial);
	                        }
	                        triggerBreakpoint = targetBreakpoint;
	                    }
	                } else {
	                    _.activeBreakpoint = targetBreakpoint;
	                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') {
	                        _.unslick(targetBreakpoint);
	                    } else {
	                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
	                        if (initial === true) {
	                            _.currentSlide = _.options.initialSlide;
	                        }
	                        _.refresh(initial);
	                    }
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            } else {
	                if (_.activeBreakpoint !== null) {
	                    _.activeBreakpoint = null;
	                    _.options = _.originalSettings;
	                    if (initial === true) {
	                        _.currentSlide = _.options.initialSlide;
	                    }
	                    _.refresh(initial);
	                    triggerBreakpoint = targetBreakpoint;
	                }
	            }

	            // only trigger breakpoints during an actual break. not on initialize.
	            if (!initial && triggerBreakpoint !== false) {
	                _.$slider.trigger('breakpoint', [_, triggerBreakpoint]);
	            }
	        }
	    };

	    Slick.prototype.changeSlide = function (event, dontAnimate) {

	        var _ = this,
	            $target = $(event.currentTarget),
	            indexOffset,
	            slideOffset,
	            unevenOffset;

	        // If target is a link, prevent default action.
	        if ($target.is('a')) {
	            event.preventDefault();
	        }

	        // If target is not the <li> element (ie: a child), find the <li>.
	        if (!$target.is('li')) {
	            $target = $target.closest('li');
	        }

	        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
	        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;

	        switch (event.data.message) {

	            case 'previous':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
	                }
	                break;

	            case 'next':
	                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
	                if (_.slideCount > _.options.slidesToShow) {
	                    _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
	                }
	                break;

	            case 'index':
	                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;

	                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
	                $target.children().trigger('focus');
	                break;

	            default:
	                return;
	        }
	    };

	    Slick.prototype.checkNavigable = function (index) {

	        var _ = this,
	            navigables,
	            prevNavigable;

	        navigables = _.getNavigableIndexes();
	        prevNavigable = 0;
	        if (index > navigables[navigables.length - 1]) {
	            index = navigables[navigables.length - 1];
	        } else {
	            for (var n in navigables) {
	                if (index < navigables[n]) {
	                    index = prevNavigable;
	                    break;
	                }
	                prevNavigable = navigables[n];
	            }
	        }

	        return index;
	    };

	    Slick.prototype.cleanUpEvents = function () {

	        var _ = this;

	        if (_.options.dots && _.$dots !== null) {

	            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));

	            if (_.options.accessibility === true) {
	                _.$dots.off('keydown.slick', _.keyHandler);
	            }
	        }

	        _.$slider.off('focus.slick blur.slick');

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
	            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);

	            if (_.options.accessibility === true) {
	                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
	                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
	            }
	        }

	        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
	        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
	        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
	        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);

	        _.$list.off('click.slick', _.clickHandler);

	        $(document).off(_.visibilityChange, _.visibility);

	        _.cleanUpSlideEvents();

	        if (_.options.accessibility === true) {
	            _.$list.off('keydown.slick', _.keyHandler);
	        }

	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().off('click.slick', _.selectHandler);
	        }

	        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);

	        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);

	        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);

	        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
	    };

	    Slick.prototype.cleanUpSlideEvents = function () {

	        var _ = this;

	        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
	        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
	    };

	    Slick.prototype.cleanUpRows = function () {

	        var _ = this,
	            originalSlides;

	        if (_.options.rows > 0) {
	            originalSlides = _.$slides.children().children();
	            originalSlides.removeAttr('style');
	            _.$slider.empty().append(originalSlides);
	        }
	    };

	    Slick.prototype.clickHandler = function (event) {

	        var _ = this;

	        if (_.shouldClick === false) {
	            event.stopImmediatePropagation();
	            event.stopPropagation();
	            event.preventDefault();
	        }
	    };

	    Slick.prototype.destroy = function (refresh) {

	        var _ = this;

	        _.autoPlayClear();

	        _.touchObject = {};

	        _.cleanUpEvents();

	        $('.slick-cloned', _.$slider).detach();

	        if (_.$dots) {
	            _.$dots.remove();
	        }

	        if (_.$prevArrow && _.$prevArrow.length) {

	            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

	            if (_.htmlExpr.test(_.options.prevArrow)) {
	                _.$prevArrow.remove();
	            }
	        }

	        if (_.$nextArrow && _.$nextArrow.length) {

	            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');

	            if (_.htmlExpr.test(_.options.nextArrow)) {
	                _.$nextArrow.remove();
	            }
	        }

	        if (_.$slides) {

	            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function () {
	                $(this).attr('style', $(this).data('originalStyling'));
	            });

	            _.$slideTrack.children(this.options.slide).detach();

	            _.$slideTrack.detach();

	            _.$list.detach();

	            _.$slider.append(_.$slides);
	        }

	        _.cleanUpRows();

	        _.$slider.removeClass('slick-slider');
	        _.$slider.removeClass('slick-initialized');
	        _.$slider.removeClass('slick-dotted');

	        _.unslicked = true;

	        if (!refresh) {
	            _.$slider.trigger('destroy', [_]);
	        }
	    };

	    Slick.prototype.disableTransition = function (slide) {

	        var _ = this,
	            transition = {};

	        transition[_.transitionType] = '';

	        if (_.options.fade === false) {
	            _.$slideTrack.css(transition);
	        } else {
	            _.$slides.eq(slide).css(transition);
	        }
	    };

	    Slick.prototype.fadeSlide = function (slideIndex, callback) {

	        var _ = this;

	        if (_.cssTransitions === false) {

	            _.$slides.eq(slideIndex).css({
	                zIndex: _.options.zIndex
	            });

	            _.$slides.eq(slideIndex).animate({
	                opacity: 1
	            }, _.options.speed, _.options.easing, callback);
	        } else {

	            _.applyTransition(slideIndex);

	            _.$slides.eq(slideIndex).css({
	                opacity: 1,
	                zIndex: _.options.zIndex
	            });

	            if (callback) {
	                setTimeout(function () {

	                    _.disableTransition(slideIndex);

	                    callback.call();
	                }, _.options.speed);
	            }
	        }
	    };

	    Slick.prototype.fadeSlideOut = function (slideIndex) {

	        var _ = this;

	        if (_.cssTransitions === false) {

	            _.$slides.eq(slideIndex).animate({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            }, _.options.speed, _.options.easing);
	        } else {

	            _.applyTransition(slideIndex);

	            _.$slides.eq(slideIndex).css({
	                opacity: 0,
	                zIndex: _.options.zIndex - 2
	            });
	        }
	    };

	    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function (filter) {

	        var _ = this;

	        if (filter !== null) {

	            _.$slidesCache = _.$slides;

	            _.unload();

	            _.$slideTrack.children(this.options.slide).detach();

	            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);

	            _.reinit();
	        }
	    };

	    Slick.prototype.focusHandler = function () {

	        var _ = this;

	        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function (event) {

	            event.stopImmediatePropagation();
	            var $sf = $(this);

	            setTimeout(function () {

	                if (_.options.pauseOnFocus) {
	                    _.focussed = $sf.is(':focus');
	                    _.autoPlay();
	                }
	            }, 0);
	        });
	    };

	    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function () {

	        var _ = this;
	        return _.currentSlide;
	    };

	    Slick.prototype.getDotCount = function () {

	        var _ = this;

	        var breakPoint = 0;
	        var counter = 0;
	        var pagerQty = 0;

	        if (_.options.infinite === true) {
	            if (_.slideCount <= _.options.slidesToShow) {
	                ++pagerQty;
	            } else {
	                while (breakPoint < _.slideCount) {
	                    ++pagerQty;
	                    breakPoint = counter + _.options.slidesToScroll;
	                    counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	                }
	            }
	        } else if (_.options.centerMode === true) {
	            pagerQty = _.slideCount;
	        } else if (!_.options.asNavFor) {
	            pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
	        } else {
	            while (breakPoint < _.slideCount) {
	                ++pagerQty;
	                breakPoint = counter + _.options.slidesToScroll;
	                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	            }
	        }

	        return pagerQty - 1;
	    };

	    Slick.prototype.getLeft = function (slideIndex) {

	        var _ = this,
	            targetLeft,
	            verticalHeight,
	            verticalOffset = 0,
	            targetSlide,
	            coef;

	        _.slideOffset = 0;
	        verticalHeight = _.$slides.first().outerHeight(true);

	        if (_.options.infinite === true) {
	            if (_.slideCount > _.options.slidesToShow) {
	                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
	                coef = -1;

	                if (_.options.vertical === true && _.options.centerMode === true) {
	                    if (_.options.slidesToShow === 2) {
	                        coef = -1.5;
	                    } else if (_.options.slidesToShow === 1) {
	                        coef = -2;
	                    }
	                }
	                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
	            }
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
	                    if (slideIndex > _.slideCount) {
	                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
	                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
	                    } else {
	                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
	                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
	                    }
	                }
	            }
	        } else {
	            if (slideIndex + _.options.slidesToShow > _.slideCount) {
	                _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
	                verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
	            }
	        }

	        if (_.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = 0;
	            verticalOffset = 0;
	        }

	        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) {
	            _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
	        } else if (_.options.centerMode === true && _.options.infinite === true) {
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
	        } else if (_.options.centerMode === true) {
	            _.slideOffset = 0;
	            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
	        }

	        if (_.options.vertical === false) {
	            targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
	        } else {
	            targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
	        }

	        if (_.options.variableWidth === true) {

	            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	            } else {
	                targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
	            }

	            if (_.options.rtl === true) {
	                if (targetSlide[0]) {
	                    targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                } else {
	                    targetLeft = 0;
	                }
	            } else {
	                targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	            }

	            if (_.options.centerMode === true) {
	                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
	                } else {
	                    targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
	                }

	                if (_.options.rtl === true) {
	                    if (targetSlide[0]) {
	                        targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
	                    } else {
	                        targetLeft = 0;
	                    }
	                } else {
	                    targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
	                }

	                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
	            }
	        }

	        return targetLeft;
	    };

	    Slick.prototype.getOption = Slick.prototype.slickGetOption = function (option) {

	        var _ = this;

	        return _.options[option];
	    };

	    Slick.prototype.getNavigableIndexes = function () {

	        var _ = this,
	            breakPoint = 0,
	            counter = 0,
	            indexes = [],
	            max;

	        if (_.options.infinite === false) {
	            max = _.slideCount;
	        } else {
	            breakPoint = _.options.slidesToScroll * -1;
	            counter = _.options.slidesToScroll * -1;
	            max = _.slideCount * 2;
	        }

	        while (breakPoint < max) {
	            indexes.push(breakPoint);
	            breakPoint = counter + _.options.slidesToScroll;
	            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
	        }

	        return indexes;
	    };

	    Slick.prototype.getSlick = function () {

	        return this;
	    };

	    Slick.prototype.getSlideCount = function () {

	        var _ = this,
	            slidesTraversed,
	            swipedSlide,
	            centerOffset;

	        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;

	        if (_.options.swipeToSlide === true) {
	            _.$slideTrack.find('.slick-slide').each(function (index, slide) {
	                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
	                    swipedSlide = slide;
	                    return false;
	                }
	            });

	            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;

	            return slidesTraversed;
	        } else {
	            return _.options.slidesToScroll;
	        }
	    };

	    Slick.prototype.goTo = Slick.prototype.slickGoTo = function (slide, dontAnimate) {

	        var _ = this;

	        _.changeSlide({
	            data: {
	                message: 'index',
	                index: parseInt(slide)
	            }
	        }, dontAnimate);
	    };

	    Slick.prototype.init = function (creation) {

	        var _ = this;

	        if (!$(_.$slider).hasClass('slick-initialized')) {

	            $(_.$slider).addClass('slick-initialized');

	            _.buildRows();
	            _.buildOut();
	            _.setProps();
	            _.startLoad();
	            _.loadSlider();
	            _.initializeEvents();
	            _.updateArrows();
	            _.updateDots();
	            _.checkResponsive(true);
	            _.focusHandler();
	        }

	        if (creation) {
	            _.$slider.trigger('init', [_]);
	        }

	        if (_.options.accessibility === true) {
	            _.initADA();
	        }

	        if (_.options.autoplay) {

	            _.paused = false;
	            _.autoPlay();
	        }
	    };

	    Slick.prototype.initADA = function () {
	        var _ = this,
	            numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow),
	            tabControlIndexes = _.getNavigableIndexes().filter(function (val) {
	            return val >= 0 && val < _.slideCount;
	        });

	        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
	            'aria-hidden': 'true',
	            'tabindex': '-1'
	        }).find('a, input, button, select').attr({
	            'tabindex': '-1'
	        });

	        if (_.$dots !== null) {
	            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function (i) {
	                var slideControlIndex = tabControlIndexes.indexOf(i);

	                $(this).attr({
	                    'role': 'tabpanel',
	                    'id': 'slick-slide' + _.instanceUid + i,
	                    'tabindex': -1
	                });

	                if (slideControlIndex !== -1) {
	                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
	                    if ($('#' + ariaButtonControl).length) {
	                        $(this).attr({
	                            'aria-describedby': ariaButtonControl
	                        });
	                    }
	                }
	            });

	            _.$dots.attr('role', 'tablist').find('li').each(function (i) {
	                var mappedSlideIndex = tabControlIndexes[i];

	                $(this).attr({
	                    'role': 'presentation'
	                });

	                $(this).find('button').first().attr({
	                    'role': 'tab',
	                    'id': 'slick-slide-control' + _.instanceUid + i,
	                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
	                    'aria-label': i + 1 + ' of ' + numDotGroups,
	                    'aria-selected': null,
	                    'tabindex': '-1'
	                });
	            }).eq(_.currentSlide).find('button').attr({
	                'aria-selected': 'true',
	                'tabindex': '0'
	            }).end();
	        }

	        for (var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++) {
	            if (_.options.focusOnChange) {
	                _.$slides.eq(i).attr({ 'tabindex': '0' });
	            } else {
	                _.$slides.eq(i).removeAttr('tabindex');
	            }
	        }

	        _.activateADA();
	    };

	    Slick.prototype.initArrowEvents = function () {

	        var _ = this;

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
	            _.$prevArrow.off('click.slick').on('click.slick', {
	                message: 'previous'
	            }, _.changeSlide);
	            _.$nextArrow.off('click.slick').on('click.slick', {
	                message: 'next'
	            }, _.changeSlide);

	            if (_.options.accessibility === true) {
	                _.$prevArrow.on('keydown.slick', _.keyHandler);
	                _.$nextArrow.on('keydown.slick', _.keyHandler);
	            }
	        }
	    };

	    Slick.prototype.initDotEvents = function () {

	        var _ = this;

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
	            $('li', _.$dots).on('click.slick', {
	                message: 'index'
	            }, _.changeSlide);

	            if (_.options.accessibility === true) {
	                _.$dots.on('keydown.slick', _.keyHandler);
	            }
	        }

	        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) {

	            $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	        }
	    };

	    Slick.prototype.initSlideEvents = function () {

	        var _ = this;

	        if (_.options.pauseOnHover) {

	            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
	            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
	        }
	    };

	    Slick.prototype.initializeEvents = function () {

	        var _ = this;

	        _.initArrowEvents();

	        _.initDotEvents();
	        _.initSlideEvents();

	        _.$list.on('touchstart.slick mousedown.slick', {
	            action: 'start'
	        }, _.swipeHandler);
	        _.$list.on('touchmove.slick mousemove.slick', {
	            action: 'move'
	        }, _.swipeHandler);
	        _.$list.on('touchend.slick mouseup.slick', {
	            action: 'end'
	        }, _.swipeHandler);
	        _.$list.on('touchcancel.slick mouseleave.slick', {
	            action: 'end'
	        }, _.swipeHandler);

	        _.$list.on('click.slick', _.clickHandler);

	        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));

	        if (_.options.accessibility === true) {
	            _.$list.on('keydown.slick', _.keyHandler);
	        }

	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }

	        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));

	        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));

	        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);

	        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
	        $(_.setPosition);
	    };

	    Slick.prototype.initUI = function () {

	        var _ = this;

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

	            _.$prevArrow.show();
	            _.$nextArrow.show();
	        }

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

	            _.$dots.show();
	        }
	    };

	    Slick.prototype.keyHandler = function (event) {

	        var _ = this;
	        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
	        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
	            if (event.keyCode === 37 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'next' : 'previous'
	                    }
	                });
	            } else if (event.keyCode === 39 && _.options.accessibility === true) {
	                _.changeSlide({
	                    data: {
	                        message: _.options.rtl === true ? 'previous' : 'next'
	                    }
	                });
	            }
	        }
	    };

	    Slick.prototype.lazyLoad = function () {

	        var _ = this,
	            loadRange,
	            cloneRange,
	            rangeStart,
	            rangeEnd;

	        function loadImages(imagesScope) {

	            $('img[data-lazy]', imagesScope).each(function () {

	                var image = $(this),
	                    imageSource = $(this).attr('data-lazy'),
	                    imageSrcSet = $(this).attr('data-srcset'),
	                    imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'),
	                    imageToLoad = document.createElement('img');

	                imageToLoad.onload = function () {

	                    image.animate({ opacity: 0 }, 100, function () {

	                        if (imageSrcSet) {
	                            image.attr('srcset', imageSrcSet);

	                            if (imageSizes) {
	                                image.attr('sizes', imageSizes);
	                            }
	                        }

	                        image.attr('src', imageSource).animate({ opacity: 1 }, 200, function () {
	                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
	                        });
	                        _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                    });
	                };

	                imageToLoad.onerror = function () {

	                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

	                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);
	                };

	                imageToLoad.src = imageSource;
	            });
	        }

	        if (_.options.centerMode === true) {
	            if (_.options.infinite === true) {
	                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
	                rangeEnd = rangeStart + _.options.slidesToShow + 2;
	            } else {
	                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
	                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
	            }
	        } else {
	            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
	            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
	            if (_.options.fade === true) {
	                if (rangeStart > 0) rangeStart--;
	                if (rangeEnd <= _.slideCount) rangeEnd++;
	            }
	        }

	        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);

	        if (_.options.lazyLoad === 'anticipated') {
	            var prevSlide = rangeStart - 1,
	                nextSlide = rangeEnd,
	                $slides = _.$slider.find('.slick-slide');

	            for (var i = 0; i < _.options.slidesToScroll; i++) {
	                if (prevSlide < 0) prevSlide = _.slideCount - 1;
	                loadRange = loadRange.add($slides.eq(prevSlide));
	                loadRange = loadRange.add($slides.eq(nextSlide));
	                prevSlide--;
	                nextSlide++;
	            }
	        }

	        loadImages(loadRange);

	        if (_.slideCount <= _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-slide');
	            loadImages(cloneRange);
	        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
	            loadImages(cloneRange);
	        } else if (_.currentSlide === 0) {
	            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
	            loadImages(cloneRange);
	        }
	    };

	    Slick.prototype.loadSlider = function () {

	        var _ = this;

	        _.setPosition();

	        _.$slideTrack.css({
	            opacity: 1
	        });

	        _.$slider.removeClass('slick-loading');

	        _.initUI();

	        if (_.options.lazyLoad === 'progressive') {
	            _.progressiveLazyLoad();
	        }
	    };

	    Slick.prototype.next = Slick.prototype.slickNext = function () {

	        var _ = this;

	        _.changeSlide({
	            data: {
	                message: 'next'
	            }
	        });
	    };

	    Slick.prototype.orientationChange = function () {

	        var _ = this;

	        _.checkResponsive();
	        _.setPosition();
	    };

	    Slick.prototype.pause = Slick.prototype.slickPause = function () {

	        var _ = this;

	        _.autoPlayClear();
	        _.paused = true;
	    };

	    Slick.prototype.play = Slick.prototype.slickPlay = function () {

	        var _ = this;

	        _.autoPlay();
	        _.options.autoplay = true;
	        _.paused = false;
	        _.focussed = false;
	        _.interrupted = false;
	    };

	    Slick.prototype.postSlide = function (index) {

	        var _ = this;

	        if (!_.unslicked) {

	            _.$slider.trigger('afterChange', [_, index]);

	            _.animating = false;

	            if (_.slideCount > _.options.slidesToShow) {
	                _.setPosition();
	            }

	            _.swipeLeft = null;

	            if (_.options.autoplay) {
	                _.autoPlay();
	            }

	            if (_.options.accessibility === true) {
	                _.initADA();

	                if (_.options.focusOnChange) {
	                    var $currentSlide = $(_.$slides.get(_.currentSlide));
	                    $currentSlide.attr('tabindex', 0).focus();
	                }
	            }
	        }
	    };

	    Slick.prototype.prev = Slick.prototype.slickPrev = function () {

	        var _ = this;

	        _.changeSlide({
	            data: {
	                message: 'previous'
	            }
	        });
	    };

	    Slick.prototype.preventDefault = function (event) {

	        event.preventDefault();
	    };

	    Slick.prototype.progressiveLazyLoad = function (tryCount) {

	        tryCount = tryCount || 1;

	        var _ = this,
	            $imgsToLoad = $('img[data-lazy]', _.$slider),
	            image,
	            imageSource,
	            imageSrcSet,
	            imageSizes,
	            imageToLoad;

	        if ($imgsToLoad.length) {

	            image = $imgsToLoad.first();
	            imageSource = image.attr('data-lazy');
	            imageSrcSet = image.attr('data-srcset');
	            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
	            imageToLoad = document.createElement('img');

	            imageToLoad.onload = function () {

	                if (imageSrcSet) {
	                    image.attr('srcset', imageSrcSet);

	                    if (imageSizes) {
	                        image.attr('sizes', imageSizes);
	                    }
	                }

	                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');

	                if (_.options.adaptiveHeight === true) {
	                    _.setPosition();
	                }

	                _.$slider.trigger('lazyLoaded', [_, image, imageSource]);
	                _.progressiveLazyLoad();
	            };

	            imageToLoad.onerror = function () {

	                if (tryCount < 3) {

	                    /**
	                     * try to load the image 3 times,
	                     * leave a slight delay so we don't get
	                     * servers blocking the request.
	                     */
	                    setTimeout(function () {
	                        _.progressiveLazyLoad(tryCount + 1);
	                    }, 500);
	                } else {

	                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');

	                    _.$slider.trigger('lazyLoadError', [_, image, imageSource]);

	                    _.progressiveLazyLoad();
	                }
	            };

	            imageToLoad.src = imageSource;
	        } else {

	            _.$slider.trigger('allImagesLoaded', [_]);
	        }
	    };

	    Slick.prototype.refresh = function (initializing) {

	        var _ = this,
	            currentSlide,
	            lastVisibleIndex;

	        lastVisibleIndex = _.slideCount - _.options.slidesToShow;

	        // in non-infinite sliders, we don't want to go past the
	        // last visible index.
	        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) {
	            _.currentSlide = lastVisibleIndex;
	        }

	        // if less slides than to show, go to start.
	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }

	        currentSlide = _.currentSlide;

	        _.destroy(true);

	        $.extend(_, _.initials, { currentSlide: currentSlide });

	        _.init();

	        if (!initializing) {

	            _.changeSlide({
	                data: {
	                    message: 'index',
	                    index: currentSlide
	                }
	            }, false);
	        }
	    };

	    Slick.prototype.registerBreakpoints = function () {

	        var _ = this,
	            breakpoint,
	            currentBreakpoint,
	            l,
	            responsiveSettings = _.options.responsive || null;

	        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {

	            _.respondTo = _.options.respondTo || 'window';

	            for (breakpoint in responsiveSettings) {

	                l = _.breakpoints.length - 1;

	                if (responsiveSettings.hasOwnProperty(breakpoint)) {
	                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;

	                    // loop through the breakpoints and cut out any existing
	                    // ones with the same breakpoint number, we don't want dupes.
	                    while (l >= 0) {
	                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) {
	                            _.breakpoints.splice(l, 1);
	                        }
	                        l--;
	                    }

	                    _.breakpoints.push(currentBreakpoint);
	                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
	                }
	            }

	            _.breakpoints.sort(function (a, b) {
	                return _.options.mobileFirst ? a - b : b - a;
	            });
	        }
	    };

	    Slick.prototype.reinit = function () {

	        var _ = this;

	        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');

	        _.slideCount = _.$slides.length;

	        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) {
	            _.currentSlide = _.currentSlide - _.options.slidesToScroll;
	        }

	        if (_.slideCount <= _.options.slidesToShow) {
	            _.currentSlide = 0;
	        }

	        _.registerBreakpoints();

	        _.setProps();
	        _.setupInfinite();
	        _.buildArrows();
	        _.updateArrows();
	        _.initArrowEvents();
	        _.buildDots();
	        _.updateDots();
	        _.initDotEvents();
	        _.cleanUpSlideEvents();
	        _.initSlideEvents();

	        _.checkResponsive(false, true);

	        if (_.options.focusOnSelect === true) {
	            $(_.$slideTrack).children().on('click.slick', _.selectHandler);
	        }

	        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);

	        _.setPosition();
	        _.focusHandler();

	        _.paused = !_.options.autoplay;
	        _.autoPlay();

	        _.$slider.trigger('reInit', [_]);
	    };

	    Slick.prototype.resize = function () {

	        var _ = this;

	        if ($(window).width() !== _.windowWidth) {
	            clearTimeout(_.windowDelay);
	            _.windowDelay = window.setTimeout(function () {
	                _.windowWidth = $(window).width();
	                _.checkResponsive();
	                if (!_.unslicked) {
	                    _.setPosition();
	                }
	            }, 50);
	        }
	    };

	    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function (index, removeBefore, removeAll) {

	        var _ = this;

	        if (typeof index === 'boolean') {
	            removeBefore = index;
	            index = removeBefore === true ? 0 : _.slideCount - 1;
	        } else {
	            index = removeBefore === true ? --index : index;
	        }

	        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) {
	            return false;
	        }

	        _.unload();

	        if (removeAll === true) {
	            _.$slideTrack.children().remove();
	        } else {
	            _.$slideTrack.children(this.options.slide).eq(index).remove();
	        }

	        _.$slides = _.$slideTrack.children(this.options.slide);

	        _.$slideTrack.children(this.options.slide).detach();

	        _.$slideTrack.append(_.$slides);

	        _.$slidesCache = _.$slides;

	        _.reinit();
	    };

	    Slick.prototype.setCSS = function (position) {

	        var _ = this,
	            positionProps = {},
	            x,
	            y;

	        if (_.options.rtl === true) {
	            position = -position;
	        }
	        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
	        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';

	        positionProps[_.positionProp] = position;

	        if (_.transformsEnabled === false) {
	            _.$slideTrack.css(positionProps);
	        } else {
	            positionProps = {};
	            if (_.cssTransitions === false) {
	                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
	                _.$slideTrack.css(positionProps);
	            } else {
	                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
	                _.$slideTrack.css(positionProps);
	            }
	        }
	    };

	    Slick.prototype.setDimensions = function () {

	        var _ = this;

	        if (_.options.vertical === false) {
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: '0px ' + _.options.centerPadding
	                });
	            }
	        } else {
	            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
	            if (_.options.centerMode === true) {
	                _.$list.css({
	                    padding: _.options.centerPadding + ' 0px'
	                });
	            }
	        }

	        _.listWidth = _.$list.width();
	        _.listHeight = _.$list.height();

	        if (_.options.vertical === false && _.options.variableWidth === false) {
	            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
	            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
	        } else if (_.options.variableWidth === true) {
	            _.$slideTrack.width(5000 * _.slideCount);
	        } else {
	            _.slideWidth = Math.ceil(_.listWidth);
	            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
	        }

	        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
	        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
	    };

	    Slick.prototype.setFade = function () {

	        var _ = this,
	            targetLeft;

	        _.$slides.each(function (index, element) {
	            targetLeft = _.slideWidth * index * -1;
	            if (_.options.rtl === true) {
	                $(element).css({
	                    position: 'relative',
	                    right: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            } else {
	                $(element).css({
	                    position: 'relative',
	                    left: targetLeft,
	                    top: 0,
	                    zIndex: _.options.zIndex - 2,
	                    opacity: 0
	                });
	            }
	        });

	        _.$slides.eq(_.currentSlide).css({
	            zIndex: _.options.zIndex - 1,
	            opacity: 1
	        });
	    };

	    Slick.prototype.setHeight = function () {

	        var _ = this;

	        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
	            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
	            _.$list.css('height', targetHeight);
	        }
	    };

	    Slick.prototype.setOption = Slick.prototype.slickSetOption = function () {

	        /**
	         * accepts arguments in format of:
	         *
	         *  - for changing a single option's value:
	         *     .slick("setOption", option, value, refresh )
	         *
	         *  - for changing a set of responsive options:
	         *     .slick("setOption", 'responsive', [{}, ...], refresh )
	         *
	         *  - for updating multiple values at once (not responsive)
	         *     .slick("setOption", { 'option': value, ... }, refresh )
	         */

	        var _ = this,
	            l,
	            item,
	            option,
	            value,
	            refresh = false,
	            type;

	        if ($.type(arguments[0]) === 'object') {

	            option = arguments[0];
	            refresh = arguments[1];
	            type = 'multiple';
	        } else if ($.type(arguments[0]) === 'string') {

	            option = arguments[0];
	            value = arguments[1];
	            refresh = arguments[2];

	            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') {

	                type = 'responsive';
	            } else if (typeof arguments[1] !== 'undefined') {

	                type = 'single';
	            }
	        }

	        if (type === 'single') {

	            _.options[option] = value;
	        } else if (type === 'multiple') {

	            $.each(option, function (opt, val) {

	                _.options[opt] = val;
	            });
	        } else if (type === 'responsive') {

	            for (item in value) {

	                if ($.type(_.options.responsive) !== 'array') {

	                    _.options.responsive = [value[item]];
	                } else {

	                    l = _.options.responsive.length - 1;

	                    // loop through the responsive object and splice out duplicates.
	                    while (l >= 0) {

	                        if (_.options.responsive[l].breakpoint === value[item].breakpoint) {

	                            _.options.responsive.splice(l, 1);
	                        }

	                        l--;
	                    }

	                    _.options.responsive.push(value[item]);
	                }
	            }
	        }

	        if (refresh) {

	            _.unload();
	            _.reinit();
	        }
	    };

	    Slick.prototype.setPosition = function () {

	        var _ = this;

	        _.setDimensions();

	        _.setHeight();

	        if (_.options.fade === false) {
	            _.setCSS(_.getLeft(_.currentSlide));
	        } else {
	            _.setFade();
	        }

	        _.$slider.trigger('setPosition', [_]);
	    };

	    Slick.prototype.setProps = function () {

	        var _ = this,
	            bodyStyle = document.body.style;

	        _.positionProp = _.options.vertical === true ? 'top' : 'left';

	        if (_.positionProp === 'top') {
	            _.$slider.addClass('slick-vertical');
	        } else {
	            _.$slider.removeClass('slick-vertical');
	        }

	        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
	            if (_.options.useCSS === true) {
	                _.cssTransitions = true;
	            }
	        }

	        if (_.options.fade) {
	            if (typeof _.options.zIndex === 'number') {
	                if (_.options.zIndex < 3) {
	                    _.options.zIndex = 3;
	                }
	            } else {
	                _.options.zIndex = _.defaults.zIndex;
	            }
	        }

	        if (bodyStyle.OTransform !== undefined) {
	            _.animType = 'OTransform';
	            _.transformType = '-o-transform';
	            _.transitionType = 'OTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.MozTransform !== undefined) {
	            _.animType = 'MozTransform';
	            _.transformType = '-moz-transform';
	            _.transitionType = 'MozTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.webkitTransform !== undefined) {
	            _.animType = 'webkitTransform';
	            _.transformType = '-webkit-transform';
	            _.transitionType = 'webkitTransition';
	            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
	        }
	        if (bodyStyle.msTransform !== undefined) {
	            _.animType = 'msTransform';
	            _.transformType = '-ms-transform';
	            _.transitionType = 'msTransition';
	            if (bodyStyle.msTransform === undefined) _.animType = false;
	        }
	        if (bodyStyle.transform !== undefined && _.animType !== false) {
	            _.animType = 'transform';
	            _.transformType = 'transform';
	            _.transitionType = 'transition';
	        }
	        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
	    };

	    Slick.prototype.setSlideClasses = function (index) {

	        var _ = this,
	            centerOffset,
	            allSlides,
	            indexOffset,
	            remainder;

	        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');

	        _.$slides.eq(index).addClass('slick-current');

	        if (_.options.centerMode === true) {

	            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;

	            centerOffset = Math.floor(_.options.slidesToShow / 2);

	            if (_.options.infinite === true) {

	                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) {
	                    _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
	                } else {

	                    indexOffset = _.options.slidesToShow + index;
	                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
	                }

	                if (index === 0) {

	                    allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
	                } else if (index === _.slideCount - 1) {

	                    allSlides.eq(_.options.slidesToShow).addClass('slick-center');
	                }
	            }

	            _.$slides.eq(index).addClass('slick-center');
	        } else {

	            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) {

	                _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
	            } else if (allSlides.length <= _.options.slidesToShow) {

	                allSlides.addClass('slick-active').attr('aria-hidden', 'false');
	            } else {

	                remainder = _.slideCount % _.options.slidesToShow;
	                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;

	                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) {

	                    allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
	                } else {

	                    allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
	                }
	            }
	        }

	        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') {
	            _.lazyLoad();
	        }
	    };

	    Slick.prototype.setupInfinite = function () {

	        var _ = this,
	            i,
	            slideIndex,
	            infiniteCount;

	        if (_.options.fade === true) {
	            _.options.centerMode = false;
	        }

	        if (_.options.infinite === true && _.options.fade === false) {

	            slideIndex = null;

	            if (_.slideCount > _.options.slidesToShow) {

	                if (_.options.centerMode === true) {
	                    infiniteCount = _.options.slidesToShow + 1;
	                } else {
	                    infiniteCount = _.options.slidesToShow;
	                }

	                for (i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1) {
	                    slideIndex = i - 1;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                for (i = 0; i < infiniteCount + _.slideCount; i += 1) {
	                    slideIndex = i;
	                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
	                }
	                _.$slideTrack.find('.slick-cloned').find('[id]').each(function () {
	                    $(this).attr('id', '');
	                });
	            }
	        }
	    };

	    Slick.prototype.interrupt = function (toggle) {

	        var _ = this;

	        if (!toggle) {
	            _.autoPlay();
	        }
	        _.interrupted = toggle;
	    };

	    Slick.prototype.selectHandler = function (event) {

	        var _ = this;

	        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');

	        var index = parseInt(targetElement.attr('data-slick-index'));

	        if (!index) index = 0;

	        if (_.slideCount <= _.options.slidesToShow) {

	            _.slideHandler(index, false, true);
	            return;
	        }

	        _.slideHandler(index);
	    };

	    Slick.prototype.slideHandler = function (index, sync, dontAnimate) {

	        var targetSlide,
	            animSlide,
	            oldSlide,
	            slideLeft,
	            targetLeft = null,
	            _ = this,
	            navTarget;

	        sync = sync || false;

	        if (_.animating === true && _.options.waitForAnimate === true) {
	            return;
	        }

	        if (_.options.fade === true && _.currentSlide === index) {
	            return;
	        }

	        if (sync === false) {
	            _.asNavFor(index);
	        }

	        targetSlide = index;
	        targetLeft = _.getLeft(targetSlide);
	        slideLeft = _.getLeft(_.currentSlide);

	        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;

	        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function () {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
	            if (_.options.fade === false) {
	                targetSlide = _.currentSlide;
	                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	                    _.animateSlide(slideLeft, function () {
	                        _.postSlide(targetSlide);
	                    });
	                } else {
	                    _.postSlide(targetSlide);
	                }
	            }
	            return;
	        }

	        if (_.options.autoplay) {
	            clearInterval(_.autoPlayTimer);
	        }

	        if (targetSlide < 0) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
	            } else {
	                animSlide = _.slideCount + targetSlide;
	            }
	        } else if (targetSlide >= _.slideCount) {
	            if (_.slideCount % _.options.slidesToScroll !== 0) {
	                animSlide = 0;
	            } else {
	                animSlide = targetSlide - _.slideCount;
	            }
	        } else {
	            animSlide = targetSlide;
	        }

	        _.animating = true;

	        _.$slider.trigger('beforeChange', [_, _.currentSlide, animSlide]);

	        oldSlide = _.currentSlide;
	        _.currentSlide = animSlide;

	        _.setSlideClasses(_.currentSlide);

	        if (_.options.asNavFor) {

	            navTarget = _.getNavTarget();
	            navTarget = navTarget.slick('getSlick');

	            if (navTarget.slideCount <= navTarget.options.slidesToShow) {
	                navTarget.setSlideClasses(_.currentSlide);
	            }
	        }

	        _.updateDots();
	        _.updateArrows();

	        if (_.options.fade === true) {
	            if (dontAnimate !== true) {

	                _.fadeSlideOut(oldSlide);

	                _.fadeSlide(animSlide, function () {
	                    _.postSlide(animSlide);
	                });
	            } else {
	                _.postSlide(animSlide);
	            }
	            _.animateHeight();
	            return;
	        }

	        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) {
	            _.animateSlide(targetLeft, function () {
	                _.postSlide(animSlide);
	            });
	        } else {
	            _.postSlide(animSlide);
	        }
	    };

	    Slick.prototype.startLoad = function () {

	        var _ = this;

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {

	            _.$prevArrow.hide();
	            _.$nextArrow.hide();
	        }

	        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {

	            _.$dots.hide();
	        }

	        _.$slider.addClass('slick-loading');
	    };

	    Slick.prototype.swipeDirection = function () {

	        var xDist,
	            yDist,
	            r,
	            swipeAngle,
	            _ = this;

	        xDist = _.touchObject.startX - _.touchObject.curX;
	        yDist = _.touchObject.startY - _.touchObject.curY;
	        r = Math.atan2(yDist, xDist);

	        swipeAngle = Math.round(r * 180 / Math.PI);
	        if (swipeAngle < 0) {
	            swipeAngle = 360 - Math.abs(swipeAngle);
	        }

	        if (swipeAngle <= 45 && swipeAngle >= 0) {
	            return _.options.rtl === false ? 'left' : 'right';
	        }
	        if (swipeAngle <= 360 && swipeAngle >= 315) {
	            return _.options.rtl === false ? 'left' : 'right';
	        }
	        if (swipeAngle >= 135 && swipeAngle <= 225) {
	            return _.options.rtl === false ? 'right' : 'left';
	        }
	        if (_.options.verticalSwiping === true) {
	            if (swipeAngle >= 35 && swipeAngle <= 135) {
	                return 'down';
	            } else {
	                return 'up';
	            }
	        }

	        return 'vertical';
	    };

	    Slick.prototype.swipeEnd = function (event) {

	        var _ = this,
	            slideCount,
	            direction;

	        _.dragging = false;
	        _.swiping = false;

	        if (_.scrolling) {
	            _.scrolling = false;
	            return false;
	        }

	        _.interrupted = false;
	        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;

	        if (_.touchObject.curX === undefined) {
	            return false;
	        }

	        if (_.touchObject.edgeHit === true) {
	            _.$slider.trigger('edge', [_, _.swipeDirection()]);
	        }

	        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {

	            direction = _.swipeDirection();

	            switch (direction) {

	                case 'left':
	                case 'down':

	                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();

	                    _.currentDirection = 0;

	                    break;

	                case 'right':
	                case 'up':

	                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();

	                    _.currentDirection = 1;

	                    break;

	                default:

	            }

	            if (direction != 'vertical') {

	                _.slideHandler(slideCount);
	                _.touchObject = {};
	                _.$slider.trigger('swipe', [_, direction]);
	            }
	        } else {

	            if (_.touchObject.startX !== _.touchObject.curX) {

	                _.slideHandler(_.currentSlide);
	                _.touchObject = {};
	            }
	        }
	    };

	    Slick.prototype.swipeHandler = function (event) {

	        var _ = this;

	        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) {
	            return;
	        } else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) {
	            return;
	        }

	        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;

	        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;

	        if (_.options.verticalSwiping === true) {
	            _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
	        }

	        switch (event.data.action) {

	            case 'start':
	                _.swipeStart(event);
	                break;

	            case 'move':
	                _.swipeMove(event);
	                break;

	            case 'end':
	                _.swipeEnd(event);
	                break;

	        }
	    };

	    Slick.prototype.swipeMove = function (event) {

	        var _ = this,
	            edgeWasHit = false,
	            curLeft,
	            swipeDirection,
	            swipeLength,
	            positionOffset,
	            touches,
	            verticalSwipeLength;

	        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;

	        if (!_.dragging || _.scrolling || touches && touches.length !== 1) {
	            return false;
	        }

	        curLeft = _.getLeft(_.currentSlide);

	        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
	        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;

	        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));

	        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));

	        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
	            _.scrolling = true;
	            return false;
	        }

	        if (_.options.verticalSwiping === true) {
	            _.touchObject.swipeLength = verticalSwipeLength;
	        }

	        swipeDirection = _.swipeDirection();

	        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
	            _.swiping = true;
	            event.preventDefault();
	        }

	        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
	        if (_.options.verticalSwiping === true) {
	            positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
	        }

	        swipeLength = _.touchObject.swipeLength;

	        _.touchObject.edgeHit = false;

	        if (_.options.infinite === false) {
	            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
	                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
	                _.touchObject.edgeHit = true;
	            }
	        }

	        if (_.options.vertical === false) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        } else {
	            _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
	        }
	        if (_.options.verticalSwiping === true) {
	            _.swipeLeft = curLeft + swipeLength * positionOffset;
	        }

	        if (_.options.fade === true || _.options.touchMove === false) {
	            return false;
	        }

	        if (_.animating === true) {
	            _.swipeLeft = null;
	            return false;
	        }

	        _.setCSS(_.swipeLeft);
	    };

	    Slick.prototype.swipeStart = function (event) {

	        var _ = this,
	            touches;

	        _.interrupted = true;

	        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
	            _.touchObject = {};
	            return false;
	        }

	        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) {
	            touches = event.originalEvent.touches[0];
	        }

	        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
	        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;

	        _.dragging = true;
	    };

	    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function () {

	        var _ = this;

	        if (_.$slidesCache !== null) {

	            _.unload();

	            _.$slideTrack.children(this.options.slide).detach();

	            _.$slidesCache.appendTo(_.$slideTrack);

	            _.reinit();
	        }
	    };

	    Slick.prototype.unload = function () {

	        var _ = this;

	        $('.slick-cloned', _.$slider).remove();

	        if (_.$dots) {
	            _.$dots.remove();
	        }

	        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) {
	            _.$prevArrow.remove();
	        }

	        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) {
	            _.$nextArrow.remove();
	        }

	        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
	    };

	    Slick.prototype.unslick = function (fromBreakpoint) {

	        var _ = this;
	        _.$slider.trigger('unslick', [_, fromBreakpoint]);
	        _.destroy();
	    };

	    Slick.prototype.updateArrows = function () {

	        var _ = this,
	            centerOffset;

	        centerOffset = Math.floor(_.options.slidesToShow / 2);

	        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {

	            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');

	            if (_.currentSlide === 0) {

	                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {

	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {

	                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
	                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
	            }
	        }
	    };

	    Slick.prototype.updateDots = function () {

	        var _ = this;

	        if (_.$dots !== null) {

	            _.$dots.find('li').removeClass('slick-active').end();

	            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
	        }
	    };

	    Slick.prototype.visibility = function () {

	        var _ = this;

	        if (_.options.autoplay) {

	            if (document[_.hidden]) {

	                _.interrupted = true;
	            } else {

	                _.interrupted = false;
	            }
	        }
	    };

	    $.fn.slick = function () {
	        var _ = this,
	            opt = arguments[0],
	            args = Array.prototype.slice.call(arguments, 1),
	            l = _.length,
	            i,
	            ret;
	        for (i = 0; i < l; i++) {
	            if ((typeof opt === 'undefined' ? 'undefined' : _typeof(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);else ret = _[i].slick[opt].apply(_[i].slick, args);
	            if (typeof ret != 'undefined') return ret;
	        }
	        return _;
	    };
	});

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var _exportSearchFunction = __webpack_require__(138);

	/* Variabili globali */
	window.isMobile = false;
	var LAST_SCROLL_TOP = 0,
	    DELTA_SCROLL = 5;

	var cookieHelper = __webpack_require__(167);

	/* Funzioni Globali */
	var responsiveResize = function responsiveResize() {
	    if (window.matchMedia("(max-width: 767.98px)").matches) {
	        $('body').addClass('cc-mobile-smartphone').addClass('cc-mobile').removeClass('cc-desktop');
	        window.isMobile = true;
	        window.isTablet = false;
	        window.isDesktop = false;
	    } else if (window.matchMedia("(max-width: 1199.98px)").matches) {
	        $('body').addClass('cc-mobile').removeClass('cc-mobile-smartphone').removeClass('cc-desktop');
	        window.isMobile = false;
	        window.isTablet = true;
	        window.isDesktop = false;
	    } else {
	        $('body').addClass('cc-desktop').removeClass('cc-mobile-smartphone').removeClass('cc-mobile');
	        window.isMobile = false;
	        window.isTablet = false;
	        window.isDesktop = true;
	    }
	    $('.js-touched').removeAttr('style');
	    $('.js-touched').removeClass('js-touched');

	    homeVisualSlider(); // eslint-disable-line
	};

	/* Header promo Banner */
	var headerPromoSlider = function headerPromoSlider() {
	    if ($('.cc-header-promo .cc-slider').length > 0) {
	        var promoSlide = $(".cc-header-promo .cc-slider .cc-slide");
	        var firstPromoSlide = promoSlide.first();
	        var intervalId;
	        firstPromoSlide.addClass("activePromo");
	        if ($('.cc-header-promo .cc-slide').length > 1) {
	            var changeSlide = function changeSlide() {
	                var activePromoSlide = $(".activePromo");
	                activePromoSlide.removeClass("activePromo");
	                var nextPromoSlide = activePromoSlide.closest('.cc-header-promo .cc-slider .cc-slide').next();
	                if (nextPromoSlide.length === 0) {
	                    nextPromoSlide = firstPromoSlide;
	                }
	                nextPromoSlide.addClass("activePromo");
	            };
	            intervalId = setInterval(changeSlide, 4000);
	            promoSlide.on('mouseenter', function () {
	                clearInterval(intervalId);
	            });
	            promoSlide.on('mouseleave', function () {
	                intervalId = setInterval(changeSlide, 4000);
	            });
	        } else {
	            firstPromoSlide.css('animation', 'none');
	        }
	    }
	};

	headerPromoSlider(); // eslint-disable-line

	/**
	 * Toggle header promo dropdown
	 */
	var toggleHeaderPromoDropdown = function toggleHeaderPromoDropdown() {
	    $(".cc-header--banner").each(function () {
	        var $banner = $(this);

	        $banner.find(".js-header-promo-dropdown-open").on("click", function (event) {
	            if (!$(event.target).is("a")) {
	                $banner.addClass("dropdown-active");
	                $("html").addClass("cc-no-scroll");
	            }
	        });

	        $banner.find(".js-header-promo-dropdown").on("click", function (event) {
	            if (!$(event.target).closest(".cc-header-promo-dropdown__inner").length) {
	                $banner.removeClass("dropdown-active");
	                $("html").removeClass("cc-no-scroll");
	            }
	        });

	        $banner.find(".js-header-promo-dropdown-close").on("click", function () {
	            $banner.removeClass("dropdown-active");
	            $("html").removeClass("cc-no-scroll");
	        });
	    });
	};

	toggleHeaderPromoDropdown();

	/**
	 * Header animation logics
	 */
	var headerAnimation = function headerAnimation() {
	    var header = $('.cc-main-wrapper[data-action="Home-Show"] .js-header');
	    if (header.length > 0) {
	        if ($(window).scrollTop() === 0 && !$('.js-header').hasClass('cc-header--white')) {
	            header.addClass('cc-header--transparent');
	        }

	        window.addEventListener('scroll', function () {
	            if ($(window).scrollTop() === 0 && !$('.js-header').hasClass('cc-header--white')) {
	                header.addClass('cc-header--transparent');
	            } else {
	                header.removeClass('cc-header--transparent');
	            }
	        }, { passive: true });
	    }
	};

	headerAnimation();

	/* Main visual banner */
	var homeVisualSlider = function homeVisualSlider() {

	    var homeVisualSliderConfig = {
	        infinite: true,
	        autoplay: true,
	        focusOnSelect: true,
	        centerMode: true,
	        autoplaySpeed: 5000,
	        speed: 1000,
	        slidesToScroll: 1,
	        slidesToShow: 1,
	        variableWidth: true,
	        dots: true,
	        arrow: true,
	        prevArrow: '<button class="cc-slider-prev"><span class="cc-icon icon-arrow-left"></span></button>',
	        nextArrow: '<button class="cc-slider-next"><span class="cc-icon icon-arrow-right"></span></button>',
	        responsive: [{
	            breakpoint: 9999999,
	            settings: 'reinit'
	        }, {
	            breakpoint: 1440,
	            settings: {
	                variableWidth: false,
	                centerMode: false
	            }
	        }, {
	            breakpoint: 767,
	            settings: 'unslick'
	        }]
	    };

	    //Lighthouse Hero Banner slider specific features
	    var homeVisualSliderAdditionalConfig = [{
	        breakpoint: 1200,
	        settings: {
	            variableWidth: false,
	            centerMode: false,
	            prevArrow: '',
	            nextArrow: ''
	        }
	    }, {
	        breakpoint: 768,
	        settings: {
	            variableWidth: false,
	            centerMode: false,
	            prevArrow: '',
	            nextArrow: ''
	        }
	    }];

	    var autoplaySpeed = 7000;

	    //Redesigned Hero Banner slider
	    var heroBannerSliderConfig = {
	        infinite: true,
	        autoplay: true,
	        focusOnSelect: true,
	        centerMode: false,
	        autoplaySpeed: autoplaySpeed,
	        speed: 1000,
	        slidesToScroll: 1,
	        slidesToShow: 1,
	        variableWidth: false,
	        dots: true,
	        arrow: true,
	        pauseOnFocus: false,
	        pauseOnHover: false,
	        prevArrow: '<button class="cc-slider-prev"><span class="cc-icon icon-arrow-left"></span></button>',
	        nextArrow: '<button class="cc-slider-next"><span class="cc-icon icon-arrow-right"></span></button>',
	        responsive: [{
	            breakpoint: 9999999,
	            settings: 'reinit'
	        }]
	    };

	    //Redesigned Hero Banner slider - unslick for mobiles
	    var heroBannerSliderAdditionalConfig = [{
	        breakpoint: 767,
	        settings: 'unslick'
	    }];

	    var lastSlideTime = Date.now(); //Time when the last slide change occurred
	    var isTouching = false; //Flag to detect if touch interaction occurred
	    var autoplayTimer = void 0; //Timer for controlling autoplay

	    function startAutoplay() {
	        $('.cc-main-visual .cc-hero-slider.slider').slick('slickPlay');
	        resetTimer(); //Resets the autoplay timer after starting
	    }

	    function stopAutoplay() {
	        $('.cc-main-visual .cc-hero-slider.slider').slick('slickPause');
	        clearTimeout(autoplayTimer); //Stops any active timers
	    }

	    function resetTimer() {
	        lastSlideTime = Date.now(); //Resets the last slide time to the current time
	        clearTimeout(autoplayTimer); //Stops the previous timer
	        autoplayTimer = setTimeout(function () {
	            $('.cc-main-visual .cc-hero-slider.slider').slick('slickNext');
	            startAutoplay(); //Automatically moves to the next slide and restarts autoplay
	        }, autoplaySpeed); //Uses the defined autoplay speed
	    }

	    function handleTouchStart() {
	        if (!isTouching) {
	            isTouching = true;
	            stopAutoplay(); //Pauses the autoplay during touch interaction
	            var remainingTime = autoplaySpeed - (Date.now() - lastSlideTime); //Calculates remaining time for the current slide
	            autoplayTimer = setTimeout(function () {
	                $('.cc-main-visual .cc-hero-slider.slider').slick('slickNext');
	                startAutoplay(); //Proceeds to the next slide and resumes autoplay
	                isTouching = false; //Resets the touch flag after slide change
	            }, remainingTime);
	        }
	    }

	    if ($('.cc-main-visual').length > 0) {
	        if ($('.cc-main-visual .slick-initialized').length < 1) {
	            $('.cc-main-visual .cc-slider').each(function () {
	                $(this).slick(homeVisualSliderConfig);
	            });

	            //Lighthouse Hero Banner slider
	            $('.cc-main-visual .cc-slider-lh').each(function () {
	                homeVisualSliderConfig.dots = false;
	                homeVisualSliderConfig.responsive.push(homeVisualSliderAdditionalConfig[0]);
	                homeVisualSliderConfig.responsive.push(homeVisualSliderAdditionalConfig[1]);
	                $(this).slick(homeVisualSliderConfig);
	            });

	            //Redesigned Hero Banner slider
	            $('.cc-main-visual .cc-hero-slider.slider').each(function () {
	                $(this).slick(heroBannerSliderConfig);
	            });

	            //Redesigned Hero Banner slider - unslick for mobiles
	            $('.cc-main-visual .cc-hero-slider:not(.slider)').each(function () {
	                heroBannerSliderConfig.responsive.push(heroBannerSliderAdditionalConfig[0]);
	                $(this).slick(heroBannerSliderConfig);
	            });

	            //Resets the time and timer after each slide change
	            $('.cc-main-visual .cc-hero-slider.slider').on('afterChange', resetTimer);

	            //Adds a listener for the touch event
	            $('.cc-main-visual .cc-hero-slider.slider').on('touchstart', handleTouchStart);

	            startAutoplay();
	        }
	    }
	};

	/* Racommendation banner */
	var racommendationSlider = function racommendationSlider() {
	    if ($('.cc-racommendation-slider .cc-slider').length > 0) {

	        if ($('.cc-racommendation-slider .cc-slider .slick-slide').length === 0) {
	            $('.cc-racommendation-slider .cc-slider').each(function () {
	                var slidesContainer = $(this);

	                slidesContainer.slick({
	                    infinite: true,
	                    autoplay: false,
	                    focusOnSelect: false,
	                    centerMode: false,
	                    autoplaySpeed: 5000,
	                    speed: 1000,
	                    slidesToScroll: 1,
	                    slidesToShow: 4,
	                    variableWidth: false,
	                    dots: false,
	                    arrow: true,
	                    prevArrow: '<button class="cc-slider-prev"><span class="cc-icon icon-arrow-left"></span></button>',
	                    nextArrow: '<button class="cc-slider-next"><span class="cc-icon icon-arrow-right"></span></button>',
	                    responsive: [{
	                        breakpoint: 1199.98,
	                        settings: {
	                            slidesToShow: 3
	                        }
	                    }, {
	                        breakpoint: 767.98,
	                        settings: {
	                            slidesToShow: 2
	                        }
	                    }]
	                });
	            });
	        }
	    }
	};

	var recommendedSlider = function recommendedSlider() {
	    if ($('.cc-recommended-slider .cc-slider').length > 0) {

	        if ($('.cc-recommended-slider .cc-slider .slick-slide').length === 0) {
	            $('.cc-recommended-slider .cc-slider').each(function () {
	                var slidesContainer = $(this);

	                slidesContainer.slick({
	                    mobileFirst: true,
	                    infinite: false,
	                    autoplay: false,
	                    focusOnSelect: false,
	                    centerMode: false,
	                    autoplaySpeed: 5000,
	                    speed: 500,
	                    slidesToScroll: 1,
	                    slidesToShow: 2.4,
	                    variableWidth: false,
	                    dots: false,
	                    arrows: false,
	                    prevArrow: '<button class="cc-slider-prev"><span class="cc-icon icon-arrow-left"></span></button>',
	                    nextArrow: '<button class="cc-slider-next"><span class="cc-icon icon-arrow-right"></span></button>',
	                    responsive: [{
	                        breakpoint: 767.98,
	                        settings: {
	                            slidesToShow: 4.2,
	                            arrows: false
	                        }
	                    }, {
	                        breakpoint: 1023.98,
	                        settings: {
	                            slidesToShow: 5.2,
	                            arrows: false
	                        }
	                    }, {
	                        breakpoint: 1199.98,
	                        settings: {
	                            slidesToShow: 6.2,
	                            arrows: true
	                        }
	                    }]
	                });
	            });
	        }
	    }
	};

	$('body').on('einsteinCarouselRedesign:setup', function () {
	    var $carousel = $('.cc-recommended-slider .cc-slider');

	    if (!$carousel.hasClass('slick-initialized')) {
	        recommendedSlider();
	    }
	});

	/* Editorial Carousel */
	var editorialCarousel = function editorialCarousel() {
	    if ($('.cc-editorial-carousel').length > 0) {

	        if ($('.cc-editorial-carousel .slick-slide').length === 0) {
	            $('.cc-editorial-carousel .cc-slider').each(function () {
	                var slidesContainer = $(this);

	                slidesContainer.slick({
	                    infinite: false,
	                    autoplay: false,
	                    focusOnSelect: false,
	                    centerMode: false,
	                    slidesToScroll: 1,
	                    slidesToShow: 4.2,
	                    swipeToSlide: true,
	                    variableWidth: false,
	                    dots: true,
	                    arrows: true,
	                    prevArrow: '<button class="cc-slider-prev"><span class="cc-icon icon-arrow-left"></span></button>',
	                    nextArrow: '<button class="cc-slider-next"><span class="cc-icon icon-arrow-right"></span></button>',
	                    responsive: [{
	                        breakpoint: 1199.98,
	                        settings: {
	                            slidesToShow: 3.2
	                        }
	                    }, {
	                        breakpoint: 767.98,
	                        settings: "unslick"
	                    }]
	                });

	                var dots = $('.slick-dots');
	                var scrollbar = "slick-scrollbar";

	                // Create custom scrollbar for slick dots
	                slidesContainer.each(function () {
	                    var slides = dots.find('li').length - 1;
	                    var scrollId = "ssb-" + (Math.random() + 1).toString(36).substring(7);
	                    var scroll = '<div class="' + scrollbar + ' ' + scrollId + '"><input type="range" min="0" max="' + slides + '" step="0.01" value="0" /></div>';
	                    $(scroll).insertAfter(dots);
	                });

	                // Handle scrollbar input change to sync with slick slider
	                $('body').on('input change', "." + scrollbar + " input", function () {
	                    var current = Math.round($(this).val());
	                    slidesContainer.slick('slickGoTo', current);
	                });

	                // On mouseup, snap to the nearest dot
	                $('body').on('mouseup', "." + scrollbar + " input", function () {
	                    var input = $(this);
	                    var currentValue = parseFloat(input.val());
	                    var nearestDot = Math.round(currentValue);
	                    input.val(nearestDot);
	                    slidesContainer.slick('slickGoTo', nearestDot);
	                });

	                // On before slide change, sync the custom scrollbar with slick slider
	                slidesContainer.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	                    var scrollbarInput = $(this).closest('.cc-editorial-carousel').find("." + scrollbar + " input");
	                    if (!scrollbarInput.is(":focus")) {
	                        scrollbarInput.val(nextSlide);
	                    }
	                });
	            });
	        }
	    }
	};

	editorialCarousel();

	/* Render 404 error image placeholder */
	var imageNotFoundError = function imageNotFoundError() {
	    var placeholder = $("[data-no-image-found]").data("no-image-found");
	    $("#home-page img").on("error", function () {
	        $(this).off("error");
	        $(this).attr("src", placeholder);
	        $(this).parent().find("source").attr("srcset", placeholder);
	        var height = $(this).height();
	        $(this).css("height", height);
	        $(this).css("width", "unset");
	        $(this).css("margin", "auto");
	    });
	    $(".cc-container-dis-picture picture img").on("error", function () {
	        $(this).off("error");
	        $(this).attr("src", placeholder);
	        $(this).parent().find("source").attr("srcset", placeholder);
	        $(this).parents(".cc-container-dis-picture").find(".cc-dis-loader-img").addClass("d-none");
	    });
	    $(".cc-pdp-thumbnails-carousel-item img, .carousel-thumbnails-item img").on("error", function () {
	        $(this).off("error");
	        $(this).attr("src", placeholder);
	    });
	    $(".js-minicart-results").find(".cc-image").on("error", function () {
	        $(this).off("error");
	        $(this).attr("src", placeholder);
	    });
	};

	function triggerOutsideMenu(evt) {
	    if (window.isTablet && evt.target.className === 'cc-content-menu') {
	        // eslint-disable-next-line no-use-before-define
	        toggleMenuMobile(evt);
	    }
	}

	function toggleMenuMobile(e) {
	    var toggleButton = $('.cc-header .cc-header-main .js-toggleMenu');
	    var mainMenu = toggleButton.closest('.cc-header').find('.cc-main-menu');
	    mainMenu.toggleClass('cc-open');

	    if (mainMenu.hasClass('cc-open')) {
	        if ((0, _exportSearchFunction.isOpenSearchBarMobile)()) {
	            (0, _exportSearchFunction.toggleSearchBarMobile)();
	        }
	        $(document).on('click', '.cc-content-menu', triggerOutsideMenu);
	        $('html').addClass('cc-no-scroll');
	    } else {
	        $('html').removeClass('cc-no-scroll');
	        $(document).off('click', '.cc-content-menu', triggerOutsideMenu);
	    }
	    e.stopPropagation();
	}

	/**
	 * Close Promo Banner Small on HP (PD component)
	 */
	var promoBannerSmallClose = function promoBannerSmallClose() {
	    if (cookieHelper.getCookie('promoBannerSmallClosed') === 'true') {
	        $('.cc-promo-banner-small').hide();
	    }

	    $('.js-promoBannerSmallClose').on('click', function () {
	        $('.cc-promo-banner-small').hide();
	        cookieHelper.setCookie('promoBannerSmallClosed', 'true', 1);
	    });
	};

	promoBannerSmallClose();

	/* Look Module carousel */
	var lookModuleSlider = function lookModuleSlider() {
	    if ($('.cc-look-module .slider').length > 0) {

	        if ($('.cc-look-module .slider .slick-slide').length === 0) {
	            $('.cc-look-module .slider').each(function () {
	                var slidesContainer = $(this);

	                slidesContainer.slick({
	                    infinite: false,
	                    autoplay: false,
	                    focusOnSelect: false,
	                    centerMode: false,
	                    slidesToScroll: 1,
	                    slidesToShow: 2.2,
	                    variableWidth: false,
	                    dots: false,
	                    arrow: true,
	                    prevArrow: '<button class="cc-slider-prev"><span class="cc-icon icon-functional-arrow-left"></span></button>',
	                    nextArrow: '<button class="cc-slider-next"><span class="cc-icon icon-functional-arrow-right"></span></button>',
	                    responsive: [{
	                        breakpoint: 1023,
	                        settings: 'unslick'
	                    }]
	                });
	            });
	        }
	    }
	};

	lookModuleSlider();

	/* TextBox carousel */
	var textBoxCarousel = function textBoxCarousel() {
	    if ($('.cc-textbox-carousel .slider').length > 0) {
	        $('.cc-textbox-carousel .slider').each(function () {
	            if ($(this).find('.slick-slide').length === 0) {
	                var slidesContainer = $(this);

	                slidesContainer.slick({
	                    infinite: false,
	                    autoplay: false,
	                    focusOnSelect: false,
	                    centerMode: false,
	                    slidesToScroll: 1,
	                    slidesToShow: 1,
	                    variableWidth: false,
	                    dots: true,
	                    arrow: false
	                });
	            }
	        });
	    }
	};

	textBoxCarousel();

	function highlightCategory() {
	    var activeCat = $('.js-main-content').data('active-category');
	    if (!activeCat) {
	        return;
	    }
	    $('.cc-menu__firstLevel__link[aria-label="' + activeCat + '"]').addClass('cc-menu__firstLevel__link__activeCategory');
	}

	highlightCategory();

	// Inserting header and announcement bar heights into css variables
	function updateHeaderHeight() {
	    var root = document.querySelector(':root');
	    var header = document.querySelector('.cc-header-main');
	    var announcementBar = document.querySelector('.cc-header--banner');

	    var headerHeight = header.offsetHeight;
	    var announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

	    root.style.setProperty('--header-height', headerHeight + 'px');
	    root.style.setProperty('--announcement-bar-height', announcementBarHeight + 'px');
	}

	window.addEventListener('load', updateHeaderHeight);
	window.addEventListener('resize', updateHeaderHeight);

	$(function () {
	    // PageSpeedInsights performance improvement - passive listeners
	    jQuery.event.special.touchstart = {
	        setup: function setup(_, ns, handle) {
	            this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
	        }
	    };
	    jQuery.event.special.touchmove = {
	        setup: function setup(_, ns, handle) {
	            this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
	        }
	    };
	    jQuery.event.special.wheel = {
	        setup: function setup(_, ns, handle) {
	            this.addEventListener("wheel", handle, { passive: true });
	        }
	    };
	    jQuery.event.special.mousewheel = {
	        setup: function setup(_, ns, handle) {
	            this.addEventListener("mousewheel", handle, { passive: true });
	        }
	    };

	    // Resize Window
	    responsiveResize();
	    $(window).resize(function () {
	        responsiveResize();
	    });

	    // Selectpicker
	    $.fn.selectpicker.Constructor.BootstrapVersion = '4';
	    $('.selectpicker').selectpicker();
	    //$.fn.selectpicker.Constructor.DEFAULTS.template.caret = '<div class=\"cc-content-arrow\"><div class=\"cc-svg cc-svg-select-arrow-down\"><span></span></div></div>';

	    // Toggle Menu Mobile
	    $(document).on('click', '.cc-header .cc-header-main .js-toggleMenu', toggleMenuMobile);

	    // Toggle Search from sticky
	    $(document).on('click', '.cc-header .js-headerSearchButton', function (e) {
	        e.preventDefault();
	        e.stopPropagation();

	        if ($('.js-header').hasClass('suggestionIsOpen')) {
	            return;
	        }

	        if ($('[data-action="Search-Show"]').length > 0) {
	            $('.cc-plp--filters--sticky').css({ 'position': 'relative', 'z-index': 'unset' });
	        }

	        $('html').addClass('cc-no-scroll');
	        (0, _exportSearchFunction.toggleSearchBarMobile)();
	    });

	    $(document).on('click', '.cc-header .cc-content-search-mobile .js-closeSearch', function () {
	        if (!$('.js-header').hasClass('suggestionIsOpen')) {
	            return;
	        }

	        if ($('[data-action="Search-Show"]').length > 0) {
	            $('.cc-plp--filters--sticky').css({ 'position': 'sticky', 'z-index': '3' });
	        }

	        $('html').removeClass('cc-no-scroll');
	        (0, _exportSearchFunction.toggleSearchBarMobile)();
	    });

	    // Submenu for logged user
	    $(document).on('click', '.js-header .js-userIcon', function () {
	        var url = $(this).data('url');
	        if (url) {
	            window.location.href = url;
	        }
	    });

	    // Close user submenu mobile
	    $('.js-userMenuOverlay').on('click', function () {
	        var subMenu = $(this).closest('.loginLink').find('.js-userSubMenu');
	        $('.js-userMenuOverlay').toggleClass('d-none');
	        $('.js-userIcon').removeClass('active');
	        if (window.isMobile || window.isTablet) {
	            $('html').toggleClass('cc-no-scroll');
	        }
	        subMenu.slideToggle(300, function () {
	            subMenu.data('isOpen', subMenu.is(":visible"));
	        });
	    });

	    // effetto background opaco Desktop con megamenu aperto
	    $(document).on('mouseenter', '.cc-header .cc-header-main .cc-main-menu .cc-menu-item-1.cc-menu-item-parent', function () {
	        $('.cc-main-wrapper').addClass('cc-background-overlay-menu');
	    });
	    $(document).on('mouseleave', '.cc-header .cc-header-main .cc-main-menu .cc-menu-item-1.cc-menu-item-parent', function () {
	        $('.cc-main-wrapper').removeClass('cc-background-overlay-menu');
	    });

	    // Search Desktop Amimation
	    $(document).on('click', '.cc-header .cc-menu-bar-container .cc-content-search .cc-search', function () {
	        $(this).closest('.cc-content-main-search').addClass('cc-open');
	        $('html').addClass('cc-no-scroll');
	    });
	    $(document).on('click', '.cc-content-search .cc-icon-search', function (e) {
	        var inputBar = $(this).siblings('.cc-content-input').find('.cc-input.cc-search');
	        if (inputBar.val().length === 0) {
	            e.stopPropagation();
	            e.preventDefault();
	            $(this).closest('.cc-content-main-search').addClass('cc-open');
	            $('html').addClass('cc-no-scroll');
	            inputBar.focus();
	        }
	    });
	    $(document).on('click', '.js-searchBarMobile .js-closeSearch', function (e) {
	        $(this).closest('.js-searchBarMobile').removeClass('cc-open');
	        $('html').removeClass('cc-no-scroll');
	        e.stopPropagation();
	    });

	    // Footer Accordion Mobile
	    $(document).on('click', '.cc-mobile-smartphone .cc-footer .cc-content-footer-nav .cc-footer-nav-title', function (e) {
	        if ($(this).data("id-footer-menu-item")) {
	            var id = $(this).data("id-footer-menu-item");

	            // closing all other active tabs
	            $('.cc-footer-nav-list').not($(this).closest('div').find('.cc-footer-nav-list')).slideUp();
	            $('.cc-footer-nav-title').not($(this)).removeClass('cc-link-open');

	            $(this).toggleClass('cc-link-open');
	            $(this).closest('div').find('.cc-footer-nav-list').filter(function () {
	                return $(this).data("id-footer-menu-item") && $(this).data("id-footer-menu-item") === id;
	            }).slideToggle();
	        }
	        e.stopPropagation();
	    });

	    // Footer Newsletter redirecting
	    var footerNewsletterForm = document.getElementById('footer-newsletter-form');
	    if (footerNewsletterForm) {
	        var newsletterPageUrl = footerNewsletterForm.getAttribute('data-newsletter-page-url');
	        footerNewsletterForm.addEventListener('submit', function (event) {
	            event.preventDefault();

	            var email = document.getElementById('footer-newsletter-email').value;

	            var encodedEmail = encodeURIComponent(email);

	            window.location.href = newsletterPageUrl + '?email=' + encodedEmail;
	        });
	    }

	    // Page Designer Menu
	    $(document).on('click', '.cc-mobile-smartphone .cc-page-designer .cc-mobile-accordion-button', function (e) {
	        $(this).toggleClass('cc-mobile-accordion-open');
	        $(this).closest('.cc-content-items').find('.cc-items-list').slideToggle();
	        $(this).closest('.cc-content-items').find('.cc-items-list').addClass('js-touched');
	        e.stopPropagation();
	    });

	    racommendationSlider();
	    recommendedSlider();

	    // Add manual club price product badge icon
	    $('.cc-label-clubprice').addClass('icon-bata-club-price-cz');

	    //Marketing Pop up inviting the customer to register to Bata club
	    $(document).ready(function () {
	        var $openpopupModal = $('#marketing-popup-modal');
	        //Seconds value, after page load, when popup will be shown
	        var triggerinterval = $openpopupModal.data('marketingpopuptriggerinterval');
	        //Display the pop up if the modal exists and if we haven't set a cookie called showMarketingPopup
	        if ($openpopupModal.length && cookieHelper.getCookie('showMarketingPopup') === '') {
	            setTimeout(function () {
	                $openpopupModal.modal('show');
	            }, triggerinterval * 1000);
	        }
	    });

	    //Set a Cookie to track the action while closing the Marketing Pop up
	    $('.js-popup-close').on('click', function () {
	        //Days value, while popup will not be shown
	        var nexttriggerinterval = $('.js-popup-close').data('marketingpopupnexttriggerinterval');
	        var date = new Date();
	        //Set Date after converting the days into milisecond
	        date.setTime(date.getTime() + nexttriggerinterval * 86400000);
	        var expires = "expires=" + date.toUTCString();
	        document.cookie = "showMarketingPopup=false;" + expires + ";path=/";
	    });

	    // Update Image Error
	    document.addEventListener('error', function () {
	        imageNotFoundError();
	    }, true);

	    if ($('.slick-cloned').length > 0) {
	        $('.slick-track a').on('click', function () {
	            var slickSlide = $(this).parent().parent().parent().parent();
	            var slickActiveSlide = $(this).parent().parent().parent().parent().parent().find('.slick-active');
	            var slickNextButton = $(this).parent().parent().parent().parent().parent().parent().parent().find('.cc-slider-next');
	            var slickPreviousButton = $(this).parent().parent().parent().parent().parent().parent().parent().find('.cc-slider-prev');
	            if (slickSlide && slickActiveSlide && slickNextButton && slickPreviousButton) {
	                if (!slickSlide.hasClass('slick-active')) {
	                    if (slickActiveSlide.data("slick-index") < slickSlide.data("slick-index")) {
	                        slickNextButton.trigger("click");
	                        return false;
	                    } else if (slickActiveSlide.data("slick-index") > slickSlide.data("slick-index")) {
	                        slickPreviousButton.trigger("click");
	                        return false;
	                    }
	                }
	            }
	        });
	    }

	    // Hero Banner Component - scroll down
	    $(document).on('click', '.cc-page-designer .cc-scroll-down', function (e) {
	        // Find the closest .experience-component ancestor within .cc-page-designer
	        // and get its next sibling with .experience-component class within the same .cc-page-designer
	        var currentComponent = $(this).closest('.experience-component');
	        var parentDesigner = $(this).closest('.cc-page-designer');
	        var nextComponent = parentDesigner.find('.experience-component').filter(function () {
	            return $(this).index() > currentComponent.index();
	        }).first();

	        // Calculate the target offset
	        var targetOffset = nextComponent.offset().top;

	        $('html, body').animate({
	            scrollTop: targetOffset
	        }, 1000);

	        e.stopPropagation();
	    });

	    $(document).on('keyup keypress', '.js-searchInput', function () {
	        var $self = $(this);

	        setTimeout(function () {
	            if ($self.val() !== '') {
	                $self.next('.js-resetSearch').removeAttr('disabled');
	            } else {
	                $self.next('.js-resetSearch').attr('disabled', 'disabled');
	            }
	        }, 0);
	    });

	    $(document).on('click', '.cc-header-promo .activePromo .cc-text-link', function () {
	        if ($(this).find('a').length > 0) {
	            window.location.href = $('.cc-header-promo .activePromo a').attr('href');
	        }
	    });

	    // Add "active" class to the brand link that matches the current URL
	    $(".cc-header-brands").find(".cc-header-brands__link").each(function () {
	        if (window.location.href === this.href) {
	            $(this).addClass("active");
	        }
	    });

	    // Add "active" class to link item on click
	    $(document).on("click", ".js-nav-link", function (e) {
	        e.preventDefault();

	        var targetId = $(this).attr("href");
	        var targetElement = $(targetId);
	        var offsetToGo = window.innerWidth < 768 ? targetElement.offset().top - 100 : targetElement.offset().top - 20;

	        if (targetElement.length) {
	            $("html, body").animate({
	                scrollTop: offsetToGo
	            }, 1000);
	        }

	        $(".js-nav-link").removeClass("active");
	        $(this).addClass("active");
	    });

	    // load right header data
	    $(document).ready(function () {
	        var url = $('.js-headerBarRight').data('url');

	        $.get(url, function (data) {
	            $('.js-headerBarRight').prepend(data);
	            $('body').trigger('headerBar:loaded');
	        });
	    });
	});

/***/ }),
/* 167 */
/***/ (function(module, exports) {

	'use strict';

	/**
	 * Get cookie value by cookie name from browser
	 * @param {string} cookieName - name of the cookie
	 * @returns {string} cookie value of the found cookie name
	 */

	function getCookie(cookieName) {
	    var name = cookieName + '=';
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var cookieArray = decodedCookie.split(';');
	    for (var i = 0; i < cookieArray.length; i++) {
	        var cookieItem = cookieArray[i];
	        while (cookieItem.charAt(0) === ' ') {
	            cookieItem = cookieItem.substring(1);
	        }
	        if (cookieItem.indexOf(name) === 0) {
	            return cookieItem.substring(name.length, cookieItem.length);
	        }
	    }
	    return '';
	}

	/**
	 * Set a cookie with the given name, value, and expiration date
	 * @param {string} cookieName - name of the cookie
	 * @param {string} cookieValue - value of the cookie
	 * @param {number} days - number of days until the cookie expires
	 */
	function setCookie(cookieName, cookieValue, days) {
	    var expirationDate = new Date();
	    expirationDate.setDate(expirationDate.getDate() + days);
	    var expires = "expires=" + expirationDate.toUTCString();
	    document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
	}

	module.exports = function () {
	    $(document).ready(function () {
	        var cookieBanner = $('.cookie-warning');
	        if (navigator.cookieEnabled) {
	            if (cookieBanner.length > 0) {
	                var previousSessionID = window.localStorage.getItem('previousSid');
	                var currentSessionID = getCookie('sid');
	                if (!previousSessionID && currentSessionID) {
	                    // When a user first time visit the home page,
	                    // set the previousSessionID to currentSessionID
	                    // and Show the cookie alert
	                    previousSessionID = currentSessionID;
	                    window.localStorage.setItem('previousSid', previousSessionID);
	                    if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
	                        cookieBanner.removeClass('d-none');

	                        //register the showing of the cookiebar
	                        $('body').trigger('analytics:showCookieBar');
	                    }
	                } else if (previousSessionID && previousSessionID === currentSessionID) {
	                    // Hide the cookie alert if user is in the same session
	                    cookieBanner.addClass('d-none');
	                } else {
	                    // Clear the previousSessionID from localStorage
	                    // when user session is changed or expired
	                    previousSessionID = '';
	                    window.localStorage.removeItem('previousSid');
	                }
	            }
	        } else {
	            if (cookieBanner.length > 0) {
	                cookieBanner.hide();
	            }
	            $('#error-message-cookies').show();
	        }
	    });
	};
	module.exports.getCookie = getCookie;
	module.exports.setCookie = setCookie;

/***/ })
/******/ ]);